(function() {
    'use strict';

    function getNewLariUrl() {
        switch (window.location.hostname) {
            case 'localhost':
            case 'lariaiddev.mlb.com':
                return 'https://lari-dev.mlbinfra.com';
            case 'lariaidstg.mlb.com':
                return 'https://lari-stg.mlbinfra.com';
            case 'lariaid.mlb.com':
            default:
                return 'https://lari.mlb.com';
        }
    }

    angular
        .module('lariAidApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngMaterial',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ngTouch',
            // angularjs-add-module : add new module here
            'angular-loading-bar',
            'scrollable-table',
            'ngLetterAvatar',
            'ngAnimate',
            'ks.ngScrollRepeat',
            'ng.deviceDetector',
            'ckeditor',
            'vAccordion',
            'ngSanitize',
            'ngNotificationsBar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$rootScope'];

    function run(stateHandler, translationHandler, $rootScope) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.newLariUrl = getNewLariUrl();
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('lariAidApp')
        .constant('VERSION', "2.0.0")
        .constant('BASE_URL', "https://api.lariaid.mlb.com/")
        .constant('OKTA_SAML_URL', "https://mlb.okta.com/home/mlb_lariaid_1/0oaypjk6m0e0XCk4h0x7/alnypjyl3d9IdwejB0x7")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
  "use strict";

  angular.module("lariAidApp").config(stateConfig);

  stateConfig.$inject = ["$stateProvider", "notificationsConfigProvider"];

  function stateConfig($stateProvider, notificationsConfigProvider) {
    // auto hide
    notificationsConfigProvider.setAutoHide(true);

    // delay before hide
    notificationsConfigProvider.setHideDelay(6000);

    // support HTML
    notificationsConfigProvider.setAcceptHTML(false);

    // Set an animation for hiding the notification
    //notificationsConfigProvider.setAutoHideAnimation('fadeOutNotifications');

    // delay between animation and removing the nofitication
    //notificationsConfigProvider.setAutoHideAnimationDelay(1200);

    $stateProvider.state("app", {
      abstract: true,
      views: {
        "navbar@": {
          templateUrl: "app/layouts/navbar/navbar.html",
          controller: "NavbarController",
          controllerAs: "vm"
        },
        "content@": {
          templateUrl: "app/main/main.html"
        }
      },
      resolve: {
        authorize: [
          "Auth",
          function (Auth) {
            return Auth.authorize().catch(e => {
              if (!!e && (!e.status || !Number.isInteger(e.status))) {
                console.error(e);
              }
            });
          }
        ],
        translatePartialLoader: [
          "$translatePartialLoader",
          function ($translatePartialLoader) {
            if (localStorage && localStorage.getItem("lari_currentVersion") != null) {
              $translatePartialLoader.addPart("global.json?version=" + localStorage.getItem("lari_currentVersion"));
            } else {
              $translatePartialLoader.addPart("global.json?timestamp=" + new Date().getTime());
            }
          }
        ]
      }
    });
  }
})();

/**
 * 
 */(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('BaseFactory', BaseFactory);

    BaseFactory.$inject = ['$resource','restService','$q','$rootScope'];
    var clubList;
    var languageList;
    function BaseFactory ($resource,restService,$q,$rootScope) {
    	return {
    		getClubLists : function(){
          		var deferred = $q.defer();
          		if(!clubList){
            		var url = "organizations/org";
            		var data = restService.restCall("", url, 'GETLIST');
            		data.$promise.then(function(response){
            			clubList = response;
            			deferred.resolve(response);
            		},
            		function (error) {
            			deferred.reject('ERROR');
            		});
            	}
        		else{
        			deferred.resolve(clubList);
        		}
          		return deferred.promise;
          	},
          	getLanguagesList : function(){
        		var deferred = $q.defer();
          		if(!languageList){
            		var url = "ref-terms/ref-set/language";
            		var data = restService.restCall("", url, 'GETLIST');
            		data.$promise.then(function(response){
            			languageList = response;
            			deferred.resolve(response);
            		},
            		function (error) {
            			deferred.reject('ERROR');
            		});
            	}
        		else{
        			deferred.resolve(languageList);
        		}
          		return deferred.promise;
          	}
    	};
    }
})();

(function () {
  "use strict";
  angular.module("lariAidApp").constant("APP", {
    GLOBAL: {
      USER_GROUP: [
        "ROLE_USER",
        "ROLE_ADMIN",
        "LARI_ADMIN",
        "LARI_ANALYST",
        "LARI_MANAGER",
        "LARI_INVESTIGATOR",
        "LARI_READ_ONLY",
        "LARI_COUNTRY_ADMIN"
      ],
      ROLE_ADMIN: "LARI_ADMIN",
      ROLE_ANALYST: "LARI_ANALYST",
      ROLE_MANAGER: "LARI_MANAGER",
      ROLE_INVESTIGATOR: "LARI_INVESTIGATOR",
      ROLE_USER: "ROLE_USER",
      ROLE_VERNALIS_ADMIN: "ROLE_ADMIN",
      ROLE_READ_ONLY: "LARI_READ_ONLY",
      ROLE_COUNTRY_ADMIN : "LARI_COUNTRY_ADMIN",
      LDAP_GROUP: "LDAP_GROUP",
      EXTERNAL_INVESTIGATOR: "EXTERNAL_INVESTIGATOR",
      LDAP_INVESTIGATOR: "LDAP_INVESTIGATOR",
      ENDLESS: "endless",
      ADMIN: "admin",
      ANALYST: "analyst",
      MANAGER: "manager",
      INVESTIGATOR: "Registered Investigators",
      EXTERNALINVESTIGATOR: "Non-Registered Investigators",
      READ_ONLY: "readOnly",
      ASC: "asc",
      DESC: "desc",
      DEFAULT_SIZE: 15,
      ENGLISH: "ENGLISH",
      SPANISH: "SPANISH",
      EN: "en",
      ES: "es",
      PDF: ".pdf",
      TRUE: "TRUE",
      FALSE: "FALSE",
      LOCAL_REGISTRY: "Local Registry",
      NATIONAL_REGISTRY: "National Registry",
      IN_PROGRESS: "IN_PROGRESS",
      COMPLETED: "COMPLETED",
      APP_VERSION: "appversion",
      ANSWER_YES: "answer_yes",
      ANSWER_NO: "answer_no",
      SIBLINGS: "Siblings",
      PFM: "PFM",
      SIBLINGIMPORTED: "siblingImported",
      VERSION_ONE: "v1",
      VERSION_TWO: "v2",
      COUNTRY_ADMIN: "COUNTRY ADMIN"
    },
    INVESTIGATION: {
      MY_INVESTIGATIONS: "My Investigations",
      REGISTRATION_TYPE: "REGISTRATION_TYPE",
      INVESTIGATION_TYPE: "INVESTIGATION_TYPE",
      HEADER_TYPE_ALL: "ALL",
      HEADER_TYPE_THIRTY: "THIRTY",
      HEADER_TYPE_FIFTEEN: "FIFTEEN",
      HEADER_TYPE_ALL_VALUE: "0",
      HALF_MONTH: "15",
      ONE_MONTH: "30",
      THREE_MONTH: "90",
      SIX_MONTH: "180",
      LOCAL_REGISTRY: "LOCAL_REGISTRY",
      NATIONAL_REGISTRY: "NATIONAL_REGISTRY",
      MEDICAL_INSTITUTION: "MEDICAL_INSTITUTION",
      RELIGIOUS_INSTITUTION: "RELIGIOUS_INSTITUTION",
      SCHOOL: "SCHOOL",
      DNA_CENTER: "DNA_CENTER",
      INVESTIGATOR_FORM: "INVESTIGATOR_FORM",
      ANALYST_FORM: "ANALYST_FORM",
      INVESTIGATORFORM: "Investigator Form",
      ANALYSTFORM: "Analyst Form",
      INVESTIGATOR_REPORT: "Investigator Form",
      ANALYST_REPORT: "Analyst Form",
      INVESTIGATOR_REPORT_NAME: "Investigator_Form",
      ANALYST_REPORT_NAME: "Analyst_Form",
      REVIEW_COMMITTEE_REPORT_NAME: "Review_Committee_Form",
      SUMMARY_CONFIMED: "summary_confirmed",
      SUMMARY_FAILED: "summary_failed",
      SUMMARY_NA: "summary_NA",
      SUMMARY_UNDETERMINED: "summary_undetermined",
      REPORT_API: "api/report/",
      DOWNLOAD_API: "api/assets/downloadDocument/",
      REQUESTED_BY_DEFAULT_COUNT: 4,
      REQUESTED_BY_MOBILE_COUNT: 6,
      ANALYST: "ANALYST",
      INVESTIGATOR: "INVESTIGATOR",
      EXPORTFILENAME: "Investigation Details.xlsx",
      EXPORT_API: "api/investigations/excel/data?user=",
      EXPORT_API_MYINVESTIGATION: "&isMyInvestigation=",
      ENABLEREOPENFLAG: "TRUE",
      INVESTIGATIONDELETEDPUPID: "investigatorFormDeleted",
      RC_DETAILS_SAVE: "Review Committee details had been saved successfully",
      ALREADR_ASSIGNED: "Analyst Form Already Assigned.",
      STATE: {
        BIRTH_CERTIFICATE_STATE: "birthCertificate",
        BIRTH_MEDICAL_STATE: "birthMedicalRecord",
        FAMILY_INFORMATION_STATE: "familyInformation",
        SCHOOL_INFORMATION_STATE: "schoolInformation",
        RELEGIOUS_INSTUTE_STATE: "religiousInstitution",
        NEIGHBOURHOOD_STATE: "neighbourhoodCanvas",
        RESIDENCY_STATE: "residencyQuestions",
        SUMMARY_STATE: "summary",
        DNA_INFORMATION_STATE: "dnaInformation",
        OTHER_STATE: "other"
      },
      COUNTRIES: "Countries"
    },
    INVESTIGATION_STATUS: {
      PENDING_INVESTIGATOR: "PENDING_INVESTIGATOR",
      DELETED_IN_EBIS: "DELETED_IN_EBIS",
      WAIVED_STATUS: "WAIVED",
      NA: "NA",
      PENDINGINVESTIGATOR: "Pending Investigator",
      PENDING_ANALYST: "PENDING_ANALYST",
      PENDINGANALYST: "Pending Analyst",
      UNDER_INVESTIGATION: "UNDER_INVESTIGATION",
      UNDERINVESTIGATION: "Under Investigation",
      ANALYST_REVIEW: "ANALYST_REVIEW",
      ANALYSTREVIEW: "Analyst Review",
      MANAGER_REVIEW: "MANAGER_REVIEW",
      MANAGERREVIEW: "Manager Review",
      REOPEN: "Reopen",
      REVIEW_COMMITTEE_SELECTED: "REVIEW_COMMITTEE_SELECTED",
      REVIEW_COMMITTEE_READY: "REVIEW_COMMITTEE_READY",
      REVIEW_COMMITTEE_TABLED: "REVIEW_COMMITTEE_TABLED",
      REVIEWCOMMITTEE_SELECTED: "Review Committee - Selected",
      REVIEWCOMMITTEE_READY: "Review Committee - Ready",
      REVIEWCOMMITTEE_TABLED: "Review Committee - Tabled",
      CONFIRMED: "Confirmed",
      FAILED: "Failed",
      UNDETERMINED: "Undetermined",
      WAIVED: "Waived",
      CREATED: "Created",
      SUBMITTED: "Submitted",
      UPDATED: "Updated",
      DELETED: "Deleted",
      ADDED: "Added",
      ASSIGNED: "Assigned",
      REMOVED: "Removed",
      REASSIGN: "Reassign",
      REVISIED: "Revisied",
      SENDBACK_INVESTIGATOR: "Send Back To Investigator",
      SENDBACK_ANALYST: "Send Back To Analyst",
      DELETEDINEBIS: "Deleted in eBis",
      BYPASSED: "ByPassed"
    },
    USER: {
      INTERNAL: "internal",
      EXTERNAL: "external",
      ADMIN: "country-admin",
      USER_ROLE_FILTER: "USER_ROLE",
      INVESTIGATION_CASES: "INVESTIGATION_CASES",
      USER_ROLE_KEY: "userRoleKey",
      INVESTIGATION_STATUS_KEY: "investigationStatusKey",
      COMPLETED: "Completed",
      SUBMITTED: "Submitted",
      ASSIGNED: "Assigned",
      USER_CREATED: "Created",
      /*USER_UPDATED : 'Name Updated', - The Keyword is changed in backEnd*/
      USER_UPDATED: "Updated",
      USER_PHONE_UPDATED: "Phone Number Updated",
      USER_LANGUAGE_UPDATED: "Language Updated",
      USER_COUNTRY_UPDATED: "Country Updated",
      USER_DELETED: "Removed",
      SORT_BY_COUNT: "caseCount",
      SORT_BY_COUNT_VALUE: "Sort By Case Open",
      SORT_BY_NAME: "firstName",
      SORT_BY_NAME_VALUE: "Sort By Name",
      PHONETYPE: "primary",
      ENTITYTYPE: "USER",
      USERPROFILE: "userprofile",
      DELETEDUSERS: "Deleted Users",
      USERWITHNOACTIVECASES: "Users with No Active Cases",
      COUNTRY_VISIBILITY_ADDED: "COUNTRY_VISIBILITY_ADDED",
			COUNTRY_VISIBILITY_REMOVED: "COUNTRY_VISIBILITY_REMOVED"
    },
    STATES: {
      INVESTIGATIONS: "INVESTIGATIONS",
      USERS: "USERS"
    },
    REF_TERM: {
      REGISTRATION_TYPE: "REGISTRATION_TYPE",
      INVESTIGATION_TYPE: "INVESTIGATION_TYPE",
      COUNTRY: "country",
      CONFIRMED: "CONFIRMED",
      FORM_CONFIRMED: "FORM_CONFIRMED",
      FAILED: "FAILED",
      FORM_FAILED: "FORM_FAILED",
      UNDETERMINED: "UNDETERMINED",
      FORM_UNDETERMINED: "FORM_UNDETERMINED",
      WAIVED: "WAIVED",
      FORM_WAIVED: "FORM_WAIVED",
      NA: "NA",
      FORM_NA: "FORM_NA",
      RC_CONFIRMED: "RC_CONFIRMED",
      RC_FAILED: "RC_FAILED",
      RC_UNDETERMINED: "RC_UNDETERMINED",
      RC_NA: "RC_NA",
      RC_TABLED: "RC_TABLED",
      DELETED_IN_EBIS: "DELETED_IN_EBIS",
      ENTITY_PROFILE: "ENTITY_PROFILE",
      SECTION: "SECTION",
      BIRTH_CERTIFICATE: "BIRTH_CERTIFICATE",
      BIRTH_AND_MEDICAL_RECORDS: "BIRTH_AND_MEDICAL_RECORDS",
      NEIGHBORHOOD_CANVAS: "NEIGHBORHOOD_CANVAS",
      FAMILY_INFORMATION: "FAMILY_INFORMATION",
      SCHOOL_INFORMATION: "SCHOOL_INFORMATION",
      RELIGIOUS_INSTITUTIONS: "RELIGIOUS_INSTITUTIONS",
      RESIDENCY_QUESTIONS: "RESIDENCY_QUESTIONS",
      SUMMARY: "SUMMARY",
      DNA: "DNA",
      OTHER: "OTHER",
      IN_PROGRESS: "In progress",
      ZERO_INDEX: "0",
      FIVE_HUNDRED: 500,
      FIVE_HUNDRED_AND_ONE: 501,
      FORM_SAVE: "FORM_SAVE",
      FORM_SUBMIT: "FORM_SUBMIT",
      FORM_SECTION_SAVE: "FORM_SECTION_SAVE",
      FORM_COPY: "FORM_COPY",
      FORM_ATTACHMENT_ADD: "FORM_ATTACHMENT_ADD",
      FORM_ATTACHMENT_DELETE: "FORM_ATTACHMENT_DELETE"
    },
    LEGACYLARI: {
      INTERNAL_SERVER_ERROR: "Internal Server Error",
      NO_DOCUMENT_FOUND: "The document not found",
      ERROR_DOWNLOADING_DOCUMENT: "Error in downloading the document",
      DOCUMENT_DOWNLOADED: "The document will get downloaded",
      NO_EBIS_ID_FOUND: "The Ebis Id is not Present",
      UNABLE_TO_CONNECT_LEGACY_LARI_SYSTEM: "Error connecting to the Legacy LARI System",
      BAD_REQUEST: "Exception occur while download document"
    },
    LIBRARY: {
      REQUEST: "request",
      ENTITY: "entities",
      LOCATION: "locations",
      OPEN_REQUEST: "OPEN_REQUEST",
      CLOSED_REQUEST: "CLOSED_REQUEST",
      ENTITY_SORT_BY_COUNT: "approvedOn",
      ENTITY_SORT_BY_COUNT_VALUE: "Sort By Approved Days",
      ENTITY_SORT_BY_NAME: "name",
      ENTITY_SORT_BY_NAME_VALUE: "Sort By Name",
      ENTITY_TYPE_ID: "entityTypeId",
      LOCATION_MAPPING_ID: "locationMappingId",
      REQUEST_STATUS_KEY: "statusKey",
      REQUEST_SORT_BY_COUNT: "daysCount",
      REQUEST_SORT_BY_COUNT_VALUE: "Sort By Days Open",
      REQUEST_SORT_BY_NAME: "firstName, lastName",
      REQUEST_SORT_BY_NAME_VALUE: "Sort By Name",
      ENTITY_REQ: "ENTITY REQUEST",
      LOCATION_REQ: "LOCATION REQUEST",
      CLOSED_REQUESTS: ["Approved", "Altered"],
      COUNTRY: "Country",
      PROVINCE: "Province",
      CITY: "City",
      SECTOR: "Sector",
      COUNTRY_CAPS: "COUNTRY",
      PROVINCE_CAPS: "PROVINCE",
      CITY_CAPS: "CITY",
      SECTOR_CAPS: "SECTOR",
      LOCATION_CONST: "Location",
      RECENTY_ADD: "Recently Added",
      REQ_LOC_ID: "requestLocation",
      REQ_LOC_PROFILE_ID: "locationProfilePopupId",
      REQ_ENTITY_ID: "requestEntity",
      REQ_ENTITY_PROFILE_ID: "entityProfilePopupId",
      REQ_ENTITY_ICON_ID: "entityIconPopupId",
      USER_SAVE: "Investigator had been added successfully",
      USER_SAVE_PROBLEM: "Problem occured in adding investigator",
      USER_EDIT: "Investigator had been updated successfully",
      USER_EDIT_PROBLEM: "Problem occured in adding investigator",
      ENTITY_REQUEST: "Entity Request is Approved/Altered",
      ENTITY_REQUEST_PROBLEM: "Problem occured while approving request",
      LOCATION_REQUEST: "Location is Approved/Altered successfully",
      LOCATION_REQUEST_PROBLEM: "Problem occured while approving location",
      LOCATION_DELETED: "Location had been deleted successfully",
      LOCATION_DELETED_PROBLEM: "Problem occured in deleting location",
      LOCATION_EDITED: "Location had been updated successfully",
      LOCATION_EDITED_PROBLEM: "Problem occured in updating location",
      LOCATION_ADD: "Location had been added successfully",
      LOCATION_ADD_PROBLEM: "Problem occured in adding location",
      ENTITY_DELETE: "Entity had been deleted successfully",
      ENTITY_DELETE_PROBLEM: "Problem occured in deleting entity",
      ENTITY_ADD: "Entity had been added successfully",
      ENTITY_ADD_PROBLEM: "Problem occured in adding entity",
      ENTITY_UPDATE: "Entity had been updated successfully",
      ENTITY_UPDATE_PROBLEM: "Problem occured in updating entity",
      DELETE_PROBLEM: "Cannot delete locations if they are mapped to other locations",
      ALL: "All",
      FORM_LOCATION_REQUEST: "FORM LOCATION REQUEST",
      LOCATION_REQUEST_SEND: "Location request sent successfully",
      LOCATION_REQUEST_SEND_PROBLEM: "Problem occured in sending entity request",
      ENTITY_REQUEST_SEND: "Entity request sent successfully",
      LOCATION_EXISTS: "The Requested New Location is already Applied!!",
      ENTITY_REQUEST_SEND_PROBLEM: "Problem occured in sending entity request",
      ENTITY_REQUEST_EXISTS: "The Requested New Entity has been already Applied!!",
      COUNTRY_ADMIN_SAVE: "The Country Admin Details has been Saved",
			COUNTRY_ADMIN_SAVE_PROBLEM: "Problem occured in saving country admin details",
			COUNTRY_ADMIN_GET_PROBLEM: "Problem while getting the Admin Data"
    },
    INVESTIGATION_FORM: {
      BIRTH_AND_MEDICAL_RECORDS: {
        QUESTION1: "birthMedical1",
        QUESTION2_MIDWIFE: "birthMedical2_mid_wife",
        QUESTION2A_MIDWIFE: "birthMedical2_mid_wife_no_2a",
        QUESTION2_MEDICAL: "birthMedical2_medical_institution",
        QUESTION2_MEDICAL_YES_2A: "birthMedical2_medical_institution_yes_2a",
        QUESTION2_MEDICAL_YES_2B: "birthMedical2_medical_institution_yes_2b",
        QUESTION3_MEDICAL: "birthMedical3_medical_institution",
        QUESTION3_MEDICAL_YES_3A: "birthMedical3_medical_institution_yes_3a",
        QUESTION3_MEDICAL_NO_3A: "birthMedical3_medical_institution_no_3a",
        QUESTION4_MEDICAL: "birthMedical4_medical_institution",
        QUESTION5_MEDICAL: "birthMedical5_medical_institution",
        QUESTION6_MEDICAL: "birthMedical6_medical_institution",
        QUESTION3_MEDICAL_YES_3B: "birthMedical3_medical_institution_yes_3b"
      },
      NEIGHBORHOOD_CANVAS: {
        QUESTION1: "neighborhood_1"
      },
      FAMILY_QUESTIONS: {
        QUESTION1_FATHER: "familyInformation_father_1",
        QUESTION1_MOTHER: "familyInformation_mother_1",
        QUESTION1_PROSPECT: "familyInformation_prospect_1",
        QUESTION1_FAMILY_MEMBER: "familyInformation_familyMember_1",
        QUESTION1_SIBLING: "familyInformation_sibling_1",
        QUESTION1_PROSPECT_1A: "familyInformation_prospect_1a",
        QUESTION1_PROSPECT_1B: "familyInformation_prospect_1b",
        QUESTION1_PROSPECT_1C: "familyInformation_prospect_1c",
        QUESTION1_PHOTO: "familyInformation_familyPhoto_1",
        QUESTION2_PHOTO: "familyInformation_familyPhoto_2",
        PHOTO_INDEX: "101"
      },
      SCHOOL_QUESTIONS: {
        QUESTION1: "schoolInformation_1",
        QUESTION2: "schoolInformation_2",
        QUESTION2_YES_2A: "schoolInformation_2_yes_2a",
        QUESTION2_YES_2B: "schoolInformation_2_yes_2b_label",
        QUESTION3: "schoolInformation_3",
        QUESTION3_YES_4: "schoolInformation_3_yes_3a",
        QUESTION3_YES_5: "schoolInformation_3_yes_3b",
        QUESTION3_YES_6: "schoolInformation_3_yes_3c",
        QUESTION3_YES_7: "schoolInformation_3_yes_3d",
        QUESTION3_NO_3A: "schoolInformation_3_no_1"
      },
      RELIGIOUS_QUESTIONS: {
        QUESTION1: "religiousInstitution_q1",
        QUESTION1_NO_1A: "religiousInstitution_q1_no_notBaptised_records_notAvailable",
        QUESTION2: "religiousInstitution_q2",
        QUESTION2A: "religiousInstitution_q2a_dateOfVisit",
        QUESTION2B: "religiousInstitution_q2a",
        QUESTION3: "religiousInstitution_q3",
        QUESTION3A: "religiousInstitution_q3_recordType",
        QUESTION4: "religiousInstitution_q4",
        QUESTION5: "religiousInstitution_q5",
        QUESTION6: "religiousInstitution_q6",
        QUESTION3B: "religiousInstitution_q3b"
      },
      DNA_QUESTIONS: {
        QUESTION1: "dnaInformation_1",
        QUESTION1A: "dnaInformation_1a"
      },
      RESIDENCY_QUESTIONS: {
        QUESTION1: "residency1",
        QUESTION2: "residency2"
      },
      SUMMARY_QUESTIONS: {
        QUESTION1: "summary_age",
        QUESTION2: "summary_identity",
        QUESTION3: "summary_3",
        QUESTION4: "summary_4",
        QUESTION5: "summary_5",
        QUESTION6: "summary_6"
      },
      SUMMARY_KEY: "summary",
      UPLOAD_DOCUMENT_CONFIRMATION_POPUPID: "uploadFileConfirmationPopup",
      PREVIEW_IMAGE: "previewImage",
      VIEW_DOCUMENT_BUTTON: "viewDocumentBtn",
      VIEW_BUTTON_CLICK: "viewButtonClick",
      BIRTH_CERTIFICATE_FORM: "bithcerticateForm",
      BIRTH_AND_MEDICAL_FORM: "birthAndMedicalForm",
      NEIGHBOURHOOD_CANVASS_FORM: "neighbourhoodCanvasForm",
      FAMILY_FORM: "familyInfoForm",
      SCHOOL_FORM: "schoolInfoForm",
      RELIGIOUS_FORM: "religiousInstitutionForm",
      RESIDENCY_FORM: "residencyQuestionForm",
      DNA_FORM: "dnaInfoForm",
      OTHER_FORM: "otherForm",
      SUMMARY_FORM: "summaryForm",
      SUMMARY_CLOSE_FORM: "saveclosePopup"
    }
  });
})();

(function(){
	'use strict'; 

angular
  .module('lariAidApp')
  .service('CommonService', ['$resource','restService','$q','$cookies','APP','Auth', function ($resource,restService,$q,$cookies,APP,Auth) {
	  
	  var vm = this;
	  vm.APP = APP;
	  
	  vm.getAgentLists= function(agentSearchKey){
  		var deferred = $q.defer();
  		var url = "trainers?searchKey="+agentSearchKey;
  		var data = restService.restCall("", url, 'GETLIST');
  		data.$promise.then(function(response){
  			deferred.resolve(response);
  		},
  		function (error) {
  			deferred.reject('ERROR');
  		});
  		return deferred.promise;
  	};
  	
  	vm.getUsersList= function(roleKey,searchkey){
		var deferred = $q.defer();
		var url = "users/role/"+roleKey+"?searchKey="+searchkey;
		var data = restService.restCall("", url, 'GETLIST');
		data.$promise.then(function(response){
			deferred.resolve(response);
		},
		function (error) {
			deferred.reject('ERROR');
		});
		return deferred.promise;
	};
	
	
	vm.getRefTermList = function(path,searchkey){
		var deferred = $q.defer();
		var url = "ref-terms/ref-set/"+path;
		if(searchkey){
			url+= "?searchKey="+searchkey;
		}
		var data = restService.restCall("", url, 'GETLIST');
		data.$promise.then(function(response){
			deferred.resolve(response);
		},
		function (error) {
			deferred.reject('ERROR');
		});
		return deferred.promise;
	};
	
	vm.getBirthCountry = function(){
		var deferred = $q.defer();
		var url = "prospects/birthCountry";
		var data = restService.restCall("", url, 'GETLIST');
		data.$promise.then(function(response){
			deferred.resolve(response);
		},
		function (error) {
			deferred.reject('ERROR');
		});
		return deferred.promise;
	};
	
	vm.getLocationById = function(locationMappingId){
		var deferred = $q.defer();
		var url = "location-mappings/"+locationMappingId;
		var data = restService.restCall('', url, 'GET');
		data.$promise.then(function(response){
			deferred.resolve(response);
		},
		function (error) {
			deferred.reject('ERROR');
		});
		return deferred.promise;
	};
	
	vm.getCookieLanguage = function() {
		var cookieLanguage = $cookies.getObject('NG_TRANSLATE_LANG_KEY');
		if(cookieLanguage) {
			return cookieLanguage;
		}
	};
	
	vm.getCookieUser = function(){
		var user = {};

		var cookieUser = $cookies.getObject('sessionDetails');
		if(cookieUser){
			var loggedUser = cookieUser.authorities[0];
			var loggedUserRole = '';
			if(loggedUser == vm.APP.GLOBAL.ROLE_MANAGER){
				loggedUserRole = vm.APP.GLOBAL.MANAGER;
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_ADMIN){
				loggedUserRole = vm.APP.GLOBAL.ADMIN;
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_INVESTIGATOR){
				loggedUserRole = vm.APP.GLOBAL.INVESTIGATOR; 
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_ANALYST){
				loggedUserRole = vm.APP.GLOBAL.ANALYST;
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY){
				loggedUserRole = vm.APP.GLOBAL.READ_ONLY;
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN){
				loggedUserRole = vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN;
			}


			user.cookieUser = cookieUser;
			user.loggedUser = loggedUser;
			user.loggedUserRole = loggedUserRole;
	
			return  user;
		} else{
			Auth.logout(false);
		}

		};	
	}]
  );
})();
(function(){
	'use strict'; 

angular
  .module('lariAidApp')
  .factory('communicationService', function () {
	var details = [];
	return {
	    setData: function (key, data) {
	     details[key] = data;
	    },
	    getData: function (key) {
	        return details[key];
	    }
	}
	});
})();
(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name lariAidApp.controller:sessionCtrl
   * @description
   * # sessionCtrl
   * Controller of the lariAidApp
   */
  angular.module("lariAidApp").controller("sessionCtrl", [
    "$scope",
    "$interval",
    "$document",
    "$mdDialog",
    "communicationService",
    "Auth",
    "$sessionStorage",
    "Account",

    function ($scope, $interval, $document, $mdDialog, communicationService, Auth, $sessionStorage, Account) {
      var SESSION_BANNER_TIMEOUT_MINUTES = 2; //in minutes
      var timer;
      var sessionTimer;
      var SESSION_TIMEOUT_IN_SCREEN = 15 * 60 * 1000; 
      var SESSION_TIMEOUT = 2 * 60 * 1000; // in milliseconds
      var intervalFlag = false;
      var countDown;
      var interval;
      var logoutTimer;
	  	var logoutTime = 15 * 60 * 1000; // 15 minutes in milliseconds

      setInterval(timeout, 1000);

      function timeout(){
        if(document.hidden){
          logoutTimer = $timeout(function() {
            // Perform logout action here
            if(document.hidden){
              var minutes = (SESSION_TIMEOUT/60000) % 60;
              var seconds = (SESSION_TIMEOUT% 60000) / 1000;
              communicationService.setData("sessionTimer",minutes + ":" + seconds);
              sessionTimer = communicationService.getData("sessionTimer");
              if( countDown != undefined && countDown != null)
              countDown.innerHTML = minutes + ":" + seconds; 
              if(!($('.sessionTimeoutPopup').hasClass("alive"))){
                $('.sessiondetails').css("display","block");
                $('.sessionTimeoutPopup').addClass("alive");
                $scope.openSessionWarningPopup('sessionWarningPopup');
              }
            }
            console.log('User has been logged out due to inactivity.');
          }, logoutTime);	
        }else {
          // If the document is not hidden, cancel the existing timeout
          if (logoutTimer) {
            $timeout.cancel(logoutTimer);
          }
        }
      }

      //Method to set session timeout
      $scope.setSessionTimeout = function () {
        var minutes = (SESSION_TIMEOUT_IN_SCREEN / 60000) % 60;
        var seconds = (SESSION_TIMEOUT_IN_SCREEN % 60000) / 1000;
        if (minutes < 10 && minutes.length != 2) minutes = "0" + minutes;
        if (seconds < 10 && seconds.length != 2) seconds = "0" + seconds;
        communicationService.setData("sessionTimer", minutes + ":" + seconds);
        sessionTimer = communicationService.getData("sessionTimer");
        countDown = document.getElementsByClassName("countDown");
        if (countDown != undefined && countDown != null) countDown.innerHTML = minutes + ":" + seconds;
        $scope.setInt();
      };

      //Method for Session time calculator
      $scope.setInt = function () {
        if ($sessionStorage.isLoggedIn) {
          interval = $interval(function () {
            if (angular.isDefined(interval)) {
              var location = window.location.href.split("#")[1];
              if (location == "/") {
                $scope.stop();
                $document.find("body").off("mousemove keydown DOMMouseScroll mousewheel mousedown touchstart");
              } else {
                var minutesLastFocus = undefined;
                if (!angular.isUndefined(communicationService.getData("timeLastFocus"))) {
                  var lastFocus = new Date(communicationService.getData("timeLastFocus"));
                  var m = new Date() - lastFocus;
                  minutesLastFocus = Math.floor(m / 60000);
                }
                if (intervalFlag == true) {
                  communicationService.setData("timeLastFocus", new Date());
                  $scope.setSessionTimeout();
                  $interval.cancel(interval);
                  intervalFlag = false;
                } else if (intervalFlag == false) {
                  communicationService.setData("isLoggedIn", $sessionStorage.isLoggedIn);
                  if (
                    !angular.isUndefined(communicationService.getData("isLoggedIn")) &&
                    communicationService.getData("isLoggedIn") == true
                  ) {
                    sessionTimer = communicationService.getData("sessionTimer");
                  } else {
                    minutes = 0;
                    seconds = 0;
                    communicationService.setData("sessionTimer", minutes + ":" + seconds);
                    sessionTimer = communicationService.getData("sessionTimer");
                  }
                  var conquer = sessionTimer.split(":");
                  var minutes = parseInt(conquer[0], 10);
                  var seconds = parseInt(conquer[1], 10);
                  var minute = "";
                  seconds -= 1;
                  if (minutes < 0) return clearInterval(interval);
                  if (seconds < 0 && minutes != 0) {
                    minutes -= 1;
                    seconds = 59;
                  }
                  if (minutes < 10 && minutes.length != 2) minutes = "0" + minutes;
                  if (seconds < 10 && length.seconds != 2) seconds = "0" + seconds;
                  if (
                    !angular.isUndefined(communicationService.getData("isLoggedIn")) &&
                    communicationService.getData("isLoggedIn") == true
                  ) {
                    communicationService.setData("sessionTimer", minutes + ":" + seconds);
                    sessionTimer = communicationService.getData("sessionTimer");
                  } else {
                    minutes = 0;
                    seconds = 0;
                    communicationService.setData("sessionTimer", minutes + ":" + seconds);
                    sessionTimer = communicationService.getData("sessionTimer");
                  }

                  $(".countDown").html(minutes + ":" + seconds);

                  if (minutes != 0) {
                    $(".second").css("display", "none");
                    $(".minute").css("display", "inline");
                  } else {
                    $(".second").css("display", "inline");
                    $(".minute").css("display", "none");
                  }
                  if (minutes >= SESSION_BANNER_TIMEOUT_MINUTES && seconds >= 0) {
                    $(".sessiondetails").css("display", "none");
                    //$mdDialog.hide();
                  } else if (minutes <= SESSION_BANNER_TIMEOUT_MINUTES && seconds <= 59) {
                    if (minutes == 0) {
                      countDown.innerHTML = seconds;
                    } else {
                      countDown.innerHTML = minutes + ":" + seconds;
                    }

                    if (!$(".sessionTimeoutPopup").hasClass("alive")) {
                      $(".sessiondetails").css("display", "block");
                      $(".sessionTimeoutPopup").addClass("alive");
                      $scope.openSessionWarningPopup("sessionWarningPopup");
                    }
                  }

                  if ((minutes == 0 && seconds == 0) || (minutesLastFocus != undefined && minutesLastFocus >= 30)) {
                    clearInterval(interval);
                    minutes = 0;
                    seconds = 0;
                    communicationService.setData("sessionTimer", minutes + ":" + seconds);
                    communicationService.setData("setSessionData", null);
                    $mdDialog.hide();
                    $sessionStorage.setSessionData = null;
                    $document.find("body").off("mousemove keydown DOMMouseScroll mousewheel mousedown touchstart");
                    $sessionStorage.sessionExpire = true;
                    $mdDialog.hide();
                    $(".sessionTimeoutPopup").removeClass("alive");
                    $scope.stop();
                    Auth.logout(false);
                  }
                }
              }
            } else {
              $scope.stop();
            }
          }, 1000);
        } else {
          //$('.sessionTimeoutPopup').removeClass("alive");
          $mdDialog.hide();
          // $state.go('login');
        }
      };

      $scope.stop = function () {
        if (angular.isDefined(interval)) {
          $mdDialog.hide();
          $(".sessionTimeoutPopup").removeClass("alive");

          $interval.cancel(interval);
          interval = undefined;
          intervalFlag = false;
        }
      };

      $document.find("body").on("mousemove keydown DOMMouseScroll mousewheel mousedown touchstart", checkAndResetIdle);

      function checkAndResetIdle() {
        if (!$(".sessionTimeoutPopup").hasClass("alive")) {
          $(".sessionTimeoutPopup").removeClass("alive");
          // $mdDialog.hide();
          $(".sessiondetails").css("display", "none");
          intervalFlag = true;
        }
      }

      $scope.openSessionWarningPopup = function (id) {
        $mdDialog.hide();
        $mdDialog.show({
          contentElement: angular.element("#" + id)
        });
      };

      $scope.keepAlive = function () {
        Account.get();
        $(".sessionTimeoutPopup").removeClass("alive");
        $mdDialog.hide();
        $(".sessiondetails").css("display", "none");
        intervalFlag = true;
      };
    }
  ]);
})();

/**
 * @ngdoc service
 * @name restService
 * @description Service in the LARI-AID.
 */
(function () {
  "use strict";

  angular.module("lariAidApp").factory("restService", [
    "$resource",
    "BASE_URL",
    function ($resource, BASE_URL) {
      return new ajaxCall($resource, BASE_URL);
    }
  ]);

  function ajaxCall(resource, BASE_URL) {
    this.resource = resource;
    this.restCall = function (data, url1, method) {
      var timestamp = new Date().getTime();
      if (url1.indexOf("?") != -1) {
        url1 = url1 + "&timestamp=" + timestamp;
      } else if (url1.indexOf("?") == -1) {
        url1 = url1 + "?timestamp=" + timestamp;
      }
      var url = BASE_URL + "api/" + url1;

      if (method == "GET") {
        var getDetail = resource(url);
        return getDetail.get();
      } else if (method == "GETLIST") {
        var getDetails = resource(url);
        return getDetails.query();
      } else if (method == "POST") {
        var saveDetail = resource(url);
        var promise = saveDetail.save(data);
        return promise;
      } else if (method == "PUT") {
        var updateDetail = resource(url, null, { update: { method: "PUT" } });
        var promise = updateDetail.update(data);
        return promise;
      } else if (method == "DELETE") {
        var deleteDetail = resource(url, null, { delete_method: { method: "DELETE" } });
        var promise = deleteDetail.delete_method();
        return promise;
      }
    };
  }
})();

(function(){
	'use strict'; 

angular
  .module('lariAidApp')
  .service('StorageDelete', ['$sessionStorage', function ($sessionStorage) {
	  	//Clearing filters value
	  
	    this.deleteInvestigation = function(index) {
	    	//investigation
            delete $sessionStorage.subFilters;
            delete $sessionStorage.selectedItemList;
            delete $sessionStorage.prevFilterList;
            delete $sessionStorage.prevClosedList;  
            delete $sessionStorage.sortBy;
            delete $sessionStorage.myInvestigation;
            delete $sessionStorage.formType;
            delete $sessionStorage.endlessScrollRetain;
            delete $sessionStorage.isRetainedCloseFilter;
	    };

	    this.deleteUser = function() {
	    	 //user
            delete $sessionStorage.selectedUserRoleList;
            delete $sessionStorage.userFilter;
            delete $sessionStorage.selectedCasesList;
            delete $sessionStorage.userEndlessScrollRetain;
            delete $sessionStorage.subUserFilters;
            delete $sessionStorage.userManagementActiveState;
	    };
	    
	  //library
	    this.deleteLibrary  = function(){
	    	
	    	//Entity
	    	delete $sessionStorage.selectedEntityType;
	    	delete $sessionStorage.libraryEnityLocationObject;
	    	delete $sessionStorage.entitySortBy;
	    	
	    	//Request
	    	delete $sessionStorage.selectedRequestList;
	    	delete $sessionStorage.requestSortBy;
	    	delete $sessionStorage.formRequest;
	    	
	    	// location
	    	delete $sessionStorage.locationSortBy;
	    	delete $sessionStorage.locFilter;
	    	
	    };
        
        //session
        this.deleteSessionValue = function() {
             //session timeout handling
            delete $sessionStorage.isLoggedIn;
            delete $sessionStorage.setSessionData;
            delete $sessionStorage.currentEnvironment;
        };


	
	}]
  );
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/home',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('home.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('home.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("InvestigationController", InvestigationController);

  InvestigationController.$inject = [
    "$rootScope",
    "$scope",
    "Auth",
    "Principal",
    "LoginService",
    "$state",
    "$mdSidenav",
    "$element",
    "JhiLanguageService",
    "$translate",
    "BaseFactory",
    "APP",
    "communicationService",
    "$timeout",
    "InvestigationService",
    "$mdMedia",
    "$sessionStorage",
    "$mdSelect",
    "StorageDelete",
    "CommonService",
    "LibraryRequestService",
    "LibraryService",
    "$location",
    "$mdDialog",
    "notifications",
    "BASE_URL",
    "$cookies",
    'InvestigationFormService',
    '$http'
  ];

  function InvestigationController(
    $rootScope,
    $scope,
    Auth,
    Principal,
    LoginService,
    $state,
    $mdSidenav,
    $element,
    JhiLanguageService,
    $translate,
    BaseFactory,
    APP,
    communicationService,
    $timeout,
    InvestigationService,
    $mdMedia,
    $sessionStorage,
    $mdSelect,
    StorageDelete,
    CommonService,
    LibraryRequestService,
    LibraryService,
    $location,
    $mdDialog,
    notifications,
    BASE_URL,
    $cookies,
    InvestigationFormService,
    $http
  ) {
    var vm = this;
    var searchText;
    $scope.media = $mdMedia;

    vm.allActiveType = {};
    vm.allActiveType.checked = false;
    vm.selectedItemList = [];
    vm.selectedIndex = [];
    vm.selectCloseList = [];
    vm.filterObj = {};
    vm.loadingListData = false;
    vm.selectedCountries = "";
    vm.filterObj.statusKey = [];
    vm.filterObj.dnaTests = [];
    vm.entityReviewItems = [];
    vm.closedRequests = ["Approved", "Altered"];
    vm.entityRequestOld = {};
    vm.entityRequestNew = {};
    vm.locationRequestNew = {};
    vm.locationRequestNew.countryObj = {};
    vm.locationRequestNew.provinceObj = {};
    vm.locationRequestNew.cityObj = {};
    vm.locationRequestNew.sectorObj = {};

    vm.entityRequestOld.countryObj = {};
    vm.entityRequestOld.provinceObj = {};
    vm.entityRequestOld.cityObj = {};
    vm.entityRequestOld.sectorObj = {};
    $scope.noOfDays = null;
    $scope.firstName = "";
    $scope.lastName = "";
    $scope.requestDuration = null;
    $scope.requestedByFirstName = "";
    $scope.requestedByLastName = "";
    vm.inputIsHideObject = {};
    vm.relpaceinputfieldObject = {};
    vm.relpaceinputfieldObject.country = false;
    vm.relpaceinputfieldObject.province = false;
    vm.relpaceinputfieldObject.city = false;
    vm.relpaceinputfieldObject.sector = false;
    vm.locationRequestNew = {};
    vm.locationRequestNew.countryObj = {};
    vm.locationRequestNew.provinceObj = {};
    vm.locationRequestNew.cityObj = {};
    vm.locationRequestNew.sectorObj = {};
    vm.mergeFlag = false;
    vm.mergeEntity = false;
    vm.locationIdValidation = false;

    var listTotalLength = 0;
    vm.dnaTestShowViewOpenInv = true;
    vm.dnaTestShowViewClosedInv = true;
    vm.dnaTestReceviedShowViewOpenInv = true;
    vm.dnaTestReceviedShowViewClosedInv = true;
    vm.dnaCenterShowViewOpenInv = true;
    vm.dnaCenterShowViewClosedInv = true;
    $scope.dateOfDnaTestOpenInv = false;
    $scope.dateOfDnaTestRecivedOpenInv = false;
    $scope.dnaCenterOpenInv = false;
    $scope.dateOfDnaTestClosedInv = false;
    $scope.dateOfDnaTestRecivedClosedInv = false;
    $scope.dnaCenterClosedInv = false;
    $scope.dnaIcon = true;
    /*vm.user =  $cookies.getObject('sessionDetails');*/
    vm.user = CommonService.getCookieUser().cookieUser;

    vm.endlessScrollRetain = {};

    if ($sessionStorage.endlessScrollRetain) {
      vm.endlessScrollRetain = $sessionStorage.endlessScrollRetain;
    }

    //Constants
    vm.APP = APP;
    vm.roleAnalyst = vm.APP.GLOBAL.ROLE_ANALYST;
    vm.endless = vm.APP.GLOBAL.ENDLESS;
    vm.roleInvestigator = vm.APP.GLOBAL.ROLE_INVESTIGATOR;

    vm.filterObj.page = 0;
    vm.filterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
    vm.investigationList = [];
    vm.loadingData = false;

    vm.filters = {};
    vm.filters.regions = [];
    vm.filters.isByClosedDate = undefined;
    vm.filters.isDnaByClosedDate = undefined;
    vm.filters.isRetainedCloseFilter = false;
    vm.filters.isDnaNotRequiredFilter;
    vm.allCountries = false;
    var investigation = {};
    vm.sortBy = {};

    $scope.myDate = new Date();

    $scope.maxDates = new Date($scope.myDate.getFullYear(), $scope.myDate.getMonth(), $scope.myDate.getDate());

    $scope.maxDate = new Date($scope.myDate.getFullYear(), $scope.myDate.getMonth(), $scope.myDate.getDate());

    $scope.change = function (temp) {
      $scope.minDates = temp;
    };

    $scope.changeTo = function (temp) {
      $scope.maxDates = temp;
    };

    vm.isMobile = false;
    if (!$scope.media("gt-sm")) {
      vm.isMobile = true;
    } else {
      vm.isMobile = false;
    }

    vm.clearName = function (name, searchKey, dropValue) {
      if (!vm.filters[name] || !vm.filters[name].id) {
        $scope[searchKey] = undefined;
        vm[dropValue] = undefined;
      }
    };

    vm.clearDate = function (startDate, endDate) {
      if (vm.filters[startDate] == undefined || vm.filters[endDate] == undefined) {
        vm.filters[startDate] = undefined;
        vm.filters[endDate] = undefined;
      }
    };

    vm.deleteEndlessDetails = function () {
      vm.endlessScrollRetain = {};
      delete $sessionStorage.endlessScrollRetain;
    };

    vm.searchInvestigatorAnalyst = function (searchKey, roleId) {
      if (searchKey) {
        if (roleId == vm.roleInvestigator) {
          vm.investigatorLoader = true;
          vm.analystLoader = false;
        } else if (roleId == vm.roleAnalyst) {
          vm.investigatorLoader = false;
          vm.analystLoader = true;
        }
        var data = CommonService.getUsersList(roleId, searchKey);
        data.then(function (response) {
          if (roleId == vm.roleInvestigator) {
            vm.investigatorVO = response;
            vm.investigatorLoader = false;
          } else if (roleId == vm.roleAnalyst) {
            vm.analystVO = response;
            vm.analystLoader = false;
          }
        });
      }
    };

    /* Method name           : vm.searchDnaCenter()
    	 * Method Description 	 : This method is used to get all DNA center by searchKey 
		 * @author Dinesh Sekar
		 */
		vm.searchDnaCenter = function(searchKey , Investigation){
			if(searchKey != null && searchKey.length >=2){
			vm.dnaFilter = {};
			vm.dnaFilter.searchKey = searchKey;
			vm.dnaFilter.entityTypeKey = "DNA_CENTER";
			var data = InvestigationFormService.addorSuggestEntityRequest(vm.dnaFilter);
		    data.then(function(response){
				if (Investigation == "openInvestigation") {
					vm.dnaCenterValueOpenInv = response;
					vm.dnaCenterValueLoaderOpenInv = false;
				  } else if (Investigation == "ClosedInvestigation") {
					vm.dnaCenterValueClosedInv = response;
					vm.dnaCenterValueClosedInvLoader = false;
				  }
              });
			}
		}
        
    vm.searchProspects = function (prospectSearchKey) {
      vm.filterObj.searchKey = prospectSearchKey;
      vm.filters.searchKey = prospectSearchKey;
      if (prospectSearchKey.length > 1 || prospectSearchKey.length == 0) {
        //vm.getInvestigationList('');//Get filter count and investigation list
        vm.getFilterList(undefined, true);
      }
      /* else {

        		//vm.getInvestigationList('');//Get filter count and investigation list
        		 vm.getFilterList(undefined,true);
        	 }

        		 vm.filters.searchKey = prospectSearchKey;
        	 }*/
    };

    vm.clearSearchProspects = function () {
      vm.prospectSearch = "";
      vm.searchProspects("");
    };

    //set the selected status key list in filterObj
    vm.setStatusKeyFilter = function () {
      if (vm.selectedItemList.length > 0) {
        //for DNA CR split the statusKey to openStatusKey and closedStatusKey 
				//To get investigation statusCount,headerCount and investigationlisting easier
        vm.filterObj.statusKey = [];
        vm.filterObj.openInvStatusKey = [];
        vm.filterObj.closedInvStatusKey = [];
        vm.prevFilterList = [];
        angular.forEach(vm.selectedItemList, function (data, key) {
          if (data.count > 0 || data.id != null) {
            if(data.id <= 13){
                 vm.filterObj.openInvStatusKey.push(data.id);
            vm.filterObj.statusKey.push(data.id);
            }
            if(data.id > 13){
            vm.filterObj.closedInvStatusKey.push(data.id);
            vm.filterObj.statusKey.push(data.id);
            } 
          }
          vm.prevFilterList.push(data);
        });
      }
      if (vm.prevClosedList.length > 0) {
        if (angular.isUndefined(vm.selectedItemList) || vm.selectedItemList.length == 0) {
          vm.filterObj.statusKey = [];
          vm.filterObj.openInvStatusKey = [];
          vm.filterObj.closedInvStatusKey = [];
        }
        angular.forEach(vm.prevClosedList, function (data, key) {
          if(data.count > 0 || data.id != null){
						if(data.id <= 13){
							vm.filterObj.openInvStatusKey.push(data.id);
							vm.filterObj.statusKey.push(data.id);
						}
						if(data.id > 13){
						  vm.filterObj.closedInvStatusKey.push(data.id);
						  vm.filterObj.statusKey.push(data.id);
						}
         	}
        });
      } else if (vm.prevClosedList.length == 0) {
        if (angular.isUndefined(vm.selectedItemList) || vm.selectedItemList.length == 0) {
          vm.filterObj.statusKey = [];
          vm.filterObj.openInvStatusKey = [];
          vm.filterObj.closedInvStatusKey = [];
        } else {
          vm.filterObj.statusKey = [];
          vm.filterObj.openInvStatusKey = [];
          vm.filterObj.closedInvStatusKey = [];
          angular.forEach(vm.selectedItemList, function (data, key) {
            if(data.count > 0 || data.id != null){
							if(data.id <= 13){
								vm.filterObj.openInvStatusKey.push(data.id);
								vm.filterObj.statusKey.push(data.id);
							}
								if(data.id > 13){
								vm.filterObj.closedInvStatusKey.push(data.id);
								vm.filterObj.statusKey.push(data.id);
							}
            }
          });
        }
      }
    };

    var clickingTimer;
    vm.getInvestigationList = function (type, headerStatusType) {
      clearTimeout(clickingTimer);

      clickingTimer = setTimeout(function () {
        vm.setStatusKeyFilter();
        if (angular.isUndefined(vm.sortBy) || angular.isUndefined(vm.sortBy.val)) {
          vm.filterObj.sortBy = "daysCountAsc";
          vm.filterObj.sortOrder = "asc";
        }
        vm.loadingData = true;
        if (type != vm.endless && vm.endlessScrollRetain && !vm.endlessScrollRetain.index) {
          vm.investigationList = [];
        }

        if (headerStatusType) {
          if (headerStatusType == vm.APP.INVESTIGATION.HEADER_TYPE_ALL) {
            vm.filterObj.daysCount = vm.APP.INVESTIGATION.HEADER_TYPE_ALL_VALUE;
          } else if (headerStatusType == vm.APP.INVESTIGATION.HEADER_TYPE_THIRTY) {
            vm.filterObj.daysCount = vm.APP.INVESTIGATION.ONE_MONTH;
          } else if (headerStatusType == vm.APP.INVESTIGATION.HEADER_TYPE_FIFTEEN) {
            vm.filterObj.daysCount = vm.APP.INVESTIGATION.HALF_MONTH;
          }
        }

        if (vm.investigationList && vm.investigationList.length == 0) {
          vm.filterObj.page = 0;
          listTotalLength = 0;
        }

        //Set size of the list to the previous size
        if (vm.endlessScrollRetain && vm.endlessScrollRetain.index) {
          vm.filterObj.page = 0;
          if (vm.endlessScrollRetain.page > vm.APP.GLOBAL.DEFAULT_SIZE) {
            vm.filterObj.size = vm.endlessScrollRetain.page;
          } else {
            vm.filterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
          }
        } else {
          vm.filterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
        }
        /*else if(vm.investigationList.length > 0){
            		vm.filterObj.page = vm.investigationList.length;
            	}*/

        if (vm.prospectSearch != undefined && (vm.prospectSearch.length > 1 || vm.prospectSearch.length == 0)) {
          vm.filterObj.searchKey = vm.prospectSearch;
          vm.filters.searchKey = vm.prospectSearch;
        }

        if (vm.filterObj.page < listTotalLength || listTotalLength == 0) {
          var data = InvestigationService.getInvestigationLists(vm.filterObj);
          data.then(
            function (response) {
              vm.noMoreMembers = false;
              if (response && !angular.equals({}, response) && response.totalCount) {
                listTotalLength = response.totalCount;
                angular.forEach(response.investigationList, function (value, key) {
                  if (value.birthDate != "" && value.birthDate != null) {
                    value.dobMonth = value.birthDate.substring(0, 3)
                    value.dobDay = value.birthDate.substring(3, 7)
                    value.dobYear = value.birthDate.substring(7, 12)
                  }
                  if (vm.investigationList == null) {
                    vm.investigationList = [];
                    vm.investigationList.push(value);
                  } else {
                    vm.investigationList.push(value);
                  }
                });
                vm.filterObj.page = vm.investigationList.length;

                if (vm.endlessScrollRetain && vm.endlessScrollRetain.index) {
                  var locationHash = vm.endlessScrollRetain.index;
                  $location.hash(locationHash);
                  $timeout(function () {
                    $location.url($location.path());
                  }, 500);
                }

                //Endless retain
                vm.endlessScrollRetain.page = vm.filterObj.page;

                //Remove index from this object
                if (vm.endlessScrollRetain.index) {
                  vm.endlessScrollRetain.index = undefined;
                }

                if (vm.filterObj.page == listTotalLength) {
                  vm.loadingData = false;
                  vm.noMembers = false;
                  vm.noMoreMembers = true;
                }

                if (vm.filterObj.page <= vm.APP.GLOBAL.DEFAULT_SIZE) {
                  vm.noMoreMembers = false;
                }
              } else if (angular.isUndefined(response)) {
                vm.loadingData = false;
                vm.noMembers = true;
                vm.noMoreMembers = false;
              }

              vm.loadingData = false;
              vm.loadingListData = false;
            },
            function (reason) {
              vm.loadingData = false;
              vm.loadingListData = false;
              return reason;
            }
          );
        } else {
          vm.loadingData = false;
          vm.loadingListData = false;
          vm.noMoreMembers = true;
          vm.noMembers = false;
        }
        $sessionStorage.subFilters = vm.filters;
        $sessionStorage.prevFilterList = vm.prevFilterList;
      }, 200);
    };

    $scope.callListfun = function () {
      vm.getInvestigationList(vm.endless);
    };

    /**
     * To get all the countries in the first call
     */
    vm.getAllRegions = function () {
      vm.regionsLoader = true;
      vm.translations = [];
      // Get the Spanish name details from translation JSON file
			$http.get('i18n/es/dashboard.json?version='+localStorage.getItem('lari_currentVersion'))
      .then(function(response) {
        vm.translations = response.data;					
      })
      .catch(function(error) {
        console.error('Error loading translations:', error);
      });
      var data = CommonService.getBirthCountry();
      data.then(function (response) {
        vm.allRegions = response;
        angular.forEach(vm.allRegions, function (item) {
          // Set the Spanish Names for countries
					if (vm.translations && vm.translations.dashboard) {
						vm.countryList = vm.translations.dashboard.filters.countries;
						angular.forEach(vm.countryList, function(key, value) {
							if (item.name == value) {
								item.spanishName = key;
							}
						});
					}		
          item.hidden = false;
          angular.forEach(vm.filters.regions, function (region) {
            if (region.id === item.id) {
              item.hidden = true;
            }
          });
        });
        vm.regionsLoader = false;
      });
    };

    /**
     * To show/hide the selected countries
     */
    vm.showSelectedCountry = function (id, flag) {
      if (!flag) {
        vm.allCountries = false;
      }
      angular.forEach(vm.allRegions, function (item) {
        if (item.id == id) {
          item.hidden = flag;
        }
      });
      $timeout(function () {
        if (vm.allRegions.length === vm.filters.regions.length) {
          vm.allCountries = true;
        }
      }, 0);
    };

    /**
     * Will execute when All countries option is chosed
     */
    vm.selectAllCountries = function () {
      vm.regionsLoader = true;
      vm.filters.regions = [];
      if (!vm.allCountries) {
        angular.forEach(vm.allRegions, function (item) {
          item.hidden = true;
        });
        $timeout(function () {
          angular.forEach(vm.allRegions, function (item) {
            vm.filters.regions.push(item);
          });
          vm.regionsLoader = false;
        }, 0);
      } else {
        angular.forEach(vm.allRegions, function (item) {
          item.hidden = false;
        });
        vm.regionsLoader = false;
      }
    };

    /**
     * To show the total number of countries selected
     */
    vm.selectCountry = function () {
      if (vm.filters.regions.length === 247) {
        vm.selectedCountries = vm.APP.LIBRARY.COUNTRIES + " " + vm.APP.INVESTIGATION.COUNTRIES;
      } else {
        vm.selectedCountries =
          "(" + vm.filters.regions.length + ")" + " " + vm.APP.INVESTIGATION.COUNTRIES + " " + "selected";
      }
    };

    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });
    vm.toggleLeft = toggleLeft("right");

    function toggleLeft(navID) {
      return function () {
        $mdSidenav(navID).toggle();
      };
    }

    vm.collapseAll = function (data) {
      for (var i in vm.accordianData) {
        if (vm.accordianData[i] != data) {
          vm.accordianData[i].expanded = false;
        }
      }
      data.expanded = !data.expanded;
    };
    $scope.toggleLeft = buildToggler("left");
    $scope.toggleRight = buildToggler("right");

    function buildToggler(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }

    vm.searchAgent = function (agentSearchKey) {
      if (agentSearchKey) {
        vm.agentLoader = true;
        var data = CommonService.getAgentLists(agentSearchKey);
        data.then(
          function (response) {
            vm.agentVO = response;
            vm.agentLoader = false;
          },
          function (reason) {
            return reason;
          }
        );
      }
      $scope.resizeOption();
    };

    $scope.resizeOption = function () {
      $timeout(function () {
        $(window).trigger("resize");
      }, 500);
    };

    $scope.TimeVO = {
      startDate: "28/12/2016",
      endDate: "28/12/2016"
    };

    var clickingTimerHeader;
    vm.getHeaderCount = function () {
      clearTimeout(clickingTimerHeader);
      clickingTimerHeader = setTimeout(function () {
        vm.setStatusKeyFilter();
        var data = InvestigationService.getHeaderCount(vm.filterObj);
        data.then(
          function (response) {
            vm.statusReport = response;
          },
          function (reason) {
            vm.loadingListData = false;
          }
        );
      }, 200);
    };

    vm.getSortedList = function (sortBy, isCallRequired) {
      vm.filterObj.sortBy = sortBy;
      if (sortBy == "daysCountDesc") {
        vm.filterObj.sortOrder = "desc";
      } else if (sortBy == "daysCountAsc") {
        vm.filterObj.sortOrder = "asc";
      } else if (sortBy == "firstName") {
        vm.filterObj.sortOrder = "asc";
      }

      $sessionStorage.sortBy = sortBy;

      if (!isCallRequired) {
        vm.getInvestigationList(""); //Prevent call from vm.investigationInit function.
      }
    };

    /**
     * To select the All active check box, when all the open investigations is checked.
     */
    vm.selectAllActive = function () {
      vm.test = false;
      angular.forEach(vm.openInvestigationList, function (data, key) {
        if (!data.checked) {
          vm.test = true;
        }
      });
      if (!vm.test) {
        vm.allActiveType.checked = true;
      }
    };

    /* Method name           :vm.dnaTestFilters()
     * Method Description    : This method is used to push and splice the value for new DNA filters
     * @author Dinesh Sekar
     */
    vm.dnaTestFilters = function(value,filter){
			vm.filterObj.dnaTests = [];
			if(filter == 'dnaNotRequired'){
				if(!value){
					$scope.firstFilter = false;
				}else{
					$scope.firstFilter = true;
				}
			}

			if(filter == 'dnaTestPending'){
				if(!value){
					$scope.secondFilter = false
				}else{
					$scope.secondFilter = true;
				}	
			}

			if(filter == 'dnaTestConducted'){
				if(!value){
					$scope.thirdFilter = false;
				}else{
					$scope.thirdFilter = true;
				}
			}

			if(!$scope.firstFilter && $scope.firstFilter != undefined){
				vm.filterObj.dnaTests.push("No");
			}
			if(!$scope.secondFilter && $scope.secondFilter != undefined){
				vm.filterObj.dnaTests.push("Yes");
			}
			if(!$scope.thirdFilter && $scope.thirdFilter != undefined){
				vm.filterObj.dnaTests.push("Selected");
			}
			vm.getFilterList();
		};
    
    vm.getFilterList = function (daysCount, loader, headerStatusType) {
      //To disable checkboxes

      if (vm.isMobile || !angular.isUndefined(headerStatusType)) {
        vm.loadingListData = true;
      }
      /*vm.userRole = vm.user.authorities[0];*/
      vm.userRole = CommonService.getCookieUser().loggedUser;
      vm.previousOpenList = angular.copy(vm.openInvestigationList);
      //vm.closeInvestigationList = [];
      //vm.openInvestigationList = [];
      //vm.statusList = []; //Commented the lines, so that while clicking on the filter will not hide the list in html page during runtime.
      vm.daysList = [];

      if ($sessionStorage.subFilters) {
        vm.filters = $sessionStorage.subFilters;
      }

      if (vm.filters.agents && vm.filters.agents.id) {
        vm.filterObj.agent = vm.filters.agents.id;
      }
      if (vm.filters.investigators && vm.filters.investigators.id) {
        vm.filterObj.investigator = vm.filters.investigators.id;
      }
      if (vm.filters.analysts && vm.filters.analysts.id) {
        vm.filterObj.analyst = vm.filters.analysts.id;
      }
      if (vm.filters.club && vm.filters.club.id) {
        vm.filterObj.club = vm.filters.club.id;
      }
      if (vm.filters.regions && vm.filters.regions.length > 0) {
        vm.filterObj.region = []; //vm.selectedCountriesNames = [];
        angular.forEach(vm.filters.regions, function (item, index) {
          vm.filterObj.region.push(item.id);
          //vm.selectedCountriesNames.push(item.name);
        });
        //vm.selectedCountries = vm.selectedCountriesNames.join(', ');
      }
      if (vm.filters.registrationTypes && vm.filters.registrationTypes.id) {
        vm.filterObj.registrationType = vm.filters.registrationTypes.id;
      }
      if (vm.filters.investigationTypes && vm.filters.investigationTypes.id) {
        vm.filterObj.investigationType = vm.filters.investigationTypes.id;
      }
      if (vm.filters.daysCount && vm.filters.daysCount.id) {
        vm.filterObj.daysCount = vm.filters.daysCount.id;
      }
      if (vm.filters.searchKey) {
        vm.filterObj.searchKey = vm.filters.searchKey;
        vm.prospectSearch = vm.filters.searchKey;
      } else {
        vm.filterObj.searchKey = "";
      }
      if (daysCount) {
        vm.filterObj.investigationDaysCount = daysCount;
      }
      if (vm.filters.isByClosedDate) {
        vm.filterObj.isByClosedDate = vm.filters.isByClosedDate;
        if ($sessionStorage.isRetainedCloseFilter) {
          vm.filters.isRetainedCloseFilter = true;
        }
        $sessionStorage.isRetainedCloseFilter = true;
      } else {
        $sessionStorage.isRetainedCloseFilter = false;
        vm.filters.isRetainedCloseFilter = false;
      }

      if (vm.filters.startDate) {
        vm.filters.startDate = moment(vm.filters.startDate).format("YYYY-MM-DD");
        vm.filterObj.startDate = vm.filters.startDate;
        vm.filters.startDate = new Date(vm.filters.startDate + "T00:00:00");
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.startDate = undefined;
      }
      if (vm.filters.endDate) {
        vm.filters.endDate = moment(vm.filters.endDate).format("YYYY-MM-DD");
        vm.filterObj.endDate = vm.filters.endDate;
        vm.filters.endDate = new Date(vm.filters.endDate + "T00:00:00");
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.endDate = undefined;
      }

      //For DNA CR introduce a new dnaCenter filter
      if (vm.filters.dnaCenterOpenInv && vm.filters.dnaCenterOpenInv.id) {
        vm.filterObj.dnaCenter = vm.filters.dnaCenterOpenInv.id;
      }

      //For DNA CR introduce a Two new filters
      if (vm.filters.startDateOfDnaTestOpenInv) {
        vm.filters.startDateOfDnaTestOpenInv = moment(vm.filters.startDateOfDnaTestOpenInv).format("YYYY-MM-DD");
        vm.filterObj.startDateOfDnaTest = vm.filters.startDateOfDnaTestOpenInv;
        vm.filters.startDateOfDnaTestOpenInv = new Date(vm.filters.startDateOfDnaTestOpenInv + "T00:00:00");
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.startDateOfDnaTest = undefined;
      }
      if (vm.filters.endDateOfDnaTestOpenInv) {
        vm.filters.endDateOfDnaTestOpenInv = moment(vm.filters.endDateOfDnaTestOpenInv).format("YYYY-MM-DD");
        vm.filterObj.endDateOfDnaTest = vm.filters.endDateOfDnaTestOpenInv;
        vm.filters.endDateOfDnaTestOpenInv = new Date(vm.filters.endDateOfDnaTestOpenInv + "T00:00:00");
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.endDateOfDnaTest = undefined;
      }

      if (vm.filters.startDateOfDnaTestRecivedOpenInv) {
        vm.filters.startDateOfDnaTestRecivedOpenInv = moment(vm.filters.startDateOfDnaTestRecivedOpenInv).format(
          "YYYY-MM-DD"
        );
        vm.filterObj.startDateOfDnaTestRecived = vm.filters.startDateOfDnaTestRecivedOpenInv;
        vm.filters.startDateOfDnaTestRecivedOpenInv = new Date(
          vm.filters.startDateOfDnaTestRecivedOpenInv + "T00:00:00"
        );
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.startDateOfDnaTestRecived = undefined;
      }
      if (vm.filters.endDateOfDnaTestRecivedOpenInv) {
        vm.filters.endDateOfDnaTestRecivedOpenInv = moment(vm.filters.endDateOfDnaTestRecivedOpenInv).format(
          "YYYY-MM-DD"
        );
        vm.filterObj.endDateOfDnaTestRecived = vm.filters.endDateOfDnaTestRecivedOpenInv;
        vm.filters.endDateOfDnaTestRecivedOpenInv = new Date(vm.filters.endDateOfDnaTestRecivedOpenInv + "T00:00:00");
        vm.filterObj.investigationDaysCount = undefined;
      } else {
        vm.filterObj.endDateOfDnaTestRecived = undefined;
      }
      $sessionStorage.subFilters = vm.filters;

      vm.setStatusKeyFilter();

      if (loader != undefined) vm.filterCountLoader = false;
      else vm.filterCountLoader = true;
      var data = InvestigationService.loadFilterList(vm.filterObj);
      data.then(
        function (response) {
          vm.filterCountLoader = false;
          if (vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            vm.openInvestigationList = response.Open_Investigations;
            vm.closeInvestigationList = response.Closed_Investigations;
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            vm.statusList = response.Investigator_Status_List;
            vm.daysList = response.Investigator_Days_List;
          }

          if (vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            vm.loadFilteredList(headerStatusType);
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
          /*else if(vm.userRole == vm.APP.GLOBAL.ROLE_ADMIN) {
            		vm.loadFilteredList();
        		}*/
            if (vm.statusList.length > 0) {
              if ($sessionStorage.prevFilterList) {
                vm.prevFilterList = $sessionStorage.prevFilterList;
              }

              if (vm.prevFilterList.length > 0) {
                angular.forEach(vm.statusList, function (data, key) {
                  angular.forEach(vm.prevFilterList, function (val, index) {
                    if (data.id == val.id) {
                      data.checked = true;
                    }
                  });
                });
              } else {
                if ($sessionStorage.selectedItemList) {
                  vm.selectedItemList = $sessionStorage.selectedItemList;
                }
                angular.forEach(vm.statusList, function (data, key) {
                  angular.forEach(vm.selectedItemList, function (val, index) {
                    if (data.id == val.id) {
                      data.checked = true;
                    }
                  });
                });
              }
              vm.selectedItemList = [];
              angular.forEach(vm.statusList, function (data, key) {
                if (data.checked) {
                  vm.selectedItemList.push(data);
                }
              });
            }
            if (vm.daysList.length > 0) {
              if ($sessionStorage.prevClosedList) {
                vm.prevClosedList = $sessionStorage.prevClosedList;
              }
              if (vm.prevClosedList.length > 0) {
                angular.forEach(vm.daysList, function (data, key) {
                  angular.forEach(vm.prevClosedList, function (val, index) {
                    if (data.id == val.id) {
                      data.checked = true;
                    }
                  });
                });
              } else {
                angular.forEach(vm.daysList, function (data, key) {
                  data.checked = false;
                });
              }
              vm.selectCloseList = [];
              angular.forEach(vm.daysList, function (data, key) {
                if (data.checked) {
                  vm.selectCloseList.push(data);
                }
              });
            }
            vm.getHeaderCount(); // call header count
            //call investigation list
            if (angular.isUndefined(headerStatusType)) vm.getInvestigationList("");
            else vm.getInvestigationList("", headerStatusType);
          }
          /*else if(vm.userRole == vm.APP.GLOBAL.ROLE_ANALYST) {
        			vm.loadFilteredList();
        		}*/
        },
        function (reason) {
          vm.loadingListData = false;
        }
      );
    };

    /* Method name           : vm.checkboxHideAndShow
     * Method Description    : This method is used to checkbox vaildation for DNA filters
     * @author Dinesh Sekar
     */
    vm.checkboxHideAndShow = function (value, filter) {
      if (filter == "dateOfDnaTest") {
        if (value == false) {
          vm.dnaTestShowViewOpenInv = false;
        } else {
          vm.dnaTestShowViewOpenInv = true;
        }
      } else if (filter == "dateofDnaTestRecived") {
        if (value == false) {
          vm.dnaTestReceviedShowViewOpenInv = false;
        } else {
          vm.dnaTestReceviedShowViewOpenInv = true;
        }
      } else if (filter == "dnaCenter") {
        if (value == false) {
          vm.dnaCenterShowViewOpenInv = false;
        } else {
          vm.dnaCenterShowViewOpenInv = true;
        }
      } else if (filter == "dateOfDnaTestClosedInvestigation") {
        if (value == false) {
          vm.dnaTestShowViewClosedInv = false;
        } else {
          vm.dnaTestShowViewClosedInv = true;
        }
      } else if (filter == "dateofDnaTestRecivedClosedInvestigation") {
        if (value == false) {
          vm.dnaTestReceviedShowViewClosedInv = false;
        } else {
          vm.dnaTestReceviedShowViewClosedInv = true;
        }
      } else if (filter == "dnaCenterClosedInvestigation") {
        if (value == false) {
          vm.dnaCenterShowViewClosedInv = false;
        } else {
          vm.dnaCenterShowViewClosedInv = true;
        }
      }
    };

    vm.loadFilteredList = function (headerStatusType) {
      if (vm.openInvestigationList.length > 0) {
        angular.forEach(vm.openInvestigationList, function (data, key) {
          if (key == 0) {
            vm.allActiveType = data;
            //vm.allActiveType.checked= false;
            vm.openInvestigationList.splice(0, 1);
          }
        });

        // Get selected list from storage
        if ($sessionStorage.prevFilterList) {
          vm.prevFilterList = $sessionStorage.prevFilterList;
        }

        if (vm.prevFilterList.length > 0) {
          angular.forEach(vm.openInvestigationList, function (data, key) {
            angular.forEach(vm.prevFilterList, function (val, index) {
              if (data.id == val.id) {
                data.checked = true;
              }
            });
          });
        } else {
          if ($sessionStorage.selectedItemList) {
            vm.selectedItemList = $sessionStorage.selectedItemList;
          }
          angular.forEach(vm.openInvestigationList, function (data, key) {
            angular.forEach(vm.selectedItemList, function (val, index) {
              if (data.id == val.id) {
                data.checked = true;
              }
            });
          });
        }
        vm.selectedItemList = [];
        angular.forEach(vm.openInvestigationList, function (data, key) {
          if (data.checked) {
            vm.selectedItemList.push(data);
          }
        });
      }
      if (vm.closeInvestigationList.length > 0) {
        if ($sessionStorage.prevClosedList) {
          vm.prevClosedList = $sessionStorage.prevClosedList;
        }

        if (vm.filters.isByClosedDate && !vm.filters.isRetainedCloseFilter) {
          vm.selectCloseList = [];
          vm.prevClosedList = [];
          angular.forEach(vm.closeInvestigationList, function (data, key) {
            if (data.count > 0) {
              data.checked = true;
              vm.selectCloseList.push(data);
              vm.prevClosedList.push(data);
            }
          });
          $sessionStorage.prevClosedList = vm.prevClosedList;
        } else if (vm.filters.isByClosedDate) {
          if (vm.prevClosedList.length > 0) {
            angular.forEach(vm.closeInvestigationList, function (data, key) {
              angular.forEach(vm.prevClosedList, function (val, index) {
                if (data.id == val.id) {
                  data.checked = true;
                }
              });
            });
          }
        } else if (vm.prevClosedList.length > 0) {
          angular.forEach(vm.closeInvestigationList, function (data, key) {
            angular.forEach(vm.prevClosedList, function (val, index) {
              if (data.id == val.id) {
                data.checked = true;
              }
            });
          });
        } else {
          angular.forEach(vm.closeInvestigationList, function (data, key) {
            data.checked = false;
          });
        }
        vm.selectCloseList = [];
        angular.forEach(vm.closeInvestigationList, function (data, key) {
          if (data.checked) {
            vm.selectCloseList.push(data);
          }
        });
      }

      vm.selectAllActive(); // To check/uncheck All active checkbox
      vm.getHeaderCount(); // call header count
      //call investigation list
      if (angular.isUndefined(headerStatusType)) vm.getInvestigationList("");
      else vm.getInvestigationList("", headerStatusType);
    };

    vm.getFilterDefaultList = function () {
      /*vm.userRole = vm.user.authorities[0];*/
      vm.userRole = CommonService.getCookieUser().loggedUser;
      vm.closeInvestigationList = [];
      vm.openInvestigationList = [];
      vm.statusList = [];
      vm.daysList = [];
      vm.filterCountLoader = true;
      var data = InvestigationService.loadFilterList(vm.filterObj);
      data.then(
        function (response) {
          vm.filterCountLoader = false;
          if (vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            vm.openInvestigationList = response.Open_Investigations;
            vm.closeInvestigationList = response.Closed_Investigations;
            if (vm.filters.isByClosedDate && vm.closeInvestigationList.length > 0) {
              vm.selectCloseList = [];
              angular.forEach(vm.closeInvestigationList, function (data, key) {
                if (data.count > 0) {
                  data.checked = true;
                  vm.selectCloseList.push(data);
                } else {
                  data.checked = false;
                }
              });
            }
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            vm.statusList = response.Investigator_Status_List;
            vm.daysList = response.Investigator_Days_List;
          }

          if (vm.userRole == vm.APP.GLOBAL.ROLE_ADMIN || vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) {
            if (vm.openInvestigationList.length > 0) {
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 0) {
                  vm.allActiveType = data;
                  //vm.allActiveType.checked= true;
                  vm.openInvestigationList.splice(0, 1);
                }
              });
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 0 || key == 2) {
                  data.checked = true;
                } else {
                  data.checked = false;
                }
              });
              if (vm.filterObj.isMyInvestigation == 1) {
                angular.forEach(vm.openInvestigationList, function (data, key) {
                  data.checked = true;
                });
              }
              /*if(vm.filterObj.isMyInvestigation == 0){
            				angular.forEach(vm.openInvestigationList, function(data, key) {
                				if(key == 0 || key == 2) {
                					data.checked = true;
                				} else {
                					data.checked = false;
                				}
                			});
            			} else {
            				angular.forEach(vm.openInvestigationList, function(data, key) {
                				data.checked = true;
            				});
            			}*/
              /*vm.selectedItemList = [];
                    	angular.forEach(vm.openInvestigationList, function(data, key) {
                    		if(data.checked) {
                    			vm.selectedItemList.push(data);
                    		}
                    	});*/
            }
            /*if(vm.closeInvestigationList.length > 0) {
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                    		data.checked = false;
                    	});
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                			if(data.checked) {
                				vm.selectCloseList.push(data);
                			}
                    	});
                	}*/
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_MANAGER) {
            if (vm.openInvestigationList.length > 0) {
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 0) {
                  vm.allActiveType = data;
                  //vm.allActiveType.checked= false;
                  vm.openInvestigationList.splice(0, 1);
                }
              });
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 4) {
                  data.checked = true;
                } else {
                  data.checked = false;
                }
              });
              if (vm.filterObj.isMyInvestigation == 1) {
                angular.forEach(vm.openInvestigationList, function (data, key) {
                  data.checked = true;
                });
              }
              /*	if(vm.filterObj.isMyInvestigation == 0){
                    		angular.forEach(vm.openInvestigationList, function(data, key) {
                				if(key == 4) {
                					data.checked = true;
                				} else {
                					data.checked = false;
                				}
                			});
            			} else {
            				angular.forEach(vm.openInvestigationList, function(data, key) {
                				data.checked = true;
            				});
            			}*/

              /*vm.selectedItemList = [];
                    	angular.forEach(vm.openInvestigationList, function(data, key) {
                    		if(data.checked) {
                    			vm.selectedItemList.push(data);
                    		}
                    	});*/
            }
            /*if(vm.closeInvestigationList.length > 0) {
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                    		data.checked = false;
                    	});
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                			if(data.checked) {
                				vm.selectCloseList.push(data);
                			}
                    	});
                	}*/
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_READ_ONLY) {
            if (vm.openInvestigationList.length > 0) {
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 0) {
                  vm.allActiveType = data;
                  //vm.allActiveType.checked= false;
                  vm.openInvestigationList.splice(0, 1);
                }
              });
              angular.forEach(vm.openInvestigationList, function (data, key) {
                data.checked = true;
              });
              angular.forEach(vm.closeInvestigationList, function (data) {
                if (data.key == "CONFIRMED") {
                  data.checked = true;
                }
              });
            }
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
            if (vm.statusList.length > 0) {
              angular.forEach(vm.statusList, function (data, key) {
                if (key == 0) {
                  data.checked = true;
                } else {
                  data.checked = false;
                }
              });
              /*vm.selectedItemList = [];
                    	angular.forEach(vm.statusList, function(data, key) {
                    		if(data.checked) {
                    			vm.selectedItemList.push(data);
                    		}
                    	});*/
            }
            if (vm.daysList.length > 0) {
              angular.forEach(vm.daysList, function (data, key) {
                data.checked = false;
              });
              /*angular.forEach(vm.daysList, function(data, key) {
                			if(data.checked) {
                				vm.selectCloseList.push(data);
                			}
                    	});*/
            }
          } else if (vm.userRole == vm.APP.GLOBAL.ROLE_ANALYST) {
            if (vm.openInvestigationList.length > 0) {
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 0) {
                  vm.allActiveType = data;
                  //vm.allActiveType.checked= false;
                  vm.openInvestigationList.splice(0, 1);
                }
              });
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (key == 1) {
                  data.checked = true;
                } else {
                  data.checked = false;
                }
              });
              if (vm.filterObj.isMyInvestigation == 1) {
                angular.forEach(vm.openInvestigationList, function (data, key) {
                  data.checked = true;
                });
              }
              /*if(vm.filterObj.isMyInvestigation == 0){
                			angular.forEach(vm.openInvestigationList, function(data, key) {
                				if(key == 3) {
                					data.checked = true;
                				} else {
                					data.checked = false;
                				}
                			});
            			} else {
            				angular.forEach(vm.openInvestigationList, function(data, key) {
                				data.checked = true;
            				});
            			}*/
              /*vm.selectedItemList = [];
                    	angular.forEach(vm.openInvestigationList, function(data, key) {
                    		if(data.checked) {
                    			vm.selectedItemList.push(data);
                    		}
                    	});*/
            }
            /*if(vm.closeInvestigationList.length > 0) {
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                    		data.checked = false;
                    	});
                		angular.forEach(vm.closeInvestigationList, function(data, key) {
                			if(data.checked) {
                				vm.selectCloseList.push(data);
                			}
                    	});
                	}*/
          }

          if (
            vm.userRole == vm.APP.GLOBAL.ROLE_ADMIN ||
            vm.userRole == vm.APP.GLOBAL.ROLE_MANAGER ||
            vm.userRole == vm.APP.GLOBAL.ROLE_ANALYST ||
            vm.userRole == vm.APP.GLOBAL.ROLE_READ_ONLY || vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN
          ) {
            if (vm.closeInvestigationList.length > 0) {
              angular.forEach(vm.closeInvestigationList, function (data, key) {
                data.checked = false;
                vm.prevClosedList = [];
                vm.selectCloseList = [];
              });
              /*angular.forEach(vm.closeInvestigationList, function(data, key) {
                			if(data.checked) {
                				vm.selectCloseList.push(data);
                			}
                    	});*/
            }
          }

          if (!$sessionStorage.selectedItemList) {
            vm.selectedItemList = [];
            if (!(vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR)) {
              angular.forEach(vm.openInvestigationList, function (data, key) {
                if (data.checked) {
                  vm.selectedItemList.push(data);
                }
              });
            } else if (vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR) {
              angular.forEach(vm.statusList, function (data, key) {
                if (data.checked) {
                  vm.selectedItemList.push(data);
                }
              });
            }
          }

          vm.getHeaderCount(); // call header count
          vm.getInvestigationList(""); //call investigation list
        },
        function (reason) {}
      );
    };

    vm.getDaysFilter = function (daysVal) {
      vm.filters.daysCount = daysVal;
      vm.getFilterList();
    };

    vm.closedList = [];
    vm.prevClosedList = [];
    vm.loadCloseinvList = function (item, list) {
      //To disable checkboxes
      if (!vm.isMobile) {
        vm.loadingListData = true;
      }
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
      vm.selectCloseList = list;
      vm.prevClosedList = [];
      angular.forEach(vm.selectCloseList, function (data, key) {
        vm.prevClosedList.push(data);
      });

      $sessionStorage.prevClosedList = vm.prevClosedList;

      if (!vm.isMobile) {
        //vm.getInvestigationList(''); The commented call will be included in getFilterList()
        vm.getFilterList(undefined, true);
      }
      vm.deleteEndlessDetails();
    };

    vm.dateChange = function (isCallRequired, value) {
      //For DNA CR have add a two filters
      if (
        vm.filters.startDateOfDnaTestOpenInv &&
        vm.filters.endDateOfDnaTestOpenInv &&
        value == "displayDnaDateOfTestOpenInvestigation" &&
        isCallRequired &&
        !vm.isMobile
      ) {
        vm.filters.displayDnaDateOfTestOpenInvestigation =
          moment(vm.filters.startDateOfDnaTestOpenInv).format("YYYY-MM-DD") +
          " - " +
          moment(vm.filters.endDateOfDnaTestOpenInv).format("YYYY-MM-DD");
        $mdSelect.hide();
        vm.getFilterList();
      } else if (
        vm.filters.startDateOfDnaTestRecivedOpenInv &&
        vm.filters.endDateOfDnaTestRecivedOpenInv &&
        value == "displayDnaTestRecived" &&
        isCallRequired &&
        !vm.isMobile
      ) {
        vm.filters.displayDnaTestRecived =
          moment(vm.filters.startDateOfDnaTestRecivedOpenInv).format("YYYY-MM-DD") +
          " - " +
          moment(vm.filters.endDateOfDnaTestRecivedOpenInv).format("YYYY-MM-DD");
        $mdSelect.hide();
        vm.getFilterList();
      } else if (vm.filters.startDate && vm.filters.endDate && isCallRequired && !vm.isMobile) {
        vm.filters.displayDate =
          moment(vm.filters.startDate).format("YYYY-MM-DD") + " - " + moment(vm.filters.endDate).format("YYYY-MM-DD");
        $mdSelect.hide();
        vm.getFilterList();
      }
    };

    vm.investigationCreatedDateChange = function (daysCount, isCallRequired, state) {
      var from = null;
      var to = null;
      to = moment().format("YYYY-MM-DD");

      if (daysCount == vm.APP.INVESTIGATION.ONE_MONTH) {
        from = moment().subtract(30, "days").format("YYYY-MM-DD");
      } else if (daysCount == vm.APP.INVESTIGATION.THREE_MONTH) {
        from = moment().subtract(3, "months").format("YYYY-MM-DD");
      } else if (daysCount == vm.APP.INVESTIGATION.SIX_MONTH) {
        from = moment().subtract(6, "months").format("YYYY-MM-DD");
      }
      // For DNA CR have add a two filters dateOfTest and dateOfTestRecived
      if (isCallRequired && !vm.isMobile && state == "displayDnaDateOfTestOpenInvestigation") {
        //clearing from and to date filters
        vm.filters.startDateOfDnaTestOpenInv = from;
        vm.filters.endDateOfDnaTestOpenInv = to;
        $mdSelect.hide();
        vm.filterObj.startDateOfDnaTest = undefined;
        vm.filterObj.endDateOfDnaTest = undefined;
        vm.getFilterList(daysCount);
      } else if (isCallRequired && !vm.isMobile && state == "displayDnaTestRecived") {
        //clearing from and to date filters
        vm.filters.startDateOfDnaTestRecivedOpenInv = from;
        vm.filters.endDateOfDnaTestRecivedOpenInv = to;
        $mdSelect.hide();
        vm.filterObj.startDateOfDnaTestRecived = undefined;
        vm.filterObj.endDateOfDnaTestRecived = undefined;
        vm.getFilterList(daysCount);
      } else {
        vm.filters.startDate = from;
        vm.filters.endDate = to;
        $mdSelect.hide();
        vm.filterObj.startDate = undefined;
        vm.filterObj.endDate = undefined;
        vm.getFilterList(daysCount);
      }
      if (state == "displayDnaDateOfTestOpenInvestigation") {
        vm.filters.displayDnaDateOfTestOpenInvestigation =
          moment(vm.filters.startDateOfDnaTestOpenInv).format("YYYY-MM-DD") +
          " - " +
          moment(vm.filters.endDateOfDnaTestOpenInv).format("YYYY-MM-DD");
      } else if (state == "displayDnaTestRecived") {
        vm.filters.displayDnaTestRecived =
          moment(vm.filters.startDateOfDnaTestRecivedOpenInv).format("YYYY-MM-DD") +
          " - " +
          moment(vm.filters.endDateOfDnaTestRecivedOpenInv).format("YYYY-MM-DD");
      } else {
        vm.filters.displayDate =
          moment(vm.filters.startDate).format("YYYY-MM-DD") + " - " + moment(vm.filters.endDate).format("YYYY-MM-DD");
      }
    };

    vm.clear = function (type, isCallRequired) {
      /*vm.filters[name] = undefined;
	       	vm[search] = undefined;*/
      if (type == "investigators") {
        vm.filters.investigators = {};
        $scope.investigatorSearchKey = "";
        vm.filterObj.investigator = "";
      } else if (type == "analysts") {
        vm.filters.analysts = {};
        $scope.analystSearchKey = "";
        vm.filterObj.analyst = "";
      } else if (type == "regions") {
        vm.filters.regions = [];
        $scope.regionSearchKey = "";
        vm.filterObj.region = [];
        vm.allCountries = false;
        angular.forEach(vm.allRegions, function (item) {
          item.hidden = false;
        });
      } else if (type == "club") {
        vm.filters.club = {};
        $scope.serchFilterClub = "";
        vm.filterObj.club = "";
      } else if (type == "investigationTypes") {
        vm.filters.investigationTypes = {};
        $scope.serchFilterInvType = "";
        vm.filterObj.investigationType = "";
      } else if (type == "registrationTypes") {
        vm.filters.registrationTypes = {};
        $scope.serchFilterRegType = "";
        vm.filterObj.registrationType = "";
      } else if (type == "agents") {
        vm.filters.agents = {};
        $scope.agentSearchKey = "";
        vm.filterObj.agent = "";
      } else if (type == "time") {
        vm.filters.time = {};
        vm.filters.startDate = "";
        vm.filters.endDate = "";
        if (vm.filterObj.isByClosedDate) {
          $sessionStorage.isRetainedCloseFilter = false;
          vm.filters.isRetainedCloseFilter = false;
        }
        vm.filters.isByClosedDate = undefined;
        vm.filterObj.isByClosedDate = undefined;
        $scope.selectedDiv = 0;
        vm.filters.isClosedFilter = undefined;
        //vm.filters.displayDate = undefined;
      } else if (type == "dnaCenterOpenInvestigation") {
        $scope.dnaCenterOpenInv = false;
        vm.filters.dnaCenterOpenInv = {};
        $scope.dnaSearchKey = "";
        vm.filterObj.dnaCenterOpenInv = "";
      } else if (type == "dnaCenter") {
        $scope.dnaCenterClosedInv = false;
        vm.filters.dnaCenterClosedInv = {};
        $scope.dnaSearchKeyClosedInvestigation = "";
        vm.filterObj.dnaCenterClosedInv = "";
      } else if (type == "openInvestigationDnaDates") {
        $scope.dateOfDnaTestOpenInv = false;
        vm.filters.dnaTest = {};
        vm.filters.startDateOfDnaTestOpenInv = "";
        vm.filters.endDateOfDnaTestOpenInv = "";
        vm.filters.isDnaByClosedDate = undefined;
        vm.filterObj.isDnaByClosedDate = undefined;
        $scope.selectedDiv = 0;
        vm.filters.isDnaClosedFilter = undefined;
      } else if (type == "dnaTestRecivedOpenInvestigation") {
        $scope.dateOfDnaTestRecivedOpenInv = false;
        vm.filters.dnaTestRecived = {};
        vm.filters.startDateOfDnaTestRecivedOpenInv = "";
        vm.filters.endDateOfDnaTestRecivedOpenInv = "";
        vm.filters.isDnaTestRecivedByClosedDate = undefined;
        vm.filterObj.isDnaTestRecivedByClosedDate = undefined;
        $scope.selectedDiv = 0;
        vm.filters.isDnaRecivedClosedFilter = undefined;
      } else if (type == "dnaTestRecivedClosedInvestigation") {
        $scope.dateOfDnaTestRecivedClosedInv = false;
        vm.filters.dnaRecivedClosedInvestigation = {};
        vm.filters.startDateOfDnaTestRecivedClosedInv = "";
        vm.filters.endDateOfDnaTestRecivedClosedInv = "";
        vm.filters.isDnaTestRecivedByClosedInvestigation = undefined;
        vm.filterObj.isDnaTestRecivedByClosedInvestigation = undefined;
        $scope.selectedDiv = 0;
        vm.filters.isdnaRecivedClosedInvestigationClosedFilter = undefined;
      } else if (type == "displayDateOfDnaTestClosedInvestigation") {
        $scope.dateOfDnaTestClosedInv = false;
        vm.filters.dateOfDnaTest = {};
        vm.filters.startDateOfDnaTestClosedInv = "";
        vm.filters.endDateOfDnaTestClosedInv = "";
        vm.filters.isDateOfDnaTestByClosedDate = undefined;
        vm.filterObj.isDateOfDnaTestByClosedDate = undefined;
        $scope.selectedDiv = 0;
        vm.filters.isDateOfDnaTestClosedInvestigationFilter = undefined;
      }

      if (isCallRequired && !vm.isMobile) {
        vm.getFilterList();
      }
    };

    vm.prevFilterList = [];
    vm.toggle = function (item, list, index) {
      //To disable checkboxes
      if (!vm.isMobile) {
        vm.loadingListData = true;
      }
      var idx = list.indexOf(item);
      vm.selectedIndex.push(index);
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }
      vm.selectedItemList = list;
      //vm.getFilterList();
      vm.prevFilterList = [];
      angular.forEach(vm.selectedItemList, function (data, key) {
        vm.prevFilterList.push(data);
      });
      /*vm.filterObj.statusKey = [];
	  		angular.forEach(vm.selectedItemList, function(data, key) {
	  			vm.filterObj.statusKey.push(data.id);
	  		});
	  		angular.forEach(vm.closedList, function(data, key) {
    			vm.filterObj.statusKey.push(data.id);
    		});*/
      $sessionStorage.prevFilterList = vm.prevFilterList;
      if (!vm.isMobile) {
        /*vm.getHeaderCount(); The commented calls will be included in getFilterList()
		        vm.getInvestigationList('');*/
        vm.getFilterList(undefined, true);
      }

      vm.deleteEndlessDetails();
    };

    vm.exists = function (item, list) {
      return list.indexOf(item) > -1;
    };

    vm.isChecked = function () {
      return vm.selectedItemList.length === vm.openInvestigationList.length;
    };

    vm.toggleAll = function (doSelectAll) {
      //To disable checkboxes
      if (!vm.isMobile) {
        vm.loadingListData = true;
      }
      //vm.allActiveType.checked = doSelectAll;
      if (!doSelectAll) {
        vm.selectedItemList = [];
      } else {
        vm.selectedItemList = [];
        angular.forEach(vm.openInvestigationList, function (data, key) {
          vm.selectedItemList.push(data);
        });
      }
      vm.prevFilterList = [];
      angular.forEach(vm.selectedItemList, function (data, key) {
        vm.prevFilterList.push(data);
      });
      /*vm.filterObj.statusKey = [];
      		angular.forEach(vm.selectedItemList, function(data, key) {
      			vm.filterObj.statusKey.push(data.id);
      		});*/

      $sessionStorage.prevFilterList = vm.prevFilterList;

      if (!vm.isMobile) {
        /*vm.getHeaderCount(); The commented calls will be included in getFilterList()
	      		vm.getInvestigationList('');*/
        vm.getFilterList(undefined, true);
      }
      vm.deleteEndlessDetails();
    };

    vm.toggleMyInvestigation = function (myInvestigation, isCallRequired) {
      if (!myInvestigation.checked) {
        vm.filterObj.isMyInvestigation = 1;
      } else {
        vm.filterObj.isMyInvestigation = 0;
      }
      if (isCallRequired) {
        if (!vm.isMobile) {
          vm.getFilterDefaultList();
        } else {
          vm.toggleAll(!myInvestigation.checked, true);
        }
        $sessionStorage.myInvestigation = myInvestigation;
      }
      vm.deleteEndlessDetails();
    };

    vm.investigationInit = function () {
      //Init values for My Investigation
      vm.myInvestigation = { name: vm.APP.INVESTIGATION.MY_INVESTIGATIONS };
      if ($sessionStorage.myInvestigation) {
        vm.myInvestigation.checked = $sessionStorage.myInvestigation.checked;
        if (vm.myInvestigation.checked) {
          vm.toggleMyInvestigation(false, false);
        }
      } else {
        vm.myInvestigation.checked = false;
        //vm.toggleMyInvestigation(false,false);
      }

      //To get all countries
      vm.getAllRegions();

      $mdSidenav("left").close();
      //Clearing user module session storage objects
      StorageDelete.deleteUser();
      StorageDelete.deleteLibrary();

      vm.sortOrderList = [
        {
          id: "daysCountAsc",
          val: "sortbydaysAsc"
        },
        {
          id: "daysCountDesc",
          val: "sortbydaysDesc"
        },
        {
          id: "firstName",
          val: "sortbyname"
        }
      ];

      //Sort by initialization through session storage
      if ($sessionStorage.sortBy) {
        for (var i = 0; i < vm.sortOrderList.length; i++) {
          if (vm.sortOrderList[i].id == $sessionStorage.sortBy) {
            vm.sortBy = vm.sortOrderList[i];
            break;
          }
        }

        vm.getSortedList(vm.sortBy.id, true); // To get sort by list
      }

      //Filter call
      if (!$sessionStorage.subFilters && !$sessionStorage.prevFilterList && !$sessionStorage.prevClosedList) {
        vm.getFilterDefaultList();
      } else {
        vm.getFilterList();
      }

      // drop down value
      var data = BaseFactory.getClubLists();
      data.then(function (response) {
        vm.clubVO = response;
      });
      var investigationTypeResult = CommonService.getRefTermList(vm.APP.REF_TERM.INVESTIGATION_TYPE);
      investigationTypeResult.then(function (response) {
        vm.investigationVO = response;
      });

      var registrationTypeResult = CommonService.getRefTermList(vm.APP.REF_TERM.REGISTRATION_TYPE);
      registrationTypeResult.then(function (response) {
        vm.registrationVO = response;
      });
    };

    vm.investigationInit();

    vm.prospectProfile = function (id, index) {
      vm.endlessScrollRetain.index = "inv" + index;
      $sessionStorage.endlessScrollRetain = vm.endlessScrollRetain;

      vm.id = communicationService.setData("investigationID", id);
      investigation.id = id;
      $state.go("profile", investigation);
    };

    vm.sideNavClose = function () {
      $mdSidenav("right").close();
    };

    vm.exportData = function () {
      var exportFileName = vm.APP.INVESTIGATION.EXPORTFILENAME;
      var url = BASE_URL + vm.APP.INVESTIGATION.EXPORT_API + $cookies.getObject('sessionDetails').login;
      var timestamp = new Date().getTime();
      var exportUrl = url + "&timestamp=" + timestamp;

      $http({
        url: exportUrl,
        method: "POST",
        data: vm.filterObj,
        headers: {
          "Content-type": "application/json"
        },
        responseType: "arraybuffer"
      }).success(function (data) {
        var blob = new Blob([data], { type: "application/xlsx" });
        var objectUrl = URL.createObjectURL(blob);
        var anchorElement = document.createElement("a");
        document.body.appendChild(anchorElement);
        anchorElement.style.display = "none";
        anchorElement.href = objectUrl;
        anchorElement.download = exportFileName;
        anchorElement.click();
        window.URL.revokeObjectURL(objectUrl);
      });
    };

    //Method to get the reopen/reassign flag for investigation
    $scope.getReopenFlag = function (investigationId, index) {
      vm["requestFlag_" + index] = false;
      vm["requestedShow_" + index] = false;
      if (vm.APP.INVESTIGATION.ENABLEREOPENFLAG == vm.APP.GLOBAL.TRUE) {
        vm["reopenLoader_" + index] = true;
        vm["reopenInvestigator_" + index] = false;
        vm["reopenAnalyst_" + index] = false;
        vm["reopenInvestigatorInprogress_" + index] = false;
        vm["reopenAnalystInprogress_" + index] = false;

        var data = InvestigationService.getReopenFlag(investigationId);
        data.then(
          function (response) {
            var reopenFlagDetails = response;
            vm["reopenLoader_" + index] = false;
            vm["reopenInvestigator_" + index] = reopenFlagDetails.investigatorFormReOpen;
            vm["reopenAnalyst_" + index] = reopenFlagDetails.analystFormReOpen;
            vm["reopenInvestigatorInprogress_" + index] = reopenFlagDetails.investigatorFormStatus;
            vm["reopenAnalystInprogress_" + index] = reopenFlagDetails.analystFormStatus;
          },
          function (reason) {
            vm["reopenLoader_" + index] = false;
          }
        );
      }
      var data = InvestigationService.getEntityIcon(investigationId);
      data.then(function (response) {
        if (response.show == true && response.show != undefined) {
          vm["requestFlag_" + index] = true;
        }
        if (response.requestedShow == true && response.requestedShow != undefined) {
          vm["requestedShow_" + index] = true;
        }
      });
    };

    vm.showIcon = function (ev, investigationId) {
      ev.stopPropagation();
      var data = InvestigationService.getEntityReviewItemsList(investigationId);
      data.then(function (response) {
        vm.entityReviewItems = response;
      });
      vm.id = "entityIconPopupId";
      vm.showEntityRequestDialog(ev, vm.id);
    };

    vm.showEntityRequestDialog = function ($event, id) {
      $mdDialog.show({
        targetEvent: $event,
        contentElement: "#" + id,
        parent: angular.element(document.body)
      });
    };

    vm.cancel = function (formName) {
      vm.entityReviewItems = [];
      vm.msgFlagForLocation = false;
      $mdDialog.hide();
    };

    vm.checkStatus = function (status) {
      if (status) {
        return true;
      } else {
        return false;
      }
    };

    $rootScope.getEntityProfileById = function (entityId, disable, ev) {
      vm.entityProfile = {};
      vm.entityPopupLoader = true;
      vm.entityId = entityId;
      vm.mergedEntityId = undefined;
      vm.entityLocationMappingId = undefined;
      vm.isMergeRequest = false;
      vm.isRequestMerged = false;
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        var responseObj = response;
        if (disable) {
          vm.isDisable = true;
          vm.isMergeRequest = true;
          vm.mergedEntityId = response.id;
        } else {
          vm.entityRequestOld = angular.copy(responseObj);
          vm.entityNameSearchText = vm.entityRequestOld.name;
          //isForm is to know whether the request is from form section or Library Section
          vm.entityRequestOld.isForm = responseObj.isForm;
        }
        vm.entityRequestNew = angular.copy(responseObj);
        $scope.noOfDays = responseObj.noOfDays;
        $scope.firstName = responseObj.createdByFirstName;
        $scope.lastName = responseObj.createdByLastName;
        vm.entityRequestNew.entityName = LibraryService.getEntityNameObj(responseObj);
        vm.entityLocationMappingId = responseObj.locationMappingId;
        vm.getLocationMappingDataById(vm.entityLocationMappingId, disable);
        vm.getEntityTypeById(responseObj.entityTypeId, disable);
        vm.entityPopupLoader = false;
        //Get Merged Entity Profile Details
        if (responseObj.isMerged) {
          vm.isRequestMerged = true;
          vm.getMergedObj(responseObj.mergedEntityId);
        }
        if (!disable) {
          vm.getRequestPopupId(ev, vm.APP.LIBRARY.ENTITY_REQUEST);
        }
      });
    };

    vm.getLocationMappingDataById = function (locationMappingId, disable) {
      var locationData = CommonService.getLocationById(locationMappingId);
      locationData.then(function (response) {
        var responseObj = response;
        $scope.requestDuration = response.noOfDays;
        $scope.requestedByFirstName = response.requestByFirstName;
        $scope.requestedByLastName = response.requestByLastName;
        //Set location objects
        if (!disable) {
          vm.entityRequestOld.countryObj = LibraryService.getCountryObj(responseObj);
          vm.entityRequestOld.provinceObj = LibraryService.getProvinceObj(responseObj);
          vm.entityRequestOld.cityObj = LibraryService.getCityObj(responseObj);
          vm.entityRequestOld.sectorObj = LibraryService.getSectorObj(responseObj);
        }
        vm.entityRequestNew.countryObj = LibraryService.getCountryObj(responseObj);
        vm.entityRequestNew.provinceObj = LibraryService.getProvinceObj(responseObj);
        vm.entityRequestNew.cityObj = LibraryService.getCityObj(responseObj);
        vm.entityRequestNew.sectorObj = LibraryService.getSectorObj(responseObj);
      });
    };

    vm.getEntityTypeById = function (entityTypeId, disable) {
      var entityTypeData = CommonService.getRefTermList(vm.APP.REF_TERM.ENTITY_PROFILE);
      entityTypeData.then(function (response) {
        vm.entityTypeList = response;
        if (vm.entityTypeList) {
          angular.forEach(vm.entityTypeList, function (data, key) {
            if (data.id == entityTypeId) {
              if (!disable) {
                vm.entityRequestOld.entityType = data;
              }
              vm.entityRequestNew.entityType = data;
              vm.requestEntityType = data.name;
            }
          });
        }
      });
    };

    vm.getMergedObj = function (entityId) {
      vm.entityRequestNew = {};
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        vm.entityRequestNew = response;
        vm.entityRequestNew.entityName = LibraryService.getEntityNameObj(vm.entityRequestNew);

        if (vm.entityTypeList) {
          angular.forEach(vm.entityTypeList, function (data, key) {
            if (data.id == vm.entityRequestNew.entityTypeId) {
              vm.entityRequestNew.entityType = data;
            }
          });
        }

        var locationData = CommonService.getLocationById(vm.entityRequestNew.locationMappingId);
        locationData.then(function (response) {
          var responseObj = response;
          vm.entityRequestNew.countryObj = LibraryService.getCountryObj(responseObj);
          vm.entityRequestNew.provinceObj = LibraryService.getProvinceObj(responseObj);
          vm.entityRequestNew.cityObj = LibraryService.getCityObj(responseObj);
          vm.entityRequestNew.sectorObj = LibraryService.getSectorObj(responseObj);
        });
      });
    };

    vm.getRequestPopupId = function (ev, requestType) {
      vm.id = "";

      //Check closed status
      var idx = vm.closedRequests.indexOf("open");

      if (requestType == vm.APP.LIBRARY.LOCATION_REQUEST) {
        //View Location Request Profile for other users
        vm.id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
        if (vm.userRole == vm.APP.GLOBAL.ROLE_MANAGER || vm.isRequestMerged) {
          vm.id = vm.APP.LIBRARY.REQ_LOC_ID;
          if (idx > -1) {
            vm.id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
          }
        }
      } else if (requestType == vm.APP.LIBRARY.ENTITY_REQUEST) {
        vm.id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
        if (vm.userRole == vm.APP.GLOBAL.ROLE_MANAGER || vm.isRequestMerged) {
          vm.id = vm.APP.LIBRARY.REQ_ENTITY_ID;
          // For read only popup if the requestStatus as closed
          if (idx > -1) {
            vm.id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
          }
        }
      }
      vm.showRequestDialog(ev, vm.id);
    };

    vm.entityApprove = function (entityRequestNew, requestEntityForm) {
      var approveEntityRequest = {};
      vm.msgFlag = false;
      vm.isEntityApproveDisable = true;
      vm.locationIdValidation = false;
      var locationValidation = communicationService.getData("ValidateEntityLocationField");
      vm.validateLocationIds(locationValidation);
      if (entityRequestNew && requestEntityForm.$valid) {
        //Approve or Alterd
        if (!vm.isMergeRequest) {
          // For new entity name selection
          if (vm.isNewEntityName) {
            approveEntityRequest.name = vm.entityNameSearchText;
          }
          // For default entity name or change from dropdown
          else {
            approveEntityRequest.name = vm.entityRequestNew.entityName.name;
          }

          if (vm.entityRequestNew.entityType != null) {
            approveEntityRequest.entityTypeId = vm.entityRequestNew.entityType.id;
          }
          if (vm.entityId != null) {
            approveEntityRequest.id = vm.entityId;
          }

          approveEntityRequest.comments = entityRequestNew.comments;
          approveEntityRequest.flag = entityRequestNew.flag;
          approveEntityRequest.contactEmail = entityRequestNew.contactEmail;
          approveEntityRequest.contactPersonName = entityRequestNew.contactPersonName;
          approveEntityRequest.contactPhoneNumber = entityRequestNew.contactPhoneNumber;

          if (locationValidation && vm.locationIdValidation) {
            if (locationValidation.id) {
              approveEntityRequest.locationMappingId = locationValidation.id;
            } else if (locationValidation.locationMappingId) {
              approveEntityRequest.locationMappingId = locationValidation.locationMappingId;
            }
          } else if (
            entityRequestNew.cityObj.locationMappingId != null &&
            entityRequestNew.cityObj.locationMappingId != undefined
          ) {
            approveEntityRequest.locationMappingId = entityRequestNew.cityObj.locationMappingId;
          } else {
            approveEntityRequest.locationMappingId = vm.entityLocationMappingId;
          }
        }

        // Merged Request
        else {
          approveEntityRequest = angular.copy(vm.entityRequestOld);
          if (vm.isMergeRequest && vm.mergedEntityId != null) {
            approveEntityRequest.mergedEntityId = vm.mergedEntityId;
          }
        }
        if (vm.mergeEntity) {
          approveEntityRequest.isEntityMerge = true;
        } else {
          approveEntityRequest.isEntityMerge = false;
        }

        var data = LibraryRequestService.entityApprove(approveEntityRequest);
        data.then(
          function (response) {
            communicationService.setData("ValidateEntityLocationField", "");
            vm.cancel(requestEntityForm);
            notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST });
            vm.isEntityApproveDisable = false;
            vm.msgFlag = false;
            vm.mergeEntity = false;
            $state.reload();
          },
          function (reason) {
            if (reason.data.statusCode == 409) {
              vm.isEntityApproveDisable = false;
              vm.msgFlag = true;
              vm.mergeEntity = true;
            } else if (reason.data.statusCode == 400) {
              // if entity approved before location
              vm.isEntityApproveDisable = false;
              vm.msgFlagForLocation = true;
              $timeout(function () {
                vm.msgFlag = false;
                vm.entityPopupId = approveEntityRequest.id;
                vm.popUpId = vm.APP.LIBRARY.ENTITY_REQ;
              }, 5000);
            } else {
              notifications.showError({ message: vm.APP.LIBRARY.ENTITY_REQUEST_PROBLEM });
            }
            return reason;
          }
        );
      } else {
        vm.isEntityApproveDisable = false;
      }
    };
    vm.setFormLocationValues = function () {
      if (vm.locationRequestOld.countryId == null && vm.locationRequestOld.countryTxt != null) {
        vm.formCountryRequest = true;
        vm.locationRequestNew.countryObj.countryId = -1;
        vm.locationRequestNew.provinceObj.provinceId = -1;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.provinceId == null &&
        vm.locationRequestOld.provinceTxt != null &&
        vm.locationRequestOld.provinceTxt != ""
      ) {
        vm.formProvinceRequest = true;
        vm.addNewLocationObject.country = false;
        vm.locationRequestNew.provinceObj.provinceId = -1;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.cityId == null &&
        vm.locationRequestOld.cityTxt != null &&
        vm.locationRequestOld.cityTxt != ""
      ) {
        vm.formCityRequest = true;
        vm.addNewLocationObject.country = false;
        vm.addNewLocationObject.province = false;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.sectorId == null &&
        vm.locationRequestOld.sectorTxt != null &&
        vm.locationRequestOld.sectorTxt != ""
      ) {
        vm.addNewLocationObject.country = false;
        vm.addNewLocationObject.province = false;
        vm.addNewLocationObject.city = false;
        vm.locationRequestNew.sectorObj.sectorId = -1;
      }

      if (
        vm.locationRequestOld.sectorTxt != null &&
        vm.locationRequestOld.sectorTxt != "" &&
        (vm.locationRequestOld.countryId == null ||
          vm.locationRequestOld.provinceId == null ||
          vm.locationRequestOld.cityId == null)
      ) {
        vm.locationRequestNew.sectorObj.sectorId = -1;
      } else if (
        (vm.locationRequestOld.provinceTxt == null || vm.locationRequestOld.provinceTxt == "") &&
        vm.locationRequestOld.provinceId == null
      ) {
        vm.inputIsHideObject.province = true;
        vm.inputIsHideObject.city = true;
        vm.inputIsHideObject.sector = true;
      } else if (
        (vm.locationRequestOld.cityTxt == null || vm.locationRequestOld.cityTxt == "") &&
        vm.locationRequestOld.cityId == null
      ) {
        vm.inputIsHideObject.city = true;
        vm.inputIsHideObject.sector = true;
      } else if (
        (vm.locationRequestOld.sectorTxt == null || vm.locationRequestOld.sectorTxt == "") &&
        vm.locationRequestOld.sectorId == null
      ) {
        vm.inputIsHideObject.sector = true;
      }

      //Set input search object for directive
      if (vm.locationRequestOld.countryTxt != null && vm.locationRequestOld.countryTxt != "") {
        vm.requestLocationInputSearchObject.countrySearchKey = vm.locationRequestOld.countryTxt;
      }
      if (vm.locationRequestOld.provinceTxt != null && vm.locationRequestOld.provinceTxt != "") {
        vm.requestLocationInputSearchObject.provinceSearchKey = vm.locationRequestOld.provinceTxt;
      }
      if (vm.locationRequestOld.cityTxt != null && vm.locationRequestOld.cityTxt != "") {
        vm.requestLocationInputSearchObject.citySearchKey = vm.locationRequestOld.cityTxt;
      }
      if (vm.locationRequestOld.sectorTxt != null && vm.locationRequestOld.sectorTxt != "") {
        vm.requestLocationInputSearchObject.sectorSearchKey = vm.locationRequestOld.sectorTxt;
      }
    };

    vm.requestLocationInputSearchObject = {};
    vm.getRequestProfileById = function (locationId, ev) {
      // To set data in popup
      vm.locationProfile = {};
      vm.requestLocationInputSearchObject = {};
      vm.addNewLocationObject = {};

      vm.requestLocationInputSearchObject.country = "";
      vm.requestLocationInputSearchObject.province = "";
      vm.requestLocationInputSearchObject.city = "";
      vm.requestLocationInputSearchObject.sector = "";

      vm.entityPopupLoader = true;
      vm.isRequestMerged = false;
      vm.inputIsHideObject.country = false;
      vm.inputIsHideObject.province = false;
      vm.inputIsHideObject.city = false;
      vm.inputIsHideObject.sector = false;
      vm.relpaceinputfieldObject.country = false;
      vm.relpaceinputfieldObject.province = false;
      vm.relpaceinputfieldObject.city = false;
      vm.relpaceinputfieldObject.sector = false;
      vm.requestLocationInputSearchObject.isHideCountry = false;
      vm.requestLocationInputSearchObject.isHideProvince = false;
      vm.requestLocationInputSearchObject.isHideCity = false;
      vm.requestLocationInputSearchObject.isHideSector = false;
      vm.formCountryRequest = false;
      vm.formProvinceRequest = false;
      vm.formCityRequest = false;
      vm.addNewLocationObject.country = true;
      vm.addNewLocationObject.province = true;
      vm.addNewLocationObject.city = true;
      vm.addNewLocationObject.sector = true;
      var data = LibraryRequestService.getRequestProfileById(locationId);
      data.then(function (response) {
        vm.locationRequestOld = response;
        vm.locationProfile = response;
        vm.locationRequestNew = angular.copy(vm.locationRequestOld);

        //Set location objects
        vm.locationRequestNew.countryObj = LibraryService.getCountryObj(vm.locationRequestOld);
        vm.locationRequestNew.provinceObj = LibraryService.getProvinceObj(vm.locationRequestOld);
        vm.locationRequestNew.cityObj = LibraryService.getCityObj(vm.locationRequestOld);
        vm.locationRequestNew.sectorObj = LibraryService.getSectorObj(vm.locationRequestOld);

        //Set LocationType
        if (vm.locationRequestOld.requestTypeName != null) {
          vm.locationTypeName = vm.locationRequestOld.requestTypeName;
        } else if (vm.locationRequestOld.requestTypeName == null) {
          vm.locationTypeName = vm.APP.LIBRARY.FORM_LOCATION_REQUEST;
        }

        //Get merged location obj
        if (vm.locationRequestNew.isMerged) {
          vm.isRequestMerged = true;
          var mergedData = LibraryRequestService.getRequestProfileById(vm.locationRequestNew.mergedLocationMappingId);
          mergedData.then(function (response) {
            vm.locationRequestNew = response;
          });
        }
        //For Showing new request in md-select drop down
        else {
          if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.COUNTRY) {
            vm.inputIsHideObject.province = true;
            vm.inputIsHideObject.city = true;
            vm.inputIsHideObject.sector = true;
            vm.locationRequestNew.countryObj.countryId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE) {
            vm.inputIsHideObject.city = true;
            vm.inputIsHideObject.sector = true;
            vm.addNewLocationObject.country = false;
            vm.locationRequestNew.provinceObj.provinceId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY) {
            vm.inputIsHideObject.sector = true;
            vm.addNewLocationObject.country = false;
            vm.addNewLocationObject.province = false;
            vm.locationRequestNew.cityObj.cityId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR) {
            vm.addNewLocationObject.country = false;
            vm.addNewLocationObject.province = false;
            vm.addNewLocationObject.city = false;
            vm.locationRequestNew.sectorObj.sectorId = -1;
          }

          //Set the form request values
          if (vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST) {
            vm.setFormLocationValues();
          }
        }
        vm.getRequestPopupId(ev, vm.APP.LIBRARY.LOCATION_REQUEST);
        vm.entityPopupLoader = false;
      });
    };
    //To open location popup in investigation listing page
    vm.getLocationPopup = function (ev, entityRequestNew, requestEntityForm) {
      vm.getRequestProfileById(entityRequestNew.locationMappingId, ev);
    };

    //Show the validation message for form location request
    vm.validation = function () {
      if (vm.approveObj.countryTxt == null || vm.approveObj.countryTxt == "" || vm.approveObj.countryTxt == undefined) {
        vm.requestLocationInputSearchObject.countrySearchKey = "";
        vm.validationFlag = true;
      }
      if (
        vm.approveObj.provinceTxt == null ||
        vm.approveObj.provinceTxt == "" ||
        vm.approveObj.provinceTxt == undefined
      ) {
        vm.requestLocationInputSearchObject.provinceSearchKey = "";
        vm.validationFlag = true;
      }
      if (vm.approveObj.cityTxt == null || vm.approveObj.cityTxt == "" || vm.approveObj.cityTxt == undefined) {
        vm.requestLocationInputSearchObject.citySearchKey = "";
        vm.validationFlag = true;
      }
      if (vm.locationRequestOld.sectorTxt != null && vm.locationRequestOld.sectorTxt != "") {
        if (vm.approveObj.sectorTxt == null || vm.approveObj.sectorTxt == "" || vm.approveObj.sectorTxt == undefined) {
          vm.validationFlag = true;
          vm.sectorValidationFlag = true; //Show sector validation message
        }
      }
      $timeout(function () {
        vm.validationFlag = false;
        vm.sectorValidationFlag = false;
      }, 5000);
    };

    //To check the location object while approve location popup
    vm.approveAlterFormLocationRequest = function (locationRequestNew, inputSearchObject, ev) {
      vm.approveObj = {};
      vm.sectorValidationFlag = false;
      vm.validationFlag = false;
      vm.isLocationApproveDisable = true;
      if (locationRequestNew) {
        vm.approveObj.id = locationRequestNew.id;

        if (
          (vm.locationRequestOld.countryId == null || inputSearchObject.countryAltered) &&
          inputSearchObject.countrySearchKey != null &&
          inputSearchObject.countrySearchKey != ""
        ) {
          vm.approveObj.countryTxt = inputSearchObject.countrySearchKey;
        } else if (
          locationRequestNew.countryObj != undefined &&
          locationRequestNew.countryObj.countryId != -1 &&
          locationRequestNew.countryObj.countryId != null
        ) {
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
        }

        if (
          (vm.locationRequestOld.provinceId == null || inputSearchObject.provinceAltered) &&
          vm.locationRequestOld.provinceTxt != null &&
          vm.locationRequestOld.provinceTxt != "" &&
          inputSearchObject.provinceSearchKey != null &&
          inputSearchObject.provinceSearchKey != ""
        ) {
          vm.approveObj.provinceTxt = inputSearchObject.provinceSearchKey;
        } else if (
          vm.locationRequestOld.provinceTxt != null &&
          vm.locationRequestOld.provinceTxt != "" &&
          locationRequestNew.provinceObj != undefined
        ) {
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
        }

        if (
          (vm.locationRequestOld.cityId == null || inputSearchObject.cityAltered) &&
          vm.locationRequestOld.cityTxt != null &&
          vm.locationRequestOld.cityTxt != "" &&
          inputSearchObject.citySearchKey != null &&
          inputSearchObject.citySearchKey != ""
        ) {
          vm.approveObj.cityTxt = inputSearchObject.citySearchKey;
        } else if (
          vm.locationRequestOld.cityTxt != null &&
          vm.locationRequestOld.cityTxt != "" &&
          locationRequestNew.cityObj != undefined
        ) {
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
        }

        if (
          locationRequestNew.cityObj != undefined &&
          locationRequestNew.cityObj.cityId != -1 &&
          locationRequestNew.cityObj.cityId != null
        ) {
          //Set merged Location mapping Id Value for City
          if (
            (vm.formCountryRequest || vm.formProvinceRequest || vm.formCityRequest) &&
            locationRequestNew.sectorObj.sectorId != -1 &&
            angular.isUndefinedOrNull(locationRequestNew.sectorObj.sectorId)
          ) {
            vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.cityObj.locationMappingId;
          }
        }

        if (
          vm.locationRequestOld.sectorTxt != null &&
          vm.locationRequestOld.sectorTxt != "" &&
          locationRequestNew.sectorObj != undefined &&
          locationRequestNew.sectorObj.sectorId != -1 &&
          locationRequestNew.sectorObj.sectorId != null
        ) {
          vm.approveObj.sectorId = locationRequestNew.sectorObj.sectorId;
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.sectorObj.locationMappingId; //Set merged Location mapping Id Value for City
        } else if (
          (vm.locationRequestOld.sectorTxt != null && locationRequestNew.sectorObj.sectorId == -1) ||
          locationRequestNew.sectorObj.sectorId == undefined
        ) {
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          if (
            inputSearchObject.sectorSearchKey != null &&
            (inputSearchObject.sectorSearchKey != "" || inputSearchObject.sectorAltered)
          ) {
            vm.approveObj.sectorTxt = inputSearchObject.sectorSearchKey;
          }
        }
        //Check the location object for validation
        vm.validation();
        if (vm.mergeFlag) {
          vm.approveObj.isMerge = true;
        } else {
          vm.approveObj.isMerge = false;
        }
        if (!vm.validationFlag) {
          var data = LibraryRequestService.saveApprovedRequestLists(vm.approveObj);
          data.then(
            function (response) {
              vm.msgFlag = false;
              vm.mergeFlag = false;
              $mdDialog.hide();
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_REQUEST });
              vm.isLocationApproveDisable = false;
              if (vm.entityPopupId && vm.popUpId == vm.APP.LIBRARY.ENTITY_REQ) {
                $timeout(function () {
                  vm.msgFlagForLocation = false;
                  vm.popUpId = "";
                  $rootScope.getEntityProfileById(vm.entityPopupId, false, ev);
                }, 1000);
              }
            },
            function (reason) {
              if (reason.data.statusCode == 409) {
                vm.msgFlag = true;
                vm.mergeFlag = true;
              } else {
                notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_PROBLEM });
              }
              vm.isLocationApproveDisable = false;
              return reason;
            }
          );
        } else {
          vm.isLocationApproveDisable = false;
        }
      } else {
        vm.isLocationApproveDisable = false;
      }
    };
    //To open entity or location popup
    vm.showRequestDialog = function ($event, id) {
      //vm.request = request;
      vm.isDisable = false;
      vm.isHide = true;
      vm.isNewEntityName = true;
      $mdDialog.show({
        targetEvent: $event,
        contentElement: "#" + id,
        parent: angular.element(document.body)
      });
    };

    vm.approvAlterLocationRequest = function (locationRequestNew, requestLocationForm, ev) {
      vm.approveObj = {};
      vm.approveObj.countryObj = {};
      vm.approveObj.provinceObj = {};
      vm.approveObj.cityObj = {};
      vm.approveObj.sectorObj = {};
      vm.sectorValidationFlag = false;
      vm.isLocationApproveDisable = true;
      if (locationRequestNew && requestLocationForm.$valid) {
        vm.approveObj.id = vm.locationRequestNew.id;
        vm.approveObj.requestTypeId = locationRequestNew.requestTypeId;
        vm.approveObj.requestTypeName = locationRequestNew.requestTypeName;
        if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.COUNTRY) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          if (locationRequestNew.countryObj && locationRequestNew.countryObj.locationMappingId != null) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.countryObj.locationMappingId;
          } else if (locationRequestNew.countryObj.countryId == -1) {
            vm.approveObj.countryId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          if (
            locationRequestNew.provinceObj &&
            locationRequestNew.countryObj &&
            locationRequestNew.provinceObj.locationMappingId != null
          ) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.provinceObj.locationMappingId;
          } else if (vm.locationRequestNew.provinceObj.provinceId == -1) {
            vm.approveObj.provinceId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          if (
            locationRequestNew.countryObj &&
            locationRequestNew.cityObj.locationMappingId != null &&
            locationRequestNew.cityObj
          ) {
            vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.cityObj.locationMappingId;
          } else if (locationRequestNew.cityObj.cityId == -1) {
            vm.approveObj.cityId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          vm.approveObj.sectorId = locationRequestNew.sectorObj.sectorId;
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          if (
            locationRequestNew.countryObj &&
            locationRequestNew.sectorObj.locationMappingId != null &&
            locationRequestNew.cityObj &&
            locationRequestNew.sectorObj
          ) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.sectorObj.locationMappingId;
          } else if (locationRequestNew.sectorObj.sectorId == -1) {
            vm.approveObj.sectorId = null;
          }
          if (vm.approveObj.sectorTxt == null || vm.approveObj.sectorTxt == "") {
            vm.sectorValidationFlag = true; //Show sector validation message
            $timeout(function () {
              vm.sectorValidationFlag = false;
            }, 5000);
          }
        }

        if (vm.mergeFlag) {
          vm.approveObj.isMerge = true;
        } else {
          vm.approveObj.isMerge = false;
        }
        if (!vm.sectorValidationFlag) {
          var data = LibraryRequestService.saveApprovedRequestLists(vm.approveObj);
          data.then(
            function (response) {
              vm.msgFlag = false;
              vm.mergeFlag = false;
              $mdDialog.hide();
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_REQUEST });
              vm.isLocationApproveDisable = false;
              if (vm.entityPopupId && vm.popUpId == vm.APP.LIBRARY.ENTITY_REQ) {
                $timeout(function () {
                  vm.msgFlagForLocation = false;
                  vm.popUpId = "";
                  $rootScope.getEntityProfileById(vm.entityPopupId, false, ev);
                }, 1000);
              }
            },
            function (reason) {
              if (reason.data.statusCode == 409) {
                vm.msgFlag = true;
                vm.mergeFlag = true;
              } else {
                notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_PROBLEM });
              }
              vm.isLocationApproveDisable = false;
              return reason;
            }
          );
        }
      } else {
        vm.isLocationApproveDisable = false;
      }
    };

    vm.validateLocationIds = function (locationValidation) {
      if (
        locationValidation &&
        locationValidation.countryId &&
        locationValidation.provinceId &&
        locationValidation.cityId
      ) {
        vm.locationIdValidation = true;
      }
    };

    // Added the show for DNA new filters
    vm.dnaFiltersShow = function (show) {
      if (show == "dna") {
        if ($scope.dnaIcon) {
          $scope.dnaIcon = false;
        } else {
          $scope.dnaIcon = true;
        }
      } else if (show) {
        $scope.dnaIcon = false;
      } else {
        $scope.dnaIcon = true;
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").service("InvestigationService", InvestigationService);

  InvestigationService.$inject = ["$resource", "restService", "$q", "$rootScope"];

  function InvestigationService($resource, restService, $q, $rootScope) {
    this.loadFilterList = function (filterObj) {
      var deferred = $q.defer();
      var url = "investigations/status/count";
      var data = restService.restCall(filterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getInvestigationLists = function (filterObj) {
      var deferred = $q.defer();
      var url = "allInvestigations";
      var data = restService.restCall(filterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getHeaderCount = function (filterObj) {
      //Clearing search key
      filterObj.searchKey = undefined;

      var deferred = $q.defer();
      var url = "investigations/headerCount";
      var data = restService.restCall(filterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getCompletedInvestigatorNames = function (investigationId) {
      var deferred = $q.defer();
      var url = "completed-investigator-names/" + investigationId;
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getReopenFlag = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigation/reOpenStatus/" + investigationId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
    this.getEntityIcon = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigation/showEntityIcon/" + investigationId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
    //to get entity items to show in entity review popup
    this.getEntityReviewItemsList = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigation/getEntityReviewItems/" + investigationId;
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','APP','$mdAriaProvider','$mdDateLocaleProvider'];

    function stateConfig($stateProvider,APP,$mdAriaProvider,$mdDateLocaleProvider) {
    		
    	    $mdAriaProvider.disableWarnings();
    	    
    	  //Date Format Provider
    		$mdDateLocaleProvider.formatDate = function(date) {
    		    return date ? moment(date).format('MMM D, Y') : '';
    		  };
    		  
    		  $mdDateLocaleProvider.parseDate = function(dateString) {
    			  if(/^[0-9-]*$/.test(dateString) == true){
    					  var m = moment(dateString, 'D-M-YYYY', true);
    					  return m.isValid() ? m.toDate() : new Date(NaN);
    			  }else if(/^[0-9/]*$/.test(dateString) == true){
    					  var m = moment(dateString, 'D/M/YYYY', true);
    					  return m.isValid() ? m.toDate() : new Date(NaN);
    			  } 
  				  	  var m = moment(dateString, 'MMM D, Y', true);
	  				  if(m.isValid()){
	  					  return m.toDate();
	  				  }else{
	  					  var m = moment(dateString, 'MMMM D, Y', true);
	  					  return m.isValid() ? m.toDate() : new Date(NaN);
	  				  }
    		  };
    		      	
        	$stateProvider.state('investigations', {
            parent: 'app',
            url: '/investigations',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            views: {
                'dynamicView': {
                    templateUrl: 'app/investigation/investigation.html',
                    controller: 'InvestigationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                    	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                    	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                'redirect' : ['Principal', '$state', '$timeout', function(Principal, $state, $timeout){
       	    		$timeout(function(){
       		    		//if ($cookies.getObject('sessionDetails') && $cookies.getObject('sessionDetails').firstName != null && $cookies.getObject('sessionDetails').firstName != ''){
       	    			if(Principal.isAuthenticated()) {
       		    			//$state.go('investigations');
       		    			return true;
       		    		} else {
       		    			$state.go('login');
       		    			return false;
       		    		}
       	    		}, 700)
       	    	 }]
            }
        });
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("LibraryController", LibraryController);

  LibraryController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$mdSidenav",
    "$element",
    "APP",
    "tabservice",
    "$mdMedia",
    "$sessionStorage",
    "$cookies",
    "LibraryService",
    "$mdDialog",
    "CommonService",
    "LibraryEntityService",
    "$q",
    "communicationService",
    "LibraryLocationService",
    "$timeout",
    "StorageDelete",
    "notifications",
    "$rootScope"
  ];

  function LibraryController(
    $scope,
    $state,
    $stateParams,
    $mdSidenav,
    $element,
    APP,
    tabservice,
    $mdMedia,
    $sessionStorage,
    $cookies,
    LibraryService,
    $mdDialog,
    CommonService,
    LibraryEntityService,
    $q,
    communicationService,
    LibraryLocationService,
    $timeout,
    StorageDelete,
    notifications,
    $rootScope
  ) {
    var vm = this;
    vm.APP = APP;
    vm.endless = vm.APP.GLOBAL.ENDLESS;
    vm.library = $stateParams;
    vm.media = $mdMedia;
    vm.requestFlag = false;
    vm.location = {};
    vm.isHide = false;

    vm.entityLocationObject = {};
    vm.entityLocationObject.countryObj = {};
    vm.entityLocationObject.provinceObj = {};
    vm.entityLocationObject.cityObj = {};
    vm.entityLocationObject.sectorObj = {};

    vm.isHorizon = true;
    //Get user from cookie storage
    vm.user = CommonService.getCookieUser();
    vm.loggedUserRole = vm.user.loggedUserRole;
    vm.library.libraryType = $state.current.name;

    $scope.isHorizon = false;
    vm.saveOrAddLocationObject = {};
    vm.saveOrAddLocationObject.countryObj = {};
    vm.saveOrAddLocationObject.provinceObj = {};
    vm.saveOrAddLocationObject.cityObj = {};
    vm.saveOrAddLocationObject.sectorObj = {};
    $scope.isAddOrSaveLocation = false;
    communicationService.setData("isAddOrSaveLocation", $scope.isAddOrSaveLocation);

    vm.addLocationObject = {};
    vm.addLocationObject.countryObj = {};
    vm.addLocationObject.provinceObj = {};
    vm.addLocationObject.cityObj = {};
    vm.addLocationObject.sectorObj = {};

    vm.addLocationInputSearchObject = {};
    vm.updateEntityLocation = true;

    $scope.addLocationInputObject = {};
    $scope.addLocationInputObject.country = false;
    $scope.addLocationInputObject.province = false;
    $scope.addLocationInputObject.city = false;
    $scope.addLocationInputObject.sector = false;

    $scope.libraryAddEntityInputSearchObject = {};
    $scope.libraryAddEntityInputSearchObject.country = "";
    $scope.libraryAddEntityInputSearchObject.province = "";
    $scope.libraryAddEntityInputSearchObject.city = "";
    $scope.libraryAddEntityInputSearchObject.countrySearchKey = "";
    $scope.libraryAddEntityInputSearchObject.provinceSearchKey = "";
    $scope.libraryAddEntityInputSearchObject.citySearchKey = "";
    $scope.libraryAddEntityInputSearchObject.sectorSearchKey = "";
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCity = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationSector = false;
    $scope.commentSize = {};
    $scope.commentSize.valid = false;
    $scope.disableSaveButton = false;

    vm.checkLibraryIndex = function () {
      vm.libraryTabIndex = tabservice.getIndex();
    };

    vm.checkLibraryIndex();

    vm.country = "";

    vm.toggleLeft = buildToggler("left");
    vm.toggleRight = buildToggler("right");

    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });

    function buildToggler(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }

    vm.sideNavClose = function (id) {
      $mdSidenav(id).close();
    };

    vm.stateRequestDetails = function () {
      vm.library.libraryType = vm.APP.LIBRARY.REQUEST;
      $state.go("request", vm.library);
    };

    vm.stateEntityDetails = function () {
      vm.library.libraryType = vm.APP.LIBRARY.ENTITY;
      $state.go("entities", vm.library);
    };

    vm.stateLocationDetails = function () {
      vm.library.libraryType = vm.APP.LIBRARY.LOCATION;
      $state.go("locations", vm.library);
    };

    vm.cancel = function (formName) {
      $mdDialog.hide();
    };

    vm.getEntityTypeList = function () {
      var entityTypeData = CommonService.getRefTermList(vm.APP.REF_TERM.ENTITY_PROFILE);
      entityTypeData.then(function (response) {
        vm.entityTypeList = response;
      });
    };

    vm.libraryInit = function () {
      vm.sideNavClose("left");
      vm.getEntityTypeList();
      //StorageDelete.deleteInvestigation(); ---------Commenting this line so that the Analyst form can be opened properly on browser back from the Library Section.
      StorageDelete.deleteUser();
    };

    vm.libraryInit();

    //ADD NEW ENTITY POPUP
    $scope.openNewEntity = function (ev, id, flag) {
      vm.entity = {}; //Clear Form fields
      vm.entityLocationObject = {};
      vm.entityLocationObject.countryObj = {};
      vm.entityLocationObject.provinceObj = {};
      vm.entityLocationObject.cityObj = {};
      vm.entityLocationObject.sectorObj = {};
      $scope.addNewEntityForm = {};
      vm.editFlag = false;
      vm.isHide = false;
      vm.updateFlag = false;
      vm.existFlag = false;
      vm.isEntityDisable = false;

      vm.flag = flag;
      // Flag 0: New Entity Request, Flag 1: New Entity, Flag 2: Update Entity
      if (vm.flag == 2) {
        vm.editFlag = true;
      }

      $mdDialog.show({
        targetEvent: ev,
        contentElement: "#" + id,
        parent: angular.element(document.body)
      });
    };

    vm.cancel = function (addNewEntityForm) {
      addNewEntityForm.$setPristine();
      vm.entity = {}; //Clear Form fields
      vm.entity.contactEmail = "";
      vm.entity.contactPerson = "";
      $scope.addNewEntityForm = {};
      $mdDialog.hide();
      $rootScope.$emit("cancelFormData");
    };

    vm.addNewEntity = function (entity, addNewEntityForm, libraryAddEntityInputSearchObject, entityLocationObject, flag) {
      vm.isEntityDisable = true;
      if (addNewEntityForm.$valid && entity) {
        vm.entityObj = {};
        vm.entityObj.comments = entity.comments;
        vm.entityObj.contactEmail = entity.contactEmail;
        vm.entityObj.contactPersonName = entity.contactPersonName;
        vm.entityObj.contactPhoneNumber = entity.contactPhoneNumber;
        vm.entityObj.entityTypeId = entity.entityTypeSearchKey.id;
        if (entity.flag == undefined || entity.flag == "") {
          entity.flag = false;
        }
        vm.entityObj.flag = entity.flag;
        vm.entityObj.name = entity.entityName;
        if (libraryAddEntityInputSearchObject.countrySearchKey == "" && libraryAddEntityInputSearchObject.provinceSearchKey == "" && libraryAddEntityInputSearchObject.sectorSearchKey == "" && libraryAddEntityInputSearchObject.citySearchKey == "") {
          libraryAddEntityInputSearchObject.isAddOrSaveLocationSector = false;
        } else if (libraryAddEntityInputSearchObject.countrySearchKey != undefined || libraryAddEntityInputSearchObject.provinceSearchKey != undefined || libraryAddEntityInputSearchObject.sectorSearchKey != undefined || libraryAddEntityInputSearchObject.citySearchKey != undefined) {
          libraryAddEntityInputSearchObject.isAddOrSaveLocationSector = true;
        }
        if ((libraryAddEntityInputSearchObject.isAddOrSaveLocationCity == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationSector == true)) {
          vm.locationObj = {};
          vm.locationObj.countryId = entityLocationObject.countryObj.countryId;
          vm.locationObj.countryTxt = libraryAddEntityInputSearchObject.countrySearchKey;
          vm.locationObj.provinceId = entityLocationObject.provinceObj.provinceId;
          vm.locationObj.provinceTxt = libraryAddEntityInputSearchObject.provinceSearchKey;
          vm.locationObj.cityId = entityLocationObject.cityObj.cityId;
          vm.locationObj.cityTxt = libraryAddEntityInputSearchObject.citySearchKey;
          vm.locationObj.sectorId = null;
          if (libraryAddEntityInputSearchObject.sectorSearchKey != null) {
            vm.locationObj.sectorTxt = libraryAddEntityInputSearchObject.sectorSearchKey;
          } else {
            vm.locationObj.sectorTxt = null;
          }
          $scope.validateUpdateEntityLocation();
          if (vm.updateEntityLocation) {
            $scope.disableSaveButton = true;
            var data = LibraryService.saveNewLocation(vm.locationObj);
            data.then(function (response) {
              $scope.disableSaveButton = false;
              vm.entityObj.locationMappingId = response.id;
              if (flag == 1) {
                var data = LibraryService.addNewEntity(vm.entityObj);
              } else if (flag == 2) {
                vm.entityObj.id = entity.id;
                var data = LibraryService.updateEntity(vm.entityObj);
              }

              data.then(function (response) {
                if (flag == 2) {
                  notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_UPDATE });
                } else {
                  notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_ADD });
                }
                $state.transitionTo($state.current, $stateParams, {
                  reload: true,
                  inherit: false,
                  notify: true
                });
                vm.isEntityDisable = false;
              }, function (reason) {
                $scope.disableSaveButton = false;

                if (reason.status == 409) {
                  vm.existFlag = true;
                } else if (reason.status == 400 && reason.data.fieldErrors[0].message == "Size" && reason.data.fieldErrors[0].field == "comments") {
                  $scope.commentSize.valid = true;
                } else if (flag == 2) {
                  notifications.showError({ message: vm.APP.LIBRARY.ENTITY_UPDATE_PROBLEM });
                } else {
                  notifications.showError({ message: vm.APP.LIBRARY.ENTITY_ADD_PROBLEM });
                }
                vm.isEntityDisable = false;
              });
            });
          }
          else {
            vm.isEntityDisable = false;
          }
        }

        else {
          vm.isEntityDisable = false;
          vm.entityObj.locationMappingId = vm.entityLocationObject.cityObj.locationMappingId;
          if (!angular.isUndefinedOrNull(vm.entityObj.locationMappingId)) {
            vm.isEntityDisable = true;
            if (flag == 1) {
              var data = LibraryService.addNewEntity(vm.entityObj);
            } else if (flag == 2) {
              vm.entityObj.id = entity.id;
              var data = LibraryService.updateEntity(vm.entityObj);
            }

            data.then(function (response) {
              if (flag == 2) {
                notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_UPDATE });
              } else {
                notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_ADD });
              }
              $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
              });
              vm.isEntityDisable = false;
            }, function (reason) {

              if (reason.status == 409) {
                vm.existFlag = true;
              } else if (reason.status == 400 && reason.data.fieldErrors[0].message == "Size" && reason.data.fieldErrors[0].field == "comments") {
                $scope.commentSize.valid = true;
              } else if (flag == 2) {
                notifications.showError({ message: vm.APP.LIBRARY.ENTITY_UPDATE_PROBLEM });
              } else {
                notifications.showError({ message: vm.APP.LIBRARY.ENTITY_ADD_PROBLEM });
              }
              vm.isEntityDisable = false;
            });
          }
        }
        //vm.cancel(addNewEntityForm);
        $timeout(function () {
          vm.existFlag = false;
        }, 3000);
      } else {
        vm.isEntityDisable = false;
      }
    };
    function fieldValidation(entityLocationObject, addNewEntityForm, libraryAddEntityInputSearchObject) {
      var isValid = true;
      if ((entityLocationObject.countryObj
        && !entityLocationObject.countryObj.countryId) && (!libraryAddEntityInputSearchObject.countrySearchKey)) {
        addNewEntityForm.country.$error = true;
        isValid = false;
      }
      if ((entityLocationObject.provinceObj
        && !entityLocationObject.provinceObj.provinceId) && (!libraryAddEntityInputSearchObject.provinceSearchKey)) {
        addNewEntityForm.province.$error = true;
        isValid = false;
      }
      if ((entityLocationObject.cityObj
        && !entityLocationObject.cityObj.cityId) && (!libraryAddEntityInputSearchObject.citySearchKey)) {
        addNewEntityForm.city.$error = true;
        isValid = false;
      }
      return isValid;
    }
    //ADD ENTITY REQUEST
    vm.saveNewEntity = function (entity, addNewEntityForm, libraryAddEntityInputSearchObject, entityLocationObject) {
      if (addNewEntityForm.$valid && entity && fieldValidation(entityLocationObject, addNewEntityForm, libraryAddEntityInputSearchObject)) {
        vm.entityObj = {};
        vm.entityObj.comments = entity.comments;
        vm.entityObj.contactEmail = entity.contactEmail;
        vm.entityObj.contactPersonName = entity.contactPersonName;
        vm.entityObj.contactPhoneNumber = entity.contactPhoneNumber;
        vm.entityObj.entityTypeId = entity.entityTypeSearchKey.id;
        if (entity.flag == undefined || entity.flag == "") {
          entity.flag = false;
        }
        vm.entityObj.flag = entity.flag;
        vm.entityObj.name = vm.entity.entityName;

        if (libraryAddEntityInputSearchObject.isAddOrSaveLocationCity == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince == true || libraryAddEntityInputSearchObject.isAddOrSaveLocationSector == true) {
          vm.locationObj = {};
          vm.locationObj.countryId = entityLocationObject.countryObj.countryId;
          vm.locationObj.countryTxt = libraryAddEntityInputSearchObject.countrySearchKey;
          vm.locationObj.provinceId = entityLocationObject.provinceObj.provinceId;
          vm.locationObj.provinceTxt = libraryAddEntityInputSearchObject.provinceSearchKey;
          vm.locationObj.cityId = entityLocationObject.cityObj.cityId;
          vm.locationObj.cityTxt = libraryAddEntityInputSearchObject.citySearchKey;
          vm.locationObj.sectorId = null;
          vm.locationObj.sectorTxt = libraryAddEntityInputSearchObject.sectorSearchKey;
          $scope.disableSaveButton = true;
          var data = LibraryService.saveNewLocation(vm.locationObj);
          data.then(function (response) {
            $scope.disableSaveButton = false;
            vm.entityObj.locationMappingId = response.id;
            var data = LibraryService.saveNewEntity(vm.entityObj);
            data.then(function (response) {
              if (response.entityExists) {
                notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST_EXISTS });
              }
              else {
                notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST_SEND });
              }
              $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
              });
            }, function (reason) {
              $scope.disableSaveButton = false;
              notifications.showError({ message: vm.APP.LIBRARY.ENTITY_REQUEST_SEND_PROBLEM });
            });
            vm.cancel(addNewEntityForm);
          });
        }
        else {
          vm.entityObj.locationMappingId = angular.isUndefinedOrNull(vm.entityLocationObject.cityObj.locationMappingId) ? vm.entityLocationObject.cityObj.id : vm.entityLocationObject.cityObj.locationMappingId;
          var data = LibraryService.saveNewEntity(vm.entityObj);
          data.then(function (response) {
            if (response.entityExists) {
              notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST_EXISTS });
            }
            else {
              notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST_SEND });
            }
            $state.transitionTo($state.current, $stateParams, {
              reload: true,
              inherit: false,
              notify: true
            });
          }, function (reason) {
            notifications.showError({ message: vm.APP.LIBRARY.ENTITY_REQUEST_SEND_PROBLEM });
          });
          vm.cancel(addNewEntityForm);
        }
      }
    };

    vm.locRegTypeValid = false;
    //ADD LOCATION REQUEST
    vm.saveLocation = function (entity, addNewLocationRequestForm) {
      if (vm.locationRequestType) {
        vm.locRegTypeValid = false;
        if (addNewLocationRequestForm.$valid && entity) {
          vm.locationObj = {};
          if (vm.locationRequestType.name == vm.APP.LIBRARY.COUNTRY) {
            vm.locationObj.countryId = null;
            vm.locationObj.countryTxt = vm.location.country;
            vm.locationObj.requestTypeId = vm.locationRequestType.id;
          } else if (vm.locationRequestType.name == vm.APP.LIBRARY.PROVINCE) {
            if (vm.addLocationObject.countryObj != undefined) {
              vm.locationObj.countryId = vm.addLocationObject.countryObj.countryId;
              vm.locationObj.countryTxt = vm.addLocationObject.countryObj.countryTxt;
            } else {
              vm.locationObj.countryId = null;
              vm.locationObj.countryTxt = vm.location.country;
            }
            vm.locationObj.provinceId = null;
            vm.locationObj.provinceTxt = vm.location.province;
            vm.locationObj.requestTypeId = vm.locationRequestType.id;
          } else if (vm.locationRequestType.name == vm.APP.LIBRARY.CITY) {
            if (vm.addLocationObject.countryObj != undefined) {
              vm.locationObj.countryId = vm.addLocationObject.countryObj.countryId;
              vm.locationObj.countryTxt = vm.addLocationObject.countryObj.countryTxt;
            }
            else {
              vm.locationObj.countryId = null;
              vm.locationObj.countryTxt = vm.location.country;
            }
            if (vm.addLocationObject.provinceObj != undefined) {
              vm.locationObj.provinceId = vm.addLocationObject.provinceObj.provinceId;
              vm.locationObj.provinceTxt = vm.addLocationObject.provinceObj.provinceTxt;
            }
            else {
              vm.locationObj.provinceId = null;
              vm.locationObj.provinceTxt = vm.location.province;
            }
            vm.locationObj.cityId = null;
            vm.locationObj.cityTxt = vm.location.city;
            vm.locationObj.requestTypeId = vm.locationRequestType.id;
          } else {
            if (vm.addLocationObject.countryObj != undefined) {
              vm.locationObj.countryId = vm.addLocationObject.countryObj.countryId;
              vm.locationObj.countryTxt = vm.addLocationObject.countryObj.countryTxt;
            }
            else {
              vm.locationObj.countryId = null;
              vm.locationObj.countryTxt = vm.location.country;
            }
            if (vm.addLocationObject.provinceObj != undefined) {
              vm.locationObj.provinceId = vm.addLocationObject.provinceObj.provinceId;
              vm.locationObj.provinceTxt = vm.addLocationObject.provinceObj.provinceTxt;
            }
            else {
              vm.locationObj.provinceId = null;
              vm.locationObj.provinceTxt = vm.location.province;
            }
            if (vm.addLocationObject.cityObj != undefined) {
              vm.locationObj.cityId = vm.addLocationObject.cityObj.cityId;
              vm.locationObj.cityTxt = vm.addLocationObject.cityObj.cityTxt;
            } else {
              vm.locationObj.cityId = null;
              vm.locationObj.cityTxt = vm.location.city;
            }
            vm.locationObj.sectorId = null;
            vm.locationObj.sectorTxt = vm.location.sector;
            vm.locationObj.requestTypeId = vm.locationRequestType.id;
          }
          $scope.disableSaveButton = true;
          var data = LibraryService.saveNewLocation(vm.locationObj);
          data.then(function (response) {
            $scope.disableSaveButton = false;
            vm.stateRequestDetails();
            $state.transitionTo($state.current, $stateParams, {
              reload: true,
              inherit: false,
              notify: true
            });
            if (response.isAlreadyExists != null) {
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_EXISTS });
            }
            else {
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_REQUEST_SEND });
            }
          }, function (reason) {
            $scope.disableSaveButton = false;
            notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_SEND_PROBLEM });
          });

          $mdDialog.hide();
          //vm.cancelLocation(addlocationRequestForm, 0);
        }
      } else {
        vm.locRegTypeValid = true;
      }
    };
    /*vm.clearLocation = function(){
   vm.entity = {};
   vm.saveOrAddLocationObject = {};
      vm.saveOrAddLocationObject.countryObj = {};
     vm.saveOrAddLocationObject.provinceObj = {};
     vm.saveOrAddLocationObject.cityObj = {};
     vm.saveOrAddLocationObject.sectorObj = {};
   vm.entity.entityTypeSearchKey = copyEntityType;
   vm.isHide =	false;
 };*/

    //ADD LOCATION REQUEST POPUP
    vm.openLocationRequest = function (ev, id, flag) {
      vm.locationVO = {};
      vm.addLocationObject = {};
      vm.isReplaceCountry = false;
      vm.isReplaceProvince = false;
      vm.isReplaceCity = false;
      vm.isReplaceSector = false;
      vm.requestFlagSectorInput = false;
      vm.requestFlagCityInput = false;
      vm.requestFlagProvinceInput = false;
      vm.requestFlagCountryInput = false;
      vm.locRegTypeValid = false;
      vm.existFlag = false;
      vm.validationMSGFlagProvinceCity = false;
      vm.validationMSGFlagProvince = false;
      vm.validationMSGFlagCity = false;
      vm.isAddLocationDisable = false;

      var locationRefset = CommonService.getRefTermList(vm.APP.LIBRARY.LOCATION_CONST);
      locationRefset.then(function (response) {
        vm.locationVO = response;
      });
      vm.flag = flag;
      if (flag == 1) {
        $scope.isAddOrSaveLocation = true;
        communicationService.setData('isAddOrSaveLocation', $scope.isAddOrSaveLocation);
      }
      $scope.isValidEnable = false;
      vm.addLocationInputSearchObject = {};
      vm.saveOrAddLocationObject = {};
      vm.saveOrAddLocationObject.countryObj = {};
      vm.saveOrAddLocationObject.provinceObj = {};
      vm.saveOrAddLocationObject.cityObj = {};
      vm.saveOrAddLocationObject.sectorObj = {};
      $scope.isHorizon = true;
      $mdDialog.show({
        targetEvent: ev,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    };

    $scope.isValidEnable = false;
    vm.addLocationInputSearchObject.isInputEmptyCountry = false;
    vm.addLocationInputSearchObject.isInputEmptyProvince = false;
    vm.addLocationInputSearchObject.isInputEmptyCity = false;
    vm.addLocationInputSearchObject.isInputEmptySector = false;

    $scope.checkMandatoryFields = function (type) {
      if ($scope.isAddOrSaveLocation) {
        if (type == vm.APP.LIBRARY.COUNTRY_CAPS) {
          if (vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '') {
            if ((vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '')
              || (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '')
              || (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            } else {
              $scope.isValidEnable = false;
            }
          } else if (vm.addLocationInputSearchObject.countrySearchKey != null && vm.addLocationInputSearchObject.countrySearchKey != '') {
            $scope.isValidEnable = true;
          } else {
            $scope.isValidEnable = false;
          }
        } else if (type == vm.APP.LIBRARY.PROVINCE_CAPS) {
          if (vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '') {
            if (vm.saveOrAddLocationObject.provinceObj && vm.saveOrAddLocationObject.provinceObj.provinceId != null && vm.saveOrAddLocationObject.provinceObj.provinceId != '') {
              if ((vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '')
                || (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
                $scope.isValidEnable = true;
              } else {
                $scope.isValidEnable = false;
              }
            } else {
              if (vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
          } else if (vm.addLocationInputSearchObject.countrySearchKey != null && vm.addLocationInputSearchObject.countrySearchKey != '') {
            if (vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '') {
              $scope.isValidEnable = true;
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
          } else {
            vm.addLocationInputSearchObject.isInputEmptyCountry = true;
            $scope.isValidEnable = false;
          }
        } else if (type == vm.APP.LIBRARY.CITY_CAPS) {
          if ((vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '')
            && (vm.saveOrAddLocationObject.provinceObj && vm.saveOrAddLocationObject.provinceObj.provinceId != null && vm.saveOrAddLocationObject.provinceObj.provinceId != '')) {
            if ((vm.saveOrAddLocationObject.cityObj && vm.saveOrAddLocationObject.cityObj.cityId != null && vm.saveOrAddLocationObject.cityObj.cityId != '')) {
              if ((vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
                $scope.isValidEnable = true;
              } else {
                $scope.isValidEnable = false;
              }
            } else {
              if (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else if (vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '') {
            if ((vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '')
              && (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '')) {
              $scope.isValidEnable = true;
            } else {
              $scope.isValidEnable = false;
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else if ((vm.addLocationInputSearchObject.countrySearchKey != null && vm.addLocationInputSearchObject.countrySearchKey != '')
            && (vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '')
            && (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '')) {
            $scope.isValidEnable = true;
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else {
            vm.addLocationInputSearchObject.isInputEmptyCountry = true;
            vm.addLocationInputSearchObject.isInputEmptyProvince = true;
            $scope.isValidEnable = false;
          }
        } else if (type == vm.APP.LIBRARY.SECTOR_CAPS) {
          if ((vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '')
            && (vm.saveOrAddLocationObject.provinceObj && vm.saveOrAddLocationObject.provinceObj.provinceId != null && vm.saveOrAddLocationObject.provinceObj.provinceId != '')
            && (vm.saveOrAddLocationObject.cityObj && vm.saveOrAddLocationObject.cityObj.cityId != null && vm.saveOrAddLocationObject.cityObj.cityId != '')) {
            if ((vm.saveOrAddLocationObject.sectorObj && vm.saveOrAddLocationObject.sectorObj.sectorId != null && vm.saveOrAddLocationObject.sectorObj.sectorId != '')) {
              $scope.isValidEnable = false;
            } else {
              if (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
            vm.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if ((vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '')
            && (vm.saveOrAddLocationObject.provinceObj && vm.saveOrAddLocationObject.provinceObj.provinceId != null && vm.saveOrAddLocationObject.provinceObj.provinceId != '')) {
            if ((vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '') && (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
            vm.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if (vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '') {
            if ((vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '') && (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '')
              && (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            }
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
            vm.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if ((vm.addLocationInputSearchObject.countrySearchKey != null && vm.addLocationInputSearchObject.countrySearchKey != '') && (vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '')
            && (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '') && (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '')) {
            $scope.isValidEnable = true;
            vm.addLocationInputSearchObject.isInputEmptyCountry = false;
            vm.addLocationInputSearchObject.isInputEmptyProvince = false;
            vm.addLocationInputSearchObject.isInputEmptyCity = false;
          } else {
            vm.addLocationInputSearchObject.isInputEmptyCountry = true;
            vm.addLocationInputSearchObject.isInputEmptyProvince = true;
            vm.addLocationInputSearchObject.isInputEmptyCity = true;
            $scope.isValidEnable = false;
          }
        }
      }
    }

    vm.checkLocationObj = function (type) {
      //Sector Location validation
      if (type == vm.APP.LIBRARY.SECTOR_CAPS) {
        if (vm.addLocationObj.cityTxt == undefined) {
          vm.validationMSGFlagCity = true;
        }
        if (vm.addLocationObj.provinceTxt == undefined) {
          vm.validationMSGFlagProvince = true;
        }
      }
      //City Location validation
      if (type == vm.APP.LIBRARY.CITY_CAPS) {
        if (vm.addLocationObj.provinceTxt == undefined) {
          vm.validationMSGFlagProvince = true;
        }
      }

      $timeout(function () {
        vm.validationMSGFlagProvince = false;
        vm.validationMSGFlagCity = false;
      }, 3000);
    }

    vm.addLocation = function (addlocationRequestForm, flag, event) {
      vm.existFlag = false;
      vm.validationMSGFlagProvince = false;
      vm.validationMSGFlagCity = false;
      vm.isAddLocationDisable = true;
      vm.addLocationObj = {};
      if (vm.saveOrAddLocationObject.countryObj && vm.saveOrAddLocationObject.countryObj.countryId != null && vm.saveOrAddLocationObject.countryObj.countryId != '') {
        vm.addLocationObj.countryId = vm.saveOrAddLocationObject.countryObj.countryId;
        vm.addLocationObj.countryTxt = vm.saveOrAddLocationObject.countryObj.countryTxt;
      } else {
        if (vm.addLocationInputSearchObject.countrySearchKey != null && vm.addLocationInputSearchObject.countrySearchKey != '') {
          vm.addLocationObj.countryTxt = vm.addLocationInputSearchObject.countrySearchKey;
        }
      }
      if (vm.saveOrAddLocationObject.provinceObj && vm.saveOrAddLocationObject.provinceObj.provinceId != null && vm.saveOrAddLocationObject.provinceObj.provinceId != '') {
        vm.addLocationObj.provinceId = vm.saveOrAddLocationObject.provinceObj.provinceId;
        vm.addLocationObj.provinceTxt = vm.saveOrAddLocationObject.provinceObj.provinceTxt;
      } else {
        if (vm.addLocationInputSearchObject.provinceSearchKey != null && vm.addLocationInputSearchObject.provinceSearchKey != '') {
          vm.addLocationObj.provinceTxt = vm.addLocationInputSearchObject.provinceSearchKey;
        }
      }
      if (vm.saveOrAddLocationObject.cityObj && vm.saveOrAddLocationObject.cityObj.cityId != null && vm.saveOrAddLocationObject.cityObj.cityId != '') {
        vm.addLocationObj.cityId = vm.saveOrAddLocationObject.cityObj.cityId;
        vm.addLocationObj.cityTxt = vm.saveOrAddLocationObject.cityObj.cityTxt;
      } else {
        if (vm.addLocationInputSearchObject.citySearchKey != null && vm.addLocationInputSearchObject.citySearchKey != '') {
          vm.addLocationObj.cityTxt = vm.addLocationInputSearchObject.citySearchKey;
          vm.checkLocationObj(vm.APP.LIBRARY.CITY_CAPS);
        }
      }
      if (vm.saveOrAddLocationObject.sectorObj && vm.saveOrAddLocationObject.sectorObj.sectorId != null && vm.saveOrAddLocationObject.sectorObj.sectorId != '') {
        vm.addLocationObj.sectorId = vm.saveOrAddLocationObject.sectorObj.sectorId;
        vm.addLocationObj.sectorTxt = vm.saveOrAddLocationObject.sectorObj.sectorTxt;
      } else {
        if (vm.addLocationInputSearchObject.sectorSearchKey != null && vm.addLocationInputSearchObject.sectorSearchKey != '') {
          vm.addLocationObj.sectorTxt = vm.addLocationInputSearchObject.sectorSearchKey;
          vm.checkLocationObj(vm.APP.LIBRARY.SECTOR_CAPS);
        }
      }
      //Location/Entity request from library section will always have isForm value false
      vm.addLocationObj.isForm = false;
      vm.addLocationObj
      if (vm.addLocationObj.countryTxt && !vm.validationMSGFlagProvince && !vm.validationMSGFlagCity) {
        var data = LibraryService.addNewLocation(vm.addLocationObj);
        data.then(function (response) {
          if (response && response.id) {
            vm.cancelLocation(addlocationRequestForm, flag);
            $state.transitionTo($state.current, $stateParams, {
              reload: true,
              inherit: false,
              notify: true
            });
            notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_ADD });
            vm.isAddLocationDisable = false;
          }
        }, function (reason) {
          if (reason.status == 409) {
            vm.existFlag = true;
          } else {
            notifications.showError({ message: vm.APP.LIBRARY.LOCATION_ADD_PROBLEM });
          }
          $timeout(function () {
            vm.existFlag = false;
          }, 3000);
          vm.isAddLocationDisable = false;
          return reason;
        });
      } else {
        if (!vm.validationMSGFlagProvince && !vm.validationMSGFlagCity) {
          vm.addLocationInputSearchObject.isInputEmptyCountry = true;
        }
        vm.isAddLocationDisable = false;
      }
    }

    vm.hidePopup = function () {
      $mdDialog.hide();
    }

    vm.openSuccessDialog = function (id, event) {
      $mdDialog.show({
        targetEvent: event,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    }

    vm.cancelLocation = function (addlocationRequestForm, flag) {
      if (flag == 1) {
        $scope.isAddOrSaveLocation = false;
        communicationService.setData('isAddOrSaveLocation', $scope.isAddOrSaveLocation);
      }
      $scope.isHorizon = false;
      addlocationRequestForm.$setPristine();
      vm.addLocationInputSearchObject = {};
      vm.locationRequestType = {};
      vm.saveOrAddLocationObject = {};
      vm.saveOrAddLocationObject.countryObj = {};
      vm.saveOrAddLocationObject.provinceObj = {};
      vm.saveOrAddLocationObject.cityObj = {};
      vm.saveOrAddLocationObject.sectorObj = {};
      $mdDialog.hide();
    };

    vm.clearOnClose = function (searchKey, dropValue) {
      vm[searchKey] = undefined;
      vm[dropValue] = undefined;
      vm.entityNameLoader = false;
    }

    vm.searchEntity = function (searchKey, entityTypeId) {
      vm.entityNameLoader = true;
      if (searchKey && searchKey.length >= 2) {
        var deferred = $q.defer();
        vm.entityNameList = [];

        var data = LibraryService.getEntityNamesList(searchKey, entityTypeId);
        data.then(function (response) {
          vm.entityNameLoader = false;
          if (response.length > 0) {
            vm.isHide = true;
            vm.entityNameList = response;
            vm.entity.entityName = searchKey;
          } else {
            vm.clearEntity();
            vm.entity.entityName = searchKey;
            vm.isHide = true;
          }
          deferred.resolve(vm.entityNameList);
        });
        return deferred.promise;
      }
    };

    vm.getLocationMappingDataById = function (locationMappingId) {
      var locationData = CommonService.getLocationById(locationMappingId);
      locationData.then(function (response) {
        var locationObj = response;

        vm.entityLocationObject.countryObj = LibraryService.getCountryObj(locationObj);
        vm.entityLocationObject.provinceObj = LibraryService.getProvinceObj(locationObj);
        vm.entityLocationObject.cityObj = LibraryService.getCityObj(locationObj);
        vm.entityLocationObject.sectorObj = LibraryService.getSectorObj(locationObj);
        //Set Location mapping Id edit entity
        vm.entityLocationObject.countryObj.locationMappingId = locationObj.id;
        vm.entityLocationObject.provinceObj.locationMappingId = locationObj.id;
        vm.entityLocationObject.cityObj.locationMappingId = locationObj.id;
        vm.entityLocationObject.sectorObj.locationMappingId = locationObj.id;

      });
    };

    vm.getEntityProfileById = function (entityId) {
      if (entityId) {
        var entityProfile = {};
        var data = LibraryService.getEntityProfileById(entityId);
        data.then(function (response) {
          entityProfile = response;
          vm.entity.contactPersonName = entityProfile.contactPersonName;
          vm.entity.contactPhoneNumber = entityProfile.contactPhoneNumber;
          vm.entity.contactEmail = entityProfile.contactEmail;
          vm.entity.flag = entityProfile.flag;
          vm.entity.comments = entityProfile.comments;
          vm.getLocationMappingDataById(entityProfile.locationMappingId);
        });
      }
    };

    vm.clearEntity = function () {
      var copyEntityType = vm.entity.entityTypeSearchKey;
      vm.entity = {};
      vm.entityLocationObject = {};
      vm.entityLocationObject.countryObj = {};
      vm.entityLocationObject.provinceObj = {};
      vm.entityLocationObject.cityObj = {};
      vm.entityLocationObject.sectorObj = {};
      vm.entity.entityTypeSearchKey = copyEntityType;
      vm.isHide = false;
    };

    vm.getEntityTypeById = function (entityTypeId) {
      angular.forEach(vm.entityTypeList, function (data, key) {
        if (data.id == entityTypeId) {
          vm.entity.entityTypeSearchKey = data;
        }
      });
    }

    $scope.showEntityProfileById = function (entityId) {
      vm.entity = {};
      vm.entityPopupLoader = true;
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        vm.entity = response;
        //vm.entity.entityName = LibraryService.getEntityNameObj(vm.entity);
        vm.entity.entityName = vm.entity.name;
        vm.getLocationMappingDataById(vm.entity.locationMappingId);
        vm.getEntityTypeById(vm.entity.entityTypeId);
        vm.entityPopupLoader = false;
      });
    };

    vm.openEntityDeletePopup = function (event, id, entityId) {
      vm.entityId = entityId;
      vm.isDeleteEntityDisable = false;
      $mdDialog.show({
        targetEvent: event,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    };

    vm.deleteEntity = function (entityId) {
      vm.isDeleteEntityDisable = true;
      var data = LibraryService.deleteEntity(entityId);
      data.then(function (response) {
        notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_DELETE });
        $state.transitionTo($state.current, $stateParams, {
          reload: true,
          inherit: false,
          notify: true
        });
        vm.isDeleteEntityDisable = false;
      }, function (reason) {
        notifications.showError({ message: vm.APP.LIBRARY.ENTITY_DELETE_PROBLEM });
        vm.isDeleteEntityDisable = false;
        return reason;
      });
    };

    vm.changeEditFlag = function () {
      vm.editFlag = false;
      vm.updateFlag = true;
      vm.isHide = true;
    };

    vm.showLocation = function () {
      var requestType;
      vm.addLocationObject = {};
      vm.location.country = null;
      vm.location.province = null;
      vm.location.city = null;
      vm.location.sector = null;

      if (vm.locationRequestType) {
        vm.locRegTypeValid = false;
      }
      //vm.isEnableSave=false;
      if (vm.locationRequestType.name != null) {
        requestType = vm.locationRequestType.name;
      }
      if (requestType == vm.APP.LIBRARY.COUNTRY) {
        vm.isShowCountry = false;
        vm.requestFlagProvinceInput = false;
        vm.requestFlagCityInput = false;
        vm.requestFlagSectorInput = false;
        vm.isShowProvince = true;
        vm.isShowCity = true;
        vm.isShowSector = true;
      } else if (requestType == vm.APP.LIBRARY.PROVINCE) {
        vm.isShowCountry = false;
        vm.isReplaceCountry = false;
        vm.requestFlagCountryInput = false;
        vm.requestFlagCityInput = false;
        vm.requestFlagSectorInput = false;
        vm.isShowProvince = false;
        vm.isReplaceProvince = false;
        vm.isShowCity = true;
        vm.isShowSector = true;
      } else if (requestType == vm.APP.LIBRARY.CITY) {
        vm.isReplaceCountry = false;
        vm.isReplaceProvince = false;
        vm.requestFlagCountryInput = false;
        vm.requestFlagProvinceInput = false;
        vm.requestFlagSectorInput = false;
        vm.isShowCountry = false;
        vm.isShowProvince = false;
        vm.isShowCity = false;
        vm.isReplaceCity = false;
        vm.isShowSector = true;
      } else {
        vm.isShowCountry = false;
        vm.isShowProvince = false;
        vm.isShowCity = false;
        vm.isShowSector = false;
        vm.isReplaceSector = false;
        vm.isReplaceCountry = false;
        vm.isReplaceCity = false;
        vm.isReplaceProvince = false;
        vm.requestFlagCityInput = false;
        vm.requestFlagCountryInput = false;
        vm.requestFlagProvinceInput = false;
      }
    }

    vm.searchRequestLocation = function (searchText, type) {
      if (searchText && searchText.length >= 2) {
        vm.locLoader = true;
        var deferred = $q.defer();
        vm.libraryLocObj = {};
        vm.libraryLocObj.searchKey = searchText;
        if (vm.addLocationObject) {
          if (vm.addLocationObject.countryObj && vm.addLocationObject.countryObj.countryId != null && vm.addLocationObject.countryObj.countryId != '') {
            vm.libraryLocObj.countryId = vm.addLocationObject.countryObj.countryId;
          }
          if (vm.addLocationObject.provinceObj && vm.addLocationObject.provinceObj.provinceId != null && vm.addLocationObject.provinceObj.provinceId != '') {
            vm.libraryLocObj.provinceId = vm.addLocationObject.provinceObj.provinceId;
          }
          if (vm.addLocationObject.cityObj && vm.addLocationObject.cityObj.cityId != null && vm.addLocationObject.cityObj.cityId != '') {
            vm.libraryLocObj.cityId = vm.addLocationObject.cityObj.cityId;
          }
          if (vm.addLocationObject.sectorObj && vm.addLocationObject.sectorObj.sectorId != null && vm.addLocationObject.sectorObj.sectorId != '') {
            vm.libraryLocObj.sectorId = vm.addLocationObject.sectorObj.sectorId;
          }
        }
        var data = LibraryLocationService.loadAllLocationsByType(vm.libraryLocObj, type);
        data.then(function (response) {
          vm.locLoader = false;
          if (response.autoSuggestionLocationDTOList) {
            if (type == vm.APP.LIBRARY.COUNTRY_CAPS) {
              vm.searchCountryList = response.autoSuggestionLocationDTOList;
            } else if (type == vm.APP.LIBRARY.PROVINCE_CAPS) {
              vm.searchProvinceList = response.autoSuggestionLocationDTOList;
            } else if (type == vm.APP.LIBRARY.CITY_CAPS) {
              vm.searchCityList = response.autoSuggestionLocationDTOList;
            } else if (type == vm.APP.LIBRARY.SECTOR_CAPS) {
              vm.searchSectorList = response.autoSuggestionLocationDTOList;
            }
          }
          if (type == vm.APP.LIBRARY.COUNTRY_CAPS) {
            deferred.resolve(vm.searchCountryList);
          } else if (type == vm.APP.LIBRARY.PROVINCE_CAPS) {
            deferred.resolve(vm.searchProvinceList);
          } else if (type == vm.APP.LIBRARY.CITY_CAPS) {
            deferred.resolve(vm.searchCityList);
          } else if (type == vm.APP.LIBRARY.SECTOR_CAPS) {
            deferred.resolve(vm.searchSectorList);
          }

        });
        return deferred.promise;
      }
    };

    vm.clear = function (type) {
      // vm.isEnableSave=false;
      if (type == vm.APP.LIBRARY.COUNTRY_CAPS) {
        vm.addLocationObject.countryObj = {};
        vm.requestFlagCountryInput = false;
        vm.isReplaceCountry = false;
        vm.location.country = undefined;

      } if (type == vm.APP.LIBRARY.PROVINCE_CAPS) {
        vm.addLocationObject.provinceObj = {};
        vm.requestFlagProvinceInput = false;
        vm.isReplaceProvince = false;
        vm.location.province = undefined;
      }
      if (type == vm.APP.LIBRARY.CITY_CAPS) {
        vm.addLocationObject.cityObj = {};
        vm.requestFlagCityInput = false;
        vm.isReplaceCity = false;
        vm.location.city = undefined;
      }
      if (type == vm.APP.LIBRARY.SECTOR_CAPS) {
        vm.addLocationObject.sectorObj = {};
        vm.requestFlagSectorInput = false;
        vm.isReplaceSector = false;
        vm.location.sector = undefined;
      }
    }

    vm.countryChange = function () {
      if (vm.country == "") {
        $scope.libraryAddEntityInputSearchObject.country = "";
        $scope.libraryAddEntityInputSearchObject.province = "";
        $scope.libraryAddEntityInputSearchObject.city = "";
        $scope.libraryAddEntityInputSearchObject.sector = "";
        vm.clear('COUNTRY');
        $scope.libraryAddEntityInputSearchObject.country = undefined;
      }
    }

    vm.countrySearchChange = function () {
      if (vm.location.country == "") {
        vm.clear('COUNTRY');
        vm.isReplaceCountry = false;
        vm.requestFlagCountryInput = false;
        vm.addLocationObject.countryObj = undefined;
      }
    }

    vm.provinceChange = function () {
      if (vm.province == "") {
        $scope.libraryAddEntityInputSearchObject.province = "";
        $scope.libraryAddEntityInputSearchObject.city = "";
        $scope.libraryAddEntityInputSearchObject.sector = "";
        vm.clear('PROVINCE');
        $scope.libraryAddEntityInputSearchObject.province = undefined;
      }
    }

    vm.provinceSearchChange = function () {
      if (vm.location.province == "") {
        vm.clear('PROVINCE');
        vm.isAddOrSaveLocationCountry = false;
        vm.addLocationObject.provinceObj = undefined;
      }
    }

    vm.cityChange = function () {
      if (vm.city == "") {
        $scope.libraryAddEntityInputSearchObject.city = "";
        $scope.libraryAddEntityInputSearchObject.sector = "";
        vm.clear('CITY');
        $scope.libraryAddEntityInputSearchObject.city = undefined;
      }
    }

    vm.citySearchChange = function () {
      if (vm.location.city == "") {
        vm.clear('CITY');
        vm.isAddOrSaveLocationCity = false;
        vm.addLocationObject.cityObj = undefined;
      }
    }

    vm.sectorChange = function () {
      if (vm.sector == "") {
        $scope.libraryAddEntityInputSearchObject.sector = "";
        vm.clear('SECTOR');
        $scope.libraryAddEntityInputSearchObject.sector = undefined;
      }
    }

    vm.sectorSearchChange = function () {
      if (vm.location.sector == "") {
        vm.clear('SECTOR');
        vm.isAddOrSaveLocationSector = false;
        vm.addLocationObject.sectorObj = undefined;
      }
    }

    vm.clearFields = function (addlocationRequestForm) {
      vm.addLocationObject = {};
      $scope.libraryAddEntityInputSearchObject = {};
      addlocationRequestForm.$setPristine();
    };
    vm.clearName = function (name, searchKey, dropValue) {
      vm[searchKey] = undefined;
      vm[dropValue] = undefined;
    }

    vm.replaceInputField = function () {
      var requestType;
      if (vm.locationRequestType != null) {
        requestType = vm.locationRequestType.name;
      }
      if (requestType == vm.APP.LIBRARY.COUNTRY) {
        if (vm.country != null || vm.location.country != null) {
          //vm.isEnableSave=true;
        }
        if (vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null && vm.searchCountryList.length == 0) {
          vm.isReplaceCountry = true;
          vm.requestFlagCountryInput = true;
          vm.location.country = vm.country;
        }
      }
      if (requestType == vm.APP.LIBRARY.PROVINCE) {
        if (vm.province != null) {
          //vm.isEnableSave=true;
        }
        //allow user to select country which is not in system
        if (vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null && vm.searchCountryList.length == 0) {
          vm.isReplaceCountry = true;
          vm.requestFlagCountryInput = true;
          vm.location.country = vm.country;
        }
        if (vm.isShowProvince == false && vm.addLocationObject.provinceObj == undefined && vm.province != null && vm.searchProvinceList.length == 0) {
          vm.location.province = vm.province;
          vm.isReplaceProvince = true;
          vm.requestFlagProvinceInput = true;
          //vm.isReplaceCountry = false;
        }
      }
      if (requestType == vm.APP.LIBRARY.CITY) {
        if (vm.city != null) {
          //vm.isEnableSave=true;
        }
        //allow user to select country which is not in system
        if (vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null && vm.searchCountryList.length == 0) {
          vm.isReplaceCountry = true;
          vm.requestFlagCountryInput = true;
          vm.location.country = vm.country;
        }
        //allow user to select province which is not in system
        if (vm.isShowProvince == false && vm.addLocationObject.provinceObj == undefined && vm.province != null && vm.searchProvinceList.length == 0) {
          vm.location.province = vm.province;
          vm.isReplaceProvince = true;
          vm.requestFlagProvinceInput = true;
          //vm.isReplaceCountry = false;
        }
        if (vm.isShowCity == false && vm.addLocationObject.cityObj == undefined && vm.city != null && vm.searchCityList.length == 0) {
          vm.location.city = vm.city;
          vm.isReplaceCity = true;
          vm.requestFlagCityInput = true;
          //vm.isReplaceCountry = false;
        }
      }
      if (requestType == vm.APP.LIBRARY.SECTOR) {
        if (vm.sector != null) {
          //vm.isEnableSave=true;
        }
        //allow user to select country which is not in system
        if (vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null && vm.searchCountryList.length == 0) {
          vm.isReplaceCountry = true;
          vm.requestFlagCountryInput = true;
          vm.location.country = vm.country;
        }
        //allow user to select province which is not in system
        if (vm.isShowProvince == false && vm.addLocationObject.provinceObj == undefined && vm.province != null && vm.searchProvinceList.length == 0) {
          vm.location.province = vm.province;
          vm.isReplaceProvince = true;
          vm.requestFlagProvinceInput = true;
          //vm.isReplaceCountry = false;
        }
        //allow user to select city which is not in system
        if (vm.isShowCity == false && vm.addLocationObject.cityObj == undefined && vm.city != null && vm.searchCityList.length == 0) {
          vm.location.city = vm.city;
          vm.isReplaceCity = true;
          vm.requestFlagCityInput = true;
          //vm.isReplaceCountry = false;
        }
        if (vm.isShowSector == false && vm.addLocationObject.sectorObj == undefined && vm.sector != null && vm.searchSectorList.length == 0) {
          vm.location.sector = vm.sector;
          vm.isReplaceSector = true;
          vm.requestFlagSectorInput = true;
          //vm.isReplaceCountry = false;
        }
      }
    }

    vm.saveValid = function (input) {
      if (input.type == 'COUNTRY') {
        if (vm.addLocationObject.countryObj && vm.addLocationObject.countryObj.countryId != "" && !$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry) {
          $scope.libraryAddEntityInputSearchObject.country = vm.addLocationObject.countryObj.countryTxt;
          vm.location.country = vm.addLocationObject.countryObj.countryTxt;
        } else if (vm.addLocationObject.countryObj && $scope.addLocationObject.countryObj.countryTxt == $scope.libraryAddEntityInputSearchObject.country) {
          $scope.addLocationObject.countryObj.countryId = undefined;
        }
        $scope.libraryAddEntityInputSearchObject.countrySearchKey = $scope.libraryAddEntityInputSearchObject.country;
        vm.country = $scope.libraryAddEntityInputSearchObject.countrySearchKey;
      }

      if (input.type == 'PROVINCE') {
        if (vm.addLocationObject.provinceObj && vm.addLocationObject.provinceObj.provinceId != "" && !$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince) {
          $scope.libraryAddEntityInputSearchObject.province = vm.addLocationObject.provinceObj.provinceTxt;
        } else if (vm.addLocationObject.provinceObj && $scope.addLocationObject.provinceObj.provinceTxt == $scope.libraryAddEntityInputSearchObject.province) {
          $scope.addLocationObject.provinceObj.provinceId != undefined;
        }
        $scope.libraryAddEntityInputSearchObject.provinceSearchKey = $scope.libraryAddEntityInputSearchObject.province;
        vm.province = $scope.libraryAddEntityInputSearchObject.provinceSearchKey;
      }

      if (input.type == 'CITY') {
        if (vm.addLocationObject.cityObj && vm.addLocationObject.cityObj.cityId != "" && !$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCity) {
          $scope.libraryAddEntityInputSearchObject.city = vm.addLocationObject.cityObj.cityTxt;
        } else if (vm.addLocationObject.cityObj && $scope.addLocationObject.cityObj.cityTxt == $scope.libraryAddEntityInputSearchObject.city) {
          $scope.addLocationObject.cityObj.cityId != undefined;
        }
        $scope.libraryAddEntityInputSearchObject.citySearchKey = $scope.libraryAddEntityInputSearchObject.city;
        vm.city = $scope.libraryAddEntityInputSearchObject.citySearchKey;
      }

      if (input.type == 'SECTOR') {
        if (vm.addLocationObject.sectorObj && vm.addLocationObject.sectorObj.sectorId != "" && !$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationSector) {
          $scope.libraryAddEntityInputSearchObject.sector = vm.addLocationObject.sectorObj.sectorTxt;
        } else if (vm.addLocationObject.sectorObj && $scope.addLocationObject.sectorObj.sectorTxt == $scope.libraryAddEntityInputSearchObject.sector) {
          $scope.addLocationObject.sectorObj.sectorId != undefined;
        }
        $scope.libraryAddEntityInputSearchObject.sectorSearchKey = $scope.libraryAddEntityInputSearchObject.sector;
        vm.sector = $scope.libraryAddEntityInputSearchObject.sectorSearchKey;
      }
    };

    vm.populatePreFillDetails = function (locationObj) {
      if (locationObj) {
        $scope.copyLocationObj = angular.copy(locationObj);
        if ($scope.copyLocationObj.countryId != null) {
          vm.addLocationObject.countryObj = $scope.copyLocationObj;
        }
        if ($scope.copyLocationObj.provinceId != null) {
          vm.addLocationObject.provinceObj = $scope.copyLocationObj;
        }
        if ($scope.copyLocationObj.cityId != null) {
          vm.addLocationObject.cityObj = $scope.copyLocationObj;
        }
        if ($scope.copyLocationObj.sectorId != null) {
          vm.addLocationObject.sectorObj = $scope.copyLocationObj;
        }
      }
    }

    $scope.setLibraryType = function () {
      vm.library.libraryType = $state.current.name;
    };

    $scope.validateUpdateEntityLocation = function () {
      vm.updateEntityLocation = true;
      if (angular.isUndefinedOrNull(vm.locationObj.cityTxt) || angular.isUndefinedOrNull(vm.locationObj.provinceTxt) || angular.isUndefinedOrNull(vm.locationObj.countryTxt)) {
        vm.updateEntityLocation = false;
      }
    };

  }

})();


(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('LibraryService', LibraryService);

    LibraryService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function LibraryService ($resource,restService,$q,$rootScope) {
    	
    	
    	/*this.loadRequestFilterList = function(filterObj) {
    		var deferred = $q.defer();
    		var url = "";
    		if(filterObj.statusKey && filterObj.statusKey.length > 0) {
    			filterObj.statusKey = undefined;
    		}
    		var data = restService.restCall(filterObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};*/
    	
    	this.addNewEntity = function(entityObj){
    		var deferred = $q.defer();
    		var url = "entity-profiles";
    		var data = restService.restCall(entityObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
    	};
    	
    	this.updateEntity = function(entityObj){
    		var deferred = $q.defer();
    		var url = "entity-profiles";
    		var data = restService.restCall(entityObj, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
    	}; 
    	
    	this.deleteEntity = function(entityId){
    		var deferred = $q.defer();
    		var url = "entity-profiles/"+entityId;
    		var data = restService.restCall('', url, 'DELETE');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	}; 
    	
    	this.saveNewEntity = function(entityObj){
    		var deferred = $q.defer();
    		var url = "entity-profiles/request";
    		var data = restService.restCall(entityObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	}
    	
    	this.saveNewLocation = function(requestObj){
    		var deferred = $q.defer();
    		var url = "location-mappings/request";
    		var data = restService.restCall(requestObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('error');
    		});
    		return deferred.promise;
    	}
    	
    	this.getEntityProfileById = function(entityId) {
    		var deferred = $q.defer();
    		var url = "entity-profiles/"+entityId;
    		var data = restService.restCall('', url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	this.getEntityNamesList = function(searchKey, entityTypeId){
    		var deferred = $q.defer();
    		var url = "approved-entity-profile-names/"+entityTypeId+"?searchKey="+searchKey;
    		var data = restService.restCall('', url, 'GETLIST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	}
    	
    	this.addNewLocation = function(saveLocObj){
    		var deferred = $q.defer();
    		var url = "location-mappings";
    		var data = restService.restCall(saveLocObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
    	}
    	
    	this.editIndividualLocation = function(saveLocObj){
    		var deferred = $q.defer();
    		var url = "locations";
    		var data = restService.restCall(saveLocObj, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
    	}
    	
    	this.deleteLocationDetail = function(mapId){
    		var deferred = $q.defer();
    		var url = "location-mappings/"+mapId;
    		var data = restService.restCall('', url, 'DELETE');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject(error);
    		});
    		return deferred.promise;
    	}
    	
    	this.getCountryObj = function(fromRequest){
	  		var countryObj = {};
    		countryObj.countryId = fromRequest.countryId;
    		countryObj.countryTxt = fromRequest.countryTxt;
    		return countryObj;
	  	};
	  	
	  	this.getProvinceObj = function(fromRequest){
	  		var provinceObj = {};
    		provinceObj.provinceId = fromRequest.provinceId;
    		provinceObj.provinceTxt = fromRequest.provinceTxt;
    		return provinceObj;
	  	}
	  	
	  	this.getCityObj = function(fromRequest){
	  		var cityObj = {};
    		cityObj.cityId = fromRequest.cityId;
    		cityObj.cityTxt = fromRequest.cityTxt;
    		return cityObj;
	  	};
	  	
	  	this.getSectorObj = function(fromRequest){
	  		var sectorObj = {};
    		sectorObj.sectorId = fromRequest.sectorId;
    		sectorObj.sectorTxt = fromRequest.sectorTxt;
    		return sectorObj;
	  	}
	  	
	  	this.getEntityNameObj = function(fromRequest){
	  		var entityNameObj = {};
	  		entityNameObj.id = fromRequest.id;
	  		entityNameObj.name = fromRequest.name;
	  		return entityNameObj;
	  	};
		
    }
})();

(function() {
	'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','APP','$mdAriaProvider','$mdDateLocaleProvider'];
    
    function stateConfig($stateProvider,APP,$mdAriaProvider,$mdDateLocaleProvider) {
    	$stateProvider.state('library', {
    		parent: 'app',
            url: '/library',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            views: {
                'dynamicView': {
                    templateUrl: 'app/library/library.management.html',
                    controller: 'LibraryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       } 
                    return $translate.refresh();
                }]/*,
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#request').triggerHandler('click');
                	  });
                }]*/
            }
            
    	});
    };
	
})();
(function () {
  "use strict";

  angular.module("lariAidApp").controller("UserController", UserController);

  UserController.$inject = [
    "$element",
    "BaseFactory",
    "APP",
    "UserService",
    "$mdMedia",
    "deviceDetector",
    "$sessionStorage",
    "tabservice",
    "$q",
    "$state",
    "$scope",
    "$mdSidenav",
    "StorageDelete",
    "$cookies",
    "CommonService",
    "$mdDialog",
    "$location",
    "$timeout",
    "$stateParams",
    "notifications"
  ];
  function UserController(
    $element,
    BaseFactory,
    APP,
    UserService,
    $mdMedia,
    deviceDetector,
    $sessionStorage,
    tabservice,
    $q,
    $state,
    $scope,
    $mdSidenav,
    StorageDelete,
    $cookies,
    CommonService,
    $mdDialog,
    $location,
    $timeout,
    $stateParams,
    notifications
  ) {
    var vm = this;
    var investigation = {};
    vm.media = $mdMedia;
    vm.selectedUserRoleList = [];
    vm.selectedCasesList = [];
    var qPromises = [];
    vm.userRoles = [];
    vm.investigationCases = [];
    vm.isCallForCount = false;
    vm.loadingListData = false;
    vm.loadingCountData = true;

    vm.APP = APP;
    vm.endless = vm.APP.GLOBAL.ENDLESS;

    vm.investigatorObj = {};
    vm.investigatorObj.language = [];
    vm.investigatorObj.phoneNumber = [];
    vm.investigatorObj.userCountryDTO = {};

    vm.userEndlessScrollRetain = {};

    if ($sessionStorage.userEndlessScrollRetain) {
      vm.userEndlessScrollRetain = $sessionStorage.userEndlessScrollRetain;
    }

    vm.checkUserIndex = function () {
      vm.userTabIndex = tabservice.getIndex();
    };
    vm.checkUserIndex();

    vm.toggleLeft = buildToggler("left");
    vm.toggleRight = buildToggler("right");

    vm.userFilter = {}; // Filters dropdown
    vm.userFilterObj = {}; // Post object
    vm.userFilterObj.from = 0;
    vm.userFilterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
    vm.userFilterObj.userRoleKey = [];
    vm.userFilterObj.investigationStatusKey = [];

    var userListTotalLength = 0;

    vm.userList = [];
    var user = {};
    vm.loadingUserData = false;
    vm.allCountry =[];
		vm.selectedAdminList=[];
		vm.savedList=[];
		vm.countryFilter=[];//side filter param
		vm.countrySearchKey = '';//overall SearchKey
		$scope.countryInsideSearch = '';
		vm.regionSearchKey = '';
		vm.allCountries=false;
		vm.deletedItemList = [];
		vm.missingCountryDetails=[];
    vm.allCoutrySelect=[];
    vm.currentDate = new Date();
		vm.endDate = new Date();
		vm.selectAllCountryStartDate = new Date();
		vm.selectAllCountryStartDate='';
		vm.selectAllCountryEndDate = new Date();
		vm.selectAllCountryEndDate = '';
		vm.futureState;
		vm.isSaveCountryAdminDetails = true;
		$sessionStorage.isSaveCountryAdminDetails = true;    	


    //Get user from cookie storage
    vm.user = CommonService.getCookieUser();
    vm.userEmail = vm.user.cookieUser.login;
    vm.loggedUserRole = vm.user.loggedUserRole;
    vm.currentState = $state.current.name;

    vm.searchLocations = function (searchKey) {
      if (searchKey) {
        vm.locationLoader = true;
        var data = CommonService.getRefTermList(vm.APP.REF_TERM.COUNTRY, searchKey);
        data.then(function (response) {
          vm.locationLoader = false;
          vm.locationVO = response;
        });
      }
    };

    var clickingUserTimer;
    vm.getUserList = function (type) {
      clearTimeout(clickingUserTimer);

      clickingUserTimer = setTimeout(function () {
        vm.loadingUserData = true;
        if (type != vm.endless && vm.userEndlessScrollRetain && !vm.userEndlessScrollRetain.index) {
          vm.userList = [];
        }

        if (vm.userList && vm.userList.length == 0) {
          vm.userFilterObj.from = 0;
          userListTotalLength = 0;
        }

        //Set size of the list to the previous size
        if (vm.userEndlessScrollRetain && vm.userEndlessScrollRetain.index) {
          vm.userFilterObj.from = 0;
          vm.userFilterObj.size = vm.userEndlessScrollRetain.from;
        } else {
          vm.userFilterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
        }

        /*else if(vm.userList.length > 0){
  	        		vm.userFilterObj.from = vm.userList.length;
  	        	}*/

        if (vm.userFilterObj.from < userListTotalLength || userListTotalLength == 0) {
          var data = UserService.getUserList(vm.userFilterObj);
          data.then(
            function (response) {
              vm.loadingUserData = false;
              vm.noMoreUsers = false;

              if (response && !angular.equals({}, response) && response.totalCount) {
                userListTotalLength = response.totalCount;
                angular.forEach(response.investigationUserlist, function (value, key) {
                  if (vm.userList == null) {
                    vm.userList = [];
                    vm.userList.push(value);
                  } else {
                    vm.userList.push(value);
                  }
                });
                vm.userFilterObj.from = vm.userList.length;

                if (vm.userEndlessScrollRetain && vm.userEndlessScrollRetain.index) {
                  var locationHash = vm.userEndlessScrollRetain.index;
                  $location.hash(locationHash);
                  $timeout(function () {
                    $location.url($location.path());
                  }, 500);
                }
                //Endless retain
                vm.userEndlessScrollRetain.from = vm.userFilterObj.from;

                //Remove index from this object
                if (vm.userEndlessScrollRetain.index) {
                  vm.userEndlessScrollRetain.index = undefined;
                }

                if (vm.userFilterObj.from == userListTotalLength) {
                  vm.loadingUserData = false;
                  vm.loadingListData = false;
                  vm.noMoreUsers = true;
                }

                if (vm.userFilterObj.from <= vm.APP.GLOBAL.DEFAULT_SIZE) {
                  vm.noMoreUsers = false;
                }
              } else if (angular.isUndefined(response)) {
                vm.loadingUserData = false;
                vm.loadingListData = false;
                vm.noMoreUsers = false;
              }
              vm.loadingListData = false;
            },
            function (reason) {
              vm.loadingListData = false;
              return reason;
            }
          );
        } else {
          vm.loadingListData = false;
          vm.loadingUserData = false;
          vm.loadingListData = false;
          vm.noMoreUsers = true;
        }
      }, 200);
    };

    vm.searchUser = function (userSearchKey) {
      vm.userFilterObj.searchKey = userSearchKey;
      $sessionStorage.subUserFilters = userSearchKey;
      if (userSearchKey.length > 1 || userSearchKey.length == 0) {
        vm.getUserList();
      }
      /*else {
        		  vm.userFilterObj.searchKey = userSearchKey;
        	 }*/
    };

    $scope.callListfun = function () {
      vm.getUserList(vm.endless);
    };

    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });

    function buildToggler(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }
    vm.stateInternalDetails = function () {
      // The manager edit the country admin at time we call the warning popup functionality
      if (!($sessionStorage.isSaveCountryAdminDetails) && $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
        vm.futureState = vm.APP.USER.INTERNAL;
        vm.showWarning('warningPopupMsg');
     } else {
        if ($sessionStorage.userManagementActiveState == vm.APP.USER.EXTERNAL || $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
           StorageDelete.deleteUser();
        }
        $sessionStorage.userManagementActiveState = vm.APP.USER.INTERNAL;
        vm.userTabIndex = 1;
        $state.go(vm.APP.USER.INTERNAL);
     }
     $sessionStorage.futureState = vm.APP.USER.INTERNAL;
    };

    vm.stateExternalDetails = function () {
      if (!($sessionStorage.isSaveCountryAdminDetails) && $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
        vm.futureState = vm.APP.USER.EXTERNAL;
        vm.showWarning('warningPopupMsg');
     } else {
        if ($sessionStorage.userManagementActiveState == vm.APP.USER.INTERNAL || $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
           StorageDelete.deleteUser();
        }
        $sessionStorage.userManagementActiveState = vm.APP.USER.EXTERNAL;
        vm.userTabIndex = 2;
        $state.go(vm.APP.USER.EXTERNAL);
     
     }
     $sessionStorage.futureState = vm.APP.USER.EXTERNAL;
    };

    vm.setCurrentStateToAdmin = function () {
      if ($sessionStorage.userManagementActiveState == vm.APP.USER.INTERNAL || $sessionStorage.userManagementActiveState == vm.APP.USER.EXTERNAL) {
         StorageDelete.deleteUser();
      }
      $sessionStorage.userManagementActiveState = vm.APP.USER.ADMIN;
      vm.userTabIndex = 3;
      $state.go(vm.APP.USER.ADMIN);
   };

    vm.goProfile = function (id, index) {
      vm.userEndlessScrollRetain.index = "user" + index;
      $sessionStorage.userEndlessScrollRetain = vm.userEndlessScrollRetain;

      user.id = id;
      // $state.go("userprofile",user);
      $state.go("userprofile", user);
    };

    vm.clearOnClose = function (name, searchKey, dropValue) {
      if (!vm.userFilter[name] || !vm.userFilter[name].id) {
        vm[searchKey] = undefined;
        vm[dropValue] = undefined;
      }
    };

    vm.callSynchronizePromise = function () {
      qPromises = [];

      qPromises.push(vm.getRoleUser());
      qPromises.push(vm.getInvestigationCases());

      $q.all(qPromises).then(function (data) {
        vm.getUserList();
      });
    };

    vm.clearUser = function (modelName, postVariable, searchKeyModel) {
      if (vm.userFilter[modelName] || vm.userFilter[modelName].id) {
        vm.userFilter[modelName] = undefined;
        vm.userFilterObj[postVariable] = undefined;
        if (searchKeyModel) {
          vm[searchKeyModel] = undefined;
        }
      }

      if (vm.media("gt-sm")) {
        vm.callSynchronizePromise();
      }
    };

    /**
     * Function to update vm.userFilterObj from vm.userFilter
     * modelName - Either location or language name
     * postVariable - Assigning Either location or language id to vm.userFilterObj
     *
     */

    vm.updateUserFilterObj = function (modelName, postVariable) {
      if (vm.userFilter[modelName] && vm.userFilter[modelName].id) {
        vm.userFilterObj[postVariable] = vm.userFilter[modelName].id;
      }

      $sessionStorage.userFilter = vm.userFilter;
    };

    /**
     * Function to update vm.userFilterObj from selected filter lists
     * postVariable - Variable name in vm.userFilterObj
     * selectedList - Either vm.selectedUserRoleList or vm.selectedCasesList
     *
     */
    vm.updateUserFilterObjList = function (postVariable, selectedList) {
      vm.userFilterObj[postVariable] = [];
      angular.forEach(selectedList, function (data, key) {
        vm.userFilterObj[postVariable].push(data.id);
      });
    };

    vm.getRoleUser = function (isDefault) {
      vm.showUserRoleDiv = false;
      var data = UserService.getRoleUser(vm.userFilterObj);
      data.then(
        function (response) {
          vm.userRoles = response.userCountList;

          angular.forEach(vm.userRoles, function (data, key) {
            if (data.count > 0) {
              vm.showUserRoleDiv = true; // To hide entire user role div when all count is 0

              // Default RoleUser filter selected
              if (isDefault) {
                data.checked = true;
                vm.selectedUserRoleList.push(data);

                //Default RoleUser filter id selected
                vm.userFilterObj.userRoleKey.push(data.id);
              }
            }
          });

          if (!isDefault) {
            if ($sessionStorage.selectedUserRoleList) {
              vm.selectedUserRoleList = [];
              vm.selectedUserRoleList = $sessionStorage.selectedUserRoleList;
            }

            // Default select after refresh
            angular.forEach(vm.userRoles, function (data, index) {
              angular.forEach(vm.selectedUserRoleList, function (selected, key) {
                if (data.id == selected.id) {
                  data.checked = true;
                }
              });
            });

            /*for(var i=0;i<vm.userRoles.length;i++){
							for(var j=0;j<vm.selectedUserRoleList.length;j++){
								 if(vm.userRoles[i].id == vm.selectedUserRoleList[j].id){
									 vm.userRoles[i].checked = true;
									 break;
								 }  	  	 		
							}
				  	 	}*/
          }

          if (!vm.showUserRoleDiv) {
            vm.selectedUserRoleList = [];
            vm.userRoles = [];
          }
          vm.updateUserFilterObjList(vm.APP.USER.USER_ROLE_KEY, vm.selectedUserRoleList); // Update userFilterObj
          vm.loadingCountData = false;
        },
        function (reason) {
          vm.showUserRoleDiv = true;
          vm.loadingCountData = false;
          return reason;
        }
      );

      return data;
    };

    //Common function for toggle based on the filter type
    vm.toggleUser = function (item, list, type) {
      //To disable checkboxes
      if (vm.media("gt-sm")) {
        vm.loadingListData = true;
      }
      //var idx = list.indexOf(item);
      var idx;
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == item.id) {
          idx = i;
        }
      }
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push(item);
      }

      if (type == vm.APP.USER.USER_ROLE_FILTER) {
        // Role filter
        $sessionStorage.selectedUserRoleList = list;
        vm.updateUserFilterObjList(vm.APP.USER.USER_ROLE_KEY, vm.selectedUserRoleList);
      } else if (vm.APP.USER.INVESTIGATION_CASES) {
        // Investigation cases
        $sessionStorage.selectedCasesList = list;
        vm.updateUserFilterObjList(vm.APP.USER.INVESTIGATION_STATUS_KEY, vm.selectedCasesList);
      }

      //Trigger the count call
      if (vm.media("gt-sm")) {
        vm.loadingListData = true;
        vm.getRoleUser();
        vm.getInvestigationCases();
        vm.getUserList();
      }

      vm.deleteEndlessDetails();
    };

    vm.getInvestigationCases = function (isDefault) {
      vm.showInvestigationCasesDiv = false;
      var data = UserService.getInvestigationCases(vm.userFilterObj);
      data.then(
        function (response) {
          vm.investigationCases = response.userCountList;

          angular.forEach(vm.investigationCases, function (data, key) {
            if (data.count > 0) {
              vm.showInvestigationCasesDiv = true; // To hide entire user role div when all count is 0

              // Default RoleUser filter selected except deleted user and user with no active cases
              if (
                isDefault &&
                data.name != vm.APP.USER.DELETEDUSERS &&
                data.name != vm.APP.USER.USERWITHNOACTIVECASES
              ) {
                data.checked = true;
                vm.selectedCasesList.push(data);

                //Default RoleUser filter id selected
                vm.userFilterObj.investigationStatusKey.push(data.id);
              }
            }
          });

          if (!isDefault) {
            if ($sessionStorage.selectedCasesList) {
              vm.selectedCasesList = [];
              vm.selectedCasesList = $sessionStorage.selectedCasesList;
            }

            // Default select after refresh
            angular.forEach(vm.investigationCases, function (data, index) {
              angular.forEach(vm.selectedCasesList, function (selected, key) {
                if (data.id == selected.id) {
                  data.checked = true;
                }
              });
            });
          }

          if (!vm.showInvestigationCasesDiv) {
            vm.selectedCasesList = [];
            vm.investigationCases = [];
          }
          vm.updateUserFilterObjList(vm.APP.USER.INVESTIGATION_STATUS_KEY, vm.selectedCasesList); // Update userFilterObj
          vm.loadingCountData = false;
        },
        function (reason) {
          vm.showInvestigationCasesDiv = true;
          vm.loadingCountData = false;
          return reason;
        }
      );
      return data;
    };

    vm.setUserType = function () {
      if (vm.userTabIndex == 1) {
        vm.userFilterObj.isInternalUser = 1; //internal
        user.userType = vm.APP.USER.INTERNAL;
      } else if (vm.userTabIndex == 2) {
        vm.userFilterObj.isInternalUser = 0; //external
        user.userType = vm.APP.USER.EXTERNAL;
      }
      else if(vm.userTabIndex == 3){
        vm.userFilterObj.isInternalUser =0;
        user.userType = vm.APP.USER.ADMIN;
      }
    };
    vm.sideNavClose = function (id) {
      $mdSidenav(id).close();
    };

    vm.getUserSortedList = function (userSortBy, isCallRequired) {
      vm.userFilterObj.sortBy = userSortBy;
      if (userSortBy == vm.APP.USER.SORT_BY_COUNT) {
        vm.userFilterObj.sortOrder = vm.APP.GLOBAL.DESC;
      } else if (userSortBy == vm.APP.USER.SORT_BY_NAME) {
        vm.userFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
      }

      $sessionStorage.userSortBy = userSortBy;

      if (!isCallRequired) {
        vm.getUserList(); //Prevent call from vm.userInit function.
      }
    };

    vm.userInit = function () {
      vm.sideNavClose("left");

      vm.sortOrderList = [
        {
          id: vm.APP.USER.SORT_BY_COUNT,
          value: vm.APP.USER.SORT_BY_COUNT_VALUE
        },
        {
          id: vm.APP.USER.SORT_BY_NAME,
          value: vm.APP.USER.SORT_BY_NAME_VALUE
        }
      ];

      //Default
      if (angular.isUndefined(vm.userSortBy) || angular.isUndefined(vm.userSortBy.value)) {
        vm.userFilterObj.sortBy = vm.APP.USER.SORT_BY_COUNT;
        vm.userFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
      }

      //Sort by initialization through session storage
      if ($sessionStorage.userSortBy) {
        for (var i = 0; i < vm.sortOrderList.length; i++) {
          if (vm.sortOrderList[i].id == $sessionStorage.userSortBy) {
            vm.userSortBy = vm.sortOrderList[i];
            break;
          }
        }

        vm.getUserSortedList(vm.userSortBy.id, true); // To get sort by list
      }

      //Clearing investigation module session storage objects
      StorageDelete.deleteInvestigation();
      StorageDelete.deleteLibrary();

      if ($sessionStorage.subUserFilters) {
        vm.userSearch = $sessionStorage.subUserFilters;
        vm.userFilterObj.searchKey = vm.userSearch;
      }

      var data = BaseFactory.getLanguagesList();
      data.then(function (response) {
        vm.languagesVO = response;
      });

      if ($sessionStorage.selectedUserRoleList) {
        qPromises.push(vm.getRoleUser(false));
      } else {
        qPromises.push(vm.getRoleUser(true));
      }

      if ($sessionStorage.selectedCasesList) {
        qPromises.push(vm.getInvestigationCases(false));
      } else {
        qPromises.push(vm.getInvestigationCases(true));
      }

      $q.all(qPromises).then(function (data) {
        vm.getUserList();
      });

      //Retaining userFilter drop down value
      if ($sessionStorage.userFilter) {
        vm.userFilter = $sessionStorage.userFilter;
        var userFilterKeys = Object.keys(vm.userFilter);

        //Assigning vm.userFilter ids into Post Object for Listing
        var postVariable = "";
        angular.forEach(userFilterKeys, function (keyName, index) {
          if (keyName) {
            postVariable = keyName + "Id";
            if (vm.userFilter[keyName]) {
              vm.userFilterObj[postVariable] = vm.userFilter[keyName].id;
            }
          }
        });
      }

      vm.setUserType(); // Set isInternalUser in userFilterObject
    };

    //ADD INVESTIGATOR POPUP

    vm.openAddEditPopup = function (ev, id, flag) {
      vm.investigator = {};
      vm.investigator.comment = "";
      $scope.addInvestigatorForm = {};
      vm.popupTitleFlag = flag;
      vm.existFlag = false;
      vm.saveDisableFlag = false;
      vm.updateExistFlag = false;
      vm.updateDisableFlag = false;
      $mdDialog.show({
        targetEvent: ev,
        contentElement: "#" + id,

        //Added by senthil to set pristine while click ESC key in popup
        onRemoving: function (ev, removePromise) {
          $timeout(function () {
            angular.element("#cancelAddEditInvForm").triggerHandler("click");
          });
        },
        parent: angular.element(document.body)
      });
    };

    vm.initLanguage = function () {
      var data = BaseFactory.getLanguagesList();
      data.then(function (response) {
        vm.languagesVO = response;
      });
    };

    vm.clearLocation = function (searchKey, listValue) {
      vm[searchKey] = undefined;
      vm[listValue] = undefined;
    };

    vm.cancel = function (addInvestigatorForm) {
      addInvestigatorForm.$setPristine();
      vm.investigator = {};
      vm.investigator.emailAddress = "";
      $mdDialog.hide();
    };

    vm.saveInvestigator = function (investigator, addInvestigatorForm) {
      if (addInvestigatorForm.$valid && investigator) {
        vm.saveDisableFlag = true;
        if (investigator.country != null) {
          vm.investigatorObj.userCountryDTO.countryId = investigator.country.id;
          vm.investigatorObj.userCountryDTO.comment = investigator.comment;
        }

        angular.forEach(investigator.language, function (obj, index) {
          var lang = {};
          lang.languageId = obj.id;
          vm.investigatorObj.language.push(lang);
        });

        var phone = {};
        if (investigator.phoneNumber != null && investigator.phoneNumber != "") {
          phone.value = investigator.phoneNumber;
          phone.phoneType = vm.APP.USER.PHONETYPE;
          phone.phoneEntityType = vm.APP.USER.ENTITYTYPE;
        }

        vm.investigatorObj.phoneNumber.push(phone);

        vm.investigatorObj.firstName = investigator.firstName;
        vm.investigatorObj.lastName = investigator.lastName;
        if (investigator.emailAddress != null && investigator.emailAddress != "") {
          vm.investigatorObj.emailAddress = investigator.emailAddress;
        }

        var data = UserService.addInvestigator(vm.investigatorObj);
        data.then(
          function (response) {
            vm.cancel(addInvestigatorForm);
            $state.transitionTo($state.current, $stateParams, {
              reload: true,
              inherit: false,
              notify: true
            });
            notifications.showSuccess({ message: vm.APP.LIBRARY.USER_SAVE });
          },
          function (reason) {
            if (reason.status == 409) {
              vm.existFlag = true;
              vm.saveDisableFlag = false;
            } else {
              notifications.showError({ message: vm.APP.LIBRARY.USER_SAVE_PROBLEM });
            }
            $timeout(function () {
              vm.existFlag = false;
            }, 3000);
          }
        );
      }
    };

    vm.deleteEndlessDetails = function () {
      vm.userEndlessScrollRetain = {};
      delete $sessionStorage.userEndlessScrollRetain;
    };

      /**
       * Get the country admin details call 
       * @author Ganeshkumar.K
       */

      vm.getAdminDetails = function () {
        vm.getAllCountry();
        setTimeout(function () {
          vm.countryFilterIds = [];
          vm.countryAdminData = [];
          if (vm.countryFilter.length > 0) {
              vm.isFilterEnable = true;
              angular.forEach(vm.countryFilter, function (country, index) {
                vm.countryFilterIds.push(country.id);
              });
          }
          vm.adminLoader = true;
          vm.initialLoading = true;
          var data = UserService.getAdminDetails(vm.countryFilterIds, vm.countrySearchKey);
          data.then(function (response) {
                vm.countryAdminData = response;
                if (vm.savedList.length > 0) {
                    for (var i = 0; i < vm.countryAdminData.length; i++) {
                      for (var j = 0; j < vm.savedList.length; j++) {
                          if (vm.savedList[j].userId === vm.countryAdminData[i].userId) {
                            vm.countryAdminData.splice(i, 1);
                            vm.countryAdminData.push(vm.savedList[j]);
                          }
                      }
                    }
                }

                angular.forEach(vm.countryAdminData, function (adminData, index) {
                    if (adminData.selectedAll) {
                      adminData.country = '';
                      adminData.country = vm.allCountry;
                    }
                });
                angular.forEach(vm.countryAdminData, function (adminData, index) {
                    angular.forEach(adminData.country, function (selected, selectindex) {
                      angular.forEach(vm.allCountry, function (all, countryIndex) {
                          if (all.id == selected.id) {
                            adminData.country[selectindex] = all;
                          }
                          if (selected.name == 'No country') {
                            adminData.country = [];
                          }
                      });
                    });
                });
                if (vm.countryFilter.length == 0) {
                    vm.filterAllCountry = vm.allCountry;
                }
                vm.adminLoader = false;
              },
              function (error) {
                vm.adminLoader = false;
                vm.countryAdminData = [];
                notifications.showError({
                    message: vm.APP.LIBRARY.COUNTRY_ADMIN_GET_PROBLEM
                });

              }
          );
        }, 1000);
      };

      /**
      * Get the all prospect birth country details
      * @returns 
      */

      vm.getAllCountry = function () {
        var data = CommonService.getBirthCountry();
        data.then(function (response) {
          vm.allCountry = response;
        });
      };

      /**
      * Check if an item exists or not in the list.
      * @param {Array} item 
      * @param {Array} list 
      * @returns {boolean}
      */

      vm.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };

      /**
      * common Save call for countryAdmin Details
      */

      vm.saveCountryAdminDetails = function () {
        vm.isSaveCountryAdminDetails = false;
        if (vm.savedList.length > 0) {
          angular.forEach(vm.savedList, function (list, index) {
              list.updatedByUserEmail = vm.userEmail;
              if (list.startDate != null) {
                list.startDate = new Date(list.startDate);
              }
              if (list.endDate != null) {
                list.endDate = new Date(list.endDate);
              }

              if (list.country.length == vm.allCountry.length) {
                list.selectedAll = true;
                list.country = [];
              } else {
                list.selectedAll = false;
              }
          });
          vm.adminLoader = true;
          var data = UserService.saveAdminDetails(vm.savedList);
          data.then(function (response) {
              if (response) {
                notifications.showSuccess({
                    message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE
                });
                vm.savedList = [];
                vm.selectedAdminList = [];
                vm.clearSelectedList();
                vm.getAdminDetails();
                $mdDialog.hide();
              }
          }, function (reason) {
              vm.adminLoader = false;
              if (reason) {
                notifications.showError(
                  reason.data.body.message
                );
              }
          });
          vm.isSaveCountryAdminDetails = true;
          $sessionStorage.isSaveCountryAdminDetails = true;
        }
      };

      vm.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        } else {
          list.push(item);
        }
        if (list.length == 0) {
          vm.clearSelectedList();
        }
      };

      vm.toggleAll = function () {
        if (vm.selectedAdminList.length === vm.countryAdminData.length) {
          vm.selectedAdminList = [];
          vm.clearSelectedList();
        } else if (vm.selectedAdminList.length === 0 || vm.selectedAdminList.length > 0) {
          vm.selectedAdminList = vm.countryAdminData.slice(0);
        }
      };
      /**
      * method for filters selectall countries 
      */

      vm.selectAllCountries = function () {
        vm.countryFilter = [];
        if (!vm.allCountries) {
          angular.forEach(vm.filterAllCountry, function (item) {
              item.hidden = true;
          });
          $timeout(function () {
              angular.forEach(vm.filterAllCountry, function (item) {
                vm.countryFilter.push(item);
              });
              vm.regionsLoader = false;
          }, 0);

        } else {
          angular.forEach(vm.filterAllCountry, function (item) {
              item.hidden = false;
          });
          vm.regionsLoader = false;
        }
      };

      /**
      * show the dialog box when click a edit button in admins tab
      * @param {Event} $event 
      * @param {String} id 
      * @param {*} index 
      */

      vm.showDialog = function ($event, id, index) {
        if (!(angular.isUndefined(index))) {
          vm.dialogIndex = index;
        }
        $mdDialog.show({
          contentElement: '#' + id,
          parent: angular.element(document.body),
          targetEvent: $event,
          clickOutsideToClose: true
        });
      };
      /**
      * Close method for Dialog box
      * @author Ganeshkumar.K
      */

      vm.closeDialog = function () {
        if (vm.missingCountryDetails.length > 0) {
          angular.forEach(vm.missingCountryDetails, function (data, index) {
              var idx = vm.deletedItemList.indexOf(data);
              if (idx == -1) {
                vm.deletedItemList.push(data);
              }
          });
          $mdDialog.hide();
          vm.missingCountryDetails = [];
        } else {
          $mdDialog.hide();
        }
      };

      /**
      * 
      * @param {*} selectedList 
      * @param {*} overallData 
      * @param {*} type 
      * @return {Boolean}
      */
      vm.isChecked = function (selectedList, overallData, type) {
        if (selectedList != null && overallData != null) {
          if (type == 'country') {
              selectedList.selectedAll = (selectedList.country.length === overallData.length);
              return selectedList.length === overallData.length;
          } else if (type == 'overallSelect') {
              vm.selectedAll = (selectedList.length === overallData.length);
              return selectedList.length === overallData.length;
          } else {
              return selectedList.length === overallData.length;
          }
        }
      };
      /**
      * functionality for overall select
      */

      vm.setCountryForSelectedPlayer = function (type) {
        if (vm.selectedAdminList.length > 0) {
          if (type == 'country') {
              angular.forEach(vm.selectedAdminList, function (list, index) {
                angular.forEach(vm.countryAdminData, function (data, index) {
                    if (data.userId == list.userId) {
                      data.country = '';
                      data.country = vm.allCoutrySelect;
                      vm.changedAdminList(data);
                    }
                });
              });
          } else if (type == 'startDate') {
              angular.forEach(vm.selectedAdminList, function (list, index) {
                angular.forEach(vm.countryAdminData, function (data, countryindex) {
                    if (data.userId == list.userId && data.country.length > 0) {
                      data.startDate = vm.selectAllCountryStartDate;
                      vm.changedAdminList(data);
                    }
                });
              });

          } else if (type == 'endDate') {
              angular.forEach(vm.selectedAdminList, function (list, index) {
                angular.forEach(vm.countryAdminData, function (data, countryindex) {
                    if (data.userId == list.userId && data.startDate != null && data.country.length > 0) {
                      data.endDate = vm.selectAllCountryEndDate;
                      vm.changedAdminList(data);
                    }
                });
              });
          } else if (type == 'selectedAll') {
              if (!vm.selectedAll) {
                vm.allCoutrySelect = vm.allCountry;
                angular.forEach(vm.selectedAdminList, function (list, index) {
                    angular.forEach(vm.countryAdminData, function (data, countryindex) {
                      if (data.userId == list.userId) {
                          data.country = '';
                          data.country = vm.allCoutrySelect;
                          vm.changedAdminList(data);
                      }
                    });
                });

              } else {
                vm.allCoutrySelect = [];
                angular.forEach(vm.selectedAdminList, function (list, index) {
                    angular.forEach(vm.countryAdminData, function (data, countryindex) {
                      if (data.userId == list.userId) {
                          data.country = '';
                          data.country = vm.allCoutrySelect;
                          vm.changedAdminList(data);
                      }
                    });
                });
              }
          }
        }
      };

      /**
      * Get the minimum date based on each admin's start date.
      * @param {Date} startDate 
      * @since 25-11-2023
      * @author Ganeshkumar.k
      * 
      */

      vm.getMinDate = function (startDate) {
        vm.minDate = new Date(startDate);
      };

      /**
      * clear the overall selectedlist 
      */

      vm.clearSelectedList = function () {
        if (vm.selectedAdminList.length == 0) {
          vm.allCoutrySelect = [];
          vm.selectAllCountryStartDate = '';
          vm.selectAllCountryEndDate = '';
        }
      };
      /**
      * when user edit the country admin the details will saved in savedList
      * @param {*} countryDetails 
      * 
      */

      vm.changedAdminList = function (countryDetails) {
        vm.clearEndDateBasedOnStartDate(countryDetails);
        var idx = vm.savedList.indexOf(countryDetails);
        if (idx > -1) {
          vm.savedList.splice(idx, 1);
          vm.savedList.push(countryDetails);
        } else {
          vm.savedList.push(countryDetails);
        }
        var tmp = false;
        angular.forEach(vm.savedList, function (list, index) {
          if (list.country.length > 0 && angular.isUndefined(list.startDate)) {
              tmp = true;
          }
        });
        if ($sessionStorage.isSaveCountryAdminDetails) {
          delete $sessionStorage.isSaveCountryAdminDetails
          $sessionStorage.isSaveCountryAdminDetails = false;
        }
        vm.isSaveCountryAdminDetails = tmp;
      };

      /**
      * save the country admin details when list is changed 
      */

      vm.isChanged = function (country) {
        if (!vm.initialLoading) {
          vm.changedAdminList(country);
        }
      };
      /**
      * show the warning message to user when move to next tab without saving the country admin details
      * @param {Element} popupId 
      */

      vm.showWarning = function (popupId) {
        var event = this;
        $mdDialog.show({
          contentElement: angular.element('#' + popupId),
          targetEvent: event,
          clickOutsideToClose: false,
          escapeToClose: false
        });
      };

      /**
      * The function call when user select yes in the warning popup
      * 
      */


      vm.changeSection = function () {
        if ($sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
          StorageDelete.deleteUser();
        }
        if ($sessionStorage.futureState != null) {
          vm.futureState = $sessionStorage.futureState;
          $sessionStorage.userManagementActiveState = vm.futureState;
          $state.go(vm.futureState);
          if (vm.futureState == vm.APP.USER.INTERNAL) {
              vm.userTabIndex = 1;
          } else if (vm.futureState == vm.APP.USER.EXTERNAL) {
              vm.userTabIndex = 2;
          }
          vm.setUserType();
        }
      };

      vm.selectAllClick = function (country) {
        if (!country.selectedAll) {
          country.country = '';
          country.country = vm.allCountry;
          vm.changedAdminList(country);
        } else {
          country.country = [];
          vm.changedAdminList(country);
        }
      }
      /**
      * Set the placeholder for country Dropdown
      * @since 06-12-2023	 
      * @param {*} country 
      * @param {*} index 
      * @param {*} type 
      */

      vm.setCountryPlaceholder = function (country, index, type) {
        if (type == 'dialog') {
          if (!angular.isUndefined(country)) {
              if (country.length > 1) {
                var element = document.getElementById("dialogCountry-" + index);
                var header = (country.length == vm.allCountry.length ? "All Countries Selected" : "(" + country.length + ")" + ' ' + vm.APP.INVESTIGATION.COUNTRIES + ' ' + "selected");
                this.setHeaderContent(element, header);
              }
          }
        } else if (type == 'SelectAll') {
          if (!angular.isUndefined(country)) {
              if (country.length > 1) {
                var element = document.getElementById("OverSelectAll");
                var header = (country.length == vm.allCountry.length ? "All Countries Selected" : "(" + country.length + ")" + ' ' + vm.APP.INVESTIGATION.COUNTRIES + ' ' + "selected");
                this.setHeaderContent(element, header);
              }
          }
        } else if (type == 'DialogSelectAll') {
          if (!angular.isUndefined(country)) {
              if (country.length > 1) {
                var element = document.getElementById("dialogCountrySelectAll");
                var header = (country.length == vm.allCountry.length ? "All Countries Selected" : "(" + country.length + ")" + ' ' + vm.APP.INVESTIGATION.COUNTRIES + ' ' + "selected");
                this.setHeaderContent(element, header);
              }
          }
        } else if (type == 'sideFilter') {
          var element = document.getElementById("sideFilter");
          if (country.length == vm.allCountry.length) {
              var header = "All Countries Selected";
              this.setHeaderContent(element, header);
          }
        } else {
          if (!angular.isUndefined(country)) {
              if (country.length > 1) {
                var element = document.getElementById("counrtryDropdown-" + index);
                var header = (country.length == vm.allCountry.length ? "All Countries Selected" : "(" + country.length + ")" + ' ' + vm.APP.INVESTIGATION.COUNTRIES + ' ' + "selected");
                this.setHeaderContent(element, header);
              }
          }
        }
      };
      /**
      * Set the Headercontent based on element
      * @param {HTMLAnchorElement} element 
      * @param {String} header 
      */

      vm.setHeaderContent = function (element, header) {
        if (element != null) {
          var child1 = element.children[0];
          if (child1 != null) {
              var child2 = child1.children[0];
              if (child2 != null) {
                child2.innerHTML = header;
              }
          }
        }
      }


      /**
      * Clear the filter value 
      */

      vm.clear = function () {
        if (vm.isFilterEnable) {
          vm.countryFilter = [];
          vm.allCountries = false;
          vm.isFilterEnable = false;
          vm.getAdminDetails();
        } else if (vm.countryFilter.length > 0) {
          vm.countryFilter = [];
          vm.allCountries = false;
          vm.isFilterEnable = false;
          vm.getAdminDetails();

        }
      };

      /**
      * Individual save call for save the country Admin details
      */

      vm.individualSaveCountryDetails = function () {
        var tempList = [];
        if (vm.dialogIndex != null) {
          tempList.push(vm.countryAdminData[vm.dialogIndex]);
        }
        var idx = vm.savedList.indexOf(vm.countryAdminData[vm.dialogIndex]);
        if (idx > -1) {
          vm.savedList.splice(idx, 1);
        }
        if (tempList.length > 0) {
          angular.forEach(tempList, function (list, index) {
              list.updatedByUserEmail = vm.userEmail;
              if (list.startDate != null) {
                list.startDate = new Date(list.startDate);
              }
              if (list.endDate != null) {
                list.endDate = new Date(list.endDate);
              }

              if (list.country.length == vm.allCountry.length) {
                list.selectedAll = true;
                list.country = [];
              } else {
                list.selectedAll = false;
              }
          });
          vm.adminLoader = true;
          var data = UserService.saveAdminDetails(tempList);
          data.then(function (response) {
              if (response) {
                notifications.showSuccess({
                    message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE
                });
                vm.isSaveCountryAdminDetails = (vm.savedList.length == 0 ? true : false);
                $sessionStorage.isSaveCountryAdminDetails = vm.isSaveCountryAdminDetails;
                $mdDialog.hide();
                vm.selectedAdminList = [];
                vm.clearSelectedList();
                vm.getAdminDetails();

              }
          }, function (reason) {
              if (reason) {
                notifications.showError({
                    message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE_PROBLEM
                });
                vm.adminLoader = false;
                $mdDialog.hide();
                vm.isSaveCountryAdminDetails = (vm.savedList.length == 0 ? true : false);
                $sessionStorage.isSaveCountryAdminDetails = vm.isSaveCountryAdminDetails;
              }
          });
        }

      };

      /**
      * 
      * @param {*} index 
      * show the warning popup when country admin have active investigation
      */

      vm.checkInvestigationWarning = function (index) {
        vm.missingCountryDetails = [];
        if (index > -1) {
          var tempSelectedCountryDetails = [];
          angular.forEach(vm.countryAdminData[index].country, function (country, idx) {
              tempSelectedCountryDetails.push(country.id);
          });
          angular.forEach(vm.countryAdminData[index].assignCountry, function (assignCountry, cidx) {
              var idx = tempSelectedCountryDetails.indexOf(assignCountry.country.id);
              if (idx == -1) {
                vm.missingCountryDetails.push(assignCountry);
              }
          });
        }
        //overall 
        else {
          angular.forEach(vm.selectedAdminList, function (adminData, aidx) {
              var tempSelectedCountryDetails = [];
              angular.forEach(adminData.country, function (country, cidx) {
                tempSelectedCountryDetails.push(country.id);
              });

              angular.forEach(adminData.assignCountry, function (assignCountry, aidx) {
                var idx = tempSelectedCountryDetails.indexOf(assignCountry.country.id);
                if (idx == -1) {
                    vm.missingCountryDetails.push(assignCountry);
                }

              });

          });
        }
        if (vm.deletedItemList.length > 0) {
          for(var i=0;i<vm.missingCountryDetails.length;i++) {
              var idx = vm.deletedItemList.indexOf(data);
              if (idx > -1) {
                vm.missingCountryDetails.splice(index, 1);
              }

          }
        }

        if (vm.missingCountryDetails.length > 0) {
          vm.showWarning('warningPopupMsgForActiveInvestigation');
        }
      };

      /**
      * check the MandatoryField for individuals 
      * @param {Object} individualCountryAdminData 
      * @returns {Boolean}
      */
      vm.checkMandatoryFieldForIndividualCountryAdmin = function (individualCountryAdminData) {
        if (angular.isDefined(individualCountryAdminData)) {
          if (vm.savedList.indexOf(individualCountryAdminData) == -1) {
              return true;
          } else {
              return (individualCountryAdminData.country.length > 0 && angular.isUndefined(individualCountryAdminData.startDate) ? true : false);
          }
        }
      };

      /**
	 * Clear the endDate based on a start date
	 * @param {Object} countryData 
	 */

	vm.clearEndDateBasedOnStartDate= function(countryData){
		var stateDateTemp = new Date(countryData.startDate);
		var endDateTemp = new Date(countryData.endDate);
		if(angular.isDefined(countryData.country) && stateDateTemp > endDateTemp){
			countryData.endDate = '';
		}
	};

  };
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('CountryAdminController', CountryAdminController);

    CountryAdminController.$inject = ['$element', 'BaseFactory', 'APP', 'UserService', '$mdMedia', 'deviceDetector', '$sessionStorage', 'tabservice', '$q', '$state', '$scope', '$mdSidenav', 'StorageDelete', '$cookies', 'CommonService', '$mdDialog', '$location', '$timeout', '$stateParams', 'notifications'];
    function CountryAdminController($element, BaseFactory, APP, UserService, $mdMedia, deviceDetector, $sessionStorage, tabservice, $q, $state, $scope, $mdSidenav, StorageDelete, $cookies, CommonService, $mdDialog, $location, $timeout, $stateParams, notifications) {
        var vm = this;
        vm.allCountry = [];
        vm.showCountrydetails = [];
        vm.personSelectedCountry = [];
        vm.selectedAdminList = [];
        vm.savedList = [];
        vm.countryFilter = [];//side filter param
        vm.countrySearchKey = '';//overall SearchKey
        $scope.countryInsideSearch = '';
        vm.regionSearchKey = '';
        vm.allCountries = false;
        vm.deletedItemList = [];
        vm.missingCountryDetails = [];
        vm.allCoutrySelect = [];
        vm.userEndlessScrollRetain = {};
        vm.currentDate = new Date();
        vm.endDate = new Date();
        vm.selectAllCountryStartDate = new Date();
        vm.selectAllCountryStartDate = '';
        vm.selectAllCountryEndDate = new Date();
        vm.selectAllCountryEndDate = null;
        vm.futureState;
        vm.isSaveCountryAdminDetails = true;
        $sessionStorage.isSaveCountryAdminDetails = true;
        vm.isCountryChanged = false;
        vm.remainingCountryList = [];
        vm.isCountryIsSelected = false;
        vm.APP = APP;
        vm.isCountryFieldChanged = false;
        $scope.countrydetailsShowId = [];

        /**
         * Get the country admin details call 
         * @author Ganeshkumar.K
         */

        vm.getAdminDetails = function () {
            vm.getAllCountry();
            setTimeout(function () {
                vm.countryFilterIds = [];
                vm.countryAdminData = [];
                if (vm.countryFilter.length > 0) {
                    vm.isFilterEnable = true;
                    angular.forEach(vm.countryFilter, function (country, index) {
                        vm.countryFilterIds.push(country.id);
                    });
                }
                vm.adminLoader = true;
                vm.initialLoading = true;
                var data = UserService.getAdminDetails(vm.countryFilterIds, vm.countrySearchKey);
                data.then(function (response) {
                    vm.countryAdminData = response;
                    if (vm.savedList.length > 0) {
                        for (var i = 0; i < vm.countryAdminData.length; i++) {
                            for (var j = 0; j < vm.savedList.length; j++) {
                                if (vm.savedList[j].userId === vm.countryAdminData[i].userId) {
                                    vm.countryAdminData.splice(i, 1);
                                    vm.countryAdminData.push(vm.savedList[j]);
                                }
                            }
                        }
                    }
                    angular.forEach(vm.countryAdminData, function (adminData, index) {
                        angular.forEach(adminData.countryListDTO, function (list, listIndex) {
                            angular.forEach(vm.allCountry, function (all, countryIndex) {
                                if (all.id == list.country.id) {
                                    list.country = all;
                                }
                                if (list.country.name == 'No country') {
                                    list.country = {};
                                }
                            });
                        });
                    });

                    angular.copy(vm.allCountry, vm.remainingCountryList);
                    vm.isCountryIsSelected = false;
                    if (vm.countryFilter.length == 0) {
                        vm.filterAllCountry = vm.allCountry;
                    }
                    vm.adminLoader = false;
                },
                    function (error) {
                        vm.adminLoader = false;
                        vm.countryAdminData = [];
                        notifications.showError({
                            message: vm.APP.LIBRARY.COUNTRY_ADMIN_GET_PROBLEM
                        });

                    }
                );
            }, 1000);
        };

        /**
        * Get the all prospect birth country details
        * @returns 
        */

        vm.getAllCountry = function () {
            var data = CommonService.getBirthCountry();
            data.then(function (response) {
                vm.allCountry = response;
                vm.showCountrydetails = vm.allCountry;
            });
        };

        /**
         * Common save call for countryAdmin Details
         */
        vm.saveCountryAdminDetails = function () {
            vm.isSaveCountryAdminDetails = false;
            $scope.noCountry = null;
            if (vm.savedList.length > 0) {
                angular.forEach(vm.savedList, function (list, index) {
                    if (list.countryListDTO.length == 1 && list.countryListDTO[0].country.id == undefined) {
                        $scope.noCountry = list;
                    }
                    angular.forEach(list.countryListDTO, function (countryList, $countryIndex) {
                        if (countryList.startDate != null) {
                            var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;  
                            var zone =  timeZone.substring(0, 7)
                            if(zone == 'America') {     
                            var date = new Date(countryList.startDate + "T20:00:00Z");
                                if(date != 'Invalid Date'){
                                countryList.startDate = date;
                                }else{
                                countryList.startDate = new Date(countryList.startDate);
                                }
                            }else{
                            countryList.startDate = new Date(countryList.startDate);
                            }
                        }
                        if (countryList.endDate != null) {
                            countryList.endDate = new Date(countryList.endDate);
                        }
                        if (countryList.country.id == undefined) {
                            vm.savedList[index].countryListDTO.splice($countryIndex, 1);
                        }
                    });
                });
                // vm.adminLoader = true;
                var data = UserService.saveAdminDetails(vm.savedList);
                data.then(function (response) {
                    if (response) {
                        notifications.showSuccess({ message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE });
                        vm.savedList = [];
                        vm.selectedAdminList = [];
                        vm.clearSelectedList();
                        // vm.getAdminDetails();
                        $mdDialog.hide();
                        if ($scope.noCountry != null) {
                            vm.addOrRemoveCountry($scope.noCountry, null, true)
                        }
                    }
                }, function (reason) {
                    vm.adminLoader = false;
                    if (reason) {
                        notifications.showError({ message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE_PROBLEM });
                    }
                }
                );
                vm.isSaveCountryAdminDetails = true;
                $sessionStorage.isSaveCountryAdminDetails = true;
            }
        };

        /**
         * method for filters selectall countries 
         */

        vm.selectAllCountries = function () {
            vm.countryFilter = [];
            if (!vm.allCountries) {
                angular.forEach(vm.filterAllCountry, function (item) {
                    item.hidden = true;
                });
                $timeout(function () {
                    angular.forEach(vm.filterAllCountry, function (item) {
                        vm.countryFilter.push(item);
                    });
                    vm.regionsLoader = false;
                }, 0);

            } else {
                angular.forEach(vm.filterAllCountry, function (item) {
                    item.hidden = false;
                });
                vm.regionsLoader = false;
            }
        };

        /**
         * show the dialog box when click a edit button in admins tab
         * @param {Event} $event 
         * @param {String} id 
         * @param {*} index 
         */

        vm.showDialog = function ($event, id, index) {
            if (!(angular.isUndefined(index))) {
                vm.dialogIndex = index;
            }
            $mdDialog.show({
                contentElement: '#' + id,
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };
        /**
         * Close method for Dialog box
         * @author Ganeshkumar.K
         */

        vm.closeDialog = function () {
            if (vm.missingCountryDetails.length > 0) {
                angular.forEach(vm.missingCountryDetails, function (data, index) {
                    var idx = vm.deletedItemList.indexOf(data);
                    if (idx == -1) {
                        vm.deletedItemList.push(data);
                    }
                });
                if (!vm.isSaveButtonEnable()) {
                    vm.saveCountryAdminDetails();
                }
                vm.missingCountryDetails = [];
                $mdDialog.hide();
            }
            else {
                $mdDialog.hide();
            }
        };


        /**
         * Get the minimum date based on each admin's start date.
         * @param {Date} startDate 
         * @since 25-11-2023
         * @author Ganeshkumar.K
         * 
         */

        vm.getMinDate = function (startDate) {
            vm.minDate = new Date(startDate);
        };

        /**
         * clear the overall selectedlist 
         */

        vm.clearSelectedList = function () {
            if (vm.selectedAdminList.length == 0) {
                vm.allCoutrySelect = [];
                vm.selectAllCountryStartDate = '';
                vm.selectAllCountryEndDate = null;
            }
        };
        /**
         * when user edit the country admin the details will saved in savedList
         * @param {*} countryDetails 
         * 
         */

        vm.changedAdminList = function (countryDetails, individualCountryDetails) {
            if (vm.isCountryChanged) {
                vm.changeStartDateIntoCurrentDate(countryDetails, individualCountryDetails);
            }
            //vm.clearEndDateBasedOnStartDate(countryDetails, individualCountryDetails);
            var idx = vm.savedList.indexOf(countryDetails);
            if (idx > -1) {
                vm.savedList.splice(idx, 1);
                vm.savedList.push(countryDetails);
            }
            else {
                vm.savedList.push(countryDetails);
            }
            if (vm.missingCountryDetails.length > 0) {
                vm.showWarning('warningPopupMsgForActiveInvestigation');
            }
            else if (!vm.isSaveButtonEnable()) {
                vm.saveCountryAdminDetails();
            }
        };

        vm.stateInternalDetails = function () {
            // The manager edit the country admin at time we call the warning popup functionality
            if (!($sessionStorage.isSaveCountryAdminDetails) && $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
                vm.futureState = vm.APP.USER.INTERNAL;
                vm.showWarning('warningPopupMsg');
            }
            else {
                if ($sessionStorage.userManagementActiveState == vm.APP.USER.EXTERNAL || $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
                    StorageDelete.deleteUser();
                }
                $sessionStorage.userManagementActiveState = vm.APP.USER.INTERNAL;
                vm.userTabIndex = 1;
                $state.go(vm.APP.USER.INTERNAL);
            }
            $sessionStorage.futureState = vm.APP.USER.INTERNAL;

        };

        vm.stateExternalDetails = function () {
            if (!($sessionStorage.isSaveCountryAdminDetails) && $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
                vm.futureState = vm.APP.USER.EXTERNAL;
                vm.showWarning('warningPopupMsg');
            }
            else {
                if ($sessionStorage.userManagementActiveState == vm.APP.USER.INTERNAL || $sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
                    StorageDelete.deleteUser();
                }
                $sessionStorage.userManagementActiveState = vm.APP.USER.EXTERNAL;
                vm.userTabIndex = 2;
                $state.go(vm.APP.USER.EXTERNAL);

            }
            $sessionStorage.futureState = vm.APP.USER.EXTERNAL;
        };

        /**
         * save the country admin details when list is changed 
         */

        vm.isChanged = function (countryData, country) {
            if (!vm.initialLoading && vm.isCountryFieldChanged) {
                vm.isCountryChanged = true;
                vm.changedAdminList(countryData, country)
                vm.isCountryFieldChanged = false;
            }
        };
        /**
         * show the warning message to user when move to next tab without saving the country admin details
         * @param {Element} popupId 
         */

        vm.showWarning = function (popupId) {
            var event = this;
            $mdDialog.show({
                contentElement: angular.element('#' + popupId),
                targetEvent: event,
                clickOutsideToClose: false,
                escapeToClose: false
            });
        };

        /**
         * The function call when user select yes in the warning popup
         * 
         */


        vm.changeSection = function () {
            if ($sessionStorage.userManagementActiveState == vm.APP.USER.ADMIN) {
                StorageDelete.deleteUser();
            }
            if ($sessionStorage.futureState != null) {
                vm.futureState = $sessionStorage.futureState;
                $sessionStorage.userManagementActiveState = vm.futureState;
                $state.go(vm.futureState);
                if (vm.futureState == vm.APP.USER.INTERNAL) {
                    vm.userTabIndex = 1;
                }
                else if (vm.futureState == vm.APP.USER.EXTERNAL) {
                    vm.userTabIndex = 2;
                }
                vm.setUserType();
            }
        };

        /**
        * Set the placeholder for country Dropdown
        * @since 06-12-2023	 
        * @param {*} country 
        * @param {*} index 
        * @param {*} type 
        */

        vm.setCountryPlaceholder = function (country, index, type) {
            if (type == 'sideFilter') {
                var element = document.getElementById("sideFilter");
                if (country.length == vm.allCountry.length) {
                    var header = "All Countries Selected";
                    this.setHeaderContent(element, header);
                }
            }
        };
        /**
         * Set the Headercontent based on element
         * @param {HTMLAnchorElement} element 
         * @param {String} header 
         */

        vm.setHeaderContent = function (element, header) {
            if (element != null) {
                var child1 = element.children[0];
                if (child1 != null) {
                    var child2 = child1.children[0];
                    if (child2 != null) {
                        child2.innerHTML = header;
                    }
                }
            }
        }

        /**
         * @since 15-09-2024
         * @author Ganeshkumar.K
         * 
         */
        vm.addOrRemoveCountry = function (countryList, removedCountry, isCountryAdded, parentIndex, index) {
            if (isCountryAdded) {
                var countryModel = {
                    "country": {},
                    "startDate": null,
                    "endDate": null,
                    "deleted": false
                };
                countryList.countryListDTO.push(countryModel);
            }
            else {
                var countryIdx = countryList.countryListDTO.indexOf(removedCountry);
                if (countryIdx > -1) {
                    countryList.countryListDTO.splice(countryIdx, 1);
                }

                if (countryList.countryListDTO.length == 0) {
                    var countryModel = {
                        "country": {},
                        "startDate": null,
                        "endDate": null,
                        "deleted": false
                    };
                    countryList.countryListDTO.push(countryModel);
                }

                var idx = vm.savedList.indexOf(countryList);
                if (idx > -1) {
                    vm.savedList.splice(idx, 1);
                    vm.savedList.push(countryList);
                }
                else {
                    vm.savedList.push(countryList);
                }

                vm.checkInvestigationWarning(parentIndex, index);


                if (vm.missingCountryDetails.length > 0) {
                    vm.showWarning('warningPopupMsgForActiveInvestigation');
                } else if (!vm.isSaveButtonEnable()) {
                    vm.saveCountryAdminDetails();
                }
            }
        }

        /**
         * Clear the filter value 
         */

        vm.clear = function () {
            if (vm.isFilterEnable) {
                vm.countryFilter = [];
                vm.allCountries = false;
                vm.isFilterEnable = false;
                vm.getAdminDetails();
            }
            else if (vm.countryFilter.length > 0) {
                vm.countryFilter = [];
                vm.allCountries = false;
                vm.isFilterEnable = false;
                vm.getAdminDetails();
            }
            vm.regionSearchKey = '';
        };

        vm.getRemainingCountryList = function (country) {
            vm.remainingCountryList = angular.copy(vm.allCountry);
            vm.isCountryIsSelected = true;
            angular.forEach(country.countryListDTO, function (list, listIndex) {
                angular.forEach(vm.remainingCountryList, function (remainingCountryList, countryIndex) {
                    if (remainingCountryList.id == list.country.id) {
                        remainingCountryList.isDisabled = true;
                    }
                });
            });
        }

        vm.resetRemainingList = function () {
            vm.remainingCountryList = angular.copy(vm.allCountry);
            vm.isCountryIsSelected = false;
        }

        /**
        * Individual save call for save the country Admin details
        */

        vm.individualSaveCountryDetails = function () {
            var tempList = [];
            if (vm.dialogIndex != null) {
                tempList.push(vm.countryAdminData[vm.dialogIndex]);
            }
            var idx = vm.savedList.indexOf(vm.countryAdminData[vm.dialogIndex]);
            if (idx > -1) {
                vm.savedList.splice(idx, 1);
            }
            if (tempList.length > 0) {
                angular.forEach(tempList, function (list, index) {
                    if (list.startDate != null) {
                        list.startDate = new Date(list.startDate);
                    }
                    if (list.endDate != null) {
                        list.endDate = new Date(list.endDate);
                    }

                    if (list.country.length == vm.allCountry.length) {
                        list.selectedAll = true;
                        list.country = [];
                    }
                    else {
                        list.selectedAll = false;
                    }
                });
                vm.adminLoader = true;
                var data = UserService.saveAdminDetails(tempList);
                data.then(function (response) {
                    if (response) {
                        notifications.showSuccess({ message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE });
                        vm.isSaveCountryAdminDetails = (vm.savedList.length == 0 ? true : false);
                        $sessionStorage.isSaveCountryAdminDetails = vm.isSaveCountryAdminDetails;
                        $mdDialog.hide();
                        vm.selectedAdminList = [];
                        vm.clearSelectedList();
                        vm.getAdminDetails();

                    }
                }, function (reason) {
                    if (reason) {
                        notifications.showError({ message: vm.APP.LIBRARY.COUNTRY_ADMIN_SAVE_PROBLEM });
                        vm.adminLoader = false;
                        $mdDialog.hide();
                        vm.isSaveCountryAdminDetails = (vm.savedList.length == 0 ? true : false);
                        $sessionStorage.isSaveCountryAdminDetails = vm.isSaveCountryAdminDetails;
                    }
                }
                );
            }

        };

        /**
        * 
        * @param {*} index 
        * show the warning popup when country admin have active investigation
        */

        vm.checkInvestigationWarning = function (listIndex, countryIndex) {
            vm.missingCountryDetails = [];
            if (countryIndex > -1) {
                var tempSelectedCountryDetails = [];
                angular.forEach(vm.countryAdminData[listIndex].countryListDTO, function (country, idx) {
                    tempSelectedCountryDetails.push(country.country.id);
                });
                angular.forEach(vm.countryAdminData[listIndex].assignCountry, function (assignCountry, cidx) {
                    var idx = tempSelectedCountryDetails.indexOf(assignCountry.country.id);
                    if (idx == -1) {
                        vm.missingCountryDetails.push(assignCountry);
                    }
                });
            }
            if (vm.deletedItemList.length > 0) {
                angular.forEach(vm.missingCountryDetails, function (data, index) {
                    var idx = vm.deletedItemList.indexOf(data);
                    if (idx > -1) {
                        vm.missingCountryDetails.splice(idx, 1);
                    }
                });
            }
            if (vm.missingCountryDetails.length > 0) {
                vm.showWarning('warningPopupMsgForActiveInvestigation');
            }
        }


        /**
        * check the MandatoryField for individuals 
        * @param {Object} individualCountryAdminData 
        * @returns {Boolean}
        */
        vm.checkMandatoryFieldForIndividualCountryAdmin = function (individualCountryAdminData) {
            if (angular.isDefined(individualCountryAdminData)) {
                if (vm.savedList.indexOf(individualCountryAdminData) == -1) {
                    return true;
                }
                else {
                    return (individualCountryAdminData.country.length > 0 && angular.isUndefined(individualCountryAdminData.startDate) ? true : false);
                }
            }
        };
        /**
        * Clear the endDate based on a start date
        * @param {Object} countryData 
        */

        vm.clearEndDateBasedOnStartDate = function (countryData, individualCountryDetails) {
            var stateDateTemp = new Date(individualCountryDetails.startDate);
            var endDateTemp = new Date(individualCountryDetails.endDate);
            if (angular.isDefined(individualCountryDetails.country) && stateDateTemp > endDateTemp) {
                individualCountryDetails.endDate = null;
            }
        };

        vm.isSaveButtonEnable = function () {
            var tmp = false;
            angular.forEach(vm.savedList, function (list, index) {
                angular.forEach(list.countryListDTO, function (countryList, $countryIndex) {
                    if (!angular.isObject(countryList.country) || (countryList.country != null && angular.isUndefined(countryList.startDate))) {
                        tmp = true;
                    }
                });
            });
            if ($sessionStorage.isSaveCountryAdminDetails) {
                delete $sessionStorage.isSaveCountryAdminDetails
                $sessionStorage.isSaveCountryAdminDetails = false;
            }
            vm.isSaveCountryAdminDetails = tmp;

            return vm.isSaveCountryAdminDetails;
        }



        vm.checkMandatoryField = function (countryData) {

        }
        /**
        * Change the start date into a current date
        */
        vm.changeStartDateIntoCurrentDate = function (countryDetails, individualCountryDetails) {
            var currentDate = new Date();
            individualCountryDetails.startDate = currentDate;
            vm.isCountryChanged = false;
        };

        vm.isDisabled = function (countryObj, countryList) {
            return countryObj.country.name == null || countryObj.startDate == null || vm.allCountry.length <= countryList.countryListDTO.length;
        };


        vm.countryAdminDetailsShow = function (show, icon, country) {
            if (show == "countryDetails") {
                if (icon) {
                    country.detailsShow = true;
                    $scope.countrydetailsShowId.push(country.userId);
                } else {
                    country.detailsShow = false;
                    let index = $scope.countrydetailsShowId.indexOf(country.userId);
                    $scope.countrydetailsShowId.splice(index, 1);
                }
            }
        };

        vm.addIndex = function (show, index, country) {
            show = show + 1;
        };

        vm.isChecked = function (selectedList, overallData, type) {
            if (selectedList != null && overallData != null) {
              if (type == 'country') {
                  selectedList.selectedAll = (selectedList.country.length === overallData.length);
                  return selectedList.length === overallData.length;
              } else if (type == 'overallSelect') {
                  vm.selectedAll = (selectedList.length === overallData.length);
                  return selectedList.length === overallData.length;
              } else {
                  return selectedList.length === overallData.length;
              }
            }
        };

    };
})();
(function () {
  "use strict";

  angular.module("lariAidApp").service("UserService", UserService);

  UserService.$inject = ["restService", "$q"];

  function UserService(restService, $q) {
    this.getRoleUser = function (userFilterObj) {
      var deferred = $q.defer();
      var url = "users/role/count";
      var data = restService.restCall(userFilterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getInvestigationCases = function (userFilterObj) {
      var deferred = $q.defer();
      var url = "users/cases/count";
      var data = restService.restCall(userFilterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getUserList = function (userFilterObj) {
      var deferred = $q.defer();
      var url = "users/list";
      var data = restService.restCall(userFilterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.addInvestigator = function (investigatorObj) {
      var deferred = $q.defer();
      var url = "createInvestigator";
      var data = restService.restCall(investigatorObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.updateInvestigator = function (investigatorObj) {
      var deferred = $q.defer();
      var url = "updateInvestigator";
      var data = restService.restCall(investigatorObj, url, "PUT");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.getAdminDetails = function (countryFilter, searchKey) {
      var deferred = $q.defer();
      var url = "countryAdmin/getCountryAdminDetails";
      url += "?countryFilter=" + countryFilter + "&searchKey=" + searchKey;
      var data = restService.restCall("", url, 'GETLIST');
      data.$promise.then(function (response) {
            deferred.resolve(response);
         },
         function (error) {
            deferred.reject('ERROR');
         });
      return deferred.promise;
   };
   
   this.saveAdminDetails = function (savedList) {
      var deferred = $q.defer();
      var url = "countryAdmin/saveOrUpdateCountryVisibility"
      var data = restService.restCall(savedList, url, 'POST');
      data.$promise.then(function (response) {
            deferred.resolve(response);
         },
         function (error) {
            deferred.reject(error);
         });
      return deferred.promise;
   };
   
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','APP','$mdAriaProvider','$mdDateLocaleProvider'];

    function stateConfig($stateProvider,APP,$mdAriaProvider,$mdDateLocaleProvider) {
    		
    	
        	$stateProvider.state('users', {
            parent: 'app',
            url: '/users',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            views: {
                'dynamicView': {
                    templateUrl: 'app/user/user.management.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                /*mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#internalUser').triggerHandler('click');
                	  });
                }],*/
                'redirect' : ['Principal', '$state', '$timeout', function(Principal, $state, $timeout){
       	    		$timeout(function(){
       	    			if(Principal.isAuthenticated()) {
       		    			return true;
       		    		} else {
       		    			$state.go('login');
       		    			return false;
       		    		}
       	    		}, 700)
       	    	 }]
            }
        });
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('password.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('password.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('activate.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('activate.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('register.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('register.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('settings.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('settings.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('sessions.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('sessions.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('audits.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('audits.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('configuration.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('configuration.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN','LARI_MANAGER'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular.module('lariAidApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('health.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('health.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("LogsController", LogsController);

  LogsController.$inject = ["LogsService"];

  function LogsController(LogsService) {
    var vm = this;

    vm.changeLevel = changeLevel;
    vm.loggers = LogsService.findAll();

    function changeLevel(name, level) {
      LogsService.changeLevel({ name: name, level: level }, function () {
        vm.loggers = LogsService.findAll();
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("LogsService", LogsService);

  LogsService.$inject = ["$resource"];

  function LogsService($resource) {
    var service = $resource(
      "management/logs",
      {},
      {
        findAll: { method: "GET", isArray: true },
        changeLevel: { method: "PUT" }
      }
    );

    return service;
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").config(stateConfig);

  stateConfig.$inject = ["$stateProvider"];

  function stateConfig($stateProvider) {
    $stateProvider.state("logs", {
      parent: "admin",
      url: "/logs",
      data: {
        authorities: ["ROLE_ADMIN"],
        pageTitle: "logs.title"
      },
      views: {
        "content@": {
          templateUrl: "app/admin/logs/logs.html",
          controller: "LogsController",
          controllerAs: "vm"
        }
      },
      resolve: {
        translatePartialLoader: [
          "$translate",
          "$translatePartialLoader",
          function ($translate, $translatePartialLoader) {
            if (localStorage && localStorage.getItem("lari_currentVersion") != null) {
              $translatePartialLoader.addPart("logs.json?version=" + localStorage.getItem("lari_currentVersion"));
            } else {
              $translatePartialLoader.addPart("logs.json?timestamp=" + new Date().getTime());
            }
            return $translate.refresh();
          }
        ]
      }
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('metrics.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('metrics.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("stateHandler", stateHandler);

  stateHandler.$inject = [
    "$rootScope",
    "$translate",
    "JhiLanguageService",
    "translationHandler",
    "$window",
    "VERSION",
    "$translatePartialLoader",
    "$localStorage"
  ];

  function stateHandler(
    $rootScope,
    $translate,
    JhiLanguageService,
    translationHandler,
    $window,
    VERSION,
    $translatePartialLoader,
    $localStorage
  ) {
    function initialize() {
      $rootScope.VERSION = VERSION;

      var stateChangeStart = $rootScope.$on("$stateChangeStart", function (event, toState, toStateParams, fromState) {
        $rootScope.unauthorized = {};
        $rootScope.unauthorized.isUnauthorized = false;
        $rootScope.toState = toState;
        $rootScope.toStateParams = toStateParams;
        $rootScope.fromState = fromState;
        $localStorage.lari_currentVersion = VERSION;

        //Reload page if the appversion miss match
        var currentVersion = $localStorage.lari_currentVersion;
        var appVersion = $localStorage.lari_appVersion;
        if (currentVersion && appVersion != currentVersion) {
          $localStorage.lari_appVersion = $localStorage.lari_currentVersion;
          setTimeout(function () {
            location.reload(true);
            window.location.href = window.location.href;
          });
        }
        // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
        if (toState.external) {
          event.preventDefault();
          $window.open(toState.url, "_self");
        }

        if (localStorage && localStorage.getItem("lari_currentVersion") != null) {
          $translatePartialLoader.addPart("login.json?version=" + localStorage.getItem("lari_currentVersion"));
        } else {
          $translatePartialLoader.addPart("login.json?timestamp=" + new Date().getTime());
        }

        // Update the language
        JhiLanguageService.getCurrent().then(function (language) {
          $translate.use(language);
        });
      });

      var stateChangeSuccess = $rootScope.$on(
        "$stateChangeSuccess",
        function (event, toState, toParams, fromState, fromParams) {
          var titleKey = "global.title";
          $rootScope.fromStateParams = fromParams;
          // Set the page title key to the one configured in state or use default one
          if (toState.data.pageTitle) {
            titleKey = toState.data.pageTitle;
          }
          translationHandler.updateTitle(titleKey);
        }
      );

      $rootScope.$on("$destroy", function () {
        if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
          stateChangeStart();
        }
        if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
          stateChangeSuccess();
        }
      });
    }

    return { initialize };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user-management.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user-management.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user-management.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user-management.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").config(httpConfig);

  httpConfig.$inject = [
    "$urlRouterProvider",
    "$httpProvider",
    "httpRequestInterceptorCacheBusterProvider",
    "$urlMatcherFactoryProvider"
  ];

  function httpConfig(
    $urlRouterProvider,
    $httpProvider,
    httpRequestInterceptorCacheBusterProvider,
    $urlMatcherFactoryProvider
  ) {
    //Cache everything except rest api requests
    httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

    $urlRouterProvider.otherwise("/");

    $httpProvider.interceptors.push("errorHandlerInterceptor");
    $httpProvider.interceptors.push('authInterceptor');
    $httpProvider.interceptors.push('authExpiredInterceptor');
    $httpProvider.interceptors.push("notificationInterceptor");
    // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

    $urlMatcherFactoryProvider.type("boolean", {
      name: "boolean",
      decode: function (val) {
        return val === true || val === "true";
      },
      encode: function (val) {
        return val ? 1 : 0;
      },
      equals: function (a, b) {
        return this.is(a) && a === b;
      },
      is: function (val) {
        return [true, false, 0, 1].indexOf(val) >= 0;
      },
      pattern: /bool|true|0|1/
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('');
        $sessionStorageProvider.setKeyPrefix('');
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}'
        });
  
        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("authExpiredInterceptor", authExpiredInterceptor);

  authExpiredInterceptor.$inject = ["$q", "$injector", "$localStorage", "$sessionStorage"];

  function authExpiredInterceptor($q, $injector, $localStorage, $sessionStorage) {
    function responseError(response) {
      if (response.status === 401) {
        delete $localStorage.authenticationToken;
        delete $sessionStorage.authenticationToken;
        var Principal = $injector.get("Principal");
        if (Principal.isAuthenticated()) {
          var Auth = $injector.get("Auth");
          Auth.authorize(true);
        }
      }

      return $q.reject(response);
    }

    return { responseError };
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("authInterceptor", authInterceptor);

  authInterceptor.$inject = ["$localStorage", "$sessionStorage", '$injector'];

  function authInterceptor($localStorage, $sessionStorage, $injector) {
    function request(config) {
      // ignore if the url is NOT an API endpoint
      if (!/^https?/i.test(config.url)) {
        return config;
      }

      /*jshint camelcase: false */
      config.headers = config.headers || {};
      var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      } else {
        if (config.url.includes('/api/') && (config.url.includes('investigation') || config.url.includes('form') || config.url.includes('comment') || config.url.includes('user') ||
          config.url.includes('section') || config.url.includes('location') || config.url.includes('entity') || config.url.includes('request'))) {
          var Auth = $injector.get('Auth');
          Auth.logout(true, true);
        }
      }
      return config;
    }

    return { request };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('lariAidApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("notificationInterceptor", notificationInterceptor);

  notificationInterceptor.$inject = ["$q", "AlertService", "$localStorage", "VERSION"];

  function notificationInterceptor($q, AlertService, $localStorage, VERSION) {
    var service = {
      response: response
    };

    return service;

    function response(response) {
      $localStorage.lari_currentVersion = VERSION;

      //Reload page if the appversion miss match - For initial login page reload
      var currentVersion = $localStorage.lari_currentVersion;
      var appVersion = $localStorage.lari_appVersion;
      if (currentVersion && appVersion != currentVersion) {
        $localStorage.lari_appVersion = $localStorage.lari_currentVersion;
        setTimeout(function () {
          location.reload(true);
          window.location.href = window.location.href;
        });
      }

      var headers = Object.keys(response.headers())
        .filter(function (header) {
          return header.endsWith("app-alert") || header.endsWith("app-params");
        })
        .sort();
      var alertKey = response.headers(headers[0]);
      if (angular.isString(alertKey)) {
        AlertService.success(alertKey, { param: response.headers(headers[1]) });
      }
      return response;
    }
  }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('lariAidApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('lariAidApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.endsWith('app-error') || header.endsWith('app-params')
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('lariAidApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('lariAidApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

angular
    .module('lariAidApp').directive("autoFocus", function(){
    	return {
    		restrict:"A",
    		link: function(scope, element, attributes){
    			$(element).trigger("focus");
    		}
    	}
    });
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('commentDateFormat', commentDateFormat);
    lariDevApp.filter("link",linkFunction);
    
    commentDateFormat.$inject = ['dateFilter','$filter'];
    function commentDateFormat(dateFilter,$filter){
    	return {
    	    scope: {
    	        format: "@",
    	    	modval: "="
    	    },
    	    link: function(scope, element, attrs) {
    	    	if(scope.modval){
    	    		var dateVal = new Date(scope.modval);
    	    		dateVal = $filter('date')(dateVal, "MMM d, y h:mm:ss a");
        	    	scope.modval = dateVal;
    	    	}
    	    }
    	}
    };
    
    linkFunction.$inject = ['$filter'];
    function linkFunction($filter){
    	return function(input){
    		if(input){
	    		var joinComment ="";
	        	var strings=input;
	        	var re = new RegExp("(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})");
	        	var commentArray = strings.split(' ');
	
	        	for(var num=0;commentArray[num]!=null; num++){
	            	if (re.test(commentArray[num])) {var test = commentArray[num];
	            		commentArray[num] ="<a target='_blank' href='"+commentArray[num]+"'>"+commentArray[num]+"</a>";
	            	}
	        	}
	        	for(var num=0;commentArray[num]!=null; num++){
	            	joinComment +=commentArray[num]+' '; 
	        	}
	        	return joinComment;
    		}
    	}
    }
    
})();
angular
	.module('lariAidApp').directive("dpBlurFormat",['$filter',function($filter){
	   return {
		    	restrict:"A",
		    	require: "ngModel", 
		    	link: function(scope, element, attributes, ngModel){
			    	$(element).find('input').on('blur', function(){
					   var viewValue = ngModel.$viewValue;
					    	if(viewValue){
					    	var updatedViewValue = $filter('date')(viewValue,'MMM dd, yyyy');
					    	//ngModel.$setViewValue(updatedViewValue);
					    	$(this).val(updatedViewValue);
				    	}
			    	});
			   }
	   }
}]);
(function(){
	'use strict';

	angular.module('lariAidApp').directive('validateEmail', emailValidation);
	
	function emailValidation(){
		/*var EMAIL_REGEXP = /^[A-Za-z0-9_-]+(\.[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,4})$/;*/
		var EMAIL_REGEXP = /^[A-Za-z\u00C0-\u017F0-9_-]+(\.[A-Za-z\u00C0-\u017F0-9]+)*@[A-Za-z\u00C0-\u017F0-9-]+(\.[A-Za-z\u00C0-\u017F0-9-]+)*(\.[A-Za-z\u00C0-\u017F]{2,4})$/;

		return {
		    require: 'ngModel',
		    restrict: 'A',
		    link: function(scope, elm, attrs, ctrl) {
		      // only apply the validator if ngModel is present and Angular has added the email validator
		      if (ctrl && ctrl.$validators.email) {
	
		        // this will overwrite the default Angular email validator
		        ctrl.$validators.email = function(modelValue) {
		          return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
		        };
		      }
		    }
		  };
	}
	
})();
(function() {
	'use strict';

	angular.module('lariAidApp').directive('focus', focus);
	//resize.inject['$window'];
	
	function focus() {
			  return {
			    restrict: 'A',
			    require: ['^^mdSelect', '^ngModel'],
			    link: function(scope, element, controller) {
			      scope.$watch(function () {
			        var foundElement = element;
			        while (!foundElement.hasClass('md-select-menu-container')) {
			          foundElement = foundElement.parent();
			        }
			        return foundElement.hasClass('md-active');
			      	}, function (newVal) {
				        if (newVal) {
				            element.focus();
				        }
			      	});
			    }
			  }
	}
})();
/*
Angular Scroll Repeat v0.0.3 by @kstam
Copyright (c) 2014

Full source at https://github.com/kstam/ng-scroll-repeat

MIT License, https://github.com/kstam/ng-scroll-repeat/blob/master/LICENSE
*/
angular.module('ks.ngScrollRepeat', ['ks.WindowService'])
    .directive('ngScrollRepeat', ['$compile', 'WindowService','$rootScope', function ($compile, windowService,$rootScope) {
        'use strict';

        var DEFAULT_PAGE_SIZE = 50;
        var DEFAULT_TOLERANCE = 200;
        var BOTTOM_REACHED_BEFORE_EVT = 'bottom-reached-before';
        var BOTTOM_REACHED_AFTER_EVT = 'bottom-reached-after';

        var safeApply = function(scope, fn) {
            if (scope.$$phase || scope.$root.$$phase) {
                fn();
            } else {
                scope.$apply(fn);
            }
        };

        var verifyRepeatExpression = function (repeatExpression) {
            if (repeatExpression.match(/limitTo/) || repeatExpression.match(/startFrom/)) {
                throw new Error('"limitTo" and "startFrom" filters are not allowed in scroll-repeat directive');
            }
        };

        var calculateScrollBottomDiff = function (element) {
            var browserBottom = windowService.height();
            var elementBottom = element.offset().top - windowService.scrollTop() + element.height();
            return elementBottom - browserBottom;
        };

        var compile = function (tElement, tAttributes) {
            var repeatExpression = tAttributes.ngScrollRepeat;
            var match = repeatExpression.match(/^\s*(.+)\s+in\s+(.*?)\s*(\s+track\s+by\s+(.+)\s*)?$/);
            var collectionString = match[2];
            var pageSize = (tAttributes.pageSize) ? Number(tAttributes.pageSize) : DEFAULT_PAGE_SIZE;
            var tolerance = (tAttributes.tolerance) ? Number(tAttributes.tolerance) : DEFAULT_TOLERANCE;

            verifyRepeatExpression(repeatExpression);
            tElement.removeAttr('ng-scroll-repeat');
            tElement.attr('ng-repeat', repeatExpression + " | limitTo:visibleResults");

            return function link($scope, $element) {
                var elementParent = $($element[0]).parent();
                var totalLength;

                $scope.visibleResults = pageSize;
                $compile($element)($scope);

                $scope.$watch(collectionString, function (collection) {
					if(collection != undefined){
						totalLength = collection.length;
						$scope.visibleResults = pageSize;
					}                    
                }, true);
				
                var dataListready = true;
                var dataAreaready = true;
                
				$(".scrollableList").scroll(function (event) {
					event.stopImmediatePropagation();
					event.stopPropagation();
					event.preventDefault();
					
				    var infiniteList = $('.scrollableList');
					  if (dataListready && Math.ceil(infiniteList.scrollTop() + infiniteList.innerHeight()) >= infiniteList.prop('scrollHeight')) {
						  dataListready = false;
						  var diff = calculateScrollBottomDiff(elementParent);
	                    if (diff <= tolerance && totalLength > $scope.visibleResults) {
	                        $scope.$broadcast(BOTTOM_REACHED_BEFORE_EVT);
	                        safeApply($scope, function () {   
	                        	/*pageSize += 25;*/
	                            $scope.visibleResults += pageSize;
	                            //$scope.loadProfileList();
	                            setTimeout(function(){$scope.callListfun();dataListready = true;},300);
	                            /*var currentScrollTop = infiniteList.scrollTop();
	                            infiniteList.scrollTop(currentScrollTop - 50);*/
	                            
	                            $('.inlineLoader').show().delay(2000).fadeOut();
	                        });
	                        $scope.$broadcast(BOTTOM_REACHED_AFTER_EVT);
	                    }else{
	                    	dataListready = true;
	                    }
						  
					  }
			    });
				
                $scope.$on(windowService.WINDOW_SCROLL, function () {
                    var diff = calculateScrollBottomDiff(elementParent);
                    if (diff <= tolerance && totalLength > $scope.visibleResults) {
                        $scope.$broadcast(BOTTOM_REACHED_BEFORE_EVT);
                        safeApply($scope, function() {
                            $scope.visibleResults += pageSize;
                        });
                        $scope.$broadcast(BOTTOM_REACHED_AFTER_EVT);
                    }
                });

                windowService.registerForScroll($scope);
            };
        };

        return {
            replace: false,
            terminal: true,
            priority: 2000,
            restrict: 'A',
            compile: compile
        };
    }]);

angular.module('ks.WindowService', [])
    .factory('WindowService', ['$window', function ($window) {
        var windowElement = angular.element($window);
        var WINDOW_SCROLL = 'WINDOW_SCROLL';
        var listeners = [];

        windowElement.on('scroll', function () {
            var scope;
            for (var index in listeners) {
                scope = listeners[index];
                scope.$broadcast(WINDOW_SCROLL);
            }
        });

        return {
            WINDOW_SCROLL: WINDOW_SCROLL,
            height: function () {
                return windowElement.height();
            },
            scrollTop: function () {
                return windowElement.scrollTop();
            },
            registerForScroll: function ($scope) {
                if ($scope && angular.isFunction($scope.$broadcast)) {
                    listeners.push($scope);
                } else {
                    throw new Error('Cannot register a non-scope object for scroll');
                }
            }
        };
    }]);
/*!
Copyright 2014 Vadim Kazakov
Adapted from source by Maarten Baijs

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 */
(function() {
    'use strict';

    angular.module('ngTinyScrollbar', [])
        .provider('scrollbar', function () {

            this.defaults = {
                axis: 'y', // Vertical or horizontal scrollbar? ( x || y ).
                wheel: true, // Enable or disable the mousewheel;
                wheelSpeed: 40, // How many pixels must the mouswheel scroll at a time.
                wheelLock: true, // Lock default scrolling window when there is no more content.
                scrollInvert: false, // Enable invert style scrolling
                trackSize: false, // Set the size of the scrollbar to auto or a fixed number.
                thumbSize: false, // Set the size of the thumb to auto or a fixed number.
                alwaysVisible: false, // Set to false to hide the scrollbar if not being used
                autoUpdate: false    // Autoupdate the scrollbar if DOM changes. Needs MutationObserver or a polyfill to be available
            };

            this.$get = function () {
                return this;
            };
        })
        .directive('scrollbar', ['$window', '$timeout', '$parse', '$animate', 'scrollbar', function($window, $timeout, $parse, $animate, scrollbar) {
            return {
                restrict: 'A',
                transclude: true,
                template: '<div class="scroll-bar"><div class="scroll-thumb"></div></div><div class="scroll-viewport"><div class="scroll-overview" ng-transclude></div></div>',
                controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {

                    var options = $attrs.scrollbar;
                    if (options) {
                        options = $parse(options)($scope);
                    } else {
                        options = {};
                    }
                    this.options = angular.extend({}, scrollbar.defaults, options);
                    this._defaults = scrollbar.defaults;

                    var self = this,
                        $body = angular.element(document.querySelectorAll('body')[0]),
                        $document = angular.element(document),
                        $viewport = angular.element($element[0].querySelectorAll('.scroll-viewport')[0]),
                        $overview = angular.element($element[0].querySelectorAll('.scroll-overview')[0]),
                        $scrollbar = angular.element($element[0].querySelectorAll('.scroll-bar')[0]),
                        $thumb = angular.element($element[0].querySelectorAll('.scroll-thumb')[0]),
                        mousePosition = 0,
                        isHorizontal = this.options.axis === 'x',
                        hasTouchEvents = ('ontouchstart' in $window),
                        wheelEvent = ("onwheel" in document ? "wheel" : // Modern browsers support "wheel"
                                      document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
                                      "DOMMouseScroll"), // let's assume that remaining browsers are older Firefox
                        sizeLabel = isHorizontal ? 'width' : 'height',
                        sizeLabelCap = sizeLabel.charAt(0).toUpperCase() + sizeLabel.slice(1).toLowerCase(),
                        posiLabel = isHorizontal ? 'left' : 'top',
                        moveEvent = document.createEvent('HTMLEvents'),
                        restoreVisibilityAfterWheel;

                    moveEvent.initEvent('move', true, true);
                    this.contentPosition = 0;
                    this.viewportSize = 0;
                    this.contentSize = 0;
                    this.contentRatio = 0;
                    this.trackSize = 0;
                    this.trackRatio = 0;
                    this.thumbSize = 0;
                    this.thumbPosition = 0;

                    this.initialize = function() {
                        if (!this.options.alwaysVisible) {
                            $scrollbar.css('opacity', 0);
                        }
                        self.update();
                        setEvents();
                        return self;
                    };

                    this.update = function(scrollTo) {
                        this.viewportSize = $viewport.prop('offset'+ sizeLabelCap);
                        this.contentSize = $overview.prop('scroll'+ sizeLabelCap);
                        this.contentRatio = this.viewportSize / this.contentSize;
                        this.trackSize = this.options.trackSize || this.viewportSize;
                        this.thumbSize = Math.min(this.trackSize, Math.max(0, (this.options.thumbSize || (this.trackSize * this.contentRatio))));
                        this.trackRatio = this.options.thumbSize ? (this.contentSize - this.viewportSize) / (this.trackSize - this.thumbSize) : (this.contentSize / this.trackSize);
                        mousePosition = $scrollbar.prop('offsetTop');

                       /* $scrollbar.toggleClass('disable', this.contentRatio >= 1 || isNaN(this.contentRatio));*/

                        if (!this.options.alwaysVisible && this.contentRatio < 1 && this.viewportSize > 0) {
                            //flash the scrollbar when update happens
                            $animate.addClass($scrollbar, 'visible').then(function() {
                                $animate.removeClass($scrollbar, 'visible');
                            });
                        }

                        if (scrollTo != null)  {
                            switch (scrollTo) {
                                case 'bottom':
                                    this.contentPosition = this.contentSize - this.viewportSize;
                                    break;
                                default:
                                    this.contentPosition = parseInt(scrollTo, 10) || 0;
                            }
                        }

                        ensureContentPosition();
                        $thumb.css(posiLabel, self.contentPosition / self.trackRatio + 'px');
                        $scrollbar.css(sizeLabel, self.trackSize + 'px');
                        $thumb.css(sizeLabel, self.thumbSize + 'px');
                        $overview.css(posiLabel, -self.contentPosition + 'px');

                        return this;
                    };

                    function ensureContentPosition() {
                        // if scrollbar is on, ensure the bottom of the content does not go above the bottom of the viewport
                        if (self.contentRatio <= 1 && self.contentPosition > self.contentSize - self.viewportSize) {
                            self.contentPosition = self.contentSize - self.viewportSize;
                        }
                        // if scrollbar is off, ensure the top of the content does not go below the top of the viewport
                        else if (self.contentRatio > 1 && self.contentPosition > 0) {
                            self.contentPosition = 0;
                        }
                    }

                    function setEvents() {

                        if(hasTouchEvents) {
                            $viewport.on('touchstart', touchstart);
                        }
                        $thumb.on('mousedown', start);
                        $scrollbar.on('mousedown', drag);

                        angular.element($window).on('resize', resize);

                        if(self.options.wheel) {
                            $element.on(wheelEvent, wheel);
                        }

                        if (self.options.autoUpdate && MutationObserver) {
                            (function () {
                                var recentWidth = $overview[0].offsetWidth,
                                    recentHeight = $overview[0].offsetHeight,
                                    updateTimer;

                                // check DOM content update
                                var observer = new MutationObserver(function (mutations) {
                                    // Render scrollbar only with $overview dimension changes, once per digest cycle
                                    if (recentWidth !== $overview[0].offsetWidth ||
                                        recentHeight !== $overview[0].offsetHeight) {
                                        $timeout.cancel(updateTimer);
                                        updateTimer = $timeout(function () {
                                            recentWidth = $overview[0].offsetWidth;
                                            recentHeight = $overview[0].offsetHeight;
                                            self.update();
                                        });
                                    }
                                });

                                observer.observe($element[0], {
                                    childList: true,
                                    subtree: true,
                                    characterData: true,
                                    attributes: true
                                });
                            })();
                        }
                    }

                    function resize() {
                        self.update();
                    }

                    function touchstart(event) {
                        var evntObj = (event && event.originalEvent) || event || $window.event;
                        if (1 === evntObj.touches.length) {
                            event.stopPropagation();
                            start(evntObj.touches[0]);
                        }
                    }

                    function start(event) {
                        $body.addClass('scroll-no-select');
                        $element.addClass('scroll-no-select');

                        if (!self.options.alwaysVisible) {
                            $scrollbar.addClass('visible');
                        }
                        mousePosition = isHorizontal ? event.pageX : event.pageY;
                        self.thumbPosition = parseInt($thumb.css(posiLabel), 10) || 0;

                        if(hasTouchEvents) {
                            $document.on('touchmove', touchdrag);
                            $document.on('touchend', end);
                        }
                        $document.on('mousemove', drag);
                        $document.on('mouseup', end);
                        $thumb.on('mouseup', end);
                    }

                    function wheel(event) {

                        if(self.contentRatio >= 1) {
                            return;
                        }

                        if (!self.options.alwaysVisible) {
                            //cancel removing visibility if wheel event is triggered before the timeout
                            if (restoreVisibilityAfterWheel) {
                                $timeout.cancel(restoreVisibilityAfterWheel);
                            }
                            $scrollbar.addClass('visible');

                            restoreVisibilityAfterWheel = $timeout(function() {
                                $scrollbar.removeClass('visible');
                            }, 100);
                        }


                        var evntObj = (event && event.originalEvent) || event || $window.event,
                            deltaDir = self.options.axis.toUpperCase(),
                            delta = {
                              X: evntObj.deltaX,
                              Y: evntObj.deltaY
                            },
                            wheelSpeed = evntObj.deltaMode == 0 ? self.options.wheelSpeed : 1;

                        if (self.options.scrollInvert) {
                          wheelSpeed *= -1;
                        }

                        if (wheelEvent === 'mousewheel') {
                          delta.Y = -1 * evntObj.wheelDelta / 40;
                          evntObj.wheelDeltaX && ( delta.X = -1 * evntObj.wheelDeltaX / 40 );
                        }
                        delta.X *= -1 / wheelSpeed;
                        delta.Y *= -1 / wheelSpeed;

                        var wheelSpeedDelta = delta[deltaDir];

                        self.contentPosition -= wheelSpeedDelta * self.options.wheelSpeed;
                        self.contentPosition = Math.min((self.contentSize - self.viewportSize), Math.max(0, self.contentPosition));

                        $element[0].dispatchEvent(moveEvent);

                        ensureContentPosition();
                        $thumb.css(posiLabel, self.contentPosition / self.trackRatio + 'px');
                        $overview.css(posiLabel, -self.contentPosition + 'px');

                        if(self.options.wheelLock || (self.contentPosition !== (self.contentSize - self.viewportSize) && self.contentPosition !== 0)) {
                            evntObj.preventDefault();
                        }
                    }

                    function touchdrag(event) {
                        var evntObj = (event && event.originalEvent) || event || $window.event;
                        if (1 === evntObj.touches.length) {
                            event.preventDefault();
                            drag(evntObj.touches[0]);
                        }
                    }

                    function drag(event) {

                        if(self.contentRatio >= 1) {
                            return;
                        }

                        var mousePositionNew = isHorizontal ? event.pageX : event.pageY,
                            thumbPositionDelta = mousePositionNew - mousePosition;

                        if((self.options.scrollInvert && event.type === 'mousemove') ||
                            (event.type !== 'mousemove' && !self.options.scrollInvert))
                        {
                            thumbPositionDelta = mousePosition - mousePositionNew;
                        }
                        var thumbPositionNew = Math.min((self.trackSize - self.thumbSize), Math.max(0, self.thumbPosition + thumbPositionDelta));
                        self.contentPosition = thumbPositionNew * self.trackRatio;

                        $element[0].dispatchEvent(moveEvent);

                        ensureContentPosition();
                        $thumb.css(posiLabel, thumbPositionNew + 'px');
                        $overview.css(posiLabel, -self.contentPosition + 'px');
                    }

                    function end() {

                        $body.removeClass('scroll-no-select');
                        $element.removeClass('scroll-no-select');
                        if (!self.options.alwaysVisible) {
                            $scrollbar.removeClass('visible');
                        }

                        $document.off('mousemove', drag);
                        $document.off('mouseup', end);
                        $thumb.off('mouseup', end);
                        $document.off('touchmove', touchdrag);
                        $document.off('ontouchend', end);
                    }

                    this.cleanup = function() {
                        $viewport.off('touchstart', touchstart);
                        $thumb.off('mousedown', start);
                        $scrollbar.off('mousedown', drag);
                        angular.element($window).off('resize', resize);
                        $element.off(wheelEvent, wheel);
                        //ensure scrollbar isn't activated
                        self.options.alwaysVisible = true;
                        end();
                    };

                }],
                link: function(scope, iElement, iAttrs, controller) {
                    var position = $window.getComputedStyle(iElement[0]).getPropertyValue('position');
                    if (position !== 'relative' && position !== 'absolute') {
                        iElement.css('position', 'relative');
                    }
                    $timeout(function(){
                    	 controller.initialize();
                    },100)
                    iElement.on('$destroy', function() {
                        controller.cleanup();
                    });
                }
            };
        }]);
})();
(function() {
	'use strict';

	angular.module('lariAidApp').directive('onlyDigits', OnlyDigits);
	//resize.inject['$window'];
	
	function OnlyDigits() {
		return {
	        restrict: 'A',
    		require: 'ngModel',
    	    link: function (scope, element, attrs, modelCtrl) {
    	    	modelCtrl.$parsers.push(function(inputValue) {
	            	var allowedChar = '';
	            	if(attrs.allowedChar){
	            		allowedChar = attrs.allowedChar;
	            	}
	            	/*var expr = "[^0-9"+allowedChar+"]";*/
	            	var expr = allowedChar;
	            	 var myRegExp = new RegExp(expr,'gi');
	            	 
	              if (inputValue == undefined)
	                return ''
	              scope.cleanInputValue = inputValue.replace(myRegExp, '');
	              if (scope.cleanInputValue != inputValue) {
	                modelCtrl.$setViewValue(scope.cleanInputValue);
	                modelCtrl.$render();
	              }
	              return scope.cleanInputValue;
    	    	});
	    	}
    	};
		}
	
})();
(function(){
	'use strict';

	angular.module('lariAidApp').directive('phoneInput', phoneNumberValidation);
	
	angular.module('lariAidApp').filter('tel', phoneNumberFilter);
	
	phoneNumberValidation.$inject = ['$filter', '$browser'];
	
	function phoneNumberValidation($filter, $browser){
		return {
	        require: 'ngModel',
	        link: function($scope, $element, $attrs, ngModelCtrl) {
	            var listener = function() {
	                var value = $element.val().replace(/[^0-9]/g, '');
	                $element.val($filter('tel')(value, false));
	            };

	            // This runs when we update the text field
	            ngModelCtrl.$parsers.push(function(viewValue) {
	                return viewValue.replace(/[^0-9]/g, '').slice(0,10);
	            });

	            // This runs when the model gets updated on the scope directly and keeps our view in sync
	            ngModelCtrl.$render = function() {
	                $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
	            };

	            $element.bind('change', listener);
	            $element.bind('keydown', function(event) {
	                var key = event.keyCode;
	                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
	                // This lets us support copy and paste too
	                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
	                    return;
	                }
	                $browser.defer(listener); // Have to do this or changes don't get picked up properly
	            });

	            $element.bind('paste cut', function() {
	                $browser.defer(listener);
	            });
	        }
	    };		
	}
	
	function phoneNumberFilter(){
		return function (tel) {
			
	        if (!tel) { return ''; }

	        var value = tel.toString().trim().replace(/^\+/, '');

	        if (value.match(/[^0-9]/)) {
	            return tel;
	        }

	        var country, city, number;

	        switch (value.length) {
	            case 1:
	            case 2:
	            case 3:
	                city = value;
	                break;

	            default:
	                city = value.slice(0, 3);
	                number = value.slice(3);
	        }

	        if(number){
	            if(number.length>3){
	                number = number.slice(0, 3) + '-' + number.slice(3,7);
	            }
	            else{
	                number = number;
	            }

	            return (city + "-" + number).trim();
	        }
	        else{
	            return city;
	        }

	    };
	}
	
	
})();
/* global window */
/* global angular */
/* global module */

(function (module, window, angular) {
    "use strict";

    function test(string, regex) {
        if (typeof regex === 'string' || regex instanceof String) {
            regex=new RegExp(regex);
        }

        if (regex instanceof RegExp) {
            return regex.test(string);
        }
        else if (regex && Array.isArray(regex.and)) {
            return regex.and.every(function (item) {
                return test(string, item);
            });
        }
        else if (regex && Array.isArray(regex.or)) {
            return regex.or.some(function (item) {
                return test(string, item);
            });
        }
        else if (regex && regex.not) {
            return !test(string, regex.not);
        }
        else {
            return false;
        }
    }

    function exec(string, regex) {
        if (typeof regex === 'string' || regex instanceof String) {
            regex=new RegExp(regex);
        }

        if (regex instanceof RegExp) {
            return regex.exec(string);
        }
        else if (regex && Array.isArray(regex)) {
            return regex.reduce(function (res, item) {
                return (!!res) ? res : exec(string, item);
            }, null);
        }
        else {
            return null;
        }
    }

    if (!!angular) {
        angular.module("reTree", []).factory("reTree", [function () {
            return {
                test: test,
                exec: exec
            };
        }]);
    }

    if (!!window) {
        window.reTree = {
            test: test,
            exec: exec
        };
    }

    if (!!module) {
        module.exports = {
            test: test,
            exec: exec
        };
    }
})(typeof module === 'undefined' ? null : module, typeof window === 'undefined' ? null : window, typeof angular === 'undefined' ? null : angular);

(function() {
	'use strict';

	angular.module('lariAidApp').directive('replace', Replace);
	//resize.inject['$window'];
	
	function Replace() {
		  return {
			    require: 'ngModel',
			    scope: {
			      regex: '@replace',
			      with: '@with'
			    }, 
			    link: function(scope, element, attrs, model) {
			      model.$parsers.push(function(val) {
			        if (!val) { return; }
			        var regex = new RegExp(scope.regex);
			        var replaced = val.replace(regex, scope.with); 
			        if (replaced !== val) {
			          model.$setViewValue(replaced);
			          model.$render();
			        }         
			        return replaced;         
			      });
			    }
			  };		
		}
})();
(function() {
	'use strict';

	angular.module('lariAidApp').directive('resize', resize);
	angular.module('lariAidApp').directive('resizePopup', resizePopup);
	//resize.inject['$window'];
	resize.$inject = ['$mdMedia'];
	function resize($mdMedia) {
		return function(scope, element) {
			var w = angular.element(window);
			var n,i,p,x;
			scope.media = $mdMedia;
			scope.getWindowDimensions = function() {
				return {
					'h' : w.height(),
					'w' : w.width()
				};
			};
			scope.$watch(scope.getWindowDimensions,
					function(newValue, oldValue) {
						scope.resizeFun(newValue, oldValue);
					}, true);

			w.bind('resize', function() {
				scope.$apply();
				scope.resizeFun(scope.getWindowDimensions());
			});
			
			scope.resizeFun = function(newValue, oldValue){
				n = angular.element('.headerTop');
				i = angular.element('.investigationHeaderTop');
				p = angular.element('.prospectHeaderSize');
				x = angular.element('.prospectHeaderXs');
				if(n.css('display') != 'none'){
					newValue.h = newValue.h - (n.height() || 0);
				}
				if(i.css('display') != 'none'){
					newValue.h = newValue.h - (i.height() || 0);
				}
				if(p.css('display') != 'none'){
					newValue.h = newValue.h - (p.height() || 0);
				}
				if(x.css('display') != 'none'){
					newValue.h = newValue.h - (x.height() || 0);
				}
				scope.windowHeight = newValue.h;
				scope.windowWidth = newValue.w;
			}
		}
	}
	function resizePopup() {
		return function(scope, element) {
			var w = angular.element('.popup');
			var n,i,p,x;
			scope.getWindowDimensions = function() {
				return {
					'h' : w.height(),
					'w' : w.width()
				};
			};
			scope.$watch(scope.getWindowDimensions,
					function(newValue, oldValue) {
						setTimeout(function(){
							scope.resizeFun(newValue, oldValue);
						},200);
					}, true);

			w.bind('resize', function() {
				scope.$apply();
				setTimeout(function(){
					scope.resizeFun(scope.getWindowDimensions());
				},500);
			});
			
			scope.resizeFun = function(newValue, oldValue){
				n = angular.element('.popupDiv');
				
				if(n.css('display') != 'none'){
					newValue.h = newValue.h - (n.height() || 0);
				}
				
				scope.windowPopHeight = newValue.h;
				scope.windowPopWidth = newValue.w;
			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('lariAidApp').directive('commonSearch', commonSearch);
	//commonSearch.inject['$http'];
	
	function commonSearch() {
		return {	
		  scope: {
		    callback: '&searchCallback'
		  },
		  link: function(scope, element, attrs) {
		 var typingTimer;
		 element.bind('keydown' , function(event){
		 clearTimeout(typingTimer);
		 typingTimer = setTimeout(function(){
		 scope.callback({ $event: event });
		 },1000);
		 });
		    }
		};
	}
})();
(function() {
	'use strict';
	angular.module('lariAidApp').directive('noSpecialChar', specialCharValidation);
	//resize.inject['$window'];
	
	function specialCharValidation() {
		 return {
	          require: 'ngModel',
	          restrict: 'A',
	          link: function(scope, element, attrs, modelCtrl) {
	        	 /*attrs.$observe('allowedChar',function() {
	        		 console.log("attrs.allowedChar>>>>"+attrs.allowedChar)
	          	});*/
	        	  
	            modelCtrl.$parsers.push(function(inputValue) {
	            	var allowedChar = '';
	            	if(attrs.allowedChar){
	            		allowedChar = attrs.allowedChar;
	            	}
	            	/* var expr = "[^\\w\\s."+allowedChar+"][À-ú][À-ÿ]";
	            	 var expr = "[^\\w\u00C0-\u017F\\s."+allowedChar+"]";
	            	var expr = "[^\\w\\s."+allowedChar+"]";*/
	            	/*This is used to allow words including latin letters
	            	var expr = "[^\\w\u00C0-\u017F\\s."+allowedChar+"]";*/
	            	var expr = allowedChar;
	            	 var myRegExp = new RegExp(expr,'gi');
	            	 
	              if (inputValue == undefined)
	                return ''
	              scope.cleanInputValue = inputValue.replace(myRegExp, '');
	              if (scope.cleanInputValue != inputValue) {
	                modelCtrl.$setViewValue(scope.cleanInputValue);
	                modelCtrl.$render();
	              }
	              return scope.cleanInputValue;
	            });
	          }
	        }
		
	}
})();
(function() {
	'use strict';

	angular.module('lariAidApp').directive('limitTo', LimitTo);
	//resize.inject['$window'];
	
	function LimitTo() {
		 return {
			 restrict: "A",
		        link: function(scope, elem, attrs) {
		            var limit = parseInt(attrs.limitTo);
		            angular.element(elem).on("keypress", function(e) {
		                if (this.value.length == limit) e.preventDefault();
		            });
		        }
		 	}
		}
})();
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('textOnly', textOnly);
    
    function textOnly(){
    	return {
    		require: 'ngModel',
    	    link: function (scope, element, attr, ngModelCtrl) {
    	      function fromUser(text) {
    	        /*var transformedInput = text.replace(/[^A-Za-z \u00C0-\u017F]/g, '');
    	        if(transformedInput !== text) {
    	            ngModelCtrl.$setViewValue(transformedInput);
    	            ngModelCtrl.$render();
    	        }
    	        return transformedInput;*/
    	    	return text;
    	      }
    	      ngModelCtrl.$parsers.push(fromUser);
    	    }
    	}
    };
    
})();
angular
	.module('lariAidApp').directive("datePickerLocalDate", ['$parse','$filter', function ($parse,$filter) {
        var directive = {
            restrict: 'A',
            require: ['ngModel'],
            link: link
        };
        return directive;

        function link(scope, element, attr, ctrls) {
            var ngModelController = ctrls[0];

            // called with a JavaScript Date object when picked from the datepicker
            ngModelController.$parsers.push(function (viewValue) {
            	if(viewValue != null){
            		 // undo the timezone adjustment we did during the formatting
                    viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
                    // we just want a local date in ISO format
                    return viewValue.toISOString().substring(0, 10);
            	}
            });

            // called with a 'yyyy-mm-dd' string to format
            ngModelController.$formatters.push(function (modelValue) {
                if (!modelValue) {
                    return undefined;
                }
                // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
                var dt = new Date(modelValue);
                // 'undo' the timezone offset again (so we end up on the original date again)
                dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
                return dt;
            });
        }
    }]);
// Rename this directive to camelCase to enable camelcase for name fileds
angular.module('lariAidApp').directive('camelCaseDirective', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if (inputValue == undefined) inputValue = '';
          var capitalized = inputValue.replace(/\S*/g, function(txt){
        	  if(txt.charAt(0) == '"' || txt.charAt(0) == "'")
        		  {
        		  return txt.charAt(0).toUpperCase() + txt.substr(1,1).toUpperCase() + txt.substr(2).toLowerCase();
        		  }
          	else {
          		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          	}});            		       	  
          if (capitalized !== inputValue) {
        	  var cursorPosition = element[0].selectionStart;
        	  modelCtrl.$setViewValue(capitalized);
        	  modelCtrl.$render();
        	  element[0].selectionStart = element[0].selectionEnd = cursorPosition;
          }
          return capitalized;
        }
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
      }
    };
  });
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("LoginController", LoginController);

  LoginController.$inject = [
    "$rootScope",
    "$state",
    "$timeout",
    "Auth",
    "$sessionStorage",
    "communicationService",
    "APP",
    "$translate",
    "tmhDynamicLocale",
    "$http",
    "$sce",
    "BASE_URL",
    "OKTA_SAML_URL"
  ];

  function LoginController(
    $rootScope,
    $state,
    $timeout,
    Auth,
    $sessionStorage,
    communicationService,
    APP,
    $translate,
    tmhDynamicLocale,
    $http,
    $sce,
    BASE_URL,
    OKTA_SAML_URL
  ) {
    var vm = this;
    vm.showPassword = false;
    vm.authenticationError = false;
    vm.cancel = cancel;
    vm.credentials = {};
    vm.login = login;
    vm.password = null;
    vm.register = register;
    vm.rememberMe = true;
    vm.requestResetPassword = requestResetPassword;
    vm.username = null;
    vm.decryptpass = decryptpass;
    vm.encryptpass = encryptpass;
    vm.activated = false;
    vm.removeError = removeError;
    vm.forgotPassword = forgotPassword;
    vm.oktaSamlUrl = $sce.trustAsResourceUrl(OKTA_SAML_URL);
    vm.APP = APP;

    $timeout(function () {
      angular.element("#username").focus();
    });

    function cancel() {
      vm.credentials = {
        username: null,
        password: null
      };
      vm.authenticationError = false;
      $uibModalInstance.dismiss("cancel");
    }
    function getEnvironmentDetails() {
      $http({
        method: "GET",
        url: BASE_URL + "api/getEnvironmentDetails"
      }).then(function successCallback(response) {
        $sessionStorage.currentEnvironment = response.data.environment;
      });
    }

    function login(event) {
      vm.activated = true;
      event.preventDefault();
      Auth.login({
        username: vm.username,
        secretkey: vm.password
      })
        .then(function () {
          getEnvironmentDetails();
          vm.authenticationError = false;
          if (
            $state.current.name === "register" ||
            $state.current.name === "activate" ||
            $state.current.name === "finishReset" ||
            $state.current.name === "requestReset" ||
            $state.current.name === "login"
          ) {
            $state.go("investigations");
            $sessionStorage.isLoggedIn = true;
            communicationService.setData("isLoggedIn", true);
            //delete $sessionStorage.languageKey;
          }

          $rootScope.$broadcast("authenticationSuccess");

          // previousState was set in the authExpiredInterceptor before being redirected to login modal.
          // since login is successful, go to stored previousState and clear previousState
          if (Auth.getPreviousState()) {
            var previousState = Auth.getPreviousState();
            Auth.resetPreviousState();
            $state.go(previousState.name, previousState.params);
          }
        })
        .catch(function () {
          vm.activated = false;
          vm.authenticationError = true;
          vm.sessionExpire = false;
          //$timeout(function () { vm.authenticationError = false; }, 3000);
        });
    }

    function register() {
      $state.go("register");
    }

    function requestResetPassword() {
      $state.go("requestReset");
    }

    function decryptpass() {
      vm.showPassword = true;
    }

    function encryptpass() {
      vm.showPassword = false;
    }
    function removeError() {
      vm.authenticationError = false;
    }

    if ($sessionStorage.sessionExpire) {
      vm.sessionExpire = true;
      $timeout(function () {
        delete $sessionStorage.sessionExpire;
      }, 3000);
    }

    function forgotPassword() {
      Auth.forgotPassword().then(function (response) {
        vm.forgotPasswordUrl = response.url;
      });
    }
    vm.defaultLanguage = function () {
      if ($sessionStorage.languageKey != null && $sessionStorage.languageKey != "") {
        vm.lang = $sessionStorage.languageKey;
      } else {
        if(navigator.language.indexOf("es")>-1){
          vm.lang = "es" ;
        }
        else{
            vm.lang = "en";
        }

      }
      $translate.use(vm.lang);
      tmhDynamicLocale.set(vm.lang);
    };

    vm.changeLanguage = function (languageKey) {
      if (languageKey == vm.APP.GLOBAL.ENGLISH) {
        vm.lang = vm.APP.GLOBAL.EN;
        $sessionStorage.languageKey = vm.APP.GLOBAL.EN;
      } else if (languageKey === vm.APP.GLOBAL.SPANISH) {
        vm.lang = vm.APP.GLOBAL.ES;
        $sessionStorage.languageKey = vm.APP.GLOBAL.ES;
      }
      $translate.use(vm.lang);
      tmhDynamicLocale.set(vm.lang);
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = [];

    function LoginService () {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                           	$translatePartialLoader.addPart('login.json?version='+localStorage.getItem('lari_currentVersion'));
                           }else{
                           	$translatePartialLoader.addPart('login.json?timestamp='+new Date().getTime());
                           }
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('lariAidApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('formattedDate', formattedDate);
    
    formattedDate.$inject = ['dateFilter'];
    function formattedDate(dateFilter){
    	return {
    	    scope: {
    	        format: "@",
    	    	modval: "="
    	    },
    	    link: function(scope, element, attrs) {
    	    	if(scope.modval){
    	    		var dateVal = new Date(scope.modval);
        	    	scope.modval = dateVal;
    	    	}
    	    }
    	}
    };
    
})();
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('lariAidApp')
        .component('jhiItemCount', jhiItemCount);
})();

if (typeof moment === "undefined" && require) {
    moment = require('moment');
}

(function(moment) {
    var STRINGS = {
        nodiff: '',
        year: 'year',
        years: 'years',
        month: 'month',
        months: 'months',
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        second: 'second',
        seconds: 'seconds',
        delimiter: ' '
    };

    function pluralize(num, word) {
        return num + ' ' + STRINGS[word + (num === 1 ? '' : 's')];
    }

    function buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff){
        var result = [];

        if (yDiff) {
            result.push(pluralize(yDiff, 'year'));
        }
        if (mDiff) {
            result.push(pluralize(mDiff, 'month'));
        }
        if (dDiff) {
            result.push(pluralize(dDiff, 'day'));
        }
        if (hourDiff) {
            result.push(pluralize(hourDiff, 'hour'));
        }
        if (minDiff) {
            result.push(pluralize(minDiff, 'minute'));
        }
        if (secDiff) {
            result.push(pluralize(secDiff, 'second'));
        }

        return result.join(STRINGS.delimiter);
    }

    moment.fn.preciseDiff = function(d2, returnValueObject) {
        return moment.preciseDiff(this, d2, returnValueObject);
    };

    moment.preciseDiff = function(d1, d2, returnValueObject) {
        var m1 = moment(d1), m2 = moment(d2), firstDateWasLater;
        
        m1.add(m2.utcOffset() - m1.utcOffset(), 'minutes'); // shift timezone of m1 to m2
        
        if (m1.isSame(m2)) {
            return STRINGS.nodiff;
        }
        if (m1.isAfter(m2)) {
            var tmp = m1;
            m1 = m2;
            m2 = tmp;
            firstDateWasLater = true;
        } else {
            firstDateWasLater = false;
        }

        var yDiff = m2.year() - m1.year();
        var mDiff = m2.month() - m1.month();
        var dDiff = m2.date() - m1.date();
        var hourDiff = m2.hour() - m1.hour();
        var minDiff = m2.minute() - m1.minute();
        var secDiff = m2.second() - m1.second();

        if (secDiff < 0) {
            secDiff = 60 + secDiff;
            minDiff--;
        }
        if (minDiff < 0) {
            minDiff = 60 + minDiff;
            hourDiff--;
        }
        if (hourDiff < 0) {
            hourDiff = 24 + hourDiff;
            dDiff--;
        }
        if (dDiff < 0) {
            var daysInLastFullMonth = moment(m2.year() + '-' + (m2.month() + 1), "YYYY-MM").subtract(1, 'M').daysInMonth();
            if (daysInLastFullMonth < m1.date()) { // 31/01 -> 2/03
                dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
            } else {
                dDiff = daysInLastFullMonth + dDiff;
            }
            mDiff--;
        }
        if (mDiff < 0) {
            mDiff = 12 + mDiff;
            yDiff--;
        }

        if (returnValueObject) {
            return {
                "years"   : yDiff,
                "months"  : mDiff,
                "days"    : dDiff,
                "hours"   : hourDiff,
                "minutes" : minDiff,
                "seconds" : secDiff,
                "firstDateWasLater" : firstDateWasLater
            };
        } else {
            return buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff);
        }


    };
}(moment));
(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('lariAidApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                           	$translatePartialLoader.addPart('error.json?version='+localStorage.getItem('lari_currentVersion'));
                           }else{
                           	$translatePartialLoader.addPart('error.json?timestamp='+new Date().getTime());
                           }
                        return $translate.refresh();
                    }]
                }
            })
            .state('login', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'fillPage@': {
                        templateUrl: 'app/components/login/login.html',
                        controller:  'LoginController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                           	$translatePartialLoader.addPart('login.json?version='+localStorage.getItem('lari_currentVersion'));
                           }else{
                           	$translatePartialLoader.addPart('login.json?timestamp='+new Date().getTime());
                           }
                        return $translate.refresh();
                    }],
                       'redirect' : ['Principal', '$state', '$timeout', function(Principal, $state, $timeout){
                           $timeout(function(){
                               //if ($cookies.getObject('sessionDetails') && $cookies.getObject('sessionDetails').firstName != null && $cookies.getObject('sessionDetails').firstName != ''){
                               if(Principal.isAuthenticated()) {
                                   $state.go('investigations');
                                   return true;
                               } else {
                                   $state.go('login');
                                   return false;
                               }
                           }, 700)
                        }]
                }
            })
             .state('accessdenied', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'fillPage@': {
                        templateUrl: 'app/components/login/login.html',
                        controller:  'LoginController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                           	$translatePartialLoader.addPart('error.json?version='+localStorage.getItem('lari_currentVersion'));
                           }else{
                           	$translatePartialLoader.addPart('error.json?timestamp='+new Date().getTime());
                           }
                        return $translate.refresh();
                    }]
                }
            })
            ;
    }
})();
(function() {
    'use strict';

    var lariDevApp = angular
        .module('lariAidApp')
        lariDevApp.controller('ProspectsController', ProspectsController);
    ProspectsController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$stateParams','$timeout','tabservice','$location','$sessionStorage','CommonService','APP'];
    function ProspectsController ($scope,$window, $mdSidenav,Principal,$state,$stateParams,$timeout,tabservice,$location,$sessionStorage,CommonService,APP) {
    	var vm=this;
    	vm.back = back;
    	vm.investigation = $stateParams;
    	vm.APP = APP;
    	//Get logged User Role
    	vm.user = CommonService.getCookieUser();
 		vm.loggedUserRole = vm.user.loggedUserRole;
    	
    	$scope.updateProspectName = function(firstName,lastName){
    		vm.prospectName = firstName + " "+lastName;
    	};
    	
    	// Set the active md tab while refresh the page
    	
    	vm.checkIndex = function(){
    		vm.tabIndex = tabservice.getIndex();
    	};
    	
    	vm.checkIndex();
        /*Investigation Form's Section sidenav  Starts Here*/
    	$scope.sectionLeft = buildToggler('formLeft');
        $scope.toggleRight = buildToggler('formRight');

        function buildToggler(componentId) {
          return function() {
            $mdSidenav(componentId).toggle();
          };
        }
        /*Investigation Form's Section sidenav Ends Here */
        
    	$scope.WindowPopupHeight=window.innerHeight;
    	function back(){
    		delete $sessionStorage.isView;
    		$state.go("investigations");
    	}
    	$scope.stateProfileDetails = function(){
     		$state.go("profile",vm.investigation); 
     	};
     	
     	$scope.stateActivity = function(){
     		$state.go("activity",vm.investigation);
     	};
     	
     	/*vm.checkState = function(){
     		vm.currentState =  $state.current.name;
     	};*/
     	
     	
     	 vm.toggleLeft = toggleLeft('right');
	     	
    	  function toggleLeft(navID) {
    	      return function() {
    	        $mdSidenav(navID).toggle()
    	      };
    	  }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('prospects', {
            parent: 'investigations',
            /*url: '/:id',*/
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            },
            views: {
                'content@': {
                    templateUrl: 'app/investigation/prospects/prospects.html',
                    controller: 'ProspectsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]/*,
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	  },500);
                }]*/
            }
        })
         /*.state('back', {
	        	 parent: 'app',
	             url: '/investigation',
	             data: {
	                 authorities:  ['ROLE_USER']
	             },
	             views: {
	                 'dynamicView@': {
	                     templateUrl: 'app/investigation/investigation.html',
	                     controller: 'InvestigationController',
	                     controllerAs: 'vm'
	                 }
	             },
		        resolve: {
		            mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
		                $translatePartialLoader.addPart('home');
		                return $translate.refresh();
		            }]
		        }
		    });*/
    }
})();

(function(){
	'use strict'; 

angular
  .module('lariAidApp')
  .service('tabservice', function () {
	  
	  this.setIndex = function(index) {
	        this.index = index;
	    };

	    this.getIndex = function() {
	        return this.index ? this.index : 0 ;
	    };
	});
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("NavbarController", NavbarController);

  NavbarController.$inject = [
    "$state",
    "$scope",
    "Auth",
    "Principal",
    "ProfileService",
    "LoginService",
    "$mdSidenav",
    "$cookies",
    "APP",
    "$timeout",
    "$sessionStorage",
    "CommonService",
    "JhiLanguageService",
    "$translate",
    "tmhDynamicLocale",
    "$controller",
    "$rootScope"
  ];

  function NavbarController(
    $state,
    $scope,
    Auth,
    Principal,
    ProfileService,
    LoginService,
    $mdSidenav,
    $cookies,
    APP,
    $timeout,
    $sessionStorage,
    CommonService,
    JhiLanguageService,
    $translate,
    tmhDynamicLocale,
    $controller,
    $rootScope
  ) {
    angular.extend(this, $controller("sessionCtrl", { $scope: $scope }));

    var vm = this;

    vm.isNavbarCollapsed = true;
    vm.isAuthenticated = Principal.isAuthenticated;
    vm.APP = APP;

    if (!angular.isUndefined($cookies.getObject("sessionDetails"))) {
      /*vm.user = $cookies.getObject('sessionDetails');*/
      vm.user = CommonService.getCookieUser().cookieUser;
      vm.loggedUser = vm.user.authorities[0];
      vm.loginName = vm.user.firstName + " " + vm.user.lastName;
    }

    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response.inProduction;
      vm.swaggerEnabled = response.swaggerEnabled;
    });

    vm.login = login;
    vm.logout = logout;
    vm.toggleNavbar = toggleNavbar;
    vm.collapseNavbar = collapseNavbar;
    vm.$state = $state;
    vm.languageName = languageName;
    vm.changeLanguage = changeLanguage;

    function languageName() {
      JhiLanguageService.getAll().then(function (languages) {
        vm.languages = languages;
      });
    }

    vm.defaultLang = function (langKey) {
      if ($sessionStorage.selectedLanguage && vm.APP.GLOBAL.ROLE_INVESTIGATOR == vm.loggedUser) {
        vm.lang = $sessionStorage.selectedLanguage;
      } else {
        vm.lang = langKey;
      }
      $sessionStorage.selectedLanguage = vm.lang;
      $rootScope.language = $sessionStorage.selectedLanguage;
      $translate.use(vm.lang);
      tmhDynamicLocale.set(vm.lang);
    };

    function changeLanguage(languageKey) {
      vm.lang = languageKey;
      if (vm.lang == vm.APP.GLOBAL.ENGLISH) {
        vm.lang = vm.APP.GLOBAL.EN;
      } else if (vm.lang == vm.APP.GLOBAL.SPANISH) {
        vm.lang = vm.APP.GLOBAL.ES;
      }
      $sessionStorage.selectedLanguage = vm.lang;
      $translate.use(vm.lang);
      tmhDynamicLocale.set(vm.lang);
      $rootScope.language = $sessionStorage.selectedLanguage;
    }

    if (!angular.isUndefined($cookies.getObject("NG_TRANSLATE_LANG_KEY")) && $sessionStorage.selectedLanguage) {
      vm.lang = $cookies.getObject("NG_TRANSLATE_LANG_KEY");
    }

    if ($sessionStorage.selectedLanguage) {
      vm.lang = $sessionStorage.selectedLanguage;
    }

    function login() {
      collapseNavbar();
      // $state.go('login');
      //LoginService.open();
    }

    function logout() {
      //$translate.use('en');
      collapseNavbar();
      Auth.resetPreviousState();
      Auth.logout(true);
      // $state.go('login');
      delete $sessionStorage.selectedLanguage;
    }

    function toggleNavbar() {
      vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
    }

    function collapseNavbar() {
      vm.isNavbarCollapsed = true;
    }

    $scope.close = function () {
      $mdSidenav("left").close();
    };

    $scope.$on("$stateChangeSuccess", function (event) {
      $timeout(function () {
        $(window).trigger("resize");
      }, 500);
    });
    function setHeaderColor() {
      if ($sessionStorage.currentEnvironment && $sessionStorage.currentEnvironment.toLowerCase() != "prod") {
        $(".headerTop").css("background-color", "#008080");
      }
    }

    setHeaderColor();

    $scope.$on("setheader", function () {
      setHeaderColor();
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider','APP'];
    
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('entities', {
            parent: 'library',
            url: '/entities',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	libraryType:null
            },
            views: {
                'libraryList': {
                    templateUrl: 'app/library/entity/library.entities.html',
                    controller: 'LibraryEntityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("2");
                	$timeout(function() {
                	    angular.element('#entity').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();
(function() {
	'use strict';

    angular
        .module('lariAidApp')
        .controller('LibraryEntityController', LibraryEntityController);
    
    LibraryEntityController.$inject = ['$rootScope','$scope','$state','$stateParams','$mdSidenav','$element','APP','tabservice','$mdMedia','$sessionStorage','LibraryEntityService','$q','$cookies','$mdDialog','CommonService','LibraryService','$timeout'];
    
    function LibraryEntityController($rootScope,$scope,$state,$stateParams,$mdSidenav,$element,APP,tabservice,$mdMedia,$sessionStorage,LibraryEntityService,$q,$cookies,$mdDialog,CommonService,LibraryService,$timeout){
    	
    	var vm = this;
    	vm.APP = APP;
    	vm.library = $stateParams;
    	vm.media = $mdMedia;
    	var qPromises = [];
    	
    	vm.initialLoader = false;
    	vm.loadingListData = false;
    	
    	//Get user from cookie storage
 		vm.user = CommonService.getCookieUser();
 		vm.loggedUserRole = vm.user.loggedUserRole;

 		vm.libraryEnityLocationObject = {};
	    vm.libraryEnityLocationObject.countryObj = {};
    	vm.libraryEnityLocationObject.provinceObj = {};
    	vm.libraryEnityLocationObject.cityObj = {};
    	vm.libraryEnityLocationObject.sectorObj = {}; 	
    	
    	$scope.libraryEntityInputSearchObject = {};
	    $scope.libraryEntityInputSearchObject.country = ''; 
    	$scope.libraryEntityInputSearchObject.province = '';
    	$scope.libraryEntityInputSearchObject.city = '';
    	$scope.libraryEntityInputSearchObject.countrySearchKey = '';
    	$scope.libraryEntityInputSearchObject.provinceSearchKey = '';
    	$scope.libraryEntityInputSearchObject.citySearchKey = '';
    	$scope.libraryEntityInputSearchObject.sectorSearchKey = '';
    	$scope.libraryEntityInputSearchObject.isAddOrSaveLocationCountry = false;
    	$scope.libraryEntityInputSearchObject.isAddOrSaveLocationProvince = false;
    	$scope.libraryEntityInputSearchObject.isAddOrSaveLocationCity = false;
    	$scope.libraryEntityInputSearchObject.isAddOrSaveLocationSector = false;
    	
    	
    	$scope.libraryEntityInputObject = {};
    	$scope.libraryEntityInputObject.country = false;
    	$scope.libraryEntityInputObject.province = false;
    	$scope.libraryEntityInputObject.city = false;
    	$scope.libraryEntityInputObject.sector = false;
    	
 		
    	var approvedEntityListTotalLength = 0;
    	vm.selectedEntityType = [];
    	vm.entityFilterObj = {};
    	vm.entityFilterObj.from = 0;
        vm.entityFilterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
    	vm.approvedEntityList = [];    	
	    vm.endless = vm.APP.GLOBAL.ENDLESS;
	    vm.entityFilterObj.entityTypeId = [];
    	
    	vm.toggleLeft = buildToggler('left');
        vm.toggleRight = buildToggler('right');
        
        vm.currentUser = CommonService.getCookieUser();
        
        function buildToggler(componentId) {
            return function() {
              $mdSidenav(componentId).toggle();
            }
        };
        
        vm.sideNavClose = function(id){
     		$mdSidenav(id).close();
     	};
     	
     	$scope.callListfun = function(){
  	    	vm.getEntityProfilesList(vm.endless);
     	};
     	
     	vm.getLocationMappingId = function(){
     		
     		if($sessionStorage.libraryEnityLocationObject && Object.keys($sessionStorage.libraryEnityLocationObject).length > 0){
     			vm.libraryEnityLocationObject = $sessionStorage.libraryEnityLocationObject;
     		}
     		
     		$sessionStorage.libraryEnityLocationObject = vm.libraryEnityLocationObject;
     		
     		vm.entityFilterObj.locationMappingId = '';
        	if(vm.libraryEnityLocationObject.sectorObj && vm.libraryEnityLocationObject.sectorObj.sectorId) {
        		//vm.entityFilterObj.locationMappingId =  vm.libraryEnityLocationObject.sectorObj.locationMappingId;
        		vm.entityFilterObj.sectorId = vm.libraryEnityLocationObject.sectorObj.sectorId;
        	} else {
        		vm.entityFilterObj.sectorId = '';
        	}
        	if(vm.libraryEnityLocationObject.cityObj && vm.libraryEnityLocationObject.cityObj.cityId) {
        		//vm.entityFilterObj.locationMappingId =  vm.libraryEnityLocationObject.cityObj.locationMappingId;
        		vm.entityFilterObj.cityId =  vm.libraryEnityLocationObject.cityObj.cityId;
        	} else {
        		vm.entityFilterObj.cityId = '';
        	} 
        	if(vm.libraryEnityLocationObject.provinceObj && vm.libraryEnityLocationObject.provinceObj.provinceId) {
        		//vm.entityFilterObj.locationMappingId = vm.libraryEnityLocationObject.provinceObj.locationMappingId;
        		vm.entityFilterObj.provinceId = vm.libraryEnityLocationObject.provinceObj.provinceId;
        	} else {
        		vm.entityFilterObj.provinceId = '';
        	} 
        	if(vm.libraryEnityLocationObject.countryObj && vm.libraryEnityLocationObject.countryObj.countryId) {
        		//vm.entityFilterObj.locationMappingId = vm.libraryEnityLocationObject.countryObj.locationMappingId;
        		vm.entityFilterObj.countryId = vm.libraryEnityLocationObject.countryObj.countryId;
        	} else {
        		vm.entityFilterObj.countryId = '';
        	}
        	
     	};
    	
     	var clickingTimerEntity;
     	vm.getEntityProfilesList = function(type) {

     		clearTimeout(clickingTimerEntity);
     		clickingTimerEntity = setTimeout(function(){

     		//To disable check box
  	    	if(!vm.media('gt-sm')) {
				 vm.loadingListData = true;
			 }
    		//$timeout(function(){

	    		vm.getLocationMappingId();
	        	
	  	    	if(type != vm.endless){
	  	    		vm.approvedEntityList = [];
	        	}
	  	    	
	  	    	if(vm.approvedEntityList && vm.approvedEntityList.length == 0){
	        		vm.entityFilterObj.from = 0;
	        		approvedEntityListTotalLength = 0;
			    }
	        	else if(vm.approvedEntityList.length > 0){
	        		vm.entityFilterObj.from = vm.approvedEntityList.length;
	        	}
	  	    	vm.loadingEntityProfileListData = true;
	  	    	if(vm.entityFilterObj.from < approvedEntityListTotalLength || approvedEntityListTotalLength == 0){
		  	    	var data = LibraryEntityService.getAllEntityProfiles(vm.entityFilterObj);
		    		data.then(function(response){
		    			vm.loadingEntityProfileListData = false;
						vm.noMoreEntities = false;
		    			
			    		if(response && !angular.equals({}, response) && response.totalCount){
			    			approvedEntityListTotalLength = response.totalCount;
							angular.forEach(response.approvedEntityProfileDTOList, function (value, key) {
								//approvedDate split in response for spanish translation
								if (value.approvedDate != "" && value.approvedDate != null) {
									value.approvedMonth = value.approvedDate.substring(0, 3)
									value.approvedDay = value.approvedDate.substring(3, 7)
									value.approvedYear = value.approvedDate.substring(7, 12)
								}
			       				if(vm.approvedEntityList == null){
			       					vm.approvedEntityList = [];
			       					vm.approvedEntityList.push(value);
					        	 }
					        	 else{
					        		 vm.approvedEntityList.push(value);
					        	 }
			   			    });
			   			 	vm.entityFilterObj.from = vm.approvedEntityList.length;
			   			 	
			   				if(vm.entityFilterObj.from == approvedEntityListTotalLength){
			       				vm.loadingEntityProfileListData = false;
			       				vm.noMoreEntities = true;
			       			  }
			   				
			   				if(vm.entityFilterObj.from <= vm.APP.GLOBAL.DEFAULT_SIZE){
			   					vm.noMoreEntities = false;
			   				}
		   				
			    		}
			    		else if(angular.isUndefined(response)){
		        			vm.loadingEntityProfileListData  = false;
		        			vm.noMoreEntities = false;
	       		        } 
			    		vm.loadingListData = false;
			    	}, function(reason) {
			    		vm.loadingListData = false;
			        		return reason;
		     		});
	  	    	}
	  	    	else{
	  	    		vm.loadingListData = false;
	        		vm.loadingEntityProfileListData = false;
	        		vm.noMoreEntities = true;
	        		vm.loadingListData = false;
		   	   }
    		},200);
    	};
    	
    	vm.callSynchronizePromise = function(){
    		qPromises = [];
   		 
   		 	qPromises.push(vm.getEntityTypeList());
   		 
   		 	$q.all(qPromises)
   		 	.then(function(data){
	   	    	vm.getEntityProfilesList();
	   	    });
    	};
    	
    	vm.searchEntity = function(entitySearchKey){
    		vm.entityFilterObj.searchKey = entitySearchKey;
    		if(entitySearchKey.length >1 || entitySearchKey.length == 0){
    			vm.getEntityProfilesList();
    		}
 	    };
 	    
 	    vm.updateEntityFilterObjList = function(postVariable,selectedList) {
 	    	vm.entityFilterObj[postVariable] = [];
 	    	angular.forEach(selectedList, function(data, key) {
	  			vm.entityFilterObj[postVariable].push(data.id);
		  	});
 	    };
    	
    	//Common function for toggle based on the filter type
    	vm.toggleEntity = function (item, list) {
    		//To disable checkboxes
    		if(vm.media('gt-sm')) {
    			vm.loadingListData = true;
    		}
    		var idx;
   		    for(var i=0; i<list.length;i++) {
		          if(list[i].id == item.id) {
		        	  idx = i;
		          }
   		    }
   		    if (idx > -1) {
   		    	list.splice(idx, 1);
   		    }
   		    else {
   		    	//list = [];
   		    	list.push(item);
   		    }
   		    vm.selectedEntityType = list;
   		 
   		    //vm.unSelectCall(vm.entityTypeList,item);
	    	$sessionStorage.selectedEntityType = list;
	    	vm.updateEntityFilterObjList(vm.APP.LIBRARY.ENTITY_TYPE_ID,vm.selectedEntityType);
  		    
  		    if(vm.media('gt-sm')){
  		    	vm.loadingListData = true;
  		    	vm.getEntityTypeList();
  		    	vm.getEntityProfilesList();
  		    }
  		    
    	};
  		/*vm.unSelectCall = function(list,item){
  			angular.forEach(list, function(data, index) {
 					if(data.id != item.id){
 						data.checked = false;
 					}
				});
  		};*/
    	
    	vm.getEntityTypeList = function(isDefault) {
    		vm.showEntityTypeDiv = false;    		
    		var data = LibraryEntityService.getEntityTypeList();
        	data.then(function(response) {
        		vm.entityTypeList = [];
        		vm.entityTypeList = response.ENTITY;
        		angular.forEach(vm.entityTypeList, function(data, index) {
        			if(data.count > 0){
    		  			vm.showEntityTypeDiv = true; // To hide entire entity type div when all count is 0	
    		  			
    		  		// By default select all filters
                		if(isDefault) {
                			data.checked = true;
                			//Add the entity type to selected entity type list
                			vm.selectedEntityType.push(data);
                			//Add the entity type id to entityFilterObj
                			vm.entityFilterObj.entityTypeId.push(data.id);
                		}
            		}
  				});
        		
        		if(!isDefault){
		  	  	 	if($sessionStorage.selectedEntityType){
		  	  	 		vm.selectedEntityType = [];
	  	  				vm.selectedEntityType = $sessionStorage.selectedEntityType;
	  	  				vm.updateEntityFilterObjList(vm.APP.LIBRARY.ENTITY_TYPE_ID,vm.selectedEntityType);
	  	  			}
		  	  	 	
		  	  	 	// Default select after refresh
			  	  	angular.forEach(vm.entityTypeList, function(data, index) {
				  	  	angular.forEach(vm.selectedEntityType, function(selected, key){
		  					if(data.id == selected.id){
		  						data.checked = true;
		  					}
			  	  		});
	  				});
	  	  		}
	  	  		if(!vm.showEntityTypeDiv){
	  	  			vm.selectedEntityType = [];
	  	  		}
        	}, function(reason) {
        		vm.loadingListData = false;
        		return reason;
        	});
        	
        	return data;
    	};
    	
    	vm.getEntitySortedList = function(entitySortBy,isCallRequired) {
         	vm.entityFilterObj.sortBy = entitySortBy;
         	if(entitySortBy == vm.APP.LIBRARY.ENTITY_SORT_BY_COUNT) {
         		vm.entityFilterObj.sortOrder = vm.APP.GLOBAL.DESC;
         	} else if (entitySortBy == vm.APP.LIBRARY.ENTITY_SORT_BY_NAME) {
         		vm.entityFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
         	}
         	
         	$sessionStorage.entitySortBy = entitySortBy;
         	
         	if(!isCallRequired){
         		vm.getEntityProfilesList();  //Prevent call from vm.userInit function.
         	}
         	
    	}
    	
    	vm.entityInit = function() {
    		vm.initialLoader = true;	
    		vm.sortOrderList = [{
                	"id":vm.APP.LIBRARY.ENTITY_SORT_BY_COUNT,
                	"value":"sortbyapproved"
                },{
                	"id":vm.APP.LIBRARY.ENTITY_SORT_BY_NAME,
                	"value":"sortbyname"
                }];
         		
         		//Default
    		if(angular.isUndefined(vm.entitySortBy) || angular.isUndefined(vm.entitySortBy.value)) {
    			vm.entityFilterObj.sortBy = vm.APP.LIBRARY.ENTITY_SORT_BY_COUNT;
    			vm.entityFilterObj.sortOrder = vm.APP.GLOBAL.DESC;
    		};
         		
         		//Sort by initialization through session storage
    		if($sessionStorage.entitySortBy){
    			for(var i=0;i<vm.sortOrderList.length;i++){
    				if(vm.sortOrderList[i].id == $sessionStorage.entitySortBy){
    					vm.entitySortBy = vm.sortOrderList[i];
    					break;
    				}
    			}
            		
    			vm.getEntitySortedList(vm.entitySortBy.id,true);  // To get sort by list 
    		};
    		
    		if($sessionStorage.selectedEntityType){
	   			   qPromises.push(vm.getEntityTypeList(false));
	   		 }
    		else{
	   			   qPromises.push(vm.getEntityTypeList(true));
	   		}
    		
    		$q.all(qPromises)
   	    	.then(function(data){
   	    		vm.initialLoader = false;
   	    		vm.getEntityProfilesList();
   	    	});
        	
            	
            	 
 	   		   //Retaining entityFilter drop down value
    		if($sessionStorage.entityFilter){
    			vm.entityFilter = $sessionStorage.entityFilter;
    			var entityFilterKeys = Object.keys(vm.entityFilter);
 			  
    			//Assigning vm.entityFilter ids into Post Object for Listing
    			var postVariable = "";
    			angular.forEach(entityFilterKeys, function(keyName, index) {
    				if(keyName){
    					postVariable = keyName + "Id";
    					if(vm.entityFilter[keyName]){
    						vm.entityFilterObj[postVariable] = vm.entityFilter[keyName].id;
    					}
    				}
    			}); 
    		};
    		
    	};
    	
    	//vm.entityInit();
    	
    }
	
})();
(function () {
  "use strict";

  angular.module("lariAidApp").service("LibraryEntityService", LibraryEntityService);

  LibraryEntityService.$inject = ["$resource", "restService", "$q", "$rootScope", "$http", "BASE_URL"];

  function LibraryEntityService($resource, restService, $q, $rootScope, $http, BASE_URL) {
    this.getEntityTypeList = function () {
      var deferred = $q.defer();
      var url = "entity-profiles/status/count";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    var deferredEntity = $q.defer();
    this.getAllEntityProfiles = function (filterObj) {
      if (deferredEntity != undefined) {
        deferredEntity.resolve();
        deferredEntity = $q.defer();
      }
      var url = BASE_URL + "api/approved-entity-profiles";
      var promise = $http.post(url, filterObj, { timeout: deferredEntity.promise }).then(function (response) {
        return response.data;
      });

      return promise;
    };
  }
})();

(function() {
	'use strict';

    angular
        .module('lariAidApp')
        .controller('LibraryLocationController', LibraryLocationController);
    
    LibraryLocationController.$inject = ['$rootScope','$scope','$state','$stateParams','$mdSidenav','$element','APP','tabservice','$mdMedia','LibraryLocationService','$q','$timeout','$sessionStorage','LibraryRequestService','$mdDialog','CommonService','communicationService','LibraryService','notifications'];
    
    function LibraryLocationController($rootScope,$scope,$state,$stateParams,$mdSidenav,$element,APP,tabservice,$mdMedia,LibraryLocationService,$q,$timeout,$sessionStorage,LibraryRequestService,$mdDialog,CommonService,communicationService,LibraryService,notifications){
    	
    	var vm = this;
    	vm.APP = APP;
    	vm.library = $stateParams;
    	vm.media = $mdMedia;
    	//Get user from cookie storage
 		vm.user = CommonService.getCookieUser();
 		vm.loggedUserRole = vm.user.loggedUserRole;
    	vm.libraryLocObj = {};
    	vm.filterObj = {};
    	var listTotalLength = 0;
    	vm.filterObj.from = 0;
        vm.filterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
        vm.locationList = [];
  	    vm.loadingData = false;
	    vm.endless = vm.APP.GLOBAL.ENDLESS;
	    vm.searchLocationCountryList = [];
	    vm.searchLocationProvinceList = [];
	    
	    $scope.libraryLocationObject = {};
	    $scope.libraryLocationObject.countryObj = {};
	    $scope.libraryLocationObject.provinceObj = {};
	    $scope.libraryLocationObject.cityObj = {};
	    $scope.libraryLocationObject.sectorObj = {};
	    $scope.libraryLocationInputSearchObject = {};
	    $scope.libraryLocationInputSearchObject.country = ''; 
    	$scope.libraryLocationInputSearchObject.province = '';
    	$scope.libraryLocationInputSearchObject.city = '';
    	$scope.libraryLocationInputSearchObject.countrySearchKey = '';
    	$scope.libraryLocationInputSearchObject.provinceSearchKey = '';
    	$scope.libraryLocationInputSearchObject.citySearchKey = '';
    	$scope.libraryLocationInputSearchObject.sectorSearchKey = '';
    	$scope.libraryLocationInputSearchObject.isAddOrSaveLocationCountry = false;
    	$scope.libraryLocationInputSearchObject.isAddOrSaveLocationProvince = false;
    	$scope.libraryLocationInputSearchObject.isAddOrSaveLocationCity = false;
    	$scope.libraryLocationInputSearchObject.isAddOrSaveLocationSector = false;
    	
    	$scope.libraryLocationInputObject = {};
    	$scope.libraryLocationInputObject.country = false;
    	$scope.libraryLocationInputObject.province = false;
    	$scope.libraryLocationInputObject.city = false;
    	$scope.libraryLocationInputObject.sector = false;
    	
 		vm.editLocationObject = {};
    	vm.editLocationObject.countryObj = {};
    	vm.editLocationObject.provinceObj = {};
    	vm.editLocationObject.cityObj = {};
    	vm.editLocationObject.sectorObj = {};
    	
    	$scope.editLocationInputSearchObject = {};
    	$scope.editLocationInputSearchObject.country = ''; 
    	$scope.editLocationInputSearchObject.province = '';
    	$scope.editLocationInputSearchObject.city = '';
    	$scope.editLocationInputSearchObject.countrySearchKey = '';
    	$scope.editLocationInputSearchObject.provinceSearchKey = '';
    	$scope.editLocationInputSearchObject.citySearchKey = '';
    	$scope.editLocationInputSearchObject.sectorSearchKey = '';
    	$scope.editLocationInputSearchObject.isAddOrSaveLocationCountry = false;
    	$scope.editLocationInputSearchObject.isAddOrSaveLocationProvince = false;
    	$scope.editLocationInputSearchObject.isAddOrSaveLocationCity = false;
    	$scope.editLocationInputSearchObject.isAddOrSaveLocationSector = false;
    	
    	$scope.editLocationInputObject = {};
    	$scope.editLocationInputObject.country = false;
    	$scope.editLocationInputObject.province = false;
    	$scope.editLocationInputObject.city = false;
    	$scope.editLocationInputObject.sector = false;
    	
    	$scope.libraryAddEntityInputSearchObject = {};
	    $scope.libraryAddEntityInputSearchObject.country = ''; 
    	$scope.libraryAddEntityInputSearchObject.province = '';
    	$scope.libraryAddEntityInputSearchObject.city = '';
    	$scope.libraryAddEntityInputSearchObject.countrySearchKey = '';
    	$scope.libraryAddEntityInputSearchObject.provinceSearchKey = '';
    	$scope.libraryAddEntityInputSearchObject.citySearchKey = '';
    	$scope.libraryAddEntityInputSearchObject.sectorSearchKey = '';
    	$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry = false;
    	$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince = false;
    	$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCity = false;
    	$scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationSector = false;
    	
    	vm.loggedUserRole = CommonService.getCookieUser().loggedUserRole;
    	
	    vm.isHorizon = false;  	  
  	  	vm.searchLocationDetails = function(searchKeyTxt) {
  		  vm.filterObj.searchKey = searchKeyTxt;
    	  if(searchKeyTxt.length > 1 || searchKeyTxt.length == 0){
    		 vm.getLocationList();
    	  }
    	  /*else {
    		 vm.filters.searchKey = searchKeyTxt;
    	 }*/
  	  }
  	  	
  	  vm.locationProfileList = [{
		  	"id":vm.APP.LIBRARY.ALL,
		  	"val":"allProfile"
	    },{
		  	"id":vm.APP.LIBRARY.COUNTRY,
		  	"val":"countryProfile"
	    },
	    {
	    	"id":vm.APP.LIBRARY.PROVINCE,
	    	"val":"provinceProfile"
	    },
	    {
	    	"id":vm.APP.LIBRARY.CITY,
	    	"val":"cityProfile"
	    },
	    {
	    	"id":vm.APP.LIBRARY.SECTOR,
	    	"val":"sectorProfile"
	  }];
  	  
  	  vm.getlocationProfileList = function(profileList,isCallRequired) {
     	vm.filterObj.profileList = profileList;
     	if(profileList == vm.APP.LIBRARY.ALL) {
     		vm.filterObj.locationProfileKey= '';
     	} else if (profileList == vm.APP.LIBRARY.COUNTRY) {
     		vm.filterObj.locationProfileKey = vm.APP.LIBRARY.COUNTRY_CAPS;
     	}else if (profileList == vm.APP.LIBRARY.PROVINCE) {
     		vm.filterObj.locationProfileKey = vm.APP.LIBRARY.PROVINCE_CAPS;
     	}else if (profileList == vm.APP.LIBRARY.CITY) {
     		vm.filterObj.locationProfileKey = vm.APP.LIBRARY.CITY_CAPS;
     	}else if (profileList == vm.APP.LIBRARY.SECTOR) {
     		vm.filterObj.locationProfileKey = vm.APP.LIBRARY.SECTOR_CAPS;
     	}
     	
     	     	
     	if(!isCallRequired){
     		vm.getLocationList('');  //Prevent call from vm.investigationInit function.
     	}
   	  }
  	  
  	  vm.locationSortedList = [{
  		  	"id":"approvedOn",
  		  	"val":"sortbyapproved"
	    },
	    {
	    	"id":"sector,city,province,country",
	    	"val":"sortbyname"
	  }];
  	  
  	  
  	  vm.getlocationSortedList = function(sortBy,isCallRequired) {
    	vm.filterObj.sortBy = sortBy;
    	if(sortBy == 'approvedOn') {
    		vm.filterObj.sortOrder = 'desc';
    	} else if (sortBy == 'sector,city,province,country') {
    		vm.filterObj.sortOrder = 'asc';
    	}
    	
    	$sessionStorage.locationSortBy = sortBy;
    	
    	if(!isCallRequired){
    		vm.getLocationList('');  //Prevent call from vm.investigationInit function.
    	}
  	  }
  	  
  	  //Sort by initialization through session storage
  	  if($sessionStorage.locationSortBy){
  		for(var i=0;i<vm.locationSortedList.length;i++){
  			if(vm.locationSortedList[i].id == $sessionStorage.locationSortBy){
  				vm.sortBy = vm.locationSortedList[i];
  				break;
  			}
  		}
  		vm.getlocationSortedList(vm.sortBy.id,true);  // To get sort by list 
  	  }
  	  
  	  vm.getLocationList = function(type) {
  		if($scope.libraryLocationObject.countryObj && $scope.libraryLocationObject.countryObj.countryId) {
    		vm.filterObj.countryId = $scope.libraryLocationObject.countryObj.countryId;
    	}  else {
    		vm.filterObj.countryId = '';
    	}
    	if($scope.libraryLocationObject.provinceObj && $scope.libraryLocationObject.provinceObj.provinceId) {
    		vm.filterObj.provinceId = $scope.libraryLocationObject.provinceObj.provinceId;
    	} else {
    		vm.filterObj.provinceId = '';
    	}
    	if($scope.libraryLocationObject.cityObj && $scope.libraryLocationObject.cityObj.cityId) {
    		vm.filterObj.cityId =  $scope.libraryLocationObject.cityObj.cityId;
    	} else {
    		vm.filterObj.cityId = '';
    	}
    	if($scope.libraryLocationObject.sectorObj && $scope.libraryLocationObject.sectorObj.sectorId) {
    		vm.filterObj.sectorId =  $scope.libraryLocationObject.sectorObj.sectorId;
    	} else {
    		vm.filterObj.sectorId = '';
    	}
    	if(angular.isUndefined(vm.sortBy) || angular.isUndefined(vm.sortBy.val)) {
    		vm.filterObj.sortBy = 'approvedOn';
    		vm.filterObj.sortOrder = 'desc';
    	} 
    	vm.loadingData = true;
  		  if(type != vm.endless){
  			  vm.locationList = [];
  		  }
  		  if(vm.locationList && vm.locationList.length == 0){
  			  vm.filterObj.from = 0;
  			  listTotalLength = 0;
	      } else if(vm.locationList.length > 0){
    		vm.filterObj.from = vm.locationList.length;
    	  }
  		  if(vm.locationSearchKey != undefined && (vm.locationSearchKey.length > 1 || vm.locationSearchKey.length == 0) ){
  			  vm.filterObj.searchKey = vm.locationSearchKey;
  		  }
  		  
  		  $sessionStorage.locFilter = $scope.libraryLocationObject;
  		  
  		  if(vm.filterObj.from < listTotalLength || listTotalLength == 0){
  			  var data = LibraryLocationService.getLocationLists(vm.filterObj);
  			  data.then(function(response){
  				  vm.loadingData = false;
  				  vm.noMoreMembers = false;
  				  if(response && !angular.equals({}, response) && response.totalCount){
  					  listTotalLength = response.totalCount;
						  //approvedDate split in response for spanish translation
						  angular.forEach(response.approvedLocationDTOList, function (value, key) {
							  if (value.approvedDate != "" && value.approvedDate != null) {
								  value.approvedLocationMonth = value.approvedDate.substring(0, 3)
								  value.approvedLocationDay = value.approvedDate.substring(3, 7)
								  value.approvedLocationYear = value.approvedDate.substring(7, 12)
							  }
  						  if(vm.locationList == null){
  							  vm.locationList = [];
  							  vm.locationList.push(value);
  						  } else{
  							  vm.locationList.push(value);
  						  }
  					  });
  					  vm.filterObj.from = vm.locationList.length;
  					  if(vm.filterObj.from == listTotalLength){
  						  vm.loadingData = false;
  						  vm.noMembers = false;
  						  vm.noMoreMembers = true;
	       			  }
  					  if(vm.filterObj.from <= vm.APP.GLOBAL.DEFAULT_SIZE){
  						  vm.noMoreMembers = false;
  					  }
  				  } else if(angular.isUndefined(response)){
  					  vm.loadingData  = false;
  					  vm.noMembers = true;
  					  vm.noMoreMembers = false;
  				  }
  				if($sessionStorage.locFilter && Object.keys($sessionStorage.locFilter).length > 0){
    		  		  $scope.libraryLocationObject = $sessionStorage.locFilter;
    			} 
  			 }, function(reason) {
  				 vm.loadingData  = false;
  				 return reason;
  			 });
    	 } else {
    		 vm.loadingData = false;
    		 vm.noMoreMembers = true;
    		 vm.noMembers = false;
	   	 }
  	  } 
  	  
  	if($sessionStorage.locFilter && Object.keys($sessionStorage.locFilter).length > 0){
			$scope.libraryLocationObject = $sessionStorage.locFilter;
			vm.getLocationList();
		}
  	  
  	  $scope.callListfun = function(){
  		  vm.getLocationList(vm.endless);
  	  };
  	  
  	$scope.mapId = '';
  	vm.locationProfileShow = function(event,location){
  		$scope.isConflict = false;
  		vm.existFlag = false;
  		var id='locationProfilePopupId';
  		$scope.mapId = location.locationMappingId;
  		var data = LibraryRequestService.getRequestProfileById(location.locationMappingId);
  		data.then(function(response) {
  			vm.locationProfile = response;
  			//Set LocationType 
  			if(vm.locationProfile.sectorTxt != null){
  				vm.locationTypeName = vm.APP.LIBRARY.SECTOR;
  			} else if(vm.locationProfile.cityTxt != null){
  				vm.locationTypeName = vm.APP.LIBRARY.CITY;
  			} else if(vm.locationProfile.provinceTxt != null){
  				vm.locationTypeName = vm.APP.LIBRARY.PROVINCE;
  			} else if(vm.locationProfile.countryTxt != null){
  				vm.locationTypeName = vm.APP.LIBRARY.COUNTRY;
  			}
    	});
  		$mdDialog.show({
 			targetEvent: event,
 			contentElement:'#'+id,
 			parent: angular.element(document.body)
	    	});
  	}
  	
	vm.cancel = function(){ /* isCancel is parameter*/
   		$mdDialog.hide();
   		$scope.isConflict = false;
   		$scope.showEditpage = false;
   		$scope.btnViewChange = false;
   		$scope.showEditpage = false;
   	   	$scope.isProvinceEdit = false;
   	   	$scope.isCityEdit = false;
   	   	$scope.isSectorEdit = false;
   	   	$scope.isCountryEdit = false;
   	   	$scope.isEmptyProvinceVal = false;
   	   	$scope.isEmptySectorVal = false;
   	   	$scope.isEmptyCityVal = false;
   	   	$scope.isEmptyCountryVal = false;
		vm.locationProfile = {};
   		/*if(isCancel) {
   			$scope.editLocationInputSearchObject = {};
   	    	$scope.editLocationInputSearchObject.country = ''; 
   	    	$scope.editLocationInputSearchObject.province = '';
   	    	$scope.editLocationInputSearchObject.city = '';
   	    	$scope.editLocationInputSearchObject.countrySearchKey = '';
   	    	$scope.editLocationInputSearchObject.provinceSearchKey = '';
   	    	$scope.editLocationInputSearchObject.citySearchKey = '';
   	    	$scope.editLocationInputSearchObject.sectorSearchKey = '';
   	    	$scope.editLocationInputSearchObject.isAddOrSaveLocationCountry = false;
   	    	$scope.editLocationInputSearchObject.isAddOrSaveLocationProvince = false;
   	    	$scope.editLocationInputSearchObject.isAddOrSaveLocationCity = false;
   	    	$scope.editLocationInputSearchObject.isAddOrSaveLocationSector = false;
   		}*/
   	};
   	
   	vm.sideNavClose = function () {
    	$mdSidenav('right').close();
    }
   	
   	$scope.showEditpage = false;
   	$scope.btnViewChange = false;
   	$scope.isProvinceEdit = false;
   	$scope.isCityEdit = false;
   	$scope.isSectorEdit = false;
   	$scope.isCountryEdit = false;
   	$scope.isEmptyProvinceVal = false;
   	$scope.isEmptySectorVal = false;
   	$scope.isEmptyCityVal = false;
   	$scope.isEmptyCountryVal = false;
   	$scope.editProfileType = '';
   	vm.locationProfileDetail = {};
   	
   	vm.editLocationProfile = function(mapId) {
   		var data = LibraryRequestService.getRequestProfileById(mapId);
  		data.then(function(response) {
  			vm.locationProfileDetail = response;
  			$scope.showEditpage = true;
  	   		$scope.btnViewChange = true;
  	   		vm.countryValidationFlag = false;
  	   		vm.provinceValidationFlag = false;
  	   		vm.cityValidationFlag = false;
  	   		vm.sectorValidationFlag = false;
  	   		vm.isUpdateLocationDisabled =false;
  	   		
  	   		communicationService.setData('isAddOrSaveLocation',true);
	  	   	vm.editLocationObject.countryObj = LibraryService.getCountryObj(vm.locationProfileDetail);
			vm.editLocationObject.provinceObj = LibraryService.getProvinceObj(vm.locationProfileDetail);
			vm.editLocationObject.cityObj = LibraryService.getCityObj(vm.locationProfileDetail);
			vm.editLocationObject.sectorObj = LibraryService.getSectorObj (vm.locationProfileDetail);
			
			if(vm.editLocationObject.countryObj.countryId != null && vm.editLocationObject.countryObj.countryId != '') {
				$scope.editProfileType = 'country';
				$scope.isCountryEdit = true;
				$scope.isEmptyCountryVal = false;
				if(vm.editLocationObject.sectorObj.sectorId == null || vm.editLocationObject.sectorObj.sectorId == '' || vm.editLocationObject.sectorObj.sectorId == undefined) {
					$scope.isEmptySectorVal = true;
				} 
				if(vm.editLocationObject.cityObj.cityId == null || vm.editLocationObject.cityObj.cityId == '' || vm.editLocationObject.cityObj.cityId == undefined) {
					$scope.isEmptyCityVal = true;
				} 
				if(vm.editLocationObject.provinceObj.provinceId == null || vm.editLocationObject.provinceObj.provinceId == '' || vm.editLocationObject.provinceObj.provinceId == undefined) {
					$scope.isEmptyProvinceVal = true;
				} 
			} else {
				$scope.isCountryEdit = false;
			}
			if(vm.editLocationObject.provinceObj.provinceId != null && vm.editLocationObject.provinceObj.provinceId != '') {
				$scope.editProfileType = 'province';
				$scope.isProvinceEdit = true;
				$scope.isEmptyProvinceVal = false;
				if(vm.editLocationObject.sectorObj.sectorId == null || vm.editLocationObject.sectorObj.sectorId == '' || vm.editLocationObject.sectorObj.sectorId == undefined) {
					$scope.isEmptySectorVal = true;
				} 
				if(vm.editLocationObject.cityObj.cityId == null || vm.editLocationObject.cityObj.cityId == '' || vm.editLocationObject.cityObj.cityId == undefined) {
					$scope.isEmptyCityVal = true;
				}
				if(vm.editLocationObject.countryObj.countryId) {
					$scope.isCountryEdit = false;
				}
			} else {
				$scope.isProvinceEdit = false;
			}
			if(vm.editLocationObject.cityObj.cityId != null && vm.editLocationObject.cityObj.cityId != '') {
				$scope.editProfileType = 'city';
				$scope.isCityEdit = true;
				$scope.isEmptyCityVal = false;
				if(vm.editLocationObject.sectorObj.sectorId == null || vm.editLocationObject.sectorObj.sectorId == '' || vm.editLocationObject.sectorObj.sectorId == undefined) {
					$scope.isEmptySectorVal = true;
				}
				if(vm.editLocationObject.provinceObj.provinceId && vm.editLocationObject.countryObj.countryId) {
					$scope.isProvinceEdit = false;
					$scope.isCountryEdit = false;
				}
			} else {
				$scope.isCityEdit = false;
			}
			if(vm.editLocationObject.sectorObj.sectorId != null && vm.editLocationObject.sectorObj.sectorId != '') {
				$scope.editProfileType = 'sector';
				$scope.isSectorEdit = true;
				$scope.isEmptySectorVal = false;
				if(vm.editLocationObject.provinceObj.provinceId && vm.editLocationObject.cityObj.cityId && vm.editLocationObject.countryObj.countryId) {
					$scope.isProvinceEdit = false;
					$scope.isCityEdit = false;
					$scope.isCountryEdit = false;
				}
			} else {
				$scope.isSectorEdit = false;
			}
    	});
   	}
   	
   	vm.locationUpdateDetail = {};
   	vm.updateLocationDetail = function(event) {
   		vm.isUpdateLocationDisabled = true;
		if($scope.editProfileType == 'country') {
   			vm.locationUpdateDetail.id = vm.editLocationObject.countryObj.countryId;
   			vm.locationUpdateDetail.name = vm.editLocationObject.countryObj.countryTxt;
   			if(vm.editLocationObject.countryObj.countryTxt == null || vm.editLocationObject.countryObj.countryTxt == ''){
				vm.countryValidationFlag = true;
			}
   		} else if($scope.editProfileType == 'province') {
   			vm.locationUpdateDetail.id = vm.editLocationObject.provinceObj.provinceId;
   			vm.locationUpdateDetail.name = vm.editLocationObject.provinceObj.provinceTxt;
   			if(vm.editLocationObject.provinceObj.provinceTxt == null || vm.editLocationObject.provinceObj.provinceTxt == ''){
				vm.provinceValidationFlag = true;
			}
   		}  else if($scope.editProfileType == 'city') {
   			vm.locationUpdateDetail.id = vm.editLocationObject.cityObj.cityId;
   			vm.locationUpdateDetail.name = vm.editLocationObject.cityObj.cityTxt;
   			if(vm.editLocationObject.cityObj.cityTxt == null || vm.editLocationObject.cityObj.cityTxt == ''){
				vm.cityValidationFlag = true;
			}
   		} else if($scope.editProfileType == 'sector') {
   			vm.locationUpdateDetail.id = vm.editLocationObject.sectorObj.sectorId;
   			vm.locationUpdateDetail.name = vm.editLocationObject.sectorObj.sectorTxt;
   			if(vm.editLocationObject.sectorObj.sectorTxt == null || vm.editLocationObject.sectorObj.sectorTxt == ''){
				vm.sectorValidationFlag = true;
			}
   		}
		if(!vm.countryValidationFlag && !vm.provinceValidationFlag && !vm.cityValidationFlag && !vm.sectorValidationFlag) {
			var data = LibraryService.editIndividualLocation(vm.locationUpdateDetail);
			data.then(function(response){
				if(response && response.id) {
					vm.cancel();
					vm.getLocationList();
					notifications.showSuccess({message: vm.APP.LIBRARY.LOCATION_EDITED});
					vm.isUpdateLocationDisabled = false;
				}
			}, function(reason) {
				if(reason.status == 409){
		        	vm.existFlag = true;
		        } else{
		        	notifications.showError({message: vm.APP.LIBRARY.LOCATION_EDITED_PROBLEM});
		        }
				vm.isUpdateLocationDisabled = false;
			});
		} else 
			vm.isUpdateLocationDisabled = false;
		
		$timeout(function () { 
       		vm.countryValidationFlag = false;
       		vm.provinceValidationFlag = false;
       		vm.cityValidationFlag = false;
       		vm.sectorValidationFlag = false;
       		vm.existFlag = false;
   		}, 3000);
   	}
   	
   	vm.closeConfirmDialog = function(event) {
   		vm.existFlag = false;
   		$mdDialog.show({
 			targetEvent: event,
 			contentElement:'#locationProfilePopupId',
 			parent: angular.element(document.body)
	    });
   	}
   	
   	$scope.isConflict = false;
   	vm.deleteLocation = function(event) {
   		vm.isDeleteLocationDisable = true;
   		var data = LibraryService.deleteLocationDetail($scope.mapId);
		data.then(function(response){
			$scope.isConflict = false;
			$mdDialog.hide();
			vm.getLocationList();
			notifications.showSuccess({message: vm.APP.LIBRARY.LOCATION_DELETED});
			vm.isDeleteLocationDisable = false;
		}, function(err){
			if(err.status == '409') {
				$scope.isConflict = true;
				$scope.errorConflictMsg = vm.APP.LIBRARY.DELETE_PROBLEM;
			}else{
				notifications.showError({message: vm.APP.LIBRARY.LOCATION_DELETED_PROBLEM});
			}
			vm.isDeleteLocationDisable = false;
		});
   	}
   	
   	vm.deleteConfirmDialog = function(event, id) {
   		$scope.isConflict = false;
   		vm.isDeleteLocationDisable = false;
   		$mdDialog.show({
 			targetEvent: event,
 			contentElement:'#'+id,
 			parent: angular.element(document.body)
	    });
   	}
   	
   	$scope.enableUpdateCall = false;
   	vm.updateLocationProfileDetail = function(event) {
   		vm.editedLocationDetail = {};
   		if(vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) {
   			vm.editedLocationDetail.countryId = vm.editLocationObject.countryObj.countryId;
   			vm.editedLocationDetail.countryTxt = vm.editLocationObject.countryObj.countryTxt;
   			$scope.enableUpdateCall = true;
   		} else if($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') {
   			vm.editedLocationDetail.countryTxt = $scope.editLocationInputSearchObject.countrySearchKey;
   			$scope.enableUpdateCall = true;
   		} else {
   			$scope.enableUpdateCall = false;
   		}
   		if(vm.editLocationObject.provinceObj && vm.editLocationObject.provinceObj.provinceId != null) {
   			if(vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) {
   				vm.editedLocationDetail.provinceId = vm.editLocationObject.provinceObj.provinceId;
   	   			vm.editedLocationDetail.provinceTxt = vm.editLocationObject.provinceObj.provinceTxt;
   	   			$scope.enableUpdateCall = true;
   			} else if($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') {
   				vm.editedLocationDetail.provinceId = vm.editLocationObject.provinceObj.provinceId;
   	   			vm.editedLocationDetail.provinceTxt = vm.editLocationObject.provinceObj.provinceTxt;
   				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			} 
   		} else if($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '') {
   			if(vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) {
   				vm.editedLocationDetail.provinceTxt = $scope.editLocationInputSearchObject.provinceSearchKey;
   	   			$scope.enableUpdateCall = true;
   			} else if($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') {
   				vm.editedLocationDetail.provinceTxt = $scope.editLocationInputSearchObject.provinceSearchKey;
   				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			}
   		}
   		if(vm.editLocationObject.cityObj && vm.editLocationObject.cityObj.cityId != null) {
   			if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)) {
   				vm.editedLocationDetail.cityId = vm.editLocationObject.cityObj.cityId;
   	   			vm.editedLocationDetail.cityTxt = vm.editLocationObject.cityObj.cityTxt;
   	   			$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')) {
   				vm.editedLocationDetail.cityId = vm.editLocationObject.cityObj.cityId;
   	   			vm.editedLocationDetail.cityTxt = vm.editLocationObject.cityObj.cityTxt;
   				$scope.enableUpdateCall = true;
   			} else if(($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')) {
   				vm.editedLocationDetail.cityId = vm.editLocationObject.cityObj.cityId;
   	   			vm.editedLocationDetail.cityTxt = vm.editLocationObject.cityObj.cityTxt;
   				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			}
   		} else if($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '') {
   			if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)) {
   				vm.editedLocationDetail.cityTxt = $scope.editLocationInputSearchObject.citySearchKey;
   	   			$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')) {
   				vm.editedLocationDetail.cityTxt = $scope.editLocationInputSearchObject.citySearchKey;
   				$scope.enableUpdateCall = true;
   			} else if(($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')) {
   				vm.editedLocationDetail.cityTxt = $scope.editLocationInputSearchObject.citySearchKey;
   				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			}
   		}
   		if(vm.editLocationObject.sectorObj && vm.editLocationObject.sectorObj.sectorId != null) {
   			if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)
   					&& (vm.editLocationObject.cityObj && vm.editLocationObject.cityObj.cityId != null)) {
   				vm.editedLocationDetail.sectorId = vm.editLocationObject.sectorObj.sectorId;
   	   			vm.editedLocationDetail.sectorTxt = vm.editLocationObject.sectorObj.sectorTxt;
   				$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
   				vm.editedLocationDetail.sectorId = vm.editLocationObject.sectorObj.sectorId;
   	   			vm.editedLocationDetail.sectorTxt = vm.editLocationObject.sectorObj.sectorTxt;
   				$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
   				vm.editedLocationDetail.sectorId = vm.editLocationObject.sectorObj.sectorId;
   	   			vm.editedLocationDetail.sectorTxt = vm.editLocationObject.sectorObj.sectorTxt;
   				$scope.enableUpdateCall = true;
   			} else if(($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
				vm.editedLocationDetail.sectorId = vm.editLocationObject.sectorObj.sectorId;
				vm.editedLocationDetail.sectorTxt = vm.editLocationObject.sectorObj.sectorTxt;
				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			}
   		} else if($scope.editLocationInputSearchObject.sectorSearchKey != null && $scope.editLocationInputSearchObject.sectorSearchKey != '') {
   			if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)
   					&& (vm.editLocationObject.cityObj && vm.editLocationObject.cityObj.cityId != null)) {
   	   			vm.editedLocationDetail.sectorTxt = $scope.editLocationInputSearchObject.sectorSearchKey;
   				$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && (vm.editLocationObject.provinceObj && vm.editLocationObject.countryObj.provinceId != null)
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
   				vm.editedLocationDetail.sectorTxt = $scope.editLocationInputSearchObject.sectorSearchKey;
   				$scope.enableUpdateCall = true;
   			} else if((vm.editLocationObject.countryObj && vm.editLocationObject.countryObj.countryId != null) && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
   				vm.editedLocationDetail.sectorTxt = $scope.editLocationInputSearchObject.sectorSearchKey;
   				$scope.enableUpdateCall = true;
   			} else if(($scope.editLocationInputSearchObject.countrySearchKey != null && $scope.editLocationInputSearchObject.countrySearchKey != '') && ($scope.editLocationInputSearchObject.provinceSearchKey != null && $scope.editLocationInputSearchObject.provinceSearchKey != '')
   					&& ($scope.editLocationInputSearchObject.citySearchKey != null && $scope.editLocationInputSearchObject.citySearchKey != '')) {
   				vm.editedLocationDetail.sectorTxt = $scope.editLocationInputSearchObject.sectorSearchKey;
				$scope.enableUpdateCall = true;
   			} else {
   				$scope.enableUpdateCall = false;
   			}
   		}
   		if($scope.enableUpdateCall) {
   			var data = LibraryService.editLocation(vm.editedLocationDetail);
   			data.then(function(response){
   				if(response && response.id) {
   					communicationService.setData('isAddOrSaveLocation',false);
   					vm.cancel(true);
   					$timeout(function(){
   						vm.openSuccessDialog('successAddLocation',event);
   					},100);
   				}
   			});
   		}
   	}
  	  
  }
})();
(function () {
  "use strict";

  angular.module("lariAidApp").service("LibraryLocationService", LibraryLocationService);

  LibraryLocationService.$inject = ["$resource", "restService", "$q", "$rootScope", "$http", "BASE_URL"];

  function LibraryLocationService($resource, restService, $q, $rootScope, $http, BASE_URL) {
    this.loadAllLocationsByType = function (postObj, type) {
      var deferred = $q.defer();
      var url = "locations/" + type;
      var data = restService.restCall(postObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    var deferredLocation = $q.defer();
    this.getLocationLists = function (filterObj) {
      if (deferredLocation != undefined) {
        deferredLocation.resolve();
        deferredLocation = $q.defer();
      }

      var url = BASE_URL + "api/approved-location-mappings";
      var promise = $http.post(url, filterObj, { timeout: deferredLocation.promise }).then(function (response) {
        return response.data;
      });

      return promise;
    };
    this.validateLocationMapping = function(locationMappingObject) {
			var deferred = $q.defer();
    		var url = "location-mapping/validate";
    		var data = restService.restCall(locationMappingObject, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
		}

  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider','APP'];
    
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('locations', {
            parent: 'library',
            url: '/locations',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	libraryType:null
            },
            views: {
                'libraryList': {
                    templateUrl: 'app/library/location/library.location.html',
                    controller: 'LibraryLocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("3");
                	$timeout(function() {
                	    angular.element('#location').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();
(function() {
	'use strict';

    angular
        .module('lariAidApp').directive('locationFilter',locationDropFilter);
    
    function locationDropFilter(){
			return {
			    templateUrl: 'app/library/locationdirective/library.locationdirective.html',
				controller:'LibraryLocationDirectiveController',
			    transclude:true,
				replace: true,
			    restrict: 'E',
				scope:{
					modelObject: '=modelObject',
					call: '&',
					horizon: '=horizonFlag',
					validation:'=validationRequired',
					formName:'=formName',
					isValidation:"=",
					savevalid: '&',
					inputsearchObject: '=inputsearchObject',
					disableFlag: '=disableFlag',
					ishideObject:'=ishideObject',
					relpaceinputfield: '&',
					relpaceinputfieldObject:'=relpaceinputfieldObject',
					media: '=media'
				},
			    link: function(scope, element, attrs) {
			    }
		    }
			
		}
    
})();
(function() {
	'use strict';

    angular
        .module('lariAidApp')
        .controller('LibraryLocationDirectiveController', LibraryLocationDirectiveController);
    
    LibraryLocationDirectiveController.$inject = ['$rootScope','$scope','$state','$stateParams','$mdSidenav','$element','APP','tabservice','$mdMedia','LibraryLocationService','$q','$timeout','$sessionStorage','communicationService'];
    
    function LibraryLocationDirectiveController($rootScope,$scope,$state,$stateParams,$mdSidenav,$element,APP,tabservice,$mdMedia,LibraryLocationService,$q,$timeout,$sessionStorage,communicationService){
    	
    	var vm = this;
    	vm.APP = APP;
    	vm.library = $stateParams;
    	vm.media = $mdMedia;
        vm.locationList = [];
  	    vm.loadingData = false;
	    $scope.searchLocationCountryList = [];
	    $scope.searchLocationProvinceList = [];
	    $scope.searchLocationCityList = [];
	    $scope.searchLocationSectorList = [];
	    $scope.locLoader = false;
	    $scope.modelObject = {};
	    
	    vm.currentState = $state.current.name;
	    
	    $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });
	    
	    $scope.checkRequiredFields = function(modelName,fieldId){
	    	var result = false;
	    	if($scope.modelObject[modelName] && $scope.modelObject[modelName][fieldId]){
       		 	result = true;
   		 	}
    		 return result;
	    };
	    
	    $scope.searchLocation = function(searchText,type, delayCall){
			  if(searchText && searchText.length >= 2){
				  $scope.inputsearchObject.isInputEmptyCountry = false;
				  var deferred = $q.defer();
				  $scope.libraryLocObj = {};
				  $scope.libraryLocObj.searchKey = searchText;
				  if($scope.modelObject) {
					  if($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryId != null) {
						  $scope.libraryLocObj.countryId = $scope.modelObject.countryObj.countryId;
	  				  }
	  				  if($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId != null ) {
	  					$scope.libraryLocObj.provinceId = $scope.modelObject.provinceObj.provinceId;
	  				  }
	  				  if($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId != null) {
	  					$scope.libraryLocObj.cityId = $scope.modelObject.cityObj.cityId;
	  				  }
	  				  if($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId != null) {
	  					$scope.libraryLocObj.sectorId = $scope.modelObject.sectorObj.sectorId;
	  				  }
				  }
				  if(communicationService.getData('isAddOrSaveLocation')) {
					  if(type == 'COUNTRY') {
						  if($scope.inputsearchObject.country) {
							  $scope.locLoader = true;
							  var data = LibraryLocationService.loadAllLocationsByType($scope.libraryLocObj,type);
							  data.then(function(response){
								  $scope.locLoader = false;
								  if(response.autoSuggestionLocationDTOList.length > 0){
									  if(type == 'COUNTRY') {
										  $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
										  if(communicationService.getData('isAddOrSaveLocation')) {
											  	$scope.inputsearchObject.countrySearchKey = '';
								  				$scope.inputsearchObject.isInputEmptyCountry = false;
								  				$scope.inputsearchObject.isInputEmptyProvince = false;
								  		        $scope.inputsearchObject.isInputEmptyCity = false;
								  		       	$scope.inputsearchObject.isInputEmptySector = false;
											  	$scope.inputsearchObject.isAddOrSaveLocationCountry = false;
											  	$scope.inputsearchObject.isAddOrSaveLocationProvince = false;
											  	$scope.inputsearchObject.isAddOrSaveLocationCity = false;
											  	$scope.inputsearchObject.isAddOrSaveLocationSector = false;
								  			}
									  } else if(type == 'PROVINCE') {
										  $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
									  } else if(type == 'CITY') {
										  $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
									  } else if(type == 'SECTOR') {
										  $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
									  }
								  } else {
									  if(type == 'COUNTRY') {
										  $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
									  } else if(type == 'PROVINCE') {
										  $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
									  } else if(type == 'CITY') {
										  $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
									  } else if(type == 'SECTOR') {
										  $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
									  }
									  $scope.loadNewInputFields(type,searchText);
								  }
								  if(type == 'COUNTRY') {
									  deferred.resolve($scope.searchLocationCountryList);
								  } else if(type == 'PROVINCE') {
									  deferred.resolve($scope.searchLocationProvinceList);
								  } else if(type == 'CITY') {
									  deferred.resolve($scope.searchLocationCityList);
								  } else if(type == 'SECTOR') {
									  deferred.resolve($scope.searchLocationSectorList);
								  }
							  });
							  return deferred.promise;
						  } else {
							  $scope.loadNewInputFields(type,searchText);
						  }
					  } else {
						  $scope.getListCall(type,searchText);
					  }
				  } else {
					  $scope.getListCall(type,searchText,delayCall);
				  }
			  }
	  };
	  
	  $scope.loadNewInputFields = function(type,searchText) {
		  if(type == 'COUNTRY') {
			  $scope.inputsearchObject.countrySearchKey = searchText;
			  $scope.inputsearchObject.isAddOrSaveLocationCountry = true;
			  $scope.inputsearchObject.isAddOrSaveLocationProvince = true;
			  $scope.inputsearchObject.isAddOrSaveLocationCity = true;
			  $scope.inputsearchObject.isAddOrSaveLocationSector = true;
		  }  else if(type == 'PROVINCE') {
			  $scope.inputsearchObject.provinceSearchKey = searchText;
			  $scope.inputsearchObject.isAddOrSaveLocationProvince = true;
			  $scope.inputsearchObject.isAddOrSaveLocationCity = true;
			  $scope.inputsearchObject.isAddOrSaveLocationSector = true;
		  } else if(type == 'CITY') {
			  $scope.inputsearchObject.citySearchKey = searchText;
			  $scope.inputsearchObject.isAddOrSaveLocationCity = true;
			  $scope.inputsearchObject.isAddOrSaveLocationSector = true;
		  } else if(type == 'SECTOR') {
			  $scope.inputsearchObject.sectorSearchKey = searchText;
			  $scope.inputsearchObject.isAddOrSaveLocationSector = true;
		  } 
	  }
	  
	  $scope.getListCall = function(type,searchText,delayCall) {
		  var deferred = $q.defer();
		  $scope.locLoader = true;
		  var data = LibraryLocationService.loadAllLocationsByType($scope.libraryLocObj,type);
		  data.then(function(response){
			  $scope.locLoader = false;
			  if(response.autoSuggestionLocationDTOList.length > 0){
				  if(type == 'COUNTRY') {
					  $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
					  if(delayCall) {
						  $scope.populatePreFillDetails($scope.searchLocationCountryList[0]);
					  }
				  } else if(type == 'PROVINCE') {
					  $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
					  if(communicationService.getData('isAddOrSaveLocation')) {
			  				$scope.inputsearchObject.isInputEmptyCountry = false;
			  		       	$scope.inputsearchObject.isInputEmptyProvince = false;
			  		       	$scope.inputsearchObject.provinceSearchKey = '';
			  		       	$scope.inputsearchObject.isAddOrSaveLocationCountry = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationProvince = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationCity = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationSector = false;
			  			}
					  if(delayCall) {
						  $scope.populatePreFillDetails($scope.searchLocationProvinceList[0]);
					  }
				  } else if(type == 'CITY') {
					  $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
					  if(communicationService.getData('isAddOrSaveLocation')) {
			  				$scope.inputsearchObject.isInputEmptyCountry = false;
			  		       	$scope.inputsearchObject.isInputEmptyProvince = false;
			  		       	$scope.inputsearchObject.isInputEmptyCity = false;
			  		       	$scope.inputsearchObject.citySearchKey = '';
			  		       	$scope.inputsearchObject.isAddOrSaveLocationCountry = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationProvince = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationCity = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationSector = false;
			  		  }
					  if(delayCall) {
						  $scope.populatePreFillDetails($scope.searchLocationCityList[0]);
					  }
				  } else if(type == 'SECTOR') {
					  $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
					  if(communicationService.getData('isAddOrSaveLocation')) {
			  				$scope.inputsearchObject.isInputEmptyCountry = false;
			  		       	$scope.inputsearchObject.isInputEmptyProvince = false;
			  		        $scope.inputsearchObject.isInputEmptyCity = false;
			  		       	$scope.inputsearchObject.isInputEmptySector = false;
				  		  	$scope.inputsearchObject.sectorSearchKey = '';
				  		  	$scope.inputsearchObject.isAddOrSaveLocationCountry = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationProvince = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationCity = false;
						  	$scope.inputsearchObject.isAddOrSaveLocationSector = false;
			  		  }
				  }
			  } else {
				  if(type == 'COUNTRY') {
					  $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
				  } else if(type == 'PROVINCE') {
					  $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
				  } else if(type == 'CITY') {
					  $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
				  } else if(type == 'SECTOR') {
					  $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
				  }
				  $scope.loadNewInputFields(type,searchText);
			  }
			  if(type == 'COUNTRY') {
				  deferred.resolve($scope.searchLocationCountryList);
			  } else if(type == 'PROVINCE') {
				  deferred.resolve($scope.searchLocationProvinceList);
			  } else if(type == 'CITY') {
				  deferred.resolve($scope.searchLocationCityList);
			  } else if(type == 'SECTOR') {
				  deferred.resolve($scope.searchLocationSectorList);
			  }
			  
		  });
		  return deferred.promise;
	  }
	    
	  $scope.clear = function(type){
  		if(type == 'COUNTRY') {
  			$scope.modelObject.countryObj = {};
  			if($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId) {
  				$scope.modelObject.provinceObj = {};
  			}
  			if($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId) {
  				$scope.modelObject.cityObj = {};
  			}
  			if($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
  				$scope.modelObject.sectorObj = {};
  			}
  			if(communicationService.getData('isAddOrSaveLocation')) {
  				$scope.inputsearchObject.isInputEmptyCountry = false;
  		       	$scope.inputsearchObject.isInputEmptyProvince = false;
  		       	$scope.inputsearchObject.isInputEmptyCity = false;
  		       	$scope.inputsearchObject.isInputEmptySector = false;
  		        $scope.inputsearchObject.countrySearchKey = '';
  		        $scope.inputsearchObject.provinceSearchKey = '';
  		        $scope.inputsearchObject.citySearchKey = '';
  		        $scope.inputsearchObject.sectorSearchKey = '';
			    $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
			    $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
			    $scope.inputsearchObject.isAddOrSaveLocationCity = false;
			    $scope.inputsearchObject.isAddOrSaveLocationSector = false;
  			}
  			vm.clearNewCountryFields();
  			vm.clearNewProvinceFields();
  			vm.clearNewCityFields();
  			vm.clearNewSectorFields();
  		} else if(type == 'PROVINCE') {
  			$scope.modelObject.provinceObj = {};
  			if($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId) {
  				$scope.modelObject.cityObj = {};
  			}
  			if($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
  				$scope.modelObject.sectorObj = {};
  			}
  			if(communicationService.getData('isAddOrSaveLocation')) {
  		       	$scope.inputsearchObject.isInputEmptyProvince = false;
  		       	$scope.inputsearchObject.isInputEmptyCity = false;
  		       	$scope.inputsearchObject.isInputEmptySector = false;
		        $scope.inputsearchObject.provinceSearchKey = '';
		        $scope.inputsearchObject.citySearchKey = '';
		        $scope.inputsearchObject.sectorSearchKey = '';
			    $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
			    $scope.inputsearchObject.isAddOrSaveLocationCity = false;
			    $scope.inputsearchObject.isAddOrSaveLocationSector = false;
  			}
  			if(vm.currentState == vm.APP.LIBRARY.ENTITY) {
  				$scope.searchLocation($scope.modelObject.countryObj.countryTxt,'COUNTRY', true);
  			}
  			vm.clearNewProvinceFields();
  			vm.clearNewCityFields();
  			vm.clearNewSectorFields();
  		}else if(type == 'CITY') {
			$scope.modelObject.cityObj = {};
  			if($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
  				$scope.modelObject.sectorObj = {};
  			}
  			if(communicationService.getData('isAddOrSaveLocation')) {
  		       	$scope.inputsearchObject.isInputEmptyCity = false;
  		       	$scope.inputsearchObject.isInputEmptySector = false;
  		       	$scope.inputsearchObject.citySearchKey = '';
		        $scope.inputsearchObject.sectorSearchKey = '';
			    $scope.inputsearchObject.isAddOrSaveLocationCity = false;
			    $scope.inputsearchObject.isAddOrSaveLocationSector = false;
  			}
  			if(vm.currentState == vm.APP.LIBRARY.ENTITY) {
  				$scope.searchLocation($scope.modelObject.provinceObj.provinceTxt,'PROVINCE', true);
  			}
  			vm.clearNewCityFields();
  			vm.clearNewSectorFields();
  		} else if(type == 'SECTOR') {
			$scope.modelObject.sectorObj = {};
			if(communicationService.getData('isAddOrSaveLocation')) {
  		       	$scope.inputsearchObject.isInputEmptySector = false;
		        $scope.inputsearchObject.sectorSearchKey = '';
			    $scope.inputsearchObject.isAddOrSaveLocationSector = false;
  			}
			if(vm.currentState == vm.APP.LIBRARY.ENTITY) {
				$scope.searchLocation($scope.modelObject.cityObj.cityTxt,'CITY', true);
			}
			vm.clearNewSectorFields();
  		}
  	  }
  	
	  $scope.populatePreFillDetails = function(locationObj) {
  		  if(locationObj) {
  			$scope.copyLocationObj = angular.copy(locationObj);
			  if($scope.copyLocationObj.countryId != null ) {
				  $scope.modelObject.countryObj = $scope.copyLocationObj;
			  }
			  if($scope.copyLocationObj.provinceId != null) {
				$scope.modelObject.provinceObj = $scope.copyLocationObj;
			  }
			  if($scope.copyLocationObj.cityId != null) {
				$scope.modelObject.cityObj = $scope.copyLocationObj;
			  }
			  if($scope.copyLocationObj.sectorId != null) {
				$scope.modelObject.sectorObj = $scope.copyLocationObj;
			  }
		  }
  	  }
	  
	  $scope.clearName = function(name,searchKey,dropValue){
		  if(!communicationService.getData('isAddOrSaveLocation')) {
			  $scope.inputsearchObject[searchKey] = undefined;
			  $scope[dropValue] = undefined;
			  $scope.inputsearchObject.countrySearchKey = '';
	          $scope.inputsearchObject.provinceSearchKey = '';
	          $scope.inputsearchObject.citySearchKey = '';
	          $scope.inputsearchObject.sectorSearchKey = '';
	          $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
		      $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
		      $scope.inputsearchObject.isAddOrSaveLocationCity = false;
		      $scope.inputsearchObject.isAddOrSaveLocationSector = false;
		  } else {
			  $scope.inputsearchObject[searchKey] = undefined;
			  $scope[dropValue] = undefined;
		  }
  	  }
	  
	  $scope.replaceInputField = function(){
		  var requestType;
		  	if(vm.locationRequestType != null){
		  		requestType=vm.locationRequestType.name;
		  	}
			 if(requestType == vm.APP.LIBRARY.COUNTRY){
				  if(vm.country != null || vm.location.country != null){
					  vm.isEnableSave=true;
				  }
				  if(vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null){
					  vm.isReplaceCountry = true;
					  vm.requestFlagCountryInput=true;
					  vm.location.country=vm.country;
				  }
			 }
			 if(requestType == vm.APP.LIBRARY.PROVINCE){
				 if(vm.province != null){
				  vm.isEnableSave=true;
				 }
				 if(vm.isShowProvince == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj == undefined && vm.province != null){
					  vm.location.province=vm.province;
					  vm.isReplaceProvince = true;
					  vm.requestFlagProvinceInput=true;
					 //vm.isReplaceCountry = false;
				 }
			 }
			 if(requestType == vm.APP.LIBRARY.CITY){
				  if(vm.city != null){
					  vm.isEnableSave=true;
				  }
				  if(vm.isShowCity == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj != null && vm.city != null){
					  vm.location.city=vm.city;
					  vm.isReplaceCity = true;
					  vm.requestFlagCityInput=true;
					  //vm.isReplaceCountry = false;
				  }
			 }
			 if(requestType == vm.APP.LIBRARY.SECTOR){
				 if(vm.city != null){
					  vm.isEnableSave=true;
				  }
				  if(vm.isShowSector == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj != null && vm.addLocationObject.cityObj != null && vm.sector != null){
					  vm.location.sector=vm.sector;
					  vm.isReplaceSector = true;
					  vm.requestFlagSectorInput=true;
					  //vm.isReplaceCountry = false;
				  }
			 }
		  }
	  
	  //Clear new Country Location input container fields
	  vm.clearNewCountryFields = function(){
		  	$scope.inputsearchObject.isHideCountry = false;
		  	if($scope.relpaceinputfieldObject != undefined) {
		  		$scope.relpaceinputfieldObject.country = false;
				$scope.relpaceinputfieldObject.countryKey = undefined;
		  	}
	  };
	  
	  //Clear new Province Location input container fields
	  vm.clearNewProvinceFields = function() {
		  	$scope.inputsearchObject.isHideProvince = false;
		  	if($scope.relpaceinputfieldObject != undefined) {
		  		$scope.relpaceinputfieldObject.province = false;
				$scope.relpaceinputfieldObject.provinceKey = undefined;
		  	}
	  };
	  
	  //Clear new City Location input container fields
	  vm.clearNewCityFields = function() {
		  	$scope.inputsearchObject.isHideCity = false;
		  	if($scope.relpaceinputfieldObject != undefined) {
		  		$scope.relpaceinputfieldObject.city = false;
				$scope.relpaceinputfieldObject.cityKey = undefined;
		  	}
	  };
	
	  //Clear new Sector Location input container fields
	  vm.clearNewSectorFields = function() {
		  	$scope.inputsearchObject.isHideSector = false;
		  	if($scope.relpaceinputfieldObject != undefined) {
		  		$scope.relpaceinputfieldObject.sector = false;
				$scope.relpaceinputfieldObject.sectorKey = undefined;
		  	}
	  };
  	   	  
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('LibraryLocationDirectiveService', LibraryLocationDirectiveService);

    LibraryLocationDirectiveService.$inject = ['$resource', 'restService', '$q'];
    
    function LibraryLocationDirectiveService ($resource, restService, $q) {
    	
		this.loadAllLocationsByType = function(postObj,type) {
			var deferred = $q.defer();
    		var url = "locations/"+type;
    		var data = restService.restCall(postObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
		}
		
    }
})();
(function () {
  "use strict";

  angular.module("lariAidApp").controller("LibraryRequestController", LibraryRequestController);

  LibraryRequestController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "$stateParams",
    "$sessionStorage",
    "$mdSidenav",
    "$element",
    "APP",
    "tabservice",
    "$mdMedia",
    "LibraryRequestService",
    "$q",
    "StorageDelete",
    "$mdDialog",
    "LibraryService",
    "CommonService",
    "$timeout",
    "notifications",
    "communicationService"
  ];

  function LibraryRequestController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $sessionStorage,
    $mdSidenav,
    $element,
    APP,
    tabservice,
    $mdMedia,
    LibraryRequestService,
    $q,
    StorageDelete,
    $mdDialog,
    LibraryService,
    CommonService,
    $timeout,
    notifications,
    communicationService
  ) {
    var vm = this;
    vm.APP = APP;
    vm.state = $state;
    vm.currentState = vm.state.current.name;
    //Get user from cookie storage
    vm.user = CommonService.getCookieUser();
    vm.loggedUserRole = vm.user.loggedUserRole;

    vm.library = $stateParams;
    vm.media = $mdMedia;
    vm.openRequest = [];
    vm.closedRequest = [];
    vm.selectedRequestList = [];
    vm.requestList = [];
    vm.requestFilterObj = {};
    var requestListTotalLength = 0;
    vm.loadingRequestData = false;
    vm.requestFilterObj.from = 0;
    vm.requestFilterObj.size = vm.APP.GLOBAL.DEFAULT_SIZE;
    vm.requestFilterObj.statusKey = [];
    var qPromises = [];
    vm.endless = vm.APP.GLOBAL.ENDLESS;
    vm.entityRequestOld = {};
    vm.entityRequestNew = {};
    vm.entityPopupId;
    vm.popUpId;
    vm.requestDuration = null;

    vm.filterCountLoader = false;
    vm.loadingListData = false;

    vm.locationRequestNew = {};
    vm.locationRequestNew.countryObj = {};
    vm.locationRequestNew.provinceObj = {};
    vm.locationRequestNew.cityObj = {};
    vm.locationRequestNew.sectorObj = {};
    vm.inputIsHideObject = {};

    vm.entityRequestOld.countryObj = {};
    vm.entityRequestOld.provinceObj = {};
    vm.entityRequestOld.cityObj = {};
    vm.entityRequestOld.sectorObj = {};

    vm.relpaceinputfieldObject = {};
    vm.relpaceinputfieldObject.country = false;
    vm.relpaceinputfieldObject.province = false;
    vm.relpaceinputfieldObject.city = false;
    vm.relpaceinputfieldObject.sector = false;
    vm.mergeFlag = false;
    vm.mergeEntity = false;

    vm.closedRequests = vm.APP.LIBRARY.CLOSED_REQUESTS;
    vm.locationIdValidation = false;

    vm.getAllRequestFilters = function (isDefault, formRequest) {
      ///vm.showOpenRequestDiv = false;
      //vm.showCloseRequestDiv = false;
      vm.filterCountLoader = true;
      var data = LibraryRequestService.getRequestFilterList(formRequest);
      data.then(
        function (response) {
          vm.openRequest = response.OPEN_LIBRARY_REQUESTS;
          vm.closedRequest = response.CLOSED_LIBRARY_REQUESTS;
          vm.filterCountLoader = false;
          angular.forEach(vm.openRequest, function (data, key) {
            // Default RoleUser filter selected
            if (isDefault) {
              if (data.name == vm.APP.LIBRARY.RECENTY_ADD) {
                data.checked = true;
                vm.selectedRequestList.push(data);

                vm.requestFilterObj.statusKey.push(data.id);
              }
            }
          });
          if (!isDefault) {
            if ($sessionStorage.selectedRequestList) {
              vm.selectedRequestList = [];
              vm.selectedRequestList = $sessionStorage.selectedRequestList;
            }

            // Default select after refresh
            angular.forEach(vm.closedRequest, function (data, index) {
              angular.forEach(vm.selectedRequestList, function (selected, key) {
                if (data.id == selected.id) {
                  data.checked = true;
                }
              });
            });
            angular.forEach(vm.openRequest, function (data, index) {
              angular.forEach(vm.selectedRequestList, function (selected, key) {
                if (data.id == selected.id) {
                  data.checked = true;
                }
              });
            });
          }
          vm.updateRequestFilterObjList(vm.APP.LIBRARY.REQUEST_STATUS_KEY, vm.selectedRequestList); // Update userFilterObj
        },
        function (reason) {
          vm.loadingListData = false;
          return reason;
        }
      );
      return data;
    };

    vm.sideNavClose = function (id) {
      $mdSidenav(id).close();
    };

    //Common function for toggle based on the filter type
    vm.toggleRequest = function (item, list) {
      //To disable checkboxes
      if (vm.media("gt-sm")) {
        vm.loadingListData = true;
      }
      var idx;
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == item.id) {
          idx = i;
        }
      }
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list = [];
        list.push(item);
      }
      vm.selectedRequestList = list;

      vm.unSelectCall(vm.openRequest, item);
      vm.unSelectCall(vm.closedRequest, item);

      $sessionStorage.selectedRequestList = list;
      vm.updateRequestFilterObjList(vm.APP.LIBRARY.REQUEST_STATUS_KEY, vm.selectedRequestList);

      if (vm.media("gt-sm")) {
        qPromises.push(vm.getAllRequestFilters(false, vm.formRequest));
        $q.all(qPromises).then(function (data) {
          vm.getRequestList();
        });
      }
    };
    vm.unSelectCall = function (list, item) {
      angular.forEach(list, function (data, index) {
        if (data.id != item.id) {
          data.checked = false;
        }
      });
    };
    vm.updateRequestFilterObjList = function (postVariable, selectedList) {
      vm.requestFilterObj[postVariable] = [];
      angular.forEach(selectedList, function (data, key) {
        vm.requestFilterObj[postVariable].push(data.id);
      });
    };
    $scope.callListfun = function () {
      vm.getRequestList(vm.endless);
    };

    var clickingTimerRequest;
    vm.getRequestList = function (type) {
      if (!vm.media("gt-sm")) {
        vm.loadingListData = true;
      }
      clearTimeout(clickingTimerRequest);

      clickingTimerRequest = setTimeout(function () {
        vm.loadingRequestData = true;

        if (type != vm.endless) {
          vm.requestList = [];
        }

        if (vm.requestList && vm.requestList.length == 0) {
          vm.requestFilterObj.from = 0;
          requestListTotalLength = 0;
        } else if (vm.requestList.length > 0) {
          vm.requestFilterObj.from = vm.requestList.length;
        }

        if ($sessionStorage.formRequest) {
          vm.requestFilterObj.formRequest = $sessionStorage.formRequest;
        } else {
          vm.requestFilterObj.formRequest = false;
        }

        if (vm.requestFilterObj.from < requestListTotalLength || requestListTotalLength == 0) {
          var data = LibraryRequestService.getRequestLists(vm.requestFilterObj);
          data.then(
            function (response) {
              vm.loadingRequestData = false;
              vm.noMoreRequests = false;

              if (response && !angular.equals({}, response) && response.totalCount) {
                requestListTotalLength = response.totalCount;
                angular.forEach(response.libraryRequestDTOList, function (value, key) {
                  if (vm.requestList == null) {
                    vm.requestList = [];
                    vm.requestList.push(value);
                  } else {
                    vm.requestList.push(value);
                  }
                });
                vm.requestFilterObj.from = vm.requestList.length;

                if (vm.requestFilterObj.from == requestListTotalLength) {
                  vm.loadingRequestData = false;
                  vm.noMoreRequests = true;
                }

                if (vm.requestFilterObj.from <= vm.APP.GLOBAL.DEFAULT_SIZE) {
                  vm.noMoreRequests = false;
                }
              } else if (angular.isUndefined(response)) {
                vm.loadingRequestData = false;
                vm.noMoreRequests = false;
              }
              vm.loadingListData = false;
            },
            function (reason) {
              return reason;
              vm.loadingListData = false;
            }
          );
        } else {
          vm.loadingRequestData = false;
          vm.loadingListData = false;
          vm.noMoreRequests = true;
        }
      }, 200);
    };

    vm.searchRequest = function (requestSearchKey) {
      vm.requestFilterObj.searchKey = requestSearchKey;
      if (requestSearchKey.length > 1 || requestSearchKey.length == 0) {
        vm.getRequestList();
      }
    };

    vm.getRequestSortedList = function (requestSortBy, isCallRequired) {
      vm.requestFilterObj.sortBy = requestSortBy;
      if (requestSortBy == vm.APP.LIBRARY.REQUEST_SORT_BY_COUNT) {
        vm.requestFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
      } else if (requestSortBy == vm.APP.LIBRARY.REQUEST_SORT_BY_NAME) {
        vm.requestFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
      }

      $sessionStorage.requestSortBy = requestSortBy;

      if (!isCallRequired) {
        vm.getRequestList(); //Prevent call from vm.userInit function.
      }
    };

    vm.getLocationMappingDataById = function (locationMappingId, disable) {
      var locationData = CommonService.getLocationById(locationMappingId);
      locationData.then(function (response) {
        var responseObj = response;
        vm.requestDuration = responseObj.noOfDays;
        //Set location objects
        if (!disable) {
          vm.entityRequestOld.countryObj = LibraryService.getCountryObj(responseObj);
          vm.entityRequestOld.provinceObj = LibraryService.getProvinceObj(responseObj);
          vm.entityRequestOld.cityObj = LibraryService.getCityObj(responseObj);
          vm.entityRequestOld.sectorObj = LibraryService.getSectorObj(responseObj);
        }
        vm.entityRequestNew.countryObj = LibraryService.getCountryObj(responseObj);
        vm.entityRequestNew.provinceObj = LibraryService.getProvinceObj(responseObj);
        vm.entityRequestNew.cityObj = LibraryService.getCityObj(responseObj);
        vm.entityRequestNew.sectorObj = LibraryService.getSectorObj(responseObj);
      });
    };

    vm.getEntityTypeById = function (entityTypeId, disable) {
      //var entityTypeData = CommonService.getRefTermList(vm.APP.REF_TERM.ENTITY_PROFILE);
      //entityTypeData.then(function(response) {
      if (vm.entityTypeList) {
        angular.forEach(vm.entityTypeList, function (data, key) {
          if (data.id == entityTypeId) {
            if (!disable) {
              vm.entityRequestOld.entityType = data;
            }
            vm.entityRequestNew.entityType = data;
            vm.requestEntityType = data.name;
          }
        });
      }

      //});
    };

    vm.clearEntity = function () {
      var copyEntityType = vm.entityRequestNew.entityType;
      vm.entityRequestNew = {};
      vm.entityRequestNew.countryObj = {};
      vm.entityRequestNew.provinceObj = {};
      vm.entityRequestNew.cityObj = {};
      vm.entityRequestNew.sectorObj = {};
      vm.entityNameSearchText = "";
      vm.entityRequestNew.flag = false; // The field flag is mandatory. So default value is set to this  field
      vm.entityRequestNew.entityType = copyEntityType;
      vm.isHide = false;
      vm.isDisable = false;
    };

    vm.clearOnClose = function (searchKey, dropValue) {
      vm[searchKey] = undefined;
      vm[dropValue] = undefined;
      vm.entityNameLoader = false;
    };

    vm.searchEntity = function (searchKey, entityTypeId) {
      if (searchKey && searchKey.length >= 2) {
        var deferred = $q.defer();
        vm.entityNameList = [];
        vm.entityNameLoader = true;
        vm.isNewEntityName = false;
        var data = LibraryService.getEntityNamesList(searchKey, entityTypeId);
        data.then(function (response) {
          vm.entityNameLoader = false;
          if (response.length > 0) {
            vm.entityNameList = response;
            vm.isHide = false;
          } else {
            vm.entityNameSearchText = searchKey;
            vm.isHide = true;
            vm.isNewEntityName = true;
            vm.entityRequestNew.entityName = {};
          }
          deferred.resolve(vm.entityNameList);
        });
        return deferred.promise;
      }
    };

    //Get Merged Entity Object
    vm.getMergedObj = function (entityId) {
      vm.entityRequestNew = {};
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        vm.entityRequestNew = response;
        vm.entityRequestNew.entityName = LibraryService.getEntityNameObj(vm.entityRequestNew);

        if (vm.entityTypeList) {
          angular.forEach(vm.entityTypeList, function (data, key) {
            if (data.id == vm.entityRequestNew.entityTypeId) {
              vm.entityRequestNew.entityType = data;
            }
          });
        }

        var locationData = CommonService.getLocationById(vm.entityRequestNew.locationMappingId);
        locationData.then(function (response) {
          var responseObj = response;
          vm.entityRequestNew.countryObj = LibraryService.getCountryObj(responseObj);
          vm.entityRequestNew.provinceObj = LibraryService.getProvinceObj(responseObj);
          vm.entityRequestNew.cityObj = LibraryService.getCityObj(responseObj);
          vm.entityRequestNew.sectorObj = LibraryService.getSectorObj(responseObj);
        });
      });
    };

    vm.getRequestPopupId = function (ev, requestType) {
      vm.id = "";

      //Check closed status
      var idx = vm.closedRequests.indexOf(vm.request.requestStatus);

      if (requestType == vm.APP.LIBRARY.LOCATION_REQUEST) {
        //View Location Request Profile for other users
        vm.id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
        if (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.isRequestMerged) {
          vm.id = vm.APP.LIBRARY.REQ_LOC_ID;
          if (idx > -1) {
            vm.id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
          }
        }
      } else if (requestType == vm.APP.LIBRARY.ENTITY_REQUEST) {
        vm.id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
        if (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.isRequestMerged) {
          vm.id = vm.APP.LIBRARY.REQ_ENTITY_ID;
          // For read only popup if the requestStatus as closed
          if (idx > -1) {
            vm.id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
          }
        }
      }
      vm.showRequestDialog(ev, vm.id);
    };

    vm.getEntityProfileById = function (entityId, disable, ev) {
      vm.entityProfile = {};
      vm.entityPopupLoader = true;
      vm.entityId = entityId;
      vm.mergedEntityId = undefined;
      vm.entityLocationMappingId = undefined;
      vm.isMergeRequest = false;
      vm.isRequestMerged = false;
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        var responseObj = response;
        if (disable) {
          vm.isDisable = true;
          vm.isMergeRequest = true;
          vm.mergedEntityId = response.id;
        } else {
          vm.entityRequestOld = angular.copy(responseObj);
          vm.entityNameSearchText = vm.entityRequestOld.name;
          //isForm is to know whether the request is from form section or Library Section
          vm.entityRequestOld.isForm = responseObj.isForm;
        }
        vm.entityRequestNew = angular.copy(responseObj);
        vm.entityRequestNew.entityName = LibraryService.getEntityNameObj(responseObj);
        vm.entityLocationMappingId = responseObj.locationMappingId;
        vm.getLocationMappingDataById(vm.entityLocationMappingId, disable);
        vm.getEntityTypeById(responseObj.entityTypeId, disable);
        vm.entityPopupLoader = false;
        //Get Merged Entity Profile Details
        if (responseObj.isMerged) {
          vm.isRequestMerged = true;
          vm.getMergedObj(responseObj.mergedEntityId);
        }
        if (!disable) {
          vm.getRequestPopupId(ev, vm.APP.LIBRARY.ENTITY_REQUEST);
        }
      });
    };

    vm.setFormLocationValues = function () {
      if (vm.locationRequestOld.countryId == null && vm.locationRequestOld.countryTxt != null) {
        vm.formCountryRequest = true;
        vm.locationRequestNew.countryObj.countryId = -1;
        vm.locationRequestNew.provinceObj.provinceId = -1;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.provinceId == null &&
        vm.locationRequestOld.provinceTxt != null &&
        vm.locationRequestOld.provinceTxt != ""
      ) {
        vm.formProvinceRequest = true;
        vm.addNewLocationObject.country = false;
        vm.locationRequestNew.provinceObj.provinceId = -1;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.cityId == null &&
        vm.locationRequestOld.cityTxt != null &&
        vm.locationRequestOld.cityTxt != ""
      ) {
        vm.formCityRequest = true;
        vm.addNewLocationObject.country = false;
        vm.addNewLocationObject.province = false;
        vm.locationRequestNew.cityObj.cityId = -1;
      } else if (
        vm.locationRequestOld.sectorId == null &&
        vm.locationRequestOld.sectorTxt != null &&
        vm.locationRequestOld.sectorTxt != ""
      ) {
        vm.addNewLocationObject.country = false;
        vm.addNewLocationObject.province = false;
        vm.addNewLocationObject.city = false;
        vm.locationRequestNew.sectorObj.sectorId = -1;
      }

      if (
        vm.locationRequestOld.sectorTxt != null &&
        vm.locationRequestOld.sectorTxt != "" &&
        (vm.locationRequestOld.countryId == null ||
          vm.locationRequestOld.provinceId == null ||
          vm.locationRequestOld.cityId == null)
      ) {
        vm.locationRequestNew.sectorObj.sectorId = -1;
      } else if (
        (vm.locationRequestOld.provinceTxt == null || vm.locationRequestOld.provinceTxt == "") &&
        vm.locationRequestOld.provinceId == null
      ) {
        vm.inputIsHideObject.province = true;
        vm.inputIsHideObject.city = true;
        vm.inputIsHideObject.sector = true;
      } else if (
        (vm.locationRequestOld.cityTxt == null || vm.locationRequestOld.cityTxt == "") &&
        vm.locationRequestOld.cityId == null
      ) {
        vm.inputIsHideObject.city = true;
        vm.inputIsHideObject.sector = true;
      } else if (
        (vm.locationRequestOld.sectorTxt == null || vm.locationRequestOld.sectorTxt == "") &&
        vm.locationRequestOld.sectorId == null
      ) {
        vm.inputIsHideObject.sector = true;
      }

      //Set input search object for directive
      if (vm.locationRequestOld.countryTxt != null && vm.locationRequestOld.countryTxt != "") {
        vm.requestLocationInputSearchObject.countrySearchKey = vm.locationRequestOld.countryTxt;
      }
      if (vm.locationRequestOld.provinceTxt != null && vm.locationRequestOld.provinceTxt != "") {
        vm.requestLocationInputSearchObject.provinceSearchKey = vm.locationRequestOld.provinceTxt;
      }
      if (vm.locationRequestOld.cityTxt != null && vm.locationRequestOld.cityTxt != "") {
        vm.requestLocationInputSearchObject.citySearchKey = vm.locationRequestOld.cityTxt;
      }
      if (vm.locationRequestOld.sectorTxt != null && vm.locationRequestOld.sectorTxt != "") {
        vm.requestLocationInputSearchObject.sectorSearchKey = vm.locationRequestOld.sectorTxt;
      }
    };

    vm.requestLocationInputSearchObject = {};
    vm.getRequestProfileById = function (locationId, ev) {
      vm.locationProfile = {};
      vm.requestLocationInputSearchObject = {};
      vm.addNewLocationObject = {};

      vm.requestLocationInputSearchObject.country = "";
      vm.requestLocationInputSearchObject.province = "";
      vm.requestLocationInputSearchObject.city = "";
      vm.requestLocationInputSearchObject.sector = "";

      vm.entityPopupLoader = true;
      vm.isRequestMerged = false;
      vm.inputIsHideObject.country = false;
      vm.inputIsHideObject.province = false;
      vm.inputIsHideObject.city = false;
      vm.inputIsHideObject.sector = false;
      vm.relpaceinputfieldObject.country = false;
      vm.relpaceinputfieldObject.province = false;
      vm.relpaceinputfieldObject.city = false;
      vm.relpaceinputfieldObject.sector = false;
      vm.requestLocationInputSearchObject.isHideCountry = false;
      vm.requestLocationInputSearchObject.isHideProvince = false;
      vm.requestLocationInputSearchObject.isHideCity = false;
      vm.requestLocationInputSearchObject.isHideSector = false;
      vm.formCountryRequest = false;
      vm.formProvinceRequest = false;
      vm.formCityRequest = false;
      vm.addNewLocationObject.country = true;
      vm.addNewLocationObject.province = true;
      vm.addNewLocationObject.city = true;
      vm.addNewLocationObject.sector = true;
      var data = LibraryRequestService.getRequestProfileById(locationId);
      data.then(function (response) {
        vm.locationRequestOld = response;
        vm.locationProfile = response;
        vm.locationRequestNew = angular.copy(vm.locationRequestOld);
        vm.requestDuration = vm.locationRequestNew.noOfDays;
        //Set location objects
        vm.locationRequestNew.countryObj = LibraryService.getCountryObj(vm.locationRequestOld);
        vm.locationRequestNew.provinceObj = LibraryService.getProvinceObj(vm.locationRequestOld);
        vm.locationRequestNew.cityObj = LibraryService.getCityObj(vm.locationRequestOld);
        vm.locationRequestNew.sectorObj = LibraryService.getSectorObj(vm.locationRequestOld);
        //Set LocationType
        if (vm.locationRequestOld.requestTypeName != null) {
          vm.locationTypeName = vm.locationRequestOld.requestTypeName;
        } else if (vm.locationRequestOld.requestTypeName == null) {
          vm.locationTypeName = vm.APP.LIBRARY.FORM_LOCATION_REQUEST;
        }

        //Get merged location obj
        if (vm.locationRequestNew.isMerged) {
          vm.isRequestMerged = true;
          var mergedData = LibraryRequestService.getRequestProfileById(vm.locationRequestNew.mergedLocationMappingId);
          mergedData.then(function (response) {
            vm.locationRequestNew = response;
          });
        }
        //For Showing new request in md-select drop down
        else {
          if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.COUNTRY) {
            vm.inputIsHideObject.province = true;
            vm.inputIsHideObject.city = true;
            vm.inputIsHideObject.sector = true;
            vm.locationRequestNew.countryObj.countryId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE) {
            vm.inputIsHideObject.city = true;
            vm.inputIsHideObject.sector = true;
            vm.addNewLocationObject.country = false;
            vm.locationRequestNew.provinceObj.provinceId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY) {
            vm.inputIsHideObject.sector = true;
            vm.addNewLocationObject.country = false;
            vm.addNewLocationObject.province = false;
            vm.locationRequestNew.cityObj.cityId = -1;
          } else if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR) {
            vm.addNewLocationObject.country = false;
            vm.addNewLocationObject.province = false;
            vm.addNewLocationObject.city = false;
            vm.locationRequestNew.sectorObj.sectorId = -1;
          }

          //Set the form request values
          if (vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST) {
            vm.setFormLocationValues();
          }
        }
        vm.getRequestPopupId(ev, vm.APP.LIBRARY.LOCATION_REQUEST);
        vm.entityPopupLoader = false;
      });
    };

    vm.getLocationPopup = function (ev, entityRequestNew, requestEntityForm) {
      vm.getRequestProfileById(entityRequestNew.locationMappingId, ev);
    };

    vm.entityApprove = function (entityRequestNew, requestEntityForm) {
      var approveEntityRequest = {};
      vm.msgFlag = false;
      vm.isEntityApproveDisable = true;
      vm.locationIdValidation = false;
			var locationValidation = communicationService.getData('ValidateEntityLocationField');
			vm.validateLocationIds(locationValidation);
      if (entityRequestNew && requestEntityForm.$valid) {
        //Approve or Alterd
        if (!vm.isMergeRequest) {
          // For new entity name selection
          if (vm.isNewEntityName) {
            approveEntityRequest.name = vm.entityNameSearchText;
          }
          // For default entity name or change from dropdown
          else {
            approveEntityRequest.name = vm.entityRequestNew.entityName.name;
          }

          if (vm.entityRequestNew.entityType != null) {
            approveEntityRequest.entityTypeId = vm.entityRequestNew.entityType.id;
          }
          if (vm.entityId != null) {
            approveEntityRequest.id = vm.entityId;
          }

          approveEntityRequest.comments = entityRequestNew.comments;
          approveEntityRequest.flag = entityRequestNew.flag;
          approveEntityRequest.contactEmail = entityRequestNew.contactEmail;
          approveEntityRequest.contactPersonName = entityRequestNew.contactPersonName;
          approveEntityRequest.contactPhoneNumber = entityRequestNew.contactPhoneNumber;
          
					if(locationValidation && vm.locationIdValidation){
						if(locationValidation.id){
							approveEntityRequest.locationMappingId = locationValidation.id;
						}
					 	else if(locationValidation.locationMappingId) {
							approveEntityRequest.locationMappingId = locationValidation.locationMappingId;
						}
					} else if (
            entityRequestNew.cityObj.locationMappingId != null &&
            entityRequestNew.cityObj.locationMappingId != undefined
          ) {
            approveEntityRequest.locationMappingId = entityRequestNew.cityObj.locationMappingId;
          } else {
            approveEntityRequest.locationMappingId = vm.entityLocationMappingId;
          }
        }

        // Merged Request
        else {
          approveEntityRequest = angular.copy(vm.entityRequestOld);
          if (vm.isMergeRequest && vm.mergedEntityId != null) {
            approveEntityRequest.mergedEntityId = vm.mergedEntityId;
          }
        }
        if (vm.mergeEntity) {
          approveEntityRequest.isEntityMerge = true;
        } else {
          approveEntityRequest.isEntityMerge = false;
        }

        var data = LibraryRequestService.entityApprove(approveEntityRequest);
        data.then(
          function (response) {
            communicationService.setData('ValidateEntityLocationField','');
            vm.cancel(requestEntityForm);
            notifications.showSuccess({ message: vm.APP.LIBRARY.ENTITY_REQUEST });
            vm.requestInit();
            vm.isEntityApproveDisable = false;
            vm.mergeEntity = false;
            vm.msgFlag = false;
          },
          function (reason) {
            if (reason.data.statusCode == 409) {
              vm.isEntityApproveDisable = false;
              vm.msgFlag = true;
              vm.mergeEntity = true;
            } else if (reason.data.statusCode == 400) {
              //if entity approved before location
              vm.isEntityApproveDisable = false;
              vm.msgFlagForLocation = true;
              $timeout(function () {
                vm.msgFlag = false;
                vm.entityPopupId = approveEntityRequest.id;
                vm.popUpId = vm.APP.LIBRARY.ENTITY_REQ;
              }, 5000);
            } else {
              notifications.showError({ message: vm.APP.LIBRARY.ENTITY_REQUEST_PROBLEM });
            }
            return reason;
          }
        );
      } else {
        vm.isEntityApproveDisable = false;
      }
    };

    /*vm.goRequest = function(ev,request){
	  		vm.msgFlag = false;
	  		var id;
	  		vm.request = request;

	  		//Check closed status
	  		var idx = vm.closedRequests.indexOf(vm.request.requestStatus);

  			if(request.requestTypeName == vm.APP.LIBRARY.LOCATION_REQUEST){
  				//View Location Request Profile for other users
  				id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
  				if(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER){
  					id = vm.APP.LIBRARY.REQ_LOC_ID;
  	  				if(idx > -1){
  	  					id = vm.APP.LIBRARY.REQ_LOC_PROFILE_ID;
  	  				}
  				}
	   			vm.getRequestProfileById(vm.request.id);
	   		}
  			else if(request.requestTypeName == vm.APP.LIBRARY.ENTITY_REQUEST){
  				id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
  				if(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER) {
  					id = vm.APP.LIBRARY.REQ_ENTITY_ID;
  		   		    // For read only popup if the requestStatus as closed
  	  				if(idx > -1){
  	  					id = vm.APP.LIBRARY.REQ_ENTITY_PROFILE_ID;
  	  				}
  				}
	   			vm.getEntityProfileById(vm.request.id,false); 
	   		}
	   		vm.showRequestDialog(ev,id,request);
	   	};*/

    vm.goRequest = function (ev, request) {
      vm.msgFlag = false;
      vm.isEntityApproveDisable = false;
      vm.isLocationApproveDisable = false;
      vm.request = request;

      if (request.requestTypeName == vm.APP.LIBRARY.LOCATION_REQ) {
        vm.getRequestProfileById(vm.request.id, ev);
      } else if (request.requestTypeName == vm.APP.LIBRARY.ENTITY_REQ) {
        vm.getEntityProfileById(vm.request.id, false, ev);
      }
    };

    vm.showRequestDialog = function ($event, id) {
      //vm.request = request;
      vm.isDisable = false;
      vm.isHide = true;
      vm.isNewEntityName = true;
      $mdDialog.show({
        targetEvent: $event,
        contentElement: "#" + id,
        parent: angular.element(document.body)
      });
    };

    vm.cancel = function (form) {
      form.$setPristine();
      $mdDialog.hide();
      vm.msgFlagForLocation = false;
      vm.isEntityApproveDisable = false;
      if ($scope.modelObject) {
        $scope.modelObject = {};
      }
      if ($scope.inputsearchObject) {
        $scope.inputsearchObject = {};
      }
    };

    vm.getEntityTypeList = function () {
      var entityTypeData = CommonService.getRefTermList(vm.APP.REF_TERM.ENTITY_PROFILE);
      entityTypeData.then(function (response) {
        vm.entityTypeList = response;
      });
    };

    //Show the validation message for library location request
    vm.checkValidation = function (locationRequestNew) {
      if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE) {
        if (
          locationRequestNew.countryObj == undefined ||
          locationRequestNew.countryObj.countryId == null ||
          locationRequestNew.countryObj.countryId == undefined
        ) {
          vm.requestLocationInputSearchObject.countrySearchKey = "";
        }
      } else if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY) {
        if (
          locationRequestNew.countryObj == undefined ||
          locationRequestNew.countryObj.countryId == null ||
          locationRequestNew.countryObj.countryId == undefined
        ) {
          vm.requestLocationInputSearchObject.countrySearchKey = "";
        }
        if (
          locationRequestNew.provinceObj == undefined ||
          locationRequestNew.provinceObj.provinceId == null ||
          locationRequestNew.provinceObj.provinceId == undefined
        ) {
          vm.requestLocationInputSearchObject.provinceSearchKey = "";
        }
      } else if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR) {
        if (
          locationRequestNew.countryObj == undefined ||
          locationRequestNew.countryObj.countryId == null ||
          locationRequestNew.countryObj.countryId == undefined
        ) {
          vm.requestLocationInputSearchObject.countrySearchKey = "";
        }
        if (
          locationRequestNew.provinceObj == undefined ||
          locationRequestNew.provinceObj.provinceId == null ||
          locationRequestNew.provinceObj.provinceId == undefined
        ) {
          vm.requestLocationInputSearchObject.provinceSearchKey = "";
        }
        if (
          locationRequestNew.cityObj == undefined ||
          locationRequestNew.cityObj.cityId == null ||
          locationRequestNew.cityObj.cityId == undefined
        ) {
          vm.requestLocationInputSearchObject.citySearchKey = "";
        }
        if (
          locationRequestNew.sectorObj == undefined ||
          locationRequestNew.sectorObj.sectorTxt == null ||
          locationRequestNew.sectorObj.sectorTxt == ""
        ) {
          vm.sectorValidationFlag = true; //Show sector validation message
          $timeout(function () {
            vm.sectorValidationFlag = false;
          }, 5000);
        }
      }
    };

    //Approve the library location request
    vm.approvAlterLocationRequest = function (locationRequestNew, requestLocationForm) {
      vm.approveObj = {};
      vm.approveObj.countryObj = {};
      vm.approveObj.provinceObj = {};
      vm.approveObj.cityObj = {};
      vm.approveObj.sectorObj = {};
      vm.sectorValidationFlag = false;
      vm.isLocationApproveDisable = true;
      if (locationRequestNew && requestLocationForm.$valid) {
        vm.approveObj.id = vm.locationRequestNew.id;
        vm.approveObj.requestTypeId = locationRequestNew.requestTypeId;
        vm.approveObj.requestTypeName = locationRequestNew.requestTypeName;
        if (vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.COUNTRY) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          if (locationRequestNew.countryObj && locationRequestNew.countryObj.locationMappingId != null) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.countryObj.locationMappingId;
          } else if (locationRequestNew.countryObj.countryId == -1) {
            vm.approveObj.countryId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          if (
            locationRequestNew.provinceObj &&
            locationRequestNew.countryObj &&
            locationRequestNew.provinceObj.locationMappingId != null
          ) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.provinceObj.locationMappingId;
          } else if (vm.locationRequestNew.provinceObj.provinceId == -1) {
            vm.approveObj.provinceId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          if (
            locationRequestNew.countryObj &&
            locationRequestNew.cityObj.locationMappingId != null &&
            locationRequestNew.cityObj
          ) {
            vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.cityObj.locationMappingId;
          } else if (locationRequestNew.cityObj.cityId == -1) {
            vm.approveObj.cityId = null;
          }
        }
        if (locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR) {
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          vm.approveObj.sectorId = locationRequestNew.sectorObj.sectorId;
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          if (
            locationRequestNew.countryObj &&
            locationRequestNew.sectorObj.locationMappingId != null &&
            locationRequestNew.cityObj &&
            locationRequestNew.sectorObj
          ) {
            vm.approveObj.mergedLocationMappingId = locationRequestNew.sectorObj.locationMappingId;
          } else if (locationRequestNew.sectorObj.sectorId == -1) {
            vm.approveObj.sectorId = null;
          }
          if (vm.approveObj.sectorTxt == null || vm.approveObj.sectorTxt == "") {
            vm.sectorValidationFlag = true; //Show sector validation message
            $timeout(function () {
              vm.sectorValidationFlag = false;
            }, 5000);
          }
        }
        if (vm.mergeFlag) {
          vm.approveObj.isMerge = true;
        } else {
          vm.approveObj.isMerge = false;
        }
        if (!vm.sectorValidationFlag) {
          var data = LibraryRequestService.saveApprovedRequestLists(vm.approveObj);
          data.then(
            function (response) {
              vm.msgFlag = false;
              vm.mergeFlag = false;
              vm.state.transitionTo(vm.state.current, vm.library, {
                reload: true,
                inherit: false,
                notify: true
              });
              $mdDialog.hide();
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_REQUEST });
            },
            function (reason) {
              if (reason.data.statusCode == 409) {
                vm.msgFlag = true;
                vm.mergeFlag = true;
              } else {
                notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_PROBLEM });
              }
              vm.isLocationApproveDisable = false;
              return reason;
            }
          );
        }
      } else {
        vm.isLocationApproveDisable = false;
        vm.checkValidation(locationRequestNew);
      }
    };

    vm.replaceCountry = function () {
      vm.locationRequestNew.countryObj = {};
      vm.requestLocationInputSearchObject.isHideCountry = true;
      vm.relpaceinputfieldObject.country = true;
    };

    vm.replaceProvince = function () {
      vm.locationRequestNew.provinceObj = {};
      vm.requestLocationInputSearchObject.isHideProvince = true;
      vm.relpaceinputfieldObject.province = true;
    };

    vm.replaceCity = function () {
      vm.locationRequestNew.cityObj = {};
      vm.requestLocationInputSearchObject.isHideCity = true;
      vm.relpaceinputfieldObject.city = true;
    };

    vm.replaceSector = function () {
      vm.locationRequestNew.sectorObj = {};
      vm.requestLocationInputSearchObject.isHideSector = true;
      vm.relpaceinputfieldObject.sector = true;
    };

    vm.formReplaceSelect = function () {
      if (
        vm.formCountryRequest &&
        vm.locationRequestNew.countryObj == undefined &&
        vm.requestLocationInputSearchObject.country != null &&
        vm.requestLocationInputSearchObject.country != ""
      ) {
        vm.replaceCountry();
        vm.replaceProvince();
        vm.replaceCity();
        vm.relpaceinputfieldObject.countryKey = vm.requestLocationInputSearchObject.country;
        vm.locationRequestNew.countryObj.countryTxt = vm.relpaceinputfieldObject.countryKey;
      } else if (
        vm.formProvinceRequest &&
        vm.locationRequestNew.countryObj &&
        vm.locationRequestNew.countryObj.countryId != null &&
        vm.locationRequestNew.provinceObj == undefined &&
        vm.requestLocationInputSearchObject.province != null &&
        vm.requestLocationInputSearchObject.province != ""
      ) {
        vm.replaceProvince();
        vm.replaceCity();
        vm.relpaceinputfieldObject.provinceKey = vm.requestLocationInputSearchObject.province;
        vm.locationRequestNew.provinceObj.provinceTxt = vm.relpaceinputfieldObject.provinceKey;
      } else if (
        vm.formCityRequest &&
        vm.locationRequestNew.countryObj &&
        vm.locationRequestNew.countryObj.countryId != null &&
        vm.locationRequestNew.provinceObj &&
        vm.locationRequestNew.provinceObj.provinceId != null &&
        vm.locationRequestNew.cityObj == undefined &&
        vm.requestLocationInputSearchObject.city != null &&
        vm.requestLocationInputSearchObject.city != ""
      ) {
        vm.replaceCity();
        vm.relpaceinputfieldObject.cityKey = vm.requestLocationInputSearchObject.city;
        vm.locationRequestNew.cityObj.cityTxt = vm.relpaceinputfieldObject.cityKey;
      }

      if (
        vm.requestLocationInputSearchObject.sector != null &&
        vm.locationRequestNew.sectorObj == undefined &&
        vm.locationRequestNew.sectorObj.sectorId == null
      ) {
        vm.replaceSector();
      }
    };

    vm.replaceSelect = function () {
      if (vm.requestLocationInputSearchObject.country != null || vm.relpaceinputfieldObject.countryKey != null) {
        vm.isEnableSave = true;
      }
      if (
        vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.COUNTRY &&
        vm.locationRequestNew.countryObj == undefined &&
        vm.requestLocationInputSearchObject.country != null
      ) {
        vm.locationRequestNew.countryObj = {};
        vm.requestLocationInputSearchObject.isHideCountry = true;
        vm.relpaceinputfieldObject.country = true;
        vm.relpaceinputfieldObject.countryKey = vm.requestLocationInputSearchObject.country;
        vm.locationRequestNew.countryObj.countryTxt = vm.relpaceinputfieldObject.countryKey;
      }

      if (
        vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.PROVINCE &&
        vm.locationRequestNew.countryObj &&
        vm.locationRequestNew.countryObj.countryId != null &&
        vm.locationRequestNew.provinceObj == undefined &&
        vm.requestLocationInputSearchObject.province != null
      ) {
        vm.locationRequestNew.provinceObj = {};
        vm.requestLocationInputSearchObject.isHideProvince = true;
        vm.relpaceinputfieldObject.province = true;
        vm.relpaceinputfieldObject.provinceKey = vm.requestLocationInputSearchObject.province;
        vm.locationRequestNew.provinceObj.provinceTxt = vm.relpaceinputfieldObject.provinceKey;
      }

      if (
        vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.CITY &&
        vm.locationRequestNew.countryObj &&
        vm.locationRequestNew.countryObj.countryId != null &&
        vm.locationRequestNew.provinceObj &&
        vm.locationRequestNew.provinceObj.provinceId != null &&
        vm.locationRequestNew.cityObj == undefined &&
        vm.requestLocationInputSearchObject.city != null
      ) {
        vm.locationRequestNew.cityObj = {};
        vm.requestLocationInputSearchObject.isHideCity = true;
        vm.relpaceinputfieldObject.city = true;
        vm.relpaceinputfieldObject.cityKey = vm.requestLocationInputSearchObject.city;
        vm.locationRequestNew.cityObj.cityTxt = vm.relpaceinputfieldObject.cityKey;
      }
      if (
        vm.locationRequestNew.requestTypeName == vm.APP.LIBRARY.SECTOR &&
        vm.locationRequestNew.countryObj &&
        vm.locationRequestNew.countryObj.countryId != null &&
        vm.locationRequestNew.provinceObj &&
        vm.locationRequestNew.provinceObj.provinceId != null &&
        vm.locationRequestNew.cityObj &&
        vm.locationRequestNew.cityObj.cityId != null &&
        (vm.locationRequestNew.sectorObj.sectorTxt == undefined || vm.locationRequestNew.sectorObj == null) &&
        vm.requestLocationInputSearchObject.sector != null
      ) {
        vm.locationRequestNew.sectorObj = {};
        vm.requestLocationInputSearchObject.isHideSector = true;
        vm.relpaceinputfieldObject.sector = true;
        vm.relpaceinputfieldObject.sectorKey = vm.requestLocationInputSearchObject.sector;
        vm.locationRequestNew.sectorObj.sectorTxt = vm.relpaceinputfieldObject.sectorKey;
      }
      //Replace input fields for Analyst Form Request
      if (vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST) {
        vm.formReplaceSelect();
      }
    };

    vm.requestInit = function () {
      //StorageDelete.deleteInvestigation();---------Commenting this line so that the Analyst form can be opened properly on browser back from the Library Section.
      StorageDelete.deleteUser();

      $scope.setLibraryType();

      vm.sortOrderList = [
        {
          id: vm.APP.LIBRARY.REQUEST_SORT_BY_COUNT,
          value: vm.APP.LIBRARY.REQUEST_SORT_BY_COUNT_VALUE
        },
        {
          id: vm.APP.LIBRARY.REQUEST_SORT_BY_NAME,
          value: vm.APP.LIBRARY.REQUEST_SORT_BY_NAME_VALUE
        }
      ];
      //Default
      if (angular.isUndefined(vm.requestSortBy) || angular.isUndefined(vm.requestSortBy.value)) {
        vm.requestFilterObj.sortBy = vm.APP.LIBRARY.REQUEST_SORT_BY_COUNT;
        vm.requestFilterObj.sortOrder = vm.APP.GLOBAL.ASC;
      }

      //Sort by initialization through session storage
      if ($sessionStorage.requestSortBy) {
        for (var i = 0; i < vm.sortOrderList.length; i++) {
          if (vm.sortOrderList[i].id == $sessionStorage.requestSortBy) {
            vm.requestSortBy = vm.sortOrderList[i];
            break;
          }
        }

        vm.getRequestSortedList(vm.requestSortBy.id, true); // To get sort by list
      }
      if ($sessionStorage.formRequest) {
        vm.formRequest = $sessionStorage.formRequest;
      } else {
        vm.formRequest = false;
      }
      if ($sessionStorage.selectedRequestList) {
        qPromises.push(vm.getAllRequestFilters(false, vm.formRequest));
      } else {
        qPromises.push(vm.getAllRequestFilters(true, vm.formRequest));
      }

      $q.all(qPromises).then(function (data) {
        vm.getRequestList();
      });

      vm.getEntityTypeList();
    };

    //Show the validation message for form location request
    vm.validation = function () {
      if (vm.approveObj.countryTxt == null || vm.approveObj.countryTxt == "" || vm.approveObj.countryTxt == undefined) {
        vm.requestLocationInputSearchObject.countrySearchKey = "";
        vm.validationFlag = true;
      }
      if (
        vm.approveObj.provinceTxt == null ||
        vm.approveObj.provinceTxt == "" ||
        vm.approveObj.provinceTxt == undefined
      ) {
        vm.requestLocationInputSearchObject.provinceSearchKey = "";
        vm.validationFlag = true;
      }
      if (vm.approveObj.cityTxt == null || vm.approveObj.cityTxt == "" || vm.approveObj.cityTxt == undefined) {
        vm.requestLocationInputSearchObject.citySearchKey = "";
        vm.validationFlag = true;
      }
      if (vm.locationRequestOld.sectorTxt != null && vm.locationRequestOld.sectorTxt != "") {
        if (vm.approveObj.sectorTxt == null || vm.approveObj.sectorTxt == "" || vm.approveObj.sectorTxt == undefined) {
          vm.validationFlag = true;
          vm.sectorValidationFlag = true; //Show sector validation message
        }
      }
      $timeout(function () {
        vm.validationFlag = false;
        vm.sectorValidationFlag = false;
      }, 5000);
    };

    //Approve/Alter Location Request from Analyst Form
    vm.approveAlterFormLocationRequest = function (locationRequestNew, inputSearchObject, ev) {
      vm.approveObj = {};
      vm.sectorValidationFlag = false;
      vm.validationFlag = false;
      vm.isLocationApproveDisable = true;
      if (locationRequestNew) {
        vm.approveObj.id = locationRequestNew.id;

        if (
          (vm.locationRequestOld.countryId == null || inputSearchObject.countryAltered) &&
          inputSearchObject.countrySearchKey != null &&
          inputSearchObject.countrySearchKey != ""
        ) {
          vm.approveObj.countryTxt = inputSearchObject.countrySearchKey;
        } else if (
          locationRequestNew.countryObj != undefined &&
          locationRequestNew.countryObj.countryId != -1 &&
          locationRequestNew.countryObj.countryId != null
        ) {
          vm.approveObj.countryTxt = locationRequestNew.countryObj.countryTxt;
          vm.approveObj.countryId = locationRequestNew.countryObj.countryId;
        }

        if (
          (vm.locationRequestOld.provinceId == null || inputSearchObject.provinceAltered) &&
          vm.locationRequestOld.provinceTxt != null &&
          vm.locationRequestOld.provinceTxt != "" &&
          inputSearchObject.provinceSearchKey != null &&
          inputSearchObject.provinceSearchKey != ""
        ) {
          vm.approveObj.provinceTxt = inputSearchObject.provinceSearchKey;
        } else if (
          vm.locationRequestOld.provinceTxt != null &&
          vm.locationRequestOld.provinceTxt != "" &&
          locationRequestNew.provinceObj != undefined
        ) {
          vm.approveObj.provinceTxt = locationRequestNew.provinceObj.provinceTxt;
          vm.approveObj.provinceId = locationRequestNew.provinceObj.provinceId;
        }

        if (
          (vm.locationRequestOld.cityId == null || inputSearchObject.cityAltered) &&
          vm.locationRequestOld.cityTxt != null &&
          vm.locationRequestOld.cityTxt != "" &&
          inputSearchObject.citySearchKey != null &&
          inputSearchObject.citySearchKey != ""
        ) {
          vm.approveObj.cityTxt = inputSearchObject.citySearchKey;
        } else if (
          vm.locationRequestOld.cityTxt != null &&
          vm.locationRequestOld.cityTxt != "" &&
          locationRequestNew.cityObj != undefined
        ) {
          vm.approveObj.cityTxt = locationRequestNew.cityObj.cityTxt;
          vm.approveObj.cityId = locationRequestNew.cityObj.cityId;
        }

        if (
          locationRequestNew.cityObj != undefined &&
          locationRequestNew.cityObj.cityId != -1 &&
          locationRequestNew.cityObj.cityId != null
        ) {
          //Set merged Location mapping Id Value for City
          if (
            (vm.formCountryRequest || vm.formProvinceRequest || vm.formCityRequest) &&
            locationRequestNew.sectorObj.sectorId != -1 &&
            angular.isUndefinedOrNull(locationRequestNew.sectorObj.sectorId)
          ) {
            vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.cityObj.locationMappingId;
          }
        }

        if (
          vm.locationRequestOld.sectorTxt != null &&
          vm.locationRequestOld.sectorTxt != "" &&
          locationRequestNew.sectorObj != undefined &&
          locationRequestNew.sectorObj.sectorId != -1 &&
          locationRequestNew.sectorObj.sectorId != null
        ) {
          vm.approveObj.sectorId = locationRequestNew.sectorObj.sectorId;
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          vm.approveObj.mergedLocationMappingId = vm.locationRequestNew.sectorObj.locationMappingId; //Set merged Location mapping Id Value for City
        } else if (
          (vm.locationRequestOld.sectorTxt != null && locationRequestNew.sectorObj.sectorId == -1) ||
          locationRequestNew.sectorObj.sectorId == undefined
        ) {
          vm.approveObj.sectorTxt = locationRequestNew.sectorObj.sectorTxt;
          if (
            inputSearchObject.sectorSearchKey != null &&
            (inputSearchObject.sectorSearchKey != "" || inputSearchObject.sectorAltered)
          ) {
            vm.approveObj.sectorTxt = inputSearchObject.sectorSearchKey;
          }
        }
        //Check the location object for validation
        vm.validation();
        vm.approveObj.isMerge = vm.mergeFlag ? true : false;

        if (!vm.validationFlag) {
          var data = LibraryRequestService.saveApprovedRequestLists(vm.approveObj);
          data.then(
            function (response) {
              vm.msgFlag = false;
              $mdDialog.hide();
              notifications.showSuccess({ message: vm.APP.LIBRARY.LOCATION_REQUEST });
              vm.isLocationApproveDisable = false;
              if (vm.entityPopupId && vm.popUpId == vm.APP.LIBRARY.ENTITY_REQ) {
                $timeout(function () {
                  vm.msgFlagForLocation = false;
                  vm.popUpId = "";
                  vm.getEntityProfileById(vm.entityPopupId, false, ev);
                }, 1000);
              } else {
                vm.state.transitionTo(vm.state.current, vm.library, {
                  reload: true,
                  inherit: false,
                  notify: true
                });
              }
            },
            function (reason) {
              if (reason.data.statusCode == 409) {
                vm.msgFlag = true;
                vm.mergeFlag = true;
              } else {
                notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_PROBLEM });
              }
              vm.isLocationApproveDisable = false;
              return reason;
            }
          );
        } else {
          vm.isLocationApproveDisable = false;
        }
      } else {
        vm.isLocationApproveDisable = false;
      }
    };

    vm.formRequestChange = function (formRequest) {
      if (vm.media("gt-sm")) {
        vm.loadingListData = true;
      }
      $sessionStorage.formRequest = formRequest;
      vm.requestInit();
    };

    vm.requestInit();

		vm.validateLocationIds = function(locationValidation){
			if(locationValidation && locationValidation.countryId && locationValidation.provinceId && locationValidation.cityId){
				vm.locationIdValidation = true;
			}
		};
    
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('LibraryRequestService', LibraryRequestService);

    LibraryRequestService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function LibraryRequestService ($resource,restService,$q,$rootScope) {
    	
    	this.getRequestFilterList = function(formRequest){
    		var deferred = $q.defer();
    		var url = "library/request/status/count?formRequest="+formRequest;
    		var data = restService.restCall('', url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	this.getRequestLists = function(filterObj){
    		var deferred = $q.defer();
    		var url = "library/request";
    		var data = restService.restCall(filterObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	}; 
    	
    	this.getRequestProfileById = function(reqId) {
    		var deferred = $q.defer();
    		var url = "location-mappings/"+reqId;
    		var data = restService.restCall('', url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	this.saveApprovedRequestLists = function(approveObj){
    		var errormsg ={};
    		var deferred = $q.defer();
    		var url = "location-mappings/request/approve";
    		var data = restService.restCall(approveObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			errormsg = error;
    			deferred.reject(errormsg);
    		});
    		return deferred.promise;
		};

    	this.entityApprove = function(approveEntityRequest){
    		var errormsg ={};
    		var deferred = $q.defer();
    		var url = "entity-profiles/request/approve";
    		var data = restService.restCall(approveEntityRequest, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			errormsg = error;
    			deferred.reject(errormsg);
    		});
    		return deferred.promise;
    	};
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider','APP'];
    
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('request', {
            parent: 'library',
            url: '/request',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	libraryType:null
            },
            views: {
                'libraryList': {
                    templateUrl: 'app/library/request/library.request.html',
                    controller: 'LibraryRequestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }                   
                    return $translate.refresh();
                }]/*,
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#request').triggerHandler('click');
                	  });
                }]*/
            }
        });
    }
})();
(function () {
  "use strict";

  angular.module("lariAidApp").factory("Account", Account);

  Account.$inject = [
    "$resource",
    "BASE_URL",
    "$cookies",
    "$sessionStorage",
    "communicationService",
    "$http",
    "$rootScope"
  ];

  function Account($resource, BASE_URL, $cookies, $sessionStorage, communicationService, $http, $rootScope) {
    var service = $resource(
      BASE_URL + "api/account",
      {},
      {
        get: {
          method: "GET",
          params: {},
          isArray: false,
          interceptor: {
            response: function (response) {
              // expose response
              $http({
                method: "GET",
                url: BASE_URL + "api/getEnvironmentDetails"
              }).then(function successCallback(response) {
                $sessionStorage.currentEnvironment = response.data.environment;
                $rootScope.$broadcast("setheader");
              });

              if (response.data.authorities[0] === "LARI_INVESTIGATOR") {
                if (navigator.language.indexOf("es") > -1) {
                  response.data.langKey = "es";
                }
                else {
                  response.data.langKey = "en";
                }
              } else {

                response.data.langKey = "en";
              }
              var sessionDetails = {
                firstName: response.data.firstName,
                lastName: response.data.lastName,
                authorities: response.data.authorities,
                langKey: response.data.langKey,
                login: response.data.login
              };

              $cookies.putObject("sessionDetails", sessionDetails);
              $sessionStorage.isLoggedIn = true;
              communicationService.setData("isLoggedIn", true);

              return response;
            }
          }
        }
      }
    );

    return service;
  }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("Auth", Auth);

  Auth.$inject = [
    "$rootScope",
    "$cookies",
    "$state",
    "$sessionStorage",
    "$q",
    "$translate",
    "Principal",
    "AuthServerProvider",
    "Account",
    "Register",
    "Activate",
    "Password",
    "PasswordResetInit",
    "PasswordResetFinish",
    "communicationService",
    "StorageDelete",
    "restService",
    "$location"
  ];

  function Auth(
    $rootScope,
    $cookies,
    $state,
    $sessionStorage,
    $q,
    $translate,
    Principal,
    AuthServerProvider,
    Account,
    Register,
    Activate,
    Password,
    PasswordResetInit,
    PasswordResetFinish,
    communicationService,
    StorageDelete,
    restService,
    $location
  ) {
    var service = {
      activateAccount: activateAccount,
      authorize: authorize,
      changePassword: changePassword,
      createAccount: createAccount,
      getPreviousState: getPreviousState,
      login: login,
      logout: logout,
      loginWithToken: loginWithToken,
      resetPasswordFinish: resetPasswordFinish,
      resetPasswordInit: resetPasswordInit,
      resetPreviousState: resetPreviousState,
      storePreviousState: storePreviousState,
      updateAccount: updateAccount,
      forgotPassword: forgotPassword
    };

    return service;

    function activateAccount(key, callback) {
      var cb = callback || angular.noop;

      return Activate.get(
        key,
        function (response) {
          return cb(response);
        },
        function (err) {
          return cb(err);
        }.bind(this)
      ).$promise;
    }

    function authorize(force) {
      return Principal.identity(force).then(function () {
        var isAuthenticated = Principal.isAuthenticated();
        // an authenticated user can't access to login and register pages
        if (
          isAuthenticated &&
          $rootScope.toState.parent === "account" &&
          ($rootScope.toState.name === "login" || $rootScope.toState.name === "register")
        ) {
          $state.go("home");
        }

        // recover and clear previousState after external login redirect (e.g. oauth2)
        if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
          var previousState = getPreviousState();
          resetPreviousState();
          $state.go(previousState.name, previousState.params);
        }

        if (
          $rootScope.toState.data.authorities &&
          $rootScope.toState.data.authorities.length > 0 &&
          !Principal.hasAnyAuthority($rootScope.toState.data.authorities)
        ) {
          if (isAuthenticated) {
            // user is signed in but not authorized for desired state
            $state.go("accessdenied");
          } else {
            // user is not authenticated. stow the state they wanted before you
            // send them to the login service, so you can return them when you're done
            if ($rootScope.toState.url !== "/") {
              storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
            }

            // now, send them to the signin state so they can log in
            $state.go("accessdenied").then(function () {
              //LoginService.open();
              $state.go("login");
            });
          }
        }
      });
    }

    function changePassword(newPassword, callback) {
      var cb = callback || angular.noop;

      return Password.save(
        newPassword,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function createAccount(account, callback) {
      var cb = callback || angular.noop;

      return Register.save(
        account,
        function () {
          return cb(account);
        },
        function (err) {
          this.logout();
          return cb(err);
        }.bind(this)
      ).$promise;
    }

    function login() {
      var cb = angular.noop;
      var deferred = $q.defer();
      var currentUrl = $location.absUrl();
      var res = currentUrl.split("=");
      if (res.length > 1) {
        currentUrl = res.slice(-1).pop();
        res = currentUrl.split("%");

        AuthServerProvider.login(res[0])
          .then(function (response) {
            // response.data has the idtoken
            Principal.identity(true).then(function (account) {
              // After the login the language will be changed to
              // the language selected by the user during his registration
              if (account !== null) {
                $translate.use(account.langKey).then(function () {
                  $translate.refresh();
                });
              }
              var sessionDetails = {
                firstName: account.firstName,
                lastName: account.lastName,
                authorities: account.authorities,
                langKey: account.langKey
              };
              $cookies.putObject("sessionDetails", sessionDetails);
              deferred.resolve(response);
            });
          })
          .catch(
            function (err) {
              this.logout();
              deferred.reject(err);
              return cb(err);
            }.bind(this)
          );
      }

      return deferred.promise;
    }
    function loginWithToken(jwt, rememberMe) {
      return AuthServerProvider.loginWithToken(jwt, rememberMe);
    }

    function logout(isLoggedOut, isTokenNotAvailable) {
      if (isTokenNotAvailable) {
        AuthServerProvider.logout(false);
      } else {
        AuthServerProvider.logout(isLoggedOut);
      }
      Principal.authenticate(null);
      $cookies.remove("sessionDetails");
      //$cookies.remove('NG_TRANSLATE_LANG_KEY');
      $state.go("login");

      //Clearing session storage values
      StorageDelete.deleteInvestigation();
      StorageDelete.deleteUser();
      StorageDelete.deleteLibrary();
      StorageDelete.deleteSessionValue();
      communicationService.setData("isLoggedIn", false);
      communicationService.setData("timeLastFocus", undefined);
    }

    function resetPasswordFinish(keyAndPassword, callback) {
      var cb = callback || angular.noop;

      return PasswordResetFinish.save(
        keyAndPassword,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function resetPasswordInit(mail, callback) {
      var cb = callback || angular.noop;

      return PasswordResetInit.save(
        mail,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function updateAccount(account, callback) {
      var cb = callback || angular.noop;

      return Account.save(
        account,
        function () {
          return cb(account);
        },
        function (err) {
          return cb(err);
        }.bind(this)
      ).$promise;
    }

    function getPreviousState() {
      var previousState = $sessionStorage.previousState;
      return previousState;
    }

    function resetPreviousState() {
      delete $sessionStorage.previousState;
    }

    function storePreviousState(previousStateName, previousStateParams) {
      var previousState = { name: previousStateName, params: previousStateParams };
      $sessionStorage.previousState = previousState;
    }

    function forgotPassword() {
      var deferred = $q.defer();
      var url = "forget-password-url";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    }
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("AuthServerProvider", AuthServerProvider);

  AuthServerProvider.$inject = ["$http", "$localStorage", "$sessionStorage", "$q", "BASE_URL"];

  function AuthServerProvider($http, $localStorage, $sessionStorage, $q, BASE_URL) {
    var service = {
      login,
      logout,
      loginWithToken,
      storeAuthenticationToken,
      getToken
    };

    return service;

    function login(tokenValue) {
      const token = { tokenId: tokenValue };
      const url = "api/token";

      return $http.get(BASE_URL + url, { params: token }).success(function (data, status, headers) {
        if (data.id_token != null) {
          service.storeAuthenticationToken(data.id_token, true);
          return data.id_token;
        }
      });
    }

    function logout(isLoggedOut) {
      // logout from the server
      $http.post(BASE_URL + "api/logout?isLoggedOut=" + isLoggedOut).success(function (response) {
        //Reload page if the appversion miss match
        var currentVersion = $localStorage.lari_currentVersion;
        var appVersion = $localStorage.lari_appVersion;
        if (currentVersion && appVersion != currentVersion) {
          $localStorage.lari_appVersion = $localStorage.lari_currentVersion;
          setTimeout(function () {
            location.reload(true);
            window.location.href = window.location.href;
          });
        }
        $http.get(BASE_URL + "api/account");
        //Delete JWT token from storage
        delete $localStorage.authenticationToken;
        delete $sessionStorage.authenticationToken;
        return response;
      });
    }

    function loginWithToken(jwt, rememberMe) {
      var deferred = $q.defer();

      if (angular.isDefined(jwt)) {
        this.storeAuthenticationToken(jwt, rememberMe);
        deferred.resolve(jwt);
      } else {
        deferred.reject();
      }

      return deferred.promise;
    }

    function storeAuthenticationToken(jwt, rememberMe) {
      if (rememberMe) {
        $localStorage.authenticationToken = jwt;
      } else {
        $sessionStorage.authenticationToken = jwt;
      }
    }

    function getToken() {
      return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("Principal", Principal);

  Principal.$inject = ["$q", "$location", "Account", "AuthServerProvider"];

  function Principal($q, $location, Account, AuthServerProvider) {
    var _identity,
      _authenticated = false;

    var service = {
      authenticate,
      hasAnyAuthority,
      hasAuthority,
      identity,
      isAuthenticated,
      isIdentityResolved
    };

    return service;

    function authenticate(identity) {
      _identity = identity;
      _authenticated = identity !== null;
    }

    function hasAnyAuthority(authorities) {
      if (!_authenticated || !_identity || !_identity.authorities) {
        return false;
      }

      for (var i = 0; i < authorities.length; i++) {
        if (_identity.authorities.indexOf(authorities[i]) !== -1) {
          return true;
        }
      }

      return false;
    }

    function hasAuthority(authority) {
      if (!_authenticated) {
        return $q.when(false);
      }

      return this.identity().then(
        function (_id) {
          return _id.authorities && _id.authorities.indexOf(authority) !== -1;
        },
        function () {
          return false;
        }
      );
    }

    function identity(force) {
      var deferred = $q.defer();

      if (force === true) {
        _identity = undefined;
      }

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving
      if (angular.isDefined(_identity)) {
        deferred.resolve(_identity);

        return deferred.promise;
      }

      // retrieve the identity data from the server, update the identity object, and then resolve.
      const match = /\?Authorization=(\d+)%.*$/i.exec($location.absUrl());
      if (!!match) {
        // using the match, find the id_token
        const tokenId = match[1];
        AuthServerProvider.login(tokenId)
          .then(() => {
            // remove the Authorization from the Address Bar. Due to AngularJs limitations,
            // we cannot set the $locationProvider to HTML5 mode (since we are serving the content
            // statically)
            const url = new URL(window.location.origin + "/" + window.location.hash);
            window.location.href = url.href;
          })
          .catch(getAccountCatch);
      } else {
        Account.get().$promise.then(getAccountThen).catch(getAccountCatch);
      }

      return deferred.promise;

      function getAccountThen(account) {
        _identity = account.data;
        _authenticated = true;
        deferred.resolve(_identity);
      }

      function getAccountCatch(e) {
        _identity = null;
        _authenticated = false;
        deferred.reject(e);
      }
    }

    function isAuthenticated() {
      return _authenticated;
    }

    function isIdentityResolved() {
      return angular.isDefined(_identity);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").factory("ProfileService", ProfileService);

  ProfileService.$inject = ["$http", "$localStorage", "BASE_URL"];

  function ProfileService($http, $localStorage, BASE_URL) {
    var dataPromise;

    var service = {
      getProfileInfo: getProfileInfo
    };

    return service;

    function getProfileInfo() {
      if (angular.isUndefined(dataPromise)) {
        var url = BASE_URL + "api/profile-info";
        dataPromise = $http.get(url).then(function (result) {
          if (result.data.activeProfiles) {
            var response = {};
            response.activeProfiles = result.data.activeProfiles;
            response.ribbonEnv = result.data.ribbonEnv;
            response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
            response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;

            //Reload page if the appversion miss match
            var currentVersion = $localStorage.currentVersion;
            var appVersion = $localStorage.appVersion;
            if (currentVersion && appVersion != currentVersion) {
              $localStorage.appVersion = $localStorage.currentVersion;
              setTimeout(function () {
                location.reload(true);
                window.location.href = window.location.href;
              });
            }

            return response;
          }
        });
      }
      return dataPromise;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('lariAidApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('external', {
            parent: 'users',
            url: '/external',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            },
            views: {
                'userList': {
                    templateUrl: 'app/user/internal/user.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user.json?timestamp='+new Date().getTime());
                       } 
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("2");
                	$timeout(function() {
                	    angular.element('#externalUser').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('internal', {
            parent: 'users',
            url: '/internal',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            },
            views: {
                'userList': {
                    templateUrl: 'app/user/internal/user.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#internalUser').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();

(function () {
    'use strict';
 
    angular
       .module('lariAidApp')
       .config(stateConfig);
    stateConfig.$inject = ['$stateProvider', 'APP'];
 
    function stateConfig($stateProvider, APP) {
       $stateProvider.state('country-admin', {
          parent: 'users',
          url: '/country-admin',
          data: {
             authorities: [APP.GLOBAL.ROLE_MANAGER]
          },
          params: {
             id: null,
          },
          views: {
             'userList': {
                templateUrl: 'app/user/admin/admins.html',
                controller: 'CountryAdminController',
                controllerAs: 'vm'
             }
          },
          resolve: {
             mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                if (localStorage && localStorage.getItem('lari_currentVersion') != null) {
                   $translatePartialLoader.addPart('user.json?version=' + localStorage.getItem('lari_currentVersion'));
                } else {
                   $translatePartialLoader.addPart('user.json?timestamp=' + new Date().getTime());
                }
                return $translate.refresh();
             }],
             mdTabIndex: ['tabservice', '$timeout', function (tabservice, $timeout) {
                tabservice.setIndex("3");
                $timeout(function () {
                   angular.element('#countryAdmin').triggerHandler('click');
                });
             }]
          }
       });
    }
 })();
(function() {
    'use strict';

    var lariDevApp = angular
        .module('lariAidApp')
        lariDevApp.controller('UserProspectsController', UserProspectsController);
    UserProspectsController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$stateParams','APP','$timeout','tabservice','$mdDialog','BaseFactory','UserProfileService','$element','UserService','CommonService','$cookies','notifications'];
    function UserProspectsController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$stateParams,APP,$timeout,tabservice,$mdDialog,BaseFactory,UserProfileService,$element,UserService,CommonService,$cookies,notifications) {
    	var vm=this;
    	vm.back = back;
    	vm.$state =$state;
    	vm.user = $stateParams; 
    	vm.media = $mdMedia;
    	vm.APP = APP;
    	vm.title = $state.includes('users');
   	    vm.titleName = vm.APP.STATES.USERS; 
   	    vm.emailDisable = false;
    	$scope.updateUserName = function(firstName,lastName){
    		vm.userName = firstName + " "+lastName;
    	};
    	$scope.userRole = function(userRole){
    		vm.userRole = userRole;
    	};
    	$scope.userActivated = function(activated){
    		vm.userActivate = activated;
    	};
   	    
   	 vm.stateProfileDetails = function(){
  		$state.go("userprofile",vm.user);
  	};
  	vm.stateActivity = function(){
  		$state.go("useractivity",vm.user);
  	};
    	// Set the active md tab while refresh the page
    	
    	vm.checkUserIndex = function(){
    		vm.userDetailsTabIndex = tabservice.getIndex();
    	};
    	
    	vm.checkUserIndex();
    	
    	$scope.WindowPopupHeight=window.innerHeight;
    	function back(){
    		$state.go(vm.user.userType);
    	};
    	
    	vm.toggleLeft = toggleLeft('right');
     	
    	function toggleLeft(navID) {
     	      return function() {
     	        $mdSidenav(navID).toggle()
     	      };
    	};
     	    
    	vm.prospectsInit = function(){
    		vm.currentState = $state.current.name;
 	    	vm.loogedUserDetails =  $cookies.getObject('sessionDetails');
     		var loggedUser = vm.loogedUserDetails.authorities[0];
     		//Read_only user has all the access as Manager user in USER page except to add a non-registered user
     		if(loggedUser == vm.APP.GLOBAL.ROLE_MANAGER){
     			vm.loggedUserRole = vm.APP.GLOBAL.MANAGER;
     		}
     		else if(loggedUser = vm.APP.GLOBAL.ROLE_ADMIN){
     			vm.loggedUserRole = vm.APP.GLOBAL.ADMIN;
     		}
			else if(loggedUser = vm.APP.GLOBAL.ROLE_INVESTIGATOR){
				vm.loggedUserRole = vm.APP.GLOBAL.INVESTIGATOR;	
			}
			else if(loggedUser = vm.APP.GLOBAL.ROLE_ANALYST){
				vm.loggedUserRole = vm.APP.GLOBAL.ANALYST;
			}
			else if(loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY){
     			vm.loggedUserRole = vm.APP.GLOBAL.READ_ONLY;
			}
 	    };
    	
//EDIT INVESTIGATOR POPUP
     	
     	vm.openEditPopup = function(ev,id,flag){
     		vm.investigator = {};
            vm.popupTitleFlag = flag;
            vm.existFlag = false;
            vm.saveDisableFlag = false;
            vm.updateExistFlag = false;
            vm.updateDisableFlag = false;
     		if(vm.user != null){
            	vm.investigatorDetails(vm.user.id);
            }
     		
     		/*$mdDialog.show({	
     			targetEvent: ev,
                controller: function () {
                    return vm;
                },
                controllerAs: 'vm',
                templateUrl: '/app/user/external/addEditInvestigator.popup.html'
   	    	});  */  
     		$mdDialog.show({   	    		
     			targetEvent: ev,
     			contentElement:'#'+id,
     			parent: angular.element(document.body)
   	    	});
     	};
     	
     	vm.isFabOpen = false;
     	
     	vm.searchLocations = function(searchKey){
	  		 if(searchKey){
	  			vm.locationLoader = true;
	  			var data =  CommonService.getRefTermList(vm.APP.REF_TERM.COUNTRY,searchKey);
		  	  	data.then(function(response){
		        	vm.locationVO = response;
		        	vm.locationLoader = false;
		  	  	});
	  		 }
	  	 }
     	
     	vm.initLanguage = function(){
   	    	var data =  BaseFactory.getLanguagesList();
    		data.then(function(response){
   	        	vm.languagesVO = response;
   	        });
   	    };
   	    
   	    vm.clearLocation = function(searchKey,listValue){    		
   	    	vm[searchKey] = undefined;
     		vm[listValue] = undefined;
   	    };
   	    
   	    vm.cancel = function(){
   	    	$mdDialog.hide();
   	    };
   	    
	   	 $element.find('input').on('keydown', function(ev) {
	         ev.stopPropagation();
	     });
     	     	
     	vm.investigatorDetails = function(userId){
     		vm.investigator = {};
     		//Set the investigator object to avoid unwanted update call
     		vm.oldInvestigatorObj = {};
     		vm.oldInvestigatorObj.language = [];
	   	    vm.oldInvestigatorObj.phoneNumber = [];
	   	    vm.oldInvestigatorObj.userCountryDTO = {};

        	if(userId){
        		var data = UserProfileService.getInvestigatorDetails(userId);
        		  data.then(function(response){
        			  vm.userProfileLoader = false;
        			  
        			  vm.investigator.firstName = response.firstName;
        			  vm.investigator.lastName = response.lastName;
        			  vm.investigator.emailAddress = response.emailAddress;
        			  
        			  //Set the investigator object to avoid unwanted update call
        			  vm.oldInvestigatorObj.firstName = response.firstName;
        			  vm.oldInvestigatorObj.lastName = response.lastName;
        			  vm.oldInvestigatorObj.emailAddress = response.emailAddress;
        			  vm.oldInvestigatorObj.id = vm.user.id;
        			  
        			  if(response.userCountryDTO){
        				  vm.investigator.comment = response.userCountryDTO.comment;
        				  //Set the investigator object to avoid unwanted update call
        				  vm.oldInvestigatorObj.userCountryDTO.countryId = response.userCountryDTO.countryId;
        				  vm.oldInvestigatorObj.userCountryDTO.comment = response.userCountryDTO.comment;
        			  }
        			  
        			  
        			  if(response.userCountryDTO){
        				  var country = {};
            			  country.id = response.userCountryDTO.countryId;
            			  country.name = response.userCountryDTO.countryName;
            			  vm.investigator.country = country;
        			  }
        			  
        			  if(response.phoneNumber != null){
        				  angular.forEach(response.phoneNumber, function(data, key){        				  
            				  vm.investigator.phoneNumber = data.value;
            				  //Set the investigator object to avoid unwanted update call
            				  var phone = {};
            				  phone.value = data.value;
            				  phone.phoneType = vm.APP.USER.PHONETYPE;
            				  phone.phoneEntityType = vm.APP.USER.ENTITYTYPE;
            				  vm.oldInvestigatorObj.phoneNumber.push(phone);  
            			  }); 
        			  }        			     
        			  
        			  if(response.language){
        				  vm.investigator.language = [];
            			  angular.forEach(response.language, function(data, key){
            				  var langObj = {};
            				  langObj.id = data.languageId;
            				  langObj.name = data.languageName;
            				  vm.investigator.language.push(langObj);
            				  vm.oldInvestigatorObj.language = response.language;
            			  });
        			  }
        			  
        		  }, function(reason) {
        		return reason;
        		});
        	}
        };
        
        vm.saveInvestigator = function(investigator,addInvestigatorForm){  
			if(addInvestigatorForm.$valid && investigator){
				vm.investigatorObj = {};
		   	    vm.investigatorObj.language = [];
		   	    vm.investigatorObj.phoneNumber = [];
		   	    vm.investigatorObj.userCountryDTO = {};
				vm.updateDisableFlag = true;
				var isPutJsonSimilar = false;
				
				if(vm.user != null){
					vm.investigatorObj.id = vm.user.id;
				}
				
				if(investigator.country != null){
					vm.investigatorObj.userCountryDTO.countryId = investigator.country.id;
					vm.investigatorObj.userCountryDTO.comment = investigator.comment;
				}
				
				angular.forEach(investigator.language, function(obj, index) {
					var lang = {};
					lang.languageId = obj.id;
					vm.investigatorObj.language.push(lang);				
	    		});		
				
				if(investigator.phoneNumber != null) {
					var phone = {};
					phone.value = investigator.phoneNumber;
					phone.phoneType = vm.APP.USER.PHONETYPE;
					phone.phoneEntityType = vm.APP.USER.ENTITYTYPE;
					vm.investigatorObj.phoneNumber.push(phone);  
				}
				
				vm.investigatorObj.firstName = investigator.firstName;
				vm.investigatorObj.lastName = investigator.lastName;
				vm.investigatorObj.emailAddress = investigator.emailAddress;
				
				if(!angular.isUndefined(vm.oldInvestigatorObj)){
					if(angular.equals(vm.investigatorObj, vm.oldInvestigatorObj)){
						isPutJsonSimilar = true;
					}
				}
				
				if(!isPutJsonSimilar) {
					var data =  UserService.updateInvestigator(vm.investigatorObj);
					data.then(function(response){		
						$mdDialog.hide();
						$state.transitionTo($state.current, $stateParams, {
						    reload: true,
						    inherit: false,
						    notify: true
						});
						notifications.showSuccess({message: vm.APP.LIBRARY.USER_EDIT});
		   	        }, function(reason) {
		   	        	if(reason.status == 409) {
		   	        		vm.updateExistFlag = true;
		   	        		vm.updateDisableFlag = false;
		   	        	} else {
		   	        		notifications.showError({message: vm.APP.LIBRARY.USER_EDIT_PROBLEM});
		   	        	}
		   	        	$timeout(function(){
		   	        		vm.updateExistFlag = false;
		   	        	},3000);
		   	        });
				} else {
					$mdDialog.hide();
				}
			}
			
    	};
    	
/*    	//DELETE POPUP
    	
    	vm.openDeletePopup = function(ev,id){
    		
    		if(vm.user != null){
    			vm.investigatorActiveCaseCount(vm.user.id);
            }
     		
     		$mdDialog.show({    			
     			targetEvent: ev,
                controller: function () {
                    return vm;
                },
                controllerAs: 'vm',
                templateUrl: '/app/user/external/deleteInvestigatorPopup.html'
   	    	});     		
     	};
     	
     	vm.investigatorActiveCaseCount = function(userId){
     		if(userId){
     			var data = UserProfileService.getInvestigatorActiveCaseCount(userId);
     			data.then(function(response){
     				vm.activeCaseCount = response;
     			});     			
     		};
     	};
     	
     	vm.deleteInvestigator = function(userId){
     		if(userId){
     			var data = UserProfileService.deleteInvestigatorDetails(userId);
     			data.then(function(response){
     				vm.activeCaseCount = response;
     			});     			
     		};
     	};*/

    }
})();

(function(){
	'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('userprospects', {
            parent: 'users',
            url: '/:userType',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            	userType:null
            },
            views: {
                'content@': {
                    templateUrl: 'app/user/userprospects/user.prospects.html',
                    controller: 'UserProspectsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]/*,
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#userProfile').triggerHandler('click');
                	  },500);
                }]*/
            }
        })
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
        	parent: 'app',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'fillPage@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('reset.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('reset.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'app',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'fillPage@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('reset.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('reset.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    var lariDevApp = angular
        .module('lariAidApp')
        lariDevApp.controller('ActivityController', ActivityController);

    ActivityController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','APP','ProspectActivityService','$stateParams','CommonService'];
    function ActivityController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,APP,ProspectActivityService,$stateParams,CommonService) {
    	var vm = this;
    	$scope.media = $mdMedia;
    	vm.APP = APP;
    	/*vm.user =  $cookies.getObject('sessionDetails');*/
    	vm.user = CommonService.getCookieUser().cookieUser;
    	vm.investigation = $stateParams;
    	
    	vm.activityLoader = true;
    	vm.activityDetails = function(investigationId){
        	if(investigationId){
        		var data = ProspectActivityService.getActivityDetails(investigationId);
        		  data.then(function(response){
					  vm.activityLoader = false;
					  $scope.translateActivityDate(response.investigationActivity)
        			  vm.activity = response;
        			  $scope.updateProspectName(response.prospectFirstName,response.prospectLastName);
        		  }, function(reason) {
        		return reason;
        		});
        	}
        };
        
        if(vm.investigation != null){
        	vm.activityDetails(vm.investigation.id);
        }
	
		//method for date split in response for spanish translation
		$scope.translateActivityDate = function (investigationActivity) {
			if (investigationActivity.length > 0) {
				angular.forEach(investigationActivity, function (activity) {
					if (activity.date != "" && activity.date != null) {
						activity.month = activity.date.substring(0, 3)
						activity.day = activity.date.substring(3, 7)
						activity.year = activity.date.substring(7, 12)
					}
				});
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('ProspectActivityService', ProspectActivityService);

    ProspectActivityService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function ProspectActivityService ($resource,restService,$q,$rootScope) {
    	
    	this.getActivityDetails= function(investigationId){
    		var deferred = $q.defer();
    		var url = "investigations/activity/"+investigationId;
    		var data = restService.restCall("", url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    		
    }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('activity', {
            parent: 'prospects',
            url: '/:id/activity',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            },
            views: {
                'sample': {
                    templateUrl: 'app/investigation/prospects/activity/activity.html',
                    controller: 'ActivityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('activity.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('activity.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("2");
                	$timeout(function() {
                	    angular.element('#activity').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();

(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.controller("ProfileController", ProfileController);

  ProfileController.$inject = [
    "$rootScope",
    "$scope",
    "$window",
    "$mdDialog",
    "$mdSidenav",
    "Principal",
    "$state",
    "$mdMedia",
    "APP",
    "ProspectProfileService",
    "$stateParams",
    "CommonService",
    "$element",
    "$sessionStorage",
    "InvestigationService",
    "$timeout",
    "$q",
    "BASE_URL",
    "$cookies"
  ];
  function ProfileController(
    $rootScope,
    $scope,
    $window,
    $mdDialog,
    $mdSidenav,
    Principal,
    $state,
    $mdMedia,
    APP,
    ProspectProfileService,
    $stateParams,
    CommonService,
    $element,
    $sessionStorage,
    InvestigationService,
    $timeout,
    $q,
    BASE_URL,
    $cookies
  ) {
    var vm = this;
    $scope.mediaCheck = $mdMedia;
    vm.APP = APP;
    vm.downloadAPI = BASE_URL + vm.APP.INVESTIGATION.DOWNLOAD_API;
    vm.user = CommonService.getCookieUser().cookieUser;
    vm.investigation = $stateParams;
    vm.show = {};
    vm.show.flag = false;
    vm.list = [];
    vm.Investigator = "";
    var originatorEv;
    vm.assign = assign;
    vm.data = {};
    vm.assinerRepeat = false;
    vm.profileForm = {};
    vm.profile = {};
    vm.analystAssignerRepeat = false;
    vm.multipleForm = false;
    var qPromises = [];

    vm.userAssign = {};
    vm.userFilterObj = {};
    vm.userFilterObj.userRoleKey = [];

    vm.loggedUserRole = CommonService.getCookieUser().loggedUserRole;

    vm.lang = CommonService.getCookieLanguage();

    vm.noInvestigationFormExistForCountryAdmin = false;
    vm.test = {};
    vm.assignerObj = {};

    vm.showCloseCases = false;
    vm.showOpenCases = true;

    vm.listTotalLength = 0;
    vm.listFrom = 0;
    vm.startSet = 0;
    vm.size = 15;
    $sessionStorage.isView = false;
    $scope.isReassign = false;
    $scope.investigationFormId = null;
    $scope.unAssignerId = null;
    vm.deleteFormObj = {};
    vm.reopenFormObj = {};

    vm.profileDetailLoader = true;
    vm.profileDataLoader = true;
    vm.requestedList = [];
    $scope.byPassInvestigationFormId = null;
    $scope.assignerId = null;
    vm.goInvestigation = false;
    vm.rcCompleted = true;
    vm.openFormObj = {};

    vm.profileDetails = function (investigationId) {
      if (!isNaN(investigationId)) {
        vm.profileProspectData(investigationId);
        vm.profileInvestigationData(investigationId);
      } else {
        $rootScope.unauthorized.isUnauthorized = true;
      }
    };

    vm.profileProspectData = function (investigationId) {
      if (investigationId) {
        var data = ProspectProfileService.getProfileData(investigationId);
        data.then(
          function (response) {
            vm.profileDataLoader = false;
            //dateOfBirth split in response for spanish translation
            if (response.dateOfBirth != "" && response.dateOfBirth != null) {
              response.monthDob = response.dateOfBirth.substring(0, 3)
              response.dayDob = response.dateOfBirth.substring(3, 7)
              response.yearDob = response.dateOfBirth.substring(7, 12)
            }
            vm.profileData = response;
            $scope.updateProspectName(response.firstName, response.lastName);
          },
          function (reason) {
            return reason;
          }
        );
      }
    };

    vm.profileInvestigationData = function (investigationId) {
      if (investigationId) {
        var data = ProspectProfileService.getProfileInvestigationData(investigationId);
        data.then(
          function (response) {
            vm.profileDetailLoader = false;
            //openInvestigation Date seperation for language translation
            $scope.translateOpenInvestigation(response)
            //closedInvestigation Date seperation for language translation
            $scope.translateClosedInvestigation(response)
            vm.profile = response;
            vm.ebisDocumentsList(investigationId);
            vm.findInvestigationId();
          },
          function (reason) {
            if (reason.status == 409) {
              vm.profileDetailLoader = false;
              vm.isAnalystForm = false;
              vm.goInvestigation = true;
              var popupId = vm.APP.INVESTIGATION.INVESTIGATIONDELETEDPUPID;
              $mdDialog.show({
                contentElement: angular.element("#" + popupId),
                clickOutsideToClose: false,
                escapeToClose: false
              });
            }
          }
        );
      }
    };

    vm.ebisDocumentsList = function (investigationId) {
      if (investigationId) {
        vm.documentLoader = true;
        var data = ProspectProfileService.getEbisDocuments(investigationId);
        data.then(
          function (response) {
            vm.documentLoader = false;
            $scope.documents = [];
            $scope.documents = response;
          },
          function (reason) {
            return reason;
          }
        );
      }
    };

    vm.assignee = function (event, id, formtype) {
      vm.assignDisableFlag = true;
      vm.assinerRepeat = false;
      vm.analystAssignerRepeat = false;
      vm.isAnalystAssigned = false;
      if (formtype == "assignInvestigatorPopup") {
        vm.formType = "INVESTIGATOR_FORM";
      }
      if (formtype == "assignAnalystPopup") {
        vm.formType = "ANALYST_FORM";
      }
      vm.assignerObj.investigationId = vm.investigation.id;
      vm.assignerObj.formType = vm.formType;
      vm.assignerObj.assignerId = id;
      if ($scope.isReassign) {
        vm.assignerObj.unAssignerId = $scope.unAssignerId;
        vm.assignerObj.investigationFormId = $scope.investigationFormId;
        var data = ProspectProfileService.saveReAssignee(vm.assignerObj);
      } else {
        var data = ProspectProfileService.saveAssignee(vm.assignerObj);
      }
      data.then(
        function (response) {
          vm.show.flag = true;
          vm.profileDetails(vm.investigation.id);
          $mdDialog.hide();
        },
        function (reject) {
          vm.assinerRepeat = true;
          if (reject.data.description != vm.APP.INVESTIGATION.ALREADR_ASSIGNED && formtype == "assignAnalystPopup") {
            vm.analystAssignerRepeat = true;
          }
          if (reject.data.description == vm.APP.INVESTIGATION.ALREADR_ASSIGNED) {
            vm.isAnalystAssigned = true;
          }
        }
      );
    };
    function assign(result, ev, id) {
      $mdDialog.hide(result);
      vm.test = result;
      vm.data = angular.copy(vm.test);
      vm.assignDisableFlag = false;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    }
    vm.searchAssign = function (searchKey) {
      vm.userFilterObj.searchKey = searchKey;
      if (searchKey.length > 1 || searchKey.length == 0) {
        vm.searchAnalystorInvestigator();
      }
    };

    vm.updateAssignUserFilterObjList = function (postVariable, modelName) {
      vm.userFilterObj.isInternalUser = 1;
      vm.userFilterObj[postVariable] = [];
      if (vm.userAssign[modelName] || vm.userFilter[modelName].id) {
        if (vm.userAssign[modelName].userRole == vm.APP.GLOBAL.INVESTIGATOR) {
          vm.userFilterObj.isInternalUser = 0;
        }

        if (vm.userAssign[modelName]) {
          vm.userFilterObj[postVariable].push(vm.userAssign[modelName].id);
        }
      }
    };

    vm.searchAnalystorInvestigator = function (type) {
      if (type != "endless") {
        $scope.assignInvestigatorVO = [];
      }
      if ($scope.assignInvestigatorVO && $scope.assignInvestigatorVO.length == 0) {
        vm.listFrom = 0;
        vm.listTotalLength = 0;
        vm.startSet = 0;
      } else if ($scope.assignInvestigatorVO.length > 0) {
        vm.listFrom = $scope.assignInvestigatorVO.length;
      }

      if (vm.listFrom < vm.listTotalLength || vm.listTotalLength == 0) {
        vm.assignInvestigatorLoader = true;
        vm.userFilterObj.from = vm.listFrom;
        vm.userFilterObj.size = vm.size;
        var data = ProspectProfileService.getUserList(vm.userFilterObj);
        data.then(function (response) {
          if (type != "endless") {
            $scope.assignInvestigatorVO = [];
          }
          if (response && !angular.equals({}, response) && response.totalCount > 0) {
            vm.assignInvestigatorLoader = false;
            vm.startSet++;
            vm.listTotalLength = response.totalCount;
            angular.forEach(response.investigationUserlist, function (boat, key) {
              if ($scope.assignInvestigatorVO == null) {
                $scope.assignInvestigatorVO = [];
                $scope.assignInvestigatorVO.push(boat);
              } else {
                $scope.assignInvestigatorVO.push(boat);
              }
            });
            vm.listFrom = $scope.assignInvestigatorVO.length;
            if (vm.listFrom == vm.listTotalLength) {
              vm.assignInvestigatorLoader = false;
              vm.noInvestigators = false;
              vm.noMoreInvestigators = true;
            }

            if (vm.listFrom <= vm.APP.GLOBAL.DEFAULT_SIZE) {
              vm.noMoreInvestigators = false;
            }
          } else if (angular.isUndefined(response.investigationUserlist)) {
            vm.assignInvestigatorLoader = false;
            vm.noInvestigators = true;
            vm.noMoreInvestigators = false;
          } else if (response && !angular.equals({}, response) && response.totalCount == 0) {
            vm.assignInvestigatorLoader = false;
            vm.noInvestigators = true;
            vm.noMoreInvestigators = false;
          }
        });
      } else {
        vm.assignInvestigatorLoader = false;
        vm.noMoreInvestigators = true;
        vm.noInvestigators = false;
      }
    };

    $scope.callListfun = function () {
      vm.searchAnalystorInvestigator("endless");
    };
    //Handling Reassign Investigation Form
    vm.openReAssignPopup = function (ev, id, role, invList) {
      $scope.isReassign = true;
      $scope.investigationFormId = invList.investigationFormId;
      $scope.unAssignerId = invList.assignerId;
      $scope.reassignFiratName = invList.assignerFirstName;
      $scope.reassignLastName = invList.assignerLastName;
      vm.openAssignPopup(ev, id, role, 1, $scope.isReassign);
    };

    vm.openAssignPopup = function (ev, id, role, isInitial, isreassign) {
      //Handling Reassign
      if (isreassign == undefined) {
        $scope.isReassign = false;
      }
      vm.assinerRepeat = false;
      var searchKey = null;
      var isExternalInvestigator = 1;
      if (role == "INVESTIGATOR") {
        role = vm.APP.GLOBAL.INVESTIGATOR;
        $scope.investigatorPopup = 1;
      } else if (role == "ANALYST") {
        $scope.investigatorPopup = 0;
      }
      if (isInitial == 1) {
        vm.userAssign.role = undefined;
        $scope.searchInvObj.assignInvestigatorSearchKey = "";
        $scope.searchInvObj = {};
      }
      if (isInitial == 0 && vm.userAssign.role != null) {
        role = vm.userAssign.role.userRole;
      }
      var data = ProspectProfileService.getRoleList();
      data.then(function (response) {
        vm.rolesList = response;
        vm.deletedIndex = [];
				//if role is country admin disable the analyst option
				angular.forEach(vm.rolesList,function(obj,index){
					if(vm.loggedUserRole === vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN){
						if((obj.userRole === "ANALYST") || (obj.userRole == "COUNTRY ADMIN")){
							vm.deletedIndex.push(index);
						}
					}
					// remove the country admin option while open a assign analyst option
					if($scope.investigatorPopup == 0 && obj.userRole == "COUNTRY ADMIN"){
						vm.rolesList.splice(index,1);
					}
					});

					if(vm.deletedIndex.length > 0){
						angular.forEach(vm.deletedIndex,function(data){
							vm.rolesList.splice(data,1);
						});
					}
        angular.forEach(vm.rolesList, function (obj, index) {
          if (obj.userRole == role) {
            vm.userAssign.role = obj;
            vm.updateAssignUserFilterObjList("userRoleKey", "role");
            vm.searchAnalystorInvestigator();
          }
        });
      });
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    };

    $scope.searchInvObj = {};
    $scope.searchInvObj.assignInvestigatorSearchKey = "";
    vm.search = function () {
      $scope.searchInvObj.assignInvestigatorSearchKey = "";
      vm.userFilterObj.searchKey = "";
      $scope.assignInvestigatorVO = [];
    };

    vm.openDeletePopup = function (ev, id, formData) {
      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(vm.checkActiveForm(formData.investigationFormId, ev, formData.investigationFormType));
      $q.all(qPromises).then(function (data) {
        vm.errorInvestigatorFlag = false;
        vm.errorFormCompletedFlag = false;
        if (formData.investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM) {
          vm.deleteFormObj.formType = vm.APP.INVESTIGATION.ANALYST_FORM;
          $scope.investigatorPopup = 0;
        }
        if (formData.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM) {
          vm.deleteFormObj.formType = vm.APP.INVESTIGATION.INVESTIGATOR_FORM;
          $scope.investigatorPopup = 1;
        }

        vm.deleteFormObj.assignerId = formData.assignerId;
        vm.deleteFormObj.investigationId = vm.investigation.id;
        vm.deleteFormObj.investigationFormId = formData.investigationFormId;
        $mdDialog.show({
          contentElement: angular.element("#" + id),
          targetEvent: ev,
          clickOutsideToClose: true
        });
      });
    };

    vm.togglepopupLeft = buildToggler("popupLeft");
    vm.toggleRight = buildToggler("right");
    function buildToggler(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }
    if (vm.investigation != null) {
      vm.profileDetails(vm.investigation.id);
    }

    vm.openInvestigationForm = function (ev, formType, isStatusUpdate) {
      vm.profileForm.investigationFormId = vm.profile.formId;
      $sessionStorage.selectedSectionIndex = 0;
      $sessionStorage.formType = formType;
      if (isStatusUpdate) {
        $state.go("profileForm", vm.profileForm);
      } else {
        //Check the form is active or not before open the form
        qPromises = [];
        qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, formType));
        $q.all(qPromises).then(function (data) {
          $state.go("profileForm", vm.profileForm);
        });
      }
    };

    vm.openMenu = function ($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    $scope.cancel = function () {
      $mdDialog.hide();
    };

    vm.openClosedCases = function () {
      if (vm.showCloseCases) {
        vm.showCloseCases = false;
      } else {
        vm.showCloseCases = true;
      }
    };
    vm.openOpenedCases = function () {
      if (vm.showOpenCases) {
        vm.showOpenCases = false;
      } else {
        vm.showOpenCases = true;
      }
    };

    $scope.loadDocuments = function () {
      //TODO Need to call the service with the respective parameters and translate to the corresponding documents
      /*var data =  ProspectProfileService.getDocuments();
	    	data.then(function(response){
	    		$scope.documents = 	response;
	    		$scope.birthRecords = response.birthRecords;
	          	$scope.schoolRecords = response.schoolRecords;
	          	$scope.familyRecords = response.familyRecords;
	          	$scope.neighborhoodRecords = response.neighborhoodRecords;
	          	$scope.dnaRecords = response.dnaRecords;
	    	},function(reject){

	    	}*/

      //Sample Json to test the Accordion
      var obj = {
        count: "7",
        documentList: [
          {
            externalLink:
              "http://10.211.50.62:9024/credential-content/organizations/98c556b8-281e-45p2-8da1-2701f1043d4/asset/587751caea96c85ee4917343/binary",
            file: "Sample Document",
            user: "Williams"
          },
          {
            externalLink:
              "http://10.211.50.62:9024/credential-content/organizations/98c556b8-281e-45p2-8da1-2701f1043d4/asset/587751caea96c85ee4917343/binary",
            file: "Test Document",
            user: "Michael"
          }
        ]
      };
      $scope.documents = obj;
      $scope.birthRecords = obj.documentList;
      $scope.schoolRecords = obj.documentList;
      $scope.familyRecords = obj.documentList;
      $scope.neighborhoodRecords = obj.documentList;
      $scope.dnaRecords = obj.documentList;
      $scope.religiousRecords = obj.documentList;
    };

    vm.toggleLeft = toggleLeft("right");

    function toggleLeft(navID) {
      return function () {
        $mdSidenav(navID).toggle();
      };
    }

    vm.viewform = function (investigationFormId, ev, formType) {
      $sessionStorage.isView = false;
      $sessionStorage.selectedSectionIndex = 0;
      $sessionStorage.formType = formType;
      vm.profileForm.investigationFormId = investigationFormId;
      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, formType));
      $q.all(qPromises).then(function (data) {
        $state.go("profileForm", vm.profileForm);
      });
    };

    //Method to open OPEN ANALYST POPUP
    vm.openAnalystFormPopup = function (ev, id) {
      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(
        vm.checkActiveForm(
          vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId,
          ev,
          vm.APP.INVESTIGATION.ANALYST_FORM
        )
      );
      $q.all(qPromises).then(function (data) {
        if ((vm.investigationId = vm.profile.openInvestigationList != null)) {
          vm.investigationId = vm.profile.openInvestigationList[0].investigationId;
        }
        var data = InvestigationService.getCompletedInvestigatorNames(vm.investigationId);
        data.then(function (response) {
          vm.investigatorForm = response;
          vm.openAnalystForm = {};
          if (vm.investigatorForm.length > 0) {
            //length has been checked to verify that the response has only external investigators or with investigators.
            vm.selectFlag = false;
            $mdDialog.show({
              targetEvent: ev,
              contentElement: "#" + id,
              parent: angular.element(document.body)
            });
          } else {
            vm.openAnalystForm.analystForm = {};
            vm.openAnalystForm.analystForm.checked = true;
            vm.openSelectedForm(vm.openAnalystForm, ev);
          }
        });
      });
    };

    vm.cancel = function () {
      $mdDialog.hide();
    };

    vm.removeSelection = function () {
      if (vm.openAnalystForm.investigatorForm != undefined && vm.openAnalystForm.investigatorForm.id != null) {
        vm.openAnalystForm.investigatorForm = {};
      }
    };

    vm.removeCheckBox = function () {
      if (vm.openAnalystForm.analystForm != undefined && vm.openAnalystForm.analystForm.checked) {
        vm.openAnalystForm.analystForm.checked = false;
      }
    };

    vm.openSelectedForm = function (analystForm, ev) {
      if (analystForm == undefined) {
        vm.selectFlag = true;
      } else if (analystForm.investigatorForm != undefined && analystForm.investigatorForm.id != null) {
        $sessionStorage.isView = true;
        $sessionStorage.analystFormId =
          vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId;
        $sessionStorage.formType = vm.APP.INVESTIGATION.INVESTIGATOR_FORM;
        vm.profileForm.investigationFormId = analystForm.investigatorForm.id;

        //Check the form is active or not before open the form
        qPromises = [];
        qPromises.push(
          vm.checkActiveForm(vm.profileForm.investigationFormId, ev, vm.APP.INVESTIGATION.INVESTIGATOR_FORM)
        );
        $q.all(qPromises).then(function (data) {
          $state.go("profileForm", vm.profileForm);
        });
      } else if (analystForm.analystForm.checked) {
        $sessionStorage.isView = false;
        $sessionStorage.selectedSectionIndex = 0;
        $sessionStorage.formType = vm.APP.INVESTIGATION.ANALYST_FORM;
        vm.profileForm.investigationFormId =
          vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId;

        //Check the form is active or not before open the form
        qPromises = [];
        qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, vm.APP.INVESTIGATION.ANALYST_FORM));
        $q.all(qPromises).then(function (data) {
          $state.go("profileForm", vm.profileForm);
        });
      }
    };

    //Set Investigator Form Id to copy content to analyst Form
    vm.setCopyFormId = function (investigatorObj, ev) {
      $sessionStorage.analystFormId =
        vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId;
      vm.analystForm = {};
      vm.analystForm.investigatorForm = {};
      if (investigatorObj != null) {
        vm.analystForm.investigatorForm.id = investigatorObj.investigationFormId;
        vm.openSelectedForm(vm.analystForm, ev);
      }
    };

    vm.deleteConfirm = function () {
      vm.deleteDisableFlag = true;
      vm.errorInvestigatorFlag = false;
      vm.errorFormCompletedFlag = false;
      vm.isAnalystForm = false;
      var data = ProspectProfileService.deleteAssignee(vm.deleteFormObj);
      data.then(
        function (response) {
          vm.deleteDisableFlag = false;
          vm.profileDetails(vm.investigation.id);
          $mdDialog.hide();
        },
        function (reason) {
          if (vm.deleteFormObj.formType == vm.APP.INVESTIGATION.ANALYST_FORM) {
            vm.isAnalystForm = true;
          }
          if (reason.status == 409) {
            vm.deleteDisableFlag = false;
            vm.errorInvestigatorFlag = true;
            vm.errorMsg = reason.data.message;
          } else if (reason.status == 404) {
            vm.deleteDisableFlag = false;
            vm.errorFormCompletedFlag = true;
            vm.errorMsg = reason.data.message;
          }
        }
      );
    };

    /**
     * investigationFormId - Investigation Form Id or Analyst Form Id
     * formType - Investigator form, Analyst Form or RC Form
     */
    vm.getPdfReport = function (investigationFormId, formType, firstName, lastName, investigationId) {
      var formReportId;
      vm.profileDataLoader = true;
      vm.reportFileName = "";
      if (firstName != null) {
        vm.reportFileName += firstName + "_";
      }

      if (lastName != null) {
        vm.reportFileName += lastName + "_";
      }

      if (formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM) {
        formReportId = 0;
        vm.reportFileName += vm.APP.INVESTIGATION.INVESTIGATOR_REPORT_NAME;
      } else if (formType == vm.APP.INVESTIGATION.ANALYST_FORM) {
        formReportId = 1;
        vm.reportFileName += vm.APP.INVESTIGATION.ANALYST_REPORT_NAME;
      } else if (formType == vm.APP.INVESTIGATION.REVIEW_COMMITTEE_REPORT_NAME) {
        formReportId = 2;
        vm.reportFileName += vm.APP.INVESTIGATION.REVIEW_COMMITTEE_REPORT_NAME;
      }
      vm.reportFileName += vm.APP.GLOBAL.PDF;
      if (investigationFormId && investigationId) {
        var cookieUser = $cookies.getObject('sessionDetails');
				var url = BASE_URL + vm.APP.INVESTIGATION.REPORT_API+investigationFormId+"/"+formReportId+"/"+investigationId+"?user="+cookieUser.login;
        var timestamp = new Date().getTime();
        vm.reportUrl = url + "&timestamp=" + timestamp;
      }
      vm.profileDataLoader = false;
    };

    vm.getInvestigationFormId = function (openInv) {
      var investigationFormId;
      if (openInv) {
        if (openInv.analystFormInProgressList === undefined || openInv.analystFormInProgressList.length == 0) {
          investigationFormId = openInv.analystFormList[0].investigationFormId;
        } else if (openInv.analystFormList === undefined || openInv.analystFormList.length == 0) {
          investigationFormId = openInv.analystFormInProgressList[0].investigationFormId;
        }
      }
      return investigationFormId;
    };

    vm.sentToAnalyst = function (ev, id, formobj) {
      vm.reopenAnalystFlag = false;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
      if (formobj.investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM) {
        vm.reopenAnalystFlag = true;
      }
      if (formobj.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM) {
        vm.reopenAnalystFlag = false;
      }

      vm.reopenFormObj.assignerId = formobj.assignerId;
      vm.reopenFormObj.investigationId = vm.investigation.id;
      vm.reopenFormObj.investigationFormId = formobj.investigationFormId;
      vm.reopenFormObj.formType = formobj.investigationFormType;
    };

    vm.sentToAnalystConfirm = function () {
      vm.sendBackDisableFlag = true;
      var data = ProspectProfileService.reopenAnalyst(vm.reopenFormObj);
      data.then(
        function (response) {
          vm.sendBackDisableFlag = false;
          vm.profileDetails(vm.investigation.id);
          $mdDialog.hide();
        },
        function (reason) {
          vm.sendBackDisableFlag = false;
        }
      );
    };

    vm.sentToRCConfirm = function (ev, id, investigationToStatus, isManagerreview) {
      $scope.investigationToStatus = investigationToStatus;
      $scope.isManagerreview = isManagerreview;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    };
    /**
     * function to send back the investigation status to manger review
     * after receiving response redirect to the investigation listing page
     */
    vm.reopenForm = function (investigationId) {
      var data = ProspectProfileService.reopenForMangerReview(investigationId);
      data.then(function (response) {
        $scope.hideBtn = true;
        $state.go("investigations"); //redirect to investigation listing page
      });
    };

    vm.sentToRC = function () {
      vm.sendToRCDisableFlag = true;
      var data = ProspectProfileService.sentToRC($scope.investigationToStatus, vm.investigation.id);
      data.then(function (response) {
        vm.sendToRCDisableFlag = false;
        if ($scope.isManagerreview == 1) {
          vm.createRCSession();
        } else {
          vm.profileDetails(vm.investigation.id);
        }
        $mdDialog.hide();
      });
    };

    vm.sentToeBisConfirm = function (ev, id, investigationStatus, investigationFormId) {
      if (investigationFormId == undefined) {
        $scope.isRCResult = 1;
      } else {
        $scope.isRCResult = 0;
      }
      $scope.ebisInvestigationFormId = investigationFormId;
      $scope.investigationStatus = investigationStatus;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    };
    vm.erroreBisFlag = false;
    vm.sentToeBis = function (ev) {
      var eBisObj = {};
      var isManagerReview;
      vm.eBisResultLoader = true;
      if ($scope.investigationStatus == vm.APP.INVESTIGATION_STATUS.MANAGER_REVIEW) {
        isManagerReview = 1;
      } else {
        isManagerReview = 0;
      }
      eBisObj.isManagerReview = isManagerReview;
      eBisObj.investigationId = vm.investigation.id;
      eBisObj.investigationFormId = $scope.ebisInvestigationFormId;

      var data = ProspectProfileService.sentToeBis(eBisObj);
      data.then(
        function (response) {
          vm.errorMsg = response.message;
          vm.sentToeBisSuccess(ev, "sentToeBisSuccess", response);
        },
        function (reason) {
          vm.erroreBisFlag = true;
          vm.errorMsg = reason.data.message;
          vm.sentToeBisSuccess(ev, "sentToeBisSuccess", reason);
        }
      );
    };

    vm.sentToeBisSuccess = function (ev, id, response) {
      vm.eBisResultLoader = false;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    };

    vm.closeResult = function () {
      $mdDialog.cancel();
      if (!vm.erroreBisFlag) {
        vm.profileDetails(vm.investigation.id);
      }
    };

    //Update the Investigation Status
    vm.updateInvestigationStatus = function (formType, ev) {
      vm.openFormObj = {};
      vm.openFormObj.disabled = true;
      vm.assignObj = {};
      vm.assignObj.investigationId = vm.investigation.id;
      vm.assignObj.formType = formType;
      //No need to update the investigation Status
      vm.assignObj.assignerId = 0;

      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(vm.checkActiveForm(vm.profile.formId, ev, formType));
      $q.all(qPromises).then(function (data) {
        var data = ProspectProfileService.updateInvestigationStatus(vm.assignObj);
        data.then(function (response) {
          vm.openInvestigationForm(ev, formType, true);
        });
      });
    };

    vm.openAnalystForm = function (ev) {
      vm.profileForm.investigationFormId =
        vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId;
      $sessionStorage.selectedSectionIndex = 0;
      $sessionStorage.formType = vm.APP.INVESTIGATION.ANALYST_FORM;
      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, vm.APP.INVESTIGATION.ANALYST_FORM));
      $q.all(qPromises).then(function (data) {
        $state.go("profileForm", vm.profileForm);
      });
    };

    vm.createRCSession = function () {
      vm.createRCObj = {};
      vm.createRCObj.investigationId = vm.investigation.id;
      var data = ProspectProfileService.createRCSession(vm.createRCObj);
      data.then(function (response) {
        vm.profileDetails(vm.investigation.id);
      });
    };

    vm.openRCSession = function (RCResultObj, isOpen) {
      vm.RCSessionData = {};
      vm.RCSessionData.investigationRCId = RCResultObj.investigationRCId;
      vm.RCSessionData.investigationId = vm.investigation.id;
      vm.RCSessionData.isOpenCase = isOpen;
      $state.go("rcDetails", vm.RCSessionData);
    };

    vm.deleteRCSession = function (ev, id, RCResultObj) {
      $scope.investigationRCId = RCResultObj.investigationRCId;
      $scope.investigationId = vm.investigation.id;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    };

    vm.deleteRCSessionConfirm = function () {
      vm.deleteRCDisableFlag = true;
      var data = ProspectProfileService.deleteRCSession($scope.investigationId, $scope.investigationRCId);
      data.then(function (response) {
        $mdDialog.hide();
        vm.deleteRCDisableFlag = false;
        vm.profileDetails(vm.investigation.id);
      });
    };

    vm.openByPassInvestigationConfirmPopup = function (ev, id, invObj) {
      $scope.byPassInvestigationFormId = invObj.investigationFormId;
      $scope.assignerId = invObj.assignerId;
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false
      });
    };

    vm.byPassInvestigationForm = function () {
      vm.bypassSuccessFlag = false;
      vm.bypPassLoader = true;
      vm.assignerObj.investigationId = vm.investigation.id;
      vm.assignerObj.formType = vm.APP.INVESTIGATION.INVESTIGATOR_FORM;
      vm.assignerObj.assignerId = $scope.assignerId;
      vm.assignerObj.investigationFormId = $scope.byPassInvestigationFormId;
      var data = ProspectProfileService.byPassOpenInvestigationForm(vm.assignerObj);
      data.then(function (response) {
        vm.bypassSuccessFlag = true;
        vm.bypPassLoader = false;
        vm.noInvestigationFormExistForCountryAdmin = response.noInvestigationFormExistForCountryAdmin;
      });
    };

    vm.cancelBypass = function () {
      vm.bypassSuccessFlag = undefined;
      vm.bypPassLoader = undefined;
      $mdDialog.hide();
      if (!vm.noInvestigationFormExistForCountryAdmin) {
        vm.profileDetails(vm.investigation.id);
      }
      else {
        $state.go("investigations");
      }
    };

    //Method to get the reopen/reassign flag for investigation
    vm.getReopenFlag = function (investigationId) {
      if (vm.APP.INVESTIGATION.ENABLEREOPENFLAG == vm.APP.GLOBAL.TRUE) {
        vm.reopenInvestigator = false;
        vm.reopenAnalyst = false;
        vm.reopenInvestigatorInprogress = false;
        vm.reopenAnalystInprogress = false;
        var data = InvestigationService.getReopenFlag(investigationId);
        data.then(function (response) {
          var reopenFlagDetails = response;
          vm.reopenInvestigator = reopenFlagDetails.investigatorFormReOpen;
          vm.reopenAnalyst = reopenFlagDetails.analystFormReOpen;
          vm.reopenInvestigatorInprogress = reopenFlagDetails.investigatorFormStatus;
          vm.reopenAnalystInprogress = reopenFlagDetails.analystFormStatus;
        });
      }
    };

    //Check the user has assigned to both investigator/analyst form
    vm.findInvestigationId = function () {
      vm.multipleForm = false;
      if (vm.profile.isOwner == 1) {
        if (
          vm.profile.openInvestigationList.length > 0 &&
          vm.profile.openInvestigationList[0].analystFormInProgressList.length > 0 &&
          vm.profile.openInvestigationList[0].analystFormInProgressList[0].isOwner == 1
        ) {
          vm.analystFormId = vm.profile.openInvestigationList[0].analystFormInProgressList[0].investigationFormId;
          angular.forEach(vm.profile.openInvestigationList[0].investigatorFormInProgressList, function (data, index) {
            if (data.isOwner == 1) {
              vm.invFormId = data.investigationFormId;
              vm.multipleForm = true;
            }
          });
        }
      }
    };

    vm.openForm = function (formType, formId, ev) {
      $sessionStorage.formType = formType;
      if (formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM) {
        $sessionStorage.isView = false;
        vm.profileForm.investigationFormId = formId;
        //Check the form is active or not before open the form
        qPromises = [];
        qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, formType));
        $q.all(qPromises).then(function (data) {
          $state.go("profileForm", vm.profileForm);
        });
      } else if (formType == vm.APP.INVESTIGATION.ANALYST_FORM) {
        $sessionStorage.isView = false;
        $sessionStorage.selectedSectionIndex = 0;
        vm.profileForm.investigationFormId = formId;
        //Check the form is active or not before open the form
        qPromises = [];
        qPromises.push(vm.checkActiveForm(vm.profileForm.investigationFormId, ev, formType));
        $q.all(qPromises).then(function (data) {
          $state.go("profileForm", vm.profileForm);
        });
      }
    };

    vm.checkActiveForm = function (formId, ev, formType) {
      var data = ProspectProfileService.getActiveInvestigationForm(formId);
      data.then(
        function (response) {},
        function (reason) {
          if (formType == vm.APP.INVESTIGATION.ANALYST_FORM) {
            vm.isAnalystForm = true;
          }
          var popupId = vm.APP.INVESTIGATION.INVESTIGATIONDELETEDPUPID;
          $mdDialog.show({
            contentElement: angular.element("#" + popupId),
            targetEvent: ev,
            clickOutsideToClose: false
          });
        }
      );
      return data;
    };

    vm.gokToInvestigation = function () {
      delete $sessionStorage.isView;
      $state.go("investigations");
    };

    vm.closeForm = function ($event) {
      $mdDialog.cancel();
      $state.go("investigations");
    };

    vm.completeInvestigationConfirmation = function (event, id, invObj) {
      vm.assignObj = {};
      vm.assignObj.formType = invObj.investigationFormType;
      vm.assignObj.assignerId = invObj.assignerId;
      vm.assignObj.investigationId = vm.investigation.id;
      vm.assignObj.investigationFormId = invObj.investigationFormId;

      vm.submitInvestigatorFlag = false;
      vm.submitInvestigatorFlagError = false;

      //Check the form is active or not before open the form
      qPromises = [];
      qPromises.push(vm.checkActiveForm(invObj.investigationFormId, event, invObj.investigationFormType));
      $q.all(qPromises).then(function (data) {
        $mdDialog.show({
          contentElement: angular.element("#" + id),
          targetEvent: event,
          clickOutsideToClose: false
        });
      });
    };

    vm.cancelSubmission = function () {
      vm.submitInvestigatorFlag = false;
      vm.submitInvestigatorLoader = false;
      vm.submitInvestigatorFlagError = false;
      $mdDialog.hide();
      vm.profileDetails(vm.investigation.id);
    };

    vm.completeInvestigation = function (assignerObj) {
      vm.submitInvestigatorFlag = false;
      vm.submitInvestigatorLoader = true;
      var data = ProspectProfileService.completeNonDRInvestigation(assignerObj);
      data.then(
        function (response) {
          vm.submitInvestigatorFlag = true;
          vm.submitInvestigatorLoader = false;
        },
        function (error) {
          vm.submitInvestigatorFlagError = true;
        }
      );
    };

    vm.cancelSubmission = function () {
      vm.submitInvestigatorFlag = false;
      vm.submitInvestigatorLoader = false;
      $mdDialog.hide();
      vm.profileDetails(vm.investigation.id);
    };
    //Function to enable assign to case button for completed RC investigation
    vm.isAllRcCompleted = function (openInvestigationList) {
      angular.forEach(openInvestigationList, function (value, key) {
        if (value.rcStatusKey != "RC_COMPLETED") {
          vm.rcCompleted = false;
          return rcCompleted;
        }
      });
    };
    $scope.translateRcMeetingDate = function (value) {
      if (value.rcDetailsList.length > 0) {
        angular.forEach(value.rcDetailsList, function (rcValue) {
          if (rcValue.rcMeetingDate != "" && rcValue.rcMeetingDate != null) {
            rcValue.monthRcMeetingDate = rcValue.rcMeetingDate.substring(0, 3)
            rcValue.dayRcMeetingDate = rcValue.rcMeetingDate.substring(3, 7)
            rcValue.yearRcMeetingDate = rcValue.rcMeetingDate.substring(7, 12)
          }
        });
      }

    }

    $scope.translateAnalystReportDate = function (value) {
      if (value.analystFormList.length > 0) {
        angular.forEach(value.analystFormList, function (analystValue) {
          if (analystValue.investigationFormDate != "" && analystValue.investigationFormDate != null) {
            analystValue.monthAnalystReportDate = analystValue.investigationFormDate.substring(0, 3)
            analystValue.dayAnalystReportDate = analystValue.investigationFormDate.substring(3, 7)
            analystValue.yearAnalystReportDate = analystValue.investigationFormDate.substring(7, 12)
          }
        });
      }
    }

    $scope.translateAnalystInprogressReportDate = function (value) {
      if (value.analystFormInProgressList.length > 0) {
        angular.forEach(value.analystFormInProgressList, function (analystInProgressValue) {
          if (analystInProgressValue.investigationFormDate != "" && analystInProgressValue.investigationFormDate != null) {
            analystInProgressValue.monthInprogressDate = analystInProgressValue.investigationFormDate.substring(0, 3)
            analystInProgressValue.dayInprogressDate = analystInProgressValue.investigationFormDate.substring(3, 7)
            analystInProgressValue.yearInprogressDate = analystInProgressValue.investigationFormDate.substring(7, 12)
          }
        });
      }
    }

    $scope.translateInvestigatorInprogressReportDate = function (value) {
      if (value.investigatorFormInProgressList.length > 0) {
        angular.forEach(value.investigatorFormInProgressList, function (inProgressValue) {
          if (inProgressValue.investigationFormDate != "" && inProgressValue.investigationFormDate != null) {
            inProgressValue.monthInprogressDate = inProgressValue.investigationFormDate.substring(0, 3)
            inProgressValue.dayInprogressDate = inProgressValue.investigationFormDate.substring(3, 7)
            inProgressValue.yearInprogressDate = inProgressValue.investigationFormDate.substring(7, 12)
          }
        });
      }
    }

    $scope.translateInvestigatorCompletedReportDate = function (value) {
      if (value.investigatorFormCompletedList.length > 0) {
        angular.forEach(value.investigatorFormCompletedList, function (completedValue) {
          if (completedValue.investigationFomCompeledDate != "" && completedValue.investigationFomCompeledDate != null &&
            completedValue.investigationFormDate != "" && completedValue.investigationFormDate != null) {
            completedValue.monthCompletedDate = completedValue.investigationFomCompeledDate.substring(0, 3)
            completedValue.dayCompletedDate = completedValue.investigationFomCompeledDate.substring(3, 7)
            completedValue.yearCompletedDate = completedValue.investigationFomCompeledDate.substring(7, 12)

            completedValue.monthInvestigationFormDate = completedValue.investigationFormDate.substring(0, 3)
            completedValue.dayInvestigationFormDate = completedValue.investigationFormDate.substring(3, 7)
            completedValue.yearInvestigationFormDate = completedValue.investigationFormDate.substring(7, 12)
          }
        });
      }
    }

    $scope.translateRemovedDate = function (value) {
      if (value.removedFormList.length > 0) {
        angular.forEach(value.removedFormList, function (removedValue) {
          if (removedValue.investigationFomCompeledDate != "" && removedValue.investigationFomCompeledDate != null &&
            removedValue.investigationFormDate != "" && removedValue.investigationFormDate != null) {
            removedValue.monthRemovedDate = removedValue.investigationFomCompeledDate.substring(0, 3)
            removedValue.dayRemovedDate = removedValue.investigationFomCompeledDate.substring(3, 7)
            removedValue.yearRemovedDate = removedValue.investigationFomCompeledDate.substring(7, 12)

            removedValue.monthinvestigationFormDate = removedValue.investigationFormDate.substring(0, 3)
            removedValue.dayinvestigationFormDate = removedValue.investigationFormDate.substring(3, 7)
            removedValue.yearinvestigationFormDate = removedValue.investigationFormDate.substring(7, 12)
          }
        });
      }
    }

    $scope.translateInvestigationFomCompeledDate = function (value) {
      if (value.investigatorFormCompletedList.length > 0) {
        angular.forEach(value.investigatorFormCompletedList, function (completedValue) {
          if (completedValue.investigationFomCompeledDate != "" && completedValue.investigationFomCompeledDate != null) {
            completedValue.monthInvestigationFomCompeledDate = completedValue.investigationFomCompeledDate.substring(0, 3)
            completedValue.dayInvestigationFomCompeledDate = completedValue.investigationFomCompeledDate.substring(3, 7)
            completedValue.yearInvestigationFomCompeledDate = completedValue.investigationFomCompeledDate.substring(7, 12)
          }
          if (completedValue.investigationFormDate != "" && completedValue.investigationFormDate != null) {
            completedValue.monthInvestigationFormDate = completedValue.investigationFormDate.substring(0, 3)
            completedValue.dayInvestigationFormDate = completedValue.investigationFormDate.substring(3, 7)
            completedValue.yearInvestigationFormDate = completedValue.investigationFormDate.substring(7, 12)

          }
        });
      }

    }

    $scope.translateOpenInvestigation = function (response) {
      if (response.openInvestigationList.length > 0) {
        angular.forEach(response.openInvestigationList, function (value) {
          if (value.investigationDateOpened != "" && value.investigationDateOpened != null) {
            value.monthInvestigationDateOpened = value.investigationDateOpened.substring(0, 3)
            value.dayInvestigationDateOpened = value.investigationDateOpened.substring(3, 7)
            value.yearInvestigationDateOpened = value.investigationDateOpened.substring(7, 12)
          }
          //methods to split date in response for spanish translation
          $scope.translateRcMeetingDate(value)
          $scope.translateAnalystReportDate(value)
          $scope.translateAnalystInprogressReportDate(value)
          $scope.translateInvestigatorInprogressReportDate(value)
          $scope.translateInvestigatorCompletedReportDate(value)
          $scope.translateRemovedDate(value)

        });
      }
    }

    $scope.translateClosedInvestigation = function (response) {
      if (response.closedInvestigationList.length > 0) {
        angular.forEach(response.closedInvestigationList, function (closedValue) {
          if (closedValue.investigationDateOpened != "" && closedValue.investigationDateOpened != null) {
            closedValue.monthInvestigationDateOpened = closedValue.investigationDateOpened.substring(0, 3)
            closedValue.dayInvestigationDateOpened = closedValue.investigationDateOpened.substring(3, 7)
            closedValue.yearInvestigationDateOpened = closedValue.investigationDateOpened.substring(7, 12)
          }
          if (closedValue.investigationResultStartTime != "" && closedValue.investigationResultStartTime != null) {
            closedValue.monthInvestigationResultStartTime = closedValue.investigationResultStartTime.substring(0, 3)
            closedValue.dayInvestigationResultStartTime = closedValue.investigationResultStartTime.substring(3, 7)
            closedValue.yearInvestigationResultStartTime = closedValue.investigationResultStartTime.substring(7, 12)

          }
          $scope.translateInvestigationFomCompeledDate(closedValue)
          $scope.translateAnalystReportDate(closedValue)
          $scope.translateRemovedDate(closedValue)

        });
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").service("ProspectProfileService", ProspectProfileService);

  ProspectProfileService.$inject = ["$resource", "restService", "$q", "$rootScope"];

  function ProspectProfileService($resource, restService, $q, $rootScope) {
    this.getProfileData = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigations/" + investigationId + "/prospect/profileData";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getProfileInvestigationData = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigations/" + investigationId + "/prospect/investigationData";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.getEbisDocuments = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigation/ebisDocuments/" + investigationId;
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getRoleList = function () {
      var deferred = $q.defer();
      var url = "userRoles";
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };
    this.getUserList = function (userFilterObj) {
      var deferred = $q.defer();
      var url = "users/assign";
      var data = restService.restCall(userFilterObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };
    this.saveAssignee = function (assignerObj) {
      var deferred = $q.defer();
      var url = "investigation-form/assign-user";
      var data = restService.restCall(assignerObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
    this.saveReAssignee = function (assignerObj) {
      var deferred = $q.defer();
      var url = "investigation-form/reassign-user";
      var data = restService.restCall(assignerObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };
    //Method to Delete Investigation Form
    this.deleteAssignee = function (deleteFormObj) {
      var deferred = $q.defer();
      var url = "investigation-form/delete-user";
      var data = restService.restCall(deleteFormObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
    /**
     * Method to Get Documents
     */
    this.getDocuments = function () {
      var deferred = $q.defer();
      var url = "TODO";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to Reopen Analyst (or) Investigation Form
    this.reopenAnalyst = function (reopenFormObj) {
      var deferred = $q.defer();
      var url = "investigation-form/reopen-form";
      var data = restService.restCall(reopenFormObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to Update status for RC
    this.sentToRC = function (investigationToStatus, investigationId) {
      var deferred = $q.defer();
      var url = "investigation-statuses/update/" + investigationId;
      if (investigationToStatus != null) {
        url = url + "?toStatuKey=" + investigationToStatus;
      }
      var data = restService.restCall("", url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method for Sent To eBis
    this.sentToeBis = function (eBisObj) {
      var deferred = $q.defer();
      var url = "ebis/send";
      var data = restService.restCall(eBisObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    //Method to update the Investigation status
    this.updateInvestigationStatus = function (assignObj) {
      var deferred = $q.defer();
      var url = "investigation-form/update-investigation-status";
      var data = restService.restCall(assignObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to Create RC Session.
    this.createRCSession = function (createRCObj) {
      var deferred = $q.defer();
      var url = "investigation-rcs/" + createRCObj.investigationId;
      var data = restService.restCall(createRCObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to Delete RC Session.
    this.deleteRCSession = function (investigationId, investigationRCId) {
      var deferred = $q.defer();
      var url = "investigation-rcs/" + investigationId + "/" + investigationRCId;
      var data = restService.restCall("", url, "DELETE");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to bypass the investigation form
    this.byPassOpenInvestigationForm = function (assignerObj) {
      var deferred = $q.defer();
      var url = "investigation-form/bypass";
      var data = restService.restCall(assignerObj, url, "PUT");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Method to get the form active status
    this.getActiveInvestigationForm = function (formId) {
      var deferred = $q.defer();
      var url = "investigation-form/" + formId + "/active";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    //Method to bypass the investigation form
    this.completeNonDRInvestigation = function (assignerObj) {
      var deferred = $q.defer();
      var url = "investigation-form/update-investigations-status";
      var data = restService.restCall(assignerObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
    this.reopenForMangerReview = function (investigationId) {
      var deferred = $q.defer();
      var url = "reopen-form-manager-review/" + investigationId;
      var data = restService.restCall("", url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider
        .state('profile', {
            parent: 'prospects',
            url: '/:id/profile',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            },
            views: {
                'sample': {
                    templateUrl: 'app/investigation/prospects/profile/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            },
            onExit: ['$sessionStorage', function ($sessionStorage) {
                delete $sessionStorage.selectedSectionIndex;
            }],
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();

(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.controller("UserProfileController", UserProfileController);

  UserProfileController.$inject = [
    "$scope",
    "$window",
    "$mdSidenav",
    "Principal",
    "$state",
    "$mdMedia",
    "APP",
    "UserProfileService",
    "$stateParams",
    "UserService",
    "$mdDialog",
    "$element",
    "BaseFactory",
    "CommonService",
    "communicationService"
  ];
  function UserProfileController(
    $scope,
    $window,
    $mdSidenav,
    Principal,
    $state,
    $mdMedia,
    APP,
    UserProfileService,
    $stateParams,
    UserService,
    $mdDialog,
    $element,
    BaseFactory,
    CommonService,
    communicationService
  ) {
    var vm = this;
    $scope.mediaCheck = $mdMedia;
    vm.APP = APP;
    /*vm.user =  $cookies.getObject('sessionDetails');*/
    vm.user = CommonService.getCookieUser().cookieUser;

    vm.userDetails = $stateParams;
    vm.userProfileLoader = true;
    vm.showCloseCases = false;
    vm.showOpenCases = true;
    vm.media = $mdMedia;

    var investigation = {};

    vm.userProfileDetails = function (userId) {
      if (userId) {
        var data = UserProfileService.getUserProfileDetails(userId);
        data.then(
          function (response) {
            vm.userProfileLoader = false;
            vm.profile = response;
            $scope.updateUserName(response.firstName, response.lastName);
            $scope.userActivated(response.activated);
            $scope.userRole(response.userRole);
            vm.getReopenStatus(response);
          },
          function (reason) {
            return reason;
          }
        );
      }
    };
    vm.openClosedCases = function () {
      if (vm.showCloseCases) {
        vm.showCloseCases = false;
      } else {
        vm.showCloseCases = true;
      }
    };
    vm.openOpenedCases = function () {
      if (vm.showOpenCases) {
        vm.showOpenCases = false;
      } else {
        vm.showOpenCases = true;
      }
    };
    if (vm.userDetails != null) {
      vm.userProfileDetails(vm.userDetails.id);
    }

    vm.toggleLeft = toggleLeft("right");

    function toggleLeft(navID) {
      return function () {
        $mdSidenav(navID).toggle();
      };
    }

    vm.prospectProfile = function (id) {
      investigation.id = id;
      $state.go("profile", investigation);
    };

    vm.getReopenStatus = function (profile) {
      var length = profile.investigationFormOpenList.length;
      for (var i = 0; i < length; i++) {
        $scope.getReopenFlag(profile.investigationFormOpenList[i].investigationId, i);
      }
    };

    $scope.getReopenFlag = function (investigationId, index) {
      vm["requestFlag_" + index] = false;
      vm["requestedShow_" + index] = false;
      if (vm.APP.INVESTIGATION.ENABLEREOPENFLAG == vm.APP.GLOBAL.TRUE) {
        vm["reopenLoader_" + index] = true;
        vm["reopenInvestigator_" + index] = false;
        vm["reopenAnalyst_" + index] = false;
        vm["reopenInvestigatorInprogress_" + index] = false;
        vm["reopenAnalystInprogress_" + index] = false;

        var data = UserProfileService.getReopenFlag(investigationId);
        data.then(
          function (response) {
            var reopenFlagDetails = response;
            vm["reopenLoader_" + index] = false;
            vm["reopenInvestigator_" + index] = reopenFlagDetails.investigatorFormReOpen;
            vm["reopenAnalyst_" + index] = reopenFlagDetails.analystFormReOpen;
            vm["reopenInvestigatorInprogress_" + index] = reopenFlagDetails.investigatorFormStatus;
            vm["reopenAnalystInprogress_" + index] = reopenFlagDetails.analystFormStatus;
          },
          function (reason) {
            vm["reopenLoader_" + index] = false;
          }
        );
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").service("UserProfileService", UserProfileService);
  UserProfileService.$inject = ["$resource", "restService", "$q", "$rootScope"];

  function UserProfileService($resource, restService, $q, $rootScope) {
    this.getUserProfileDetails = function (userId) {
      var deferred = $q.defer();
      var url = "users/" + userId + "/profile";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getInvestigatorDetails = function (userId) {
      var deferred = $q.defer();
      var url = "investigator/" + userId + "/investigatorProfile";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getInvestigatorActiveCaseCount = function (userId) {
      var deferred = $q.defer();
      var url = "investigator/activeCaseCount/" + userId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getReopenFlag = function (investigationId) {
      var deferred = $q.defer();
      var url = "investigation/reOpenStatus/" + investigationId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	 $stateProvider.state('userprofile', {
             parent: 'userprospects',
             url: '/:id/profile',
             data: {
                 authorities: APP.GLOBAL.USER_GROUP
             },
             params: {
             	id:null,
             	userType:null
             },
             views: {
                 'userDetails': {
                     templateUrl: 'app/user/userprospects/profile/user.profile.html',
                     controller: 'UserProfileController',
                     controllerAs: 'vm'
                 }
             },resolve: {
                 mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                     if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                        	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                        }else{
                        	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                        }
                     return $translate.refresh();
                 }],
                 mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                 	tabservice.setIndex("1");
                 	$timeout(function() {
                 	    angular.element('#userProfile').triggerHandler('click');
                 	  });
                 }]
             }
    	 });
    }
})();
(function(){
	var lariDevApp = angular
	.module('lariAidApp')
	lariDevApp.controller('UserActivityController',UserActivityController);
	UserActivityController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','APP','UserActivityService','$stateParams','CommonService'];
    function UserActivityController($scope,$window, $mdSidenav,Principal,$state,$mdMedia,APP,UserActivityService,$stateParams,CommonService) {
    	var vm = this;
    	$scope.media = $mdMedia;
    	vm.APP = APP;
    	/*vm.user =  $cookies.getObject('sessionDetails');*/
    	vm.user = CommonService.getCookieUser().cookieUser;
    	
    	vm.userDetails = $stateParams;
    	vm.userActivityLoader = true;
    	vm.userActivityDetails = function(userId){
        	if(userId){
        		var data = UserActivityService.getUserActivityDetails(userId);
        		  data.then(function(response){
        			  vm.userActivityLoader = false;
        			  vm.activity = response.investigationActivity;
        			  $scope.updateUserName(response.investigatorFirstName,response.investigatorLastName);
        		  }, function(reason) {
        		return reason;
        		});
        	}
        };
    	
    	if(vm.userDetails != null){
        	vm.userActivityDetails(vm.userDetails.id);
        }
    }
})();
(function(){
	'use strict';
	angular
	.module('lariAidApp')
	.service('UserActivityService',UserActivityService)
	UserActivityService.$inject = ['$resource','restService','$q','$rootScope'];
	
	function UserActivityService($resource,restService,$q,$rootScope){
		this.getUserActivityDetails = function(userId){
			var deferred = $q.defer();
			var url = "investigator/activity/"+userId;
			var data = restService.restCall("",url,'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('useractivity', {
            parent: 'userprospects',
            url: '/:userType/:id/activity',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	id:null,
            	userType:null
            },
            views: {
                'userDetails': {
                    templateUrl: 'app/user/userprospects/activity/user.activity.html',
                    controller: 'UserActivityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("2");
                	$timeout(function() {
                	    angular.element('#userActivity').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('InvestigationFormHeaderController', InvestigationFormHeaderController);
    
    InvestigationFormHeaderController.$inject = ['$element','$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','InvestigationFormService','$stateParams','$location','investigationFormIndexService','$document','$interval','$rootScope','$sessionStorage','Upload','$timeout','$q','$mdDialog','CommonService','SideCommentsDirectiveService','$filter','$controller'];
    function InvestigationFormHeaderController ($element,$scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,InvestigationFormService,$stateParams,$location,investigationFormIndexService,$document,$interval,$rootScope,$sessionStorage,Upload,$timeout,$q,$mdDialog,CommonService,SideCommentsDirectiveService,$filter,$controller) {

    	var vm = this;
    	
    	$scope.mediaCheck = $mdMedia;
    	vm.profileForm = $stateParams;
    	vm.formProfile = {};
    	vm.investigation = [];
    	$scope.investigationFormId = vm.profileForm.investigationFormId;
    	vm.app = APP;
    	vm.user = CommonService.getCookieUser().cookieUser;
    	
    	$scope.updateProspectName = function(firstName,lastName,investigationType,investigationId){
    		vm.formProfile.firstName = firstName;
    		vm.formProfile.lastName = lastName;
    		vm.formProfile.investigationType = investigationType;
    		vm.formProfile.investigationId = investigationId;
    	};
    	
    	/*Investigation Form's Section sidenav  Starts Here*/
    	$scope.sectionLeft = buildToggler('formLeft');
        $scope.toggleRight = buildToggler('formRight');

        function buildToggler(componentId) {
          return function() {
            $mdSidenav(componentId).toggle();
          };
        }
        /*Investigation Form's Section sidenav Ends Here */
        
        vm.backProfile = function(){
        	vm.investigation.id = vm.formProfile.investigationId;
    		$state.go("profile",vm.investigation);
    		
    	};
    	
    }
    
})();
(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.controller("InvestigationFormController", InvestigationFormController);

  InvestigationFormController.$inject = [
    "$element",
    "$scope",
    "$window",
    "$mdSidenav",
    "Principal",
    "$state",
    "$mdMedia",
    "$cookies",
    "APP",
    "InvestigationFormService",
    "$stateParams",
    "$location",
    "investigationFormIndexService",
    "$document",
    "$interval",
    "$rootScope",
    "$sessionStorage",
    "Upload",
    "$timeout",
    "$q",
    "$mdDialog",
    "CommonService",
    "SideCommentsDirectiveService",
    "$filter",
    "$controller",
    "$mdUtil",
    "BASE_URL"
  ];
  function InvestigationFormController(
    $element,
    $scope,
    $window,
    $mdSidenav,
    Principal,
    $state,
    $mdMedia,
    $cookies,
    APP,
    InvestigationFormService,
    $stateParams,
    $location,
    investigationFormIndexService,
    $document,
    $interval,
    $rootScope,
    $sessionStorage,
    Upload,
    $timeout,
    $q,
    $mdDialog,
    CommonService,
    SideCommentsDirectiveService,
    $filter,
    $controller,
    $mdUtil,
    BASE_URL
  ) {
    $scope.deleteLoader = {};
    $scope.deleteLoader.flag = false;
    $scope.recordFlag = true;
    var vm = this;
    angular.extend(this, $controller("LibraryAddRequestController", { $scope: $scope }));
    var id = "birthCertificateSectionSummary";
    $scope.mediaCheck = $mdMedia;
    $scope.cancelAutoSave = false;
    $rootScope.formValid = {};
    vm.profileForm = $stateParams;
    vm.formProfile = {};
    vm.investigation = [];
    $scope.investigationFormId = vm.profileForm.investigationFormId;
    vm.app = APP;
    $scope.entityChanged = false;
    $scope.assetDownloadAPI = BASE_URL + vm.app.INVESTIGATION.DOWNLOAD_API;
    vm.user = CommonService.getCookieUser().cookieUser;
    $scope.uploadFileSectionList = [];
    $scope.uploadFileSectionListObj = {};
    $scope.uploadFileSectionListObj.uploadList = [];

    $scope.uploadFileSectionListObjSummary = {};
    $scope.uploadFileSectionListObjSummary.uploadList = [];
    $scope.sideCommentTrigger = false;

    $scope.uploadFileSectionFamilyPhotoList = [];
    $scope.uploadFileSectionFamilyPhotoListObj = {};
    $scope.uploadFileSectionFamilyPhotoListObj.uploadList = [];
    $scope.fileTypeError = false;
    $scope.fileUploadLoader = false;
    vm.warrnFlag = false;
    $scope.checkValid;
    $scope.isView = $sessionStorage.isView;
    vm.entityProfileList = [];
    $scope.uploadFileDelete = {};

    vm.myDate = new Date();
    $scope.sideComments = {};

    $scope.toggleValue = {};
    $scope.toggleValue.sideNav = [];
    $scope.toggleValue.sideNav.checkboxes = [];
    $scope.toggleValue.sideNav.checkboxes.values = [];
    $scope.summaryActivated = true;

    $scope.sideNavAccordion = {};
    $scope.sideNavAccordion.expanded = false;
    $scope.familyPhotoCommentTrigger = false;

    var originatorEv;

    $scope.investigationSectionObj = {};
    $scope.investigationSectionObj.id = [];
    $scope.investigationSectionObj.name = [];
    vm.sectionValue = {};
    vm.sectionValue.birthcerticate_checked = false;
    vm.sectionValue.birthAndMedical_checked = false;
    vm.sectionValue.familyInfo_checked = false;
    vm.sectionValue.schoolInfo_checked = false;
    vm.sectionValue.religiousInstitution_checked = false;
    vm.sectionValue.residencyQuestion_checked = false;
    vm.sectionValue.neighbourhoodCanvas_checked = false;
    vm.sectionValue.other_checked = false;
    vm.sectionValue.summary_checked = false;
    $scope.uploadedFile = false;
    $scope.lastEditTime;
    vm.isLastEditVisible = false; //Initially its not visible for ui.
    $rootScope.sideCommentVisible = true; //To edit the side comments even when the form is in readOnly mode
    vm.showWarning = {};
    $rootScope.warningPopup = {};
    $rootScope.warningPopup.show = undefined;

    $scope.goback = false;
    vm.disableUpload = false;
    $rootScope.notApproved = false;
    $scope.maxDate = new Date(vm.myDate.getFullYear(), vm.myDate.getMonth(), vm.myDate.getDate());

    vm.loggedUserRole = CommonService.getCookieUser().loggedUserRole;

    /* Method name           : loadSectionFormByType()
     * Method Description 	 : This method is used to trigger the section form state by type
     */
    vm.loadSectionFormByType = function (type) {
      $scope.previousState = angular.copy($scope.currentState);
      if ($scope.currentState == undefined) {
        $scope.previousState = type;
      }
      if ($scope.currentState != type) {
        $scope.sideCommentTrigger = false;
      }
      $scope.currentState = type;
      $scope.triggerSaveForActiveSection($scope.previousState, $scope.currentState);
    };

    $scope.YesToProceed = false;
    $scope.sectionNavigationFunc = function (type) {
      if (type == "bithcerticateForm") {
        $scope.currentSection = vm.app.REF_TERM.BIRTH_CERTIFICATE;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("birthCertificate");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }

        //$scope.getSectionIdByType('BIRTH_CERTIFICATE');
      } else if (type == "birthAndMedicalForm") {
        $scope.currentSection = vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("birthMedicalRecord");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('BIRTH_AND_MEDICAL_RECORDS');
      } else if (type == "familyInfoForm") {
        $scope.currentSection = vm.app.REF_TERM.FAMILY_INFORMATION;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("familyInformation");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('FAMILY_INFORMATION');
      } else if (type == "schoolInfoForm") {
        $scope.currentSection = vm.app.REF_TERM.SCHOOL_INFORMATION;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("schoolInformation");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('SCHOOL_INFORMATION');
      } else if (type == "religiousInstitutionForm") {
        $scope.currentSection = vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("religiousInstitution");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('RELIGIOUS_INSTITUTIONS');
      } else if (type == "neighbourhoodCanvasForm") {
        $scope.currentSection = vm.app.REF_TERM.NEIGHBORHOOD_CANVAS;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("neighbourhoodCanvas");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('NEIGHBORHOOD_CANVAS');
      } else if (type == "residencyQuestionForm") {
        $scope.currentSection = vm.app.REF_TERM.RESIDENCY_QUESTIONS;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("residencyQuestions");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('RESIDENCY_QUESTIONS');
      } else if (type == "summaryForm") {
        $scope.currentSection = vm.app.REF_TERM.SUMMARY;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("summary");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('SUMMARY');
      } else if (type == "dnaInfoForm") {
        $scope.currentSection = vm.app.REF_TERM.DNA;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("dnaInformation");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('DNA');
      } else if (type == "otherForm") {
        $scope.currentSection = vm.app.REF_TERM.OTHER;
        if ($scope.isOwner || $scope.YesToProceed || $scope.goback || !$rootScope.warningPopup.show) {
          $state.go("other");
          $scope.YesToProceed = false;
          $scope.goback = false;
        } else if ($rootScope.warningPopup.show) {
          $scope.showWarning("formSectionChange");
        }
        //$scope.getSectionIdByType('OTHER');
      }
      $scope.currentState = type;
    };

    $scope.showWarning = function (popupId) {
      var event = this;
      $mdDialog.show({
        contentElement: angular.element("#" + popupId),
        targetEvent: event,
        clickOutsideToClose: false,
        escapeToClose: false
      });
      $timeout(function () {
        $rootScope.warningPopup.show = false;
      });
    };

    vm.backToCurrentSection = function () {
      $scope.goback = true;
      $scope.retainValue = true; // To retain checkbox values if No is clicked in popup
      $mdDialog.cancel();
      var index = null;

      var ps = $scope.previousState;
      $scope.currentState = $scope.previousState;
      if ($scope.currentState == "bithcerticateForm") {
        index = 0;
      } else if ($scope.currentState == "birthAndMedicalForm") {
        index = 1;
      } else if ($scope.currentState == "neighbourhoodCanvasForm") {
        index = 2;
      } else if ($scope.currentState == "familyInfoForm") {
        index = 3;
      } else if ($scope.currentState == "schoolInfoForm") {
        index = 4;
      } else if ($scope.currentState == "religiousInstitutionForm") {
        index = 5;
      }
      $scope.collapseAll(index);
      $scope.sectionNavigationFunc(ps);
    };

    //To clear select All values after clicking Yes in popup
    vm.clearSelectAllCheckListValue = function (sectionType) {
      vm["selectAll" + sectionType + "Type"].firstObj.checked = false;
      vm["selectAll" + sectionType + "Type"].secondObj.checked = false;
      vm["selectAll" + sectionType + "Type"].thirdObj.checked = false;
      vm["selectAll" + sectionType + "Type"].fourthObj.checked = false;
    };

    vm.changeSection = function () {
      $scope.YesToProceed = true;
      $mdDialog.cancel();
      var cs = $scope.currentState;
      //Clear or keep previous value in checkbox if yes is clicked in popup
      if ($scope.investigationFormType == "ANALYST_FORM") {
        if ($scope.previousState == "bithcerticateForm" && !$scope.isOwner) {
          $scope.birthCertificateCheckList = angular.copy($scope.birthCertificateCheckListTempObj);
          vm.clearSelectAllCheckListValue("BC");
        } else if ($scope.previousState == "birthAndMedicalForm" && !$scope.isOwner) {
          $scope.birthMedicalCheckList = angular.copy($scope.birthMedicalCheckListTempObj);
          vm.clearSelectAllCheckListValue("BirthMedicalRecord");
        } else if ($scope.previousState == "neighbourhoodCanvasForm" && !$scope.isOwner) {
          $scope.neighbourhoodCheckList = angular.copy($scope.neighbourhoodCheckListTempObj);
          vm.clearSelectAllCheckListValue("Neighbourhood");
        } else if ($scope.previousState == "familyInfoForm" && !$scope.isOwner) {
          $scope.familyCheckList = angular.copy($scope.familyCheckListTempObj);
          vm.clearSelectAllCheckListValue("Family");
        } else if ($scope.previousState == "schoolInfoForm" && !$scope.isOwner) {
          $scope.schoolCheckList = angular.copy($scope.schoolCheckListTempObj);
          vm.clearSelectAllCheckListValue("School");
        } else if ($scope.previousState == "religiousInstitutionForm" && !$scope.isOwner) {
          $scope.religiousCheckList = angular.copy($scope.religiousCheckListTempObj);
          vm.clearSelectAllCheckListValue("Religious");
        }
      }
      $scope.sectionNavigationFunc(cs);
    };

    /* Method name           : triggerSaveForActiveSection()
     * Method Description 	 : This method is used to trigger the save function on navigation menu click
     */

    $scope.triggerSaveForActiveSection = function (sectionType, currentType) {
      if (sectionType) {
        if (sectionType == vm.app.INVESTIGATION_FORM.BIRTH_CERTIFICATE_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#bcFormSave").triggerHandler("click");
            }
            if (sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("birthCertificate");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#medicalFormSave").triggerHandler("click");
            }
            if (sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("birthMedical");
            }
            $scope.currentType = currentType;

            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.FAMILY_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#familyFormSave").triggerHandler("click");
            }
            if (sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("family");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.SCHOOL_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#schoolFormSave").triggerHandler("click");
            }
            if (sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("school");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.RELIGIOUS_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#religiousFormSave").triggerHandler("click");
            }
            if (sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("religious");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.NEIGHBOURHOOD_CANVASS_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#neighbourhoodFormSave").triggerHandler("click");
            }
            if (sectionType != currentType && sectionType != currentType) {
              $scope.saveAnalystFormTypeCheckList("neighbourhood");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.RESIDENCY_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#residencyFormSave").triggerHandler("click");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.DNA_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#dnaFormSave").triggerHandler("click");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.SUMMARY_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#summaryFormSave").triggerHandler("click");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        } else if (sectionType == vm.app.INVESTIGATION_FORM.OTHER_FORM) {
          $timeout(function () {
            if (!$scope.isreadonly && sectionType != currentType) {
              angular.element("#otherFormSave").triggerHandler("click");
            }
            $scope.currentType = currentType;
            $scope.sectionNavigationFunc(currentType);
          }, 1);
        }
      }
    };

    /* Method name           : getSectionIdByType()
     * Method Description 	 : This method is used to get the section Id by type passed
     */
    /*$scope.getSectionIdByType = function(type){
    		var data = InvestigationFormService.getSectionIdByType(type);
  		  	data.then(function(response){
  		  		//$scope.investigationFormSectionId = response[0].id;
  		  		if(type == 'BIRTH_CERTIFICATE'){
  		  			$scope.birthCertificateSectionId = response[0].id;
  		  			$state.go("birthCertificate");
  		  		} else if(type == 'BIRTH_AND_MEDICAL_RECORDS'){
  		  			$scope.birthMedicalSectionId = response[0].id;
  		  			$state.go("birthMedicalRecord");
  		  		} else if(type == 'FAMILY_INFORMATION'){
  		  			$scope.familyInfoSectionId = response[0].id;
  		  			$state.go("familyInformation");
  		  		} else if(type == 'SCHOOL_INFORMATION'){
  		  			$scope.schoolInfoSectionId = response[0].id;
  		  			$state.go("schoolInformation");
  		  		} else if(type == 'RELIGIOUS_INSTITUTIONS'){
  		  			$scope.religiousInsSectionId = response[0].id;
  		  			$state.go("religiousInstitution");
  		  		} else if(type == 'NEIGHBORHOOD_CANVAS'){
  		  			$scope.neighbourhoodSectionId = response[0].id;
  		  			$state.go("neighbourhoodCanvas");
  		  		} else if(type == 'DNA'){
		  			$scope.dnaFormSectionId = response[0].id;
		  			$state.go("dnaInformation");
		  		}else if(type == 'RESIDENCY_QUESTIONS'){
  		  			$scope.residencySectionId = response[0].id;
  		  			$state.go("residencyQuestions");
  		  		} else if(type == 'SUMMARY'){
  		  			$scope.summarySectionId = response[0].id;
  		  			$state.go("summary");
  		  		} else if(type == 'OTHER'){
  		  			$scope.summarySectionId = response[0].id;
  		  			$state.go("other");
  		  		}
  		  }, function(reason) {
  			  return reason;
  		  });
    	};*/

    /* Method name           : triggerAutosave()
     * Method Description 	 : This method triggers auto save once investigation form is opened
     */
    var idleInterval;
    var intervalFlag = false;
    $scope.triggerAutosave = function () {
      clearTimeout(idleInterval);
      idleInterval = $timeout(function () {
        if (angular.isDefined(idleInterval)) {
          if (!$scope.cancelAutoSave) {
            if (intervalFlag == true) {
              // $scope.triggerAutosave();
              //$interval.cancel(idleInterval);
              // $scope.autoSaveSection($location.path(),false);
              intervalFlag = false;
            } else if (intervalFlag == false) {
              $scope.autoSaveSection($location.path(), true);
            }
          }
        }
      }, 7000);
    };

    /* Method name           : triggerAutoSaveInterval()
     * Method Description 	 : This method triggers auto save interval once investigation form is opened
     */
    var stopIntrvl;
    $scope.triggerAutoSaveInterval = function () {
      if (!$scope.isreadonly) {
        //$interval.cancel(stopIntrvl);
        if (angular.isDefined(stopIntrvl)) return;
        //clearInterval(stopIntrvl);
        stopIntrvl = $interval(function () {
          if (!$scope.cancelAutoSave) {
            $scope.triggerAutosave();
          }
        }, 7000);
      }
    };

    $scope.stopInterval = function () {
      if (angular.isDefined(stopIntrvl)) {
        $interval.cancel(stopIntrvl);
        stopIntrvl = undefined;
      }
    };

    $scope.$on("$destroy", function () {
      $scope.stopInterval();
    });

    //$document.find('body').on('mousemove DOMMouseScroll mousewheel mousedown keydown keypress keyup tap click touchstart',checkAndResetIdle);

    /* Method name           : checkAndResetIdle()
     * Method Description 	 : This method resets the idle time interval
     */
    function checkAndResetIdle() {
      if (intervalFlag == false) {
        intervalFlag = true;
        $scope.triggerAutosave();
      }
    }

    /* Method name           : autoSaveSection()
     * Method Description 	 : This method assign the section auto save value by location path
     */
    $scope.autoSaveSection = function (path, value) {
      path = path.substring(path.lastIndexOf("/"), path.length);
      if (path == "/birthCertificate") {
        $rootScope.birthCertificateAutoSave = value;
      } else if (path == "/birthMedicalReport") {
        $rootScope.birthMedicalAutoSave = value;
      } else if (path == "/familyInformation") {
        $rootScope.familyInfoAutoSave = value;
      } else if (path == "/schoolInformation") {
        $rootScope.schoolInfoAutoSave = value;
      } else if (path == "/religiousInstitution") {
        $rootScope.religiousInstitutionAutoSave = value;
      } else if (path == "/neighbourhoodCanvas") {
        $rootScope.neighbourhoodCanvasAutoSave = value;
      } else if (path == "/residencyQuestions") {
        $rootScope.residencyQuestionsAutoSave = value;
      } else if (path == "/dnaInformation") {
        $rootScope.dnaAutoSave = value;
      } else if (path == "/summary") {
        $rootScope.summaryAutoSave = value;
      } else if (path == "/other") {
        $rootScope.otherAutoSave = value;
      }
    };

    vm.cancelAutoSave = function () {
      $interval.cancel(idleInterval);
      $scope.cancelAutoSave = true;
    };

    /* Method name           : checkSectionFormType()
     * Method Description 	 : This method is used to load the section from which it is been refreshed
     */
    vm.checkSectionFormType = function () {
      var type = investigationFormIndexService.getInvestigationValue();
      vm.loadSectionFormByType(type);
      $scope.cancelAutoSave = false;
      //$scope.triggerAutosave();
      $scope.triggerAutoSaveInterval();
    };

    /*vm.checkSectionFormType();*/

    /* Method name           : loadBirthCertificateInitially()
     * Method Description 	 : This method is used to load birth certificate form initially on page load
     */
    vm.loadBirthCertificateInitially = function () {
      $state.go("birthCertificate");
    };

    /* Method name           : isActiveSectionForm()
     * Method Description 	 : This method is used to highlight the active investigation form in left panel of sections
     */
    vm.isActiveSectionForm = function (path) {
      if ($location.path().substr($location.path().lastIndexOf("/")) == path) {
        return true;
      } else {
        return false;
      }
    };
    /*Investigation Form's Section sidenav  Starts Here*/
    $scope.sectionLeft = buildToggler("formLeft");
    $scope.toggleRight = buildToggler("formRight");

    function buildToggler(componentId) {
      return function () {
        $mdSidenav(componentId).toggle();
      };
    }
    /*Investigation Form's Section sidenav Ends Here */

    vm.backProfile = function () {
      vm.investigation.id = vm.formProfile.investigationId;
      $state.go("profile", vm.investigation);
    };

    vm.formProfileDetails = function (investigationFormId) {
      if (investigationFormId) {
        var data = InvestigationFormService.getFormProfileDetails(investigationFormId);
        data.then(
          function (response) {
            vm.profileDetailLoader = false;
            if (response.dateOfBirth != "" && response.dateOfBirth != null) {
              response.dobMonth = response.dateOfBirth.substring(0, 3)
              response.dobDay = response.dateOfBirth.substring(3, 7)
              response.dobYear = response.dateOfBirth.substring(7, 12)
            }
            vm.formProfile = response;
            $scope.updateProspectName(
              response.firstName,
              response.lastName,
              vm.formProfile.investigationType,
              vm.formProfile.investigationId
            );
            $scope.investigationID = vm.formProfile.investigationId;
            $scope.investigationFormType = vm.formProfile.investigationFormType;
            $scope.investigationDateOfBirth = vm.formProfile.dateOfBirth;
            $scope.investigationFormStatus = vm.formProfile.investigationFormStatus;

            if (vm.formProfile.isOwner == 1) {
              $scope.isOwner = true;
            } else {
              $scope.isOwner = false;
            }
            $scope.isreadonly = true;
            //To confirm the investigation status is open
            if (
              vm.formProfile.investigationStatus != vm.app.REF_TERM.CONFIRMED &&
              vm.formProfile.investigationStatus != vm.app.REF_TERM.FAILED &&
              vm.formProfile.investigationStatus != vm.app.REF_TERM.UNDETERMINED &&
              vm.formProfile.investigationStatus != vm.app.REF_TERM.WAIVED &&
              vm.formProfile.investigationStatus != vm.app.REF_TERM.NA &&
              vm.formProfile.investigationStatus != vm.app.REF_TERM.DELETED_IN_EBIS
            ) {
              if (vm.loggedUserRole == vm.app.GLOBAL.MANAGER || vm.loggedUserRole == vm.app.GLOBAL.ADMIN) {
                $scope.isreadonly = false;
              }

              //Investigation Form
              if (
                vm.formProfile.investigationFormType == vm.app.INVESTIGATION.INVESTIGATOR_FORM &&
                ((vm.formProfile.isOwner == 1 && vm.formProfile.investigationFormStatus == vm.app.GLOBAL.IN_PROGRESS) ||
                  vm.loggedUserRole == vm.app.GLOBAL.ANALYST || vm.loggedUserRole == vm.app.GLOBAL.ROLE_COUNTRY_ADMIN)
              ) {
                $scope.isreadonly = false;
              } //Analyst Form
              else if (
                vm.formProfile.investigationFormType != vm.app.INVESTIGATION.INVESTIGATOR_FORM &&
                vm.formProfile.isOwner == 1
              ) {
                $scope.isreadonly = false;
                if (
                  vm.loggedUserRole == vm.app.GLOBAL.ANALYST &&
                  vm.formProfile.investigationFormStatus == vm.app.GLOBAL.COMPLETED
                ) {
                  $scope.isreadonly = true;
                }
              }
            }
          },
          function (reason) {
            return reason;
          }
        );
      }
    };

    if (vm.profileForm != null) {
      vm.formProfileDetails(vm.profileForm.investigationFormId);
    }

    /**
     * Method to check the uploaded file section.
     * orginSectionFileUpload - Will be set from every section.
     */
    $scope.setOrginSectionFileUpload = function (orginSectionName) {
      $scope.orginSectionFileUpload = orginSectionName;
    };

    //fileupload
    $scope.uploadFileInSectionSummary = function (
      ev,
      files,
      questionKey,
      sectionId,
      isSummary,
      id,
      idName,
      sectionAccordionIndex,
      description
    ) {
      $scope.uploadingFile = files;
      $scope.fileUploadLoader = true;
      $scope.fileTypeError = false;
      vm.submittedAsset = {};
      vm.submittedAsset.fileName = files.name;
      var dispalyName = files.name;
      dispalyName = dispalyName.slice(0, dispalyName.lastIndexOf("."));
      var questionId;
      var fileDescription;
      var entityId;
      var investigationFormType;
      $scope.questionKeyUpload = questionKey;
      $scope.sectionAccordionIndex = sectionAccordionIndex;

      if (questionKey != null && questionKey != undefined) {
        questionId = questionKey;
      }
      if (description != null && description != undefined) {
        fileDescription = description;
      }
      if (sectionId != null && sectionId != undefined) {
        entityId = sectionId;
      }
      if ($scope.investigationFormType == vm.app.INVESTIGATION.INVESTIGATOR_FORM) {
        investigationFormType = "INVESTIGATOR_FORM";
      } else if ($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM) {
        investigationFormType = "ANALYST_FORM";
      }

      if (files && files.size <= 26214400) {
        if (
          files.type == "application/pdf" ||
          files.type == "image/png" ||
          files.type == "image/jpg" ||
          files.type == "image/jpeg" ||
          files.type == "image/bmp" ||
          files.type == "image/tiff"
        ) {
          $scope.uploadFileDetails = {};
          $scope.uploadFileDetails.files = files;
          $scope.uploadFileDetails.dispalyName = dispalyName;
          $scope.uploadFileDetails.entityId = entityId;
          $scope.uploadFileDetails.investigationFormType = investigationFormType;
          $scope.uploadFileDetails.questionId = questionId;
          $scope.uploadFileDetails.fileDescription = fileDescription;
          $scope.uploadFileDetails.isSummary = isSummary;
          $scope.uploadFileDetails.sectionAccordionIndex = sectionAccordionIndex;
          //Show the confirmation popup if user edit the another user form
          if ($scope.isOwner) $scope.uploadFile();
          else {
            vm.disableUpload = false;
            $mdDialog.show({
              targetEvent: ev,
              contentElement: "#" + vm.app.INVESTIGATION_FORM.UPLOAD_DOCUMENT_CONFIRMATION_POPUPID,
              clickOutsideToClose: false,
              escapeToClose: false
            });
          }
        } else {
          $timeout(function () {
            $scope.fileUploadLoader = false;
            var errorId = "fileTypeError_" + idName;
            var element = document.getElementById(errorId);
            element.classList.remove("hide");
            $timeout(function () {
              element.classList.add("hide");
            }, 5000);
          }, 100);
        }
      } else {
        $scope.fileUploadLoader = false;
        var errorId = "fileSizeError_" + idName;
        var element = document.getElementById(errorId);
        element.classList.remove("hide");
        $timeout(function () {
          element.classList.add("hide");
        }, 5000);
      }
    };

    //Upload the aatachments
    $scope.uploadFile = function () {
      vm.disableUpload = true;
      //Initialize the file upload progress flag for respective sections.
      if (vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO == $scope.uploadFileDetails.questionId) {
        $scope.fileUploadProgress_photo = 0;
      } else if ($scope.uploadFileDetails.isSummary == vm.app.GLOBAL.TRUE) {
        $scope.fileUploadProgressSummary = 0;
      } else {
        $scope.fileUploadProgressAccordion = 0;
      }
      //Close the confirmation popup
      vm.gobacktoForm();
      $scope.uploadFileDetails.files.upload = Upload.upload({
        url: BASE_URL + "api/assets/uploadDocument",
        fields: {
          displayName: $scope.uploadFileDetails.dispalyName,
          parentEntityId: vm.profileForm.investigationFormId,
          entityId: $scope.uploadFileDetails.entityId,
          parentEntityType: $scope.uploadFileDetails.investigationFormType,
          entityType: "SECTION",
          questionId: $scope.uploadFileDetails.questionId,
          description: $scope.uploadFileDetails.fileDescription,
          isSummary: $scope.uploadFileDetails.isSummary,
          sectionAccordionIndex: $scope.uploadFileDetails.sectionAccordionIndex
        },
        file: $scope.uploadFileDetails.files
      });
      $scope.uploadFileDetails.files.upload.then(
        function (response) {
          $scope.uploadedFile = true;
          $scope.fileUploadLoader = false;
          $scope.fileUploadProgressAccordion = null;
          $scope.fileUploadProgressSummary = null;
          $scope.fileUploadProgress_photo = null;
          $scope.updateLastEditTime(response.data.updatedOn);
          setTimeout(function () {
            $scope.uploadFileDetails.files.result = response.data;

            // Summary documents
            if (
              !$scope.uploadFileDetails.questionId &&
              $scope.uploadFileDetails.questionId != vm.app.INVESTIGATION_FORM.SUMMARY_KEY &&
              $scope.uploadFileDetails.questionId != vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO
            ) {
              $scope.uploadFileSectionListObj.uploadList.push($scope.uploadFileDetails.files.result);
              $scope.uploadFileSectionList.push($scope.uploadFileSectionListObj);
            } else if ($scope.uploadFileDetails.questionId == vm.app.INVESTIGATION_FORM.SUMMARY_KEY) {
              $scope.uploadFileSectionListObjSummary.uploadList.push($scope.uploadFileDetails.files.result);
              $scope.uploadFileSectionListSummary.push($scope.uploadFileSectionListObjSummary);
            }
            //Family photo documents
            else {
              $scope.uploadFileSectionFamilyPhotoListObj.uploadList.push($scope.uploadFileDetails.files.result);
              $scope.uploadFileSectionFamilyPhotoList.push($scope.uploadFileSectionFamilyPhotoListObj);
              //Set the temporay family photo object to restrict the family description save call
              $scope.tempFamilyPhotoObject = angular.copy($scope.uploadFileSectionFamilyPhotoListObj.uploadList);
            }
          });
        },
        function (response) {
          $scope.fileUploadLoader = false;
          $scope.fileUploadProgressAccordion = null;
          $scope.fileUploadProgressSummary = null;
          $scope.fileUploadProgress_photo = null;
          if (response.status > 0) $scope.errorMsg = response.status + ": " + response.data;
        },
        function (evt) {
          if ($scope.uploadFileDetails.questionId == vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO) {
            $scope.fileUploadProgress_photo = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total));
          } else if ($scope.uploadFileDetails.isSummary == "true") {
            $scope.fileUploadProgressSummary = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total));
          } else {
            $scope.fileUploadProgressAccordion = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total));
          }
        }
      );
    };

    /* Method name           : hideUploadProgressBar()
     * Method Description 	 : This method is used to make the progress value null to hide the progress bar on abort
     */
    $scope.hideUploadProgressBar = function (isSummary) {
      $timeout(function () {
        if (isSummary == "true") {
          $scope.fileUploadProgressSummary = null;
        } else if (isSummary == "photo") {
          $scope.fileUploadProgress_photo = null;
          $scope.fileUploadLoader = false;
        } else {
          $scope.fileUploadProgressAccordion = null;
        }
      }, 100);
    };

    $scope.removeAttachment = function (element) {
      $(element.target.parentElement).remove();
    };
    $scope.deleteFileConfirm = function (ev, documentId, index, questionKey) {
      $scope.uploadFileDelete = {};
      $scope.uploadFileDelete.documentId = documentId;
      $scope.uploadFileDelete.index = index;
      $scope.uploadFileDelete.questionKey = questionKey;
      $scope.recordFlag = false;
      $mdDialog.show({
        targetEvent: ev,
        contentElement: "#deleteUploadFilePopup",
        clickOutsideToClose: false,
        escapeToClose: false
      });
    };

    $scope.deleteFile = function () {
      var data = InvestigationFormService.deleteFiles($scope.uploadFileDelete.documentId);
      data.then(function (response) {
        $scope.recordFlag = true;
        $mdDialog.hide();
        $scope.updateLastEditTime(response.updatedOn);
        $scope.uploadedFile = true;
        if (
          !$scope.uploadFileDelete.questionKey &&
          $scope.uploadFileDelete.questionKey != vm.app.INVESTIGATION_FORM.SUMMARY_KEY &&
          $scope.uploadFileDelete.questionKey != vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO
        ) {
          $scope.uploadFileSectionList[0].uploadList.splice($scope.uploadFileDelete.index, 1);
        } else if ($scope.uploadFileDelete.questionKey == vm.app.INVESTIGATION_FORM.SUMMARY_KEY) {
          $scope.uploadFileSectionListSummary[0].uploadList.splice($scope.uploadFileDelete.index, 1);
        } else {
          $scope.uploadFileSectionFamilyPhotoList[0].uploadList.splice($scope.uploadFileDelete.index, 1);
          //Set the temporay family photo object to restrict the family description save call
          $scope.tempFamilyPhotoObject = angular.copy($scope.uploadFileSectionFamilyPhotoList[0].uploadList);
        }
      });
    };

    $scope.deleteDocumentByIndex = function (entityKey, sectionAccordionIndex) {
      var parentEntityId = vm.profileForm.investigationFormId;
      var data = InvestigationFormService.deleteFilesByIndex(parentEntityId, entityKey, sectionAccordionIndex);
      data.then(function (response) {
        //Updating 0th index after delete 0th accordion
        if (sectionAccordionIndex == 0) {
          $scope.getUploadFiles(null, entityKey, sectionAccordionIndex);
        }
      });
    };

    $scope.deleteAllFamilyPhoto = function (familyPhotos) {
      $mdDialog.hide();
      $scope.uploadFileSectionFamilyPhotoList[0].uploadList = [];
      angular.forEach(familyPhotos, function (data, key) {
        InvestigationFormService.deleteFiles(data.id);
      });
    };

    $scope.getUploadFiles = function (questionKey, entityKey, sectionAccordionIndex) {
      $scope.uploadFileSectionList = [];
      $scope.uploadFileSectionListObj.uploadList = [];

      $scope.uploadFileLoader = true;
      var parentEntityId = vm.profileForm.investigationFormId;
      var data = InvestigationFormService.getUploadFiles(parentEntityId, entityKey, sectionAccordionIndex, questionKey);
      data.then(function (response) {
        //sectionAccordionIndex!=undefined &&
        if (
          !questionKey &&
          questionKey != vm.app.INVESTIGATION_FORM.SUMMARY_KEY &&
          questionKey != "familyInformation_familyPhoto_1"
        ) {
          $scope.uploadFileSectionListObj.uploadList = response;
          $scope.uploadFileSectionList.push($scope.uploadFileSectionListObj);
        } else if (questionKey == vm.app.INVESTIGATION_FORM.SUMMARY_KEY) {
          $scope.uploadFileSectionListSummary = [];
          $scope.uploadFileSectionListObjSummary.uploadList = [];

          $scope.uploadFileSectionListObjSummary.uploadList = response;
          $scope.uploadFileSectionListSummary.push($scope.uploadFileSectionListObjSummary);
        } else {
          $scope.uploadFileSectionFamilyPhotoList = [];
          $scope.uploadFileSectionFamilyPhotoListObj.uploadList = [];

          $scope.uploadFileSectionFamilyPhotoListObj.uploadList = response;
          $scope.uploadFileSectionFamilyPhotoList.push($scope.uploadFileSectionFamilyPhotoListObj);
          //Set the temporay family photo object to restrict the family description save call
          $scope.tempFamilyPhotoObject = [];
          $scope.tempFamilyPhotoObject = angular.copy($scope.uploadFileSectionFamilyPhotoListObj.uploadList);
        }

        $scope.uploadFileLoader = false;
      });
    };

    //Method for add or suggest entity
    $scope.entityObj = {};
    $scope.entityRequestAddorSuggest = function (entityName, entityType) {
      entityName = entityName.split(",")[0];
      $scope.entityObj.entityTypeKey = [];
      $scope.entityObj.searchKey = {};
      if (entityType == "Medical Institution") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.MEDICAL_INSTITUTION);
      } else if (entityType == "Religious Institution") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.RELIGIOUS_INSTITUTION);
      } else if (entityType == "School") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.SCHOOL);
      } else if (entityType == "Dna Center") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.DNA_CENTER);
      } else if (entityType == "Local Registry") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.LOCAL_REGISTRY);
      } else if (entityType == "National Registry") {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.NATIONAL_REGISTRY);
      } else {
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.LOCAL_REGISTRY);
        $scope.entityObj.entityTypeKey.push(vm.app.INVESTIGATION.NATIONAL_REGISTRY);
      }
      $scope.entityObj.searchKey = entityName;

      var deferred = $q.defer();
      var data = InvestigationFormService.addorSuggestEntityRequest($scope.entityObj);
      data.then(function (response) {
        deferred.resolve(response);
        //To  handle auto complete scroll in touch based devices
        window.addEventListener(
          "touchstart",
          function () {
            $timeout(function () {
              if (response.length == 0) {
                $mdUtil.enableScrolling();
                window.addEventListener(
                  "touchmove",
                  function () {
                    $(".md-autocomplete-suggestions-container.md-not-found").addClass("ng-hide");
                    $(".md-autocomplete-suggestions-container.md-not-found").removeClass(
                      "$mdAutocompleteCtrl.notFoundVisible()"
                    );
                  },
                  false
                );
              }
            }, 200);
          },
          false
        );
      });
      return deferred.promise;
    };

    vm.sideNavClose = function () {
      $mdSidenav("formLeft").close();
    };

    $scope.collapseAll = function (index) {
      vm.collapseAll(index);
      if (index == 0) {
        vm.getAnalystSectionList("birthCertitficate", vm.selectAllBCType);
      } else if (index == 1) {
        vm.getAnalystSectionList("birthMedical", vm.selectAllBirthMedicalRecordType);
      } else if (index == 2) {
        vm.getAnalystSectionList("neighbourhood", vm.selectAllNeighbourhoodType);
      } else if (index == 3) {
        vm.getAnalystSectionList("family", vm.selectAllFamilyType);
      } else if (index == 4) {
        vm.getAnalystSectionList("school", vm.selectAllSchoolType);
      } else if (index == 5) {
        vm.getAnalystSectionList("religious", vm.selectAllReligiousType);
      } else if (index == 9) {
        vm.summarycall();
      }
    };

    vm.collapseAll = function (index) {
      $sessionStorage.selectedSectionIndex = index;
      if (index != 9) {
        for (var i = 0; i < 6; i++) {
          if (i == index) {
            if ($scope.sideNavAccordion[i]) {
              $scope.sideNavAccordion[i] = false;
              vm.currentStateSideNav();
            } else {
              $scope.sideNavAccordion[i] = true;
            }
          } else {
            $scope.sideNavAccordion[i] = false;
          }
        }
        $scope.summaryActivated = true;
      } else {
        for (var i = 0; i < 10; i++) {
          $scope.sideNavAccordion[i] = true;
        }
        $scope.summaryActivated = false;
      }
    };

    vm.currentStateSideNav = function () {
      if ($scope.currentState == "bithcerticateForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("birthCertificate");
      } else if ($scope.currentState == "birthAndMedicalForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("birthMedical");
      } else if ($scope.currentState == "neighbourhoodCanvasForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("neighbourhood");
      } else if ($scope.currentState == "familyInfoForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("family");
      } else if ($scope.currentState == "schoolInfoForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("school");
      } else if ($scope.currentState == "religiousInstitutionForm" && $scope.isOwner == true) {
        $scope.saveAnalystFormTypeCheckList("religious");
      }
    };

    vm.togglecheckbox = function (sideNavVal, checkboxes, type, selectAll) {
      if (selectAll) {
        for (var i = 1; i <= selectAll; i++) {
          // console.log("type====ww"+$scope.toggleValue.sideNav[sideNavVal].checkboxes[i].values[type]);

          //$scope.toggleValue.sideNav[sideNavVal].checkboxes[0].values[type]=true;
          $scope.toggleValue.sideNav[sideNavVal].checkboxes[i].values[type] = true;
          //$scope.toggleValue.sideNav[sideNavVal].checkboxes[2].values[type]=true;
          //$scope.toggleValue.sideNav[sideNavVal].checkboxes[3].values[type]=true;
          /* for(var j=0;j<4;j++){
					 if(j==type){
				           $scope.toggleValue.sideNav[sideNavVal].checkboxes[i].values[j]=true;
					 }
					 else{
						$scope.toggleValue.sideNav[sideNavVal].checkboxes[i].values[j]=false;
					 }
				 }*/
        }
      } else {
        for (var i = 0; i < 4; i++) {
          if (i == type) {
            $scope.toggleValue.sideNav[0].checkboxes[checkboxes].values[i] = false;
            $scope.toggleValue.sideNav[sideNavVal].checkboxes[checkboxes].values[i] = true;
          } else {
            $scope.toggleValue.sideNav[sideNavVal].checkboxes[checkboxes].values[i] = false;
          }
        }
      }
    };
    vm.openMenu = function ($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    /*vm.openDialog = function(ev,id){
   		$mdDialog.show({                   
            targetEvent: ev,
            contentElement:'#'+id
           });
   	}*/
    vm.selectCheck = [
      {
        name: "Birth Certificate"
      },
      {
        name: "Birth Medical"
      },
      {
        name: "Family Information"
      }
    ];
    //COPY INVESTIGATOR
    if (vm.user.authorities[0] == vm.app.GLOBAL.ROLE_INVESTIGATOR) {
      delete $sessionStorage.isView;
    }
    vm.formSectionCopy = function (sections, ev, id) {
      $scope.investigationSectionObj = {};
      $scope.investigationSectionObj.id = [];
      $scope.investigationSectionObj.name = [];

      var data = CommonService.getRefTermList(vm.app.REF_TERM.SECTION);
      data.then(function (response) {
        vm.formSectionList = response;

        //To set the selected section id and name
        if (sections.birthcerticate_checked) {
          vm.getSectionId("Birth Certificate", vm.formSectionList);
        }
        if (sections.birthAndMedical_checked) {
          vm.getSectionId("Birth And Medical Records", vm.formSectionList);
        }
        if (sections.neighbourhoodCanvas_checked) {
          vm.getSectionId("Neighborhood Canvass", vm.formSectionList);
        }
        if (sections.familyInfo_checked) {
          vm.getSectionId("Family Information", vm.formSectionList);
        }
        if (sections.schoolInfo_checked) {
          vm.getSectionId("School Information", vm.formSectionList);
        }
        if (sections.religiousInstitution_checked) {
          vm.getSectionId("Religious Institutions", vm.formSectionList);
        }
        if (sections.residencyQuestion_checked) {
          vm.getSectionId("Residency Questions", vm.formSectionList);
        }
        if (sections.other_checked) {
          vm.getSectionId("Other", vm.formSectionList);
        }
        if (sections.summary_checked) {
          vm.getSectionId("Summary", vm.formSectionList);
        }
        $mdDialog.show({
          targetEvent: ev,
          contentElement: "#" + id,
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          escapeToClose: false
        });
      });
    };
    vm.getSectionId = function (sectionName, formlist) {
      for (var i = 0; i < formlist.length; i++) {
        if (formlist[i].name == sectionName) {
          $scope.investigationSectionObj.id.push(formlist[i].id);
          $scope.investigationSectionObj.name.push(formlist[i].name);
          break;
        }
      }
    };
    vm.checkFlag = true;
    vm.selectAllSection = function (list) {
      if (list) {
        vm.sectionValue.birthcerticate_checked = false;
        vm.sectionValue.birthAndMedical_checked = false;
        vm.sectionValue.neighbourhoodCanvas_checked = false;
        vm.sectionValue.familyInfo_checked = false;
        vm.sectionValue.schoolInfo_checked = false;
        vm.sectionValue.religiousInstitution_checked = false;
        vm.sectionValue.residencyQuestion_checked = false;
        vm.sectionValue.other_checked = false;
        vm.sectionValue.summary_checked = false;
      } else {
        vm.sectionValue.birthcerticate_checked = true;
        vm.sectionValue.birthAndMedical_checked = true;
        vm.sectionValue.neighbourhoodCanvas_checked = true;
        vm.sectionValue.familyInfo_checked = true;
        vm.sectionValue.schoolInfo_checked = true;
        vm.sectionValue.religiousInstitution_checked = true;
        vm.sectionValue.residencyQuestion_checked = true;
        vm.sectionValue.other_checked = true;
        vm.sectionValue.summary_checked = true;
      }
    };
    vm.unselect = function () {
      vm.selectAll = false;
    };

    vm.goBack = function () {
      $mdDialog.hide();
    };
    vm.submitWarn = function () {
      if ($sessionStorage.analystFormId != null) {
        vm.copyDisable = true;
        vm.analystFormId = $sessionStorage.analystFormId;
        vm.investigatorFormId = vm.profileForm.investigationFormId;
        var data = InvestigationFormService.copyInvestigationFormDetails(
          vm.analystFormId,
          vm.investigatorFormId,
          $scope.investigationSectionObj.id
        );
        data.then(
          function (response) {
            vm.copyDisable = false;
            vm.warrnFlag = true;
          },
          function (reason) {
            vm.copyDisable = false;
            return reason;
          }
        );
      }
    };

    vm.openAnalystForm = function () {
      if ($sessionStorage.analystFormId != null) {
        vm.profileForm.investigationFormId = $sessionStorage.analystFormId;
      }
      delete $sessionStorage.analystFormId;
      $state.go("profileForm", vm.profileForm);
      $sessionStorage.selectedSectionIndex = 0;
      $sessionStorage.formType = vm.app.INVESTIGATION.ANALYST_FORM;
      delete $sessionStorage.isView;
      $mdDialog.hide();
    };
    vm.selectedItemList = [];
    vm.selectAllBCType = {};
    vm.selectAllBCType.firstObj = {};
    vm.selectAllBCType.secondObj = {};
    vm.selectAllBCType.thirdObj = {};
    vm.selectAllBCType.fourthObj = {};
    vm.selectAllBCType.firstObj.checked = false;
    vm.selectAllBCType.secondObj.checked = false;
    vm.selectAllBCType.thirdObj.checked = false;
    vm.selectAllBCType.fourthObj.checked = false;

    vm.selectAllBirthMedicalRecordType = {};
    vm.selectAllBirthMedicalRecordType.firstObj = {};
    vm.selectAllBirthMedicalRecordType.secondObj = {};
    vm.selectAllBirthMedicalRecordType.thirdObj = {};
    vm.selectAllBirthMedicalRecordType.fourthObj = {};
    vm.selectAllBirthMedicalRecordType.firstObj.checked = false;
    vm.selectAllBirthMedicalRecordType.secondObj.checked = false;
    vm.selectAllBirthMedicalRecordType.thirdObj.checked = false;
    vm.selectAllBirthMedicalRecordType.fourthObj.checked = false;

    vm.selectAllNeighbourhoodType = {};
    vm.selectAllNeighbourhoodType.firstObj = {};
    vm.selectAllNeighbourhoodType.secondObj = {};
    vm.selectAllNeighbourhoodType.thirdObj = {};
    vm.selectAllNeighbourhoodType.fourthObj = {};
    vm.selectAllNeighbourhoodType.firstObj.checked = false;
    vm.selectAllNeighbourhoodType.secondObj.checked = false;
    vm.selectAllNeighbourhoodType.thirdObj.checked = false;
    vm.selectAllNeighbourhoodType.fourthObj.checked = false;

    vm.selectAllFamilyType = {};
    vm.selectAllFamilyType.firstObj = {};
    vm.selectAllFamilyType.secondObj = {};
    vm.selectAllFamilyType.thirdObj = {};
    vm.selectAllFamilyType.fourthObj = {};
    vm.selectAllFamilyType.firstObj.checked = false;
    vm.selectAllFamilyType.secondObj.checked = false;
    vm.selectAllFamilyType.thirdObj.checked = false;
    vm.selectAllFamilyType.fourthObj.checked = false;

    vm.selectAllSchoolType = {};
    vm.selectAllSchoolType.firstObj = {};
    vm.selectAllSchoolType.secondObj = {};
    vm.selectAllSchoolType.thirdObj = {};
    vm.selectAllSchoolType.fourthObj = {};
    vm.selectAllSchoolType.firstObj.checked = false;
    vm.selectAllSchoolType.secondObj.checked = false;
    vm.selectAllSchoolType.thirdObj.checked = false;
    vm.selectAllSchoolType.fourthObj.checked = false;

    vm.selectAllReligiousType = {};
    vm.selectAllReligiousType.firstObj = {};
    vm.selectAllReligiousType.secondObj = {};
    vm.selectAllReligiousType.thirdObj = {};
    vm.selectAllReligiousType.fourthObj = {};
    vm.selectAllReligiousType.firstObj.checked = false;
    vm.selectAllReligiousType.secondObj.checked = false;
    vm.selectAllReligiousType.thirdObj.checked = false;
    vm.selectAllReligiousType.fourthObj.checked = false;

    vm.toggleList = function (list, subList, index, parentIndex, item, selectObj) {
      if (index == 0) {
        if (selectObj.firstObj.checked) {
          angular.forEach(subList, function (data, key) {
            if (index == key) {
              data.checked = false;
              selectObj.firstObj.checked = false;
            }
          });
        } else {
          var listCheckFirstSize = 0;
          angular.forEach(list, function (data, key) {
            for (var i = 0; i < data.checkBoxDTOList.length; i++) {
              if (i == 0 && data.checkBoxDTOList[index].checked == true) {
                listCheckFirstSize++;
              }
            }
          });
          if (list.length == listCheckFirstSize) {
            selectObj.firstObj.checked = true;
          } else {
            selectObj.firstObj.checked = false;
          }
        }
      } else if (index == 1) {
        if (selectObj.secondObj.checked) {
          angular.forEach(subList, function (data, key) {
            if (index == key) {
              data.checked = false;
              selectObj.secondObj.checked = false;
            }
          });
        } else {
          var listCheckSecondSize = 0;
          angular.forEach(list, function (data, key) {
            for (var i = 0; i < data.checkBoxDTOList.length; i++) {
              if (i == 0 && data.checkBoxDTOList[index].checked == true) {
                listCheckSecondSize++;
              }
            }
          });
          if (list.length == listCheckSecondSize) {
            selectObj.secondObj.checked = true;
          } else {
            selectObj.secondObj.checked = false;
          }
        }
      } else if (index == 2) {
        if (selectObj.thirdObj.checked) {
          angular.forEach(subList, function (data, key) {
            if (index == key) {
              data.checked = false;
              selectObj.thirdObj.checked = false;
            }
          });
        } else {
          var listCheckThirdSize = 0;
          angular.forEach(list, function (data, key) {
            for (var i = 0; i < data.checkBoxDTOList.length; i++) {
              if (i == 0 && data.checkBoxDTOList[index].checked == true) {
                listCheckThirdSize++;
              }
            }
          });
          if (list.length == listCheckThirdSize) {
            selectObj.thirdObj.checked = true;
          } else {
            selectObj.thirdObj.checked = false;
          }
        }
      } else if (index == 3) {
        if (selectObj.fourthObj.checked) {
          angular.forEach(subList, function (data, key) {
            if (index == key) {
              data.checked = false;
              selectObj.fourthObj.checked = false;
            }
          });
        } else {
          var listCheckFourthSize = 0;
          angular.forEach(list, function (data, key) {
            for (var i = 0; i < data.checkBoxDTOList.length; i++) {
              if (i == 0 && data.checkBoxDTOList[index].checked == true) {
                listCheckFourthSize++;
              }
            }
          });
          if (list.length == listCheckFourthSize) {
            selectObj.fourthObj.checked = true;
          } else {
            selectObj.fourthObj.checked = false;
          }
        }
      }
    };

    vm.toggleSubList = function (subList, index, parentIndex, toggleObj) {
      angular.forEach(subList, function (data, key) {
        if (index != key) {
          data.checked = false;
          toggleObj.firstObj.checked = false;
          toggleObj.secondObj.checked = false;
          toggleObj.thirdObj.checked = false;
          toggleObj.fourthObj.checked = false;
        } else {
          data.checked = true;
        }
      });
    };

    vm.isChecked = function (selectObj) {
      return selectObj.checked;
    };

    vm.toggleAll = function (doSelectAll, indexVal, list, selectableObj) {
      if (indexVal == 0) {
        selectableObj.firstObj.checked = doSelectAll;
        selectableObj.secondObj.checked = false;
        selectableObj.thirdObj.checked = false;
        selectableObj.fourthObj.checked = false;
      } else if (indexVal == 1) {
        selectableObj.secondObj.checked = doSelectAll;
        selectableObj.firstObj.checked = false;
        selectableObj.thirdObj.checked = false;
        selectableObj.fourthObj.checked = false;
      } else if (indexVal == 2) {
        selectableObj.thirdObj.checked = doSelectAll;
        selectableObj.secondObj.checked = false;
        selectableObj.firstObj.checked = false;
        selectableObj.fourthObj.checked = false;
      } else if (indexVal == 3) {
        selectableObj.fourthObj.checked = doSelectAll;
        selectableObj.secondObj.checked = false;
        selectableObj.thirdObj.checked = false;
        selectableObj.firstObj.checked = false;
      }
      if (!doSelectAll) {
        angular.forEach(list, function (data, key) {
          if (indexVal == 0) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 0) {
                val.checked = false;
              }
            });
          }
          if (indexVal == 1) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 1) {
                val.checked = false;
              }
            });
          }
          if (indexVal == 2) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 2) {
                val.checked = false;
              }
            });
          }
          if (indexVal == 3) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 3) {
                val.checked = false;
              }
            });
          }
        });
      } else {
        angular.forEach(list, function (data, key) {
          if (indexVal == 0) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 0) {
                val.checked = true;
              } else {
                val.checked = false;
              }
            });
          }
          if (indexVal == 1) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 1) {
                val.checked = true;
              } else {
                val.checked = false;
              }
            });
          }
          if (indexVal == 2) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 2) {
                val.checked = true;
              } else {
                val.checked = false;
              }
            });
          }
          if (indexVal == 3) {
            angular.forEach(data.checkBoxDTOList, function (val, index) {
              if (index == 3) {
                val.checked = true;
              } else {
                val.checked = false;
              }
            });
          }
        });
      }
    };

    /*$scope.birthCertificateCheckList = [];
      $scope.birthMedicalCheckList = [];
      $scope.neighbourhoodCheckList = [];
      $scope.familyCheckList = [];
      $scope.schoolCheckList = [];
      $scope.religiousCheckList = [];*/

    vm.getAnalystSectionList = function (type, selectableObj) {
      $timeout(function () {
        if ($sessionStorage.formType == vm.app.INVESTIGATION.ANALYST_FORM && !$scope.retainValue) {
          var sectionKey;
          if (type == "birthCertitficate") {
            sectionKey = vm.app.REF_TERM.BIRTH_CERTIFICATE;
            $scope.birthCertificateCheckList = [];
          } else if (type == "birthMedical") {
            sectionKey = vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS;
            $scope.birthMedicalCheckList = [];
          } else if (type == "neighbourhood") {
            sectionKey = vm.app.REF_TERM.NEIGHBORHOOD_CANVAS;
            $scope.neighbourhoodCheckList = [];
          } else if (type == "family") {
            sectionKey = vm.app.REF_TERM.FAMILY_INFORMATION;
            $scope.familyCheckList = [];
          } else if (type == "school") {
            sectionKey = vm.app.REF_TERM.SCHOOL_INFORMATION;
            $scope.schoolCheckList = [];
          } else if (type == "religious") {
            sectionKey = vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS;
            $scope.religiousCheckList = [];
          }
          var formId = $scope.investigationFormId;
          var data = InvestigationFormService.getIndividualAnalystSectionList(sectionKey, formId);
          data.then(function (response) {
            selectableObj.fourthObj.checked = false;
            selectableObj.secondObj.checked = false;
            selectableObj.thirdObj.checked = false;
            selectableObj.firstObj.checked = false;
            if (type == "birthCertitficate") {
              if ($scope.birthCertificateCheckList.length == 0) {
                vm.loadStaticBirthCertificateList();
                $scope.birthCertificateCheckListTempObj = angular.copy($scope.birthCertificateCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.birthCertificateCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionKey == data.questionKey) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.birthCertificateCheckListTempObj = angular.copy($scope.birthCertificateCheckList);
              } /*else {
        				  vm.loadStaticBirthCertificateList();
        			  }*/
            } else if (type == "birthMedical") {
              if ($scope.birthMedicalCheckList.length == 0) {
                vm.loadStaticBirthMedicalRecordList();
                $scope.birthMedicalCheckListTempObj = angular.copy($scope.birthMedicalCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.birthMedicalCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionValue == data.questionValue) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.birthMedicalCheckListTempObj = angular.copy($scope.birthMedicalCheckList);
              } else {
                vm.loadStaticBirthMedicalRecordList();
              }
            } else if (type == "neighbourhood") {
              if ($scope.neighbourhoodCheckList.length == 0) {
                vm.loadStaticNeighbourhoodCheckList();
                $scope.neighbourhoodCheckListTempObj = angular.copy($scope.neighbourhoodCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.neighbourhoodCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionValue == data.questionValue) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.neighbourhoodCheckListTempObj = angular.copy($scope.neighbourhoodCheckList);
              } else {
                vm.loadStaticNeighbourhoodCheckList();
              }
            } else if (type == "family") {
              if ($scope.familyCheckList.length == 0) {
                vm.loadStaticFamilyCheckList();
                $scope.familyCheckListTempObj = angular.copy($scope.familyCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.familyCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionValue == data.questionValue) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.familyCheckListTempObj = angular.copy($scope.familyCheckList);
              } else {
                vm.loadStaticFamilyCheckList();
              }
            } else if (type == "school") {
              if ($scope.schoolCheckList.length == 0) {
                vm.loadStaticSchoolCheckList();
                $scope.schoolCheckListTempObj = angular.copy($scope.schoolCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.schoolCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionValue == data.questionValue) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.schoolCheckListTempObj = angular.copy($scope.schoolCheckList);
              } else {
                vm.loadStaticSchoolCheckList();
              }
            } else if (type == "religious") {
              if ($scope.religiousCheckList.length == 0) {
                vm.loadStaticReligiousCheckList();
                $scope.religiousCheckListTempObj = angular.copy($scope.religiousCheckList);
              }
              if (response && response.formSectionResultDTOList.length > 0) {
                angular.forEach($scope.religiousCheckList, function (val, index) {
                  angular.forEach(response.formSectionResultDTOList, function (data, key) {
                    if (val.questionValue == data.questionValue) {
                      val.checkBoxDTOList = data.checkBoxDTOList;
                    }
                    if (data.questionValue == "Other" && data.subAnswer && data.subAnswer != "") {
                      val.subAnswer = data.subAnswer;
                      val.others_Checked = true;
                    }
                  });
                });
                $scope.religiousCheckListTempObj = angular.copy($scope.religiousCheckList);
              } else {
                vm.loadStaticReligiousCheckList();
              }
            }
          });
        }
        $scope.retainValue = false;
      }, 500);
      //}
    };

    $scope.setEntityType = function (typeKey, birthFlag, listFlag) {
      angular.forEach(vm.entityTypeList, function (data, key) {
        if (data.key == typeKey && birthFlag == vm.app.GLOBAL.FALSE && listFlag == vm.app.GLOBAL.FALSE) {
          $scope.entity.entityTypeSearchKey = data;
          $scope.entityTypeList.push(data);
        }
        if (data.key == typeKey && birthFlag == vm.app.GLOBAL.TRUE && listFlag == vm.app.GLOBAL.FALSE) {
          $scope.entity.entityTypeSearchKey = data;
        }
        if (data.key == typeKey && birthFlag == vm.app.GLOBAL.FALSE && listFlag == vm.app.GLOBAL.TRUE) {
          $scope.entityTypeList.push(data);
        }
      });
    };

    $scope.birthCertificateEntityRequest = function (ev, id, flag, chosenEntity) {
      $scope.entity = {};
      $scope.entityTypeList = [];
      $scope.inputSearchText = "";
      //Set Entity Type List
      $scope.setEntityType(vm.app.INVESTIGATION.LOCAL_REGISTRY, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.TRUE);
      $scope.setEntityType(vm.app.INVESTIGATION.NATIONAL_REGISTRY, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.TRUE);

      if (chosenEntity != undefined && chosenEntity != null) {
        $scope.entity.entityTypeSearchKey = {};
        if (chosenEntity == vm.app.GLOBAL.NATIONAL_REGISTRY) {
          $scope.setEntityType(vm.app.INVESTIGATION.NATIONAL_REGISTRY, vm.app.GLOBAL.TRUE, vm.app.GLOBAL.FALSE);
        } else {
          $scope.setEntityType(vm.app.INVESTIGATION.LOCAL_REGISTRY, vm.app.GLOBAL.TRUE, vm.app.GLOBAL.FALSE);
        }
      }
      $scope.openNewEntity(ev, id, flag);
    };

    $scope.birthMedicalEntityRequest = function (ev, id, flag) {
      $scope.entity = {};
      $scope.entity.entityTypeSearchKey = {};
      $scope.entityTypeList = [];
      $scope.inputSearchText = "";
      $scope.setEntityType(vm.app.INVESTIGATION.MEDICAL_INSTITUTION, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.FALSE);
      $scope.openNewEntity(ev, id, flag);
    };

    $scope.religiousEntityRequest = function (ev, id, flag) {
      $scope.entity = {};
      $scope.entity.entityTypeSearchKey = {};
      $scope.entityTypeList = [];
      $scope.inputSearchText = "";
      $scope.setEntityType(vm.app.INVESTIGATION.RELIGIOUS_INSTITUTION, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.FALSE);
      $scope.openNewEntity(ev, id, flag);
    };

    $scope.schoolEntityRequest = function (ev, id, flag) {
      $scope.entity = {};
      $scope.entity.entityTypeSearchKey = {};
      $scope.entityTypeList = [];
      $scope.inputSearchText = "";
      $scope.setEntityType(vm.app.INVESTIGATION.SCHOOL, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.FALSE);
      $scope.openNewEntity(ev, id, flag);
    };

    $scope.dnaEntityRequest = function (ev, id, flag) {
      $scope.entity = {};
      $scope.entity.entityTypeSearchKey = {};
      $scope.entityTypeList = [];
      $scope.inputSearchText = "";
      $scope.setEntityType(vm.app.INVESTIGATION.DNA_CENTER, vm.app.GLOBAL.FALSE, vm.app.GLOBAL.FALSE);
      $scope.openNewEntity(ev, id, flag);
    };

    vm.loadStaticBirthCertificateList = function () {
      $scope.birthCertificateCheckList = [
        {
          questionValue: "Declaration timing",
          questionKey: "birth_declaration_time",
          "dataTranslate" : "prospects.AnalystFormQuestion.declarationTiming",	
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Civil Registry Verification",
          questionKey: "birth_civil",
          "dataTranslate" : "prospects.AnalystFormQuestion.civilRegistryVerification",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "National Registry Verification",
          questionKey: "birth_national",
          "dataTranslate" : "prospects.AnalystFormQuestion.nationalRegistryVerification",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Declarants",
          questionKey: "birth_declarant",
          "dataTranslate" : "prospects.AnalystFormQuestion.declarants",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Documentation Authenticity",
          questionKey: "birth_documentation",
          "dataTranslate" : "prospects.AnalystFormQuestion.documentationAuthenticity",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "birth_other",
          "dataTranslate" : "prospects.AnalystFormQuestion.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    vm.loadStaticBirthMedicalRecordList = function () {
      $scope.birthMedicalCheckList = [
        {
          questionValue: "Records Availability",
          questionKey: "birth_medical_record_available",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.recordsAvailability",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Records Authenticity",
          questionKey: "birth_medical_record_auth",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.recordsAuthenticity",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Cons. with reported DOB",
          questionKey: "birth_medical_cons_dob",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.consWithReportedDOB",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Cons. w/ Mother/Gender/etc",
          questionKey: "birth_medical_cons_mg",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.consW/Mother/Gender/etc",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Midwife Verification",
          questionKey: "birth_medical_Midwife",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.midwifeVerification",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "birth_medical_other",
          "dataTranslate" : "prospects.AnalystFormQuestionMedical.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    vm.loadStaticNeighbourhoodCheckList = function () {
      $scope.neighbourhoodCheckList = [
        {
          questionValue: "Recognition of Photo by Name",
          questionKey: "neighbour_recog",
          "dataTranslate" : "prospects.AnalystFormQuestionCanvas.recognitionOfPhotoByName",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Nickname v. Reported Name",
          questionKey: "neighbour_nickname",
          "dataTranslate" : "prospects.AnalystFormQuestionCanvas.nicknameV.ReportedName",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Neighborhood Cooperation",
          questionKey: "neighbour_cooperation",
          "dataTranslate" : "prospects.AnalystFormQuestionCanvas.neighborhoodCooperation",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "neighbour_other",
          "dataTranslate" : "prospects.AnalystFormQuestionCanvas.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    vm.loadStaticFamilyCheckList = function () {
      $scope.familyCheckList = [
        {
          questionValue: "Parent Sibling Info Consistent",
          questionKey: "family_parent",
          "dataTranslate" : "prospects.AnalystFormQuestionFamily.parentSiblingInfoConsistent",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Family Photos",
          questionKey: "family_familyPhoto",
          "dataTranslate" : "prospects.AnalystFormQuestionFamily.familyPhotos",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "family_other",
          "dataTranslate" : "prospects.AnalystFormQuestionFamily.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    vm.loadStaticReligiousCheckList = function () {
      $scope.religiousCheckList = [
        {
          questionValue: "Matches Reported Info",
          questionKey: "religious_matchs",
          "dataTranslate" : "prospects.AnalystFormQuestionRelegious.matchesReportedInfo",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Authenticity/Timing",
          questionKey: "religious_auth",
          "dataTranslate" : "prospects.AnalystFormQuestionRelegious.authenticity/Timing",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "religious_other",
          "dataTranslate" : "prospects.AnalystFormQuestionRelegious.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    vm.loadStaticSchoolCheckList = function () {
      $scope.schoolCheckList = [
        {
          questionValue: "Availability of Records",
          questionKey: "school_availability",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.availabilityOfRecords",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "8th Grade National Exam",
          questionKey: "school_eigth_grade",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.8thGradeNationalExam",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Authenticity of Records",
          questionKey: "school_auth",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.authenticityOfRecords",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "DOB Consistency w/ Records",
          questionKey: "school_dob_cons",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.DOBConsistencyw/Records",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Name Consistency w/ Records",
          questionKey: "school_name_cons",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.nameConsistencyw/Records",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Recognition of Employees",
          questionKey: "school_recog",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.recognitionOfEmployees",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Recognition of Classmates",
          questionKey: "school_recog_class",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.recognitionOfClassmates",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        },
        {
          questionValue: "Other",
          questionKey: "school_other",
          "dataTranslate" : "prospects.AnalystFormQuestionSchool.other",
          others_Checked: false,
          subAnswer: "",
          checkBoxDTOList: [
            {
              value: "SUPPORTS",
              checked: false
            },
            {
              value: "INCONCLUSIVE",
              checked: false
            },
            {
              value: "DOES NOT SUPPORT",
              checked: false
            },
            {
              value: "NOT APPLICABLE",
              checked: false
            }
          ]
        }
      ];
    };

    $scope.saveAnalystFormTypeCheckList = function (type, isFromSection, isSaveFormAudit) {
      if ($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM) {
        var postCheckList = [];
        var sectionKey;
        var isSaveFormAuditFlag = true;
        var isSimilar = true;

        if (type == "birthCertificate") {
          sectionKey = vm.app.REF_TERM.BIRTH_CERTIFICATE;
          postCheckList = angular.copy($scope.birthCertificateCheckList);
          if (
            angular.isDefined($scope.birthCertificateCheckList) &&
            angular.isDefined($scope.birthCertificateCheckListTempObj) &&
            !angular.equals($scope.birthCertificateCheckList, $scope.birthCertificateCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
            // $scope.birthCertificateCheckList = null;
          }
        } else if (type == "birthMedical") {
          sectionKey = vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS;
          postCheckList = angular.copy($scope.birthMedicalCheckList);
          if (
            angular.isDefined($scope.birthMedicalCheckList) &&
            angular.isDefined($scope.birthMedicalCheckListTempObj) &&
            !angular.equals($scope.birthMedicalCheckList, $scope.birthMedicalCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
          }
        } else if (type == "neighbourhood") {
          sectionKey = vm.app.REF_TERM.NEIGHBORHOOD_CANVAS;
          postCheckList = angular.copy($scope.neighbourhoodCheckList);
          if (
            angular.isDefined($scope.neighbourhoodCheckList) &&
            angular.isDefined($scope.neighbourhoodCheckListTempObj) &&
            !angular.equals($scope.neighbourhoodCheckList, $scope.neighbourhoodCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
          }
        } else if (type == "family") {
          sectionKey = vm.app.REF_TERM.FAMILY_INFORMATION;
          postCheckList = angular.copy($scope.familyCheckList);
          if (
            angular.isDefined($scope.familyCheckList) &&
            angular.isDefined($scope.familyCheckListTempObj) &&
            !angular.equals($scope.familyCheckList, $scope.familyCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
          }
        } else if (type == "school") {
          sectionKey = vm.app.REF_TERM.SCHOOL_INFORMATION;
          postCheckList = angular.copy($scope.schoolCheckList);
          if (
            angular.isDefined($scope.schoolCheckList) &&
            angular.isDefined($scope.schoolCheckListTempObj) &&
            !angular.equals($scope.schoolCheckList, $scope.schoolCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
          }
        } else if (type == "religious") {
          sectionKey = vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS;
          postCheckList = angular.copy($scope.religiousCheckList);
          if (
            angular.isDefined($scope.religiousCheckList) &&
            angular.isDefined($scope.religiousCheckListTempObj) &&
            !angular.equals($scope.religiousCheckList, $scope.religiousCheckListTempObj)
          ) {
            isSimilar = false;
            $rootScope.warningPopup.show = true;
          }
        }
        var formId = $scope.investigationFormId;
        if (angular.isDefined(isSaveFormAudit) && isSaveFormAudit == false) isSaveFormAuditFlag = isSaveFormAudit;
        if (!isSimilar && (isFromSection == true || $scope.isOwner == true)) {
          var data = InvestigationFormService.saveIndividualAnalystSectionList(
            sectionKey,
            formId,
            isSaveFormAuditFlag,
            postCheckList
          );
          data.then(function (response) {
            //Set the checklist temp object
            $scope[type + "CheckListTempObj"] = angular.copy($scope[type + "CheckList"]);
          });
        }
      }
    };

    vm.birthCertificateCall = function () {
      // $rootScope.warningPopup.show = false;
      if ($scope.birthCertificateCheckList == undefined || $scope.birthCertificateCheckList.length == 0) {
        vm.getAnalystSectionList("birthCertitficate", vm.selectAllBCType);
      }
      vm.loadSectionFormByType("bithcerticateForm");
      //$scope.birthCertificateCheckListTempObj = angular.copy($scope.birthCertificateCheckList);
    };

    vm.birthMedicalCall = function () {
      if ($scope.birthMedicalCheckList == undefined || $scope.birthMedicalCheckList.length == 0) {
        vm.getAnalystSectionList("birthMedical", vm.selectAllBirthMedicalRecordType);
      }
      vm.loadSectionFormByType("birthAndMedicalForm");
      //$scope.birthMedicalCheckListTempObj = angular.copy($scope.birthMedicalCheckList);
    };

    vm.neighbourhoodCall = function () {
      if ($scope.neighbourhoodCheckList == undefined || $scope.neighbourhoodCheckList.length == 0) {
        vm.getAnalystSectionList("neighbourhood", vm.selectAllNeighbourhoodType);
      }
      vm.loadSectionFormByType("neighbourhoodCanvasForm");
      //$scope.neighbourhoodCheckListTempObj = angular.copy($scope.neighbourhoodCheckList);
    };

    vm.familyCall = function () {
      if ($scope.familyCheckList == undefined || $scope.familyCheckList.length == 0) {
        vm.getAnalystSectionList("family", vm.selectAllFamilyType);
      }
      vm.loadSectionFormByType("familyInfoForm");
      //$scope.familyCheckListTempObj = angular.copy($scope.familyCheckList);
    };

    vm.schoolCall = function () {
      if ($scope.schoolCheckList == undefined || $scope.schoolCheckList.length == 0) {
        vm.getAnalystSectionList("school", vm.selectAllSchoolType);
      }
      vm.loadSectionFormByType("schoolInfoForm");
      //$scope.schoolCheckListTempObj = angular.copy($scope.schoolCheckList);
    };

    vm.religiousCall = function () {
      if ($scope.religiousCheckList == undefined || $scope.religiousCheckList.length == 0) {
        vm.getAnalystSectionList("religious", vm.selectAllReligiousType);
      }
      vm.loadSectionFormByType("religiousInstitutionForm");
      //$scope.religiousCheckListTempObj = angular.copy($scope.religiousCheckList);
    };

    vm.summarycall = function () {
      if ($scope.birthCertificateCheckList == undefined || $scope.birthCertificateCheckList.length == 0) {
        vm.getAnalystSectionList("birthCertitficate", vm.selectAllBCType);
      }
      if ($scope.birthMedicalCheckList == undefined || $scope.birthMedicalCheckList.length == 0) {
        vm.getAnalystSectionList("birthMedical", vm.selectAllBirthMedicalRecordType);
      }
      if ($scope.neighbourhoodCheckList == undefined || $scope.neighbourhoodCheckList.length == 0) {
        vm.getAnalystSectionList("neighbourhood", vm.selectAllNeighbourhoodType);
      }
      if ($scope.familyCheckList == undefined || $scope.familyCheckList.length == 0) {
        vm.getAnalystSectionList("family", vm.selectAllFamilyType);
      }
      if ($scope.schoolCheckList == undefined || $scope.schoolCheckList.length == 0) {
        vm.getAnalystSectionList("school", vm.selectAllSchoolType);
      }
      if ($scope.religiousCheckList == undefined || $scope.religiousCheckList.length == 0) {
        vm.getAnalystSectionList("religious", vm.selectAllReligiousType);
      }
      $timeout(function () {
        vm.collapseAll(9);
        vm.loadSectionFormByType("summaryForm");
        vm.sideNavClose();
      }, 500);
    };

    vm.submitInvestigationForm = function (ev, id) {
      $mdDialog.show({
        contentElement: angular.element("#" + id),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false
      });
    };
    vm.gobacktoForm = function () {
      $mdDialog.cancel();
      $scope.recordFlag = true;
      $scope.fileUploadLoader = false;
    };

    vm.openToComplete = function (index, formName, event) {
      vm.collapseAll(index); // First Call to close all the SideNav
      vm.loadSectionFormByType(formName);
      vm.collapseAll(index); // Second Call to Open the SideNav
      vm.sideNavClose();
      var msg = "provideDetailsPopup";
      vm.submitInvestigationForm(event, msg);
    };

    $scope.summaryValidation = function (event) {
      var i, j;
      for (i = 0; i < $scope.birthCertificateCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.birthCertificateCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (
          !valid &&
          i == $scope.birthCertificateCheckList.length - 1 &&
          !$scope.birthCertificateCheckList[i].others_Checked
        ) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(0, "bithcerticateForm", event);
          return false;
        }
      }

      for (i = 0; i < $scope.birthMedicalCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.birthMedicalCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (!valid && i == $scope.birthMedicalCheckList.length - 1 && !$scope.birthMedicalCheckList[i].others_Checked) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(1, "birthAndMedicalForm", event);
          return false;
        }
      }

      for (i = 0; i < $scope.neighbourhoodCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.neighbourhoodCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (
          !valid &&
          i == $scope.neighbourhoodCheckList.length - 1 &&
          !$scope.neighbourhoodCheckList[i].others_Checked
        ) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(2, "neighbourhoodCanvasForm", event);
          return false;
        }
      }

      for (i = 0; i < $scope.familyCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.familyCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (!valid && i == $scope.familyCheckList.length - 1 && !$scope.familyCheckList[i].others_Checked) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(3, "familyInfoForm", event);
          return false;
        }
      }

      for (i = 0; i < $scope.schoolCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.schoolCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (!valid && i == $scope.schoolCheckList.length - 1 && !$scope.schoolCheckList[i].others_Checked) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(4, "schoolInfoForm", event);
          return false;
        }
      }

      for (i = 0; i < $scope.religiousCheckList.length; i++) {
        var valid = false;
        for (j = 0; j < 4; j++) {
          if ($scope.religiousCheckList[i].checkBoxDTOList[j].checked == true) {
            valid = true;
            break;
          }
        }
        if (!valid && i == $scope.religiousCheckList.length - 1 && !$scope.religiousCheckList[i].others_Checked) {
          valid = true;
        }
        if (!valid) {
          vm.openToComplete(5, "religiousInstitutionForm", event);
          return false;
        }
      }

      if (valid) {
        var msg = "formConformPopup";
        $rootScope.validationCompleted(event, msg);
      }
    };

    vm.clearfield = function (type) {
      vm.emptyChecked = [
        {
          value: "SUPPORTS",
          checked: false
        },
        {
          value: "INCONCLUSIVE",
          checked: false
        },
        {
          value: "DOES NOT SUPPORT",
          checked: false
        },
        {
          value: "NOT APPLICABLE",
          checked: false
        }
      ];
      if (type == "BIRTH_CERTIFICATE") {
        $scope.birthCertificateCheckList[5].subAnswer = "";
        $scope.birthCertificateCheckList[5].checkBoxDTOList = vm.emptyChecked;
      } else if (type == "BIRTH_MEDICAL") {
        $scope.birthMedicalCheckList[5].subAnswer = "";
        $scope.birthMedicalCheckList[5].checkBoxDTOList = vm.emptyChecked;
      } else if (type == "NEIGHBORHOOD_CANVASS") {
        $scope.neighbourhoodCheckList[3].subAnswer = "";
        $scope.neighbourhoodCheckList[3].checkBoxDTOList = vm.emptyChecked;
      } else if (type == "FAMILY_INFORMATION") {
        $scope.familyCheckList[2].subAnswer = "";
        $scope.familyCheckList[2].checkBoxDTOList = vm.emptyChecked;
      } else if (type == "SCHOOL_INFORMATION") {
        $scope.schoolCheckList[7].subAnswer = "";
        $scope.schoolCheckList[7].checkBoxDTOList = vm.emptyChecked;
      } else if (type == "RELIGIOUS_INSTITUTION") {
        $scope.religiousCheckList[2].subAnswer = "";
        $scope.religiousCheckList[2].checkBoxDTOList = vm.emptyChecked;
      }
    };

    $scope.analystInit = function () {
      if ($sessionStorage.formType == vm.app.INVESTIGATION.ANALYST_FORM) {
        if ($sessionStorage.selectedSectionIndex != 0) {
          var index = $sessionStorage.selectedSectionIndex;
          $scope.collapseAll(index);
        } else {
          $scope.collapseAll(0);
        }
      }
    };

    $scope.analystInit();

    $scope.getSideComments = function (formId, section, index) {
      if ($sessionStorage.formType == vm.app.INVESTIGATION.ANALYST_FORM) {
        $scope.sectionDTO = [];
        $scope.sideCommentTrigger = false;
        var data = SideCommentsDirectiveService.getSideComments(formId, section);
        //$scope.sideComments = {};
        data.then(
          function (response) {
            $scope.sideComments = response; //angular.toJson(response);
            angular.forEach($scope.sideComments.formSectionDTOs, function (data, key) {
              if (data.accordionIndex == index) {
                //$scope.sectionDTO = [];
                $scope.sectionDTO = data;
              }
            });
            $scope.sideCommentInitTrigger();
            if (section == vm.app.REF_TERM.FAMILY_INFORMATION) {
              $scope.getPhotoSectionDTO();
            }
          },
          function (reason) {
            return reason;
          }
        );
      }
    };

    $scope.getSectionDTO = function (index) {
      $scope.sideCommentTrigger = false;
      $scope.sectionDTO = [];
      angular.forEach($scope.sideComments.formSectionDTOs, function (data, key) {
        if (data.accordionIndex == index) {
          $scope.sectionDTO = data;
        }
      });
      $scope.sideCommentInitTrigger();
    };

    $scope.sideCommentInitTrigger = function () {
      $scope.sideCommentTrigger = true;
    };

    $scope.sideCommentCloseTrigger = function () {
      $scope.sideCommentTrigger = !$scope.sideCommentTrigger;
    };

    $scope.formViewCall = function (index) {
      $scope.sideCommentTrigger = false;
      $scope.getSideComments($scope.investigationFormId, $scope.currentSection, index);
    };

    /**
     * Method to delete side comments by section type and accodionIndex
     */
    $scope.deleteSidecommentsByIndex = function (sectionType, accordionIndex) {
      var data = SideCommentsDirectiveService.getSideCommentsBySectionIndex(
        $scope.investigationFormId,
        sectionType,
        accordionIndex
      );
      data.then(function (response) {
        $scope.sideComment = response;
        if ($scope.sideComment.investigationFormId != null) {
          $q.all([
            SideCommentsDirectiveService.deleteCommentsByIndex($scope.investigationFormId, sectionType, accordionIndex)
          ]).then(function (value) {
            if (accordionIndex != 0) {
              --accordionIndex;
            }
            $scope.getSideComments($scope.investigationFormId, sectionType, accordionIndex);
          });
        }
      });
    };

    $scope.getPhotoSectionDTO = function () {
      $scope.photoSectionDTO = [];
      angular.forEach($scope.sideComments.formSectionDTOs, function (data, key) {
        if (data.accordionIndex == vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.PHOTO_INDEX) {
          $scope.photoSectionDTO = data;
        }
      });
      $scope.familyPhotoCommentTrigger = true;
    };

    //Form Request
    $scope.requestStatus = function (requestedEntity) {
      var data = InvestigationFormService.getApprovedEntityProfile(requestedEntity.answerId);
      data.then(function (response) {
        if (response.isApproved) {
          requestedEntity.answer = response.entityName;
          requestedEntity.answerId = response.entityId;
          requestedEntity.requested = false;
          requestedEntity.subAnswer = true;
          $scope.checkValid = true; //This flag is used to maintain the approved message for 500ms - used in $scope.hideApprovedMessage()
          $timeout(function () {
            $scope.checkValid = false;
          }, 500);
        }
      });
      return requestedEntity;
    };

    /**
     * This function will hide the Entity approved message on its first change.
     */
    $scope.hideApprovedMessage = function (subAnswerFlag) {
      if (subAnswerFlag && !$scope.checkValid) {
        subAnswerFlag = undefined;
      }
      return subAnswerFlag;
    };
    // if the entity is choosed from dropdown but entity is in pending status
    $scope.isEntityApproved = function (value, isEntityValueChanged) {
      if (value != undefined) {
        $scope.entityChanged = isEntityValueChanged;
        var data = InvestigationFormService.getApprovedEntityProfile(value);
        data.then(function (response) {
          if (response.isApproved) {
            $rootScope.notApproved = false;
          } else {
            $rootScope.notApproved = true;
          }
        });
      } else {
        $rootScope.notApproved = false;
        $scope.entityChanged = false;
      }
    };
    function convertLocalDateToServer(date) {
      if (date) {
        return $filter("date")(date, "MMMM dd, yyyy hh:mm a");
      } else {
        return null;
      }
    }

    $scope.updateLastEditTime = function (lastEditTime) {
      $scope.lastEditTime = convertLocalDateToServer(lastEditTime);
      vm.isLastEditVisible = true;
    };

    vm.getEntityTypeList = function () {
      var entityTypeData = CommonService.getRefTermList(vm.app.REF_TERM.ENTITY_PROFILE);
      entityTypeData.then(function (response) {
        vm.entityTypeList = response;
      });
    };
    vm.getEntityTypeList();

    // To enable the delete button flag after 200 ms
    $scope.enableDeleteButton = function () {
      $timeout(function () {
        $scope.deleteLoader.flag = false;
      }, 200);
    };

    // Make flag to indicate there is no changes in Upload documents in the current form.

    $scope.uploadFileStatusUpdated = function () {
      $scope.uploadedFile = false;
    };

    $scope.clearCKEditor = function () {
      var instance = {};
      for (instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].updateElement();
      }
      CKEDITOR.instances[instance].setData("");
    };

    // To change String to Date format
    $scope.datePickerFormat = function (datePickerValue) {
      if (datePickerValue && datePickerValue != "") {
        return new Date(datePickerValue);
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").controller("LibraryAddRequestController", LibraryAddRequestController);

  LibraryAddRequestController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$mdSidenav",
    "APP",
    "tabservice",
    "$mdMedia",
    "$sessionStorage",
    "$cookies",
    "LibraryService",
    "$mdDialog",
    "CommonService",
    "LibraryEntityService",
    "$q",
    "communicationService",
    "LibraryLocationService",
    "$timeout",
    "StorageDelete",
    "notifications",
    "$rootScope",
    "InvestigationFormService"
  ];

  function LibraryAddRequestController(
    $scope,
    $state,
    $stateParams,
    $mdSidenav,
    APP,
    tabservice,
    $mdMedia,
    $sessionStorage,
    $cookies,
    LibraryService,
    $mdDialog,
    CommonService,
    LibraryEntityService,
    $q,
    communicationService,
    LibraryLocationService,
    $timeout,
    StorageDelete,
    notifications,
    $rootScope,
    InvestigationFormService
  ) {
    var vm = this;
    $scope.APP = APP;
    $scope.endless = $scope.APP.GLOBAL.ENDLESS;
    $scope.library = $stateParams;
    $scope.media = $mdMedia;
    $scope.requestFlag = false;
    $scope.location = {};
    $scope.isHide = false;
    $scope.entityOrLocation = false;
    $scope.disableSaveButton = false;

    $scope.entityLocationObject = {};
    $scope.entityLocationObject.countryObj = {};
    $scope.entityLocationObject.provinceObj = {};
    $scope.entityLocationObject.cityObj = {};
    $scope.entityLocationObject.sectorObj = {};

    $scope.isHorizon = true;
    //Get user from cookie storage
    $scope.user = CommonService.getCookieUser();
    $scope.loggedUserRole = $scope.user.loggedUserRole;
    $scope.library.libraryType = $state.current.name;

    $scope.isHorizon = false;
    $scope.saveOrAddLocationObject = {};
    $scope.saveOrAddLocationObject.countryObj = {};
    $scope.saveOrAddLocationObject.provinceObj = {};
    $scope.saveOrAddLocationObject.cityObj = {};
    $scope.saveOrAddLocationObject.sectorObj = {};
    $scope.isAddOrSaveLocation = false;
    communicationService.setData("isAddOrSaveLocation", $scope.isAddOrSaveLocation);

    $scope.addLocationObject = {};
    $scope.addLocationObject.countryObj = {};
    $scope.addLocationObject.provinceObj = {};
    $scope.addLocationObject.cityObj = {};
    $scope.addLocationObject.sectorObj = {};

    $scope.addLocationInputSearchObject = {};

    $scope.addLocationInputObject = {};
    $scope.addLocationInputObject.country = false;
    $scope.addLocationInputObject.province = false;
    $scope.addLocationInputObject.city = false;
    $scope.addLocationInputObject.sector = false;

    $scope.libraryAddEntityInputSearchObject = {};
    $scope.libraryAddEntityInputSearchObject.country = "";
    $scope.libraryAddEntityInputSearchObject.province = "";
    $scope.libraryAddEntityInputSearchObject.city = "";
    $scope.libraryAddEntityInputSearchObject.countrySearchKey = "";
    $scope.libraryAddEntityInputSearchObject.provinceSearchKey = "";
    $scope.libraryAddEntityInputSearchObject.citySearchKey = "";
    $scope.libraryAddEntityInputSearchObject.sectorSearchKey = "";
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCountry = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationProvince = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationCity = false;
    $scope.libraryAddEntityInputSearchObject.isAddOrSaveLocationSector = false;

    $scope.disableButton = {};
    $scope.disableButton.isDisabled = false;
    $scope.country = "";

    $scope.cancel = function (formName) {
      $mdDialog.hide();
    };

    //ADD NEW ENTITY POPUP
    $scope.openNewEntity = function (ev, id, flag) {
      //$scope.entity = {}; //Clear Form fields 
      $scope.libraryAddEntityInputSearchObject = {};
      $scope.entityLocationObject = {};
      $scope.entityLocationObject.countryObj = {};
      $scope.entityLocationObject.provinceObj = {};
      $scope.entityLocationObject.cityObj = {};
      $scope.entityLocationObject.sectorObj = {};
      $scope.addNewEntityForm = {};
      $scope.modelObject = {};
      $scope.inputsearchObject = {};
      $scope.editFlag = false;
      $scope.isHide = false;
      $scope.updateFlag = false;
      $scope.existFlag = false;
      $scope.entity.inputSearchText = '';
      $scope.flag = flag;
      if ($scope.entityObj.searchKey != null) {
        $scope.setEntityName($scope.entityObj.searchKey);
      } else {
        $scope.setEntityResponseName();
      }

      $mdDialog.show({
        targetEvent: ev,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    };

    $scope.cancel = function (addNewEntityForm) {
      addNewEntityForm.$setPristine();
      $scope.entity = {}; //Clear Form fields 
      $scope.entity.contactEmail = '';
      $scope.entity.contactPerson = '';
      $scope.addNewEntityForm = {};
      $mdDialog.hide();
    };

    //ADD ENTITY REQUEST
    $scope.saveNewEntity = function (entity, addNewEntityForm, locationObject, libraryAddEntityInputSearchObject) {
      if (addNewEntityForm.$valid && entity) {
        $scope.entityObj = {};
        $scope.entityObj.comments = entity.comments;
        $scope.entityObj.contactEmail = entity.contactEmail;
        $scope.entityObj.contactPersonName = entity.contactPersonName;
        $scope.entityObj.contactPhoneNumber = entity.contactPhoneNumber;
        $scope.entityObj.entityTypeId = entity.entityTypeSearchKey.id;
        $scope.entityType = entity.entityTypeSearchKey.key;
        if (entity.flag == undefined || entity.flag == "") {
          entity.flag = false;
        }
        $scope.entityObj.flag = entity.flag;
        $scope.entityObj.name = $scope.entity.entityName;
        $scope.entityObj.isForm = true;
        if (locationObject.cityObj.locationMappingId == undefined || locationObject.provinceObj.locationMappingId == undefined || locationObject.countryObj.locationMappingId == undefined) {
          $scope.entityOrLocation = true;
          $scope.saveLocation(locationObject, libraryAddEntityInputSearchObject, $scope.entityObj, entity, addNewEntityForm, $scope.entityOrLocation);
        }
        else {
          $scope.entityObj.locationMappingId = locationObject.cityObj.locationMappingId;
          var data = LibraryService.saveNewEntity($scope.entityObj);
          data.then(function (response) {
            if ($scope.entityType == $scope.APP.INVESTIGATION.MEDICAL_INSTITUTION) {
              $rootScope.birthMedicalEntityRequestsent(entity, locationObject, response);
            }
            if ($scope.entityType == $scope.APP.INVESTIGATION.LOCAL_REGISTRY || $scope.entityType == $scope.APP.INVESTIGATION.NATIONAL_REGISTRY) {
              $rootScope.birthCertificateEntityRequestsent(entity, locationObject, response);
            }
            if ($scope.entityType == $scope.APP.INVESTIGATION.RELIGIOUS_INSTITUTION) {
              $rootScope.residencyEntityRequestsent(entity, locationObject, response);
            }
            if ($scope.entityType == $scope.APP.INVESTIGATION.SCHOOL) {
              $rootScope.schoolEntityRequestsent(entity, locationObject, response);
            }
            if ($scope.entityType == $scope.APP.INVESTIGATION.DNA_CENTER) {
              $rootScope.dnaEntityRequestsent(entity, locationObject, response);
            }
            if (response.entityExists) {
              notifications.showSuccess({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_EXISTS });
            }
            else {
              notifications.showSuccess({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_SEND });
            }
          }, function (reason) {
            notifications.showError({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_SEND_PROBLEM });
          });
          $scope.cancel(addNewEntityForm);
        }
      }
    };

    $scope.locRegTypeValid = false;

    //ADD LOCATION REQUEST POPUP
    $scope.openLocationRequest = function (ev, id, flag, inputSearchObject, locationObject) {
      $scope.flag = flag;
      $scope.formInputSearchObject = angular.copy(inputSearchObject);
      $scope.formLocationObject = angular.copy(locationObject);
      $scope.addLocationInputSearchObject = inputSearchObject;
      $scope.saveOrAddLocationObject = locationObject;
      $scope.isHorizon = true;
      $scope.disableButton.isDisabled = false;
      $mdDialog.show({
        targetEvent: ev,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    };

    $scope.isValidEnable = false;
    $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
    $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
    $scope.addLocationInputSearchObject.isInputEmptyCity = false;
    $scope.addLocationInputSearchObject.isInputEmptySector = false;

    $scope.checkMandatoryFields = function (type) {
      if ($scope.isAddOrSaveLocation) {
        if (type == $scope.APP.LIBRARY.COUNTRY_CAPS) {
          if ($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '') {
            if (($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '')
              || ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '')
              || ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            } else {
              $scope.isValidEnable = false;
            }
          } else if ($scope.addLocationInputSearchObject.countrySearchKey != null && $scope.addLocationInputSearchObject.countrySearchKey != '') {
            $scope.isValidEnable = true;
          } else {
            $scope.isValidEnable = false;
          }
        } else if (type == $scope.APP.LIBRARY.PROVINCE_CAPS) {
          if ($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '') {
            if ($scope.saveOrAddLocationObject.provinceObj && $scope.saveOrAddLocationObject.provinceObj.provinceId != null && $scope.saveOrAddLocationObject.provinceObj.provinceId != '') {
              if (($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '')
                || ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
                $scope.isValidEnable = true;
              } else {
                $scope.isValidEnable = false;
              }
            } else {
              if ($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
          } else if ($scope.addLocationInputSearchObject.countrySearchKey != null && $scope.addLocationInputSearchObject.countrySearchKey != '') {
            if ($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '') {
              $scope.isValidEnable = true;
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
          } else {
            $scope.addLocationInputSearchObject.isInputEmptyCountry = true;
            $scope.isValidEnable = false;
          }
        } else if (type == $scope.APP.LIBRARY.CITY_CAPS) {
          if (($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '')
            && ($scope.saveOrAddLocationObject.provinceObj && $scope.saveOrAddLocationObject.provinceObj.provinceId != null && $scope.saveOrAddLocationObject.provinceObj.provinceId != '')) {
            if (($scope.saveOrAddLocationObject.cityObj && $scope.saveOrAddLocationObject.cityObj.cityId != null && $scope.saveOrAddLocationObject.cityObj.cityId != '')) {
              if (($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
                $scope.isValidEnable = true;
              } else {
                $scope.isValidEnable = false;
              }
            } else {
              if ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else if ($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '') {
            if (($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '')
              && ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '')) {
              $scope.isValidEnable = true;
            } else {
              $scope.isValidEnable = false;
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else if (($scope.addLocationInputSearchObject.countrySearchKey != null && $scope.addLocationInputSearchObject.countrySearchKey != '')
            && ($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '')
            && ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '')) {
            $scope.isValidEnable = true;
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
          } else {
            $scope.addLocationInputSearchObject.isInputEmptyCountry = true;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = true;
            $scope.isValidEnable = false;
          }
        } else if (type == $scope.APP.LIBRARY.SECTOR_CAPS) {
          if (($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '')
            && ($scope.saveOrAddLocationObject.provinceObj && $scope.saveOrAddLocationObject.provinceObj.provinceId != null && $scope.saveOrAddLocationObject.provinceObj.provinceId != '')
            && ($scope.saveOrAddLocationObject.cityObj && $scope.saveOrAddLocationObject.cityObj.cityId != null && $scope.saveOrAddLocationObject.cityObj.cityId != '')) {
            if (($scope.saveOrAddLocationObject.sectorObj && $scope.saveOrAddLocationObject.sectorObj.sectorId != null && $scope.saveOrAddLocationObject.sectorObj.sectorId != '')) {
              $scope.isValidEnable = false;
            } else {
              if ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '') {
                $scope.isValidEnable = true;
              }
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
            $scope.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if (($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '')
            && ($scope.saveOrAddLocationObject.provinceObj && $scope.saveOrAddLocationObject.provinceObj.provinceId != null && $scope.saveOrAddLocationObject.provinceObj.provinceId != '')) {
            if (($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '') && ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
            $scope.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if ($scope.saveOrAddLocationObject.countryObj && $scope.saveOrAddLocationObject.countryObj.countryId != null && $scope.saveOrAddLocationObject.countryObj.countryId != '') {
            if (($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '') && ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '')
              && ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
              $scope.isValidEnable = true;
            }
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
            $scope.addLocationInputSearchObject.isInputEmptyCity = false;
          } else if (($scope.addLocationInputSearchObject.countrySearchKey != null && $scope.addLocationInputSearchObject.countrySearchKey != '') && ($scope.addLocationInputSearchObject.provinceSearchKey != null && $scope.addLocationInputSearchObject.provinceSearchKey != '')
            && ($scope.addLocationInputSearchObject.citySearchKey != null && $scope.addLocationInputSearchObject.citySearchKey != '') && ($scope.addLocationInputSearchObject.sectorSearchKey != null && $scope.addLocationInputSearchObject.sectorSearchKey != '')) {
            $scope.isValidEnable = true;
            $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
            $scope.addLocationInputSearchObject.isInputEmptyCity = false;
          } else {
            $scope.addLocationInputSearchObject.isInputEmptyCountry = true;
            $scope.addLocationInputSearchObject.isInputEmptyProvince = true;
            $scope.addLocationInputSearchObject.isInputEmptyCity = true;
            $scope.isValidEnable = false;
          }
        }
      }
    }

    $scope.hidePopup = function () {
      $mdDialog.hide();
    }

    $scope.openSuccessDialog = function (id, event) {
      $mdDialog.show({
        targetEvent: event,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    }

    $scope.cancelLocation = function (addlocationRequestForm, flag) {
      if (flag == 1) {
        $scope.isAddOrSaveLocation = false;
        communicationService.setData('isAddOrSaveLocation', $scope.isAddOrSaveLocation);
        $scope.addLocationInputSearchObject.isInputEmptyCountry = false;
        communicationService.setData('isInputEmptyCountry', $scope.addLocationInputSearchObject.isInputEmptyCountry);
        $scope.addLocationInputSearchObject.isInputEmptyProvince = false;
        communicationService.setData('isInputEmptyProvince', $scope.addLocationInputSearchObject.isInputEmptyProvince);
        $scope.addLocationInputSearchObject.isInputEmptyCity = false;
        communicationService.setData('isInputEmptyCity', $scope.addLocationInputSearchObject.isInputEmptyCity);
        $scope.addLocationInputSearchObject.isInputEmptySector = false;
        communicationService.setData('isInputEmptySector', $scope.addLocationInputSearchObject.isInputEmptySector);
      }
      $scope.isHorizon = false;
      addlocationRequestForm.$setPristine();
      $scope.addLocationInputSearchObject = {};
      $scope.locationRequestType = {};
      $scope.saveOrAddLocationObject = {};
      $scope.saveOrAddLocationObject.countryObj = {};
      $scope.saveOrAddLocationObject.provinceObj = {};
      $scope.saveOrAddLocationObject.cityObj = {};
      $scope.saveOrAddLocationObject.sectorObj = {};
      //To set the form location object in neighborhood canvass form
      $rootScope.setInputObjectAndModel($scope.formInputSearchObject, $scope.formLocationObject);
      $mdDialog.hide();
    };

    $scope.clearOnClose = function (searchKey, dropValue) {
      $scope[searchKey] = undefined;
      $scope[dropValue] = undefined;
      $scope.entityNameLoader = false;
    }

    $scope.setEntityResponseName = function () {
      var sectionKey = $scope.currentSection;
      var formId = $scope.investigationFormId;
      var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey, formId);
      data.then(function (response) {
        if (response != null) {
          if ($scope.currentState == "bithcerticateForm") {
            $scope.setEntityName(response.formDTO.sections[0].questions[0].birthCertificate_1a.answer);
          } else if ($scope.currentState == "birthAndMedicalForm") {
            $scope.setEntityName(response.formDTO.sections[0].questions[0].birthMedical1_1_medical_institution_1.answer);
          } else if ($scope.currentState == "schoolInfoForm") {
            $scope.setEntityName(response.formDTO.sections[0].questions[0].schoolInformation_1_label.answer);
          } else if ($scope.currentState == "religiousInstitutionForm") {
            $scope.setEntityName(response.formDTO.sections[0].questions[0].religiousInstitution_q1_yes_nameofInstitution.answer);
          } else if ($scope.currentState == "dnaInfoForm") {
            $scope.setEntityName(response.formDTO.sections[0].questions[0].dnaInformation_1a_2.answer);
          }
        }
      });
    }

    $scope.setEntityName = function (entityName) {
      if (entityName != null) {
        if ($scope.currentState == "bithcerticateForm" || $scope.currentState == "birthAndMedicalForm" || $scope.currentState == "schoolInfoForm" || $scope.currentState == "religiousInstitutionForm" || $scope.currentState == "dnaInfoForm") {
          $scope.isHide = true;
          $scope.entity.entityName = entityName;
        }
      }
    }

    $scope.searchEntity = function (searchKey, entityTypeId) {
      $scope.entityNameLoader = true;
      if (searchKey && searchKey.length >= 2) {
        var deferred = $q.defer();
        $scope.entityNameList = [];

        var data = LibraryService.getEntityNamesList(searchKey, entityTypeId);
        data.then(function (response) {
          $scope.entityNameLoader = false;
          if (response.length > 0) {
            $scope.isHide = true;
            $scope.entityNameList = response;
            $scope.entity.entityName = searchKey;
          } else {
            $scope.clearEntity();
            $scope.entity.entityName = searchKey;
            $scope.entity.inputSearchText = searchKey;
            $scope.isHide = true;
          }
          deferred.resolve($scope.entityNameList);
        });
        return deferred.promise;
      }
    };

    $scope.getLocationMappingDataById = function (locationMappingId) {
      var locationData = CommonService.getLocationById(locationMappingId);
      locationData.then(function (response) {
        var locationObj = response;

        $scope.entityLocationObject.countryObj = LibraryService.getCountryObj(locationObj);
        $scope.entityLocationObject.provinceObj = LibraryService.getProvinceObj(locationObj);
        $scope.entityLocationObject.cityObj = LibraryService.getCityObj(locationObj);
        $scope.entityLocationObject.sectorObj = LibraryService.getSectorObj(locationObj);
        //Set Location mapping Id edit entity
        $scope.entityLocationObject.countryObj.locationMappingId = locationObj.id;
        $scope.entityLocationObject.provinceObj.locationMappingId = locationObj.id;
        $scope.entityLocationObject.cityObj.locationMappingId = locationObj.id;
        $scope.entityLocationObject.sectorObj.locationMappingId = locationObj.id;

      });
    };

    $scope.getEntityProfileById = function (entityId) {
      if (entityId) {
        var entityProfile = {};
        var data = LibraryService.getEntityProfileById(entityId);
        data.then(function (response) {
          entityProfile = response;
          $scope.entity.contactPersonName = entityProfile.contactPersonName;
          $scope.entity.contactPhoneNumber = entityProfile.contactPhoneNumber;
          $scope.entity.contactEmail = entityProfile.contactEmail;
          $scope.entity.flag = entityProfile.flag;
          $scope.entity.comments = entityProfile.comments;
          $scope.getLocationMappingDataById(entityProfile.locationMappingId);
        });
      }
    };

    $scope.clearEntity = function () {
      var copyEntityType = $scope.entity.entityTypeSearchKey;
      $scope.entity = {};
      $scope.entity.entityName = '';
      //$scope.inputSearchText = '-----';
      $scope.entityNameList = [];
      $scope.libraryAddEntityInputSearchObject = {};
      $scope.entityLocationObject = {};
      $scope.entityLocationObject.countryObj = {};
      $scope.entityLocationObject.provinceObj = {};
      $scope.entityLocationObject.cityObj = {};
      $scope.entityLocationObject.sectorObj = {};
      $scope.entity.entityTypeSearchKey = copyEntityType;
      $scope.isHide = false;
    };

    $scope.getEntityTypeById = function (entityTypeId) {
      angular.forEach($scope.entityTypeList, function (data, key) {
        if (data.id == entityTypeId) {
          $scope.entity.entityTypeSearchKey = data;
        }
      });
    }

    $scope.showEntityProfileById = function (entityId) {
      $scope.entity = {};
      $scope.entityPopupLoader = true;
      var data = LibraryService.getEntityProfileById(entityId);
      data.then(function (response) {
        $scope.entity = response;
        //$scope.entity.entityName = LibraryService.getEntityNameObj($scope.entity);
        $scope.entity.entityName = $scope.entity.name;
        $scope.getLocationMappingDataById($scope.entity.locationMappingId);
        $scope.getEntityTypeById($scope.entity.entityTypeId);
        $scope.entityPopupLoader = false;
      });
    };

    $scope.openEntityDeletePopup = function (ev, id, entityId) {
      $scope.entityId = entityId;
      $mdDialog.show({
        targetEvent: event,
        contentElement: '#' + id,
        parent: angular.element(document.body)
      });
    };

    $scope.deleteEntity = function (entityId) {
      var data = LibraryService.deleteEntity(entityId);
      data.then(function (response) {
        notifications.showSuccess({ message: $scope.APP.LIBRARY.ENTITY_DELETE });
        $state.transitionTo($state.current, $stateParams, {
          reload: true,
          inherit: false,
          notify: true
        });
      }, function (response) {
        notifications.showError({ message: $scope.APP.LIBRARY.ENTITY_DELETE_PROBLEM });
        return reason;
      });
    };

    $scope.changeEditFlag = function () {
      $scope.editFlag = false;
      $scope.updateFlag = true;
      $scope.isHide = true;
    };

    $scope.searchRequestLocation = function (searchText, type) {
      if (searchText && searchText.length >= 2) {
        var deferred = $q.defer();
        $scope.libraryLocObj = {};
        $scope.libraryLocObj.searchKey = searchText;
        if ($scope.addLocationObject) {
          if ($scope.addLocationObject.countryObj && $scope.addLocationObject.countryObj.countryId != null && $scope.addLocationObject.countryObj.countryId != '') {
            $scope.libraryLocObj.countryId = $scope.addLocationObject.countryObj.countryId;
          }
          if ($scope.addLocationObject.provinceObj && $scope.addLocationObject.provinceObj.provinceId != null && $scope.addLocationObject.provinceObj.provinceId != '') {
            $scope.libraryLocObj.provinceId = $scope.addLocationObject.provinceObj.provinceId;
          }
          if ($scope.addLocationObject.cityObj && $scope.addLocationObject.cityObj.cityId != null && $scope.addLocationObject.cityObj.cityId != '') {
            $scope.libraryLocObj.cityId = $scope.addLocationObject.cityObj.cityId;
          }
          if ($scope.addLocationObject.sectorObj && $scope.addLocationObject.sectorObj.sectorId != null && $scope.addLocationObject.sectorObj.sectorId != '') {
            $scope.libraryLocObj.sectorId = $scope.addLocationObject.sectorObj.sectorId;
          }
        }
        $scope.locLoader = true;
        var data = LibraryLocationService.loadAllLocationsByType($scope.libraryLocObj, type);
        data.then(function (response) {
          $scope.locLoader = false;
          if (response.autoSuggestionLocationDTOList) {
            if (type == $scope.APP.LIBRARY.COUNTRY_CAPS) {
              $scope.searchCountryList = response.autoSuggestionLocationDTOList;
            } else if (type == $scope.APP.LIBRARY.PROVINCE_CAPS) {
              $scope.searchProvinceList = response.autoSuggestionLocationDTOList;
            } else if (type == $scope.APP.LIBRARY.CITY_CAPS) {
              $scope.searchCityList = response.autoSuggestionLocationDTOList;
            } else if (type == $scope.APP.LIBRARY.SECTOR_CAPS) {
              $scope.searchSectorList = response.autoSuggestionLocationDTOList;
            }
          }
          if (type == $scope.APP.LIBRARY.COUNTRY_CAPS) {
            deferred.resolve($scope.searchCountryList);
          } else if (type == $scope.APP.LIBRARY.PROVINCE_CAPS) {
            deferred.resolve($scope.searchProvinceList);
          } else if (type == $scope.APP.LIBRARY.CITY_CAPS) {
            deferred.resolve($scope.searchCityList);
          } else if (type == $scope.APP.LIBRARY.SECTOR_CAPS) {
            deferred.resolve($scope.searchSectorList);
          }

        });
        return deferred.promise;
      }
    };


    $scope.setLibraryType = function () {
      $scope.library.libraryType = $state.current.name;
    };

    //Add location Request
    $scope.saveLocation = function (locationObject, addLocationInputSearchObject, entityObj, entity, addNewEntityForm, entityOrLocation) {
      if ((!angular.isUndefinedOrNull(addLocationInputSearchObject.countrySearchKey) && addLocationInputSearchObject.countrySearchKey != "") || (locationObject.countryObj && locationObject.countryObj.countryId)) {

        $scope.locRegTypeValid = false;
        $scope.validationMSGFlagCity = false;
        $scope.validationMSGFlagProvince = false;
        $scope.locationObj = {};
        $scope.isValidLocation = false;
        //$rootScope.loadValid();

        if (locationObject.countryObj && locationObject.countryObj.countryId) {
          $scope.locationObj.countryId = locationObject.countryObj.countryId;
          $scope.locationObj.countryTxt = locationObject.countryObj.countryTxt;
        } else {
          $scope.locationObj.countryTxt = addLocationInputSearchObject.countrySearchKey;
        }

        if (locationObject.provinceObj && locationObject.provinceObj.provinceId) {
          $scope.locationObj.provinceId = locationObject.provinceObj.provinceId;
          $scope.locationObj.provinceTxt = locationObject.provinceObj.provinceTxt;
        } else if (addLocationInputSearchObject.provinceSearchKey != "") {
          $scope.locationObj.provinceTxt = addLocationInputSearchObject.provinceSearchKey;
        } else if (addLocationInputSearchObject.provinceSearchKey == "" || addLocationInputSearchObject.provinceSearchKey == null) {
          $scope.validationMSGFlagProvince = true;
        }

        if (locationObject.cityObj && locationObject.cityObj.cityId) {
          $scope.locationObj.cityId = locationObject.cityObj.cityId;
          $scope.locationObj.cityTxt = locationObject.cityObj.cityTxt;
        } else if (addLocationInputSearchObject.citySearchKey != "") {
          $scope.locationObj.cityTxt = addLocationInputSearchObject.citySearchKey;
          $scope.checkLocationObj('CITY', $scope.locationObj);
        } else if (addLocationInputSearchObject.citySearchKey == "" || addLocationInputSearchObject.citySearchKey == null) {
          $scope.validationMSGFlagCity = true;
        }

        if (locationObject.sectorObj && locationObject.sectorObj.sectorId) {
          $scope.locationObj.sectorId = locationObject.sectorObj.sectorId;
          $scope.locationObj.sectorTxt = locationObject.sectorObj.sectorTxt;
        } else if (addLocationInputSearchObject.sectorSearchKey != "") {
          $scope.locationObj.sectorTxt = addLocationInputSearchObject.sectorSearchKey;
          $scope.checkLocationObj('SECTOR', $scope.locationObj);
        } else if (locationObject.cityObj && locationObject.cityObj.cityId && addLocationInputSearchObject.sector == "" && addLocationInputSearchObject.sectorSearchKey == "") {
          $scope.isValidLocation = true;
        }


        $scope.locationObj.isForm = true;
        if (!$scope.validationMSGFlagProvince) {
          if (!$scope.isValidLocation) {
            if (!$scope.validationMSGFlagCity) {
              $scope.disableSaveButton = true;
              var data = LibraryService.saveNewLocation($scope.locationObj);
              data.then(function (response) {
                $scope.disableSaveButton = false;
                if (response.isApproved && $state.current.name == "neighbourhoodCanvas") {
                  $scope.isValidLocation = true;
                  $timeout(function () {
                    $scope.isValidLocation = false;
                  }, 3000);
                  $scope.disableButton.isDisabled = false;
                } else {
                  $scope.hidePopup();
                  if (entityOrLocation) {
                    $scope.entityObj.locationMappingId = response.id;
                    var data = LibraryService.saveNewEntity($scope.entityObj);
                    data.then(function (response1) {
                      locationObject.countryObj.countryTxt = response.countryTxt;
                      locationObject.cityObj.cityTxt = response.provinceTxt;
                      if ($scope.entityType == $scope.APP.INVESTIGATION.MEDICAL_INSTITUTION) {
                        $rootScope.birthMedicalEntityRequestsent(entity, locationObject, response1);
                      }
                      if ($scope.entityType == $scope.APP.INVESTIGATION.LOCAL_REGISTRY || $scope.entityType == $scope.APP.INVESTIGATION.NATIONAL_REGISTRY) {
                        $rootScope.birthCertificateEntityRequestsent(entity, locationObject, response1);
                      }
                      if ($scope.entityType == $scope.APP.INVESTIGATION.RELIGIOUS_INSTITUTION) {
                        $rootScope.residencyEntityRequestsent(entity, locationObject, response1);
                      }
                      if ($scope.entityType == $scope.APP.INVESTIGATION.SCHOOL) {
                        $rootScope.schoolEntityRequestsent(entity, locationObject, response1);
                      }
                      if ($scope.entityType == $scope.APP.INVESTIGATION.DNA_CENTER) {
                        $rootScope.dnaEntityRequestsent(entity, locationObject, response1);
                      }
                      if (response1.entityExists) {
                        notifications.showSuccess({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_EXISTS });
                      }
                      else {
                        notifications.showSuccess({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_SEND });
                      }
                    }, function (reason) {
                      $scope.disableSaveButton = false;
                      notifications.showError({ message: $scope.APP.LIBRARY.ENTITY_REQUEST_SEND_PROBLEM });
                    });
                    $scope.cancel(addNewEntityForm);
                  }
                  $rootScope.requestSuccess(response);
                  $scope.disableButton.isDisabled = false;

                  if (response.isAlreadyExists && !response.isApproved) {
                    notifications.showSuccess({ message: $scope.APP.LIBRARY.LOCATION_EXISTS });
                  } else {
                    notifications.showSuccess({ message: $scope.APP.LIBRARY.LOCATION_REQUEST_SEND });
                  }
                }

              }, function (reason) {
                $scope.disableButton.isDisabled = false;

                notifications.showError({ message: vm.APP.LIBRARY.LOCATION_REQUEST_SEND_PROBLEM });
              });

            } else {
              addLocationInputSearchObject.isInputEmptyCity = true;
              $timeout(function () {
                addLocationInputSearchObject.isInputEmptyCity = false;
              }, 3000);
            }

          } else {
            $timeout(function () {
              $scope.isValidLocation = false;
            }, 3000);
          }
        } else {
          addLocationInputSearchObject.isInputEmptyProvince = true;
          $scope.validationMSGFlagCity = false;
          $timeout(function () {
            addLocationInputSearchObject.isInputEmptyProvince = false;
          }, 3000);
        }
      }
      else {
        addLocationInputSearchObject.isInputEmptyCountry = true;
        $scope.validationMSGFlagcountry = true;
        $timeout(function () {
          addLocationInputSearchObject.isInputEmptyCountry = false;
        }, 3000);
      }
    };

    $scope.checkLocationObj = function (type, addLocationObj) {
      //Sector Location validation
      if (type == 'SECTOR') {

        if (angular.isUndefinedOrNull(addLocationObj.cityTxt)) {
          $scope.validationMSGFlagCity = true;
        }

        if (angular.isUndefinedOrNull(addLocationObj.provinceTxt)) {
          $scope.validationMSGFlagProvince = true;
        }

      }

      //City Location validation
      if (type == 'CITY') {
        if (angular.isUndefinedOrNull(addLocationObj.provinceTxt)) {
          $scope.validationMSGFlagProvince = true;
        }
      }

    }

    $scope.replaceSelect = function () {
      if ($scope.locationRequestNew.requestTypeName == $scope.APP.LIBRARY.COUNTRY && $scope.locationRequestNew.countryObj == undefined && $scope.requestLocationInputSearchObject.country != null) {
        $scope.locationRequestNew.countryObj = {};
        $scope.requestLocationInputSearchObject.isHideCountry = true;
        $scope.relpaceinputfieldObject.country = true;
        $scope.relpaceinputfieldObject.countryKey = $scope.requestLocationInputSearchObject.country;
        $scope.locationRequestNew.countryObj.countryTxt = $scope.relpaceinputfieldObject.countryKey;
      }

      if ($scope.locationRequestNew.requestTypeName == $scope.APP.LIBRARY.PROVINCE && $scope.locationRequestNew.countryObj && $scope.locationRequestNew.countryObj.countryId != null && $scope.locationRequestNew.provinceObj == undefined && $scope.requestLocationInputSearchObject.province != null) {
        $scope.locationRequestNew.provinceObj = {};
        $scope.requestLocationInputSearchObject.isHideProvince = true;
        $scope.relpaceinputfieldObject.province = true;
        $scope.relpaceinputfieldObject.provinceKey = $scope.requestLocationInputSearchObject.province;
        $scope.locationRequestNew.provinceObj.provinceTxt = $scope.relpaceinputfieldObject.provinceKey;
      }

      if ($scope.locationRequestNew.requestTypeName == $scope.APP.LIBRARY.CITY && $scope.locationRequestNew.countryObj && $scope.locationRequestNew.countryObj.countryId != null && $scope.locationRequestNew.provinceObj && $scope.locationRequestNew.provinceObj.provinceId != null && $scope.locationRequestNew.cityObj == undefined && $scope.requestLocationInputSearchObject.city != null) {
        $scope.locationRequestNew.cityObj = {};
        $scope.requestLocationInputSearchObject.isHideCity = true;
        $scope.relpaceinputfieldObject.city = true;
        $scope.relpaceinputfieldObject.cityKey = $scope.requestLocationInputSearchObject.city;
        $scope.locationRequestNew.cityObj.cityTxt = $scope.relpaceinputfieldObject.cityKey;
      }
      if ($scope.locationRequestNew.requestTypeName == $scope.APP.LIBRARY.SECTOR && $scope.locationRequestNew.countryObj && $scope.locationRequestNew.countryObj.countryId != null
        && $scope.locationRequestNew.provinceObj && $scope.locationRequestNew.provinceObj.provinceId != null
        && $scope.locationRequestNew.cityObj && $scope.locationRequestNew.cityObj.cityId != null
        && ($scope.locationRequestNew.sectorObj.sectorTxt == undefined || $scope.locationRequestNew.sectorObj == null)
        && $scope.requestLocationInputSearchObject.sector != null) {
        $scope.locationRequestNew.sectorObj = {};
        $scope.requestLocationInputSearchObject.isHideSector = true;
        $scope.relpaceinputfieldObject.sector = true;
        $scope.relpaceinputfieldObject.sectorKey = $scope.requestLocationInputSearchObject.sector;
        $scope.locationRequestNew.sectorObj.sectorTxt = $scope.relpaceinputfieldObject.sectorKey;
      }
    }

    angular.isUndefinedOrNull = function (val) {
      return angular.isUndefined(val) || val == ""
    }

    $rootScope.$on('enableAddLocationButton', function () {
			$scope.disableButton.isDisabled = false;
		});

  }

})();


(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('investigationFormSidenav', InvestigationFormSidenav);
    
    function InvestigationFormSidenav () {
		return {
			restrict : 'AE',
			templateUrl : "app/investigation/prospects/profile/investigation-form/investigation.form.sidenav.html",
		};
    }
			
    
})();
(function(){
	'use strict'; 

angular
  .module('lariAidApp')
  .service('investigationFormIndexService', function () {
	  
		  var sectionValue = '';
		  
		  this.setInvestigationValue = function(value) {
			  sectionValue = value;
		  };
	
	     this.getInvestigationValue = function() {
	        return sectionValue;
	     };
	});
})();
(function () {
  "use strict";

  angular.module("lariAidApp").service("InvestigationFormService", InvestigationFormService);

  InvestigationFormService.$inject = ["$resource", "restService", "$q", "$rootScope", "$http", "BASE_URL"];

  function InvestigationFormService($resource, restService, $q, $rootScope, $http, BASE_URL) {
    this.saveInvestigationForm = function (dataObj) {
      var deferred = $q.defer();
      var url = "investigation-form-data/save";
      var data = restService.restCall(dataObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.copyInvestigationFormDetails = function (analystFormId, invFormId, sectionIdList) {
      var deferred = $q.defer();
      var url = "investigation-form-data/copy/" + analystFormId + "/" + invFormId + "?sectionIdList=" + sectionIdList;
      var data = restService.restCall("", url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getInvestigationFormBySectionId = function (sectionKey, formId) {
      var deferred = $q.defer();
      var url = "investigation-form-data/get/" + formId + "?sectionKey=" + sectionKey;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getFormProfileDetails = function (investigationFormId) {
      var deferred = $q.defer();
      var url = "investigation-forms/" + investigationFormId + "/prospect";
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.saveInvestigationFormComment = function (dataObj) {
      var deferred = $q.defer();
      var url = "form-comments/save";
      var data = restService.restCall(dataObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.updateInvestigationFormComment = function (dataObj) {
      var deferred = $q.defer();
      var url = "form-comments/update/";
      var data = restService.restCall(dataObj, url, "PUT");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.deleteInvestigationFormComment = function (commentId) {
      var deferred = $q.defer();
      var url = "form-comments/delete/" + commentId;
      var data = restService.restCall("", url, "DELETE");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.deleteFilesByIndex = function (parentEntityId, entityKey, sectionAccordionIndex) {
      var deferred = $q.defer();
      var url = "assets/delete/" + parentEntityId + "/" + entityKey + "/" + sectionAccordionIndex;
      var data = restService.restCall("", url, "DELETE");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.deleteFiles = function (documentId) {
      var deferred = $q.defer();
      var url = "assets/document/" + documentId;
      var data = restService.restCall("", url, "DELETE");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //To delete multiple assets from the manage attachments popup
    this.deleteAllFiles = function (deleteAssetList) {
      var deferred = $q.defer();
      var url = "assets/document/list";
      var data = restService.restCall(deleteAssetList, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getUploadFiles = function (parentEntityId, entityKey, sectionAccordionIndex, questionKey) {
      var deferred = $q.defer();
      var url = "assets/getListDocument/" + parentEntityId;

      if (entityKey && entityKey != "") {
        url += "?entityKey=" + entityKey;
      }

      if (sectionAccordionIndex != undefined && sectionAccordionIndex != null) {
        url += "&sectionAccordionIndex=" + sectionAccordionIndex;
      }

      if (questionKey != undefined && questionKey != null) {
        url += "&questionKey=" + questionKey;
      }
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.saveInvestigatorResult = function (investigationFormId, ageResult, identityResult, formLanguage) {
      var deferred = $q.defer();
      var url =
        "investigation-form/save-investigator-result/" +
        investigationFormId +
        "?ageResult=" +
        ageResult +
        "&&identityResult=" +
        identityResult +
        "&&formLanguage=" +
        formLanguage;
      var data = restService.restCall("", url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    this.addorSuggestEntityRequest = function (dataObj) {
      var deferred = $q.defer();
      var url =
        "approved-entity-profile-names?searchKey=" + dataObj.searchKey + "&entityTypeKey=" + dataObj.entityTypeKey;
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.saveFamilyPhotoDescriptions = function (uploadFamilyPhotoObj) {
      var deferred = $q.defer();
      var url = "assets/save-asset-descriptions";
      var data = restService.restCall(uploadFamilyPhotoObj, url, "POST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getIndividualAnalystSectionList = function (sectionKey, formId) {
      var deferred = $q.defer();
      var url = "form-section-results/get/" + formId + "?sectionKey=" + sectionKey;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    var saveSectionDeferred = $q.defer();
    this.saveIndividualAnalystSectionList = function (sectionKey, formId, isSaveFormAuditFlag, postCheckList) {
      if (saveSectionDeferred != undefined) {
        saveSectionDeferred.resolve();
        saveSectionDeferred = $q.defer();
      }
      var url =
        "form-section-results/" + formId + "?sectionKey=" + sectionKey + "&isSaveFormAuditFlag=" + isSaveFormAuditFlag;
      var timestamp = new Date().getTime();
      if (url.indexOf("?") != -1) {
        url = url + "&timestamp=" + timestamp;
      } else if (url.indexOf("?") == -1) {
        url = url + "?timestamp=" + timestamp;
      }
      url = BASE_URL + "api/" + url;
      var promise = $http.post(url, postCheckList, { timeout: saveSectionDeferred.promise }).then(function (response) {
        return response.data;
      });
      return promise;
    };

    //Get the location request by requestId
    this.getRequestProfileById = function (reqId) {
      var deferred = $q.defer();
      var url = "location-mappings/isApproved/" + reqId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    //Get the approved entity by entitysId
    this.getApprovedEntityProfile = function (requestedId) {
      var deferred = $q.defer();
      var url = "entity-profiles/isApproved/" + requestedId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };

    this.getFamilyInformationService = function (formId, lang) {
      var deferred = $q.defer();
      var url = "investigation-form-data/get-sibling-details/" + formId + "?langKey=" + lang;
      var data = restService.restCall("", url, "GETLIST");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject("ERROR");
        }
      );
      return deferred.promise;
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('investigationForm', {
            parent: 'profile',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
             'content@': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/investigation.form.header.html',
                    controller: 'InvestigationFormHeaderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {                  
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }                
                    return $translate.refresh();
                }]
            }
        })
    	.state('profileForm', {
            parent: 'investigationForm',
            //url: '/investigationForm',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'invesForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/investigation.form.html',
                    controller: 'InvestigationFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("bithcerticateForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('BirthCertificateController', BirthCertificateController);
    
    BirthCertificateController.$inject = ['$element','$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','BirthCertificateService','$stateParams','$rootScope','InvestigationFormService','$timeout','Upload','$mdDialog','$q','$sessionStorage'];
    function BirthCertificateController ($element,$scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,BirthCertificateService,$stateParams,$rootScope,InvestigationFormService,$timeout,Upload,$mdDialog,$q,$sessionStorage) {
    	var vm = this;
    	vm.dateOfVisit = '';
    	$scope.declarationDate = undefined;
    	vm.profileForm = $stateParams;
    	vm.myDate = new Date();
    	$scope.interviewFlag = true;
    	vm.entityObj = {};
    	vm.entityObj.entityTypeId = [];
    	vm.entityObj.searchKey = {};
    	vm.app = APP;
    	$scope.entityNameSearchKey = {};
    	vm.entityList = [];
    	$scope.loadingBirthCertificate = false;
    	vm.langKey = $cookies.getObject('NG_TRANSLATE_LANG_KEY');
    	$scope.disablesaveflag = false;
    	
    	/**
    	 * To get Current date
    	 */
    	vm.maxDate = new Date(
    	   vm.myDate.getFullYear(),
    	   vm.myDate.getMonth(),
    	   vm.myDate.getDate()
    	 );
    	/*************** Birth Certificate Functional Implementation ****************/
        
        $scope.birthCertificate = {};
        $scope.birthCertificate.sections = [];
        $scope.birthCertificate.sections.questions = [];
        $scope.birthCertificate.summary = {};
        vm.radioButtonFlag = [];
        var oldFormData = {};
        
        
        /* Method name           : collapseAll()
    	 * Method Description 	 : This method is used to collapse the accordion 
		 */
        vm.collapseAll = function(index,flag){
        	 var height = 0;
	            for(var i=0;i<$scope.birthCertificate.sections.length;i++){
		            if(flag==0){
		            	height = height + $('.acc_'+index).closest('.md-accordion').offsetHeight + 42;
		            }
		            else{
		            	height = height + $('.acc_'+index).closest('.md-accordion')[0].offsetHeight + 42;
		            }
		            if(i == index){
		   	             if(!$scope.birthCertificate.sections[i].expanded){
		   	            	 	$scope.formViewCall(index);
				   	            $scope.birthCertificate.sections[i].expanded = !$scope.birthCertificate.sections[i].expanded;
				                $('#birthCertificate').animate({scrollTop: height}, 'slow');
				                
				                //Calling get documents based on accordion index
				                $scope.getUploadFiles(null,vm.app.REF_TERM.BIRTH_CERTIFICATE,index)
		   	             }else{
		   	            	    $scope.birthCertificate.sections[i].expanded = !$scope.birthCertificate.sections[i].expanded;
		   	             }
		            } else {
		            		$scope.birthCertificate.sections[i].expanded = false;
		            	}
		            if($scope.birthCertificate.sections[i].expanded){
		            	if($scope.birthCertificate.sections[i].questions[0] == undefined){
		            		$scope.isApproved=false;
		            	}else{
		            	$scope.isEntityApproved($scope.birthCertificate.sections[i].questions[0].birthCertificate_1a.answerId);
		            	}
	           	    	$scope.openAccordionIndex = i;
	           	    }
	            }
       };
       
       /* Method name           : loadBirthCertificateFormDetails()
        * Method Description 	: This method loads the birth certificate form details
	    */
       vm.loadBirthCertificateFormDetails = function(){
    	   vm.getBirthCertificateDetails();
       };
       
       vm.getBirthCertificateDetails = function(){
		   $scope.entityObj.searchKey = null;
    	   $scope.loadingBirthCertificate = true;
    	   var sectionKey = vm.app.REF_TERM.BIRTH_CERTIFICATE;
		   var formId = $scope.investigationFormId;
    	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
		  	data.then(function(response){
		  		if(response.formVersion != null){
 		  			$scope.formVersion = response.formVersion;
 		  		}
		  		if(response.sectionId != null){
 		  			$scope.birthCertificateSectionId = response.sectionId;
 		  		}
		  		if(response.formDTO == null){
		  		   var tempObj = {};
		     	   tempObj.questions = [];
		     	   $scope.birthCertificate.sections.push(tempObj);
		  		} else if(response.formDTO.sections.length == 0) {
				  	   if(response.formDTO.summary){
						     var tempObj = {};
						  	   tempObj.questions = [];
						  	         $scope.birthCertificate.sections.push(tempObj);
						  	         $scope.birthCertificate.summary = response.formDTO.summary;
				  	   } else {
						  	   var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.birthCertificate.sections.push(tempObj);
				  	   }
		  	    }else {
		  			$scope.birthCertificate = response.formDTO;		  			
		  	    }
		  	   //Set the object to restrict the initial save call
		  		oldFormData = angular.copy(response.formDTO);
		  		$scope.loadingBirthCertificate = false;
		  		$scope.updateLastEditTime(response.updatedOn);
		  		
		   }, function(reason) {
			  return reason;
		   });
       }
       
       /* Method name           : assignDateDiffValue()
        * Method Description     : This method binds the date difference value to difference question
        */
       vm.assignDateDiffValue = function(dateVal,declaredDob){
    	   if(declaredDob){
    		  // var dobDate = declaredDob;
    		   var dobDate = $scope.timzoneFormat(declaredDob);
    	   } else{
    		   var dobDate = new Date($scope.investigationDateOfBirth);
    	   }
    	   vm.trueflag =true;
    	  // var dobDate = new Date($scope.investigationDateOfBirth);
    	   /*var m1 = moment(dobDate,'YYYY-MM-DD');
           var m2 = moment(dateVal,'YYYY-MM-DD');
           dateVal = moment.preciseDiff(m1, m2); 
           if(dateVal == ''){
               dateVal = '0 days'
           }*/
    	   var dateValue = $scope.timzoneFormat(dateVal);
    	   
    	   $scope.dateDiff ={};
    	  
    	   var a = moment(dobDate,'YYYY-MM-DD');
    	   var b = moment(dateValue,'YYYY-MM-DD');
    	   
    	   $scope.years = a.diff(b, 'year');
    	   b.add($scope.years, 'years');

    	   $scope.months = a.diff(b, 'months');
    	   b.add($scope.months, 'months');

    	   $scope.days = a.diff(b, 'days');
    	   
    	   if($scope.years < 0){
    		   $scope.years = $scope.years * (-1);
    	   }
    	   
    	   if($scope.months < 0){
    		   $scope.months = $scope.months * (-1);
    	   }
    	   
    	   if($scope.days < 0){
    		   $scope.days = $scope.days * (-1);
    	   }
    	   $scope.years = $scope.years.toString();
    	   $scope.months = $scope.months.toString();
    	   $scope.days = $scope.days.toString();
       };
       
       /* Method name            : declaredPersonsDob()
        * Method Description     : This method returns the prospect's date of birth to date picker with time zone
        */
       $scope.declaredPersonsDob = function(dateValue,declaredPerson){	
    	   	  if(angular.isUndefined(dateValue) && declaredPerson == 'birth_prospect'){    	  
    	   	  var dob = new Date($scope.investigationDateOfBirth);
    	   	  dob.setMinutes(dob.getMinutes() - dob.getTimezoneOffset());
    	   	  return dob.toISOString();
    	 	  }else{
    	 		  return dateValue;
    	 	  }
       };
       
       /* Method name           : saveBirthCertificateFormDetails()
        * Method Description 	: This method saves the birth certificate form details 
	    */
       $scope.saveBirthCertificateFormDetails = function(){
    	   var isPutJsonSimilar = false;
    	   $rootScope.warningPopup.show = false;  //To avoid showing popup while moving to other section if there is no edit in current section
    	   var saveDataObj = {};
    	   saveDataObj.formDTO = angular.copy($scope.birthCertificate);
    	   saveDataObj.formVersion = $scope.formVersion;
    	   saveDataObj.investigationFormId = $scope.investigationFormId;
    	   saveDataObj.sectionId = $scope.birthCertificateSectionId;
    	   var registry = {};
           for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
               if(!saveDataObj.formDTO.sections[i].questions){
                   saveDataObj.formDTO.sections.splice(i,1);
                   i--;
               } else if(saveDataObj.formDTO.sections[i].questions.length == 0 || (saveDataObj.formDTO.sections[i].questions.length == 1 && 
            		   saveDataObj.formDTO.sections[i].questions[0].birthCertificate_1a.answer == "" && saveDataObj.formDTO.sections[i].questions[0].birthCertificate_1b == null)) {
                   saveDataObj.formDTO.sections.splice(i,1);
                   i--;
               } else{
                   delete saveDataObj.formDTO.sections[i].expanded;
                   saveDataObj.formDTO.sections[i].sortOrder = i+1;
               }
               
           }
           /*	Set the temporary object to avoid unwanted save call. 
     			Fist condition to avoid the initial save call for empty form 
     			Second condition to avoid the initial save call if the section has any form data 
           */
           if(angular.isUndefined($scope.tempBCObj) && ((saveDataObj.formDTO.sections != null && saveDataObj.formDTO.sections[0] != null &&  saveDataObj.formDTO.sections[0].questions != null && 
        		   saveDataObj.formDTO.sections[0].questions.length == 1 && saveDataObj.formDTO.sections[0].questions[0].birthCertificate_1a.answer == "" && 
                   saveDataObj.formDTO.sections[0].questions[0].birthCertificate_1b == null && saveDataObj.formDTO.sections[0].questions[0].birthCertificate1 == null) ||  saveDataObj.formDTO.sections.length == 0) && 
                   (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined) && oldFormData == null) {
               $scope.tempBCObj = angular.copy(saveDataObj);
           } else if(angular.isUndefined($scope.tempBCObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
        	   $scope.tempBCObj = angular.copy(saveDataObj);
           } else if(!angular.isUndefinedOrNull(oldFormData) && (!angular.isUndefinedOrNull(oldFormData.sections) && oldFormData.sections.length > 0) && 
                   (!angular.isUndefined(oldFormData.sections[0].questions) && oldFormData.sections[0].questions.length > 0) && oldFormData.sections[0].questions[0].birthCertificate_1a && 
                   (oldFormData.sections[0].questions[0].birthCertificate_1a.answer == null || oldFormData.sections[0].questions[0].birthCertificate_1a.answer == "") && 
                   angular.isUndefined(oldFormData.sections[0].questions[0].birthCertificate_1b)){
        	   oldFormData.sections = [];       	  
        	   $scope.tempBCObj = {};
        	   $scope.tempBCObj.formDTO = angular.copy(oldFormData);
           } else if(angular.isUndefined($scope.tempBCObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
        	   $scope.tempBCObj = {};
        	   $scope.tempBCObj.formDTO = angular.copy(oldFormData);
           } 
           	 
    	   if(!angular.isUndefined($scope.tempBCObj)){
    		   if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempBCObj.formDTO))){
    			   isPutJsonSimilar = true;    			   
	    		 }
    	   }
    	   if($scope.isOwner){
    		   $scope.tempBCObj = angular.copy(saveDataObj);
    	   } else {
    		   $scope.tempBCObj = undefined; //Every time temporary object will be newly updated for non owner 
    	   }
    	
    	   /* saveData flag - to ensure the save button is clicked in form*/
    	   if(!isPutJsonSimilar) {    		  
    		   if($scope.isOwner || $scope.saveData) {
    			   //Flag to set the section results are edited or not
    			   if(angular.isDefined($scope.birthCertificateCheckList) && angular.isDefined($scope.birthCertificateCheckListTempObj) && !angular.equals($scope.birthCertificateCheckList, $scope.birthCertificateCheckListTempObj)) {
    				   saveDataObj.isFormSectionResultEdited = true;
        			   $scope.saveAnalystFormTypeCheckList('birthCertificate', true, false);
    			   }
    			   else 
    				   saveDataObj.isFormSectionResultEdited = false;
    			   
    			   var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
    			   data.then(function(response) {
    				   if($state.current.name === vm.app.INVESTIGATION.STATE.BIRTH_CERTIFICATE_STATE)
    					   $scope.updateLastEditTime(response.updatedOn);
    				   $scope.uploadFileStatusUpdated();
    			   }, function(reason) {
    				   return reason;
    			   });
    		   }
    		   $rootScope.warningPopup.show = true;
    	   } else if(($scope.isOwner || $scope.saveData) && angular.isDefined($scope.birthCertificateCheckList) && 
    			   angular.isDefined($scope.birthCertificateCheckListTempObj) && !angular.equals($scope.birthCertificateCheckList, $scope.birthCertificateCheckListTempObj)) {
    		   $scope.saveAnalystFormTypeCheckList('birthCertificate', true);
    	   }
       };
       
       /* Method name           : addAdditionalInstitutionForm()
        * Method Description 	: This method adds birth certificate form to list of birth certificate form 
	    */
       vm.addAdditionalInstitutionForm = function(){
           var tempObj = {};
           tempObj.expanded = false;
           tempObj.questions = [];
           $rootScope.notApproved=false;
           $scope.birthCertificate.sections.push(tempObj);
           //For local/National confirmation popup, If new birth certificate added it mu
           vm.radioButtonFlag[$scope.birthCertificate.sections.length-1] = false;
           vm.collapseAll($scope.birthCertificate.sections.length - 1,0);
       };
       
       /* Method name           : removeBirthCertificateForm()
        * Method Description 	: This method removes the added birth certificate form from list of birth certificate form
	    */
      /* vm.removeBirthCertificateForm = function(index){
    	   $scope.birthCertificate.sections.splice(index,1);
       };*/
       vm.removeBirthCertificateForm = function(ev,id,indexValue){
    	   $scope.indexVal = indexValue;  
    	   $mdDialog.show({
    		   contentElement: angular.element('#'+id),
    		   targetEvent: ev,
    		   clickOutsideToClose: false,
    		   escapeToClose: false
    	   })
       };
       
       vm.closeConform = function(index){
    	   $scope.deleteLoader.flag = true;
       	$mdDialog.hide();
       	$scope.birthCertificate.sections.splice(index,1);
       	if(index != 0){
       		vm.collapseAll(index-1,1);
       	}	
        $scope.enableDeleteButton();
       };
       
       vm.closeCancel = function(){
    	   $mdDialog.cancel();
       	   $scope.interviewFlag = true;
       	   $scope.recordFlag = true;
       };
       
      
       /* Method Description 	: This method triggers auto save for birth certificate form */
       $scope.$watch('birthCertificateAutoSave', function(newValue, oldValue) {
    	  if(newValue != undefined && newValue != oldValue){
    		if(newValue && $scope.isOwner){
  					if($scope.formVersion && !$scope.isreadonly){
  						$scope.saveBirthCertificateFormDetails();
  						$rootScope.birthCertificateAutoSave = false;
  					} else{
  						$rootScope.birthCertificateAutoSave = false;
  					}
  				}else{
  					$rootScope.birthCertificateAutoSave = false;
  				}
    		 
			}
		});
       
           vm.interviewFlag = function(flag, index){
          	 $scope.interviewFlag = flag;
          	 if(index){
          		 $scope.sectionIndex = index; 
          	 }
            };
           
           vm.addAdditionalInterviewForm = function(){
               var testObj = {};
               if($scope.interviewFlag == 1){
              	 $scope.birthCertificate.sections[0].questions[0].birthCertificate2b.interviews.push(testObj);
               }
               if($scope.interviewFlag == 2){
              	 if($scope.sectionIndex){
              		 $scope.birthCertificate.sections[$scope.sectionIndex].questions[0].birthCertificate2b.interviews.push(testObj);
              	 }
               }
           };
           
           /* File Upload Sections */
           vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
       		    $("#birthCertificateSectionSummary").val(null);
    	        $('#birthCertificateSectionSummary').trigger('click'); 
    	        $('#birthCertificateSectionSummary').off('change').on('change', function() {
    	        	var file = this.files[0];
        			var sectionId = $scope.birthCertificateSectionId;
        			var questionKey = null;
        			if(isSummary == "true"){
        				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
        			}
        			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.BIRTH_CERTIFICATE);
        			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null);
    	        });
    		};

    		
    			vm.nextInvestigationForm = function(){
    				//$scope.saveAnalystFormTypeCheckList('birthCertificate');    	
    				$scope.disablesaveflag = true;
    				$scope.saveData = true;
    				$scope.saveBirthCertificateFormDetails();
    				//$state.go("birthMedicalRecord");
    				$rootScope.warningPopup.show = false;
    				$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_FORM);
    				if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
    					$scope.collapseAll(1);
    				}
    				$scope.updateLastEditTime(null);
    			};
    		
    		/**
    		 * To find which accordion is open currently
    		 */	
			vm.findOpenform = function(){
	        	 if($scope.birthCertificate.sections.length > 1){
	        		 var j = -1;
	        		 for(var i = 0;i < $scope.birthCertificate.sections.length;i++){
	            		 if($scope.birthCertificate.sections[i].expanded == true){
	            			 return ++i;
	            		 }
	            	 } 
	        		 return j;
	        	 }
	        	 return 1;
	         };
    			
    		/**
    		 * Add the requested Entity
    		 * 
    		 */	
    		$rootScope.birthCertificateEntityRequestsent = function(entity,locationObject,response){
		    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
		    	  var openForm = vm.findOpenform();openForm--;
		    	  if(openForm != -1){
		    		  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1a.answer = entityName;
		    		  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1a.answerId = response.id;
		    		  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1a.requested = true;
		    		  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1b.answerId=response.entityTypeId;
		    		  if(response.entityTypeRefTermKey == vm.app.INVESTIGATION.LOCAL_REGISTRY){
		    			  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1b.answer = vm.app.GLOBAL.LOCAL_REGISTRY;
		    		  }else if(response.entityTypeRefTermKey == vm.app.INVESTIGATION.NATIONAL_REGISTRY){
		    			  $scope.birthCertificate.sections[openForm].questions[0].birthCertificate_1b.answer = vm.app.GLOBAL.NATIONAL_REGISTRY;
		    		  }
		    		  
		    	  }
		    	  document.querySelector('.global-search-input input').value = entityName;
		    	  $scope.selectedtext = entityName;
    		};
    			    			
    			//Method for add or suggest entity
    		    vm.entityRequestSuggest = function(searchKey,entityName,index){
    		    	vm.radioButtonFlag[index] = true;
    		    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
    		   	};

    		   	$scope.radioChangeCheck = function(ev,id,value,index){
    		   			if(vm.radioButtonFlag[index]){
    		   				$scope.radioButtonChange(ev,id,value,index);
    		   			}
    		   	}
    		   	$scope.radioButtonChange = function(ev,id,value,index){
    		   		vm.radioButtonValue = value;
    		   		if(vm.radioButtonFlag[index]){
    		   			if($sessionStorage.selectedLanguage != null){
        	        		vm.selectedLang = $sessionStorage.selectedLanguage;
        	        	}
    		   			vm.currentIndex = index;
		    			$mdDialog.show({
		    	   			 contentElement: angular.element('#'+id),
		    	   		      targetEvent: ev,
		    	   		      clickOutsideToClose:false,
		    	   		      escapeToClose: false,
		    	   		      onShowing: function (event, showPromise) { 
		    	   		    	  vm.yesToProceed = false;
		    	   		   		},
		    	   		      onRemoving: function (event, removePromise) { 
		    	   		    	  if(!vm.yesToProceed){
		    	   		    		  vm.backToOriginalValue(vm.radioButtonValue);
		    	   		    	  }
		    	   		   		}
		    	   		    });
    		   		}
    		   	}
    		   	vm.backToOriginalValue = function(value){
    		   		angular.forEach($scope.birthCertificate.sections,function(data, key) {
    		   			if(data.questions && key == vm.currentIndex){
    		   				angular.forEach(data.questions, function(dataQuestions,key){
    		   					if(dataQuestions.birthCertificate_1b) {
    		   						if(value == vm.app.GLOBAL.LOCAL_REGISTRY){
    		   							dataQuestions.birthCertificate_1b.answer = vm.app.GLOBAL.NATIONAL_REGISTRY;
    		   						 }else if(value == vm.app.GLOBAL.NATIONAL_REGISTRY){
    		   							dataQuestions.birthCertificate_1b.answer = vm.app.GLOBAL.LOCAL_REGISTRY;
    		   						}
    		   					}
    		   				});
    		   			}
    		   		});
    		   		$mdDialog.cancel();
    	    	}
    	    	vm.changeRadioValue = function() {
    	    		vm.yesToProceed = true;
    	    		angular.forEach($scope.birthCertificate.sections,function(data, key) {
    		   			if(data.questions && key == vm.currentIndex){
    		   				angular.forEach(data.questions, function(dataQuestions,key){
    		   					if(dataQuestions.birthCertificate_1a) {
    		   						dataQuestions.birthCertificate_1a = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_2) {
    		   						dataQuestions.birthCertificate_2 = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_2a) {
    		   						dataQuestions.birthCertificate_2a = {};
    		   					}
    		   					if(dataQuestions.birthCertificate2b) {
    		   						dataQuestions.birthCertificate2b = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_3) {
    		   						dataQuestions.birthCertificate_3 = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_3aYes) {
    		   						dataQuestions.birthCertificate_3aYes = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_3aNo) {
    		   						dataQuestions.birthCertificate_3aNo = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_4) {
    		   						dataQuestions.birthCertificate_4 = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_5) {
    		   						dataQuestions.birthCertificate_5 = {};
    		   					}
    		   					if(dataQuestions.birthCertificate_6) {
    		   						dataQuestions.birthCertificate_6 = {};
    		   					}
    		   				});
    		   			}
    		   		});
    	    		$mdDialog.cancel();
    	    	}
    	    	vm.birthInit = function(){
    	    		vm.radioButtonFlag = [];
    	    		angular.forEach($scope.birthCertificate.sections,function(data, key) {
    		   			if(data.questions){
    		   				angular.forEach(data.questions, function(dataQuestions,index){
    		   					if(dataQuestions.birthCertificate_1b != undefined && dataQuestions.birthCertificate_1b != null) {
    		   						vm.radioButtonFlag[key] = true;
    		   					}
    		   					else{
    		   						vm.radioButtonFlag[key] = false;
    		   					}
    		   				});
    		   			}
    		   		});
    	    		
    	    	}
    	    	//vm.birthInit();
    	    	$scope.timzoneFormat = function(date){
    	    		 var dt = new Date(date);
	                 // 'undo' the timezone offset again (so we end up on the original date again)
	                 dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
	                 return dt;
    	    	};
    	    	
    	    	//It will get triggered while exiting from current state
    	    	$scope.$on('$destroy', function() {
    	    		if(!$scope.isreadonly && $scope.isOwner) {
    	    			$scope.saveBirthCertificateFormDetails();
    		   		}
    	    		$rootScope.warningPopup.show = false;   
    	    		$scope.uploadedFile = false;
    	        });
    	        
    	    	//To open the confirmation pop up for remove the additional interview or records
    	    	vm.deleteIndex = function(event,id,index,isInterview){
					$scope.indexVal = index;
					$scope.isInterview = isInterview;
					$scope.interviewFlag = false;
					$scope.recordFlag = false;
					$mdDialog.show({
						contentElement: angular.element('#'+id),
						targetEvent: event,
						clickOutsideToClose: false,
						escapeToClose: false,
						onRemoving: function (event, removePromise) {
							vm.closeCancel();
						}
					});
    	    	};
    	       	
    	    	//To remove the interview content form the form data
    	       	vm.deleteInterviewConfirm = function(index){
    	       		$scope.deleteLoader.flag = true;
    	       		if($scope.birthCertificate.sections.length == 1){
      		  			$scope.openAccordionIndex = 0;
      		  		}
    	       		$scope.birthCertificate.sections[$scope.openAccordionIndex].questions[0].birthCertificate2b.interviews.splice(index,1);
    	       		vm.closeCancel();
    	             $scope.enableDeleteButton();
    	       	};
    	       	
    	       	//To remove the records form the form data
    	       	vm.deleteRecordConfirm = function(index){
    	       		$scope.deleteLoader.flag = true;
    	       		if($scope.birthCertificate.sections.length == 1){
      		  			$scope.openAccordionIndex = 0;
      		  		}
    	       		$scope.birthCertificate.sections[$scope.openAccordionIndex].questions[0].birthCertificate_3aYes.records.splice(index,1);
    	       	    vm.closeCancel();
    	       	    $scope.enableDeleteButton();
    	       	};   	       	    	  
    	    	//It will get triggered while exiting from current state
    	    	$scope.$on('$destroy', function() {
                    if(!$scope.isreadonly && $scope.isOwner) {
    	    			$scope.saveBirthCertificateFormDetails();
    	    		}
                    $rootScope.warningPopup.show = false;
                    $scope.uploadedFile = false;
    	        });
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('BirthCertificateService', BirthCertificateService);

    BirthCertificateService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function BirthCertificateService ($resource,restService,$q,$rootScope) {
    	
    	
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('birthCertificate', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/birthCertificate',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.html',
                    controller: 'BirthCertificateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('investigationQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('investigationQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("bithcerticateForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('BirthMedicalController', BirthMedicalController);
	
	BirthMedicalController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','BirthMedicalService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope'];
	function BirthMedicalController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,BirthMedicalService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope) {
		var vm = this;
		vm.dateOfVisit = '';
    	$scope.declarationDate = undefined;
    	vm.app = APP;
    	
    	$scope.birthMedical = {};
    	$scope.birthMedical.sections = [];
    	$scope.birthMedical.summary = {};
    	$scope.loadingBirthMedical = false;
    	$scope.interviewFlag = true;
    	$scope.recordFlag = true;
    	$scope.disablesaveflag = false;
    	var oldFormData = {};
    	
    	
    	//$scope.birthMedical.sections.questions = [];
    	vm.profileForm = $stateParams;
    	vm.myDate = new Date();
    	
    	/**
    	 * To get Current date
    	 */
    	vm.maxDate = new Date(
    	   vm.myDate.getFullYear(),
    	   vm.myDate.getMonth(),
    	   vm.myDate.getDate()
    	 );
        
    	vm.addAdditionalInstitutionForm = function(){
            var tempObj = {};
            tempObj.expanded = false;
            tempObj.questions = [];
            $scope.notApproved=false;
            $scope.birthMedical.sections.push(tempObj);
            vm.collapseAll($scope.birthMedical.sections.length - 1,0);
        };
    	
        vm.collapseAll = function(index,flag){
        	 var height = 0;
	            for(var i=0;i<$scope.birthMedical.sections.length;i++){
	            if(flag==0){
	            	height = height + $('.acc_'+index).closest('.md-accordion').offsetHeight + 42;
	            }
	            else{
	            	height = height + $('.acc_'+index).closest('.md-accordion')[0].offsetHeight + 42;
	            }
	            if(i == index){
	   	             if(!$scope.birthMedical.sections[i].expanded){
	   	            	 	$scope.formViewCall(index);
			   	            $scope.birthMedical.sections[i].expanded = !$scope.birthMedical.sections[i].expanded;
			                $('#birthMedical').animate({scrollTop: height}, 'slow');
			                
			                //Calling get documents based on accordion index
			                $scope.getUploadFiles(null,vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS,index)
			                
	   	             }else{
	   	            	    $scope.birthMedical.sections[i].expanded = !$scope.birthMedical.sections[i].expanded;
	   	             }
	            } else {
	            		$scope.birthMedical.sections[i].expanded = false;
	            	}
	            if($scope.birthMedical.sections[i].expanded){
	            	if($scope.birthMedical.sections[i].questions[0] == undefined){
	            		$scope.notApproved=false;
	            	}else{
	            	$scope.isEntityApproved($scope.birthMedical.sections[i].questions[0].birthMedical1_1_medical_institution_1.answerId);
	            	}
           	    	$scope.openAccordionIndex = i;
           	    }
	            }
       };
       
       vm.loadBirthMedicalFormDetails = function(){
    	   $scope.loadingBirthMedical = true;
		   vm.getBirthMedicalDetails();
    	  
       };
       
       vm.getBirthMedicalDetails = function(){
		   $scope.entityObj.searchKey = null;
    	   var sectionKey = vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS;
		   var formId = $scope.investigationFormId;
    	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
		  	data.then(function(response){
		  		if(response.formVersion != null){
 		  			$scope.formVersion = response.formVersion;
 		  		}
		  		if(response.sectionId != null){
 		  			$scope.birthMedicalSectionId = response.sectionId;
 		  		}
		  		if(response.formDTO == null){
		  		   var tempObj = {};
		     	   tempObj.questions = [];
		     	   $scope.birthMedical.sections.push(tempObj);
		  		} else if(response.formDTO.sections.length == 0) {
				  	   if(response.formDTO.summary){
						     var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.birthMedical.sections.push(tempObj);
				  	           $scope.birthMedical.summary = response.formDTO.summary;
				  	   } else {
						  	   var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.birthMedical.sections.push(tempObj);
				  	   }
		  	    } else {
		  			$scope.birthMedical = response.formDTO;	  		
		  		}
		  	    //Set the object to restrict the initial save call
		  		oldFormData = angular.copy(response.formDTO);
		  		$scope.loadingBirthMedical = false;
		  		$scope.updateLastEditTime(response.updatedOn);
		   }, function(reason) {
			  return reason;
		   });  
       };
       
       vm.removeBirthAndMedicalForm = function(ev,id,indexValue){
    	   $scope.indexVal = indexValue;  
    	   $mdDialog.show({
    		   contentElement: angular.element('#'+id),
    		   targetEvent: ev,
    		   clickOutsideToClose: false,
    		   escapeToClose: false
    	   })
       };
        
        vm.closeConform = function(index){
        	  $scope.deleteLoader.flag = true;
        	$mdDialog.hide();
        	$scope.birthMedical.sections.splice(index,1);
        	if(index != 0){
           		vm.collapseAll(index-1,1);
           	}
        	 $scope.enableDeleteButton();
        };
        
        vm.closeCancel = function(){
        	$mdDialog.cancel();
        	$scope.interviewFlag = true;
        	$scope.recordFlag = true;
        };
        
        /* Method name           : saveBirthCertificateFormDetails()
         * Method Description 	: This method saves the birth certificate form details 
 	    */
        $scope.saveBirthMedicalFormDetails = function(){
           var isPutJsonSimilar = false;
           $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
     	   var saveDataObj = {};
     	   saveDataObj.formDTO = angular.copy($scope.birthMedical);
     	   saveDataObj.formVersion = $scope.formVersion;
     	   saveDataObj.investigationFormId = $scope.investigationFormId;
     	   saveDataObj.sectionId = $scope.birthMedicalSectionId;
	     	 for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
	              if(!saveDataObj.formDTO.sections[i].questions){
	                  saveDataObj.formDTO.sections.splice(i,1);
	                  i--;
	              } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
	                  saveDataObj.formDTO.sections.splice(i,1);
	                  i--;
	              } else {
	                  delete saveDataObj.formDTO.sections[i].expanded;
	                  saveDataObj.formDTO.sections[i].sortOrder = i+1;
	              }
	          }
	     	
	     	/*	Set the temporary object to avoid unwanted save call. 
	      		Fist condition to avoid the initial save call for empty form 
	      		Second condition to avoid the initial save call if the section has any form data 
	      	*/
	     
            if(angular.isUndefined($scope.tempMedicalObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                    (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                $scope.tempMedicalObj = angular.copy(saveDataObj);
            } else if(angular.isUndefined($scope.tempMedicalObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
         	   $scope.tempMedicalObj = angular.copy(saveDataObj);
            }  else if(angular.isUndefined($scope.tempMedicalObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	$scope.tempMedicalObj = {};
            	$scope.tempMedicalObj.formDTO = angular.copy(oldFormData);
            } 
            
            if(!angular.isUndefined($scope.tempMedicalObj)){
            	if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempMedicalObj.formDTO))){
            		isPutJsonSimilar = true;	    
            	} 	    				
            }
	  
            if($scope.isOwner){
            	$scope.tempMedicalObj = angular.copy(saveDataObj);
            } else {
            	$scope.tempMedicalObj = undefined; //Every time temporary object will be newly updated for non owner 
            }

	      /* saveData flag - to ensure the save button is clicked in form*/
	    	if(!isPutJsonSimilar){	    		
	    		if($scope.isOwner || $scope.saveData){
	    			//Flag to set the section results are edited or not
	    			if(angular.isDefined($scope.birthMedicalCheckList) && angular.isDefined($scope.birthMedicalCheckListTempObj) && !angular.equals($scope.birthMedicalCheckList, $scope.birthMedicalCheckListTempObj)) {
	    				saveDataObj.isFormSectionResultEdited = true;
	    				$scope.saveAnalystFormTypeCheckList('birthMedical', true, false);
	    			}
	    			
	    			var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		  		  	data.then(function(response){
		  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.BIRTH_MEDICAL_STATE)
		  		  		{
		  		  			$scope.updateLastEditTime(response.updatedOn);
		  		  		}
		  		  		$scope.uploadFileStatusUpdated();
		  		  	}, function(reason) {
		  			  return reason;
		  		  	});
	    		}	
	    		 $rootScope.warningPopup.show = true;
            } else if(($scope.isOwner || $scope.saveData) && angular.isDefined($scope.birthMedicalCheckList) && angular.isDefined($scope.birthMedicalCheckListTempObj) 
        			&& !angular.equals($scope.birthMedicalCheckList, $scope.birthMedicalCheckListTempObj)) {
				$scope.saveAnalystFormTypeCheckList('birthMedical', true);
			} 
        };
        
        vm.interviewFlag = function(flag, index){
       	 $scope.interviewFlag = flag;
       	 if(index){
       		 $scope.sectionIndex = index; 
       	 }
         };
        
        vm.addAdditionalInterviewForm = function(){
            var testObj = {};
            if($scope.interviewFlag == 1){
           	 $scope.birthMedical.sections[0].questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.push(testObj);
            }
            if($scope.interviewFlag == 2){
           	 if($scope.sectionIndex){
           		 $scope.birthMedical.sections[$scope.sectionIndex].questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.push(testObj);
           	 }
            }
        };
        vm.nextInvestigationForm = function(){
        	//$scope.saveAnalystFormTypeCheckList('birthMedical');
        	$scope.disablesaveflag = true;
        	$scope.saveData = true;
        	$scope.saveBirthMedicalFormDetails();
        	$rootScope.warningPopup.show = false;
			$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.NEIGHBOURHOOD_CANVASS_FORM);
        	//$state.go("neighbourhoodCanvas");
        	if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(2);
			}
			$scope.updateLastEditTime(null);
		};
		
		 /* File Upload Sections */
		vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
    		$("#birthMedicalSectionSummary").val(null);
 	        $('#birthMedicalSectionSummary').trigger('click'); 
 	       $('#birthMedicalSectionSummary').off('change').on('change', function() {
 	    	    var file = this.files[0];
 	    		var sectionId = $scope.birthMedicalSectionId; 
 	    		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null); 	    		
	        });
 		};

 		
 		/* Method Description 	: This method triggers auto save for birth certificate form */
        $scope.$watch('birthMedicalAutoSave', function(newValue, oldValue) {
          if(newValue != undefined && newValue != oldValue){
        	if(newValue && $scope.isOwner){
 					if($scope.formVersion && !$scope.isreadonly){
 						$scope.saveBirthMedicalFormDetails();
 	 					$rootScope.birthMedicalAutoSave = false;
					} else{
						$rootScope.birthMedicalAutoSave = false;
					}
 				}else{
 					$rootScope.birthMedicalAutoSave = false;
 				}
        	
 			}
 		});
        
        /**
		 * To find which accordion is open currently
		 */	
		vm.findOpenform = function(){
        	 if($scope.birthMedical.sections.length > 1){
        		 var j = -1;
        		 for(var i = 0;i < $scope.birthMedical.sections.length;i++){
            		 if($scope.birthMedical.sections[i].expanded == true){
            			 return ++i;
            		 }
            	 } 
        		 return j;
        	 }
        	 return 1;
         };
        
        /**
		 * Add the requested Entity
		 * 
		 */	
		$rootScope.birthMedicalEntityRequestsent = function(entity,locationObject,response){
	    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
	    	  var openForm = vm.findOpenform();openForm--;
	    	  if(openForm != -1){
	    		  $scope.birthMedical.sections[openForm].questions[0].birthMedical1_1_medical_institution_1.answer = entityName;
	    		  $scope.birthMedical.sections[openForm].questions[0].birthMedical1_1_medical_institution_1.answerId = response.id;
	    		  $scope.birthMedical.sections[openForm].questions[0].birthMedical1_1_medical_institution_1.requested = true;
	    	  }
	    	  document.querySelector('.global-search-input input').value = entityName;
		};
		
      //Method for add or suggest entity
	    vm.entityRequestSuggest = function(searchKey,entityName){
	    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
	   	};
	   	
	   	vm.checkIfFormEdited = function(){
    		$rootScope.warningPopup.show = false;
    		if(angular.isDefined($scope.tempMedicalObj) && 
    		angular.isDefined(oldFormData) && !angular.equals(oldFormData,$scope.tempMedicalObj)){
    			$rootScope.warningPopup.show = true;
    		}
    	}
	   	
	    //It will get triggered while exiting from current state
	   	$scope.$on('$destroy', function() {
	   		if(!$scope.isreadonly && $scope.isOwner) {
	   			$scope.saveBirthMedicalFormDetails();
	   		}
	   		$rootScope.warningPopup.show = false;
	   		$scope.uploadedFile = false;
        });
	   	
	   	//To open the confirmation pop up for remove the additional interview or records
    	vm.deleteIndex = function(event,id,index,isInterview){
			$scope.indexVal = index;
			$scope.isInterview = isInterview;
			$scope.interviewFlag = false;
			$scope.recordFlag = false;
           	$mdDialog.show({
       			  contentElement: angular.element('#'+id),
       		      targetEvent: event,
       		      clickOutsideToClose: false,
       		      escapeToClose: false,
       		      onRemoving: function (event, removePromise) {
    		    	  vm.closeCancel();
	   		   		}
       		    });
    	};
       	
    	//To remove the interview content form the form data
       	vm.deleteInterviewConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.birthMedical.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.birthMedical.sections[$scope.openAccordionIndex].questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.splice(index,1);
       	    vm.closeCancel();
       	 $scope.enableDeleteButton();
       	};
       	
       	//To remove the records form the form data
       	vm.deleteRecordConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.birthMedical.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.birthMedical.sections[$scope.openAccordionIndex].questions[0].birth_medical_record_list.records.splice(index,1);
       	 vm.closeCancel();
       	 $scope.enableDeleteButton();
       	};
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('BirthMedicalService', BirthMedicalService);

    BirthMedicalService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function BirthMedicalService ($resource,restService,$q,$rootScope) {
    	
    	
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('birthMedicalRecord', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/birthMedicalReport',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.information.html',
                    controller: 'BirthMedicalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('birthMedicalQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('birthMedicalQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("birthAndMedicalForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('InvestigationFormCommentController', InvestigationFormCommentController);
    
    InvestigationFormCommentController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','$stateParams','$rootScope','InvestigationFormService','$timeout','$sce'];
    function InvestigationFormCommentController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,$stateParams,$rootScope,InvestigationFormService,$timeout,$sce) {
    	
    	/* Method name           : saveOrUpdateComment()
   	 	 * Method Description 	 : This method is used to save/update question comment
		 */
	   	$scope.saveOrUpdateComment = function(comment){
	   		if(!$scope.isContentEmpty(comment)) {
	   			var validatedComment=$scope.validation(comment);
	   			$scope.modelName = validatedComment;	
	   		} else {
	   			$scope.modelName = "";
	   		}
	   	};
	   	
	   	$scope.isContentEmpty = function(inputValue) {
	   		var plainText;
	   		var tempVal;

	   		if(inputValue != undefined){
	   			plainText = inputValue.replace(/<\/?[^>]+(>|$)/g, "");  
	   			plainText = plainText.replace(/&nbsp;/g, "");
	   			plainText = plainText.replace(/ /g, "");
	   			tempVal = plainText.replace(/[\n\r]/g,"");
	   			if(tempVal == '') plainText = tempVal
	   		}

	   		if (plainText == undefined || plainText == '') {
	   			return true;
	   		} else {
	   			return false;
	   		}
	   	};
	   	$scope.validation = function(inputComment){
	   		inputComment=inputComment.replace(/(:)[a-z]{1,4}(\([0-9a-z\(\-\\*\s\)\.]*\))/g,":16px");
	   		return inputComment;
	   	};
	   	$scope.removeComment = function(commentId){
	   		
	   		if(commentId) {
	   			var data = InvestigationFormService.deleteInvestigationFormComment(commentId);
	   		}
	   		if(data){
   				data.then(function(response){
	 		  		$scope.cmtId = response.id;
	 		    }, function(reason) {
	 			  return reason;
	 		   });
   			}
	   		$scope.modelName = "";
	   	};
	   	$rootScope.openAutocomplete=function(index){
 		   setTimeout(function(){
 		       angular.element('#'+index).find('input').focus();
 		   },0);
 };

	   		
		$scope.showOrHideComment = function(){
			$scope.showComment = !$scope.showComment;
		}
	   		
		   	$scope.trustAsHTML = function(htmlContent){
		   		return $sce.trustAsHtml(htmlContent);
		   		
		   	}
    }
    
})();
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('investigationComment', function()
    	{
	    	return {
				restrict : 'AE',				
				templateUrl: 'app/investigation/prospects/profile/investigation-form/comment-directive/investigationform.comment.html',
				controller: 'InvestigationFormCommentController',
				scope :{
					modelName : '=modelValue',
					cmtId : '=commentId',
					formId : '@',
					questionKey : '@',
					sectionId : '@',
					reqValue : '=reqVal',
					readOnly : '@',
					indexval : '@',
					parentindex : '@'
				},
				link: function(scope, element, attrs, ngModel) {
					if(scope.readOnly == 'false'){
						if(!scope.reqValue){
							if (scope.modelName && !angular.equals(scope.modelName,{})){
								scope.showComment = true;
							} else {
								scope.showComment = false;
							}
						}
					} else{
						if(scope.modelName && !angular.equals(scope.modelName,{})){
							scope.showDisableComment = true;
						} else {
							scope.showDisableComment = false;
						}
					}
					
				}
			};
    	});
    
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('DNAInformationController', DNAInformationController);
	
	DNAInformationController.$inject = ['$scope','$window','$mdSidenav','Principal','$sessionStorage','StorageDelete','$state','$mdMedia','$cookies','APP','DNAInformationService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope'];
	function DNAInformationController ($scope,$window,$mdSidenav,Principal,$sessionStorage,StorageDelete,$state,$mdMedia,$cookies,APP,DNAInformationService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope) {
		
		var vm = this;
		vm.app = APP;
		$scope.dna = {};
		$scope.dna.sections =[];
		vm.profileForm = $stateParams;
    	vm.myDate = new Date();
    	var oldFormData = {};
		$scope.disableDnaSaveButton = {};
		$scope.disableDnaSaveButton.isDisabled = false;
		$scope.nullDateOfTest = false;
    	$scope.nullDateOfTestRecived = false;
		$scope.nullDnaCenterId = false;
    	
    	/**
    	 * To get Current date
    	 */
    	vm.maxDate = new Date(
    	   vm.myDate.getFullYear(),
    	   vm.myDate.getMonth(),
    	   vm.myDate.getDate()
    	 );
		
    	vm.loadDNAFormDetails = function(){
    		$scope.loadingDNA = true;
			vm.getDNAinformation();
     	   
        };
		
		/* Method name           : $scope.enableSave
    	 * Method Description 	 : This method is used to save validation in DNA form 
		 * @author Dinesh Sekar
		 */
		$scope.enableSave = function (field, value) {
			if (field == "dnaTestInThisCase") {
				if (value != null && value != undefined) {
				  $scope.disableDnaSaveButton.isDisabled = false;
				  $scope.nullDateOfTest = false;
    	          $scope.nullDateOfTestRecived = false;
		          $scope.nullDnaCenterId = false;
				}
			  }
			if (field == "dnaConducted") {
				if (value != null && value != undefined) {
					$scope.disableDnaSaveButton.isDisabled = false;
					$scope.nullDateOfTest = false;
					$scope.nullDateOfTestRecived = false;
					$scope.nullDnaCenterId = false;
				}
			}  
			if (field == "dnaTest") {
			  if (value != null && value != undefined) {
				$scope.disableDnaSaveButton.isDisabled = false;
			  }
			}
			if (field == "dnaCenter") {
			  if (value != null && value != undefined) {
				$scope.disableDnaSaveButton.isDisabled = false;
			  }
			}
			if (field == "dnaTestRecived") {
			  if (value != null && value != undefined) {
				$scope.disableDnaSaveButton.isDisabled = false;
			  }
			}
		  };
         
    	vm.getDNAinformation = function(){
			$scope.entityObj.searchKey = null;
  		   var sectionKey = vm.app.REF_TERM.DNA;
	     	   var formId = $scope.investigationFormId;
      	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
  		  	data.then(function(response){
  		  		if(response.formVersion != null){
   		  			$scope.formVersion = response.formVersion;
   		  		}
	  		  	if(response.sectionId != null){
		  			$scope.dnaFormSectionId = response.sectionId;
		  		}
  		  		if(response.formDTO == null){
  		  		   var tempObj = {};
  		     	   tempObj.questions = [];
  		     	   $scope.dna.sections = [];
  		     	   $scope.dna.sections.push(tempObj);
  		  		} else if(response.formDTO.sections.length == 0) {
				  	   if(response.formDTO.summary){
					     var tempObj = {};
					  	   tempObj.questions = [];
			  	           $scope.dna.sections.push(tempObj);
			  	           $scope.dna.summary = response.formDTO.summary;
  				  	   } else {
  						  	   var tempObj = {};
  						  	   tempObj.questions = [];
  				  	           $scope.dna.sections.push(tempObj);
  				  	   }
	  		  	} else {
  		  			$scope.dna = response.formDTO;  		  			
  		  		}
  		  	    //Set the object to restrict the initial save call
		  		oldFormData = angular.copy(response.formDTO);
  		  		$scope.loadingDNA = false;
  		  		
		  		$scope.updateLastEditTime(response.updatedOn);
		  		
  		   }, function(reason) {
  			  return reason;
  		   });
  	   
    	};
    	vm.removeDNAForm = function(ev,id,indexValue){
    		$scope.indexVal = indexValue;
    		$mdDialog.show({
    			contentElement: angular.element('#'+id),
    			targetEvent: ev,
    			clickOutsideToClose: false,
    			escapeToClose: false
    		})
    	};
	       
	        vm.closeConform = function(index){
	        	$mdDialog.hide();
	        	$scope.dna.sections.splice(index,1);
	        	 vm.collapseAll(index-1,1);
	        };
	        
	        vm.closeCancel = function(){
	        	$mdDialog.cancel();
	        };
	       
	       /* Method name           : collapseAll()
	    	 * Method Description 	 : This method is used to collapse the accordion 
			 */
	        vm.collapseAll = function(index,flag){
	        	 var height = 0;
		            for(var i=0;i<$scope.dna.sections.length;i++){
		            if(flag==0){
		            	height = height + $('.acc_'+index).closest('.md-accordion').offsetHeight + 42;
		            }
		            else{
		            	height = height + $('.acc_'+index).closest('.md-accordion')[0].offsetHeight + 42;
		            }
		            if(i == index){
		   	             if(!$scope.dna.sections[i].expanded){
				   	            $scope.dna.sections[i].expanded = !$scope.dna.sections[i].expanded;
				                $('#dnaInformation').animate({scrollTop: height}, 'slow');
		   	             }else{
		   	            	    $scope.dna.sections[i].expanded = !$scope.dna.sections[i].expanded;
		   	             }
		            } else {
		            		$scope.dna.sections[i].expanded = false;
		            	}
		            }
	       };
	       vm.addAdditionalDNAForm = function(){
	            var tempObj = {};
	            tempObj.expanded = false;
	            tempObj.questions = [];
	            $scope.notApproved=false;
	            $scope.dna.sections.push(tempObj);
	            vm.collapseAll($scope.dna.sections.length - 1,0);
	        };
	       vm.nextInvestigationForm = function(){	        	
	        	//$scope.saveAnalystFormTypeCheckList('birthMedical');
	    	    $scope.saveData = true;
				var saveDataObj = {};
				saveDataObj.formDTO = angular.copy($scope.dna);
				//For DNA CR vaildate the required field in this method while save the DNA form
				if (
					saveDataObj.formDTO.sections[0].questions[0] != undefined && saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1.answer ==
				  "answer_yes"
				) {
					if(saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_1.answer!=null)

					{
						saveDataObj.dateOfTest = saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_1.answer;
					}else
					{
						saveDataObj.dateOfTest = null;
					}
					if(saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_2.answerId!=null)
					{
						saveDataObj.dnaCenterId = saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_2.answerId;
					}else
					{
						saveDataObj.dnaCenterId = null;
					}
					if(saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_9.answer!=null)
					{
						saveDataObj.dateOfTestRecived = saveDataObj.formDTO.sections[0].questions[0].dnaInformation_1a_9.answer;
					}else
					{
						saveDataObj.dateOfTestRecived = null;
					}			
				  if (
					(saveDataObj.dateOfTest != null ||
					  saveDataObj.dateOfTest != undefined) &&
					(saveDataObj.dnaCenterId != null ||
					  saveDataObj.dnaCenterId != undefined) &&
					(saveDataObj.dateOfTestRecived != null ||
					  saveDataObj.dateOfTestRecived != undefined)
				  ) {
					$scope.saveDNAFormDetails();
					//$state.go("residencyQuestions");
					$rootScope.warningPopup.show = false;
					$scope.sectionNavigationFunc(
					  vm.app.INVESTIGATION_FORM.RESIDENCY_FORM
					);
					$scope.updateLastEditTime(null);
				  } else {
					if (
					  saveDataObj.dateOfTest == null ||
					  saveDataObj.dateOfTest == undefined
					) {
					  $scope.nullDateOfTest = true;
					}
					if (
					  saveDataObj.dnaCenterId == null ||
					  saveDataObj.dnaCenterId == undefined
					) {
					  $scope.nullDnaCenterId = true;
					}
					if (
					  saveDataObj.dateOfTestRecived == null ||
					  saveDataObj.vdateOfTestRecived == undefined
					) {
					  $scope.nullDateOfTestRecived = true;
					}
					$scope.disableSaveButton.isDisabled = true;
				  }
				} else {
	    	    $scope.saveDNAFormDetails();	        	
	        	//$state.go("residencyQuestions");
	    	    $rootScope.warningPopup.show = false;
				$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.RESIDENCY_FORM);
				$scope.updateLastEditTime(null);
				}
			};
			/* Method name           : saveDNAFormDetails()
	         * Method Description 	 : This method saves DNA form details 
	 	    */
	        $scope.saveDNAFormDetails = function(){
	           var isPutJsonSimilar = false;
	           $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
	     	   var saveDataObj = {};
	     	   saveDataObj.formDTO = angular.copy($scope.dna);
	     	   saveDataObj.formVersion = $scope.formVersion;
	     	   saveDataObj.investigationFormId = $scope.investigationFormId;
	     	   saveDataObj.sectionId = $scope.dnaFormSectionId;
		     	 for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
		              if(!saveDataObj.formDTO.sections[i].questions){
		                  saveDataObj.formDTO.sections.splice(i,1);
		                  i++;
		              } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
		                  saveDataObj.formDTO.sections.splice(i,1);
		                  i++;
		              } else {
		                  delete saveDataObj.formDTO.sections[i].expanded;
		                  saveDataObj.formDTO.sections[i].sortOrder = i+1;
		              }
		          }
		     	
		     	 /*	 Set the temporary object to avoid unwanted save call. 
	      			 Fist condition to avoid the initial save call for empty form 
	      			 Second condition to avoid the initial save call if the section has any form data 
		     	 */
                 if(angular.isUndefined($scope.tempDNAObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                         (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                     $scope.tempDNAObj = angular.copy(saveDataObj);
                 } else if(angular.isUndefined($scope.tempDNAObj) && angular.equals(saveDataObj.formDTO, oldFormData)) {
              	   $scope.tempDNAObj = angular.copy(saveDataObj);
                 } else if(angular.isUndefined($scope.tempDNAObj) && !angular.equals(saveDataObj.formDTO, oldFormData)) {
                	 $scope.tempDNAObj = {};
                	 $scope.tempDNAObj.formDTO = angular.copy(oldFormData);
                 }
		     	 
                 if(!angular.isUndefined($scope.tempDNAObj)){
                	 if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempDNAObj.formDTO))){
                		 isPutJsonSimilar = true;		    			
                	 } 
                 }
                 if($scope.isOwner){
                	 $scope.tempDNAObj = angular.copy(saveDataObj);
                 } else {
                	 $scope.tempDNAObj = undefined; //Every time temporary object will be newly updated for non owner 
                 }

		     	 /*saveData flag - to ensure the save button is clicked in form*/
		    	if(!isPutJsonSimilar){
		    		if($scope.isOwner || $scope.saveData){
		    			var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
			  		  	data.then(function(response){
			  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.DNA_INFORMATION_STATE)
			  		  		{
			  		  			$scope.updateLastEditTime(response.updatedOn);
			  		  		}
			  		  		$scope.uploadFileStatusUpdated();
			  		  	}, function(reason) {
			  			  return reason;
			  		  	});
		    		}
		    		$rootScope.warningPopup.show = true;
		    	}
	        };
	        
	 		 /* File Upload Sections */
	        
	        vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
	    		$("#dnaSectionSummary").val(null);
	 	        $('#dnaSectionSummary').trigger('click'); 
	 	        $('#dnaSectionSummary').off('change').on('change', function() {
	 	        	var file = this.files[0];
		 	   		var sectionId = $scope.dnaFormSectionId;
		 	   		$scope.setOrginSectionFileUpload(vm.app.REF_TERM.DNA);
		 	   	    $scope.uploadFileInSectionSummary(ev,file,vm.app.INVESTIGATION_FORM.SUMMARY_KEY,sectionId,isSummary);
	 	        });
	 		};
	 		
	 		$rootScope.warningPopup.show = false;	
	 		/* Method Description 	: This method triggers auto save for birth certificate form */
	        $scope.$watch('dnaAutoSave', function(newValue, oldValue) {
	 			if(newValue != undefined && newValue != oldValue){	 		
	 				if(newValue && $scope.isOwner){	 					
		 					if($scope.formVersion && !$scope.isreadonly){
		 						$scope.saveDNAFormDetails();
			 					$rootScope.dnaAutoSave = false;
							} else{
								$rootScope.dnaAutoSave = false;
							}
		 				}else{
		 					$rootScope.dnaAutoSave = false;
		 				}	 				
	 			}
	 		});
	        
	        /**
			 * Add the requested Entity
			 * 
			 */	
			$rootScope.dnaEntityRequestsent = function(entity,locationObject,response){
		    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
		    	  	  $scope.dna.sections[0].questions[0].dnaInformation_1a_2.answer = entityName;
		    		  $scope.dna.sections[0].questions[0].dnaInformation_1a_2.answerId = response.id;
		    		  $scope.dna.sections[0].questions[0].dnaInformation_1a_2.requested = true;
		    	  document.querySelector('.global-search-input input').value = entityName;
			};
	        
	      //Method for add or suggest entity
		    vm.entityRequestSuggest = function(searchKey,entityName){
		    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
		   	};
		   	
		    //It will get triggered while exiting from current state
		   	$scope.$on('$destroy', function() {
		   		if(!$scope.isreadonly && $scope.isOwner) {
		   			$scope.saveDNAFormDetails();
		   		}
		   		$rootScope.warningPopup.show = false;
		   		$scope.uploadedFile = false;
		   	});
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('DNAInformationService', DNAInformationService);

    DNAInformationService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function DNAInformationService ($resource,restService,$q,$rootScope) {
    	
    }
    
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('dnaInformation', {
            parent: 'profileForm',
            url: '/:investigationFormId/dnaInformation',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/dna-information/dna.information.html',
                    controller: 'DNAInformationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dnaInformationQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dnaInformationQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("dnaInfoForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('FamilyInformationController', FamilyInformationController);
	
	FamilyInformationController.$inject = ['$scope','$window','$mdSidenav','Principal','$sessionStorage','StorageDelete','$state','$mdMedia','$cookies','APP','FamilyInformationService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope','$sce','deviceDetector'];
	function FamilyInformationController ($scope,$window,$mdSidenav,Principal,$sessionStorage,StorageDelete,$state,$mdMedia,$cookies,APP,FamilyInformationService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope,$sce,deviceDetector) {
		
		var vm = this;
		vm.app = APP;
		vm.media = $mdMedia;
       $scope.familyInformation = {};
       vm.siblingsCount = 1;
	   vm.familyMembersCount = 0;
       //$scope.familyInformation.photo.questions=[];
       $scope.familyInformation.sections =[];
       $scope.familyInformation.summary = {};
       var oldFormData = {};
       $scope.siblingsSelectAll = {};
       var fromAlert=false;
       $scope.disablesaveflag = false;
       vm.familyInformationSectionPhoto = "familyInformationSectionPhoto";
       vm.familyPhotos = "familyPhotos";

       vm.removingMember = {};
        
       vm.profileForm = $stateParams;
       $scope.loadingFamilyInfo = false;
       
       vm.relationTypeList = [
                              {
                            	  "value":"Aunt"
                              },
                              {
                            	  "value":"Grandfather"
                              },
                              {
                            	  "value":"Grandmother"
                              },
                              {
                            	  "value":"Guardian"
                              },
                              {
                            	  "value":"Step-parent"
                              },
                              {
                            	  "value":"Uncle"
                              },{
                            	  "value":"Others"
                              }
                              ];
       
        $scope.familyMember = [
             	            {
             		    		"id":"0",
             		    		"value":"Father"
             		    	},
             		    	{
             		    		"id":"1",
             		    		"value":"Mother"
             		    	},
             		    	{
             		    		"id":"2",
             		    		"value":"Prospect"
             		    	},
             		    	{
             		    		"id":"3",
             		    		"value":"Siblings"
             		    	}
             	        ];
      
 	   $scope.familyMember[0].expanded = true;
 	           
 	   vm.collapseAll = function(index,flag){
     	    var height = 0;
     	    var value;
	     	   if(index.value && index.value == 'PFM' && index.id > 3){
	     		    value = index.id;
	     	    }else if(index.value){
	     	        value = index.id;
	     	    }else{
	     	        value = index;
	     	    }
	            for(var i=0;i<$scope.familyMember.length;i++){
		            if(flag==0){
		            	height = height + $('.acc_'+value).closest('.md-accordion').offsetHeight + 70;
		            }
		            else{
		            	height = height + $('.acc_'+value).closest('.md-accordion')[0].offsetHeight + 70;
		            }
		            if(i == value){
		   	             if(!$scope.familyMember[i].expanded){
		   	            	    $scope.formViewCall(value);
				   	            $scope.familyMember[i].expanded = !$scope.familyMember[i].expanded;
				                $('#familyInformation').animate({scrollTop: height}, 'slow');
				                
				                //Calling get documents based on accordion index
				                $scope.getUploadFiles(null,vm.app.REF_TERM.FAMILY_INFORMATION,value);
		   	             }else{
		   	            	    $scope.familyMember[i].expanded = !$scope.familyMember[i].expanded;
		   	             }
		            } else {
		            	  
		            		$scope.familyMember[i].expanded = false;
		            	}
	            }
       };
 	   
 	   
        vm.loadFamilyInformationDetails = function(){
        	$scope.loadingFamilyInfo = true;
        		vm.getFamilyInformationDetails();
          
        };
        
        vm.getFamilyInformationDetails = function(){
        	 var sectionKey = vm.app.REF_TERM.FAMILY_INFORMATION;
        	   var formId = $scope.investigationFormId;
        	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
    		  	data.then(function(response){
    		  		if(response.formVersion != null){
    		  			$scope.formVersion = response.formVersion;
    		  		}
    		  		if(response.sectionId != null){
    		  			$scope.familyInfoSectionId = response.sectionId;
    		  		}
    		  		if(response.formDTO == null){
	      		  		for(var i=0;i<$scope.familyMember.length;i++){
	      	            	var tempObj = {};
	      	                tempObj.questions=[];
	      	                $scope.familyInformation.sections[i] = tempObj;
	      	                $scope.familyInformation.sections[i].sortOrder = i+1;
	      	                if($scope.familyMember[i].value != vm.app.GLOBAL.SIBLINGS){
	      	                	 $scope.familyInformation.sections[i].type = "PFM";
	      	                } else {
	      	                	 $scope.familyInformation.sections[i].type = vm.app.GLOBAL.SIBLINGS;
	      	                }
	      	            }
	      		  		$scope.familyInformation.photo = {};
	      		  		$scope.familyInformation.photo.questions = [];
	      		  		vm.add = 0;
    		  		} 
    		  		else {
    		  		   $scope.familyMember = [];
    		  			$scope.familyInformation = angular.copy(response.formDTO);
    		  			for(var i=0,s=1,f=1;i<response.formDTO.sections.length;i++){
    		  				var familyTempObj = {};
    		  				familyTempObj.id = i;
    		  				familyTempObj.value = response.formDTO.sections[i].type;
    		  				$scope.familyMember.push(familyTempObj);
	      		  			$scope.familyMember[i].id = i;
		  			    	if($scope.familyMember[i].value == vm.app.GLOBAL.SIBLINGS){
		  	    	        	$scope.familyMember[i].sortOrder = s;
		  	    	        	vm.siblingsCount = s;s++;
		      	        	}
		  			    	if($scope.familyMember[i].value == 'PFM' && $scope.familyMember[i].id != 0  && $scope.familyMember[i].id != 1  && $scope.familyMember[i].id != 2){
		  	    	        	$scope.familyMember[i].sortOrder = f;
		  	    	        	vm.familyMembersCount = f;f++;
		      	        	}
    		  			}
    		  		   $scope.familyMember[0].expanded = true;
    		  		    //$scope.familyMember.push(response.formDTO.sections);
    		  		    vm.add = 1;
    		  			if(response.formDTO.photo == null){
	      		  			$scope.familyInformation.photo = {};
	          		  		$scope.familyInformation.photo.questions = [];
    		  			}
    		  			if(response.formDTO.sections.length == 0){
    		  				if(response.formDTO.summary){
   						     var tempObj = {};
   						  	   tempObj.questions = [];
   				  	           $scope.familyInformation.sections.push(tempObj);
   				  	           $scope.familyInformation.summary = response.formDTO.summary;
	   				  	    } else {
	   						  	   var tempObj = {};
	   						  	   tempObj.questions = [];
	   				  	           $scope.familyInformation.sections.push(tempObj);
	   				  	   }
    		  			}
    		  			//Set the object to restrict the initial save call
    		  			//oldFormData = angular.copy($scope.familyInformation);
    		  			
    		  		}
    		  		oldFormData = angular.copy($scope.familyInformation);
    		  		if(response.formDTO == null || response.formDTO.summary == null) {
    		  			oldFormData.summary = {};
    		  			oldFormData.summary.question = "familyInformation_summary_comment";
    		  		}
    		  		$scope.loadingFamilyInfo = false;
    		  		var indexValue = vm.app.REF_TERM.FIVE_HUNDRED_AND_ONE;
    		  		angular.forEach($scope.familyMember, function(data, key) {
    	 				  if(data.id > 3 && data.value == "PFM") {
    	 					  data.index = indexValue;
    	 					  indexValue++;
    	 				  }
    	 			  });
    		  		$scope.updateLastEditTime(response.updatedOn);
    		  		
    		   }, function(reason) {
    			  return reason;
    		   });
        };
        
        vm.familyMemberCount = 0;
        vm.addfamilyInfoForm = function(PFMorSiblings){
        	var testObj = {};
        	var max = 0;
	        testObj.questions = [];	       
	        testObj.expanded = true;
        	 if(PFMorSiblings == vm.app.GLOBAL.SIBLINGS){
         		vm.siblingsCount++;
         		for(var i=0;i<$scope.familyMember.length;i++){
         			$scope.familyMember[i].expanded = true;
    	        	if($scope.familyMember[i].value == vm.app.GLOBAL.SIBLINGS){
    	        		max = $scope.familyMember[i].id; 	
    	        	}
    	        }max++;
    	        testObj.type = PFMorSiblings;
    	        $scope.familyInformation.sections.splice(max,0,testObj);
    	        var tempObj = {};
    	        tempObj.id = max;
    	        tempObj.value = PFMorSiblings;
    	        tempObj.sortOrder = vm.siblingsCount;
    	        tempObj.expanded = false;
    	       /* if($scope.familyMember[max].expanded){
    	        	$scope.familyMember[max].id = max + 1;
    	        	$scope.familyMember[max].value = "PFM";
    	        	$scope.familyMember[max].expanded = false;
    	        }*/
    	        $scope.familyMember.splice(max,0,tempObj);
    	        for(var i=0;i<$scope.familyMember.length;i++){
    	        	$scope.familyMember[i].id = i;   	
    	        }
    	        vm.collapseAll(max, 0);
         	}else if(PFMorSiblings ==  vm.app.GLOBAL.PFM){
         		vm.familyMembersCount++;
         		testObj.type = PFMorSiblings;
         		var temp = $scope.familyMember.length;
    	        $scope.familyInformation.sections.push(testObj);
    	        var tempObj = {}; 
    	        tempObj.id = temp;
    	        tempObj.value = PFMorSiblings;
    	        tempObj.sortOrder = vm.familyMembersCount;
    	        tempObj.index = vm.app.REF_TERM.FIVE_HUNDRED + vm.familyMembersCount;
    	        $scope.familyMember.push(tempObj);    
    	        vm.collapseAll($scope.familyInformation.sections.length - 1, 0);
         	}
	         
	        //vm.checkIndex('add'); 
        };
        /**
         * 
         * It imports data froom BC to Family informations
         * 
         */
        vm.importedSibblings;
        vm.siblingPopupButtonClick= function(){
        
        		$scope.disableConfirm = true;
	        	var sibItr=0;
	        	var max;
	        	var selectedList = [];
	        	var numberOfSiblingsAdded=0;
	        	
	        	angular.forEach(vm.dataList, function(data, key){
	        		if(data.selected == true){
	        			selectedList.push(data);
	        		}
	        	});
	        	        	
	        	angular.forEach($scope.familyInformation.sections, function(data, index){
	        		if(data.type == vm.app.GLOBAL.SIBLINGS){
		        		max = $scope.familyMember[index].id; 	
		        	}
	        	})
	        	
	        	//Add the new sibling if the last sibling 
	        	angular.forEach(selectedList, function(data, index){
	        		if($scope.familyInformation.sections[max].questions.length == 0 && index==0){}
	        		else {
	        			vm.addfamilyInfoForm(vm.app.GLOBAL.SIBLINGS);
	        		}
	        	});
	        	//Replace the last sibling if the sibling details are empty and create the 
		        angular.forEach($scope.familyInformation.sections, function(data,index){
		        	if($scope.familyInformation.sections[index].type == vm.app.GLOBAL.SIBLINGS){
		        		if(index >= max && $scope.familyInformation.sections[index].questions.length == 0 && sibItr < selectedList.length )
		        		{
	       				    $scope.familyInformation.sections[index].questions = selectedList[sibItr].questions;
	       				 sibItr++;
		        		}
		        	}
		        });
	        	
		        vm.closeCancel();
				
				/**
				 * This conditions are use to have a record of "is Sibling Imported Already?" it stores the flag as a subanser in familyInformation_prospect_1_2 of
				 * the familyInformation object and make a save call.
				 */
				if ($scope.familyInformation.sections[0].questions.length == 0){				
					$scope.familyInformation.sections[0].questions = [];
					$scope.familyInformation.sections[0].questions[0] = {};
					$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2 = {};
					$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2.subAnswer = vm.app.GLOBAL.SIBLINGIMPORTED;
					$scope.saveFamilyInformationDetails();
				} else if (!$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2) {				
					$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2 = {};
					$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2.subAnswer = vm.app.GLOBAL.SIBLINGIMPORTED;
					$scope.saveFamilyInformationDetails();
				} else if ($scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2) {				
					$scope.familyInformation.sections[0].questions[0].familyInformation_prospect_1_2.subAnswer = vm.app.GLOBAL.SIBLINGIMPORTED;
					$scope.saveFamilyInformationDetails();
				} 
        	
        }
                
        vm.removefamilyInfoForm = function(ev,id,member){
        	vm.removingMember = member;
        	$mdDialog.show({
        		contentElement: angular.element('#'+id),
        		targetEvent: ev,
        		clickOutsideToClose: false,
        		escapeToClose: false
        	})
        };
	       
	       vm.closeConform = function(members){   
	    	   $scope.deleteLoader.flag = true;
	    	   if(members.value == vm.app.GLOBAL.SIBLINGS){
	        		vm.siblingsCount--;    		
	        	}else if(members.value == vm.app.GLOBAL.PFM){
	        		vm.familyMembersCount--;	
	        	}
		    	for(var i=0;i<$scope.familyMember.length;i++){
	   	        	if($scope.familyMember[i].id == members.id){
	   	        		 $scope.familyMember.splice(members.id, 1);
	  			    	 $scope.familyInformation.sections.splice(members.id,1);
	   	        	}
	   	        }
			    for(var i=0,s=1,f=1;i<$scope.familyMember.length;i++){
			    	$scope.familyMember[i].id = i;
			    	if($scope.familyMember[i].value == vm.app.GLOBAL.SIBLINGS){
	    	        	$scope.familyMember[i].sortOrder = s;s++;
    	        	}
			    	if($scope.familyMember[i].value == vm.app.GLOBAL.PFM && $scope.familyMember[i].id != 0  && $scope.familyMember[i].id != 1  && $scope.familyMember[i].id != 2){
	    	        	$scope.familyMember[i].sortOrder = f;f++;
    	        	}
    	        }
			    //vm.checkIndex('del'); 
			    $mdDialog.hide();
			    $scope.enableDeleteButton();
			    var index = 1;
			    angular.forEach($scope.familyInformation.sections, function(item){
    				item.sortOrder = index;
    				index++;
			    });
	       };
	       
	       vm.closeCancel = function(){
	    	   $mdDialog.cancel();
	    	   //Set the selected sibling count
	    	   vm.numberOfSiblingsAdded = 0;
	       };
        
	       /* Method name           : saveFamilyInformationDetails()
	        * Method Description 	: This method saves the family form details 
	 	    */
	       $scope.saveFamilyInformationDetails = function(){
		       var isPutJsonSimilar = false;
		       $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
	      	   var saveDataObj = {};
	      	   saveDataObj.formDTO = angular.copy($scope.familyInformation);
	      	   saveDataObj.formVersion = $scope.formVersion;
	      	   saveDataObj.investigationFormId = $scope.investigationFormId;
	      	   saveDataObj.sectionId = $scope.familyInfoSectionId;
	      	    var saveDataObjSiblingsCount = angular.copy(vm.siblingsCount);  
	      	    
                // Index should starts from 3, because Father, Mother, Prospect, Siblings accordions should present compulsory. 
	      	   for(var i=3;i<saveDataObj.formDTO.sections.length;i++){   
	      		   if(!saveDataObj.formDTO.sections[i].questions){
	      			   saveDataObj.formDTO.sections.splice(i,1);
	      			   i--;
	      		   } else if(saveDataObj.formDTO.sections[i].questions.length == 0 && saveDataObj.formDTO.sections[i].type == vm.app.GLOBAL.SIBLINGS && saveDataObjSiblingsCount > 1) {
	      			   saveDataObj.formDTO.sections.splice(i,1); //Empty Sibling accordions were removed while saving if its count was greater than 1
	      			   saveDataObjSiblingsCount--;
	      			   i--;
	      		   } else if(saveDataObj.formDTO.sections[i].questions.length == 0 &&   saveDataObj.formDTO.sections[i].type == vm.app.GLOBAL.PFM) {
	      			  saveDataObj.formDTO.sections.splice(i,1); //Empty Family Member accordions were removed while saving
	      			  i--;
	      		   }else {
	      			   //delete saveDataObj.formDTO.sections[i].expanded;
	      			   saveDataObj.formDTO.sections[i].sortOrder = i+1; 
	      		   }
	      	   }
      	   
	      	   /*	Set the temporary object to avoid unwanted save call. 
	      			Fist condition to avoid the initial save call for empty form 
	      			Second condition to avoid the initial save call if the section has any form data 
	      	   */	      	   
               if(angular.isUndefined($scope.tempFamilyObj) && saveDataObj.formDTO.sections.length == 4 && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData)) && 
            		   saveDataObj.formDTO.sections[0].questions.length == 0 && 
                       saveDataObj.formDTO.sections[1].questions.length == 0 && saveDataObj.formDTO.sections[2].questions.length == 0 && 
                       saveDataObj.formDTO.sections[3].questions.length == 0 && saveDataObj.formDTO.photo.questions.length == 0 &&
                       (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                   $scope.tempFamilyObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempFamilyObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempFamilyObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempFamilyObj) && !angular.isUndefined(oldFormData) && !angular.isUndefined(oldFormData.sections) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))){
            	          var oldFormDataSiblingsCount = 0;           	 
            	   angular.forEach(oldFormData.sections,function(element){
            		   if (element.type == vm.app.GLOBAL.SIBLINGS){
            			   oldFormDataSiblingsCount++; // Count of Sibling accordions from old data in db
            		   }
            	   });
            	// Index should starts from 3, because Father, Mother, Prospect, Siblings accordions should present compulsory.
            	   for(var i=3;i<oldFormData.sections.length;i++){
    	      		   if(!oldFormData.sections[i].questions){
    	      			  oldFormData.sections.splice(i,1);	 
    	      			  i--;   	      			  
    	      		   } else if(oldFormData.sections[i].questions.length == 0 && oldFormData.sections[i].type == vm.app.GLOBAL.SIBLINGS && oldFormDataSiblingsCount > 1) {
    	      			  oldFormData.sections.splice(i,1); //Empty Sibling accordions were removed in old data from db if its count was greater than 1
    	      			  oldFormDataSiblingsCount--;
    	      			  i--;
    	      		   } else if(oldFormData.sections[i].questions.length == 0 && oldFormData.sections[i].type == vm.app.GLOBAL.PFM) {
    	      			  oldFormData.sections.splice(i,1);  //Empty Family Member accordions were removed in old data from db 
    	      			  i--;
    	      		   } 
    	      		   else{   	
    	      			  oldFormData.sections[i].sortOrder = i+1; 
    	      		   }
    	      	   }
            	   $scope.tempFamilyObj = {};
            	   $scope.tempFamilyObj.formDTO = angular.copy(oldFormData);    	      	   
               } else if(angular.isUndefined($scope.tempFamilyObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempFamilyObj = {};
            	   $scope.tempFamilyObj.formDTO = angular.copy(oldFormData);
               } 
               if(!angular.isUndefined($scope.tempFamilyObj)){
	    		   if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempFamilyObj.formDTO))){
	    			   isPutJsonSimilar = true;	    			
	    		   }
	    	   }

               if($scope.isOwner){
	    	       $scope.tempFamilyObj = angular.copy(saveDataObj);
               } else {
            	   $scope.tempFamilyObj = undefined; //Every time temporary object will be newly updated for non owner  
               }
               
               /* saveData flag - to ensure the save button is clicked in form*/
	    	   if(!isPutJsonSimilar){
	    		   if($scope.isOwner || $scope.saveData){
	    			   //Flag to set the section results are edited or not
	    			   if(angular.isDefined($scope.familyCheckList) && angular.isDefined($scope.familyCheckListTempObj) && !angular.equals($scope.familyCheckList, $scope.familyCheckListTempObj)) {
	    				   saveDataObj.isFormSectionResultEdited = true;
	    				   $scope.saveAnalystFormTypeCheckList('family', true, false);
	    			   }
	    			   
	    			   var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
			   		  	data.then(function(response){
			  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.FAMILY_INFORMATION_STATE)
			  		  		{
			  		  			$scope.updateLastEditTime(response.updatedOn);
			  		  		}
			  		  		$scope.uploadFileStatusUpdated();
			   		  }, function(reason) {
			   			  return reason;
			   		  });
	    		   }
	    		   $rootScope.warningPopup.show = true;
	    	   } else if(($scope.isOwner || $scope.saveData) && angular.isDefined($scope.familyCheckList) && angular.isDefined($scope.familyCheckListTempObj)
	    			   && !angular.equals($scope.familyCheckList, $scope.familyCheckListTempObj)) {
				   $scope.saveAnalystFormTypeCheckList('family', true);
			   }
         };
         
         /* File Upload Sections */
         
         vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
     		$("#familyInformationSectionSummary").val(null);
  	        $('#familyInformationSectionSummary').trigger('click'); 
  	        $('#familyInformationSectionSummary').off('change').on('change', function() {
	  	    	var file = this.files[0];
	     		var sectionId = $scope.familyInfoSectionId;
	     		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.FAMILY_INFORMATION);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,'summary',idName,accordionIndex,idName,null);
	        });
  		};
    
         vm.nextInvestigationForm = function(){
        	//$scope.saveAnalystFormTypeCheckList('family');
        	 $scope.disablesaveflag = true;
        	$scope.saveData = true;
        	$scope.saveFamilyInformationDetails(); 
        	if($scope.uploadFileSectionFamilyPhotoList && $scope.uploadFileSectionFamilyPhotoList.length > 0){
            	vm.saveFamilyPhotoSectionDescription($scope.uploadFileSectionFamilyPhotoList[0].uploadList);
        	}
        	$rootScope.warningPopup.show = false;
			$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.SCHOOL_FORM);
        	//$state.go("schoolInformation");
        	if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(4);
			}
			$scope.updateLastEditTime(null);
 		 };
 		 
 		vm.familyPhotoUploadFileForSummary = function(id,idName,ev){
      		$("#familyPhotoSectionSummary").val(null);
   	        $('#familyPhotoSectionSummary').trigger('click'); 
   	        $('#familyPhotoSectionSummary').off('change').on('change', function() {
   	        	var file = this.files[0];
   	      		var sectionId = $scope.familyInfoSectionId;
   	      		var questionKey = vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO;
   	      	    $scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,false,id,idName); // as the family photo section is not a summary section, the boolean isSumamry is set to false 
	        });
   		};
   		
   		$scope.attachedPhotoRemove = function(event,answer,id){
   			if($scope.uploadFileSectionFamilyPhotoList[0]){
   				if(answer == vm.app.GLOBAL.ANSWER_NO && $scope.uploadFileSectionFamilyPhotoList[0].uploadList.length > 0){
   					$mdDialog.show({                   
   						targetEvent: event,
   						contentElement: '#'+id,
   						parent: angular.element(document.body),
   						clickOutsideToClose: false,
   						escapeToClose: false,
   	   	                onShowing: function (event, showPromise) { 
		   		    	  vm.yesToProceed = false;
		   		   		},
   	   	                onRemoving: function (event, removePromise) { 
   	   	                	if(!vm.yesToProceed){
   	   	                		vm.gobacktoForm();
   	   	                	}
   	   	                }
   	   	           });
   	   			}
   				else{
   					vm.yesToProceed = true;
   				}
   			}	
   			
   			//To remove NO comments while switching to Yes under family info questions.
   			if(answer == vm.app.GLOBAL.ANSWER_YES){
   				if($scope.familyInformation != null && $scope.familyInformation.photo.questions[0] != null && $scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1 != null && 
   	        			$scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1.comment != null && $scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1.comment.comment != null ){
   	        		 $scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1.comment.comment = "";
   	        	}
   			}
   		};
   		
   		vm.setRemovalFlag = function(){
   			vm.yesToProceed = true;
   		};
   		
   		$rootScope.warningPopup.show = false;
   		// Method Description 	: This method triggers auto save for birth certificate form 
        $scope.$watch('familyInfoAutoSave', function(newValue, oldValue) {
 			if(newValue != undefined && newValue != oldValue){ 				
 				if(newValue && $scope.isOwner){ 				
 	 					if($scope.formVersion && !$scope.isreadonly){
 	 						$scope.saveFamilyInformationDetails();
 	 						vm.saveFamilyPhotoSectionDescription($scope.uploadFileSectionFamilyPhotoList[0].uploadList);
 	 	 					$rootScope.familyInfoAutoSave = false;
 						} else{
 							$rootScope.familyInfoAutoSave = false;
 						}
 	 				}else{
 	 					$rootScope.familyInfoAutoSave = false;
 	 				} 				
 			}
 		});
        
        vm.gobacktoForm = function(){	
			$scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer = 'answer_yes';
			$mdDialog.cancel();
		};
		
		vm.saveFamilyPhotoSectionDescription = function(uploadFamilyPhotoObj){
			 var isPutJsonSimilar = false;
			 var savePhotoObj = {};
			 if(uploadFamilyPhotoObj != undefined && uploadFamilyPhotoObj != null && uploadFamilyPhotoObj.length > 0){
			     savePhotoObj =  angular.copy($scope.uploadFileSectionFamilyPhotoList[0].uploadList);
			 }
	      
			 angular.forEach(savePhotoObj, function(item){
	                if(!angular.isUndefined(item.isSelected)){
	                           delete item.isSelected;
	                }});
			 
			 if(!angular.isUndefined($scope.tempFamilyPhotoObject) && !angular.isUndefined(savePhotoObj) && savePhotoObj.length > 0){
				 if(angular.equals(savePhotoObj, $scope.tempFamilyPhotoObject)){
					 isPutJsonSimilar = true;
				 }
			 } else {
				 isPutJsonSimilar = true;
			 }
             if($scope.isOwner) {
    	    	 $scope.tempFamilyPhotoObject = angular.copy(savePhotoObj);
             }
             
	    	 if(!isPutJsonSimilar){
	    		 if($scope.isOwner || $scope.saveData){
		    		 var data = InvestigationFormService.saveFamilyPhotoDescriptions(uploadFamilyPhotoObj);
		    		 data.then(function(response){
		    		 });
	    		 }
	    		 $rootScope.warningPopup.show = true;
	    	 }
        };
        
        //It will get triggered while exiting from current state
        $scope.$on('$destroy', function() {
        	if(!$scope.isreadonly && $scope.isOwner) {
        		$scope.saveFamilyInformationDetails();
        	}
        	$rootScope.warningPopup.show = false;
        	$scope.uploadedFile = false;
        });
        
        $scope.trustAsHTML = function(htmlContent){
	   		return $sce.trustAsHtml(htmlContent);
	   	}
        
        vm.setFamilyPhotoValue = function() {
        	if(angular.isDefined($scope.familyInformation) && angular.isDefined($scope.familyInformation.photo) && $scope.familyInformation.photo.questions.length > 0 &&
        	       	$scope.familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer == vm.app.GLOBAL.ANSWER_NO) {
        		vm.yesToProceed = true;
        	}
        };
        
        vm.openimportFamilyPopup = function(event,popupId) {
        	vm.dataList = [];
        	if($sessionStorage.selectedLanguage == vm.app.GLOBAL.ES) {
        		vm.language = true;
        	} else {
        		vm.language = false;
        	}
        	if(deviceDetector.raw.browser.firefox) {
        		vm.isFireFox = true;
        	} else {
        		vm.isFireFox = false;
        	}
        	
        	$scope.notselected = true;
        	$scope.siblingsSelectAll.checked = false;
        	vm.contentWaitForResponse=true;
        	var formId = $scope.investigationFormId;
        	
        	if(vm.language != undefined){
        		 var lang = vm.language;
        	}
        	var dataList = InvestigationFormService.getFamilyInformationService(formId,lang);
        	dataList.then(function(response) {
        		vm.dataList = response;
        		vm.contentWaitForResponse=false;

        		angular.forEach(vm.dataList, function(item){
        			item.selected = false;
                	
        		}); 
        	});
        	vm.popupShow(event,popupId);
        }
        
        $scope.selectedCount = function(){
        	vm.numberOfSiblingsAdded=0;
        	vm.selectedSiblings='';
        	angular.forEach(vm.dataList, function(data, key){
        		if(data.selected == true){
            		vm.numberOfSiblingsAdded++;
        		}
        	});

        }
        $scope.toggleSelect = function(){
        	var notselected = true;
        	var isSelected = true;
        	
        	
        	angular.forEach(vm.dataList, function(item){
        		if(!item.selected){
        			isSelected = false;
        		}else{
        			notselected = false;
        		}
    		}); 
			$scope.notselected = notselected;
        	$scope.siblingsSelectAll.checked = isSelected;
        	$scope.selectedCount();
        }
        
        vm.selectAll = function(){
        	if($scope.siblingsSelectAll.checked){
        		$scope.notselected = true;
        		angular.forEach(vm.dataList, function(item){
        			item.selected = false;
        		});
        	}else{
        		$scope.notselected = false;
        		angular.forEach(vm.dataList, function(item){
        			item.selected = true;
        		});
        	}
        	$scope.selectedCount();
        };
        /**
         * 
         *  alert dialoge to import siblings
         * 
         */
        vm.popupShow = function(event, popupId){
        	if(!fromAlert){
        		vm.numberOfSiblingsAdded=0;        		
        	}  
        	fromAlert=false;
        	$mdDialog.show({
				contentElement: angular.element('#' + popupId),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false
			});
        }
        vm.siblingImportAlert = function(event,alertId) {
        	$scope.disableConfirm = false;
        	$mdDialog.show({
				contentElement: angular.element('#' + alertId),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false
			});
        }
        vm.hideSiblingImportAlert = function(event,alertId,popupId) {
        	fromAlert=true;
        	vm.popupShow(event,popupId);
        	$mdDialog.hide({
				contentElement: angular.element('#' + alertId),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false
			});
        }

	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('FamilyInformationService', FamilyInformationService);

    FamilyInformationService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function FamilyInformationService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('familyInformation', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/familyInformation',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/family-information/family.information.html',
                    controller: 'FamilyInformationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('familyInformationQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('familyInformationQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("familyInfoForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';

    angular
        .module('lariAidApp').directive('formLocationFilter',locationDropFilter);
    
    function locationDropFilter(){
			return {
			    templateUrl: 'app/investigation/prospects/profile/investigation-form/location-directive/form.locationdirective.html',
				controller:'FormLocationDirectiveController',
			    transclude:true,
				replace: true,
			    restrict: 'E',
				scope:{
					modelObject: '=modelObject',
					call: '&',
					horizon: '=horizonFlag',
					validation:'=validationRequired',
					addNewLocation:'=?',
					isRequested:'=?',
					formName:'=formName',
					isValidation:"=",
					savevalid: '&',
					inputsearchObject: '=inputsearchObject',
					disableFlag: '=disableFlag',
					ishideObject:'=ishideObject',
					relpaceinputfield: '&',
					relpaceinputfieldObject:'=relpaceinputfieldObject',
					media: '=media',
					addnewlocationObject: '=addnewlocationObject'
				},
			    link: function(scope, element, attrs) {
			    }
		    }
			
		}
    
})();
(function () {
  "use strict";

  angular.module("lariAidApp").controller("FormLocationDirectiveController", FormLocationDirectiveController);

  FormLocationDirectiveController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "$stateParams",
    "$mdSidenav",
    "$element",
    "APP",
    "tabservice",
    "$mdMedia",
    "LibraryLocationService",
    "$q",
    "$timeout",
    "$sessionStorage",
    "communicationService"
  ];

  function FormLocationDirectiveController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $mdSidenav,
    $element,
    APP,
    tabservice,
    $mdMedia,
    LibraryLocationService,
    $q,
    $timeout,
    $sessionStorage,
    communicationService
  ) {
    var vm = this;
    vm.countrychange = {};
    vm.provincechange = {};
    vm.citychange = {};
    vm.sectorchange = {};
    vm.country = {};
    vm.country1 = {};
    vm.province = {};
    vm.province1 = {};
    vm.city = {};
    vm.city1 = {};
    vm.sector = {};
    vm.sector1 = {};
    vm.APP = APP;
    vm.library = $stateParams;
    vm.media = $mdMedia;
    vm.locationList = [];
    vm.loadingData = false;
    vm.addnewlocationObject = {};
    $scope.searchLocationCountryList = [];
    $scope.searchLocationProvinceList = [];
    $scope.disableButton = {};
    $scope.searchLocationCityList = [];
    $scope.searchLocationSectorList = [];
    $scope.locLoader = false;
    //$scope.modelObject = {};
    $scope.addNewLocation;
    $scope.isRequested;
    /*$scope.inputsearchObject = {  
              "country": "",
              "countrySearchKey": "",
              "isAddOrSaveLocationCountry": false,
              "isAddOrSaveLocationProvince": false,
              "isAddOrSaveLocationCity": false,
              "isAddOrSaveLocationSector": false,
              "citySearchKey": "",
              "sectorSearchKey": "",
              "provinceSearchKey": "",
              "province": "",
              "city": "",
              "sector": ""};*/

    $scope.currentState = $state.current.name;

    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });

    $scope.checkRequiredFields = function (modelName, fieldId) {
      var result = false;
      if ($scope.modelObject[modelName] && $scope.modelObject[modelName][fieldId]) {
        result = true;
      }
      return true;
    };

    $scope.searchLocation = function (searchText, type, delayCall) {
      if (searchText && searchText.length >= 2) {
        $scope.inputsearchObject.isInputEmptyCountry = false;
        var deferred = $q.defer();
        $scope.libraryLocObj = {};
        $scope.libraryLocObj.searchKey = searchText;
        if (type == 'COUNTRY') {
          $scope.modelObject.countryObj = {};
          $scope.validateLocationId(type);
          $scope.existingSearchLocation(type);
          $scope.inputsearchObject.isAddOrSaveLocationCountry = ($scope.cleanInputValue) ? true : false;//To clear the Country Field while searching
        } else if (type == 'PROVINCE') {
          $scope.modelObject.provinceObj = {};
          $scope.validateLocationId(type);
          $scope.existingSearchLocation(type);
          $scope.inputsearchObject.isAddOrSaveLocationProvince = ($scope.cleanInputValue) ? true : false;//To clear the Province Field while searching 
        } else if (type == 'CITY') {
          $scope.modelObject.cityObj = {};
          $scope.validateLocationId(type);
          $scope.existingSearchLocation(type);
          $scope.inputsearchObject.isAddOrSaveLocationCity = ($scope.cleanInputValue) ? true : false;//To clear the City Field while searching
        } else if (type == 'SECTOR') {
          $scope.modelObject.sectorObj = {};
          $scope.inputsearchObject.isAddOrSaveLocationSector = ($scope.cleanInputValue) ? true : false;//To clear the Sector Field while searching
        }
        if ($scope.modelObject) {
          if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryId != null) {
            $scope.libraryLocObj.countryId = $scope.modelObject.countryObj.countryId;
          }
          if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId != null) {
            $scope.libraryLocObj.provinceId = $scope.modelObject.provinceObj.provinceId;
          }
          if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId != null) {
            $scope.libraryLocObj.cityId = $scope.modelObject.cityObj.cityId;
          }
          if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId != null) {
            $scope.libraryLocObj.sectorId = $scope.modelObject.sectorObj.sectorId;
          }
        }
        if (communicationService.getData('isAddOrSaveLocation')) {
          if (type == 'COUNTRY' && $scope.currentStatevalid != "locations") {
            if ($scope.inputsearchObject.country) {
              $scope.locLoader = true;
              var data = LibraryLocationService.loadAllLocationsByType($scope.libraryLocObj, type);
              data.then(function (response) {
                $scope.locLoader = false;
                if (response.autoSuggestionLocationDTOList.length > 0) {
                  if (type == 'COUNTRY') {
                    $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
                    if (communicationService.getData('isAddOrSaveLocation')) {
                      $scope.inputsearchObject.countrySearchKey = '';
                      $scope.inputsearchObject.isInputEmptyCountry = false;
                      $scope.inputsearchObject.isInputEmptyProvince = false;
                      $scope.inputsearchObject.isInputEmptyCity = false;
                      $scope.inputsearchObject.isInputEmptySector = false;
                      $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
                    }
                  } else if (type == 'PROVINCE') {
                    $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
                  } else if (type == 'CITY') {
                    $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
                  } else if (type == 'SECTOR') {
                    $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
                  }
                } else {
                  if (type == 'COUNTRY') {
                    $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
                  } else if (type == 'PROVINCE') {
                    $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
                  } else if (type == 'CITY') {
                    $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
                  } else if (type == 'SECTOR') {
                    $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
                  }
                  $scope.loadNewInputFields(type, searchText);
                }
                if (type == 'COUNTRY') {
                  deferred.resolve($scope.searchLocationCountryList);
                } else if (type == 'PROVINCE') {
                  deferred.resolve($scope.searchLocationProvinceList);
                } else if (type == 'CITY') {
                  deferred.resolve($scope.searchLocationCityList);
                } else if (type == 'SECTOR') {
                  deferred.resolve($scope.searchLocationSectorList);
                }
              });
              return deferred.promise;
            } else {
              $scope.loadNewInputFields(type, searchText);
            }
          } else {
            $scope.getListCall(type, searchText);
          }
        } else {
          $scope.getListCall(type, searchText, delayCall);
        }
      }
    };

    $scope.loadNewInputFields = function (type, searchText) {
      if (type == 'COUNTRY') {
        $scope.inputsearchObject.countrySearchKey = searchText;
        $scope.inputsearchObject.country = searchText;
        $scope.inputsearchObject.isAddOrSaveLocationCountry = true;
        vm.addnewlocationObject.country = true;
        vm.addnewlocationObject.province = true;
        vm.addnewlocationObject.city = true;
        vm.addnewlocationObject.sector = true;
        $scope.inputsearchObject.countryAltered = true;

        if (!$scope.inputsearchObject.isInputEmptySector && !$scope.inputsearchObject.isInputEmptyCity && !$scope.inputsearchObject.isInputEmptyProvince) {
          $scope.inputsearchObject.isAddOrSaveLocationSector = true;
          $scope.inputsearchObject.sectorAltered = true;
          $scope.inputsearchObject.isAddOrSaveLocationCity = true;
          $scope.inputsearchObject.cityAltered = true;
          $scope.inputsearchObject.isAddOrSaveLocationProvince = true;
          $scope.inputsearchObject.provinceAltered = true;
        } else {
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
          $scope.inputsearchObject.sectorAltered = false;
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.cityAltered = false;
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
          $scope.inputsearchObject.provinceAltered = false;
        }

      } else if (type == 'PROVINCE') {
        $scope.inputsearchObject.provinceSearchKey = searchText;
        $scope.inputsearchObject.province = searchText;
        $scope.inputsearchObject.isAddOrSaveLocationProvince = true;
        vm.addnewlocationObject.province = true;
        vm.addnewlocationObject.city = true;
        vm.addnewlocationObject.sector = true;
        $scope.inputsearchObject.provinceAltered = true;

        if (!$scope.inputsearchObject.isInputEmptySector && !$scope.inputsearchObject.isInputEmptyCity) {
          $scope.inputsearchObject.isAddOrSaveLocationSector = true;
          $scope.inputsearchObject.sectorAltered = true;
          $scope.inputsearchObject.isAddOrSaveLocationCity = true;
          $scope.inputsearchObject.cityAltered = true;
        } else {
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
          $scope.inputsearchObject.sectorAltered = false;
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.cityAltered = false;
        }

      } else if (type == 'CITY') {
        $scope.inputsearchObject.citySearchKey = searchText;
        $scope.inputsearchObject.city = searchText;
        $scope.inputsearchObject.isAddOrSaveLocationCity = true;
        vm.addnewlocationObject.city = true;
        vm.addnewlocationObject.sector = true;
        $scope.inputsearchObject.cityAltered = true;

        if (!$scope.inputsearchObject.isInputEmptySector) {
          $scope.inputsearchObject.isAddOrSaveLocationSector = true;
          $scope.inputsearchObject.sectorAltered = true;
        } else {
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
          $scope.inputsearchObject.sectorAltered = false;
        }

      } else if (type == 'SECTOR') {
        $scope.inputsearchObject.sectorSearchKey = searchText;
        $scope.inputsearchObject.sector = searchText;
        $scope.inputsearchObject.isAddOrSaveLocationSector = true;
        vm.addnewlocationObject.sector = true;
        $scope.inputsearchObject.sectorAltered = true;
      }
      // $scope.addInputSearchObject();
    }

    $scope.getListCall = function (type, searchText, delayCall) {
      var deferred = $q.defer();
      $scope.locLoader = true;
      var data = LibraryLocationService.loadAllLocationsByType($scope.libraryLocObj, type);
      data.then(function (response) {
        $scope.locLoader = false;
        if (response.autoSuggestionLocationDTOList.length > 0) {
          if (type == 'COUNTRY') {
            $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
            if (delayCall) {
              $scope.populatePreFillDetails($scope.searchLocationCountryList[0]);
            }
          } else if (type == 'PROVINCE') {
            $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
            if ($scope.currentStatevalid === "locations") {
              if ($scope.inputsearchObject.isAddOrSaveLocationCountry || $scope.inputsearchObject.isAddOrSaveLocationProvince || $scope.inputsearchObject.isAddOrSaveLocationCity || $scope.inputsearchObject.isAddOrSaveLocationSector) {

                communicationService.setData('isAddOrSaveLocation', false);
              }


            }
            if (communicationService.getData('isAddOrSaveLocation')) {
              $scope.inputsearchObject.isInputEmptyCountry = false;
              $scope.inputsearchObject.isInputEmptyProvince = false;
              //$scope.inputsearchObject.provinceSearchKey = '';
              $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
              $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
            }
            if (delayCall) {
              $scope.populatePreFillDetails($scope.searchLocationProvinceList[0]);
            }
          } else if (type == 'CITY') {
            $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
            if ($scope.currentStatevalid === "locations") {
              if ($scope.inputsearchObject.isAddOrSaveLocationCountry == true || $scope.inputsearchObject.isAddOrSaveLocationProvince == true || $scope.inputsearchObject.isAddOrSaveLocationCity == true || $scope.inputsearchObject.isAddOrSaveLocationSector == true) {

                communicationService.setData('isAddOrSaveLocation', false);
              }
            }
            if (communicationService.getData('isAddOrSaveLocation')) {
              $scope.inputsearchObject.isInputEmptyCountry = false;
              $scope.inputsearchObject.isInputEmptyProvince = false;
              $scope.inputsearchObject.isInputEmptyCity = false;
              //$scope.inputsearchObject.citySearchKey = '';
              $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
              $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
              $scope.inputsearchObject.isAddOrSaveLocationCity = false;
            }
            if (delayCall) {
              $scope.populatePreFillDetails($scope.searchLocationCityList[0]);
            }
          } else if (type == 'SECTOR') {
            $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
            if ($scope.currentStatevalid === "locations") {
              if ($scope.inputsearchObject.isAddOrSaveLocationCountry == true || $scope.inputsearchObject.isAddOrSaveLocationProvince == true || $scope.inputsearchObject.isAddOrSaveLocationCity == true || $scope.inputsearchObject.isAddOrSaveLocationSector == true) {

                communicationService.setData('isAddOrSaveLocation', false);
              }
            }
            if (communicationService.getData('isAddOrSaveLocation')) {
              $scope.inputsearchObject.isInputEmptyCountry = false;
              $scope.inputsearchObject.isInputEmptyProvince = false;
              $scope.inputsearchObject.isInputEmptyCity = false;
              $scope.inputsearchObject.isInputEmptySector = false;
              //$scope.inputsearchObject.sectorSearchKey = '';
              $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
              $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
              $scope.inputsearchObject.isAddOrSaveLocationCity = false;
              $scope.inputsearchObject.isAddOrSaveLocationSector = false;
            }
          }
        } else {
          if (type == 'COUNTRY') {
            $scope.searchLocationCountryList = response.autoSuggestionLocationDTOList;
          } else if (type == 'PROVINCE') {
            $scope.searchLocationProvinceList = response.autoSuggestionLocationDTOList;
          } else if (type == 'CITY') {
            $scope.searchLocationCityList = response.autoSuggestionLocationDTOList;
          } else if (type == 'SECTOR') {
            $scope.searchLocationSectorList = response.autoSuggestionLocationDTOList;
          }
          $scope.loadNewInputFields(type, searchText);
        }
        if (type == 'COUNTRY') {
          deferred.resolve($scope.searchLocationCountryList);
        } else if (type == 'PROVINCE') {
          deferred.resolve($scope.searchLocationProvinceList);
        } else if (type == 'CITY') {
          deferred.resolve($scope.searchLocationCityList);
        } else if (type == 'SECTOR') {
          deferred.resolve($scope.searchLocationSectorList);
        }
        $rootScope.$emit('enableAddLocationButton');

      });
      return deferred.promise;
    }

    $scope.clear = function (type) {
      if (type == 'COUNTRY') {
        $scope.modelObject.countryObj = {};
        if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId) {
          $scope.modelObject.provinceObj = {};
        }
        if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId) {
          $scope.modelObject.cityObj = {};
        }
        if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
          $scope.modelObject.sectorObj = {};
        }
        if (communicationService.getData('isAddOrSaveLocation')) {
          $scope.inputsearchObject.isInputEmptyCountry = false;
          $scope.inputsearchObject.isInputEmptyProvince = false;
          $scope.inputsearchObject.isInputEmptyCity = false;
          $scope.inputsearchObject.isInputEmptySector = false;
          $scope.inputsearchObject.countrySearchKey = '';
          $scope.inputsearchObject.provinceSearchKey = '';
          $scope.inputsearchObject.citySearchKey = '';
          $scope.inputsearchObject.sectorSearchKey = '';
          $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }

      } else if (type == 'PROVINCE') {
        $scope.modelObject.provinceObj = {};
        if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId) {
          $scope.modelObject.cityObj = {};
        }
        if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
          $scope.modelObject.sectorObj = {};
        }
        if (communicationService.getData('isAddOrSaveLocation')) {
          $scope.inputsearchObject.isInputEmptyProvince = false;
          $scope.inputsearchObject.isInputEmptyCity = false;
          $scope.inputsearchObject.isInputEmptySector = false;
          $scope.inputsearchObject.provinceSearchKey = '';
          $scope.inputsearchObject.citySearchKey = '';
          $scope.inputsearchObject.sectorSearchKey = '';
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }
        if (vm.currentState == vm.APP.LIBRARY.ENTITY) {
          $scope.searchLocation($scope.modelObject.countryObj.countryTxt, 'COUNTRY', true);
        }

      } else if (type == 'CITY') {
        $scope.modelObject.cityObj = {};
        if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
          $scope.modelObject.sectorObj = {};
        }
        if (communicationService.getData('isAddOrSaveLocation')) {
          $scope.inputsearchObject.isInputEmptyCity = false;
          $scope.inputsearchObject.isInputEmptySector = false;
          $scope.inputsearchObject.citySearchKey = '';
          $scope.inputsearchObject.sectorSearchKey = '';
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }
        if (vm.currentState == vm.APP.LIBRARY.ENTITY) {
          $scope.searchLocation($scope.modelObject.provinceObj.provinceTxt, 'PROVINCE', true);
        }

      } else if (type == 'SECTOR') {
        $scope.modelObject.sectorObj = {};
        if (communicationService.getData('isAddOrSaveLocation')) {
          $scope.inputsearchObject.isInputEmptySector = false;
          $scope.inputsearchObject.sectorSearchKey = '';
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }
        if (vm.currentState == vm.APP.LIBRARY.ENTITY) {
          $scope.searchLocation($scope.modelObject.cityObj.cityTxt, 'CITY', true);
        }
      }
    }


    $scope.populatePreFillDetails = function (locationObj, isFromValidation) {
      if (locationObj) {
        if(locationObj.id || locationObj.locationMappingId)
		  	{
			  	communicationService.setData('ValidateEntityLocationField', locationObj);
			  }
        $scope.copyLocationObj = angular.copy(locationObj);
        if ($scope.copyLocationObj.countryId != null) {
          $scope.modelObject.countryObj = $scope.copyLocationObj;
          $scope.inputsearchObject.country = $scope.modelObject.countryObj.countryTxt;
          $scope.inputsearchObject.countrySearchKey = $scope.modelObject.countryObj.countryTxt;

          $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
        } else if (isFromValidation && ($scope.copyLocationObj.countryTxt == "" || angular.isUndefinedOrNull($scope.copyLocationObj.countryTxt))) {
          $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
        }
        if ($scope.copyLocationObj.provinceId != null) {
          $scope.modelObject.provinceObj = $scope.copyLocationObj;
          $scope.inputsearchObject.province = $scope.modelObject.provinceObj.provinceTxt;
          $scope.inputsearchObject.provinceSearchKey = $scope.modelObject.provinceObj.provinceTxt;

          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
        } else if (isFromValidation && ($scope.copyLocationObj.provinceTxt == "" || angular.isUndefinedOrNull($scope.copyLocationObj.provinceTxt))) {
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
        }
        if ($scope.copyLocationObj.cityId != null) {
          $scope.modelObject.cityObj = $scope.copyLocationObj;
          $scope.inputsearchObject.city = $scope.modelObject.cityObj.cityTxt;
          $scope.inputsearchObject.citySearchKey = $scope.modelObject.cityObj.cityTxt;

          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
        } else if (isFromValidation && ($scope.copyLocationObj.cityTxt == "" || angular.isUndefinedOrNull($scope.copyLocationObj.cityTxt))) {
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
        }
        if ($scope.copyLocationObj.sectorId != null) {
          $scope.modelObject.sectorObj = $scope.copyLocationObj;
          $scope.inputsearchObject.sector = $scope.modelObject.sectorObj.sectorTxt;
          $scope.inputsearchObject.sectorSearchKey = $scope.modelObject.sectorObj.sectorTxt;

          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        } else if (isFromValidation && ($scope.copyLocationObj.sectorTxt == "" || angular.isUndefinedOrNull($scope.copyLocationObj.sectorTxt))) {
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }

        if (!angular.isUndefinedOrNull($scope.modelObject.cityObj.locationMappingId) && !angular.isUndefinedOrNull($scope.modelObject.provinceObj.locationMappingId)
          && $scope.modelObject.cityObj.locationMappingId != $scope.modelObject.provinceObj.locationMappingId) {
          $scope.inputsearchObject.isAddOrSaveLocationCity = true;
          $scope.modelObject.cityObj.locationMappingId = undefined;

          if (!angular.isUndefinedOrNull($scope.copyLocationObj.sectorTxt) && $scope.copyLocationObj.sectorTxt != "") {
            $scope.inputsearchObject.isAddOrSaveLocationSector = true;
          }
        }
      }
    }

    $scope.countryChange = function () {
      vm.addnewlocationObject = {};
      vm.addnewlocationObject.country = true;
      vm.addnewlocationObject.province = true;
      vm.addnewlocationObject.city = true;
      vm.addnewlocationObject.sector = true;
      if ($scope.inputsearchObject.countrySearchKey == "") {
        $scope.modelObject.countryObj = {};
        $scope.inputsearchObject.country = "";
        $scope.formName.country.$error = true;
        $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
        $scope.inputsearchObject.province = $scope.inputsearchObject.provinceSearchKey;
        $scope.inputsearchObject.isAddOrSaveLocationProvince = true;
        $scope.inputsearchObject.city = $scope.inputsearchObject.citySearchKey;
        $scope.inputsearchObject.isAddOrSaveLocationCity = true;
        $scope.inputsearchObject.sector = $scope.inputsearchObject.sectorSearchKey;
        $scope.inputsearchObject.isAddOrSaveLocationSector = true;
        $scope.existingSearchLocation("COUNTRY");
        if (angular.isUndefinedOrNull($scope.inputsearchObject.provinceSearchKey) && angular.isUndefinedOrNull($scope.inputsearchObject.citySearchKey)
          && angular.isUndefinedOrNull($scope.inputsearchObject.sectorSearchKey)) {
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        }
      } else {
        $scope.formName.country.$error = false;
      }
    };

    $scope.countrySearchChange = function () {
      if ($scope.inputsearchObject.country == "") {
        $scope.inputsearchObject.countrySearchKey = "";
        $scope.countryChange();
        $scope.formName.country.$error = true;
      } else {
        $scope.formName.country.$error = false;
      }
    };

    $scope.provinceChange = function () {
      vm.addnewlocationObject = {};
      vm.addnewlocationObject.province = true;
      vm.addnewlocationObject.city = true;
      vm.addnewlocationObject.sector = true;
      $scope.locationAltered();
      if ($scope.inputsearchObject.provinceSearchKey == "") {

        $scope.inputsearchObject.province = "";
        $scope.formName.province.$error = true;
        if (($scope.modelObject.countryObj && !angular.isUndefinedOrNull($scope.modelObject.countryObj.countryId) && !angular.isUndefinedOrNull($scope.inputsearchObject.countrySearchKey)) || !$scope.inputsearchObject.isAddOrSaveLocationCountry) {
          $scope.inputsearchObject.isAddOrSaveLocationCity = true;
          $scope.inputsearchObject.isAddOrSaveLocationProvince = false;
          $scope.inputsearchObject.isAddOrSaveLocationSector = true;
          $scope.existingSearchLocation("PROVINCE");
          if (angular.isUndefinedOrNull($scope.inputsearchObject.citySearchKey) && angular.isUndefinedOrNull($scope.inputsearchObject.sectorSearchKey)) {
            $scope.inputsearchObject.isAddOrSaveLocationCity = false;
            $scope.inputsearchObject.isAddOrSaveLocationSector = false;
          }
          $scope.modelObject.provinceObj = {};
          $scope.modelObject.cityObj.cityId = null;
          $scope.modelObject.sectorObj.sectorId = null;
          $scope.inputsearchObject.city = $scope.inputsearchObject.citySearchKey;
          $scope.inputsearchObject.sector = $scope.inputsearchObject.sectorSearchKey;
        }
        else {
          vm.addnewlocationObject.country = true;
        }
      } else {
        $scope.formName.province.$error = false;
      }
    };

    $scope.provinceSearchChange = function () {
      if ($scope.inputsearchObject.province == "") {
        $scope.inputsearchObject.provinceSearchKey = "";
        $scope.inputsearchObject.isAddOrSaveLocationCountry = false;
        $scope.provinceChange();
        $scope.formName.province.$error = true;
      } else {
        $scope.formName.province.$error = false;
      }
    };

    $scope.cityChange = function () {
      vm.addnewlocationObject = {};
      vm.addnewlocationObject.city = true;
      $scope.locationAltered();
      if ($scope.inputsearchObject.citySearchKey == "") {
        $scope.inputsearchObject.city = "";
        if (($scope.modelObject.provinceObj && !angular.isUndefinedOrNull($scope.modelObject.provinceObj.provinceId) && !angular.isUndefinedOrNull($scope.inputsearchObject.provinceSearchKey)) || !$scope.inputsearchObject.isAddOrSaveLocationProvince) {
          $scope.inputsearchObject.isAddOrSaveLocationCity = false;
          $scope.formName.city.$error = true;
          $scope.modelObject.cityObj = {};
        }
      } else {
        vm.addnewlocationObject.province = true;
        $scope.formName.city.$error = false;
      }
    };

    $scope.citySearchChange = function () {
      if ($scope.inputsearchObject.city == "") {
        $scope.inputsearchObject.isAddOrSaveLocationCity = false;
        $scope.inputsearchObject.citySearchKey = "";
        $scope.cityChange();
        $scope.formName.city.$error = true;
      } else {
        $scope.formName.city.$error = false;
      }
      if ($scope.isRequested) {
        $scope.isRequested = false;
      }
    };

    $scope.sectorChange = function () {
      vm.addnewlocationObject = {};
      vm.addnewlocationObject.sector = true;
      $scope.locationAltered();
      if ($scope.inputsearchObject.sectorSearchKey == "") {
        $scope.inputsearchObject.sector = "";
        if (($scope.modelObject.cityObj && !angular.isUndefinedOrNull($scope.modelObject.cityObj.cityId) && !angular.isUndefinedOrNull($scope.inputsearchObject.citySearchKey)) || !$scope.inputsearchObject.isAddOrSaveLocationCity) {
          vm.addnewlocationObject.city = true;
          $scope.inputsearchObject.isAddOrSaveLocationSector = false;
          $scope.clear('SECTOR');
        }
      }
      else {
        vm.addnewlocationObject.city = true;
      }
    };

    $scope.sectorSearchChange = function () {
      if ($scope.inputsearchObject.sector == "") {
        $scope.inputsearchObject.isAddOrSaveLocationSector = false;
        $scope.inputsearchObject.sectorSearchKey = "";
        $scope.sectorChange();
      }
      if ($scope.isRequested) {
        $scope.isRequested = false;
      }
    };

    $scope.clearName = function (name, searchKey, dropValue) {
      $scope[searchKey] = undefined;
      $scope[dropValue] = undefined;
    };

    $scope.replaceInputField = function () {
      var requestType;
      if (vm.locationRequestType != null) {
        requestType = vm.locationRequestType.name;
      }
      if (requestType == vm.APP.LIBRARY.COUNTRY) {
        if (vm.country != null || vm.location.country != null) {
          //vm.isEnableSave=true;
        }
        if (vm.isShowCountry == false && vm.addLocationObject.countryObj == undefined && vm.country != null) {
          vm.isReplaceCountry = true;
          vm.requestFlagCountryInput = true;
          vm.location.country = vm.country;
        }
      }
      if (requestType == vm.APP.LIBRARY.PROVINCE) {
        if (vm.province != null) {
          //vm.isEnableSave=true;
        }
        if (vm.isShowProvince == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj == undefined && vm.province != null) {
          vm.location.province = vm.province;
          vm.isReplaceProvince = true;
          vm.requestFlagProvinceInput = true;
          //vm.isReplaceCountry = false;
        }
      }
      if (requestType == vm.APP.LIBRARY.CITY) {
        if (vm.city != null) {
          //vm.isEnableSave=true;
        }
        if (vm.isShowCity == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj != null && vm.addLocationObject.cityObj == undefined && vm.city != null) {
          vm.location.city = vm.city;
          vm.isReplaceCity = true;
          vm.requestFlagCityInput = true;
          //vm.isReplaceCountry = false;
        }
      }
      if (requestType == vm.APP.LIBRARY.SECTOR) {
        if (vm.city != null) {
          //vm.isEnableSave=true;
        }
        if (vm.isShowSector == false && vm.addLocationObject.countryObj != null && vm.addLocationObject.provinceObj != null && vm.addLocationObject.cityObj != null && vm.addLocationObject.sectorObj == null && vm.sector != null) {
          vm.location.sector = vm.sector;
          vm.isReplaceSector = true;
          vm.requestFlagSectorInput = true;
          //vm.isReplaceCountry = false;
        }
      }
    };

    $rootScope.loadValid = function () {
      $scope.saveValid({ type: 'COUNTRY' });
      $scope.saveValid({ type: 'PROVINCE' });
      $scope.saveValid({ type: 'CITY' });
      $scope.saveValid({ type: 'SECTOR' });
    };

    // this method is used for set the given values in all location
    $scope.saveValid = function (input) {
      vm.countrychange = "";
      vm.provincechange = "";
      vm.citychange = "";
      vm.sectorchange = "";
      $scope.currentStatevalid = $state.current.name;
      if (input.type == "COUNTRY") {
        if($scope.currentStatevalid == "investigations"){
          if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryTxt != null && $scope.modelObject.countryObj.countryTxt != undefined) {
            vm.countrychange = $scope.modelObject.countryObj.countryTxt;
          }else if($scope.inputsearchObject.country != undefined){
            vm.countrychange = $scope.inputsearchObject.country;
          }
        }else{
        if (($scope.currentStatevalid != "entities") && ($scope.currentStatevalid != "request")) {
          if ($scope.inputsearchObject.country != vm.country && $scope.cleanInputValue == $scope.inputsearchObject.country) {
            vm.countrychange = $scope.inputsearchObject.country;
          } else if ($scope.inputsearchObject.countrySearchKey != vm.country1 && $scope.cleanInputValue == $scope.inputsearchObject.countrySearchKey) {
            vm.countrychange = $scope.inputsearchObject.countrySearchKey;
          } else if ($scope.inputsearchObject.countrySearchKey != undefined && $scope.inputsearchObject.country != undefined && $scope.inputsearchObject.countrySearchKey == vm.country1 && $scope.inputsearchObject.country == vm.country) {
            vm.countrychange = $scope.inputsearchObject.country
          } else if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryTxt != null && $scope.modelObject.countryObj.countryTxt != undefined) {
            vm.countrychange = $scope.modelObject.countryObj.countryTxt;
          } else if ($scope.inputsearchObject.countrySearchKey != undefined && $scope.inputsearchObject.country != undefined && $scope.inputsearchObject.countrySearchKey == vm.country1) {
            vm.countrychange = $scope.inputsearchObject.countrySearchKey;
          } else if ($scope.inputsearchObject.countrySearchKey != vm.country1) {
            vm.countrychange = $scope.inputsearchObject.country;
          }
        } else {
          if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryTxt != null && $scope.modelObject.countryObj.countryTxt != undefined) {
            vm.countrychange = $scope.modelObject.countryObj.countryTxt;
          } else if ($scope.inputsearchObject.countrySearchKey != vm.country1 && $scope.inputsearchObject.countrySearchKey != undefined && $scope.cleanInputValue == $scope.inputsearchObject.countrySearchKey) {
            vm.countrychange = $scope.inputsearchObject.countrySearchKey;
          } else if ($scope.inputsearchObject.country != vm.country && $scope.inputsearchObject.country != undefined && $scope.cleanInputValue == $scope.inputsearchObject.country) {
            vm.countrychange = $scope.inputsearchObject.country;
          } else if ($scope.inputsearchObject.countrySearchKey != undefined && $scope.inputsearchObject.country != undefined && $scope.inputsearchObject.countrySearchKey == vm.country1 && $scope.inputsearchObject.country == vm.country) {
            vm.countrychange = $scope.inputsearchObject.country;
          } else if ($scope.inputsearchObject.countrySearchKey != undefined && $scope.inputsearchObject.country != undefined && $scope.inputsearchObject.countrySearchKey == vm.country1) {
            vm.countrychange = $scope.inputsearchObject.countrySearchKey;
          } else if ($scope.inputsearchObject.countrySearchKey != vm.country1) {
            vm.countrychange = $scope.inputsearchObject.country;
          }
        }
      }
        if (vm.countrychange == "") {
          vm.countrychange = null;
        }
        if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryId != "" && (!$scope.inputsearchObject.isAddOrSaveLocationCountry || $scope.currentStatevalid != "neighbourhoodCanvas")) {
          $scope.modelObject.countryObj.countryTxt = vm.countrychange;
          $scope.inputsearchObject.country = vm.countrychange;
          $scope.inputsearchObject.countrySearchKey = vm.countrychange;
        } else if ($scope.modelObject.countryObj && $scope.modelObject.countryObj.countryTxt == $scope.inputsearchObject.country) {
          $scope.modelObject.countryObj.countryId = undefined;
          $scope.inputsearchObject.country = $scope.modelObject.countryObj.countryTxt;
        } else {
          $scope.inputsearchObject.country = vm.countrychange;
          $scope.inputsearchObject.countrySearchKey = vm.countrychange;
        }
        vm.country = angular.copy($scope.inputsearchObject.country);
        vm.country1 = angular.copy($scope.inputsearchObject.countrySearchKey);
      }
      if (input.type == "PROVINCE") {
        if($scope.currentStatevalid == "investigations"){
          if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceTxt != null && $scope.modelObject.provinceObj.provinceTxt != undefined) {
            vm.provincechange = $scope.modelObject.provinceObj.provinceTxt;
          }else if($scope.inputsearchObject.province != undefined){
            vm.provincechange = $scope.inputsearchObject.province;
          }
        }else{
        if (($scope.currentStatevalid != "entities") && ($scope.currentStatevalid != "request")) {
          if ($scope.inputsearchObject.province != vm.province && $scope.cleanInputValue == $scope.inputsearchObject.province) {
            vm.provincechange = $scope.inputsearchObject.province;
          } else if ($scope.inputsearchObject.provinceSearchKey != vm.province1 && $scope.cleanInputValue == $scope.inputsearchObject.provinceSearchKey) {
            vm.provincechange = $scope.inputsearchObject.provinceSearchKey;
          } else if ($scope.inputsearchObject.provinceSearchKey != undefined && $scope.inputsearchObject.province != undefined && $scope.inputsearchObject.provinceSearchKey == vm.province1 && $scope.inputsearchObject.province == vm.province) {
            vm.provincechange = $scope.inputsearchObject.province;
          } else if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceTxt != null && $scope.modelObject.provinceObj.provinceTxt != undefined) {
            vm.provincechange = $scope.modelObject.provinceObj.provinceTxt;
          } else if ($scope.inputsearchObject.provinceSearchKey != undefined && $scope.inputsearchObject.province != undefined && $scope.inputsearchObject.provinceSearchKey == vm.province1) {
            vm.provincechange = $scope.inputsearchObject.provinceSearchKey;
          } else if ($scope.inputsearchObject.provinceSearchKey != vm.province1) {
            vm.provincechange = $scope.inputsearchObject.province;
          }
        } else {
          if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceTxt != null && $scope.modelObject.provinceObj.provinceTxt != undefined) {
            vm.provincechange = $scope.modelObject.provinceObj.provinceTxt;
          } else if ($scope.inputsearchObject.provinceSearchKey != vm.province1 && $scope.cleanInputValue == $scope.inputsearchObject.provinceSearchKey) {
            vm.provincechange = $scope.inputsearchObject.provinceSearchKey;
          } else if ($scope.inputsearchObject.province != vm.province && $scope.cleanInputValue == $scope.inputsearchObject.province) {
            vm.provincechange = $scope.inputsearchObject.province;
          } else if ($scope.inputsearchObject.provinceSearchKey != undefined && $scope.inputsearchObject.province != undefined && $scope.inputsearchObject.provinceSearchKey == vm.province1 && $scope.inputsearchObject.province == vm.province) {
            vm.provincechange = $scope.inputsearchObject.province;
          } else if ($scope.inputsearchObject.provinceSearchKey != undefined && $scope.inputsearchObject.province != undefined && $scope.inputsearchObject.provinceSearchKey == vm.province1) {
            vm.provincechange = $scope.inputsearchObject.provinceSearchKey;
          } else if ($scope.inputsearchObject.provinceSearchKey != vm.province1) {
            vm.provincechange = $scope.inputsearchObject.province;
          }
        }
      }
        if (vm.provincechange == "") {
          vm.provincechange = null;
        }
        if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId != "" && (!$scope.inputsearchObject.isAddOrSaveLocationProvince || $scope.currentStatevalid != "neighbourhoodCanvas")) {
          $scope.modelObject.provinceObj.provinceTxt = vm.provincechange;
          $scope.inputsearchObject.province = vm.provincechange;
          $scope.inputsearchObject.provinceSearchKey = vm.provincechange;
        } else if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceTxt == $scope.inputsearchObject.province) {
          $scope.modelObject.provinceObj.provinceId != undefined;
          $scope.inputsearchObject.province = $scope.modelObject.provinceObj.provinceTxt;
        } else {
          $scope.inputsearchObject.province = vm.provincechange;
          $scope.inputsearchObject.provinceSearchKey = vm.provincechange;
        }
        vm.province = angular.copy($scope.inputsearchObject.province);
        vm.province1 = angular.copy($scope.inputsearchObject.provinceSearchKey);
      }

      if (input.type == "CITY") {
        if($scope.currentStatevalid == "investigations"){
          if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityTxt != null && $scope.modelObject.cityObj.cityTxt != undefined) {
            vm.citychange = $scope.modelObject.cityObj.cityTxt;
          }else if($scope.inputsearchObject.city != undefined){
            vm.citychange = $scope.inputsearchObject.city;
          }
        }else{
        if (($scope.currentStatevalid != "entities") && ($scope.currentStatevalid != "request")) {
          if ($scope.inputsearchObject.city != vm.city && $scope.cleanInputValue == $scope.inputsearchObject.city) {
            vm.citychange = $scope.inputsearchObject.city;
          } else if ($scope.inputsearchObject.citySearchKey != vm.city1 && $scope.cleanInputValue == $scope.inputsearchObject.citySearchKey) {
            vm.citychange = $scope.inputsearchObject.citySearchKey;
          } else if ($scope.inputsearchObject.citySearchKey != undefined && $scope.inputsearchObject.city != undefined && $scope.inputsearchObject.citySearchKey == vm.city1 && $scope.inputsearchObject.city == vm.city) {
            vm.citychange = $scope.inputsearchObject.city;
          } else if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityTxt != null && $scope.modelObject.cityObj.cityTxt != undefined) {
            vm.citychange = $scope.modelObject.cityObj.cityTxt;
          } else if ($scope.inputsearchObject.citySearchKey != undefined && $scope.inputsearchObject.city != undefined && $scope.inputsearchObject.citySearchKey == vm.city1) {
            vm.citychange = $scope.inputsearchObject.citySearchKey;
          } else if ($scope.inputsearchObject.citySearchKey != vm.city1) {
            vm.citychange = $scope.inputsearchObject.city;
          }
        } else {
          if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityTxt != null && $scope.modelObject.cityObj.cityTxt != undefined) {
            vm.citychange = $scope.modelObject.cityObj.cityTxt;
          } else if ($scope.inputsearchObject.citySearchKey != vm.city1 && $scope.cleanInputValue == $scope.inputsearchObject.citySearchKey) {
            vm.citychange = $scope.inputsearchObject.citySearchKey;
          } else if ($scope.inputsearchObject.city != vm.city && $scope.cleanInputValue == $scope.inputsearchObject.city) {
            vm.citychange = $scope.inputsearchObject.city;
          } else if ($scope.inputsearchObject.citySearchKey != undefined && $scope.inputsearchObject.city != undefined && $scope.inputsearchObject.citySearchKey == vm.city1 && $scope.inputsearchObject.city == vm.city) {
            vm.citychange = $scope.inputsearchObject.city;
          } else if ($scope.inputsearchObject.citySearchKey != undefined && $scope.inputsearchObject.city != undefined && $scope.inputsearchObject.citySearchKey == vm.city1) {
            vm.citychange = $scope.inputsearchObject.citySearchKey;
          } else if ($scope.inputsearchObject.citySearchKey != vm.city1) {
            vm.citychange = $scope.inputsearchObject.city;
          }
        }
      }
        if (vm.citychange == "") {
          vm.citychange = null;
        }
        if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId != "" && (!$scope.inputsearchObject.isAddOrSaveLocationCity || $scope.currentStatevalid != "neighbourhoodCanvas")) {
          $scope.modelObject.cityObj.cityTxt = vm.citychange;
          $scope.inputsearchObject.city = vm.citychange;
          $scope.inputsearchObject.citySearchKey = vm.citychange;
        } else if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityTxt == $scope.inputsearchObject.city) {
          $scope.inputsearchObject.city = $scope.modelObject.cityObj.cityTxt;
          $scope.modelObject.cityObj.cityId != undefined;
        } else {
          $scope.inputsearchObject.city = vm.citychange;
          $scope.inputsearchObject.citySearchKey = vm.citychange;
        }
        vm.city = angular.copy($scope.inputsearchObject.city);
        vm.city1 = angular.copy($scope.inputsearchObject.citySearchKey);
      }

      if (input.type == "SECTOR") {
        if($scope.currentStatevalid == "investigations"){
          if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt != null && $scope.modelObject.sectorObj.sectorTxt != undefined) {
            vm.sectorchange = $scope.modelObject.sectorObj.sectorTxt;
          }else if($scope.inputsearchObject.sector != undefined){
            vm.sectorchange = $scope.inputsearchObject.sector;
          }
        }else{
        if (($scope.currentStatevalid != "entities") && ($scope.currentStatevalid != "request")) {
          if ($scope.inputsearchObject.sector != vm.sector && $scope.cleanInputValue == $scope.inputsearchObject.sector) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          } else if ($scope.inputsearchObject.sectorSearchKey != vm.sector1 && $scope.cleanInputValue == $scope.inputsearchObject.sectorSearchKey) {
            vm.sectorchange = $scope.inputsearchObject.sectorSearchKey;
          } else if ($scope.inputsearchObject.sectorSearchKey != undefined && $scope.inputsearchObject.sector != undefined && $scope.inputsearchObject.sectorSearchKey == vm.sector1 && $scope.inputsearchObject.sector == vm.sector) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          } else if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt != null && $scope.modelObject.sectorObj.sectorTxt != undefined) {
            vm.sectorchange = $scope.modelObject.sectorObj.sectorTxt;
          } else if ($scope.inputsearchObject.sectorSearchKey != undefined && $scope.inputsearchObject.sector != undefined && $scope.inputsearchObject.sectorSearchKey == vm.sector1) {
            vm.sectorchange = $scope.inputsearchObject.sectorSearchKey;
          } else if ($scope.inputsearchObject.sectorSearchKey != vm.sector1) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          }
        } else {
          if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt != null && $scope.modelObject.sectorObj.sectorTxt != undefined && $scope.currentStatevalid === "entities") {
            vm.sectorchange = $scope.modelObject.sectorObj.sectorTxt;
          } else if ($scope.inputsearchObject.sectorSearchKey != vm.sector1 && $scope.inputsearchObject.sectorSearchKey != undefined && $scope.cleanInputValue == $scope.inputsearchObject.sectorSearchKey) {
            vm.sectorchange = $scope.inputsearchObject.sectorSearchKey;
          } else if ($scope.inputsearchObject.sector != vm.sector && $scope.cleanInputValue == $scope.inputsearchObject.sector && $scope.inputsearchObject.sector != undefined) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          } else if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt != vm.sector2 && $scope.currentStatevalid === "request") {
            vm.sectorchange = $scope.modelObject.sectorObj.sectorTxt;
          } else if ($scope.inputsearchObject.sectorSearchKey != undefined && $scope.inputsearchObject.sector != undefined && $scope.inputsearchObject.sectorSearchKey == vm.sector1 && $scope.inputsearchObject.sector == vm.sector) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          } else if ($scope.inputsearchObject.sectorSearchKey != undefined && $scope.inputsearchObject.sector != undefined && $scope.inputsearchObject.sectorSearchKey == vm.sector1) {
            vm.sectorchange = $scope.inputsearchObject.sectorSearchKey;
          } else if ($scope.inputsearchObject.sectorSearchKey != vm.sector1) {
            vm.sectorchange = $scope.inputsearchObject.sector;
          }

        }
      }
        if (vm.sectorchange == "") {
          vm.sectorchange = null;
        }
        if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId != "" && (!$scope.inputsearchObject.isAddOrSaveLocationSector || $scope.currentStatevalid != "neighbourhoodCanvas")) {
          $scope.modelObject.sectorObj.sectorTxt = vm.sectorchange;
          $scope.inputsearchObject.sector = vm.sectorchange;
          $scope.inputsearchObject.sectorSearchKey = vm.sectorchange;
        } else if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt == $scope.inputsearchObject.sector) {
          $scope.modelObject.sectorObj.sectorId != undefined;
          $scope.inputsearchObject.sector = $scope.modelObject.sectorObj.sectorTxt;
        } else {
          $scope.inputsearchObject.sector = vm.sectorchange;
          $scope.inputsearchObject.sectorSearchKey = vm.sectorchange;
        }
        vm.sector = angular.copy($scope.inputsearchObject.sector);
        vm.sector1 = angular.copy($scope.inputsearchObject.sectorSearchKey);
        vm.sector2 = angular.copy($scope.modelObject.sectorObj);
      }
    };

    //Clear new Country Location input container fields
    vm.clearNewCountryFields = function () {
      $scope.inputsearchObject.isHideCountry = false;
      if ($scope.relpaceinputfieldObject != undefined) {
        $scope.relpaceinputfieldObject.country = false;
        $scope.relpaceinputfieldObject.countryKey = undefined;
      }
    };

    //Clear new Province Location input container fields
    vm.clearNewProvinceFields = function () {
      $scope.inputsearchObject.isHideProvince = false;
      if ($scope.relpaceinputfieldObject != undefined) {
        $scope.relpaceinputfieldObject.province = false;
        $scope.relpaceinputfieldObject.provinceKey = undefined;
      }
    };

    //Clear new City Location input container fields
    vm.clearNewCityFields = function () {
      $scope.inputsearchObject.isHideCity = false;
      if ($scope.relpaceinputfieldObject != undefined) {
        $scope.relpaceinputfieldObject.city = false;
        $scope.relpaceinputfieldObject.cityKey = undefined;
      }
    };

    //Clear new Sector Location input container fields
    vm.clearNewSectorFields = function () {
      $scope.inputsearchObject.isHideSector = false;
      if ($scope.relpaceinputfieldObject != undefined) {
        $scope.relpaceinputfieldObject.sector = false;
        $scope.relpaceinputfieldObject.sectorKey = undefined;
      }
    };

    angular.isUndefinedOrNull = function (val) {
      return angular.isUndefined(val) || val == "" || val == null;
    }

    $scope.existingSearchLocation = function (type) {
      if ($scope.modelObject) {
        if (type == 'COUNTRY') {
          if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceTxt) {
            $scope.inputsearchObject.provinceSearchKey = $scope.modelObject.provinceObj.provinceTxt;
            $scope.inputsearchObject.province = $scope.modelObject.provinceObj.provinceTxt;
          }
        }
        if (type == 'COUNTRY' || type == 'PROVINCE') {
          if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityTxt) {
            $scope.inputsearchObject.citySearchKey = $scope.modelObject.cityObj.cityTxt;
            $scope.inputsearchObject.city = $scope.modelObject.cityObj.cityTxt;
          }
        }
        if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorTxt) {
          $scope.inputsearchObject.sectorSearchKey = $scope.modelObject.sectorObj.sectorTxt;
          $scope.inputsearchObject.sector = $scope.modelObject.sectorObj.sectorTxt;
        }
      }
    }


    $scope.locationAltered = function () {
      if ($scope.inputsearchObject) {
        if ($scope.inputsearchObject.countryAltered) {
          vm.addnewlocationObject.country = true;
        }
        if ($scope.inputsearchObject.provinceAltered) {
          vm.addnewlocationObject.province = true;
        }
        if ($scope.inputsearchObject.cityAltered) {
          vm.addnewlocationObject.city = true;
        }
        if ($scope.inputsearchObject.sectorAltered) {
          vm.addnewlocationObject.sector = true;
        }
      }
    }

    $scope.validateLocationId = function (type) {

      if ($scope.modelObject) {
        if (type == "COUNTRY") {
          if ($scope.modelObject.provinceObj && $scope.modelObject.provinceObj.provinceId) {
            $scope.modelObject.provinceObj.provinceId = null;
          }
        }
        if (type == "COUNTRY" || type == "PROVINCE") {
          if ($scope.modelObject.cityObj && $scope.modelObject.cityObj.cityId) {
            $scope.modelObject.cityObj.cityId = null;
          }
        }
        if (type == "COUNTRY" || type == "PROVINCE" || type == "CITY") {
          if ($scope.modelObject.sectorObj && $scope.modelObject.sectorObj.sectorId) {
            $scope.modelObject.sectorObj.sectorId = null;
          }
        }
      }
    }

    $rootScope.$on('cancelFormData', function () {
      if ($scope.modelObject) {
        $scope.modelObject = {};
      }
      if ($scope.inputsearchObject) {
        $scope.inputsearchObject = {};
      }
    });

    // Validate the location mapping on change of every location field
    $scope.validateLocationMapping = function () {
      $scope.locationMappingObject = {};
      $scope.locationMappingObject.countryTxt = $scope.inputsearchObject.country;
      $scope.locationMappingObject.provinceTxt = $scope.inputsearchObject.province;
      $scope.locationMappingObject.cityTxt = $scope.inputsearchObject.city;
      $scope.locationMappingObject.sectorTxt = $scope.inputsearchObject.sector;
      $scope.valid = false;
      var data = LibraryLocationService.validateLocationMapping($scope.locationMappingObject);
      data.then(function (response) {
        $scope.populatePreFillDetails(response, true);

      });

    };

    $rootScope.triggerPopulatePreFillDetails = function (countryObj, provinceObj, cityObj, sectorObj) {
      // Set Country Details
      $scope.modelObject.countryObj = angular.copy(countryObj);
      $scope.inputsearchObject.country = $scope.modelObject.countryObj.countryTxt;
      $scope.inputsearchObject.countrySearchKey = $scope.modelObject.countryObj.countryTxt;

      // Set Province Details
      $scope.modelObject.provinceObj = angular.copy(provinceObj);
      $scope.inputsearchObject.province = $scope.modelObject.provinceObj.provinceTxt;
      $scope.inputsearchObject.provinceSearchKey = $scope.modelObject.provinceObj.provinceTxt;

      // Set City Details
      $scope.modelObject.cityObj = angular.copy(cityObj);
      $scope.inputsearchObject.city = $scope.modelObject.cityObj.cityTxt;
      $scope.inputsearchObject.citySearchKey = $scope.modelObject.cityObj.cityTxt;

      // Set Sector Details
      $scope.modelObject.sectorObj = angular.copy(sectorObj);
      $scope.inputsearchObject.sector = $scope.modelObject.sectorObj.sectorTxt;
      $scope.inputsearchObject.sectorSearchKey = $scope.modelObject.sectorObj.sectorTxt;
    };

  }
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('FormLocationDirectiveService', FormLocationDirectiveService);

    FormLocationDirectiveService.$inject = ['$resource', 'restService', '$q'];
    
    function FormLocationDirectiveService ($resource, restService, $q) {
    	
		this.loadAllLocationsByType = function(postObj,type) {
			var deferred = $q.defer();
    		var url = "locations/"+type;
    		var data = restService.restCall(postObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
		}
		
    }
})();

angular.module('lariAidApp').directive('hidePop',['$window', function ($window) {
	
	var headerHeight = 76;
	
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
          element.on('scroll', function (e) {
        	  hidePopup();
          });
          
         element.on('mouseover', function (e) {
        	 hidePopup();
        });
    }
  };
  
  function hidePopup(){
	  if($(".popover").length > 0){
       	 if($(".popover").position().top <= headerHeight ){
       		 $(".popover").css("visibility","hidden");
       	 }
       	 else if($(".popover").position().top > headerHeight){
       		 $(".popover").css("visibility","visible");
       	 }
       }
  }
  
}]);
(function() {
	'use strict';

    angular
        .module('lariAidApp').directive('formSideComment',formSideComment);
    
    function formSideComment(){
			return {
			    templateUrl: 'app/investigation/prospects/profile/investigation-form/sideComment-directive/side.commentdirective.html',
				controller:'SideCommentsDirectiveController',
			    transclude:true,
				replace: true,
			    restrict: 'E',
				scope:{
					formName:'=formName',
					investigationId:"=investigationId",
					disableFlag: '=disableFlag',
					modelObject: '@',
					questionName: '=questionName',
					objectList: '=objectList',
					accordionIndex: '=accordionIndex'
				},
			    link: function(scope, element, attrs) {
			    }
		    }
			
		}
    
})();
(function() {
	'use strict';

    angular
        .module('lariAidApp')
        .controller('SideCommentsDirectiveController', SideCommentsDirectiveController);
    
    SideCommentsDirectiveController.$inject = ['$rootScope','$scope','$state','$stateParams','$mdSidenav','$element','APP','tabservice','$mdMedia','SideCommentsDirectiveService','$q','$timeout','$sessionStorage','CommonService','$filter','$mdDialog'];
    
    function SideCommentsDirectiveController($rootScope,$scope,$state,$stateParams,$mdSidenav,$element,APP,tabservice,$mdMedia,SideCommentsDirectiveService,$q,$timeout,$sessionStorage,CommonService,$filter,$mdDialog){
    	$scope.showFlag = false;
    	$scope.showReplyButton = true;
    	$scope.selectedSortOrder;	
    	$scope.mediaCheck = $mdMedia;
    	$scope.limit = 3;
    	$scope.valueBeforeEdit ="";
    	$scope.app = APP;
    	
    	//Get user from cookie storage
 		$scope.user = CommonService.getCookieUser();
    	
    	$scope.editMode = false;
    	$scope.loggedInUser = CommonService.getCookieUser().cookieUser;
    	
    	/**
    	 * To show all comments in popup
    	 */
    	$scope.showAllComments = function(){
    		$scope.limit = $scope.modelObject.formQuestionCommentDTOs.length;
    	};
    	
    	/**
    	 * To Show less Comments
    	 */
    	$scope.showLessComments = function(){
    		$scope.limit = 3;
    	};
    	
    	/**
    	 * To open or close the comments box
    	 */
    	$scope.showComment = function(questionName){
    		$scope.showFlag = !$scope.showFlag;
    		$scope.loader = false;
    		$timeout(function(){
    			$("#SideCommentsDiv"+questionName).click(function(e){e.stopPropagation();});
    			
    			$("#SideCommentsDiv"+questionName).on('mouseover', function (e) {
    	        	if($rootScope.sideCommentVisible){
    	        		$rootScope.sideCommentVisible = false;
    	        	}
    	        });
    			
    			$("#SideCommentsDiv"+questionName).on('click', function (e) {
    	        	if($rootScope.sideCommentVisible){
    	        		$rootScope.sideCommentVisible = false;
    	        	}
    	        });
    			 
    		},50);
    		
    		//To maintain the access to the form
    		$scope.changeVisibilityTrue();
    	};
    	
    	/**
    	 * To show or hide the Reply box
    	 */
    	$scope.hideReply = function(){
        	$scope.showReplyButton = !$scope.showReplyButton;
        }
    	
    	/**
    	 * To show/hide Edit and Delete option
    	 */
        $scope.openMenu = function($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };
        
        /**
         * To edit the comment
         */
        $scope.editComment = function(sortOrder){
        	$scope.selectedSortOrder = sortOrder;
        	$scope.editMode = !$scope.editMode;
        	$scope.openPopup = false;
        	if($scope.showReplyButton == false) {
        		$scope.showReplyButton = true;
        	}
        };
        
        /**
         * To Update a comment
         */
        $scope.updateComment = function(changedComment){
        	angular.forEach($scope.modelObject.formQuestionCommentDTOs,function(data,key){
        		if(data.id == changedComment.id){
        			$scope.valueBeforeEdit = data.commentData;
        		}
        	});
        	if(changedComment.commentData != ""){
        		if(changedComment.commentData != $scope.valueBeforeEdit){  
            		if(changedComment.sortOrder == 0){
                		//update Parent
                		$scope.updateParentComment(changedComment);
                	}else{
                		//update Child
                		$scope.updateChildComment(changedComment);
                	}       		
            	}else{
            		$scope.cancelCommentUpdate();
            	}
            	$scope.valueBeforeEdit = "";
        	}
        };
        
        /**
         * To Update a Parent Comment
         */
        $scope.updateParentComment = function(comment){
        	var formId = $scope.investigationId;
        	var parentId = $scope.modelObject.formQuestionCommentDTOs[0].id;
        	var dataObj = {};
        	
        	dataObj.questionKey = $scope.questionName;
        	dataObj.formQuestionCommentDTOs = [];
        	
        	var tempObj ={};
        	tempObj.commentData = comment.commentData;
        	
        	dataObj.formQuestionCommentDTOs.push(tempObj);
        	
        	var data = SideCommentsDirectiveService.updateParentComment(formId,parentId,dataObj);
 		  	data.then(function(response){
 		  		$scope.updateResponse(comment,response);
 		  	}, function(reason) {
 			  return reason;
 		  	});

        };
        
        /**
         * To update Child Comment
         */
        $scope.updateChildComment = function(comment){
        	var formId = $scope.investigationId;
        	var parentId = $scope.modelObject.formQuestionCommentDTOs[0].id;
        	var dataObj = {};
        	
        	dataObj.questionKey = $scope.questionName;
        	dataObj.formQuestionCommentDTOs = [];
        	
        	var tempObj ={};
        	tempObj.commentData = comment.commentData;
        	tempObj.sideCommentParentId = comment.sideCommentParentId;
        	tempObj.id = comment.id;
        	
        	dataObj.formQuestionCommentDTOs.push(tempObj);
        	
        	var data = SideCommentsDirectiveService.updateChildComment(formId,parentId,comment.id,dataObj);
 		  	data.then(function(response){
 		  		$scope.updateResponse(comment,response);
 		  	}, function(reason) {
 			  return reason;
 		  	});

        };
        
        /**
         * To set the updated response
         */
        $scope.updateResponse = function(changedComment,response){
        	
        	changedComment.isEdited = true;
        	var dateVal = response.updatedOn;
    	    dateVal = $filter('date')(dateVal, "MMM d, y h:mm:ss a");
        	changedComment.updatedOn = dateVal;
        	$scope.editMode = false;
        	$scope.selectedSortOrder = undefined;
        	var data = SideCommentsDirectiveService.getSideCommentsBySectionQuestion($scope.investigationId,$scope.formName,$scope.accordionIndex,$scope.questionName);
        	data.then(function(response){
        		$scope.modelObject = response;
        		$scope.copyModelObject = angular.copy($scope.modelObject);
        	})
        };
               
        /**
         * To Cancel a comment edit
         */
        $scope.cancelCommentUpdate = function(comment){
        	if(!angular.isUndefinedOrNull(comment)) {
        		angular.forEach($scope.copyModelObject.formQuestionCommentDTOs, function(data,key){
            		if(data.id == comment.id && data.commentData != comment.commentData) {
            			comment.commentData = data.commentData;
            		}
            	})
        	}
        	
        	
        	$scope.editMode = false;
        	$scope.selectedSortOrder = undefined;
        };
        
        /**
         * To add a new comment
         */
        $scope.addComment = function(comment){
        	if($scope.user.loggedUser == $scope.app.GLOBAL.ROLE_READ_ONLY){
        		return;
        	}
        	if(!angular.isUndefinedOrNull(comment)){
            	$scope.responsedata = {};
            	if($scope.modelObject.formQuestionCommentDTOs.length == 0){
            		$scope.saveParentComment(comment);
            	}else{
            		$scope.saveChildComment(comment);
            	}       	
        	}      	
        };
        
        /**
         * To Get the Comment List before adding or editing a comment
         */
        $scope.getCommentDTO = function(comment,newCommentFlag){
    		$scope.loader = true;
        	var data = SideCommentsDirectiveService.getSideCommentsBySectionQuestion($scope.investigationId,$scope.formName,$scope.accordionIndex,$scope.questionName);
        	data.then(function(response){
        		$scope.modelObject = response;
        		if(angular.equals($scope.modelObject,{})){
        			$scope.setEmptyModelObject();
        		}
        		if(newCommentFlag == $scope.app.GLOBAL.TRUE){
            		$scope.addComment(comment);
        		}else{
        			$scope.updateComment(comment);
        		}
        		$scope.loader = false;
        	})
        };
        
        /**
         * Set comment data object
         */
        $scope.setCommentObject = function(comment){
        	$scope.tempComment = {};
    		$scope.tempComment.sortOrder = $scope.modelObject.formQuestionCommentDTOs.length;
        	$scope.tempComment.commenterId;
        	$scope.tempComment.isOwner = true;
        	$scope.tempComment.commentData = comment;
        	$scope.tempComment.isEdited = false;
        	
        	$scope.tempComment.commenterName = $scope.responsedata.commenterName;
        	$scope.tempComment.createdOn = $scope.responsedata.createdOn;
        	$scope.tempComment.updatedOn = $scope.responsedata.updatedOn;
        	$scope.tempComment.id = $scope.responsedata.id;
        	$scope.tempComment.isParentComment = true;
        	if($scope.modelObject.formQuestionCommentDTOs.length != 0){
            	$scope.tempComment.sideCommentParentId = $scope.modelObject.formQuestionCommentDTOs[0].id;
            	$scope.tempComment.isParentComment = false;
            	$scope.hideReply();
        	}

        	$scope.modelObject.formQuestionCommentDTOs.push($scope.tempComment);
        	if(!$scope.mediaCheck('gt-sm')) {
  	  			$scope.limit = $scope.modelObject.formQuestionCommentDTOs.length;
  	  		}
        	$scope.replyComment="";
        	$scope.copyModelObject = angular.copy($scope.modelObject);
        };
        
        /**
         * To Save Parent Comment
         */
        $scope.saveParentComment = function(comment){
        	var dataObj = {};
        	var formId = $scope.investigationId;
        	var responseData = {};

        	dataObj.type = $scope.formName;
        	dataObj.accordionIndex = $scope.accordionIndex;
        	dataObj.formQuestionDTOs = [];
        	
        	var tempObj ={};
        	tempObj.questionKey = $scope.questionName;
        	tempObj.formQuestionCommentDTOs =[];
        	
        	var tempComment = {};
        	tempComment.commentData = comment;
        	
        	tempObj.formQuestionCommentDTOs.push(tempComment);
        	dataObj.formQuestionDTOs.push(tempObj);
       	
        	var data = SideCommentsDirectiveService.saveParentComment($scope.investigationId,dataObj);
        	data.then(function(response){
        		$scope.responsedata = response;
        		//$rootScope.getSectionDTOs($scope.investigationId,$scope.formName,$scope.accordionIndex);
        		$scope.setCommentObject(comment);
 		  	}, function(reason) {
 			  return reason;
 		  	});
        };
        
        /**
         * To save a child comment
         */
        $scope.saveChildComment =function(comment){
        	var parentId = $scope.modelObject.formQuestionCommentDTOs[0].id;
        	var dataObj ={};
        	var responseData = {};
        	var formId = $scope.investigationId;
        	dataObj.questionKey = $scope.questionName;
        	dataObj.formQuestionCommentDTOs =[];
        	
        	var tempComment = {};
        	tempComment.commentData = comment;
        	tempComment.sideCommentParentId = parentId;
        	
        	dataObj.formQuestionCommentDTOs.push(tempComment);
        	
        	var data = SideCommentsDirectiveService.saveChildComment(formId,dataObj,parentId);
 		  	data.then(function(response){
 		  		$scope.responsedata = response;
 		  		//$rootScope.getSectionDTOs($scope.investigationId,$scope.formName,$scope.accordionIndex);
        		$scope.setCommentObject(comment);
 		  	}, function(reason) {
 			  return reason;
 		  	});
        };
                
        /**
         * Clear Text Field
         */
        $scope.clearTxt = function(comment){
        	comment = "";
        	$scope.commentContent = "";
        };
        
        /**
         * To Delete a comment
         */
        $scope.deleteComment = function(commentSortId,commentId){
        	$scope.openPopup = false;
        	$scope.arrayIndex = "";
        	var data = SideCommentsDirectiveService.getSideCommentsBySectionQuestion($scope.investigationId,$scope.formName,$scope.accordionIndex,$scope.questionName);
        	data.then(function(response){
        		$scope.modelObject = response;
        		
        		if(angular.equals($scope.modelObject,{})){
        			$scope.setEmptyModelObject();
        		}else{
        			var parentId = $scope.modelObject.formQuestionCommentDTOs[0].id;
        		}
        		
            	if(commentSortId == 0 && $scope.modelObject.formQuestionCommentDTOs.length != 0){
            		//call Parent delete api
                	SideCommentsDirectiveService.deleteParentComment($scope.investigationId,parentId);
            		$scope.modelObject.formQuestionCommentDTOs = [];
            		$scope.limit = 3;
            	}else if($scope.modelObject.formQuestionCommentDTOs.length > 1 && commentSortId < $scope.modelObject.formQuestionCommentDTOs.length){
            		//commentSortId--;
                	SideCommentsDirectiveService.deleteChildComment(parentId,commentId);

                	angular.forEach($scope.modelObject.formQuestionCommentDTOs,function(data,key){
                		if(data.id == commentId) {
                			$scope.arrayIndex = key;
                		}
                	});
                	
                	$scope.modelObject.formQuestionCommentDTOs.splice($scope.arrayIndex,1);
                	for(var i=0;i < $scope.modelObject.formQuestionCommentDTOs.length;i++){
                		$scope.modelObject.formQuestionCommentDTOs[i].sortOrder = i;
                	}
            	}
            	$scope.copyModelObject = angular.copy($scope.modelObject);
        	});
        };
                
        /**
         * To return true value if the variable is Undefined/Null/Empty
         */
        angular.isUndefinedOrNull = function(val) {
	  	    return angular.isUndefined(val) || val == "" || val == null
	  	};
	  	
	  	/**
	  	 * To close the pop-up screen for moible or Ipad
	  	 */
	  	$scope.closeMobileSideComment = function(){
    		$mdDialog.cancel();
    	};
    	
    	/**
    	 * To Create Empty Model Object
    	 */
	  	$scope.setEmptyModelObject = function(){
	  		var tempObj = {};
  			tempObj.questionKey = $scope.questionName;
  			tempObj.formQuestionCommentDTOs = [];
  			$scope.modelObject = tempObj;
	  	};
	  	
	  	/**
	  	 * Init function
	  	 */
	  	$scope.getModelObject = function(){
	  		
	  		if($scope.objectList && $scope.objectList.length != 0){	  			
	  			angular.forEach($scope.objectList, function(data, key) {
    				if(data.questionKey == $scope.questionName){
    					$scope.modelObject = {};
    					$scope.modelObject = data;    	
    					$scope.copyModelObject = angular.copy($scope.modelObject);
    				}
    			});
	  		}
	  		
	  		$scope.popupId = $scope.questionName+$scope.accordionIndex;
	  		
	  		if(angular.isUndefinedOrNull($scope.modelObject)){
	  			$scope.setEmptyModelObject();
	  		}
	  	};
	  	//init call
	  	$scope.getModelObject();
	  	    
          $scope.changeVisibilityFalse = function(){
              $rootScope.sideCommentVisible = false;
          };
          
          $scope.changeVisibilityTrue = function(){
              $rootScope.sideCommentVisible = true;
          };

          /**
           * To open the pop-up for mobile designs
           */
          $scope.showMobileSideComment = function(ev,id){
  	  		$scope.showAllComments();
  	  		$scope.loader = false;
  	  		$scope.editLoader = false;
      		$mdDialog.show({                   
                  targetEvent: ev,
                  contentElement: '#'+id,
                  parent: angular.element(document.body),
                  clickOutsideToClose:true,
                  escapeToClose: true
             });
      	};
      	
	  	
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('SideCommentsDirectiveService', SideCommentsDirectiveService);

    SideCommentsDirectiveService.$inject = ['$resource', 'restService', '$q'];
    
    function SideCommentsDirectiveService ($resource, restService, $q) {
    	
    	/**
    	 * To get the sideComments
    	 */
		this.getSideComments = function(formId,section) {
			var deferred = $q.defer();
    		var url = "side-comment/"+formId+"/"+section;
    		var data = restService.restCall("",url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
		}
		
		/**
		 * To Save the Parent Comment
    	 * @param formId - investigationId
    	 * @param dataObj - Save Object
		 */
		this.saveParentComment = function(formId,dataObj){
    		var deferred = $q.defer();
    		var url = "side-comment-parent/"+formId;
    		var data = restService.restCall(dataObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To Save the child comment
    	 * @param formId - investigationId
    	 * @param dataObj - Save Object
    	 * @param parentId - Parent Comment Id
    	 */
    	this.saveChildComment = function(formId,dataObj,parentId){
    		var deferred = $q.defer();
    		var url = "side-comment-child/"+formId+"/"+parentId;
    		var data = restService.restCall(dataObj, url, 'POST');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To delete a Parent Comment
    	 * @param formId - investigationId
    	 * @param parentId - Parent Comment Id
    	 */
    	this.deleteParentComment = function(formId,parentId){    		
    		var deferred = $q.defer();
    		var url = "side-comment-parent/"+formId+"/"+parentId+"/delete";
    		var data = restService.restCall("", url, 'DELETE');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To delete a Child Comment
    	 * @param commentId - Child comment Id which is to be deleted
    	 * @param parentId - Parent Comment Id
    	 */
    	this.deleteChildComment = function(parentId,commentId){    		
    		var deferred = $q.defer();
    		var url = "side-comment-child/"+parentId+"/"+commentId+"/delete";
    		var data = restService.restCall("", url, 'DELETE');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To Update a parent comment
    	 */
    	this.updateParentComment = function(formId,parentId,dataObj){
    		var deferred = $q.defer();
    		var url = "side-comment-parent/"+formId+"/"+parentId;
    		var data = restService.restCall(dataObj, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To Update a Child Comment
    	 */
    	this.updateChildComment = function(formId,parentId,commentId,dataObj){
    		var deferred = $q.defer();
    		var url = "side-comment-child/"+formId+"/"+parentId+"/"+commentId;
    		var data = restService.restCall(dataObj, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * To delete side comments using section and accoidionIndex
    	 */
    	this.deleteCommentsByIndex = function(formId,section,accordionIndex){
    		var deferred = $q.defer();
    		var url = "side-comment/"+formId+"/"+section+"/"+accordionIndex+"/";
    		var data = restService.restCall("", url, 'DELETE');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * Get side comments using section, accordionIndex and question
    	 */
    	this.getSideCommentsBySectionQuestion = function(formId,section,accordionIndex,question) {
    		var deferred = $q.defer();
    		var url = "side-comment-parent/"+formId+"/"+section+"/"+accordionIndex+"/"+question;
    		var data = restService.restCall("",url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	/**
    	 * Get side comments using section and accordionIndex
    	 */
    	this.getSideCommentsBySectionIndex = function(formId,section,accordionIndex) {
    		var deferred = $q.defer();
    		var url = "side-comment/"+formId+"/"+section+"/"+accordionIndex;
    		var data = restService.restCall("",url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
		
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('NeighbourhoodCanvasController', NeighbourhoodCanvasController);
	NeighbourhoodCanvasController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','NeighbourhoodCanvasService','InvestigationFormService','$stateParams','$timeout','Upload','$mdDialog','$rootScope'];
	function NeighbourhoodCanvasController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,NeighbourhoodCanvasService,InvestigationFormService,$stateParams,$timeout,Upload,$mdDialog,$rootScope) {
		
		var vm = this;
		vm.dateOfVisit = '';
		vm.app = APP;
    	$scope.declarationDate = undefined;
        $scope.neighbourhoodCanvasForm = {};
        $scope.neighbourhoodCanvasForm.sections = [];
        //$scope.neighbourhoodCanvasForm.sections.questions = [];
        $scope.neighbourhoodCanvasForm.summary = {};
        $scope.loadingNeighbourhood = false;
        vm.entityLocationObject = {};
		vm.entityLocationObject.countryObj = {};
		vm.entityLocationObject.provinceObj = {};
		vm.entityLocationObject.cityObj = {};
		vm.entityLocationObject.sectorObj = {};
        vm.inputSearchObject = {};
        vm.LocationObject = {};
        $scope.interviewFlag = true;
        $scope.disablesaveflag = false;
        var oldFormData = {};
        vm.APP = APP;
        
        vm.loadNeighbourhoodCanvasFormDetails = function(){
          $scope.loadingNeighbourhood = true;
          vm.getNeighborhoodCanvassDetails();
     	 
        };
        
        vm.getNeighborhoodCanvassDetails = function (){
  		   var sectionKey = vm.app.REF_TERM.NEIGHBORHOOD_CANVAS;
  		   var formId = $scope.investigationFormId;
      	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
  		  	data.then(function(response){
  		  		if(response.formVersion != null){
   		  			$scope.formVersion = response.formVersion;
   		  		}
  		  		if(response.sectionId != null){
		  			$scope.neighbourhoodSectionId = response.sectionId;
		  		}
  		  		if(response.formDTO == null){
  		  		   var tempObj = {};
  		     	   tempObj.questions = [];
  		     	   $scope.neighbourhoodCanvasForm.sections.push(tempObj);
  		  		} else if(response.formDTO.sections.length == 0) {
				  	   if(response.formDTO.summary){
						     var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.neighbourhoodCanvasForm.sections.push(tempObj);
				  	           $scope.neighbourhoodCanvasForm.summary = response.formDTO.summary;
				  	   } else {
						  	   var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.neighbourhoodCanvasForm.sections.push(tempObj);
				  	   }
		  	    } else {
  		  			$scope.neighbourhoodCanvasForm = angular.copy(response.formDTO); 		  			
	  		  		$scope.setUpOldFormData();
  		  			$scope.setLocationResponse(0);	
  		  		}
  		  	    //Set the object to restrict the initial save call
  		  		oldFormData = angular.copy(response.formDTO);
  		  		$scope.loadingNeighbourhood = false;
		  		$scope.updateLastEditTime(response.updatedOn);
  		   }, function(reason) {
  			  return reason;
  		   });
        };
        
        /* Method name          : saveNeighbourhoodCanvasFormDetails()
         * Method Description 	: This method saves the NeighbourhoodCanvas form details 
 	     */
        $scope.saveNeighbourhoodCanvasFormDetails = function(){
           var isPutJsonSimilar = false;
           $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
      	   var saveDataObj = {};
      	   //save location
      	   var formNumber = vm.findOpenform();
      	   //vm.saveLocation(formNumber);
      	   if(formNumber != -1){
      		 $scope.saveLocation(--formNumber);   
      	   }
      	   saveDataObj.formDTO = angular.copy($scope.neighbourhoodCanvasForm);
      	   saveDataObj.formVersion = $scope.formVersion;
      	   saveDataObj.investigationFormId = $scope.investigationFormId;
      	   saveDataObj.sectionId = $scope.neighbourhoodSectionId;
	      	 for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
	             if(!saveDataObj.formDTO.sections[i].questions){
	                 saveDataObj.formDTO.sections.splice(i,1);
	                 i--;
	             } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
	                 saveDataObj.formDTO.sections.splice(i,1);
	                 i--;
	             } else {
	                 delete saveDataObj.formDTO.sections[i].expanded;
	                 saveDataObj.formDTO.sections[i].sortOrder = i+1;
	             }
	         }
	      	 
	      	/*	Set the temporary object to avoid unwanted save call. 
  				Fist condition to avoid the initial save call for empty form 
  				Second condition to avoid the initial save call if the section has any form data 
	      	*/
            if(angular.isUndefined($scope.tempNeighbourhoodObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                    (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                $scope.tempNeighbourhoodObj = angular.copy(saveDataObj);
            } else if(angular.isUndefined($scope.tempNeighbourhoodObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
         	   $scope.tempNeighbourhoodObj = angular.copy(saveDataObj);
            } else if(angular.isUndefined($scope.tempNeighbourhoodObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	$scope.tempNeighbourhoodObj = {};
            	$scope.tempNeighbourhoodObj.formDTO = angular.copy(oldFormData);
            }
	      	
            if(!angular.isUndefined($scope.tempNeighbourhoodObj)){
            	if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempNeighbourhoodObj.formDTO))){
            		isPutJsonSimilar = true;	    			   
            	} 
            }
	      	
            if($scope.isOwner){
            	$scope.tempNeighbourhoodObj = angular.copy(saveDataObj);
            } else {
            	$scope.tempNeighbourhoodObj = undefined; //Every time temporary object will be newly updated for non owner  
            }
            
            /* saveData flag - to ensure the save button is clicked in form*/
	       if(!isPutJsonSimilar){
	    	   if($scope.isOwner || $scope.saveData){
	    		   //Flag to set the section results are edited or not
	    		   if(angular.isDefined($scope.neighbourhoodCheckList) && angular.isDefined($scope.neighbourhoodCheckListTempObj) && !angular.equals($scope.neighbourhoodCheckList, $scope.neighbourhoodCheckListTempObj)) {
	    			   saveDataObj.isFormSectionResultEdited = true;
	    			   $scope.saveAnalystFormTypeCheckList('neighbourhood', true, false);
	    		   }
	    		   
	    		   var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		   		  	data.then(function(response){
		  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.NEIGHBOURHOOD_STATE)
		  		  		{
		  		  			$scope.updateLastEditTime(response.updatedOn);
		  		  		}
		  		  		$scope.uploadFileStatusUpdated();
		   		  }, function(reason) {
		   			  return reason;
		   		  }); 
	    	   }
	    	   $rootScope.warningPopup.show = true;
	       } else if(($scope.isOwner || $scope.saveData) && angular.isDefined($scope.neighbourhoodCheckList) && angular.isDefined($scope.neighbourhoodCheckListTempObj) 
	    		   && !angular.equals($scope.neighbourhoodCheckList, $scope.neighbourhoodCheckListTempObj)) {
			   $scope.saveAnalystFormTypeCheckList('neighbourhood', true);
		   }
         };
         
         /**
          * Save the Location Object
          */
         $scope.saveLocation = function(index){    	 
        	 //for(var i=0;i<$scope.neighbourhoodCanvasForm.sections.length;i++){
        	 var i = index;
      		   if($scope.neighbourhoodCanvasForm.sections[i].questions[0] && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1){
      			   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1.answer == 'answer_yes'){
      				   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a = {};
      				   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b = {};
      				   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c = {};
      				   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d = {};
      				   
          			   if(vm.entityLocationObject.countryObj && !vm.inputSearchObject.isAddOrSaveLocationCountry && vm.entityLocationObject.countryObj.countryTxt != null && vm.entityLocationObject.countryObj.countryTxt != ''){
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer = vm.entityLocationObject.countryObj.countryTxt;
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.subAnswer = vm.entityLocationObject.countryObj.countryId;
          			   }else if(vm.inputSearchObject.isAddOrSaveLocationCountry && vm.inputSearchObject.countrySearchKey != null && vm.inputSearchObject.countrySearchKey != ''){
          				   	 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer = vm.inputSearchObject.countrySearchKey;
                		    // $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.subAnswer = null;
          			   }/*else{
          				     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer = null;
                  		     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.subAnswer = null;
          			   }*/
          			   
          			   if(vm.entityLocationObject.provinceObj && !vm.inputSearchObject.isAddOrSaveLocationProvince && vm.entityLocationObject.provinceObj.provinceTxt != null && vm.entityLocationObject.provinceObj.provinceTxt != ''){
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer = vm.entityLocationObject.provinceObj.provinceTxt;
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.subAnswer = vm.entityLocationObject.provinceObj.provinceId;
  	  	  			   }else if(vm.inputSearchObject.isAddOrSaveLocationProvince && vm.inputSearchObject.provinceSearchKey != null && vm.inputSearchObject.provinceSearchKey != ''){
	  	  	  				 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer = vm.inputSearchObject.provinceSearchKey;
	  	  	  				 //$scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.subAnswer = null;
  	  	  			   }/*else{
  	    				     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer = null;
  	            		     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.subAnswer = null;
  	    			   }*/
          			   
          			   if(vm.entityLocationObject.cityObj && !vm.inputSearchObject.isAddOrSaveLocationCity && vm.entityLocationObject.cityObj.cityTxt != null && vm.entityLocationObject.cityObj.cityTxt != ''){
    	          			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer = vm.entityLocationObject.cityObj.cityTxt;
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.subAnswer = vm.entityLocationObject.cityObj.cityId;
  	  	  			   }else if(vm.inputSearchObject.isAddOrSaveLocationCity && vm.inputSearchObject.citySearchKey != null && vm.inputSearchObject.citySearchKey != ''){
	  	  	  				 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer = vm.inputSearchObject.citySearchKey;
	  	  	  				// $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.subAnswer = null;
  	  	  			   }/*else{
  	    				     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer = null;
  	            		     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.subAnswer = null;
  	    			   }*/
          			 
          			   if(vm.entityLocationObject.sectorObj && !vm.inputSearchObject.isAddOrSaveLocationSector && vm.entityLocationObject.sectorObj.sectorTxt != null && vm.entityLocationObject.sectorObj.sectorTxt != ''){
    	         			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer = vm.entityLocationObject.sectorObj.sectorTxt;
                			 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.subAnswer = vm.entityLocationObject.sectorObj.sectorId;
  	  	 			   }else if(vm.inputSearchObject.isAddOrSaveLocationSector && vm.inputSearchObject.sectorSearchKey != null && vm.inputSearchObject.sectorSearchKey != ''){
	  	  	 				 $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer = vm.inputSearchObject.sectorSearchKey;
	  	  	 				 //$scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.subAnswer = null;
  	  	 			   }/*else{
  	    				     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer = null;
  	            		     $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.subAnswer = null;
  	    			   }*/
          			   //Set the requested flag
          			   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.requested = false;
          			   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.requested = false;
          			   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.requested = false;
          			   $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.requested = false;
      			   }
      		   }        		          		   
      	   //}
         };
         
         vm.initializeLocations = function(){
        	 vm.inputSearchObject = {  
           		  "country": "",
           		  "countrySearchKey": "",
           		  "isAddOrSaveLocationCountry": false,
           		  "isAddOrSaveLocationProvince": false,
           		  "isAddOrSaveLocationCity": false,
           		  "isAddOrSaveLocationSector": false,
           		  "citySearchKey": "",
           		  "sectorSearchKey": "",
           		  "provinceSearchKey": "",
           		  "province": "",
           		  "city": "",
           		  "sector": ""};
           vm.LocationObject = {
       		"sectorObj": {
   						"sectorTxt": null,
   						"sectorId":null
   				},
   			"countryObj": {
   					    "countryTxt": null,
   					    "countryId": null
   				  		},
   			"provinceObj": {       			    
   					    "provinceTxt": null,
   					    "provinceId": null
   					  },
   			"cityObj": {
   					    "cityTxt": null,
   					    "cityId": null
   					  }
   				};
         };
         
         $scope.setLocationResponse = function(index){
        	 //for(var i=0;i<$scope.neighbourhoodCanvasForm.sections.length;i++){
        	 var i = index;
        	 vm.initializeLocations();
        	 if($scope.neighbourhoodCanvasForm != null && $scope.neighbourhoodCanvasForm.sections != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0] && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1){
        		 
	      		   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1.answer == 'answer_yes'){
	      			   
      			   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.subAnswer != null){
      				 vm.LocationObject.countryObj.countryTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer;
        			 vm.LocationObject.countryObj.countryId = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.subAnswer;
      			   }else if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer != null){
					vm.LocationObject.countryObj.countryTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer; 
					vm.inputSearchObject.isAddOrSaveLocationCountry = true;
      				 vm.inputSearchObject.countrySearchKey = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1a.answer;
      			   }
      			   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.subAnswer != null){
      				 vm.LocationObject.provinceObj.provinceTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer;
        			 vm.LocationObject.provinceObj.provinceId = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.subAnswer;
      			   }else if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer != null){
					vm.LocationObject.provinceObj.provinceTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer; 
					vm.inputSearchObject.isAddOrSaveLocationProvince = true;
      				 vm.inputSearchObject.provinceSearchKey = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1b.answer;
      			   }
      			   
      			   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.subAnswer != null){
      				 vm.LocationObject.cityObj.cityTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer;
       			     vm.LocationObject.cityObj.cityId = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.subAnswer;
      			   }else if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer != null){
					vm.LocationObject.cityObj.cityTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer; 
					vm.inputSearchObject.isAddOrSaveLocationCity = true;
      				 vm.inputSearchObject.citySearchKey = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1c.answer;
      			   }
      			   
      			   if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.subAnswer != null){
      				 vm.LocationObject.sectorObj.sectorTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer;
        			 vm.LocationObject.sectorObj.sectorId = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.subAnswer;
      			   }else if($scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d != null && $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer != null){
					vm.LocationObject.sectorObj.sectorTxt = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer;
					vm.inputSearchObject.isAddOrSaveLocationSector = true;
      				 vm.inputSearchObject.sectorSearchKey = $scope.neighbourhoodCanvasForm.sections[i].questions[0].neighborhood_1d.answer;
      			   }
	      		   }
             	}
		        	$timeout(function(){
	  					vm.setOpenFormLocation();
						$rootScope.triggerPopulatePreFillDetails(vm.LocationObject.countryObj, vm.LocationObject.provinceObj, vm.LocationObject.cityObj, vm.LocationObject.sectorObj);
	  					$rootScope.loadValid();
						},500);       	 
         };
         
         vm.setOpenFormLocation = function(){
        	 
        		  vm.entityLocationObject.countryObj = vm.LocationObject.countryObj;
		  		  vm.entityLocationObject.provinceObj = vm.LocationObject.provinceObj;
		  		  vm.entityLocationObject.cityObj = vm.LocationObject.cityObj;
		  		  vm.entityLocationObject.sectorObj = vm.LocationObject.sectorObj;
        	 
         };
         
         vm.findOpenform = function(){
        	 if($scope.neighbourhoodCanvasForm.sections.length > 1){
        		 var j = -1;
        		 for(var i = 0;i < $scope.neighbourhoodCanvasForm.sections.length;i++){
            		 if($scope.neighbourhoodCanvasForm.sections[i].expanded == true){
            			 return ++i;
            		 }
            	 } 
        		 return j;
        	 }
        	 return 1;
         };
         
         vm.saveLocation = function(openForm){
        	 var i = 0;
        	 if(openForm != 1){
        		 i = --openForm;
        	 } 
        	 vm.LocationObject[i].countryObj = vm.entityLocationObject.countryObj;
        	 vm.LocationObject[i].provinceObj = vm.entityLocationObject.provinceObj;
        	 vm.LocationObject[i].cityObj = vm.entityLocationObject.cityObj;
        	 vm.LocationObject[i].sectorObj = vm.entityLocationObject.sectorObj;
         };
         
         vm.interviewFlag = function(flag, index){
        	 $scope.interviewFlag = flag;
        	 if(index){
        		 $scope.sectionIndex = index; 
        	 }
          };
         
         vm.addAdditionalInterviewForm = function(){
             var testObj = {};
             if($scope.interviewFlag == 1){
            	 $scope.neighbourhoodCanvasForm.sections[0].questions[0].neighborhood_1.interviews.push(testObj);
             }
             if($scope.interviewFlag == 2){
            	 if($scope.sectionIndex){
            		 $scope.neighbourhoodCanvasForm.sections[$scope.sectionIndex].questions[0].neighborhood_1.interviews.push(testObj);
            	 }
             }
         };
          
         vm.loadLocations = function(index){
        	 var formNumber = vm.findOpenform();
        	 formNumber--;
        	 if(formNumber > 0){
        		 $scope.saveLocation(formNumber); 
        	 }
        	 $scope.setLocationResponse(index);
         };
         
          /* Method name           : collapseAll()
      	 * Method Description 	 : This method is used to collapse the accordion 
  		 */
          vm.collapseAll = function(index, flag){
        	  var height = 0;
        	  vm.loadLocations(index);
	            for(var i=0;i<$scope.neighbourhoodCanvasForm.sections.length;i++){
	            	 if(flag==0){
	 	            	height = height + $('.acc_'+index).closest('.md-accordion').offsetHeight + 42;
	 	            }
	 	            else{
	 	            	height = height + $('.acc_'+index).closest('.md-accordion')[0].offsetHeight + 42;
	 	            }
	            if(i == index){
	   	             if(!$scope.neighbourhoodCanvasForm.sections[i].expanded){
	   	            	 	$scope.formViewCall(index);
			   	            $scope.neighbourhoodCanvasForm.sections[i].expanded = !$scope.neighbourhoodCanvasForm.sections[i].expanded;
			                $('#neighbourhoodCanvas').animate({scrollTop: height}, 'slow');
			                
			                //Calling get documents based on accordion index
			                $scope.getUploadFiles(null,vm.app.REF_TERM.NEIGHBORHOOD_CANVAS,index)
	   	             }else{
	   	            	    $scope.neighbourhoodCanvasForm.sections[i].expanded = !$scope.neighbourhoodCanvasForm.sections[i].expanded;
	   	             }
	            } else {
	            		$scope.neighbourhoodCanvasForm.sections[i].expanded = false;
	            	}
	            if($scope.neighbourhoodCanvasForm.sections[i].expanded){
           	    	$scope.openAccordionIndex = i;
           	    }
	            }
         };
         
         
         /* Method name           : addAdditionalInstitutionForm()
          * Method Description 	: This method adds Neighborhood canvas form to list of birth certificate form 
  	    */
         vm.addAdditionalInstitutionForm = function(){
             var tempObj = {};
             tempObj.questions = [];
             tempObj.expanded = false;
             $scope.neighbourhoodCanvasForm.sections.push(tempObj);
             vm.collapseAll($scope.neighbourhoodCanvasForm.sections.length - 1,0);
         };
         
         /* Method name           : removeBirthCertificateForm()
          * Method Description 	: This method removes the added Neighborhood canvas form from list of birth certificate form
  	    */
         /*vm.removeneighbourhoodCanvasForm = function(index){
      	   $scope.neighbourhoodCanvasForm.sections.splice(index,1);
         };*/
         vm.removeneighbourhoodCanvasForm = function(ev,id,indexValue){
        	 $scope.indexVal = indexValue; 
        	 $mdDialog.show({
        		 contentElement: angular.element('#'+id),
        		 targetEvent: ev,
        		 clickOutsideToClose: false,
        		 escapeToClose: false
        	 })
         };
         
         vm.closeConform = function(index){
        	 $scope.deleteLoader.flag = true;
         	$mdDialog.hide();
         	$scope.neighbourhoodCanvasForm.sections.splice(index,1);
         	if(index != 0){
           		vm.collapseAll(index-1,1);
           	}
         	 $scope.enableDeleteButton();
         };
         
         vm.closeCancel = function(){
         	$mdDialog.cancel();
         	$scope.interviewFlag = true;
         };
         
         /* File Upload Sections */
         
         vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
     		$("#neighborhoodSectionSummary").val(null);
  	        $('#neighborhoodSectionSummary').trigger('click'); 
  	        $('#neighborhoodSectionSummary').off('change').on('change', function() {
	  	    	var file = this.files[0];
	     		var sectionId = $scope.neighbourhoodSectionId;
	     		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.NEIGHBORHOOD_CANVAS);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null);
	        });
  		};

		vm.nextInvestigationForm = function(){
			//$scope.saveAnalystFormTypeCheckList('neighbourhood');
			$scope.disablesaveflag = true;
			$scope.saveData = true;
			$scope.saveNeighbourhoodCanvasFormDetails();
			$rootScope.warningPopup.show = false;
			$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.FAMILY_FORM);
			//$state.go("familyInformation");
			if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(3);
			}
			$scope.updateLastEditTime(null);
		};
		
		vm.deleteIndex = function(event,id,index){
			//$scope.saveNeighbourhoodCanvasFormDetails();		
			$scope.indexVal = index;
			$scope.interviewFlag = false;
			$mdDialog.show({
				contentElement: angular.element('#'+id),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false,
				onRemoving: function (event, removePromise) {
					vm.closeCancel();
				}
			});
			//vm.getNeighborhoodCanvassDetails();
		};
       	 
       	vm.deleteInterviewConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		/*var formNumber = vm.findOpenform();
       	    formNumber--;
       	    $scope.neighbourhoodCanvasForm.sections[formNumber].questions[0].neighborhood_1.interviews.splice(index,1);*/
       		if($scope.neighbourhoodCanvasForm.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.neighbourhoodCanvasForm.sections[$scope.openAccordionIndex].questions[0].neighborhood_1.interviews.splice(index,1);
       	    vm.closeCancel();
       	    $scope.enableDeleteButton();
       	};
		

           
		 /* Method Description 	: This method triggers auto save form */

	       $scope.$watch('neighbourhoodCanvasAutoSave', function(newValue, oldValue) {
				if(newValue != undefined && newValue != oldValue){									
						if($scope.isOwner && newValue){
							if($scope.formVersion && !$scope.isreadonly){
								$scope.saveNeighbourhoodCanvasFormDetails();
								$rootScope.neighbourhoodCanvasAutoSave = false;
							} else{
								$rootScope.neighbourhoodCanvasAutoSave = false;
							}
						}else{
							$rootScope.neighbourhoodCanvasAutoSave = false;
						}				
				}
			});
	       
	       /**
	   		* To find which accordion is open currently
	   		*/	
			vm.findOpenform = function(){
	        	 if($scope.neighbourhoodCanvasForm.sections.length > 1){
	        		 var j = -1;
	        		 for(var i = 0;i < $scope.neighbourhoodCanvasForm.sections.length;i++){
	            		 if($scope.neighbourhoodCanvasForm.sections[i].expanded == true){
	            			 return ++i;
	            		 }
	            	 } 
	        		 return j;
	        	 }
	        	 return 1;
	         };
	       
	       /**
	        * 
	        */
	       $scope.formLocationRequest = function($event){
	    	   //$scope.addLocationInputSearchObject = inputSearchObject;
		       $scope.openLocationRequest($event,'locationRequestPopupId',1,vm.inputSearchObject,vm.entityLocationObject);
	       };
	       
	       /**
	        * 
	        */
	       $rootScope.requestSuccess = function(response){
	    	   var openForm = vm.findOpenform();openForm--;
			   if(response.isAlreadyExists && !response.isApproved) {
				$scope.neighbourhoodCanvasForm.sections[openForm].questions[0].neighborhood_1.requestAlreadyApplied = true;
			}
	    	   $scope.neighbourhoodCanvasForm.sections[openForm].questions[0].neighborhood_1.requested = true;
	    	   $scope.neighbourhoodCanvasForm.sections[openForm].questions[0].neighborhood_1.answerId = response.id;
	       };

	     //It will get triggered while exiting from current state
	       $scope.$on('$destroy', function() {
	    	   if(!$scope.isreadonly && $scope.isOwner) {
	    		   $scope.saveNeighbourhoodCanvasFormDetails();
	    	   }
	    	   $rootScope.warningPopup.show = false;
	    	   $scope.uploadedFile = false;
	        });
	       
	       //Check the location request is approved or not?
	       vm.checkLocationRequest = function(question) {
	    	   var openForm = vm.findOpenform();openForm--;
	    	   var data = InvestigationFormService.getRequestProfileById(question.neighborhood_1.answerId);
	    	   data.then(function(response) {
	    		   var locationObj = response;
	    		   var currentForm = vm.findOpenform();currentForm--;
	    		   if(currentForm == openForm && locationObj.isApproved) {
	    			   question.neighborhood_1a.answer = locationObj.countryTxt;
	    			   question.neighborhood_1a.subAnswer = locationObj.countryId;
	    			   question.neighborhood_1b.answer = locationObj.provinceTxt;
	    			   question.neighborhood_1b.subAnswer = locationObj.provinceId;
	    			   question.neighborhood_1c.answer = locationObj.cityTxt;
	    			   question.neighborhood_1c.subAnswer = locationObj.cityId;
	    			   question.neighborhood_1d.answer = locationObj.sectorTxt;
	    			   question.neighborhood_1d.subAnswer = locationObj.sectorId;
	    			   question.neighborhood_1.requested = false;
	    			   question.neighborhood_1.subAnswer = "true";
	    			   $scope.setLocationResponse(openForm);
	    			   //Show the nothification message
	    			   notifications.showSuccess({message: vm.APP.LIBRARY.LOCATION_REQUEST});
	    		   } else {
	    			   question.neighborhood_1.subAnswer = "false"; 
	    		   }
	    	   });
	       }
	       
	       //To set the location object while cancel the request popup 
	       $rootScope.setInputObjectAndModel = function(inputSearchObject,locationObject){
	    	   vm.inputSearchObject = angular.copy(inputSearchObject);
	    	   vm.entityLocationObject = angular.copy(locationObject);
	       };
	       
	       //Set up oldFormObject
	       $scope.setUpOldFormData = function() {
	    	   
	    	   angular.forEach(oldFormData.sections, function(data, key){
	    		   vm.initializeLocations();
	    		   
	    		   /*OldFormObject to Temporary variables
	    		    * 
	    		    */
	    		   if(data.questions[0] && data.questions[0].neighborhood_1){
		      		   if(data.questions[0].neighborhood_1.answer == 'answer_yes'){
		      			   if(data.questions[0].neighborhood_1a != null &&  data.questions[0].neighborhood_1a.subAnswer != null){
		      				 vm.LocationObject.countryObj.countryTxt =  data.questions[0].neighborhood_1a.answer;
		        			 vm.LocationObject.countryObj.countryId =  data.questions[0].neighborhood_1a.subAnswer;
		      			   }else if( data.questions[0].neighborhood_1a != null &&  data.questions[0].neighborhood_1a.answer != null){
		      				 vm.inputSearchObject.isAddOrSaveLocationCountry = true;
		      				 vm.inputSearchObject.countrySearchKey =  data.questions[0].neighborhood_1a.answer;
		      			   }
		      			   if( data.questions[0].neighborhood_1b != null &&  data.questions[0].neighborhood_1b.subAnswer != null){
		      				 vm.LocationObject.provinceObj.provinceTxt =  data.questions[0].neighborhood_1b.answer;
		        			 vm.LocationObject.provinceObj.provinceId =  data.questions[0].neighborhood_1b.subAnswer;
		      			   }else if( data.questions[0].neighborhood_1b != null &&  data.questions[0].neighborhood_1b.answer != null){
		      				 vm.inputSearchObject.isAddOrSaveLocationProvince = true;
		      				 vm.inputSearchObject.provinceSearchKey =  data.questions[0].neighborhood_1b.answer;
		      			   }
		      			   
		      			   if( data.questions[0].neighborhood_1c != null &&  data.questions[0].neighborhood_1c.subAnswer != null){
		      				 vm.LocationObject.cityObj.cityTxt =  data.questions[0].neighborhood_1c.answer;
		       			     vm.LocationObject.cityObj.cityId =  data.questions[0].neighborhood_1c.subAnswer;
		      			   }else if( data.questions[0].neighborhood_1c != null &&  data.questions[0].neighborhood_1c.answer != null){
		      				 vm.inputSearchObject.isAddOrSaveLocationCity = true;
		      				 vm.inputSearchObject.citySearchKey =  data.questions[0].neighborhood_1c.answer;
		      			   }
		      			   
		      			   if( data.questions[0].neighborhood_1d != null &&  data.questions[0].neighborhood_1d.subAnswer != null){
		      				 vm.LocationObject.sectorObj.sectorTxt =  data.questions[0].neighborhood_1d.answer;
		        			 vm.LocationObject.sectorObj.sectorId =  data.questions[0].neighborhood_1d.subAnswer;
		      			   }else if( data.questions[0].neighborhood_1d != null &&  data.questions[0].neighborhood_1d.answer != null){
		      				 vm.inputSearchObject.isAddOrSaveLocationSector = true;
		      				 vm.inputSearchObject.sectorSearchKey =  data.questions[0].neighborhood_1d.answer;
		      			   }
		      			   
		      			   /*
		      			    * Set the organized values to the oldFormObject
		      			    * 
		      			    * */
		      			   
	      				    data.questions[0].neighborhood_1a = {};
	      				    data.questions[0].neighborhood_1b = {};
	      				    data.questions[0].neighborhood_1c = {};
	      				    data.questions[0].neighborhood_1d = {};
	      				    
	      				   
	          			   if(vm.LocationObject.countryObj && !vm.inputSearchObject.isAddOrSaveLocationCountry){
	                			  data.questions[0].neighborhood_1a.answer = vm.LocationObject.countryObj.countryTxt;
	                			  data.questions[0].neighborhood_1a.subAnswer = vm.LocationObject.countryObj.countryId;
	          			   }else if(vm.inputSearchObject.isAddOrSaveLocationCountry){
	          				   	  data.questions[0].neighborhood_1a.answer = vm.inputSearchObject.countrySearchKey;
	                		      data.questions[0].neighborhood_1a.subAnswer = null;
	          			   }else{
	          				      data.questions[0].neighborhood_1a.answer = null;
	                  		      data.questions[0].neighborhood_1a.subAnswer = null;
	          			   }
	          			   
	          			   if(vm.LocationObject.provinceObj && !vm.inputSearchObject.isAddOrSaveLocationProvince){
	                			  data.questions[0].neighborhood_1b.answer = vm.LocationObject.provinceObj.provinceTxt;
	                			  data.questions[0].neighborhood_1b.subAnswer = vm.LocationObject.provinceObj.provinceId;
	  	  	  			   }else if(vm.inputSearchObject.isAddOrSaveLocationProvince){
		  	  	  				  data.questions[0].neighborhood_1b.answer = vm.inputSearchObject.provinceSearchKey;
		  	  	  				  data.questions[0].neighborhood_1b.subAnswer = null;
	  	  	  			   }else{
	  	    				      data.questions[0].neighborhood_1b.answer = null;
	  	            		      data.questions[0].neighborhood_1b.subAnswer = null;
	  	    			   }
	          			   
	          			   if(vm.LocationObject.cityObj && !vm.inputSearchObject.isAddOrSaveLocationCity){
	    	          			  data.questions[0].neighborhood_1c.answer = vm.LocationObject.cityObj.cityTxt;
	                			  data.questions[0].neighborhood_1c.subAnswer = vm.LocationObject.cityObj.cityId;
	  	  	  			   }else if(vm.inputSearchObject.isAddOrSaveLocationCity){
		  	  	  				  data.questions[0].neighborhood_1c.answer = vm.inputSearchObject.citySearchKey;
		  	  	  				  data.questions[0].neighborhood_1c.subAnswer = null;
	  	  	  			   }else{
	  	    				      data.questions[0].neighborhood_1c.answer = null;
	  	            		      data.questions[0].neighborhood_1c.subAnswer = null;
	  	    			   }
	          			 
	          			   if(vm.LocationObject.sectorObj && !vm.inputSearchObject.isAddOrSaveLocationSector){
	    	         			  data.questions[0].neighborhood_1d.answer = vm.LocationObject.sectorObj.sectorTxt;
	                			  data.questions[0].neighborhood_1d.subAnswer = vm.LocationObject.sectorObj.sectorId;
	  	  	 			   }else if(vm.inputSearchObject.isAddOrSaveLocationSector){
		  	  	 				  data.questions[0].neighborhood_1d.answer = vm.inputSearchObject.sectorSearchKey;
		  	  	 				  data.questions[0].neighborhood_1d.subAnswer = null;
	  	  	 			   }else{
	  	    				      data.questions[0].neighborhood_1d.answer = null;
	  	            		      data.questions[0].neighborhood_1d.subAnswer = null;
	  	    			   }
	      			   	}
	      		   	}
	    	   	});
	       }
	}
        
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('NeighbourhoodCanvasService', NeighbourhoodCanvasService);

    NeighbourhoodCanvasService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function NeighbourhoodCanvasService ($resource,restService,$q,$rootScope) {
    	
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('other', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/other',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/other/other.html',
                    controller: 'OtherController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("otherForm");
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('OtherController', OtherController);
	
	OtherController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','OtherService','$stateParams','InvestigationFormService','$timeout','$rootScope'];
	function OtherController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,OtherService,$stateParams,InvestigationFormService,$timeout,$rootScope) {
		
		var vm = this;
		vm.app = APP;
		vm.profileForm = $stateParams;
		$scope.otherForm = {};
    	$scope.otherForm.sections = [];
    	$scope.otherForm.sections.questions = [];
    	//$scope.otherForm.summary = {};
    	$scope.loadingOther = false;
    	var oldFormData = {};
    	
    	
           vm.loadOther = function(){
        	   $scope.loadingOther = true;
    		   vm.getOtherDetails();
          	 
             };   
           
             vm.getOtherDetails = function (){
          	   $scope.loadingOther = true;
        	   var sectionKey = vm.app.REF_TERM.OTHER;
    		   var formId = $scope.investigationFormId;
        	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
    		  	data.then(function(response){
    		  		if(response.formVersion != null){
     		  			$scope.formVersion = response.formVersion;
     		  		}
    		  		if(response.sectionId != null){
     		  			$scope.otherSectionId = response.sectionId;
     		  		}
    		  		if(response.formDTO == null){
    		  		   var tempObj = {};
    		     	   tempObj.questions = [];
    		     	   $scope.otherForm.sections.push(tempObj);
    		  		} else if(response.formDTO.sections.length == 0) {
					  	   var tempObj = {};
					  	   tempObj.questions = [];
			  	           $scope.otherForm.sections.push(tempObj);
    				  	   
    		  	    }else {
    		  			$scope.otherForm = response.formDTO;    		  			
    		  		}
    		  	    //Set the object to restrict the initial save call
		  			oldFormData = angular.copy(response.formDTO);
    		  		$scope.loadingOther = false;
    		  		$scope.updateLastEditTime(response.updatedOn);
    		  		
    		   }, function(reason) {
    			  return reason;
    		   });
           };
          
       /* Method name              : saveOtherDetails()
        * Method Description 	   : This method saves the other form details 
        */      
    	$scope.saveOtherDetails = function(){
    	   var isPutJsonSimilar = false;
    	   $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
      	   var saveDataObj = {};
      	   saveDataObj.formDTO = angular.copy($scope.otherForm);
      	   saveDataObj.formVersion = $scope.formVersion;
      	   saveDataObj.investigationFormId = $scope.investigationFormId;
      	   saveDataObj.sectionId = $scope.otherSectionId;
	      	 for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
	             if(!saveDataObj.formDTO.sections[i].questions){
	                 saveDataObj.formDTO.sections.splice(i,1);
	             } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
	                 saveDataObj.formDTO.sections.splice(i,1);
	             } else {
	                 delete saveDataObj.formDTO.sections[i].expanded;
	                 saveDataObj.formDTO.sections[i].sortOrder = i+1;
	             }
	         }
	      	 
	      	 /*	Set the temporary object to avoid unwanted save call. 
   				Fist condition to avoid the initial save call for empty form 
   				Second condition to avoid the initial save call if the section has any form data 
	      	 */
             if(angular.isUndefined($scope.tempOtherObj) && saveDataObj.formDTO.sections.length == 0) {
                 $scope.tempOtherObj = angular.copy(saveDataObj);
             } else if(angular.isUndefined($scope.tempOtherObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
          	   $scope.tempOtherObj = angular.copy(saveDataObj);
             } else if(angular.isUndefined($scope.tempOtherObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	 $scope.tempOtherObj = {};
            	 $scope.tempOtherObj.formDTO = angular.copy(oldFormData);
             } 

             if(!angular.isUndefined($scope.tempOtherObj)){
            	 if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempOtherObj.formDTO))){
            		 isPutJsonSimilar = true;	    			  
            	 } 
             }
             if($scope.isOwner){
            	 $scope.tempOtherObj = angular.copy(saveDataObj);
             } else {
            	 $scope.tempOtherObj = undefined; //Every time temporary object will be newly updated for non owner 
             }
	      	
	        /* saveData flag - to ensure the save button is clicked in form*/
	       if(!isPutJsonSimilar){
	    	   if($scope.isOwner || $scope.saveData){
	    		   var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		   		  	data.then(function(response){
		  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.OTHER_STATE)
		  		  		{
		  		  			$scope.updateLastEditTime(response.updatedOn);
		  		  		}
		  		  		$scope.uploadFileStatusUpdated();
		   		  }, function(reason) {
		   			  return reason;
		   		  });
	    	   }
	    	   $rootScope.warningPopup.show = true;
	       }
         };
         
         vm.nextInvestigationForm = function(){
        	$scope.saveData = true;
        	$scope.saveOtherDetails(); 
        	//$state.go("summary");
        	$rootScope.warningPopup.show = false;
			$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.SUMMARY_FORM);
        	if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(9);
			}
			$scope.updateLastEditTime(null);
 		 };
 		
 		 /* File Upload Sections */
         
         
         vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
     		$("#other").val(null);
  	        $('#other').trigger('click'); 
  	        $('#other').off('change').on('change', function() {
	  	    	var file = this.files[0];
	     		var sectionId = $scope.otherSectionId;
	     		$scope.setOrginSectionFileUpload(vm.app.REF_TERM.OTHER);
	     		$scope.uploadFileInSectionSummary(ev,file,vm.app.INVESTIGATION_FORM.SUMMARY_KEY,sectionId,isSummary);
	        });
  		};

  		$scope.other_file_attach = function(element){
     		
  		};

  		/*vm.uploadFileInSectionSummary = function(file){
     		vm.submittedAsset = {};
     		vm.submittedAsset.fileName = file.name;
  		};*/
  			
		$scope.removeAttachment = function(element){
			$(element.target.parentElement).remove();
		};
		
		$rootScope.warningPopup.show = false;
		/* Method Description 	: This method triggers auto save for birth certificate form */
	      $scope.$watch('otherAutoSave', function(newValue, oldValue) {
				if(newValue != undefined && newValue != oldValue){					
					if(newValue && $scope.isOwner){						
							if($scope.formVersion && !$scope.isreadonly){
								$scope.saveOtherDetails();
								$rootScope.otherAutoSave = false;
							} else{
								$rootScope.otherAutoSave = false;
							}
						}else{
							$rootScope.otherAutoSave = false;
						}					
				}
			});
	       
	     //It will get triggered while exiting from current state
	      $scope.$on('$destroy', function() {
	    	  if(!$scope.isreadonly && $scope.isOwner) {
	    		  $scope.saveOtherDetails();
	    	  }
	    	  $rootScope.warningPopup.show = false;
	    	  $scope.uploadedFile = false;
	      });
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('OtherService', OtherService);

    OtherService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function OtherService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('neighbourhoodCanvas', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/neighbourhoodCanvas',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvass.html',
                    controller: 'NeighbourhoodCanvasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('neighborhoodCanvass.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('neighborhoodCanvass.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("neighbourhoodCanvasForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('ReligiousInstitutionController', ReligiousInstitutionController);
	
	ReligiousInstitutionController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','ReligiousInstitutionService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope'];
	function ReligiousInstitutionController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,ReligiousInstitutionService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope) {
		
		var vm = this;
		vm.dateOfVisit = '';
		vm.app = APP;
		vm.now = new Date();
		$scope.interviewFlag = true;
		$scope.recordFlag = true;
		$scope.disablesaveflag = false;
		var oldFormData = {};
		
		vm.maxDate = new Date(
		   vm.now.getFullYear(),
		   vm.now.getMonth(),
		   vm.now.getDate()
		);
		
		$scope.religiousInstitution = {};
        $scope.religiousInstitution.sections = [];
        //$scope.religiousInstitution.sections.questions = [];
        $scope.religiousInstitution.summary = {};
        $scope.loadingReligious = false;

        vm.loadReligiousDetails = function(){
        	$scope.loadingReligious = true;
    		vm.getReligiousInformationDetails();
      	   
         };
         
         vm.getReligiousInformationDetails = function (){
			 $scope.entityObj.searchKey = null;
        	 var sectionKey = vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS;
    		   var formId = $scope.investigationFormId;
        	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
    		  	data.then(function(response){
    		  		if(response.formVersion != null){
     		  			$scope.formVersion = response.formVersion;
     		  		}
    		  		if(response.sectionId != null){
			  			$scope.religiousInsSectionId = response.sectionId;
			  		}
    		  		if(response.formDTO == null){
    		  		   var tempObj = {};
    		     	   tempObj.questions = [];
    		     	   $scope.religiousInstitution.sections.push(tempObj);
    		  		} else if(response.formDTO.sections.length == 0) {
  				  	   if(response.formDTO.summary){
						     var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.religiousInstitution.sections.push(tempObj);
				  	           $scope.religiousInstitution.summary = response.formDTO.summary;
				  	   } else {
						  	   var tempObj = {};
						  	   tempObj.questions = [];
				  	           $scope.religiousInstitution.sections.push(tempObj);
				  	   }
		  	       } else {
    		  			$scope.religiousInstitution = response.formDTO;    		  			
		  		   }
    		  	   //Set the object to restrict the initial save call
		  		   oldFormData = angular.copy(response.formDTO);
    		  	   $scope.loadingReligious = false;
    		  	   $scope.updateLastEditTime(response.updatedOn);
    		   }, function(reason) {
    			  return reason;
    		   });
         };
         
         /* Method name            : saveReligiousInstitutionsDetails()
	      * Method Description 	   : This method saves the religious form details 
	 	  */ 
         $scope.saveReligiousInstitutionsDetails = function(){
        	   var isPutJsonSimilar = false;
        	   $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
        	   var saveDataObj = {};
        	   saveDataObj.formDTO = angular.copy($scope.religiousInstitution);
        	   saveDataObj.formVersion = $scope.formVersion;
        	   saveDataObj.investigationFormId =$scope.investigationFormId;
        	   saveDataObj.sectionId = $scope.religiousInsSectionId;
        	   for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
                   if(!saveDataObj.formDTO.sections[i].questions){
                       saveDataObj.formDTO.sections.splice(i,1);
                       i--;
                   } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
                       saveDataObj.formDTO.sections.splice(i,1);
                       i--;
                   } else {
                       delete saveDataObj.formDTO.sections[i].expanded;
                       saveDataObj.formDTO.sections[i].sortOrder = i+1;
                   }
               }
        	   
        	   /*	Set the temporary object to avoid unwanted save call. 
	      			Fist condition to avoid the initial save call for empty form 
	      			Second condition to avoid the initial save call if the section has any form data 
        	   */
               if(angular.isUndefined($scope.tempReligiousObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                       (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                   $scope.tempReligiousObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempReligiousObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempReligiousObj = angular.copy(saveDataObj);
               } else if(angular.isUndefined($scope.tempReligiousObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	   $scope.tempReligiousObj = {};
            	   $scope.tempReligiousObj.formDTO = angular.copy(oldFormData);
               }  
        	   
        	   if(!angular.isUndefined($scope.tempReligiousObj)){
	    		   if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempReligiousObj.formDTO))){
	    			   isPutJsonSimilar = true;	    			   
	    		   } 
	    	   }
        	   if($scope.isOwner){
        		   $scope.tempReligiousObj = angular.copy(saveDataObj);
        	   } else {
        		   $scope.tempReligiousObj = undefined; //Every time temporary object will be newly updated for non owner 
        	   }

        	   /* saveData flag - to ensure the save button is clicked in form*/
	       	   if(!isPutJsonSimilar){
		       		if($scope.isOwner || $scope.saveData){
		       			//Flag to set the section results are edited or not
		       			if(angular.isDefined($scope.religiousCheckList) && angular.isDefined($scope.religiousCheckListTempObj) && !angular.equals($scope.religiousCheckList, $scope.religiousCheckListTempObj)) {
		       				saveDataObj.isFormSectionResultEdited = true;
		       				$scope.saveAnalystFormTypeCheckList('religious', true, false);
		       			}
		       			
		       		 var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		     		  	data.then(function(response){
			  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.RELEGIOUS_INSTUTE_STATE)
			  		  		{
			  		  			$scope.updateLastEditTime(response.updatedOn);
			  		  		}
			  		  		$scope.uploadFileStatusUpdated();
		     		  }, function(reason) {
		     			  return reason;
		     		  });
		       		}
		       	 $rootScope.warningPopup.show = true;
	       	   } else if($scope.isOwner || $scope.saveData && angular.isDefined($scope.religiousCheckList) && angular.isDefined($scope.religiousCheckListTempObj)
	       			   && !angular.equals($scope.religiousCheckList, $scope.religiousCheckListTempObj)) {
       				$scope.saveAnalystFormTypeCheckList('religious', true);
       			}
           };
           
           vm.interviewFlag = function(flag, index){
          	 $scope.interviewFlag = flag;
          	 if(index){
          		 $scope.sectionIndex = index; 
          	 }
            };
           
           vm.addAdditionalInterviewForm = function(){
               var testObj = {};
               if($scope.interviewFlag == 1){
              	 $scope.religiousInstitution.sections[0].questions[0].religiousInstitution_q2a.interviews.push(testObj);
               }
               if($scope.interviewFlag == 2){
              	 if($scope.sectionIndex){
              		 $scope.religiousInstitution.sections[$scope.sectionIndex].questions[0].religiousInstitution_q2a.interviews.push(testObj);
              	 }
               }
           };
            
            /* Method name           : collapseAll()
        	 * Method Description 	 : This method is used to collapse the accordion 
    		 */
        vm.collapseAll = function(index, flag) {
		var height = 0;
			for (var i = 0; i < $scope.religiousInstitution.sections.length; i++) {
				if (flag == 0) {
					height = height
							+ $('.acc_' + index).closest('.md-accordion').offsetHeight
						+ 42;
				} else {
					height = height
							+ $('.acc_' + index).closest('.md-accordion')[0].offsetHeight
							+ 42;
				}
				
				if (i == index) {
					if (!$scope.religiousInstitution.sections[i].expanded) {
						$scope.formViewCall(index);
						$scope.religiousInstitution.sections[i].expanded = !$scope.religiousInstitution.sections[i].expanded;
						$('#religiousInstitution').animate({
						scrollTop : height
						}, 'slow');
						// Calling get documents based on accordion index
						$scope.getUploadFiles(null,	vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS, index)
					} else {
						$scope.religiousInstitution.sections[i].expanded = !$scope.religiousInstitution.sections[i].expanded;
					}
				} else {
					$scope.religiousInstitution.sections[i].expanded = false;
				}
				if ($scope.religiousInstitution.sections[i].expanded) {
					if($scope.religiousInstitution.sections[i].questions[0] == undefined){
						$scope.notApproved=false;
					}else{
					$scope.isEntityApproved($scope.religiousInstitution.sections[i].questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId);
					}
					$scope.openAccordionIndex = i;
				}
			}
        };
           
           
           /* Method name           : addAdditionalInstitutionForm()
            * Method Description 	: This method adds Neighborhood canvas form to list of birth certificate form 
    	    */
           vm.addAdditionalInstitutionForm = function(){
               var tempObj = {};
               tempObj.questions = [];
               tempObj.expanded = false;
               $scope.notApproved=false;
               $scope.religiousInstitution.sections.push(tempObj);
               vm.collapseAll($scope.religiousInstitution.sections.length - 1,0);
           };
           
           
           /* Method name           : removeBirthCertificateForm()
            * Method Description 	: This method removes the added Neighborhood canvas form from list of birth certificate form
    	    */
           /*vm.removeReligiousInstitutions = function(index){
        	   $scope.religiousInstitution.sections.splice(index,1);
           };*/
           vm.removeReligiousInstitutions  = function(ev,id,indexValue){
        	   $scope.indexVal = indexValue;
        	   $mdDialog.show({
        		   contentElement: angular.element('#'+id),
        		   targetEvent: ev,
        		   clickOutsideToClose: false,
        		   escapeToClose: false
        	   })
           };
            
            vm.closeConform = function(index){
            	$scope.deleteLoader.flag = true;
            	$mdDialog.hide();
            	$scope.religiousInstitution.sections.splice(index,1);
            	if(index != 0){
               		vm.collapseAll(index-1,1);
               	}	
            	 $scope.enableDeleteButton();
            };
            
            vm.closeCancel = function(){
            	$mdDialog.cancel();
            	$scope.interviewFlag = true;
        		$scope.recordFlag = true;
            };
		vm.profileForm = $stateParams;
		

		 /* File Upload Sections */
       
       vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
   		$("#religiousInstitutionSectionSummary").val(null);
	        $('#religiousInstitutionSectionSummary').trigger('click'); 
	        $('#religiousInstitutionSectionSummary').off('change').on('change', function() {
	        	var file = this.files[0];
		   		var sectionId = $scope.religiousInsSectionId;
		   		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null);    			
	        });
		};

		vm.nextInvestigationForm = function(){
			$scope.disablesaveflag = true;
			$scope.saveAnalystFormTypeCheckList('religious');
			$scope.saveData = true;
			$scope.saveReligiousInstitutionsDetails();
			if($scope.investigationFormType == vm.app.INVESTIGATION.INVESTIGATOR_FORM){
				//$state.go("residencyQuestions");
				$rootScope.warningPopup.show = false;
	            $scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.RESIDENCY_FORM);
			}
			if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				//$state.go("dnaInformation");
				//While clicking save button in religious section set warning popup false
				$rootScope.warningPopup.show = false;
	            $scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.DNA_FORM);
				$scope.collapseAll(5);
			}
			$scope.updateLastEditTime(null);
		};
		
		$rootScope.warningPopup.show = false;
		/* Method Description 	: This method triggers auto save for birth certificate form */
        $scope.$watch('religiousInstitutionAutoSave', function(newValue, oldValue) {
 			if(newValue != undefined && newValue != oldValue){ 				
 				if(newValue && $scope.isOwner){ 				
 	 					if($scope.formVersion && !$scope.isreadonly){
 	 						$scope.saveReligiousInstitutionsDetails();
 	 	 					$rootScope.religiousInstitutionAutoSave = false;
 						} else{
 							$rootScope.religiousInstitutionAutoSave = false;
 						}
 	 				}else{
 	 					$rootScope.religiousInstitutionAutoSave = false;
 	 				} 				
 			}
 		});
        
        /**
		 * To find which accordion is open currently
		 */	
		vm.findOpenform = function(){
        	 if($scope.religiousInstitution.sections.length > 1){
        		 var j = -1;
        		 for(var i = 0;i < $scope.religiousInstitution.sections.length;i++){
            		 if($scope.religiousInstitution.sections[i].expanded == true){
            			 return ++i;
            		 }
            	 } 
        		 return j;
        	 }
        	 return 1;
         };
			
		/**
		 * Add the requested Entity
		 * 
		 */	
         $rootScope.residencyEntityRequestsent = function(entity,locationObject,response){
	    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
	    	  var openForm = vm.findOpenform();openForm--;
	    	  if(openForm != -1){
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.answer = entityName;
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId = response.id;
	    		  $scope.religiousInstitution.sections[openForm].questions[0].religiousInstitution_q1_yes_nameofInstitution.requested = true;
	    	  }
	    	  document.querySelector('.global-search-input input').value = entityName;
	    	  $scope.selectedtext = entityName;
		};
		
      //Method for add or suggest entity
	    vm.entityRequestSuggest = function(searchKey,entityName){
	    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
	   	};
	   	
	    //It will get triggered while exiting from current state
	   	$scope.$on('$destroy', function() {
	   		if(!$scope.isreadonly && $scope.isOwner) {
	   			$scope.saveReligiousInstitutionsDetails();
        	}
	   		$rootScope.warningPopup.show = false;
	   		$scope.uploadedFile = false;
        });

	   	//To open the confirmation pop up for remove the additional interview or records
    	vm.deleteIndex = function(event,id,index,isInterview){
			$scope.indexVal = index;
			$scope.isInterview = isInterview;
			$scope.interviewFlag = false;
			$scope.recordFlag = false;
			$mdDialog.show({
				contentElement: angular.element('#'+id),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false,
				onRemoving: function (event, removePromise) {
					vm.closeCancel();
				}
			});
    	};
       	
    	//To remove the interview content form the form data
       	vm.deleteInterviewConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.religiousInstitution.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.religiousInstitution.sections[$scope.openAccordionIndex].questions[0].religiousInstitution_q2a.interviews.splice(index,1);
       	    vm.closeCancel();
       	    $scope.enableDeleteButton();
       	};
       	
       	//To remove the records form the form data
       	vm.deleteRecordConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.religiousInstitution.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.religiousInstitution.sections[$scope.openAccordionIndex].questions[0].religious_record_list.records.splice(index,1);
       	    vm.closeCancel();
       	 $scope.enableDeleteButton();
       	};
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('ReligiousInstitutionService', ReligiousInstitutionService);

    ReligiousInstitutionService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function ReligiousInstitutionService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('religiousInstitution', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/religiousInstitution',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.html',
                    controller: 'ReligiousInstitutionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('religiousInstitution.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('religiousInstitution.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("religiousInstitutionForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('ResidencyQuestionsController', ResidencyQuestionsController);
	
	ResidencyQuestionsController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','ResidencyQuestionsService','$stateParams','InvestigationFormService','$timeout','$rootScope','$mdDialog'];
	function ResidencyQuestionsController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,ResidencyQuestionsService,$stateParams,InvestigationFormService,$timeout,$rootScope,$mdDialog) {
		
		var vm = this;
		vm.app = APP;
		vm.profileForm = $stateParams;
		$scope.residencyQuestions = {};
    	$scope.residencyQuestions.sections = [];
    	//$scope.residencyQuestions.sections.questions = [];
    	$scope.residencyQuestions.summary = {};
    	$scope.loadingResidency = false;
    	var oldFormData = {};
    	
           vm.addAdditionalSchoolForm = function(){
               var testObj = {};
              $scope.residencyQuestions.sections[0].questions[0].residency2_2a.interviews.push(testObj);
           };
           
           vm.addAdditionalCountryForm = function(){
               var testObj1 = {};
               $scope.residencyQuestions.sections[0].questions[0].residency1_1a.interviews.push(testObj1);
           };
    	
           vm.initLoadResidencyQuestions = function(){
        	   $scope.loadingResidency = true;
    		   vm.getResidencyQuestionDetails();
          	 
             };   
           
             vm.getResidencyQuestionDetails = function (){
            	 var sectionKey = vm.app.REF_TERM.RESIDENCY_QUESTIONS;
        		   var formId = $scope.investigationFormId;
            	   var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
        		  	data.then(function(response){
        		  		if(response.formVersion != null){
         		  			$scope.formVersion = response.formVersion;
         		  		}
        		  		if(response.sectionId != null){
    			  			$scope.residencySectionId = response.sectionId;
    			  		}
        		  		if(response.formDTO == null){
        		  		   var tempObj = {};
        		     	   tempObj.questions = [];
        		     	   $scope.residencyQuestions.sections.push(tempObj);
        		  		} else if(response.formDTO.sections.length == 0) {
       				  	   if(response.formDTO.summary){
  						     var tempObj = {};
  						  	   tempObj.questions = [];
  				  	           $scope.residencyQuestions.sections.push(tempObj);
  				  	           $scope.residencyQuestions.summary = response.formDTO.summary;
	  				  	   } else {
	  						  	   var tempObj = {};
	  						  	   tempObj.questions = [];
	  				  	           $scope.residencyQuestions.sections.push(tempObj);
	  				  	   }
	  		  	       } else {
	  		  	    	   $scope.residencyQuestions = response.formDTO;	  		  	    	   
	  		  	       }
        		  	    //Set the object to restrict the initial save call
	  		  	    	oldFormData = angular.copy(response.formDTO);
	        		  	$scope.loadingResidency = false;
	        		  	$scope.updateLastEditTime(response.updatedOn);
	        		   }, function(reason) {
	        			  return reason;
	        		   });
             };
             
	     /* Method name            : saveResidencyQuestionsDetails()
	      * Method Description 	   : This method saves the residency form details 
	 	  */     
    	$scope.saveResidencyQuestionsDetails = function(){
    	   var isPutJsonSimilar = false;
    	   $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
      	   var saveDataObj = {};
      	   saveDataObj.formDTO = angular.copy($scope.residencyQuestions);
      	   saveDataObj.formVersion = $scope.formVersion;
      	   saveDataObj.investigationFormId = $scope.investigationFormId;
      	   saveDataObj.sectionId = $scope.residencySectionId;
	      	 for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
	             if(!saveDataObj.formDTO.sections[i].questions){
	                 saveDataObj.formDTO.sections.splice(i,1);
	                 i++;
	             } else if(saveDataObj.formDTO.sections[i].questions.length == 0) {
	                 saveDataObj.formDTO.sections.splice(i,1);
	                 i++;
	             } else {
	                 delete saveDataObj.formDTO.sections[i].expanded;
	                 saveDataObj.formDTO.sections[i].sortOrder = i+1;
	             }
	         }
	      	 
	      	 /*	Set the temporary object to avoid unwanted save call. 
   				Fist condition to avoid the initial save call for empty form 
   				Second condition to avoid the initial save call if the section has any form data 
	      	 */
             if(angular.isUndefined($scope.tempResidencyObj) && saveDataObj.formDTO.sections.length == 0 && oldFormData == null && 
                     (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                 $scope.tempResidencyObj = angular.copy(saveDataObj);
             } else if(angular.isUndefined($scope.tempResidencyObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
          	   $scope.tempResidencyObj = angular.copy(saveDataObj);
             } else if(angular.isUndefined($scope.tempResidencyObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	 $scope.tempResidencyObj = {};
            	 $scope.tempResidencyObj.formDTO = angular.copy(oldFormData);
             } 
	      	
             if(!angular.isUndefined($scope.tempResidencyObj)){
            	 if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempResidencyObj.formDTO))){
            		 isPutJsonSimilar = true;	    			  
            	 } 
             }
             if($scope.isOwner){
            	 $scope.tempResidencyObj = angular.copy(saveDataObj);
             } else {
            	 $scope.tempResidencyObj = undefined; //Every time temporary object will be newly updated for non owner 
             }

	      	/* saveData flag - to ensure the save button is clicked in form*/
	       if(!isPutJsonSimilar){
	    	   if($scope.isOwner || $scope.saveData){
	    		   var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
		   		  	data.then(function(response){
		  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.RESIDENCY_STATE)
		  		  		{
		  		  			$scope.updateLastEditTime(response.updatedOn);
		  		  		}
		  		  		$scope.uploadFileStatusUpdated();
		   		  }, function(reason) {
		   			  return reason;
		   		  });
	    	   }
	    	   $rootScope.warningPopup.show = true;
	       }
         };
         
         vm.nextInvestigationForm = function(){
        	$scope.saveData = true;
        	$scope.saveResidencyQuestionsDetails(); 
        	//$state.go("other");
        	$rootScope.warningPopup.show = false;
            $scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.OTHER_FORM);
        	if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(8);
			}
			$scope.updateLastEditTime(null);
 		 };
 		
 		 /* File Upload Sections */
         
         
         vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
     		$("#residencySectionSummary").val(null);
  	        $('#residencySectionSummary').trigger('click'); 
  	        $('#residencySectionSummary').off('change').on('change', function() {
	  	    	var file = this.files[0];
	     		var sectionId = $scope.residencySectionId;
	     		$scope.setOrginSectionFileUpload(vm.app.REF_TERM.RESIDENCY_QUESTIONS);
	     		$scope.uploadFileInSectionSummary(ev,file,vm.app.INVESTIGATION_FORM.SUMMARY_KEY,sectionId,isSummary);
	        });
  		};

  		/*vm.uploadFileInSectionSummary = function(file){
     		vm.submittedAsset = {};
     		vm.submittedAsset.fileName = file.name;
  		};*/
  			
		$scope.removeAttachment = function(element){
			$(element.target.parentElement).remove();
		};
		
		 $rootScope.warningPopup.show = false;
		/* Method Description 	: This method triggers auto save for birth certificate form */
	       $scope.$watch('residencyQuestionsAutoSave', function(newValue, oldValue) {
				if(newValue != undefined && newValue != oldValue){					
					if(newValue && $scope.isOwner){						
							if($scope.formVersion && !$scope.isreadonly){
								$scope.saveResidencyQuestionsDetails();
								$rootScope.residencyQuestionsAutoSave = false;
							} else{
								$rootScope.residencyQuestionsAutoSave = false;
							}
						}else{
							$rootScope.residencyQuestionsAutoSave = false;
						}					
				}
			});
	       
	     //It will get triggered while exiting from current state
	       $scope.$on('$destroy', function() {
	    	   if(!$scope.isreadonly && $scope.isOwner) {
	    		   $scope.saveResidencyQuestionsDetails();
	        	}
	    	   $rootScope.warningPopup.show = false;
	    	   $scope.uploadedFile = false;
	       });
	       
	       vm.closeCancel = function(){
	    	   $mdDialog.cancel();
	       };

		   	//To open the confirmation pop up for remove the additional interview or records
	       vm.deleteIndex = function(event,id,index,isCountry){
	    	   $scope.indexVal = index;
	    	   $scope.isCountry = isCountry;
	    	   $mdDialog.show({
	    		   contentElement: angular.element('#'+id),
	    		   targetEvent: event,
	    		   clickOutsideToClose: false,
	    		   escapeToClose: false,
	    		   onRemoving: function (event, removePromise) {
	    			   vm.closeCancel();
	    		   }
	    	   });
	       };
	       	
	    	//To remove the school records form the form data
	       	vm.deleteSchoolConfirm = function(index){
	       		$scope.residencyQuestions.sections[0].questions[0].residency2_2a.interviews.splice(index,1)
	       	    vm.closeCancel();
	       	};
	       	
	       	//To remove the country records form the form data
	       	vm.deleteCountryConfirm = function(index){
	       		$scope.residencyQuestions.sections[0].questions[0].residency1_1a.interviews.splice(index,1)
	       	    vm.closeCancel();
	       	};
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('ResidencyQuestionsService', ResidencyQuestionsService);

    ResidencyQuestionsService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function ResidencyQuestionsService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('residencyQuestions', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/residencyQuestions',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.html',
                    controller: 'ResidencyQuestionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('residencyQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('residencyQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("residencyQuestionForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';
	
	var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.controller('SchoolInformationController', SchoolInformationController);
	
	SchoolInformationController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','SchoolInformationService','InvestigationFormService','$stateParams','$timeout','$mdDialog','$rootScope'];
	function SchoolInformationController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,SchoolInformationService,InvestigationFormService,$stateParams,$timeout,$mdDialog,$rootScope) {
		
		var vm = this;
		vm.dateOfVisit = '';
		vm.app = APP;
		
        $scope.schoolInformation = {};
        $scope.schoolInformation.sections = [];
        //$scope.schoolInformation.sections.questions = [];
        $scope.schoolInformation.summary = {};
        $scope.loadingSchool = false;
        $scope.interviewFlag = true;
		$scope.recordFlag = true;
		$scope.disablesaveflag = false;
		var oldFormData = {};
        
        vm.loadschoolInformationDetails = function(){
        	$scope.loadingSchool = true;
    		vm.getSchoolInformationDetails();
       	  	
          };   
        
          vm.getSchoolInformationDetails = function (){
			$scope.entityObj.searchKey = null;
        	  var sectionKey = vm.app.REF_TERM.SCHOOL_INFORMATION;
        	  var formId = $scope.investigationFormId;
        	  var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
        	  data.then(function(response){
        		  if(response.formVersion != null){
        			  $scope.formVersion = response.formVersion;
        		  }
		  		  if(response.sectionId != null){
		  			  $scope.schoolInfoSectionId = response.sectionId;
		  		  }
      		  	  if(response.formDTO == null){
      		  		  var tempObj = {};
      		  		  tempObj.questions = [];
      		  		  $scope.schoolInformation.sections.push(tempObj);
      		  	  } else if(response.formDTO.sections.length == 0) {
      		  		  if(response.formDTO.summary){
      		  			  var tempObj = {};
      		  			  tempObj.questions = [];
      		  			  $scope.schoolInformation.sections.push(tempObj);
      		  			  $scope.schoolInformation.summary = response.formDTO.summary;
      		  		  } else {
      		  			  var tempObj = {};
      		  			  tempObj.questions = [];
      		  			  $scope.schoolInformation.sections.push(tempObj);
      		  		  }
      		  	  } else {
      		  		  $scope.schoolInformation = response.formDTO;      		  		  
      		  	  }
      		      //Set the object to restrict the initial save call
  		  		  oldFormData = angular.copy(response.formDTO);
      		  	  $scope.loadingSchool = false;
      		  	  $scope.updateLastEditTime(response.updatedOn);
        	  }, function(reason) {
        		  return reason;
        	  });
          };
          
          /* Method name            : saveschoolInformationDetails()
	       * Method Description 	: This method saves the school form details 
	 	   */ 
         $scope.saveschoolInformationDetails = function(){
           var isPutJsonSimilar = false;
           $rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
       	   var saveDataObj = {};
       	   saveDataObj.formDTO = angular.copy($scope.schoolInformation);
       	   saveDataObj.formVersion = $scope.formVersion;
       	   saveDataObj.investigationFormId = $scope.investigationFormId;
       	   saveDataObj.sectionId = $scope.schoolInfoSectionId;
	       	for(var i=0;i<saveDataObj.formDTO.sections.length;i++){
	            if(!saveDataObj.formDTO.sections[i].questions){
	                saveDataObj.formDTO.sections.splice(i,1);
	                i--;
	            } else if(saveDataObj.formDTO.sections[i].questions.length == 0 || (saveDataObj.formDTO.sections[i].questions.length == 1 && saveDataObj.formDTO.sections[i].questions[0].schoolInformation_1_label.answer == "")) {
	                saveDataObj.formDTO.sections.splice(i,1);
	                i--;
	            } else {
	                delete saveDataObj.formDTO.sections[i].expanded;
	                saveDataObj.formDTO.sections[i].sortOrder = i+1;
	            }
	        }
	       	
	       	/*	Set the temporary object to avoid unwanted save call. 
      			Fist condition to avoid the initial save call for empty form 
      			Second condition to avoid the initial save call if the section has any form data 
	       	*/
            if(angular.isUndefined($scope.tempSchoolObj) && ((saveDataObj.formDTO.sections != null && saveDataObj.formDTO.sections[0] != null && saveDataObj.formDTO.sections[0].questions != null &&
            		saveDataObj.formDTO.sections[0].questions.length == 1 && saveDataObj.formDTO.sections[0].questions[0].schoolInformation_1_label.answer == "") || 
                    saveDataObj.formDTO.sections.length == 0 && oldFormData == null) && (saveDataObj.formDTO.summary.comment == null || saveDataObj.formDTO.summary.comment == undefined)) {
                $scope.tempSchoolObj = angular.copy(saveDataObj);
            } else if(angular.isUndefined($scope.tempSchoolObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
         	   $scope.tempSchoolObj = angular.copy(saveDataObj);
            } else if(angular.isUndefined($scope.tempSchoolObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
            	$scope.tempSchoolObj = {};
            	$scope.tempSchoolObj.formDTO = angular.copy(oldFormData);
            } 
	       	
            if(!angular.isUndefined($scope.tempSchoolObj)){
            	if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempSchoolObj.formDTO))){
            		isPutJsonSimilar = true;	    			  
            	} 
            }
            if($scope.isOwner){
            	$scope.tempSchoolObj = angular.copy(saveDataObj);
            } else {
            	$scope.tempSchoolObj = undefined; //Every time temporary object will be newly updated for non owner 
            }

	       	/* saveData flag - to ensure the save button is clicked in form*/
	       	if(!isPutJsonSimilar){
	       		if($scope.isOwner || $scope.saveData){
	       			//Flag to set the section results are edited or not
	       			if(angular.isDefined($scope.schoolCheckList) && angular.isDefined($scope.schoolCheckListTempObj) && !angular.equals($scope.schoolCheckList, $scope.schoolCheckListTempObj)) {
	       				saveDataObj.isFormSectionResultEdited = true;
	       				$scope.saveAnalystFormTypeCheckList('school', true, false);
	       			}
	       			
	       			var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
	    		  	data.then(function(response){
		  		  		if($state.current.name === vm.app.INVESTIGATION.STATE.SCHOOL_INFORMATION_STATE)
		  		  		{
		  		  			$scope.updateLastEditTime(response.updatedOn);
		  		  		}
		  		  		$scope.uploadFileStatusUpdated();
	    		  	}, function(reason) {
	    			  return reason;
	    		  	});
	       		}
	       	 $rootScope.warningPopup.show = true;
	       	} else if(($scope.isOwner || $scope.saveData) && angular.isDefined($scope.schoolCheckList) && angular.isDefined($scope.schoolCheckListTempObj)
	       			&& !angular.equals($scope.schoolCheckList, $scope.schoolCheckListTempObj)) {
   				$scope.saveAnalystFormTypeCheckList('school', true);
   			}
          };
          
          vm.interviewFlag = function(flag, index){
         	 $scope.interviewFlag = flag;
         	 if(index){
         		 $scope.sectionIndex = index; 
         	 }
           };
          
          vm.addAdditionalInterviewForm = function(){
              var testObj = {};
              if($scope.interviewFlag == 1){
             	 $scope.schoolInformation.sections[0].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.push(testObj);
              }
              if($scope.interviewFlag == 2){
             	 if($scope.sectionIndex){
             	   $scope.schoolInformation.sections[$scope.sectionIndex].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.push(testObj);
             	 }
              }
          };
           
           /* Method name           : collapseAll()
       	 * Method Description 	 : This method is used to collapse the accordion 
   		 */
          vm.collapseAll = function(index,flag){
        	  var height = 0;
        	  for(var i=0;i<$scope.schoolInformation.sections.length;i++){
        		  if(flag==0){
        			  height = height + $('.acc_'+index).closest('.md-accordion').offsetHeight + 42;
        		  }
        		  else{
        			  height = height + $('.acc_'+index).closest('.md-accordion')[0].offsetHeight + 42;
        		  }
        		  if(i == index){
        			  if(!$scope.schoolInformation.sections[i].expanded){
        				  $scope.formViewCall(index);
        				  $scope.schoolInformation.sections[i].expanded = !$scope.schoolInformation.sections[i].expanded;
        				  $('#schoolInformation').animate({scrollTop: height}, 'slow');
		    
        				  //Calling get documents based on accordion index
        				  $scope.getUploadFiles(null,vm.app.REF_TERM.SCHOOL_INFORMATION,index)
        			  }else{
        				  $scope.schoolInformation.sections[i].expanded = !$scope.schoolInformation.sections[i].expanded;
        			  }
        		  } else {
        			  $scope.schoolInformation.sections[i].expanded = false;
        		  }
        		  if($scope.schoolInformation.sections[i].expanded){
        			  if($scope.schoolInformation.sections[i].questions[0] == undefined){
        				  $scope.notApproved=false;
        			  }else{
        			  $scope.isEntityApproved($scope.schoolInformation.sections[i].questions[0].schoolInformation_1_label.answerId);
        			  }
        			  $scope.openAccordionIndex = i;
        		  }
        	  }
          };
          
          
          /* Method name           : addAdditionalInstitutionForm()
           * Method Description 	: This method adds Neighborhood canvas form to list of birth certificate form 
   	    */
          vm.addAdditionalInstitutionForm = function(){
              var tempObj = {};
              tempObj.questions = [];
              tempObj.expanded = false;
              $scope.notApproved=false;
              $scope.schoolInformation.sections.push(tempObj);
              vm.collapseAll($scope.schoolInformation.sections.length - 1,0);
          };
          
          /* Method name           : removeschoolInformation()
           * Method Description 	: This method removes the added Neighborhood canvas form from list of birth certificate form
   	    */
          /*vm.removeschoolInformation = function(index){
       	   $scope.schoolInformation.sections.splice(index,1);
          };*/
          vm.removeschoolInformation = function(ev,id,indexValue){
        	  $scope.indexVal = indexValue;  
        	  $mdDialog.show({
        		  contentElement: angular.element('#'+id),
        		  targetEvent: ev,
        		  clickOutsideToClose: false,
        		  escapeToClose: false
        	  })
          };
          
          vm.closeConform = function(index){
        	  $scope.deleteLoader.flag = true;
          	$mdDialog.hide();
          	$scope.schoolInformation.sections.splice(index,1);
          	if(index != 0){
           		vm.collapseAll(index-1,1);
           	}	
          	 $scope.enableDeleteButton();
          };
          
          vm.closeCancel = function(){
        	  $mdDialog.cancel();
        	  $scope.interviewFlag = true;
			  $scope.recordFlag = true;
          };
          
		vm.profileForm = $stateParams;
		
		vm.nextInvestigationForm = function(){
			//$scope.saveAnalystFormTypeCheckList('school');
			$scope.disablesaveflag = true;
			$scope.saveData = true;
			$scope.saveschoolInformationDetails();
			$rootScope.warningPopup.show = false;
			$scope.sectionNavigationFunc(vm.app.INVESTIGATION_FORM.RELIGIOUS_FORM);
			//$state.go("religiousInstitution");
			if($scope.investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM){
				$scope.collapseAll(5);
			}
			$scope.updateLastEditTime(null);
		};

		/* File Upload Sections */
        
        vm.uploadFileForSummary = function(isSummary,accordionIndex,idName,ev){
    		$("#schoolInformationSectionSummary").val(null);
 	        $('#schoolInformationSectionSummary').trigger('click'); 
 	       $('#schoolInformationSectionSummary').off('change').on('change', function() {
 	    	   	var file = this.files[0];
 	    		var sectionId = $scope.schoolInfoSectionId;
 	    		var questionKey = null;
    			if(isSummary == "true"){
    				questionKey = vm.app.INVESTIGATION_FORM.SUMMARY_KEY;
    			}
    			$scope.setOrginSectionFileUpload(vm.app.REF_TERM.SCHOOL_INFORMATION);
    			$scope.uploadFileInSectionSummary(ev,file,questionKey,sectionId,isSummary,null,idName,accordionIndex,null);
	        });
 		};

 		$rootScope.warningPopup.show = false;
 		/* Method Description 	: This method triggers auto save for birth certificate form */
        $scope.$watch('schoolInfoAutoSave', function(newValue, oldValue) {
 			if(newValue != undefined && newValue != oldValue){ 				
 				if(newValue && $scope.isOwner){
	 					if($scope.formVersion && !$scope.isreadonly){
	 						$scope.saveschoolInformationDetails();
	 	 					$rootScope.schoolInfoAutoSave = false;
						} else{
							$rootScope.schoolInfoAutoSave = false;
						}
	 				}else{
	 					$rootScope.schoolInfoAutoSave = false;
	 				} 				
 			}
 		});
        
        /**
		 * To find which accordion is open currently
		 */	
		vm.findOpenform = function(){
        	 if($scope.schoolInformation.sections.length > 1){
        		 var j = -1;
        		 for(var i = 0;i < $scope.schoolInformation.sections.length;i++){
            		 if($scope.schoolInformation.sections[i].expanded == true){
            			 return ++i;
            		 }
            	 } 
        		 return j;
        	 }
        	 return 1;
         };
			
		/**
		 * Add the requested Entity
		 * 
		 */	
         $rootScope.schoolEntityRequestsent = function(entity,locationObject,response){
	    	  var entityName = entity.entityName+", "+locationObject.cityObj.cityTxt+", "+locationObject.countryObj.countryTxt;
	    	  var openForm = vm.findOpenform();openForm--;
	    	  if(openForm != -1){
	    		  $scope.schoolInformation.sections[openForm].questions[0].schoolInformation_1_label.answer = entityName;
	    		  $scope.schoolInformation.sections[openForm].questions[0].schoolInformation_1_label.answerId = response.id;
	    		  $scope.schoolInformation.sections[openForm].questions[0].schoolInformation_1_label.requested = true;
	    	  }
	    	  document.querySelector('.global-search-input input').value = entityName;
	    	  $scope.selectedtext = entityName;
		};
		
      //Method for add or suggest entity
	    vm.entityRequestSuggest = function(searchKey,entityName){
	    	return $scope.entityRequestAddorSuggest(searchKey,entityName);
	   	};
	   	
	  //It will get triggered while exiting from current state
	   	$scope.$on('$destroy', function() {
	   		if(!$scope.isreadonly && $scope.isOwner) {
	   			$scope.saveschoolInformationDetails();
        	}
	   		$rootScope.warningPopup.show = false;
	   		$scope.uploadedFile = false;
	   	});
	   	
	   	//To open the confirmation pop up for remove the additional interview or records
    	vm.deleteIndex = function(event,id,index,isInterview){
			$scope.indexVal = index;
			$scope.isInterview = isInterview;
			$scope.interviewFlag = false;
			$scope.recordFlag = false;
			$mdDialog.show({
				contentElement: angular.element('#'+id),
				targetEvent: event,
				clickOutsideToClose: false,
				escapeToClose: false,
				onRemoving: function (event, removePromise) {
					vm.closeCancel();
				}
			});
    	};
       	
    	//To remove the interview content form the form data
       	vm.deleteInterviewConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.schoolInformation.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.schoolInformation.sections[$scope.openAccordionIndex].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.splice(index,1);
       	    vm.closeCancel();
       	    $scope.enableDeleteButton();
       	};
       	
       	//To remove the records form the form data
       	vm.deleteRecordConfirm = function(index){
       		$scope.deleteLoader.flag = true;
       		if($scope.schoolInformation.sections.length == 1){
	  			$scope.openAccordionIndex = 0;
	  		}
       		$scope.schoolInformation.sections[$scope.openAccordionIndex].questions[0].school_record_list.records.splice(index,1);
       	    vm.closeCancel();
       	    $scope.enableDeleteButton();
       	};
	}
})();

(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('SchoolInformationService', SchoolInformationService);

    SchoolInformationService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function SchoolInformationService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('schoolInformation', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/schoolInformation',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/school-information/school.information.html',
                    controller: 'SchoolInformationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('schoolInformation.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('schoolInformation.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("schoolInfoForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
	'use strict';

	var lariDevApp = angular
	.module('lariAidApp')
	lariDevApp.controller('SummaryController', SummaryController);

	SummaryController.$inject = ['$scope','$window', '$mdSidenav','Principal','$state','$mdMedia','$cookies','APP','SummaryService','$stateParams','$timeout','InvestigationFormService','$mdDialog','$rootScope','tmhDynamicLocale'];
	function SummaryController ($scope,$window, $mdSidenav,Principal,$state,$mdMedia,$cookies,APP,SummaryService,$stateParams,$timeout,InvestigationFormService,$mdDialog,$rootScope,tmhDynamicLocale) {

		var vm = this;
		vm.profileForm = $stateParams;
		vm.investigation = {};

		$scope.summaryForm = {};
		$scope.summaryForm.sections = [];
		//$scope.summaryForm.sections.questions = [];
		$scope.loadingSummary = false;
		var oldFormData = {};
		vm.noInvestigationFormExistForCountryAdmin = false;

		vm.APP = APP;

		vm.loadSummaryFormDetails = function(){
			$scope.loadingSummary = true;
			vm.getSummaryDetails();

		};

		vm.getSummaryDetails = function (){
			var sectionKey = vm.APP.REF_TERM.SUMMARY;
			var formId = $scope.investigationFormId;
			var data = InvestigationFormService.getInvestigationFormBySectionId(sectionKey,formId);
			data.then(function(response){
				if(response.formVersion != null){
					$scope.formVersion = response.formVersion;
				}
				if(response.sectionId != null){
					$scope.summarySectionId = response.sectionId;
				}
				if(response.formDTO == null){
					var tempObj = {};
					tempObj.questions = [];
					$scope.summaryForm.sections = [];
					$scope.summaryForm.sections.push(tempObj);
				} else {
					$scope.summaryForm = response.formDTO;
					//Set the object to restrict the initial save call
					oldFormData = angular.copy(response.formDTO);
				}
				$scope.loadingSummary = false;
				$scope.updateLastEditTime(response.updatedOn);
			}, function(reason) {
				return reason;
			});
		};


		vm.saveSideNavCheckList = function(){
			if($scope.investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM){
				$scope.saveAnalystFormTypeCheckList('birthCertificate');
				$scope.saveAnalystFormTypeCheckList('birthMedical');
				$scope.saveAnalystFormTypeCheckList('neighbourhood');
				$scope.saveAnalystFormTypeCheckList('family');
				$scope.saveAnalystFormTypeCheckList('school');
				$scope.saveAnalystFormTypeCheckList('religious');
			}  
		};

		/* Method name               : saveSummaryFormDetails()
		 * Method Description 	   : This method saves the summary form details 
		 */ 
		$scope.saveSummaryFormDetails = function(submitResult){
			var isPutJsonSimilar = false;
			vm.isGoBackDisable = true;
			var saveDataObj = {};
			$rootScope.warningPopup.show = false; //To avoid showing popup while moving to other section if there is no edit in current section
			if(submitResult == 1 && $scope.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM){
				if($scope.summaryForm.sections[0].questions[0] == undefined){
					$scope.summaryForm.sections[0].questions[0] = {};
				}
				if($scope.summaryForm.sections[0].questions[0].summary_age == null || $scope.summaryForm.sections[0].questions[0].summary_age == undefined){
					$scope.summaryForm.sections[0].questions[0].summary_age = {};
					$scope.summaryForm.sections[0].questions[0].summary_age.answer = vm.APP.INVESTIGATION.SUMMARY_NA;
				}
				if($scope.summaryForm.sections[0].questions[0].summary_identity == null || $scope.summaryForm.sections[0].questions[0].summary_identity == undefined){
					$scope.summaryForm.sections[0].questions[0].summary_identity = {};
					$scope.summaryForm.sections[0].questions[0].summary_identity.answer = vm.APP.INVESTIGATION.SUMMARY_NA;
				}
			}
			if(submitResult == 2 && $scope.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM){
				if($scope.summaryForm.sections[0].questions[0] != undefined && $scope.summaryForm.sections[0].questions[0].summary_age != null && $scope.summaryForm.sections[0].questions[0].summary_age.answer == vm.APP.INVESTIGATION.SUMMARY_NA){
					$scope.summaryForm.sections[0].questions[0].summary_age = undefined;
				}
				if($scope.summaryForm.sections[0].questions[0] != undefined && $scope.summaryForm.sections[0].questions[0].summary_identity != null && $scope.summaryForm.sections[0].questions[0].summary_identity.answer == vm.APP.INVESTIGATION.SUMMARY_NA){
					$scope.summaryForm.sections[0].questions[0].summary_identity = undefined;
				}
			}
			saveDataObj.formDTO = angular.copy($scope.summaryForm);
			saveDataObj.formVersion = $scope.formVersion;
			saveDataObj.investigationFormId = $scope.investigationFormId;
			saveDataObj.sectionId = $scope.summarySectionId;

			/*	Set the temporary object to avoid unwanted save call. 
 				Fist condition to avoid the initial save call for empty form 
 				Second condition to avoid the initial save call if the section has any form data 
			 */
			if(angular.isUndefined($scope.tempSummaryObj) && saveDataObj.formDTO.sections[0].questions.length == 0) {
               $scope.tempSummaryObj = angular.copy(saveDataObj);
			} else if(angular.isUndefined($scope.tempSummaryObj) && angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
        	   $scope.tempSummaryObj = angular.copy(saveDataObj);
			}  else if(angular.isUndefined($scope.tempSummaryObj) && !angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify(oldFormData))) {
				$scope.tempSummaryObj = {};
				$scope.tempSummaryObj.formDTO = angular.copy(oldFormData);
			} 

			if(!angular.isUndefined($scope.tempSummaryObj)){
				if(angular.equals(JSON.stringify(saveDataObj.formDTO), JSON.stringify($scope.tempSummaryObj.formDTO))){
					isPutJsonSimilar = true;					
				}
			}
			if($scope.isOwner){
				$scope.tempSummaryObj = angular.copy(saveDataObj);
			} else {
				$scope.tempSummaryObj = undefined; //Every time temporary object will be newly updated for non owner 
			}
			
			if(!isPutJsonSimilar){
				if($scope.isOwner || $scope.saveData){
					var data = InvestigationFormService.saveInvestigationForm(saveDataObj);
					data.then(function(response){
		  		  		if($state.current.name === vm.APP.INVESTIGATION.STATE.SUMMARY_STATE)
		  		  			$scope.updateLastEditTime(response.updatedOn);
					}, function(reason) {						
						return reason;
					});	
				}								
				$rootScope.warningPopup.show = true;
				vm.isGoBackDisable = false;
			} else {
				vm.isGoBackDisable = false;
			}
		};
		vm.summaryValidationFunc = function(event){
			$scope.summaryValidation(event);
		};

		/*vm.reportResult = function(ev,id){
      		$mdDialog.show({
     			 contentElement: angular.element('#'+id),
     		      targetEvent: ev,
     		      clickOutsideToClose:true
     		    })
        };*/

		vm.backProfile = function () {
			if (!vm.noInvestigationFormExistForCountryAdmin) {
				$mdDialog.hide();
				vm.investigation.id = $scope.investigationID;
				$state.go("profile", vm.investigation);
			}
			else {
				$mdDialog.hide();
				$state.go("investigations");
			}
		};

		vm.gobackInvestigationForm = function(){
			$mdDialog.cancel();
		};

		vm.reportResult = function(event,resultPopup,errorPopup){
			//Trigger the save while another user submitting the form
			if(!$scope.isOwner) {
				$scope.saveData = true;
				$scope.saveSummaryFormDetails(0);
			}
			vm.formSubmitDisableFlag = true;
			var ageResult;
			var identityResult;
			var language = tmhDynamicLocale.get();
			if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_age != null && $scope.summaryForm.sections[0].questions[0].summary_age.answer == vm.APP.INVESTIGATION.SUMMARY_CONFIMED){
				ageResult =  vm.APP.REF_TERM.FORM_CONFIRMED;
			}else if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_age != null && $scope.summaryForm.sections[0].questions[0].summary_age.answer == vm.APP.INVESTIGATION.SUMMARY_FAILED){
				ageResult =  vm.APP.REF_TERM.FORM_FAILED;
			}else if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_age != null && $scope.summaryForm.sections[0].questions[0].summary_age.answer == vm.APP.INVESTIGATION.SUMMARY_UNDETERMINED){
				ageResult =  vm.APP.REF_TERM.FORM_UNDETERMINED;
			}else {
				ageResult = vm.APP.REF_TERM.FORM_NA;
			}

			if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_identity != null && $scope.summaryForm.sections[0].questions[0].summary_identity.answer == vm.APP.INVESTIGATION.SUMMARY_CONFIMED){
				identityResult =  vm.APP.REF_TERM.FORM_CONFIRMED;
			}else if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_identity != null && $scope.summaryForm.sections[0].questions[0].summary_identity.answer == vm.APP.INVESTIGATION.SUMMARY_FAILED){
				identityResult =  vm.APP.REF_TERM.FORM_FAILED;
			}else if($scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					$scope.summaryForm.sections[0].questions[0].summary_identity != null && $scope.summaryForm.sections[0].questions[0].summary_identity.answer == vm.APP.INVESTIGATION.SUMMARY_UNDETERMINED){
				identityResult =  vm.APP.REF_TERM.FORM_UNDETERMINED;
			}else {
				identityResult = vm.APP.REF_TERM.FORM_NA;
			}
			var formLanguage = tmhDynamicLocale.get();
			if(formLanguage == vm.APP.GLOBAL.EN){
				formLanguage = vm.APP.GLOBAL.ENGLISH;
			}else if(formLanguage == APP.GLOBAL.ES){
				formLanguage = vm.APP.GLOBAL.SPANISH;
			}
			var data = InvestigationFormService.saveInvestigatorResult($scope.investigationFormId,ageResult,identityResult,formLanguage);
			data.then(function(response){
				vm.formSubmitDisableFlag = false;
				vm.noInvestigationFormExistForCountryAdmin = response.noInvestigationFormExistForCountryAdmin;
				if (vm.noInvestigationFormExistForCountryAdmin) {
					resultPopup = "countryAdminWarningPopup";
				}
				$mdDialog.show({
					contentElement: angular.element('#'+resultPopup),
					targetEvent: event,
					clickOutsideToClose: false,
					escapeToClose: false,
					onRemoving: function (event, removePromise) { 
						vm.backProfile();
					}
				})
			}, function(reason) {
				if(reason.status == 409){
					$mdDialog.show({
						contentElement: angular.element('#'+errorPopup),
						targetEvent: event,
						clickOutsideToClose: false,
						escapeToClose: false
					})
				}
			});
		}

		vm.submitInvestigationForm = function(ev,id){
			//$scope.saveData = true;
			if($scope.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && $scope.summaryForm != null && $scope.summaryForm.sections.length >0 && $scope.summaryForm.sections[0].questions.length > 0 && 
					($scope.summaryForm.sections[0].questions[0].summary_age == null || $scope.summaryForm.sections[0].questions[0].summary_age == undefined || 
							$scope.summaryForm.sections[0].questions[0].summary_identity == null || $scope.summaryForm.sections[0].questions[0].summary_identity == undefined)){
				$scope.saveSummaryFormDetails(1);
			}
			//Trigger the save call while click the Save & Close button 
			if(!$scope.isOwner && id == vm.APP.INVESTIGATION_FORM.SUMMARY_CLOSE_FORM) {
				$scope.saveData = true;
				$scope.saveSummaryFormDetails(0);
			}
			$mdDialog.show({
				contentElement: angular.element('#'+id),
				targetEvent: ev,
				clickOutsideToClose:false,
				escapeToClose: false
			})
		};

		$rootScope.validationCompleted = function(event){
			if($scope.summaryForm.sections[0].questions[0] == undefined){
				$scope.summaryForm.sections[0].questions[0] = {};
			}
			if($scope.summaryForm.sections[0].questions[0].summary_age != null && $scope.summaryForm.sections[0].questions[0].summary_identity != null){
				vm.submitInvestigationForm(event,'formConformPopup');
			}else{
				vm.submitInvestigationForm(event,'fillOutSummary');
			}

		}

		$rootScope.warningPopup.show = false;
		/* Method Description 	: This method triggers auto save for birth certificate form */
		$scope.$watch('summaryAutoSave', function(newValue, oldValue) {
			if(newValue != undefined && newValue != oldValue){				
				if(newValue && $scope.isOwner){					
						if($scope.formVersion && !$scope.isreadonly){
							$scope.saveSummaryFormDetails(0);
							$rootScope.summaryAutoSave = false;
						} else{
							$rootScope.summaryAutoSave = false;
						}
					}else{
						$rootScope.summaryAutoSave = false;
					}				
			}
		});

		//It will get triggered while exiting from current state
		$scope.$on('$destroy', function() {
			if(!$scope.isreadonly && $scope.isOwner) {
				$scope.saveSummaryFormDetails(0);
			}
			$rootScope.warningPopup.show = false;
		});
	}
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('SummaryService', SummaryService);

    SummaryService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function SummaryService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('summary', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/summary',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/summary/summary.html',
                    controller: 'SummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('investigationSummary.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('investigationSummary.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("summaryForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();
(function() {
    'use strict';
    
    var lariDevApp = angular
    .module('lariAidApp')
    lariDevApp.directive('uploadFormFile', function()
    	{
	    	return {
				restrict : 'AE',			
				templateUrl: 'app/investigation/prospects/profile/investigation-form/upload-file-directive/upload.file.html',
				/*controller: 'uploadFileController',*/
				link: function(scope, element, attrs, ngModel) {
					if(attrs.idName){
						scope.idName = attrs.idName;
					}
					if(attrs.idFormName){
						scope.idFormName = attrs.idFormName;
					}
					if(attrs.isSummary){
						scope.isSummary = attrs.isSummary;
					}
					if(attrs.isReadOnly){
						scope.isReadOnly = attrs.isReadOnly;
					}
				}
			};
    	});
    
})();
(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.directive("manageAttachments", function () {
    return {
      restrict: "AE",
      controller: "ManageAttachmentsController",
      templateUrl:
        "app/investigation/prospects/profile/investigation-form/manage-attachments-directive/manage.attachments.html",
      scope: {
        idName: "=idName",
        idFormName: "=idFormName",
        assetList: "=assetList",
        isSummary: "=isSummary",
        isReadOnly: "=isReadOnly",
        recordFlag: "=recordFlag"
      },
      link: function (scope, element, attrs, ngModel) {}
    };
  });
})();

(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.controller("ManageAttachmentsController", ManageAttachmentsController);

  ManageAttachmentsController.$inject = [
    "$scope",
    "$mdMedia",
    "$mdDialog",
    "CommonService",
    "InvestigationFormService",
    "APP",
    "$window",
    "BASE_URL"
  ];
  function ManageAttachmentsController(
    $scope,
    $mdMedia,
    $mdDialog,
    CommonService,
    InvestigationFormService,
    APP,
    $window,
    BASE_URL
  ) {
    var vm = this;
    $scope.assetSelectedCount = 0;
	$scope.baseUrl = BASE_URL;
    vm.lang = CommonService.getCookieLanguage();
    $scope.media = $mdMedia;
    vm.APP = APP;
    vm.managePopupId = {};
    $scope.showDeleteConfirmPopup = false;
    $scope.isAllSelected = false;

    //To open the manage attachment popup.
    $scope.showDialog = function (event, popupId) {
      angular.forEach($scope.assetList, function (itm) {
        itm.isSelected = false;
      });
      $scope.assetSelectedCount = 0;
      $scope.isAllSelected = false;
      if ($scope.assetList && $scope.assetList.length > 0) {
        $mdDialog.show({
          contentElement: angular.element("#" + popupId + "_" + $scope.idName),
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: false,
          escapeToClose: false
        });
      } else {
        $mdDialog.hide();
      }
    };
    $scope.closeCancel = function () {
      $mdDialog.hide();
      $scope.showDeleteConfirmPopup = false;
    };
    $scope.closeOpen = function (event) {
      //$mdDialog.hide();
      $scope.recordFlag = true;
      $scope.showDeleteConfirmPopup = false;
      $scope.showDialog(event, "manageAttachmentPopupId");
    };

    //Method to view the attachment in seperate tab. Prevent the parent element select functionality
    $scope.viewAttachment = function (url, assetId, event) {
      var previewUrl =  $scope.baseUrl + url + assetId + "/LARI_AID";
      $window.open(previewUrl, "_blank");
      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();
      event.cancelBubble = true;
      event.returnValue = false;
    };

    /*to select and deselect the preview image*/
    $scope.toggle = function (isSelected, event) {
      if (
        event.target.className != vm.APP.INVESTIGATION_FORM.VIEW_BUTTON_CLICK &&
        $scope.isReadOnly == vm.APP.GLOBAL.FALSE.toLowerCase()
      ) {
        if (isSelected) {
          $scope.assetSelectedCount--;
          $scope.isAllSelected = false;
        } else {
          $scope.assetSelectedCount++;
        }
        if ($scope.assetList.length == $scope.assetSelectedCount) {
          $scope.isAllSelected = true;
        } else {
					$scope.isAllSelected = false;
			  }
        return !isSelected;
      }
    };

    /*To select all the preview image in the popup*/
    $scope.toggleAll = function () {
      if(($scope.assetList.length != $scope.assetSelectedCount) || ($scope.assetSelectedCount == 0)){$scope.assetSelectedCount = angular.copy($scope.assetList.length);
        angular.forEach($scope.assetList, function (itm) {
          itm.isSelected = true;
        });
        $scope.isAllSelected = true;
      } else {
        $scope.assetSelectedCount = 0;
        angular.forEach($scope.assetList, function (itm) {
          itm.isSelected = false;
        });
        $scope.isAllSelected = false;
      }
    };

    /*To open the delete confirmation warn popup*/
    $scope.deleteAllFileConfirm = function (event, assetList) {
      $scope.recordFlag = false;
      $scope.assetList = assetList;
      $scope.showDeleteConfirmPopup = true;
    };

    /*
     * To delete the selected elements from the popup
     */
    $scope.deleteMultipleFile = function (event, assetList) {
      var assetFullList = angular.copy(assetList);
      $scope.assetDeleteList = [];
      angular.forEach(assetFullList, function (asset) {
        if (asset.isSelected) {
          $scope.assetDeleteList.push(asset.id);
        }
      });
      $scope.assetList = $scope.assetList.filter(function (asset) {
        return asset.isSelected == false;
      });
      var data = InvestigationFormService.deleteAllFiles($scope.assetDeleteList);
      data.then(function (response) {
        //$mdDialog.hide();
        $scope.recordFlag = true;
        $scope.showDeleteConfirmPopup = false;
        $scope.showDialog(event, "manageAttachmentPopupId");
      });
    };
  }
})();

(function () {
  "use strict";

  var lariDevApp = angular.module("lariAidApp");
  lariDevApp.directive("previewImage", function () {
    return {
      restrict: "AE",
      templateUrl: "app/investigation/prospects/profile/investigation-form/preview-image-directive/preview.image.html",
      scope: {
        assetList: "=assetList",
        assetSelectedCount: "=assetSelectedCount",
        isReadOnly: "=isReadOnly",
        baseUrl: "=baseUrl"
      },
      controller: "ManageAttachmentsController",
      link: function (scope, element, attrs, ngModel) {}
    };
  });
})();

(function() {
    'use strict';

    var lariDevApp = angular.module('lariAidApp')
    lariDevApp.controller('RCDetailsController', RCDetailsController);

    RCDetailsController.$inject = ['$element', '$scope', '$window', '$mdSidenav', 'Principal', '$state', '$mdMedia', '$cookies', 'APP', 'RCDetailsService', '$stateParams', '$mdDialog', 'CommonService','$sessionStorage','$sce','notifications','$timeout'];

    function RCDetailsController($element, $scope, $window, $mdSidenav, Principal, $state, $mdMedia, $cookies, APP, RCDetailsService, $stateParams, $mdDialog, CommonService,$sessionStorage,$sce,notifications,$timeout) {

        var vm = this;
        vm.app = APP;
        $scope.mediaCheck = $mdMedia;
        vm.RCSessionData = $stateParams;
        vm.RCMeetingData = {};
        vm.investigation = {};
        vm.formProfile = {};
        vm.currentStateName = $state.current.name;
        vm.RCMeetingDataOldObj = {};
    	vm.loggedUserRole = CommonService.getCookieUser().loggedUserRole;

        
        vm.isCaseOpen = vm.RCSessionData.isOpenCase;
        
        if(vm.isCaseOpen != undefined && vm.isCaseOpen != null){
        	$sessionStorage.isOpenCase = vm.RCSessionData.isOpenCase;
        }
        else{
        	 vm.isCaseOpen = $sessionStorage.isOpenCase;
        }
        //$scope.resizingRCPage is to recalculate the window height
        $scope.resizingRCPage= true;
        vm.getRCSessionData = function() {
            $scope.loadingRCSessionData = true;
            $scope.investigationRCId = vm.RCSessionData.investigationRCId;
            $scope.investigationId = vm.RCSessionData.id;
            var data = RCDetailsService.getRCSessionData($scope.investigationId, $scope.investigationRCId);
            data.then(function (response) {
                if (response.prospectDob != "" && response.prospectDob != null) {
                    response.prospectDobMonth = response.prospectDob.substring(0, 3)
                    response.prospectDobDay = response.prospectDob.substring(3, 7)
                    response.prospectDobYear = response.prospectDob.substring(7, 12)
                }
                vm.RCMeetingData = response;
                vm.RCMeetingDataOldObj = angular.copy(response);
                $scope.loadingRCSessionData = false;
                $scope.resizingRCPage = false;
                $timeout(function(){
                	 $scope.resizingRCPage = true;
                },0);
                
                //$scope.timzoneFormat(vm.RCMeetingData.assignmentDate);
                $scope.updateProspectName(vm.RCMeetingData.prospectFirstName,vm.RCMeetingData.prospectLastName,vm.RCMeetingData.investigationType,vm.RCMeetingData.investigationId);
                vm.formProfile.firstName = vm.RCMeetingData.prospectFirstName;
                vm.formProfile.lastName = vm.RCMeetingData.prospectLastName;
                vm.formProfile.investigationType = vm.RCMeetingData.investigationType;
                $scope.rcDetailsId = vm.RCMeetingData.rcDetailsId;
                if (vm.RCMeetingData.maxDate != null) {
                    vm.RCMeetingData.maxDate = new Date(vm.RCMeetingData.maxDate);
                }
                if (vm.RCMeetingData.minDate != null) {
                    vm.RCMeetingData.minDate = new Date(vm.RCMeetingData.minDate);
                }
            });
        };

        vm.saveRCSessionData = function(ev) {
            if (vm.RCMeetingData.assignmentDate != null) {
            	vm.RCMeetingData.assignmentDate = $scope.timzoneFormat(vm.RCMeetingData.assignmentDate);
                vm.RCMeetingData.assignmentDate = moment(vm.RCMeetingData.assignmentDate).format('YYYY-MM-DD');
            }
            vm.RCMeetingData.id = vm.RCSessionData.investigationRCId;
            vm.RCMeetingData.investigationId = vm.RCSessionData.id;
            vm.RCMeetingData.rcDetailsId = $scope.rcDetailsId;
            var valid = vm.validation(vm.RCMeetingData);
            if (valid == 0) {
                vm.saveRCSessionDataCall();
            } else {
                var id;
                if (valid == 1) {
                    id = 'fillOutDate';
                } else if (valid == 2) {
                    id = 'tabledConfirm';
                } else if (valid == 3) {
                    id = 'fillResult';
                }
                $mdDialog.show({
                    contentElement: angular.element('#' + id),
                    targetEvent: ev,
                    clickOutsideToClose: false
                });
            }
        };

        vm.backProfile = function() {
            vm.investigation.id = vm.RCSessionData.id;
            $state.go("profile", vm.investigation);
        };

        $scope.timzoneFormat = function(date) {
            var dt = new Date(date);
            // 'undo' the timezone offset again (so we end up on the original date again)
            dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
            return dt;
        };

        vm.validation = function(RCMeetingDataObj) {
            var isvalid = 0;
            if (RCMeetingDataObj.assignmentDate == null && RCMeetingDataObj.ageResult != null && RCMeetingDataObj.identityResult != null) {
                isvalid = 1;
            } else if ((RCMeetingDataObj.ageResult != null && RCMeetingDataObj.ageResult.refTermKey == vm.app.REF_TERM.RC_TABLED) || (RCMeetingDataObj.identityResult != null && RCMeetingDataObj.identityResult.refTermKey == vm.app.REF_TERM.RC_TABLED)) {
                isvalid = 2;
            } else if ((RCMeetingDataObj.ageResult == null && RCMeetingDataObj.identityResult != null) || (RCMeetingDataObj.ageResult != null && RCMeetingDataObj.identityResult == null)) {
            	isvalid = 3;
            }
            return isvalid;
        };

        vm.closePopup = function() {
            $mdDialog.cancel();
        };

        vm.resultConfirm = function(ev) {
        	$mdDialog.hide();
            if (vm.RCMeetingData.ageResult == null) {
                vm.RCMeetingData.ageResult = {};
                vm.RCMeetingData.ageResult.refTermKey = vm.app.REF_TERM.RC_TABLED;
            } else {
                vm.RCMeetingData.ageResult.refTermKey = vm.app.REF_TERM.RC_TABLED;
            }
            if (vm.RCMeetingData.identityResult == null) {
                vm.RCMeetingData.identityResult = {};
                vm.RCMeetingData.identityResult.refTermKey = vm.app.REF_TERM.RC_TABLED;
            } else {
                vm.RCMeetingData.identityResult.refTermKey = vm.app.REF_TERM.RC_TABLED;
            }
            if (vm.RCMeetingData.assignmentDate == null && vm.RCMeetingData.ageResult != null && vm.RCMeetingData.identityResult != null) {
            	$mdDialog.show({
                    contentElement: angular.element('#fillOutDate'),
                    targetEvent: ev,
                    clickOutsideToClose: false
                });
            } else {
            	 vm.saveRCSessionDataCall();
            }
        };
        
        vm.objectCompare = function() {
        	var valid = false;
        	if(vm.RCMeetingDataOldObj.assignmentDate != vm.RCMeetingData.assignmentDate){
        		valid = true;
        	} 
        	if(!angular.equals(vm.RCMeetingData.ageResult,vm.RCMeetingDataOldObj.ageResult) ){
        		valid = true;
        	}
        	if(!angular.equals(vm.RCMeetingData.identityResult,vm.RCMeetingDataOldObj.identityResult)){
        		valid = true;
        	} 
        	if(vm.RCMeetingData.commentData != (vm.RCMeetingDataOldObj.commentData!= null && vm.RCMeetingDataOldObj.commentData) ){
        		valid = true;
        	}
        	
        	return valid;
        };
        
        vm.saveRCSessionDataCall = function() {
        	$mdDialog.hide();
        	var equal = vm.objectCompare();
        	if(equal){
        		 var data = RCDetailsService.saveRCSessionData(vm.RCMeetingData);
                 data.then(function(response) {
                     vm.investigation.id = vm.RCSessionData.id;
                     /* To show any success message while the user successful update the RC meeting details. */
                     notifications.showSuccess({message: vm.app.INVESTIGATION.RC_DETAILS_SAVE});
                     $state.go("profile", vm.investigation);
                 });
        	} else {
        		vm.investigation.id = vm.RCSessionData.id;
                $state.go("profile", vm.investigation);
        	}
           
        };
        
      //It will get triggered while exiting from current state
    	$scope.$on('$destroy', function() {
    		delete $sessionStorage.isOpenCase;
        });
    	
    	$scope.trustAsHTML = function(htmlContent){
	   		return $sce.trustAsHtml(htmlContent);
	   	}
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('RCDetailsService', RCDetailsService);

    RCDetailsService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function RCDetailsService ($resource,restService,$q,$rootScope) {
    	
    	//Method to Get RC Session Data.
    	this.getRCSessionData= function(investigationId,investigationRCId){
    		var deferred = $q.defer();
    		var url = "investigation-rcs/"+investigationId+"/"+investigationRCId;
    		var data = restService.restCall("", url, 'GET');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    	
    	//Method to save RC Session Data.
    	this.saveRCSessionData= function(RCMeetingData){
    		var deferred = $q.defer();
    		var url = "investigation-rcs/"+RCMeetingData.investigationId+"/"+RCMeetingData.id;
    		var data = restService.restCall(RCMeetingData, url, 'PUT');
    		data.$promise.then(function(response){
    			deferred.resolve(response);
    		},
    		function (error) {
    			deferred.reject('ERROR');
    		});
    		return deferred.promise;
    	};
    }
})();
(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('rcHeader', {
            parent: 'profile',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationRCId:null
            },
            views: {
             'content@': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/investigation.form.header.html',
                    controller: 'InvestigationFormHeaderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        })
    	.state('rcDetails', {
            parent: 'rcHeader',
            url: '/:investigationRCId/RC',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationRCId:null,
            	isOpenCase:null
            },
            views: {
             'invesForm': {
                    templateUrl: 'app/investigation/prospects/profile/rc/rc.details.html',
                    controller: 'RCDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('rcDetails.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('rcDetails.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }]
            }
        });
    }
})();
(function () {
  "use strict";

  angular.module("lariAidApp").controller("LegacyLariController", LegacyLariController);

  LegacyLariController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$mdSidenav",
    "$element",
    "APP",
    "tabservice",
    "$mdMedia",
    "$sessionStorage",
    "$cookies",
    "LegacyLariService",
    "$mdDialog",
    "CommonService",
    "$q",
    "communicationService",
    "$timeout",
    "StorageDelete",
    "notifications",
    "$http",
    "BASE_URL"
  ];

  function LegacyLariController(
    $scope,
    $state,
    $stateParams,
    $mdSidenav,
    $element,
    APP,
    tabservice,
    $mdMedia,
    $sessionStorage,
    $cookies,
    LegacyLariService,
    $mdDialog,
    CommonService,
    $q,
    communicationService,
    $timeout,
    StorageDelete,
    notifications,
    $http,
    BASE_URL
  ) {
    var vm = this;
    var requestListTotalLength = 0;
    var clickingTimerRequest;

    vm.APP = APP;
    vm.state = $state;
    vm.currentState = vm.state.current.name;
    vm.user = CommonService.getCookieUser();
    vm.loggedUserRole = vm.user.loggedUserRole;
    vm.loadingListData = false;
    vm.requestFilterObj = {};
    vm.requestFileObj = {};
    vm.requestList = [];
    vm.media = $mdMedia;
    vm.search = true;
    vm.prospectId = "";
    vm.endless = vm.APP.GLOBAL.ENDLESS;
    vm.noResult = false;

    vm.getRequestList = function (type) {
      if (!vm.media("gt-sm")) {
        vm.loadingRequestData = true;
      }
      clearTimeout(clickingTimerRequest);
      clickingTimerRequest = setTimeout(function () {
        if (type != vm.endless) {
          vm.requestList = [];
        }
        var data = LegacyLariService.getRequestLists(vm.requestFilterObj);
        data.then(
          function (response) {
            vm.loadingRequestData = false;
            if (response && !angular.equals({}, response)) {
              vm.prospectId = response.prospectId;
              if (vm.prospectId == null) vm.noResult = true;
              angular.forEach(response.documents, function (value, key) {
                if (vm.requestList == null) {
                  vm.requestList = [];
                  vm.requestList.push(value);
                } else {
                  vm.requestList.push(value);
                }
              });
            } else if (angular.isUndefined(response)) {
              vm.loadingRequestData = false;
            }
          },
          function (reason) {
            vm.noResult = true;
            vm.loadingRequestData = false;
            if (reason.data.statusCode == 404) {
              notifications.showError({ message: vm.APP.LEGACYLARI.NO_EBIS_ID_FOUND });
            } else if (reason.data.statusCode == 409) {
              notifications.showError({ message: vm.APP.LEGACYLARI.UNABLE_TO_CONNECT_LEGACY_LARI_SYSTEM });
            } else if (reason.data.statusCode == 500) {
              notifications.showError({ message: vm.APP.LEGACYLARI.INTERNAL_SERVER_ERROR });
            }
            return reason;
          }
        );
      }, 200);
    };

    vm.searchRequest = function (requestSearchKey) {
      vm.requestFilterObj.searchKey = requestSearchKey;
      if (requestSearchKey.length > 3) {
        vm.loadingRequestData = true;
        vm.search = false;
        vm.noResult = false;
        vm.getRequestList();
      } else {
        vm.loadingRequestData = false;
        vm.noResult = false;
        vm.search = true;
      }
    };

    vm.downloadFile = function (fileType, index) {
      vm.loadingRequestData = true;
      vm.requestFileObj = vm.requestList[index];
      vm.requestFileObj.prospectId = vm.prospectId;
      var queryParams = {
        prospectId: vm.prospectId,
        documentId: vm.requestFileObj.id,
        fileTypeId: vm.requestFileObj.fileTypeId
      };

      var paramString = Object.entries(queryParams)
        .map(function (entry) {
          return entry[0] + "=" + entry[1];
        })
        .join("&");
      $http.get(BASE_URL + "api/getDocumentData?" + paramString, { responseType: "arraybuffer" }).then(
        function successCallback(response) {
          var contentType = response.headers("Content-Type");
          var contentDisposition = response.headers("Content-Disposition");
          var link = document.createElement("a");
          link.target = "_blank";

          // if there is no fileName header & the content type is JSON, this will return a link
          if (!contentDisposition && contentType === "application/json") {
            var decoded = new TextDecoder().decode(response.data);
            var body = JSON.parse(decoded);
            link.href = body.link;
          } else {
            var file = new Blob([response.data], { type: contentType });
            link.href = window.URL.createObjectURL(file);
            var header = response.headers()["content-disposition"];
            var regex = /.*filename="(.+)"$/i.exec(header || "");
            link.download = regex ? regex[1] : vm.requestFileObj.fileName;
          }

          link.click();
          vm.loadingRequestData = false;
          $q.resolve(fileURL);
        },
        function errorCallback(response) {
          if (response.status == 404) {
            notifications.showError({ message: vm.APP.LEGACYLARI.NO_DOCUMENT_FOUND });
          } else if (response.status == 409) {
            notifications.showError({ message: vm.APP.LEGACYLARI.ERROR_DOWNLOADING_DOCUMENT });
          } else if (response.status == 500) {
            notifications.showError({ message: vm.APP.LEGACYLARI.INTERNAL_SERVER_ERROR });
          } else if (response.status == 400) {
            notifications.showError({ message: vm.APP.LEGACYLARI.BAD_REQUEST });
          }
          vm.loadingRequestData = false;
        }
      );
    };
  }
})();

(function () {
  "use strict";

  angular.module("lariAidApp").service("LegacyLariService", LegacyLariService);

  LegacyLariService.$inject = ["$resource", "restService", "$q", "$rootScope"];

  function LegacyLariService($resource, restService, $q, $rootScope) {
    this.getRequestLists = function (filterObj) {
      var deferred = $q.defer();
      var ebisId = filterObj.searchKey;
      var url = "getDocumentsByEbisId" + "/" + ebisId;
      var data = restService.restCall("", url, "GET");
      data.$promise.then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('lariAidApp')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider', 'APP', '$mdAriaProvider', '$mdDateLocaleProvider'];

  function stateConfig($stateProvider, APP, $mdAriaProvider, $mdDateLocaleProvider) {
    $stateProvider.state('legacyLari', {
      parent: 'app',
      url: '/legacyLari',
      data: {
        authorities: APP.GLOBAL.USER_GROUP
      },
      views: {
        'dynamicView': {
          templateUrl: 'app/legacyLari/legacyLari.management.html',
          controller: 'LegacyLariController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          if (localStorage && localStorage.getItem('lari_currentVersion') != null) {
            $translatePartialLoader.addPart('legacyLari.json?version=' + localStorage.getItem('lari_currentVersion'));
          } else {
            $translatePartialLoader.addPart('legacyLari.json?timestamp=' + new Date().getTime());
          }
          return $translate.refresh();
        }]
      }

    });
  }

})();
(function(){'use strict';angular.module('lariAidApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li><li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li><li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li><li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li><li><a href="https://twitter.com/java_hipster" target="_blank" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!</p></div></div></div>');
$templateCache.put('app/investigation/investigation.filters.html','<div layout="row"><div flex="100" layout="row" ng-cloak><div><md-button ng-click="vm.toggleLeft()" class="md-primary" hide-gt-sm>Toggle left</md-button></div></div></div>');
$templateCache.put('app/investigation/investigation.header.html','<div layout="row" class="contentWidth pagePadding investigationHeaderTop"><div flex layout="row" layout-xs="column" layout-sm="column" class="colorWh investigationMargin investigationHeader"><div layout="row" flex layout-align="space-between center" class="invBottom"><div layout="row" layout-align="start center" class="invLeft"><div ng-click="toggleLeft()" class="mr24" hide-gt-sm><i class="material-icons">sort</i></div><div flex-gt-xs="" class="invHeader pl30" data-translate="dashboard.header.investigations"></div></div><div><div ng-click="vm.toggleLeft()" hide-gt-sm><i class="material-icons">tune</i></div></div></div><div layout="row" class="mr4 rghtAlign" layout-align-gt-sm="end" layout-align="space-around center"><div class="noOutLine headCountFilterCls" ng-class="{\'disable notAllowed\':vm.loadingListData}" layout="row" layout-align="center center" layout-xs="column" ng-click="vm.getFilterList(undefined,vm.APP.GLOBAL.TRUE,vm.APP.INVESTIGATION.HEADER_TYPE_ALL);"><div class="circle allActive" ng-bind="vm.statusReport.activeStatusCount"></div><div class="pdLeftSize statusName caps" data-translate="dashboard.header.active"></div></div><div class="noOutLine headCountFilterCls" ng-class="{\'disable notAllowed\':vm.loadingListData}" layout="row" layout-align="center center" layout-xs="column" ng-click="vm.getFilterList(undefined,vm.APP.GLOBAL.TRUE,vm.APP.INVESTIGATION.HEADER_TYPE_FIFTEEN);"><div class="circle fifteenOpen" ng-bind="vm.statusReport.fifteenDaysOpenCount"></div><div class="pdLeftSize statusName caps" data-translate="dashboard.header.daysopen.fifteen"></div></div><div class="noOutLine mr5" ng-class="{\'disable notAllowed\':vm.loadingListData}" layout="row" layout-align="center center" layout-xs="column" ng-click="vm.getFilterList(undefined,vm.APP.GLOBAL.TRUE,vm.APP.INVESTIGATION.HEADER_TYPE_THIRTY);"><div class="circle thirtyOpen" ng-bind="vm.statusReport.thirtyDaysOpenCount"></div><div class="pdLeftSize statusName caps" data-translate="dashboard.header.daysopen.thirty"></div></div></div></div></div>');
$templateCache.put('app/investigation/investigation.html','<div layout="column"><div ng-include class="paddingT" layout-align="center center" layout="row" src="\'app/investigation/investigation.header.html\'"></div><div layout="row" layout-align="center start" class="lytWhiteBg" resize ng-style="{\'height\':windowHeight}"><div ng-show="vm.filterCountLoader"><md-progress-linear class="countListLoad" ng-show="vm.filterCountLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-show="!vm.filterCountLoader" layout="row" class="contentWidth pagePadding invTotSty"><div id="investigationFilterId" flex="25" flex-xs="0" flex-sm="0" show-gt-sm resize style="overflow-y:auto; overflow-x:hidden" ng-style="{\'height\':windowHeight}"><!-- <md-sidenav flex="20" class="md-sidenav-right filterPannel" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id ="right" > --><md-sidenav flex="100" class="md-sidenav-right" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right"><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filters.filters"></div><!-- <div class="md-toolbar-tools tgRightTitle" data-translate="dashboard.filters.manager"></div> --><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER" class="md-toolbar-tools tgRightTitle">Manager</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ADMIN" class="md-toolbar-tools tgRightTitle">Admin</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="md-toolbar-tools tgRightTitle">Investigator</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ANALYST" class="md-toolbar-tools tgRightTitle">Analyst</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN" class="md-toolbar-tools tgRightTitle">Country Admin</div></md-toolbar><div class="backcolor pt30 mblSideFilter pl30" layout-align="center center"><div ng-show="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div class="filters" layout="row"><div flex="85"><md-checkbox ng-model="vm.myInvestigation.checked" ng-click="vm.toggleMyInvestigation(vm.myInvestigation,true);"><span data-translate="dashboard.filters.investigationSideFilter.myInvestigation"></span></md-checkbox></div><div flex="10"></div></div><div ng-if="vm.openInvestigationList.length > 0 && vm.allActiveType.count > 0" layout="column" layout-align="start start" class="filterHeading caps" data-translate="dashboard.filters.investigationType.open"></div><div class="filters" ng-if="vm.openInvestigationList.length > 0  && vm.allActiveType.count > 0" layout="row"><div flex="85"><md-checkbox ng-disabled="vm.loadingListData" ng-model="vm.allActiveType.checked" ng-checked="vm.isChecked()" ng-click="vm.toggleAll(!vm.allActiveType.checked);"><span data-translate="dashboard.filters.investigationAllActive.ALL_ACTIVE"></span></md-checkbox></div><div flex="10" class="w18mr"><div class="filtersCount">{{vm.allActiveType.count}}</div></div></div><div class="filters" ng-if="((openInvestigationStatus.count > 0  && vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) || vm.userRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN )" layout="row" ng-repeat="openInvestigationStatus in vm.openInvestigationList track by $index"><div flex="85"><md-checkbox ng-disabled="vm.loadingListData" ng-model="openInvestigationStatus.checked" ng-checked="vm.exists(openInvestigationStatus, vm.selectedItemList)" ng-click="vm.toggle(openInvestigationStatus, vm.selectedItemList, $index);"><span data-translate="dashboard.filters.investigationSideNavFilter.{{openInvestigationStatus.key}}"></span></md-checkbox></div><div flex="10" class="w18mr"><div class="filtersCount">{{openInvestigationStatus.count}}</div></div></div><div ng-if="vm.closeInvestigationList.length > 0 && (vm.closeInvestigationList[0].count > 0 || vm.closeInvestigationList[1].count > 0 || vm.closeInvestigationList[2].count > 0 || vm.closeInvestigationList[3].count > 0 || vm.closeInvestigationList[4].count > 0 || vm.closeInvestigationList[5].count > 0)" layout="column" layout-align="start start" class="filterHeading caps" data-translate="dashboard.filters.investigationType.close"></div><div class="filters" layout="row" ng-if="((closeInvestigationStatus.count > 0  && vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) || vm.userRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN )" ng-repeat="closeInvestigationStatus in vm.closeInvestigationList track by $index"><div flex="85"><md-checkbox ng-disabled="vm.loadingListData" ng-model="closeInvestigationStatus.checked" ng-change="vm.loadCloseinvList(closeInvestigationStatus, vm.selectCloseList);"><span data-translate="dashboard.filters.investigationCloseFilter.{{closeInvestigationStatus.key}}"></span></md-checkbox></div><div flex="10"><div class="filtersCount">{{closeInvestigationStatus.count}}</div></div></div></div><div ng-if="vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div ng-if="vm.statusList.length > 0" layout="column" layout-align="start start" class="filterHeading caps" data-translate="dashboard.filters.status"></div><div class="filters" ng-if="openInvestigationStatus.count > 0" layout="row" ng-repeat="openInvestigationStatus in vm.statusList track by $index"><div flex="85"><md-checkbox ng-disabled="vm.loadingListData" ng-if="vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR" ng-model="openInvestigationStatus.checked" ng-click="vm.toggle(openInvestigationStatus, vm.selectedItemList, $index);"><span data-translate="dashboard.filters.investigationType.{{openInvestigationStatus.name}}"></span></md-checkbox></div><div flex="10"><div class="filtersCount">{{openInvestigationStatus.count}}</div></div></div><!-- <md-divider ng-if="vm.daysList.length > 0 && (vm.daysList[0].count > 0 || vm.daysList[1].count > 0)" class="dividerStyle" flex="95"></md-divider>\n\t\t\t\t\t          <div class="filters" ng-if="closeInvestigationStatus.count > 0" layout="row" ng-repeat="closeInvestigationStatus in vm.daysList track by $index">\n\t\t\t\t                  <div flex="85">\n   \t\t\t\t\t\t\t\t\t   <md-checkbox ng-model="closeInvestigationStatus.checked" ng-change="vm.loadCloseinvList(closeInvestigationStatus, vm.selectCloseList)">{{closeInvestigationStatus.name}}</md-checkbox>          \n\t\t\t\t                  </div>\n\t\t\t\t                  <div flex="10" >\n\t\t\t\t                     <div class="filtersCount">{{closeInvestigationStatus.count}}</div>\n\t\t\t\t                  </div>\n\t\t\t\t\t          </div> --></div><md-divider flex="95" ng-if="(vm.allActiveType.count > 0) || (vm.closeInvestigationList[0].count > 0 || vm.closeInvestigationList[1].count > 0 || vm.closeInvestigationList[2].count > 0 || vm.closeInvestigationList[3].count > 0 || vm.closeInvestigationList[4].count > 0)" class="dividerStyle"></md-divider><div ng-show="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><!-- Investigator Filter --> <i ng-if="vm.filters.investigators.id" ng-click="vm.clear(\'investigators\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.investigators.id" ng-model="vm.filters.investigators" md-on-close="vm.clearName(\'investigators\',\'investigatorSearchKey\',\'investigatorVO\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.investigators.id == undefined ? (\'dashboard.placeholder.investigators\' | translate) : vm.filters.investigators.name }}" class="md-no-underline selectHeader dropdownSelection caps"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char common-search search-callback="vm.searchInvestigatorAnalyst(investigatorSearchKey,vm.roleInvestigator)" name="investigatorSearchKey" class="left-drop-search mb18 cursorText" ng-model="investigatorSearchKey" ng-change="vm.investigatorVO = undefined" ng-minlength="2" placeholder="{{\'dashboard.search.investigator\' | translate}}" type="search"><!-- <i flex-order="3" ng-if="investigatorSearchKey.length > 1" ng-click="vm.clear(\'investigators\',false);" class="material-icons removeSelection" >close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="investigatorSearchKey.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.investigatorLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.investigatorVO" class="stickySearch"><md-option ng-if="investigatorSearchKey.length >1" ng-value="dropValueInv" ng-repeat="dropValueInv in vm.investigatorVO"><span ng-if="!vm.filters.investigators.id"><ng-letter-avatar ng-if="!vm.filters.investigators.id" fontsize="18px" shape="round" avatarcustomborder="margin-right: 10px;" height="30px" width="30px" data="{{ dropValueInv.name| limitTo : limit : begin}}"></ng-letter-avatar></span><span>{{dropValueInv.name}}</span></md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.investigatorVO.length == 0 && investigatorSearchKey.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Analysts Filter--> <i ng-if="vm.filters.analysts.id" ng-click="vm.clear(\'analysts\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-show="vm.userRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN" ng-disabled="vm.filters.analysts.id" ng-model="vm.filters.analysts" md-on-close="vm.clearName(\'analysts\',\'analystSearchKey\',\'analystVO\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.analysts.id == undefined ? (\'dashboard.placeholder.analyst\' | translate) : vm.filters.analysts.name}}" class="md-no-underline selectHeader dropdownSelection caps ofH"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char common-search search-callback="vm.searchInvestigatorAnalyst(analystSearchKey,vm.roleAnalyst)" ng-change="vm.analystVO = undefined" name="analystSearchKey" class="left-drop-search mb18 cursorText" ng-model="analystSearchKey" ng-minlength="2" placeholder="{{\'dashboard.search.analyst\' | translate}}" type="search"><!-- <i flex-order="3" ng-if="analystSearchKey.length > 1" ng-click="vm.clear(\'analysts\',false);" class="material-icons removeSelection" >close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="analystSearchKey.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.analystLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.analystVO" class="stickySearch"><md-option ng-if="analystSearchKey.length >1" ng-value="dropValueAnlst" ng-repeat="dropValueAnlst in vm.analystVO"><span ng-if="!vm.filters.analysts.id"><ng-letter-avatar ng-if="!vm.filters.analysts.id" shape="round" fontsize="18px" avatarcustomborder="margin-right: 10px;" height="30px" width="30px" data="{{ dropValueAnlst.name| limitTo : limit : begin}}"></ng-letter-avatar></span><span>{{dropValueAnlst.name}}</span></md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.analystVO.length == 0 && analystSearchKey.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Regions Filter--> <i ng-if="vm.filters.regions.length > 0" ng-click="vm.clear(\'regions\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><!-- <div><span style="float: right;">{{vm.selectedCountries}}</span> </div> --><md-select ng-model="vm.filters.regions" md-on-close="vm.filters.regions.length > 0? vm.getFilterList():\'\';vm.clearName(\'regions\',\'regionSearchKey\',\'regionVO\');" placeholder="{{vm.filters.regions.length === 0? (\'dashboard.placeholder.regions\' | translate) : vm.selectedCountries}}" ng-change="vm.selectCountry();" class="md-no-underline selectHeader dropdownSelection caps ofH" multiple="multiple"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char name="regionSearchKey" ng-model="regionSearchKey" type="search" placeholder="{{\'dashboard.search.regions\' | translate}}" class="left-drop-search mb18 cursorText"><!-- <i flex-order="3" ng-if="regionSearchKey.length > 1" ng-click="vm.clear(\'regions\',false);" class="material-icons removeSelection" >close</i> --></md-input-container></md-select-header><md-optgroup label="vm.regionVO" class="regionStickySearch noHScroll"><div ng-hide="regionSearchKey" layout="row" class="mt1p"><div class="ml12"><md-checkbox ng-model="vm.allCountries" ng-click="vm.selectAllCountries();"></md-checkbox></div><div flex="40" class="md-text" data-translate="dashboard.filters.AllCountries"></div></div><div ng-if="!vm.allCountries" style="border: 1px solid #C9CBCE;"></div><md-progress-linear ng-if="vm.regionsLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-option ng-if="vm.filters.regions.length > 0 && language == \'en\'" ng-value="dropValueReg" ng-repeat="dropValueReg in vm.filters.regions | filter: regionSearchKey | orderBy : \'name\'" ng-click="vm.showSelectedCountry(dropValueReg.id, false);">{{dropValueReg.name}}</md-option><md-option ng-if="vm.filters.regions.length > 0 && language == \'es\'" ng-value="dropValueReg" ng-repeat="dropValueReg in vm.filters.regions | filter: regionSearchKey | orderBy : \'spanishName\'" ng-click="vm.showSelectedCountry(dropValueReg.id, false);"><span data-translate="dashboard.filters.countries.{{dropValueReg.name}}"></span></md-option><div ng-if="!vm.allCountries" style="border: 1px solid #C9CBCE;"></div><!--For English Language --><md-option ng-if="language == \'en\'" ng-value="dropValueReg" ng-repeat="dropValueReg in vm.allRegions | filter: { hidden: false } | filter: regionSearchKey | orderBy : \'name\'" ng-click="vm.showSelectedCountry(dropValueReg.id, true);">{{dropValueReg.name}}</md-option><!--For Spanish Language --><md-option ng-if="language == \'es\'" ng-value="dropValueReg" ng-repeat="dropValueReg in vm.allRegions | filter: { hidden: false } | filter: regionSearchKey | orderBy : \'spanishName\'" ng-click="vm.showSelectedCountry(dropValueReg.id, true);"><span data-translate="dashboard.filters.countries.{{dropValueReg.name}}"></span></md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.regionVO.length == 0 && regionSearchKey.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Club Filter--> <i ng-if="vm.filters.club.id" ng-click="vm.clear(\'club\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.club.id" ng-model="vm.filters.club" md-on-close="vm.clearName(\'club\',\'serchFilterClub\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.club.id == undefined ? (\'dashboard.placeholder.organization\' | translate) : vm.filters.club.name}}" class="md-no-underline selectHeader dropdownSelection caps ofH"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char ng-model="serchFilterClub" type="search" placeholder="{{\'dashboard.search.organization\' | translate}}" class="left-drop-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="vm.clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="serchFilterClub.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.clubLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.clubVO" class="stickySearch"><md-option ng-if="serchFilterClub.length >1" ng-value="dropValueClub" ng-repeat="dropValueClub in clubVO = (vm.clubVO | filter:serchFilterClub)">{{dropValueClub.name}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="clubVO.length == 0 && serchFilterClub.length > 1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Investigation Types Filter --> <i ng-if="vm.filters.investigationTypes.id" ng-click="vm.clear(\'investigationTypes\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.investigationTypes.id" ng-model="vm.filters.investigationTypes" md-on-close="vm.clearName(\'investigationTypes\',\'serchFilterInvType\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.investigationTypes.id == undefined ? (\'dashboard.placeholder.investigationtype\' | translate) : vm.filters.investigationTypes.name }}" class="md-no-underline selectHeader dropdownSelection caps ofH"><!-- <md-select-header>\n\t\t\t\t\t\t\t      \t\t<md-input-container md-no-float class="md-block drop-search">\n\t\t\t\t\t\t\t\t\t\t\t<i class="material-icons left-drop-icon">search</i>\n\t\t\t\t\t\t\t\t\t\t\t<input common-search search-callback="vm.searchType(\'INVESTIGATION_TYPE\')" ng-model="serchFilterInvType" type="search" placeholder="Search Users" class="left-drop-search">\n\t\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t      </md-select-header> --><md-progress-linear ng-if="vm.investigationTypeLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-option ng-value="dropValueInvType" ng-repeat="dropValueInvType in vm.investigationVO | filter:serchFilterInvType"><span data-translate="dashboard.filters.investigationInvTypes.{{dropValueInvType.key}}"></span></md-option><div class="textcenter searchnote" ng-if="vm.investigationVO.length == 0 && serchFilterInvType.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Registration type Filter--> <i ng-if="vm.filters.registrationTypes.id" ng-click="vm.clear(\'registrationTypes\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.registrationTypes.id" ng-model="vm.filters.registrationTypes" md-on-close="vm.clearName(\'registrationTypes\',\'serchFilterRegType\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.registrationTypes.id == undefined ? (\'dashboard.placeholder.registrationtype\' | translate) : vm.filters.registrationTypes.name}}" class="md-no-underline selectHeader dropdownSelection caps ofH"><!-- <md-select-header>\n\t\t\t\t\t\t\t      \t\t<md-input-container md-no-float class="md-block drop-search">\n\t\t\t\t\t\t\t\t\t\t\t<i class="material-icons left-drop-icon">search</i>\n\t\t\t\t\t\t\t\t\t\t\t<input common-search search-callback="vm.searchType(\'RIGISTRATION_TYPE\')" ng-model="serchFilterRegType" type="search" placeholder="Search Users" class="left-drop-search">\n\t\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t      </md-select-header> --><md-progress-linear ng-if="vm.registrationTypeLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-option ng-value="dropValueRegTyp" ng-repeat="dropValueRegTyp in vm.registrationVO | filter:serchFilterRegType"><span data-translate="dashboard.filters.investigationRegTypes.{{dropValueRegTyp.key}}"></span></md-option>{{dropValueRegTyp.name}}<div class="textcenter searchnote" ng-if="vm.registrationVO.length == 0 && dropValueRegTyp.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Agents Filter--> <i ng-if="vm.filters.agents.id" ng-click="vm.clear(\'agents\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.agents.id" ng-model="vm.filters.agents" md-on-close="vm.clearName(\'agents\',\'agentSearchKey\',\'agentVO\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.agents.id == undefined ? (\'dashboard.placeholder.agents\' | translate) : vm.filters.agents.name }}" class="md-no-underline selectHeader dropdownSelection caps ofH"><md-select-header><md-input-container md-no-float class="md-block drop-search"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char common-search search-callback="vm.searchAgent(agentSearchKey)" name="agentSearch" ng-change="vm.agentVO = undefined" class="left-drop-search cursorText" ng-model="agentSearchKey" ng-minlength="2" placeholder="{{\'dashboard.search.agents\' | translate}}" type="search"><!-- <i flex-order="3" ng-if="agentSearchKey.length > 1" ng-click="vm.clear(\'agents\',false);" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="agentSearchKey.length > 1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.agentLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.agentVO" class="stickySearch"><md-option ng-if="agentSearchKey.length >1" ng-value="dropValueAgnt" ng-repeat="dropValueAgnt in vm.agentVO"><span ng-if="!vm.filters.agents.id"><ng-letter-avatar ng-if="!vm.filters.agents.id" shape="round" fontsize="18px" avatarcustomborder="margin-right: 10px;" height="30px" width="30px" data="{{ dropValueAgnt.name| limitTo : limit : begin}}"></ng-letter-avatar></span><span>{{dropValueAgnt.name}}</span></md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.agentVO.length == 0 && agentSearchKey.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select><!-- Days Open Filter--><div ng-if="vm.filters.isClosedFilter" flex="40" class="md-text dashboardDateFilter pb10 pt10" data-translate="dashboard.placeholder.openDateFilter"></div><div ng-show="(!vm.filters.isByClosedDate || vm.filters.isByClosedDate == undefined)"><i ng-if="vm.filters.startDate && vm.filters.endDate" ng-click="vm.clear(\'time\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.startDate && vm.filters.endDate" md-on-open="vm.filters.isByClosedDate = false" md-on-close="vm.clearDate(\'startDate\',\'endDate\');!(vm.filters.startDate && vm.filters.endDate)?vm.filters.isByClosedDate = undefined:\'\';" ng-model="vm.filters.time" placeholder="{{(vm.filters.startDate && vm.filters.endDate) ? (vm.filters.displayDate) : (\'dashboard.placeholder.openDateFilter\' | translate)}}" class="md-no-underline selectHeader dropdownSelection caps ofH"><div layout-padding-lg><div layout="row" layout-xs="column" class="mb10"><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 1}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.ONE_MONTH,true);selectedDiv = 1;vm.filters.isClosedFilter = false;"><span data-translate="dashboard.filters.lastOneMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 2}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.THREE_MONTH,true);selectedDiv = 2;vm.filters.isClosedFilter = false;"><span data-translate="dashboard.filters.lastThreeMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 3}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.SIX_MONTH,true);selectedDiv = 3;vm.filters.isClosedFilter = false;"><span data-translate="dashboard.filters.lastSixMonth"></span></div></div><div layout="row" flex layout-align="space-between center" class="hideIcon mr10"><div><md-datepicker ng-change="vm.dateChange(true);selectedDiv = 0;vm.filters.isClosedFilter = false;" ng-model="vm.filters.startDate" md-placeholder="{{(\'dashboard.placeholder.From date\') | translate}}" md-min-date="minDate" md-max-date="maxDates" date-picker-local-date dp-blur-format></md-datepicker></div><span>-</span><div><md-datepicker ng-change="vm.dateChange(true);selectedDiv = 0;vm.filters.isClosedFilter = false;" ng-model="vm.filters.endDate" md-placeholder="{{(\'dashboard.placeholder.To date\') | translate}}" md-min-date="minDates" md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker></div></div></div></md-select></div><!-- Days Closed Filter--><div ng-if="vm.filters.isClosedFilter != undefined && !vm.filters.isClosedFilter" flex="40" class="md-text dashboardDateFilter pb10 pt10" data-translate="dashboard.placeholder.closeDateFilter"></div><div ng-show="(vm.filters.isByClosedDate || vm.filters.isByClosedDate == undefined)"><i ng-if="vm.filters.startDate && vm.filters.endDate" ng-click="vm.clear(\'time\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.filters.startDate && vm.filters.endDate" md-on-open="vm.filters.isByClosedDate = true" md-on-close="vm.clearDate(\'startDate\',\'endDate\');!(vm.filters.startDate && vm.filters.endDate)?vm.filters.isByClosedDate = undefined:\'\';" ng-model="vm.filters.time" placeholder="{{(vm.filters.startDate && vm.filters.endDate) ? (vm.filters.displayDate) : (\'dashboard.placeholder.closeDateFilter\' | translate)}}" class="md-no-underline selectHeader dropdownSelection caps ofH"><div layout-padding-lg><div layout="row" layout-xs="column" class="mb10"><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 1}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.ONE_MONTH,true);selectedDiv = 1;vm.filters.isClosedFilter = true;"><span data-translate="dashboard.filters.lastOneMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 2}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.THREE_MONTH,true);selectedDiv = 2;vm.filters.isClosedFilter = true;"><span data-translate="dashboard.filters.lastThreeMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 3}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.SIX_MONTH,true);selectedDiv = 3;vm.filters.isClosedFilter = true;"><span data-translate="dashboard.filters.lastSixMonth"></span></div></div><div layout="row" flex layout-align="space-between center" class="hideIcon mr10"><div><md-datepicker ng-change="vm.dateChange(true);selectedDiv = 0;vm.filters.isClosedFilter = true;" ng-model="vm.filters.startDate" md-placeholder="{{(\'dashboard.placeholder.From date\') | translate}}" md-min-date="minDate" md-max-date="maxDates" date-picker-local-date dp-blur-format></md-datepicker></div><span>-</span><div><md-datepicker ng-change="vm.dateChange(true);selectedDiv = 0;vm.filters.isClosedFilter = true;" ng-model="vm.filters.endDate" md-placeholder="{{(\'dashboard.placeholder.To date\') | translate}}" md-min-date="minDates" md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker></div></div></div></md-select></div><!-- filters for new DNA CR --><div ng-show="vm.userRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><div class="fc100 mtop20" style="margin-bottom: 22px;" data-translate="dashboard.dna filters"></div><div class="iconUpDown" ng-click="vm.dnaFiltersShow(\'dna\')"><i class="material-icons navAccountArrowdna" ng-show="dnaIcon">arrow_drop_down</i> <i class="material-icons navAccountArrowdna" ng-show="!dnaIcon">arrow_drop_up</i></div><div ng-show="!dnaIcon"><md-checkbox ng-model="isDnaNotRequired" class="mr16px" ng-click="vm.dnaTestFilters(isDnaNotRequired,\'dnaNotRequired\')"><div flex="" class="fc100" data-translate="dashboard.Dna Test Not Required"></div></md-checkbox><md-checkbox ng-model="isDnaPending" ng-click="vm.dnaTestFilters(isDnaPending,\'dnaTestPending\')"><div flex="" class="fc100" data-translate="dashboard.Dna Test Pending"></div></md-checkbox><md-checkbox ng-model="isDnaConducted" ng-click="vm.dnaTestFilters(isDnaConducted ,\'dnaTestConducted\')"><div flex="" class="fc100" data-translate="dashboard.Dna Test Conducted"></div></md-checkbox><!-- First filter for DNA CR in open investigation --><div layout="row" class="dnadropdownSelection clrgray" ng-show="!dnaIcon"><span style="margin-top: -6px;"><i ng-if="vm.filters.startDateOfDnaTestOpenInv && vm.filters.endDateOfDnaTestOpenInv" ng-click="vm.clear(\'openInvestigationDnaDates\',true);vm.checkboxHideAndShow(!dateOfDnaTestOpenInv,\'dateOfDnaTest\');" class="material-icons removeSelectionTest fleft" data-translate="dashboard.filters.close"></i></span><div class="dropdowninTestSelection"><div ng-if="vm.filters.isDnaClosedFilter != undefined && !vm.filters.isDnaClosedFilter" flex="40" class="" data-translate="dashboard.Date of Dna Test"></div><div class="marginright" ng-show="(vm.filters.isDnaByClosedDate || vm.filters.isDnaByClosedDate == undefined )"><md-select ng-disabled="vm.filters.startDateOfDnaTestOpenInv && vm.filters.endDateOfDnaTestOpenInv" md-on-open="vm.filters.isDnaClosedFilter = true" md-on-close="vm.clearDate(\'startDate\',\'endDate\');!(vm.filters.startDateOfDnaTestOpenInv && vm.filters.endDateOfDnaTestOpenInv)?vm.filters.isDnaByClosedDate = undefined:\'\';" ng-model="vm.filters.dnaTest" placeholder="{{(vm.filters.startDateOfDnaTestOpenInv && vm.filters.endDateOfDnaTestOpenInv) ? (vm.filters.displayDnaDateOfTestOpenInvestigation) : (\'dashboard.DateofDnaTest\' | translate)}}" class="md-no-underline" layout="column" ng-class="(vm.filters.startDateOfDnaTestOpenInv && vm.filters.endDateOfDnaTestOpenInv) ? \'dnaTestRecivedOpenInvestigation\' : \'w40mr\'"><div layout-padding-lg><div layout="row" layout-xs="column" class="mb10"><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 1}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.ONE_MONTH,true,\'displayDnaDateOfTestOpenInvestigation\');selectedDiv = 1;vm.filters.isDnaByClosedDate = true;"><span data-translate="dashboard.filters.lastOneMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 2}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.THREE_MONTH,true,\'displayDnaDateOfTestOpenInvestigation\');selectedDiv = 2;vm.filters.isDnaByClosedDate = true;"><span data-translate="dashboard.filters.lastThreeMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 3}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.SIX_MONTH,true,\'displayDnaDateOfTestOpenInvestigation\');selectedDiv = 3;vm.filters.isDnaByClosedDate = true;"><span data-translate="dashboard.filters.lastSixMonth"></span></div></div><div layout="row" flex layout-align="space-between center" class="hideIcon mr100"><div><md-datepicker ng-change="vm.dateChange(true,\'displayDnaDateOfTestOpenInvestigation\');selectedDiv = 0;vm.filters.isDnaByClosedDate = true;" ng-model="vm.filters.startDateOfDnaTestOpenInv" md-placeholder="From date" md-min-date="minDate" md-max-date="maxDates" date-picker-local-date dp-blur-format></md-datepicker></div><span>-</span><div><md-datepicker ng-change="vm.dateChange(true,\'displayDnaDateOfTestOpenInvestigation\');selectedDiv = 0;vm.filters.isDnaByClosedDate = true;" ng-model="vm.filters.endDateOfDnaTestOpenInv" md-placeholder="To date" md-min-date="minDates" md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker></div></div></div></md-select></div></div></div><!-- Second filter for DNA CR in open investigation --><div layout="row" class="clrgray"><span style="margin-top: -6px;"><i ng-if="vm.filters.startDateOfDnaTestRecivedOpenInv && vm.filters.endDateOfDnaTestRecivedOpenInv" ng-click="vm.clear(\'dnaTestRecivedOpenInvestigation\',true);vm.checkboxHideAndShow(!dateOfDnaTestRecivedOpenInv,\'dateofDnaTestRecived\');" class="material-icons removeSelectionRec fleft" data-translate="dashboard.filters.close"></i></span><div class="dropdowninRecSelection"><div ng-if="vm.filters.isDnaRecivedClosedFilter != undefined && !vm.filters.isDnaRecivedClosedFilter" flex="40" class="" data-translate="dashboard.Date of Dna Test Received"></div><div class="dropdownSelectionCenter" ng-show="(vm.filters.isDnaTestRecivedByClosedDate || vm.filters.isDnaTestRecivedByClosedDate == undefined )"><md-select ng-disabled="vm.filters.startDateOfDnaTestRecivedOpenInv && vm.filters.endDateOfDnaTestRecivedOpenInv" md-on-open="vm.filters.isDnaRecivedClosedFilter = true" md-on-close="vm.clearDate(\'startDate\',\'endDate\');!(vm.filters.startDateOfDnaTestRecivedOpenInv && vm.filters.endDateOfDnaTestRecivedOpenInv)?vm.filters.isDnaTestRecivedByClosedDate = undefined:\'\';" ng-model="vm.filters.dnaTestRecived" placeholder="{{(vm.filters.startDateOfDnaTestRecivedOpenInv && vm.filters.endDateOfDnaTestRecivedOpenInv) ? (vm.filters.displayDnaTestRecived) : (\'dashboard.DateofDnaTestReceived\' | translate)}}" class="md-no-underline dropdownSelection" layout="column" ng-class="(vm.filters.startDateOfDnaTestRecivedOpenInv && vm.filters.endDateOfDnaTestRecivedOpenInv) ? \'dnaTestRecivedOpenInvestigation\' : \'w40mrg\'"><div layout-padding-lg><div layout="row" layout-xs="column" class="mb10"><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 1}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.ONE_MONTH,true,\'displayDnaTestRecived\');selectedDiv = 1;vm.filters.isDnaTestRecivedByClosedDate = true;"><span data-translate="dashboard.filters.lastOneMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 2}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.THREE_MONTH,true,\'displayDnaTestRecived\');selectedDiv = 2;vm.filters.isDnaTestRecivedByClosedDate = true;"><span data-translate="dashboard.filters.lastThreeMonth"></span></div><div flex class="fz10 m0imp dateFilter" ng-class="{blueColor:selectedDiv == 3}" ng-click="vm.investigationCreatedDateChange(vm.APP.INVESTIGATION.SIX_MONTH,true,\'displayDnaTestRecived\');selectedDiv = 3;vm.filters.isDnaTestRecivedByClosedDate = true;"><span data-translate="dashboard.filters.lastSixMonth"></span></div></div><div layout="row" flex layout-align="space-between center" class="hideIcon mr100"><div><md-datepicker ng-change="vm.dateChange(true,\'displayDnaTestRecived\');selectedDiv = 0;vm.filters.isDnaTestRecivedByClosedDate = true;" ng-model="vm.filters.startDateOfDnaTestRecivedOpenInv" md-placeholder="From date" md-min-date="minDate" md-max-date="maxDates" date-picker-local-date dp-blur-format></md-datepicker></div><span>-</span><div><md-datepicker ng-change="vm.dateChange(true,\'displayDnaTestRecived\');selectedDiv = 0;vm.filters.isDnaTestRecivedByClosedDate = true;" ng-model="vm.filters.endDateOfDnaTestRecivedOpenInv" md-placeholder="To date" md-min-date="minDates" md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker></div></div></div></md-select></div></div></div><!-- Third filter for DNA CR in open investigation --><div layout="row" class="clrgray"><i ng-if="vm.filters.dnaCenterOpenInv.id" ng-click="vm.clear(\'dnaCenterOpenInvestigation\',true);vm.checkboxHideAndShow(!dnaCenterOpenInv,\'dnaCenter\');" class="material-icons selectionRemove fleft" data-translate="dashboard.filters.close"></i><div class="dropdowninRecSelection"><div class="mrlf64"><md-select ng-disabled="vm.filters.dnaCenterOpenInv.id" ng-model="vm.filters.dnaCenterOpenInv" mrlf64 md-on-close="vm.clearName(\'openInvestigationDnaCenter\',\'dnaSearchKey\',\'dnaCenterValue\');" ng-change="(vm.isMobile) ? \'\':vm.getFilterList()" placeholder="{{vm.filters.dnaCenterOpenInv.id == undefined ? (\'dashboard.DnaCenter\' | translate) : vm.filters.dnaCenterOpenInv.nameCityCounty}}" class="md-no-underline dropdownSelection" ng-class="{ \'mrright43\': vm.filters.dnaCenterOpenInv.id}"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char common-search search-callback="vm.searchDnaCenter(dnaSearchKey , \'openInvestigation\')" name="dnaSearchKey" class="left-drop-search mb18 cursorText" ng-model="dnaSearchKey" ng-change="vm.dnaCenterValueOpenInv = undefined" ng-minlength="2" placeholder="{{\'dashboard.Dna Center\' | translate}}" type="search"></md-input-container></md-select-header><div class="searchnote" ng-hide="dnaSearchKey.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.dnaCenterValueLoaderOpenInv" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.dnaCenterValueOpenInv" class="stickySearch"><md-option ng-if="dnaSearchKey.length >1" ng-value="dropValueInv" ng-repeat="dropValueInv in vm.dnaCenterValueOpenInv"><span ng-if="!vm.filters.dnaCenterOpenInv.id"><ng-letter-avatar ng-if="!vm.filters.dnaCenterOpenInv.id" fontsize="18px" shape="round" avatarcustomborder="margin-right: 10px;" height="30px" width="30px" data="{{ dropValueInv.nameCityCounty| limitTo : limit : begin}}"></ng-letter-avatar></span><span>{{dropValueInv.nameCityCounty}}</span></md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.dnaCenterValueOpenInv.length == 0 && dnaSearchKey.length > 1" ng-init="$index=-1" data-translate="dashboard.filters.noresult"></div></md-select></div></div></div></div></div></div><div ng-show="vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR"><!-- <i ng-if="vm.filters.birthDate!=null" ng-click="vm.clear(\'time\',true);" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i>\n\t\t\t\t\t\t \t  <md-select ng-model="vm.filters.birthDate" placeholder="{{\'dashboard.placeholder.birthdate\' | translate}}" class="md-no-underline selectHeader dropdownSelection caps">\n\t\t\t\t\t\t\t      <md-option ng-value="TimeVO.startDate" >\n\t\t\t\t\t\t\t      \t\t<md-datepicker ng-model="startDate" name="startDate" md-min-date=TimeVO.startDate></md-datepicker>\n\t\t\t\t                  </md-option>\n\t\t\t\t                  <md-option ng-value="TimeVO.endDate" >\n\t\t\t\t\t\t\t      \t\t<md-datepicker ng-model="endDate" name="endDate" md-min-date=TimeVO.endDate></md-datepicker>\n\t\t\t\t                  </md-option>\n\t\t\t\t\t\t \t  </md-select>\n\t\t\t\t\t\t \t  <div flex-gt-xs>\n\t\t\t\t\t\t\t      \t  <md-datepicker ng-change="vm.dateChange(true);" ng-model="vm.filters.startDate" md-placeholder="From date" md-min-date="minDate" md-max-date="maxDates"></md-datepicker>\n     \t\t\t\t\t\t \t\t</div> --></div></div><div><md-button ng-click="vm.getFilterList();vm.sideNavClose();" class="leftButton applyFilter" hide-gt-sm data-translate="dashboard.filters.apply"></md-button></div></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/investigation/investigation.listing.html\'"></div></div></div></div>');
$templateCache.put('app/investigation/investigation.listing.html','<div id="investigationListing"><div flex="100" layout="column" class="pv15 ml30 investigationContainer"><div layout="row" class="w100Imp"><div flex="85" flex-xs="70"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon">search</i> <input flex-order="2" no-special-char common-search allowed-char="\'-/" search-callback="vm.searchProspects(vm.prospectSearch)" name="prospectSearch" id="prosInvSearchId" class="searchLeft" ng-model="vm.prospectSearch" placeholder="{{media(\'xs\') ? (\'dashboard.search.mobileSearch\' | translate): (\'dashboard.search.searchbar\' | translate)}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div flex="5" ng-if="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"></div><div flex="10" ng-if="vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR"></div><div flex layout-align="end center" layout ng-class="{iconLeft:vm.userRole == vm.APP.GLOBAL.ROLE_INVESTIGATOR}"><div class="sort"></div><md-select ng-model="vm.sortBy" ng-change="vm.getSortedList(vm.sortBy.id);" class="sortOrder md-no-underline selectHeader dropdownSelection caps sort mbt0"><md-option ng-repeat="sortOrder in vm.sortOrderList" ng-value="sortOrder"><span data-translate="dashboard.search.{{sortOrder.val}}"></span></md-option></md-select></div><div ng-if="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR" layout="row" flex-gt-sm="5" flex-sm="5" flex-xs="10" layout-align="end" layout-align-sm="space-around" layout-align-xs="space-between" class="mt20"><div class="disableText textDecorationNoneImportant" ng-click="vm.exportData()"><img src="content/images/Excel.png"></div></div></div><div id="investigationListId" layout="column" class="bgColorWh"><div class="scrollableList" ng-style="{\'max-height\': windowHeight - 110}" style="overflow-y: auto; overflow-x: hidden"><div class="noOutLine" page-size="10" ng-scroll-repeat="investigation in vm.investigationList track by $index" ng-click="vm.prospectProfile(investigation.investigationId,$index)"><div id="inv{{$index}}" layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center" ng-init="getReopenFlag(investigation.investigationId,$index)"><div flex="10" flex-xs="15"><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ investigation.firstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="30" class="mw150MBL"><div class="prospectName prosMBL"><span ng-bind="investigation.firstName"></span><span class="pl5" ng-bind="investigation.lastName"></span></div><div class="investigationsType" hide-xs><span data-translate="dashboard.filters.dob"></span> <span data-translate="dashboard.month.{{investigation.dobMonth}}"></span> <span data-translate="{{investigation.dobDay}}"></span> <span data-translate="{{investigation.dobYear}}"></span> <span>.eBis</span><span ng-bind="investigation.ebisId"></span></div><div flex class="status" show-xs hide-gt-xs><span data-translate="dashboard.{{investigation.investigationStatus}}"></span></div></div><!-- Show the reopen/reassign Flag --><!-- <div hide-gt-xs show-xs class="mt0 mb0 w30MBL">\n\t\t\t\t\t\t\t\t\t<md-progress-circular md-mode="indeterminate" ng-show="vm.reopenLoader_{{$index}}" class="md-hue-2" md-diameter="20px"></md-progress-circular>\n\t\t\t\t\t         \t\tReopened Investigator Form in In progress Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenInvestigator_{{$index}} && vm.reopenInvestigatorInprogress_{{$index}} == vm.APP.GLOBAL.IN_PROGRESS">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UI" class="mb5 reopenCircle"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Investigator Form in Completed Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenInvestigator_{{$index}} && vm.reopenInvestigatorInprogress_{{$index}}  != vm.APP.GLOBAL.IN_PROGRESS">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UI" class="mb5 reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Analyst Form in In progress Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenAnalyst_{{$index}} && vm.reopenAnalystInprogress_{{$index}} == vm.APP.GLOBAL.IN_PROGRESS && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UA" class="reopenCircle"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Analyst Form in Completed Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenAnalyst_{{$index}} && vm.reopenAnalystInprogress_{{$index}}  != vm.APP.GLOBAL.IN_PROGRESS && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UA" class="reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t</div> --><md-progress-circular hide-gt-xs show-xs md-mode="indeterminate" ng-show="vm.reopenLoader_{{$index}}" class="md-hue-2" md-diameter="20px"></md-progress-circular><div flex="10" hide-gt-xs show-xs class="mt0 mb0 w30MBL" ng-class="vm.reopenInvestigator_{{$index}} || (vm.reopenAnalyst_{{$index}} && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) ? \'redFlag \' : \'\'"></div><!-- <div flex=10 hide-gt-xs show-xs class="w30MBL" ng-show="!vm.reopenInvestigator_{{$index}} && !vm.reopenAnalyst_{{$index}}"></div> --><div flex="50" layout="row" flex-xs="25" layout-align="space-around center" layout-xs="column"><div layout="row" flex layout-align="space-around center" hide-xs flex-gt-xs="50"><div class="smallCircle" hide-xs></div><div flex class="status" hide-xs><span data-translate="dashboard.{{investigation.investigationStatus}}"></span></div><!-- <div>4days . 8 total</div> --></div><!-- Show the reopen/reassign Flag --><!-- <div flex-gt-xs="25" hide-xs show-gt-xs layout="row">\n\t\t\t\t\t\t\t\t\t<md-progress-circular md-mode="indeterminate" ng-show="vm.reopenLoader_{{$index}}" class="md-hue-2" md-diameter="20px"></md-progress-circular>\n\t\t\t\t\t\t\t\t\tReopened Investigator Form in In progress Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenInvestigator_{{$index}} && vm.reopenInvestigatorInprogress_{{$index}}  == vm.APP.GLOBAL.IN_PROGRESS" popover-trigger="mouseenter" popover-placement="bottom" uib-popover="{{(\'dashboard.reopenFlag.UnderInvestigation\' | translate)}}" type="button" popover-class="popoverClass">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UI" class="mr5 reopenCircle"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Investigator Form in Completed Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenInvestigator_{{$index}} && vm.reopenInvestigatorInprogress_{{$index}}  != vm.APP.GLOBAL.IN_PROGRESS" popover-trigger="mouseenter" popover-placement="bottom" uib-popover="{{(\'dashboard.reopenFlag.UnderInvestigation\' | translate)}}" type="button" popover-class="popoverClass"> \n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UI" class="mr5 reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Analyst Form in In progress Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenAnalyst_{{$index}} && vm.reopenAnalystInprogress_{{$index}} == vm.APP.GLOBAL.IN_PROGRESS && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR" popover-trigger="mouseenter" popover-placement="bottom" uib-popover="{{(\'dashboard.reopenFlag.UnderAnalysis\' | translate)}}" type="button" popover-class="popoverClass">\n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UA" class="reopenCircle"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t\tReopened Analyst Form in Completed Status\n\t\t\t\t\t         \t\t<div ng-show="vm.reopenAnalyst_{{$index}} && vm.reopenAnalystInprogress_{{$index}}  != vm.APP.GLOBAL.IN_PROGRESS && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR" popover-trigger="mouseenter" popover-placement="bottom" uib-popover="{{(\'dashboard.reopenFlag.UnderAnalysis\' | translate)}}" type="button" popover-class="popoverClass"> \n\t\t\t\t\t         \t\t\t<div data-translate="dashboard.reopenFlag.UA" class="reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t         \t\t</div>\n\t\t\t\t\t         \t</div> --><md-progress-circular hide-xs show-gt-xs md-mode="indeterminate" ng-show="vm.reopenLoader_{{$index}}" class="md-hue-2" md-diameter="20px"></md-progress-circular><!-- Add the new tube Icon for based on DNA records --><div flex="15" ng-if="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div ng-show="investigation.isDnaTested == \'Yes\'" class="dnaPending"></div><div ng-show="investigation.isDnaTested == \'Selected\'" class="dnaConducted"></div></div><div flex="20" ng-if="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div ng-show="(vm.requestFlag_{{$index}} || vm.requestedShow_{{$index}})" class="redalert listEntityIcon" ng-click="vm.showIcon($event,investigation.investigationId)"></div></div><div flex="10" hide-xs show-gt-xs ng-class="vm.reopenInvestigator_{{$index}} || (vm.reopenAnalyst_{{$index}} && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) ? \'redFlag \' : \'\'"></div><!-- <div flex=10 hide-xs show-gt-xs ng-show="!vm.reopenInvestigator_{{$index}} && !vm.reopenAnalyst_{{$index}}"></div> --><div layout="column" flex-xs="5" flex-gt-xs="30" flex-sm="35" layout-align="center center" layout-align-xs=""><div ng-if="investigation.investigationStatus == \'Confirmed\' || investigation.investigationStatus == \'Failed\' || investigation.investigationStatus == \'Undetermined\' || investigation.investigationStatus == \'Waived\' || investigation.investigationStatus == \'NA\' || investigation.investigationStatus == \'Completed\'"><div class="mblCount caps color-grey" data-translate="dashboard.filters.close"></div><!-- <div class="common caps" hide-xs ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}">Close</div>\n\t\t\t\t\t\t\t\t        \t<div show-xs hide-gt-xs class="mblCount caps" ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}">Close</div> --></div><div ng-if="!(investigation.investigationStatus == \'Confirmed\' || investigation.investigationStatus == \'Failed\' || investigation.investigationStatus == \'Undetermined\' || investigation.investigationStatus == \'Waived\' || investigation.investigationStatus == \'NA\' || investigation.investigationStatus == \'Completed\')"><div class="common caps nowrap pl15 pr15" hide-xs ng-class="{\'color-red\': investigation.daysCount >= vm.APP.INVESTIGATION.ONE_MONTH,\'color-yellow\': (investigation.daysCount < vm.APP.INVESTIGATION.ONE_MONTH && investigation.daysCount >= vm.APP.INVESTIGATION.HALF_MONTH),\'color-grey\': investigation.daysCount < vm.APP.INVESTIGATION.HALF_MONTH}"><span data-translate="dashboard.open"></span> <span ng-bind="investigation.daysCount"></span> <span data-translate="dashboard.days"></span></div><div show-xs hide-gt-xs class="mblCount caps" ng-class="{\'color-red\': investigation.daysCount >= vm.APP.INVESTIGATION.ONE_MONTH,\'color-yellow\': (investigation.daysCount < vm.APP.INVESTIGATION.ONE_MONTH && investigation.daysCount >= vm.APP.INVESTIGATION.HALF_MONTH),\'color-grey\': investigation.daysCount < vm.APP.INVESTIGATION.HALF_MONTH}"><span ng-bind="investigation.daysCount"></span> <span data-translate="dashboard.days"></span></div></div><!-- <div>4days . 8 total</div> --></div></div></div></div></div><div ng-if="vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><div class="h60p" ng-if="vm.investigationList.length == 0 && !vm.loadingData && vm.allRegions.length == 0" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.noResultForCountryAdmin"></span></div><div class="h60p" ng-if="vm.investigationList.length == 0 && !vm.loadingData && !(vm.allRegions.length == 0)" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.noresult"></span></div></div><div ng-if="!(vm.userRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN)"><div class="h60p" ng-if="vm.investigationList.length == 0 && !vm.loadingData" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.noresult"></span></div></div><div class="h60p" ng-if="!vm.loadingData && vm.noMoreMembers" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.nomoreresult"></span></div></div><div class="mtm5" ng-if="vm.loadingData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div><div ng-include="\'app/library/entity/entityIconPopup.html\'" style="display:none;"></div><div ng-include="\'app/library/request/requestEntity.html\'" style="display:none;"></div><div ng-include="\'app/library/request/requestLocation.html\'" style="display:none;"></div></div>');
$templateCache.put('app/legacyLari/legacyLari.header.html','<div layout="row" class="contentWidth pagePadding investigationHeaderTop"><div flex layout="row" layout-xs="column" layout-sm="column" class="colorWh investigationMargin investigationHeader"><div layout="row" flex layout-align="space-between center" class="invBottom"><div layout="row" layout-align="start center" class="invLeft"><div flex-gt-xs="" class="invHeader pl30" data-translate="dashboard.header.legacyLari"></div></div></div></div></div>');
$templateCache.put('app/legacyLari/legacyLari.listing.html','<div id="investigationListing"><div flex="100" layout="column" class="pv15 ml30 investigationContainer"><div layout="row" class="w100Imp"><div flex="100" flex-xs="65"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon searchAlignment">search</i> <input class="searchTextAlign searchLeft" flex-order="2" no-special-char common-search search-callback="vm.searchRequest(vm.requestSearch)" name="requestSearch" class="searchLeft" ng-model="vm.requestSearch" placeholder="Search by Ebis-ID" type="search"></md-input-container><div class="searchExists" ng-if="vm.loadingRequestData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div><div class="searchNotExists" ng-if="vm.search==true"><div align="center" data-translate="legacyLari.search.searchEbisID"></div></div><div class="searchExists" ng-if="vm.search == false"><div class="scrollableList noHScroll overYAuto" ng-style="{\'max-height\': windowHeight - 110}" style="overflow-y: auto; overflow-x: hidden"><div class="noOutLine listBorder bgColorWh" page-size="10" ng-scroll-repeat="request in vm.requestList track by $index" ng-if="vm.noResult == false"><div layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center"><div flex="95" flex-xs="75" layout="row" layout-xs="column" class="mw150MBL" margin-top="-15px"><div class="marginAlignment" flex="95" flex-xs="5" layout-align-gt-xs="center center"><div class="prospectName prosMBL" ng-class="{\'mt20\' : !vm.media(\'xs\') && (request.fileTypeId!=null || request.fileType!=null)}"><span class="camelCase" ng-bind="request.fileName"></span></div><div class="investigationsType" hide-xs>File Type: <span ng-bind="request.fileType"></span></div></div><div flex="1" flex-xs="7" layout="row" layout-align-gt-xs="space-around center" layout-xs="column"><div flex="4" flex-sm="6" flex-xs="25" class="mr5"><div class="download" ng-click="vm.downloadFile(vm.requestDownload,$index)" ng-model="vm.requestProspectFile"><span class="material-icons" ng-class="{\'mt20\' : !vm.media(\'xs\') && vm.fileTypeId = request.fileTypeId}">file_download</span></div></div></div></div></div></div></div><div class="h60p listBorder bgColorWh" ng-if="!vm.loadingRequestData && vm.noResult==true" layout="row" layout-align="center center"><span class="caps" data-translate="legacyLari.filters.noResult"></span></div></div></div></div></div>');
$templateCache.put('app/legacyLari/legacyLari.management.html','<div layout="column"><div ng-include class="paddingT" layout-align="center center" layout="row" src="\'app/legacyLari/legacyLari.header.html\'"></div><div class="lytWhiteBg"><div ui-view="libraryList" class="pagePadding noHScroll overflowHidden" resize ng-style="{\'height\':windowHeight+1 + \'px\'}"><div class="smoothScroll" flex ng-include src="\'app/legacyLari/legacyLari.listing.html\'"></div></div></div></div>');
$templateCache.put('app/library/library.header.html','<div layout="column" class="w100p contentWidth pagePadding investigationHeaderTop"><div class="w100p"><div layout="row" class="colorWh investigationMargin investigationHeader" layout-align="center center" ng-class="{pl33:vm.media(\'(min-width: 959px)\')}"><div flex layout-align="space-between center" class=""><div layout="row" layout-align="start center" class="invLeft"><div ng-click="vm.toggleLeft()" class="" hide-gt-sm><i class="material-icons">sort</i></div><div hide-sm hide-xs flex class=""><div flex class="pb10"><span class="caps white-text fz30" data-translate="library.subTitle"><span></span></span></div><md-divider class="bg-grey h3p"></md-divider></div><div show-xs hide-gt-sm flex class="plr3p bgc-blue textCenter" layout="row"><div flex class="pb10 pt7"><span class="caps white-text fz30" data-translate="library.subTitle"><span></span></span></div></div></div></div><div><div ng-click="vm.toggleRight()" hide-gt-sm><i class="material-icons">tune</i></div></div></div><div layout="row" class="pl32"><div ng-if="vm.loggedUserRole != vm.APP.GLOBAL.INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.READ_ONLY" id="request" class="prospects" layout-padding ng-click="vm.stateRequestDetails();vm.libraryTabIndex = 1;" ng-class="{activeDiv:vm.library.libraryType == vm.APP.LIBRARY.REQUEST}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="library.subHeaders.request"></span><div class="arrow_box" ng-if="vm.library.libraryType == vm.APP.LIBRARY.REQUEST"></div></div><div id="entity" class="prospects" layout-padding ng-click="vm.stateEntityDetails(); vm.libraryTabIndex = 2;" ng-class="{activeDiv:vm.library.libraryType == vm.APP.LIBRARY.ENTITY}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="library.subHeaders.entity"></span><div class="arrow_box" ng-if="vm.library.libraryType == vm.APP.LIBRARY.ENTITY;"></div></div><div id="location" class="prospects" layout-padding ng-click="vm.stateLocationDetails(); vm.libraryTabIndex = 3;" ng-class="{activeDiv:vm.library.libraryType == vm.APP.LIBRARY.LOCATION}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="library.subHeaders.location"></span><div class="arrow_box" ng-if="vm.library.libraryType == vm.APP.LIBRARY.LOCATION;"></div></div></div><div ng-if="vm.library.libraryType == vm.APP.LIBRARY.REQUEST && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_READ_ONLY" class="mTB mRequestT0"><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab fab" area-label="menu"><span class="s25">+</span></md-button></md-fab-trigger><md-fab-actions><md-button class="md-fab md-raised md-mini bgColorWh" aria-label="addEntity" ng-click="openNewEntity($event,\'addNewEntityPopupId\',0)"><img class="h30" src="content\\images\\Entity-AddIcon.png"></md-button><md-button class="md-fab md-mini bgColorWh" aria-label="addLocation" ng-click="vm.openLocationRequest($event,\'locationRequestPopupId\',0)"><img class="h30" src="content\\images\\Location-AddIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div><div ng-if="vm.library.libraryType == vm.APP.LIBRARY.ENTITY && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER" class="mTB mRequestT0"><md-button aria-label="menu" class="md-fab fab" aria-label="addEntity" ng-click="openNewEntity($event,\'addNewEntityPopupId\',1)"><img src="content\\images\\Entity-AddIcon.png"></md-button></div><div ng-if="vm.library.libraryType == vm.APP.LIBRARY.LOCATION && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER" class="mTB mRequestT0"><md-button aria-label="menu" class="md-fab fab" aria-label="addLocation" ng-click="vm.openLocationRequest($event,\'locationRequestPopupId\',1)"><img src="content\\images\\Location-AddIcon.png"></md-button></div></div></div><div ng-include src="\'app/library/entity/addEntity.html\'" style="display:none;"></div><div ng-include src="\'app/library/entity/addLocation.html\'" style="display:none;"></div><div class="hide"><div id="successAddLocation" class="md-dialog-container"><md-dialog class="createPopup"><md-dialog-content><div layout="column" layout-align="center center" class="p40"><div class="popupLbl grncolor" data-translate="library.popup.validation.success"></div><div class="pt10 popupLbl" ng-click="vm.hidePopup();" data-translate="library.filters.close"></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/library/library.management.html','<div layout="column"><div ng-include class="paddingT" layout-align="center center" layout="row" src="\'app/library/library.header.html\'"></div><div class="lytWhiteBg"><div ui-view="libraryList" class="pagePadding noHScroll overflowHidden" resize ng-style="{\'height\':windowHeight+1 + \'px\'}"></div></div></div>');
$templateCache.put('app/main/main.html','<div ui-view="dynamicView" flex></div>');
$templateCache.put('app/user/user.filters.html','<div layout="row"><div flex="100" layout="row" ng-cloak><div><md-button ng-click="vm.toggleLeft()" class="md-primary" hide-gt-sm>Toggle left</md-button></div></div></div>');
$templateCache.put('app/user/user.header.html','<div layout="column" class="w100p contentWidth pagePadding investigationHeaderTop"><div class="w100p"><div layout="row" class="colorWh investigationMargin investigationHeader" layout-align="center center" ng-class="{pl33:vm.media(\'(min-width: 959px)\')}"><div flex layout-align="space-between center" class=""><div layout="row" layout-align="start center" class="invLeft"><div ng-click="vm.toggleLeft()" class="" hide-gt-sm><i class="material-icons">sort</i></div><div hide-sm hide-xs flex class=""><div flex class="pb10"><span class="caps white-text fz30" data-translate="user.subtitle"><span></span></span></div><md-divider class="bg-grey h3p"></md-divider></div><div show-xs hide-gt-sm flex class="plr3p bgc-blue textCenter" layout="row"><div flex class="pb10 pt7"><span class="caps white-text fz30" data-translate="user.subtitle"><span></span></span></div></div></div></div><div><div ng-click="vm.toggleRight()" hide-gt-sm><i class="material-icons">tune</i></div></div></div><div layout="row" class="pl32"><div id="internalUser" class="prospects" layout-padding ng-click="vm.stateInternalDetails();" ng-class="{activeDiv:vm.userTabIndex == 1}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="user.subheaders.internal"></span><div class="arrow_box" ng-if="vm.userTabIndex == 1"></div></div><div id="externalUser" class="prospects" layout-padding ng-click="vm.stateExternalDetails();" ng-class="{activeDiv: vm.userTabIndex == 2}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="user.subheaders.external"></span><div class="arrow_box" ng-if="vm.userTabIndex == 2"></div></div><div id="countryAdmin" ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER" class="prospects" layout-padding ng-click="vm.setCurrentStateToAdmin(); vm.userTabIndex = 3;vm.setUserType();" ng-class="{activeDiv: vm.userTabIndex == 3}" style="padding: 0px 24px 0px 0px;"><span class="pl0" data-translate="user.subheaders.admin"></span><div class="arrow_box" ng-if="vm.userTabIndex == 3"></div></div></div><div ng-if="vm.userTabIndex == 2 && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER" class="mTB mobileEditmt"><md-button class="md-fab fab" aria-label="plus" ng-click="vm.openAddEditPopup($event,\'addEditInvestigatorPopupId\',1)"><img src="content\\images\\UserAddIcon.png"></md-button></div></div></div><div ng-include="\'app/user/external/addEditInvestigator.popup.html\'" style="display:none;"></div>');
$templateCache.put('app/user/user.management.html','<div layout="column"><div ng-include class="paddingT" layout-align="center center" layout="row" src="\'app/user/user.header.html\'"></div><div class="lytWhiteBg"><div ui-view="userList" class="pagePadding noHScroll overflowHidden" resize ng-style="{\'height\':windowHeight+1 + \'px\'}"></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label> <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label> <input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label> <input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label> <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"> <label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label> <input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label> <input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label> <input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label> <input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label> <select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label> <select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer;">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer;">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="centerAlign" ng-init="vm.defaultLanguage();"><div layout="column" flex layout-align="center center"><img class="cred-logo" src="content/images/mlb_logo.svg"> <span class="logoContent" data-translate="login.title"></span></div><div id="loginpage" flex="100"><form class="loginbox" action="{{vm.oktaSamlUrl}}"><button id="loginButton" type="submit"><span data-translate="login.form.login_to_okta"></span></button></form></div></div>');
$templateCache.put('app/components/login/unauthorized.html','<div class="centerAlign"><div id="unauthorizedpage" flex="100"><div><div flex layout-align="center center" class="textCenter"><img class="cred-logo mt22" src="content/images/lock.png"></div><div class="accessDeniedContent signInContent" data-translate="login.form.accessDenied"></div><div class="accessDeniedMessage signInContent" data-translate="login.form.accessDeniedMessage"></div><div ng-if="fromState.name" class="signInDiv" ui-sref="{{fromState.name}}({{fromStateParams}})"><md-button type="submit" id="loginButton" layout-align="center center"><span layout="row" layout-align="center"><md-progress-circular md-mode="indeterminate" ng-show="vm.activated" class="md-hue-2" md-diameter="20px"></md-progress-circular><span class="mlt5" ng-class="{mr20 : vm.activated}" data-translate="login.form.unauthorizedbutton"></span></span></md-button></div><div ng-if="!fromState.name" class="signInDiv" ui-sref="login({})" href="#/"><md-button type="submit" id="loginButton" layout-align="center center"><span layout="row" layout-align="center"><md-progress-circular md-mode="indeterminate" ng-show="vm.activated" class="md-hue-2" md-diameter="20px"></md-progress-circular><span class="mlt5" ng-class="{mr20 : vm.activated}" data-translate="login.form.unauthorizedbutton"></span></span></md-button></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<div flex layout="row" hide-sm hide-xs show-gt-sm class="tc-white headerTop" layout-align="center center" ng-init="vm.defaultLang(vm.user.langKey)"><div ng-init="setSessionTimeout()"></div><div layout="row" class="contentWidth paddingV15 pagePadding" layout-align="center center"><div class="widandhei" layout="row" flex="25" flex-md="25" flex-lg="20" layout-align="start"><div class="lariHeader" data-translate="dashboard.title"></div><div class="lariLabel"><span class="labelContent" data-translate="dashboard.subtitle"></span></div></div><div flex="50" layout-align="start center" class="navTabHeader" layout="row"><div class="mr60" ng-class="{\'th-select\': vm.$state.includes(\'investigations\')}"><span class="tabHeader" ng-class="{\'th-select\': vm.$state.includes(\'investigations\')}" ui-sref="investigations" data-translate="dashboard.header.investigations"></span></div><div class="mr60" ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_MANAGER || vm.loggedUser == vm.APP.GLOBAL.ROLE_ADMIN || vm.loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY"><span ng-class="{\'th-select\': vm.$state.includes(\'users\')}" class="tabHeader" data-translate="dashboard.header.users" ui-sref="internal"></span></div><!-- <div class="mr60" ng-class="(vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_INVESTIGATOR\']) !== -1) ? \'th-select mrt200\' : \'th-select\'"> --><div class="mr60" ng-if="vm.loggedUser != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUser != vm.APP.GLOBAL.ROLE_READ_ONLY"><span ng-class="{\'th-select\': vm.$state.includes(\'library\')}" class="tabHeader" data-translate="dashboard.header.libraries" ui-sref="request"></span></div><div class="mr60" ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_INVESTIGATOR || vm.loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY"><span ng-class="{\'th-select\': vm.$state.includes(\'library\')}" class="tabHeader" data-translate="dashboard.header.libraries" ui-sref="entities"></span></div><div class="mr60" ng-if="(vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_VERNALIS_ADMIN\']) !== -1) || (vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_MANAGER\']) !== -1)"><span class="tabHeader" ng-class="{\'th-select\': vm.$state.includes(\'reports\')}" data-translate="dashboard.header.reports"></span></div><div ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_MANAGER || vm.loggedUser == vm.APP.GLOBAL.ROLE_ADMIN || vm.loggedUser == vm.APP.GLOBAL.ROLE_ANALYST"><span class="tabHeader" ng-class="{\'th-select\': vm.$state.includes(\'legacyLari\')}" ui-sref="legacyLari" data-translate="dashboard.header.legacyLari"></span></div></div><div flex="30" layout="row" layout-align="end center"><div uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()" class="accountNav"><div layout="row" ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer mr2"><div class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu" layout="row"><!-- <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER" class="userName capitalize">MANAGER</div>\n                        <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ADMIN" class="userName capitalize">ADMIN</div>\n                        <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="userName capitalize">INVESTIGATOR</div>\n                        <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ANALYST" class="userName capitalize">ANALYST</div> --><div class="userName capitalize">{{vm.loginName}}</div><i class="material-icons navAccountArrow">arrow_drop_down</i></div><ul class="dropdown-menu pull-right mw165 pb0imp" uib-dropdown-menu="" aria-labelledby="single-button"><li class="ptot aligncenter"><ng-letter-avatar shape="round" height="60" width="60" avatarcustombgcolor="#F5C727" charcount="2" fontfamily="Montserrat" fontsize="25" data="{{vm.loginName}}"></ng-letter-avatar></li><li style="font-size:18px;" class="aligncenter capitalize pt20"><span class="camelCase" ng-bind="vm.loginName.toLowerCase()"></span></li><li class="divider w100p"></li><div class="bg-white" layout="column" flex layout-align="space-around" layout-margin ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_INVESTIGATOR || vm.loggedUser == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><div class="investigationsType fz14 textCenter" data-translate="dashboard.header.language"></div><div class="greenClr brder50px" ng-class="{lytGreyBackgrnd : vm.lang == vm.APP.GLOBAL.ES}"><div class="white-text textCenter" data-translate="dashboard.header.english" ng-click="vm.changeLanguage(vm.APP.GLOBAL.ENGLISH);"></div></div><div class="lytGreyClr brder50px" ng-class="{greenClr : vm.lang == vm.APP.GLOBAL.ES}"><div class="white-text textCenter" data-translate="dashboard.header.spanish" ng-click="vm.changeLanguage(vm.APP.GLOBAL.SPANISH);"></div></div></div><li ui-sref-active="active" ng-switch-when="true" ng-click="vm.logout()" class="aligncenter caps noOutLine color-yellow pt3" tabindex="0"><a class="signOutAlign"><i class="material-icons signOutIcon">&#xE8AC;</i><span class="fontW600 pl5 ng-scope" data-translate="global.menu.account.logout"></span></a></li></ul></div></div></div></div></div><!-- For mobile and Tab view --><md-sidenav show-gt-sm hide-gt-sm class="md-sidenav-left mobileNavBar" md-component-id="left" md-whiteframe="4"><md-content layout-margin-gt-lg layout-padding-gt-lg layout-align="space-between start" class="mobileNav h100p"><!-- <div>\n            <ng-letter-avatar shape="round" height="50px" width="50px" data="{{vm.loginName}}"></ng-letter-avatar>\n            <div layout="row" layout-align="space-between end" uib-dropdown class="dropdown pointer">\n                <div class="username-Left capitalize">{{vm.loginName}}</div>\n                <i uib-dropdown-toggle href="" id="account-menu" class="material-icons dropdown-toggle " >arrow_drop_down</i>\n                <ul class="dropdown-menu " uib-dropdown-menu="" aria-labelledby="single-button">\n                  <li ui-sref-active="active">\n                        <a href="" ng-click="vm.logout()" id="logout">\n                            <span class="glyphicon glyphicon-log-out"></span>&nbsp;\n                            <span data-translate="global.menu.account.logout"></span>\n                        </a>\n                    </li>\n                 </ul>\n                 </div>\n            <div class="userPosition-Left capitalize">{{vm.loginName}}</div>\n            <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ADMIN" class="userPosition-Left capitalize">Admin</div>\n            <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="userPosition-Left capitalize">Investigator</div>\n            <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ANALYST" class="userPosition-Left capitalize">Analyst</div>\n            <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER" class="userPosition-Left capitalize">Manager</div>\n        </div> --><div uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()" class="accountNav h300"><div ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer mr2"><div class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu" layout="row"><!-- <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER" class="userName capitalize">MANAGER</div>\n                    <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ADMIN" class="userName capitalize">ADMIN</div>\n                    <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="userName capitalize">INVESTIGATOR</div>\n                    <div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ANALYST" class="userName capitalize">ANALYST</div> --><div class="userName capitalize">{{vm.loginName}}</div><i class="material-icons navAccountArrow">arrow_drop_down</i></div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ADMIN" class="userPosition-Left capitalize">Admin</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="userPosition-Left capitalize">Investigator</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_ANALYST" class="userPosition-Left capitalize">Analyst</div><div ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER" class="userPosition-Left capitalize">Manager</div><ul class="dropdown-menu mw165 pb0imp" uib-dropdown-menu="" aria-labelledby="single-button"><li class="ptot aligncenter"><ng-letter-avatar shape="round" height="60" width="60" avatarcustombgcolor="#F5C727" charcount="2" fontfamily="Montserrat" fontsize="25" data="{{vm.loginName}}"></ng-letter-avatar></li><li style="font-size:18px;" class="aligncenter capitalize"><span class="camelCase" ng-bind="vm.loginName.toLowerCase()"></span></li><li class="divider w100p"></li><div class="bg-white" flex layout-align="space-around" layout-margin ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div class="investigationsType fz14 textCenter" data-translate="dashboard.header.language"></div><div class="greenClr brder50px h30" ng-class="{lytGreyBackgrnd : vm.lang == vm.APP.GLOBAL.ES}"><div class="white-text ml30 pb12" data-translate="dashboard.header.english" ng-click="vm.changeLanguage(vm.APP.GLOBAL.ENGLISH);"></div></div><div class="lytGreyClr brder50px h30" ng-class="{greenClr : vm.lang == vm.APP.GLOBAL.ES}"><div class="white-text ml30 pb12" data-translate="dashboard.header.spanish" ng-click="vm.changeLanguage(vm.APP.GLOBAL.SPANISH);"></div></div></div><li ui-sref-active="active" ng-switch-when="true" ng-click="vm.logout()" class="aligncenter caps noOutLine color-yellow pt3" tabindex="0"><a class="signOutAlign"><i class="material-icons signOutIcon">&#xE8AC;</i><span class="fontW600 pl5 ng-scope" data-translate="global.menu.account.logout"></span></a></li></ul></div></div><div layout-align="space-between start" class="pAtop50"><div flex layout-align="space-between start"><div><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'investigations\')}" ui-sref="investigations" data-translate="dashboard.header.investigations"></span></div><div ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_MANAGER || vm.loggedUser == vm.APP.GLOBAL.ROLE_ADMIN || vm.loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'users\')}" data-translate="dashboard.header.users" ui-sref="internal"></span></div><div ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_INVESTIGATOR || vm.loggedUser == vm.APP.GLOBAL.READ_ONLY_USER"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'library\'), \'lineHeight25\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="dashboard.header.libraries" ui-sref="entities"></span></div><div ng-if="vm.loggedUser != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUser != vm.APP.GLOBAL.ROLE_READ_ONLY"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'library\')}" data-translate="dashboard.header.libraries" ui-sref="request"></span></div><div ng-if="vm.loggedUser == vm.APP.GLOBAL.ROLE_READ_ONLY"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'library\')}" data-translate="dashboard.header.libraries" ui-sref="entities"></span></div><div ng-if="(vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_VERNALIS_ADMIN\']) !== -1) || (vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_MANAGER\']) !== -1)"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'reports\')}" data-translate="dashboard.header.reports"></span></div><div ng-if="(vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_VERNALIS_ADMIN\']) !== -1) || (vm.user.authorities.indexOf(vm.APP.GLOBAL[\'ROLE_MANAGER\']) !== -1)"><span class="tabHeader-Left" ng-class="{\'th-select\': vm.$state.includes(\'legacyLari\')}" data-translate="dashboard.header.legacyLari"></span></div></div></div><div class="widandhei tgRightHeaderPosition" layout-align="end"><div layout="row"><div class="lariHeader" data-translate="dashboard.title"></div><div class="lariLabel"><div class="labelContent" data-translate="dashboard.subtitle"></div></div></div></div></md-content></md-sidenav><!-- SESSION WARNING POPUP STARTS HERE --><div class="sessiondetails"><div class="md-dialog-container" id="sessionWarningPopup"><md-dialog class="sessionTimeoutPopup assignConfirmPopupWidth"><md-dialog-content><div layout="row" class="m50imp"><div layout-margin layout-align="center center"><div layout-align="center center"><div class="assignSub fz16"><span data-translate="dashboard.session.message"></span> <span class="countDown redTxt" style="padding-left: 5px;"></span> <span class="minute">mins</span> <span class="second">secs</span></div><div class="textCenter"><md-button ng-click="keepAlive();" id="loginButton" class="fz14 w50pi md-raised md-primary" ng-class="{w60pi:vm.lang == vm.APP.GLOBAL.ES}" data-translate="dashboard.session.keepMeLogin"></md-button></div></div></div></div></md-dialog-content></md-dialog></div></div><!-- SESSION WARNING POPUP ENDS HERE -->');
$templateCache.put('app/investigation/prospects/prospects.html','<div><div hide-xs flex class="prospectHeaderSize plr8p prospectPad"><div flex ng-click="vm.back()" class="mw150 prospectProfileBack"><span class="letsp1p fz10 monstFamily halfOpacity caps white-text" data-translate="prospects.title"></span> <span class="ptop8 letsp1p fz10 monstFamily halfOpacity caps white-text"><i class="material-icons">&#xE315;</i></span></div><div flex class="pb10"><span class="caps white-text fz30" ng-bind="vm.prospectName"><span></span></span></div><md-divider class="bg-grey h3p"></md-divider></div><div hide-gt-sm hide-gt-xs show-xs flex class="plr3p bgc-blue prospectHeaderXs" layout="row"><div ng-click="vm.back()" class="letsp1p fz10 monstFamily halfOpacity caps white-text mt30 mr20"><i class="material-icons">&#xE317;</i></div><div flex class="pb10 pt20"><span class="caps white-text fz30" ng-bind="vm.prospectName"><span></span></span></div></div><div layout="row" class="prosHeadPart" resize style="overflow-y:auto; overflow-x:hidden" ng-style="{\'height\':windowHeight + \'px\'}"><div flex class="bktrans overflowHidden"><div class="profileContent" layout="row"><div id="profile" class="prospects" layout-padding ng-click="stateProfileDetails();vm.tabIndex = 1;" ng-class="{activeDiv:vm.tabIndex == 1}"><span data-translate="prospects.profile"></span><div class="arrow_box" ng-if="vm.tabIndex == 1"></div></div><div ng-show="vm.loggedUserRole!= vm.APP.GLOBAL.INVESTIGATOR" id="activity" class="prospects" layout-padding ng-click="stateActivity(); vm.tabIndex = 2;" ng-class="{activeDiv: vm.tabIndex == 2}"><span data-translate="prospects.activity"></span><div class="arrow_box" ng-if="vm.tabIndex == 2"></div></div></div><div ng-if="vm.tabIndex == 1" class="mTB mR3" hide-xs hide-gt-sm ng-class="{mR7:vm.media(\'gt-md\')}"><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab fab"><img src="content\\images\\UserProfile.png"></md-button></md-fab-trigger><md-fab-actions><md-button ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile"><img class="h30" src="content\\images\\UserProfileViewIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div><div ui-view="sample" class="lytWhiteBg smoothScroll" resize ng-style="{\'height\':windowHeight + \'px\'}"></div></div></div></div>');
$templateCache.put('app/library/entity/addEntity.html','<div id="addNewEntityPopupId" class="md-dialog-container req-entity"><md-dialog class="addEditPopup w780" ng-class="{popupMBL:vm.media(\'xs\')}"><!-- Flag 0: New Entity Request, Flag 1: New Entity, Flag 2: Update Entity  --><form name="addNewEntityForm" id="addEntityFormId" novalidate ng-submit="(vm.flag == 1 || vm.flag == 2) ? vm.addNewEntity(vm.entity,addNewEntityForm,libraryAddEntityInputSearchObject,vm.entityLocationObject,vm.flag) : vm.saveNewEntity(vm.entity,addNewEntityForm,libraryAddEntityInputSearchObject,vm.entityLocationObject)" class="addEntityForm"><md-toolbar><div ng-if="vm.flag == 1"><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.newEntity"></div></div><div ng-if="vm.flag == 0"><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.entityTitle"></div></div><!-- Desktop View --><div ng-if="vm.editFlag"><div layout layout-align="center center" class="actProfile popupTle"><span data-translate="library.popup.entityProfile"></span> - <span class="caps" data-translate="library.subheaders.{{vm.entity.entityTypeSearchKey.name}}"></span></div></div><div ng-if="vm.updateFlag"><div layout layout-align="center center" class="actProfile popupTle"><span data-translate="library.popup.updateEntity"></span> - <span class="caps" data-translate="library.subheaders.{{vm.entity.entityTypeSearchKey.name}}"></span></div></div></md-toolbar><md-dialog-content ng-show="!vm.editFlag"><div ng-if="vm.entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div class="pdlr40"><div class="pb10 pt30imp popupHr mb15" data-translate="library.popup.entityDetails"></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><div flex class="alignpb mb17" ng-class="{\'w100Imp mt20\':vm.media(\'xs\') || vm.media(\'sm\')}" flex="50"><div ng-style="{notAllowed:vm.updateFlag}"><label class="popupLbl required pl0imp" data-translate="library.popup.labels.entityType"></label><md-select ng-disabled="vm.updateFlag" ng-change="vm.clearEntity();" ng-required="addNewEntityForm.$submitted" ng-model-options="{trackBy: \'$value.id\'}" name="entityTypeSearchKey" ng-model="vm.entity.entityTypeSearchKey" placeholder="{{vm.entity.entityTypeSearchKey.id == undefined ? (\'library.popup.labels.selectType\' | translate) : vm.entity.entityTypeSearchKey.name }}" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required,notAllowed:vm.updateFlag}" class="popupFont md-no-underline selectHeader dropdownSelection ofH border camelCase"><md-option ng-value="dropValueLan" ng-repeat="dropValueLan in vm.entityTypeList" class="camelCase"><span data-translate="library.popup.entityOption.{{dropValueLan.key}}"></span></md-option></md-select><div ng-messages="addNewEntityForm.entityTypeSearchKey.$error"><div ng-if="addNewEntityForm.entityTypeSearchKey.$error.required && addNewEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex-gt-sm="10"></div><div flex class="alignpb mb17" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}" flex="50"><label class="popupLbl required pl0imp marginLeftZero" data-translate="library.popup.labels.entityName"></label><!-- required --><!-- <div layout="column"  layout-align="start start" class="popupLbl required pl0imp" data-translate="library.popup.labels.entityName"></div> --><div layout="row"><i ng-if="vm.entity.entityName.id && !vm.updateFlag" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select flex ng-required="!vm.entity.entityName" ng-hide="(vm.isHide || vm.updateFlag) && !vm.entity.entityName.id" ng-class="{borderError:!vm.entity.entityName.id && addNewEntityForm.$submitted}" ng-disabled="vm.entity.entityTypeSearchKey.id == null" md-on-close="vm.clearOnClose(\'inputSearchText\',\'entityNameList\');" name="entityName" ng-model="vm.entity.entityName" ng-change="vm.getEntityProfileById(vm.entity.entityName.id);" placeholder="{{vm.entity.entityName.id == undefined ? (\'library.popup.labels.searchName\' | translate) : vm.entity.entityName.name }}" class="popupFont md-no-underline selectHeader dropdownSelection ofH border camelCase"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg w285 m0imp"><input ng-keydown="$event.stopPropagation();" ng-blur="" focus no-special-char common-search search-callback="vm.searchEntity(vm.inputSearchText,vm.entity.entityTypeSearchKey.id)" ng-model="vm.inputSearchText" type="search" placeholder="{{\'library.search.searchEntity\' | translate}}" class="left-drop-library-search mb18 cursorText h20Imp" ng-minlength="2"></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.inputSearchText.length >1" data-translate="library.filters.minsearch"></div><div ng-if="vm.entityNameLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><md-optgroup label="entityNameList" class="stickySearch"><md-option ng-value="dropValue" ng-repeat="dropValue in vm.entityNameList" class="camelCase">{{dropValue.name.toLowerCase()}}<div class="investigationsType camelCase" hide-xs><span ng-bind="dropValue.cityName.toLowerCase()"></span></div><md-tooltip class="camelCase" md-direction="bottom"><span>{{dropValue.name.toLowerCase()}}</span></md-tooltip></md-option></md-optgroup><div class="searchnote" ng-if="vm.entityNameList.length == 0 && vm.inputSearchText.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div><div layout="row"><i ng-hide="vm.updateFlag" ng-if="vm.isHide && !vm.entity.entityName.id" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container flex ng-required="!vm.entity.entityName" name="entityNameSearchKey" ng-show="(vm.isHide || vm.updateFlag) && !vm.entity.entityName.id" md-no-float class="locationPopInputSty widthclass camelCase" flex><input id="entityNameSearchTextId" class="right-drop-search camelCase popupFont" ng-model="vm.entity.entityName" type="search"></md-input-container></div><div ng-messages="addNewEntityForm.entityName.$error"><div ng-if="addNewEntityForm.entityName.$error.required && addNewEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><form-location-filter disable-flag="vm.entity.entityName.id != null && !vm.updateFlag" class="width100" inputsearch-object="libraryAddEntityInputSearchObject" model-object="vm.entityLocationObject" horizon-flag="vm.isHorizon" add-new-location="true" call="" form-name="addNewEntityForm" is-validation="true"></form-location-filter></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="alignpb" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.personName"></label><!-- <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" type="text" name="contactPerson" ng-model="vm.entity.contactPersonName" class="popupFont camelCase" no-special-char ng-pattern="/^(\\D)+$/"> --> <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" type="text" name="contactPerson" ng-model="vm.entity.contactPersonName" class="popupFont camelCase" no-special-char><!-- <div ng-messages="addNewEntityForm.contactPerson.$error">                            \t\n\t                            \t<div  ng-if="!addNewEntityForm.contactPerson.$error.required && addNewEntityForm.contactPerson.$error.pattern"><span data-translate="library.popup.validation.name"></span></div>                 \t\n\t                            </div> --></md-input-container><div flex-gt-sm="10"></div><md-input-container class="alignpb" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.number"></label><!-- <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" no-special-char type="text" phone-input name="contactNumber" ng-model="vm.entity.contactPhoneNumber" class="popupFont"> --> <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" type="text" name="contactNumber" ng-model="vm.entity.contactPhoneNumber" class="popupFont"></md-input-container></div><div flex class="mtm13" layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="alignpb" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.email"></label><!-- <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" type="email" name="contactEmail" ng-model="vm.entity.contactEmail" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"> --> <input ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" validate-email type="email" name="contactEmail" ng-model="vm.entity.contactEmail" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"><div ng-messages="addNewEntityForm.contactEmail.$error"><div ng-if="!addNewEntityForm.contactEmail.$error.required && addNewEntityForm.contactEmail.$error.email"><span data-translate="library.popup.validation.email"></span></div></div></md-input-container><div flex-gt-sm="10"></div><div layout="row" class="alignpb" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label class="popupLbl mt20 mr20 pl0imp" data-translate="library.popup.labels.flag"></label><md-switch ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" class="md-primary" ng-model="vm.entity.flag" aria-label="Switch 1"></md-switch></div></div><div layout-align="space-between start" flex class="w95" ng-class="{w90:vm.media(\'xs\') || vm.media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.comment"></label><md-input-container class="md-block" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><textarea ng-disabled="vm.entity.entityName.id != null && !vm.updateFlag" ng-required="addNewEntityForm.$submitted && vm.entity.flag" name="comment" ng-model="vm.entity.comments" row="3" class="popupCmt resizeNone greyBorder hyt60p"></textarea><div ng-messages="addNewEntityForm.comments.$error"><div class="redTxt" ng-if="addNewEntityForm.$submitted && addNewEntityForm.comment.$error.required"><span data-translate="library.popup.validation.comment"></span></div></div><div ng-messages="commentSize.valid"><div class="redTxt" ng-if="addNewEntityForm.$submitted && commentSize.valid"><span data-translate="library.popup.validation.commentSize"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-content ng-show="vm.editFlag"><div ng-if="vm.entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="column" class="pd50 pt40"><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.entityType"></label><div name="profileEntityType" data-translate="library.subheaders.{{vm.entity.entityTypeSearchKey.name}}" class="popupFont"></div></div><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.entityName"></label><div name="profileEntityName" ng-bind="vm.entity.entityName" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.country"></label><div name="profileCountry" ng-bind="vm.entityLocationObject.countryObj.countryTxt.toLowerCase()" class="popupFont camelCase"></div></div><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.province"></label><div name="profileProvince" ng-bind="vm.entityLocationObject.provinceObj.provinceTxt.toLowerCase()" class="popupFont camelCase"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.city"></label><div name="profileCity" ng-bind="vm.entityLocationObject.cityObj.cityTxt.toLowerCase()" class="popupFont camelCase"></div></div><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.sector"></label><div name="profileSector" ng-bind="vm.entityLocationObject.sectorObj.sectorTxt != null && vm.entityLocationObject.sectorObj.sectorTxt != \'\' ? vm.entityLocationObject.sectorObj.sectorTxt.toLowerCase() : \'-\'" class="popupFont camelCase"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.personName"></label><div name="profileContactPerson" ng-bind="vm.entity.contactPersonName != null && vm.entity.contactPersonName != \'\' ? vm.entity.contactPersonName.toLowerCase() : \'-\'" class="popupFont camelCase"></div></div><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.number"></label><div name="profileContactNumber" ng-bind="vm.entity.contactPhoneNumber != null && vm.entity.contactPhoneNumber != \'\' ? vm.entity.contactPhoneNumber : \'-\'" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb15"><label class="popupLbl normalFont" data-translate="library.popup.labels.email"></label><div name="profileContactEmail" ng-bind="vm.entity.contactEmail != null && vm.entity.contactEmail != \'\' ? vm.entity.contactEmail : \'-\'" class="popupFont"></div></div><div flex="50" class="mb15" ng-if="vm.loggedUserRole != vm.APP.GLOBAL.INVESTIGATOR"><label class="popupLbl normalFont" data-translate="library.popup.labels.flag"></label><div name="profileFlag" ng-bind="vm.entity.flag" class="popupFont camelCase"></div></div></div><div ng-if="vm.loggedUserRole != vm.APP.GLOBAL.INVESTIGATOR" layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start" class="mb15"><div><label class="popupLbl normalFont" data-translate="library.popup.labels.comment"></label><div name="profileComment" ng-bind="vm.entity.comments != null && vm.entity.comments != \'\' ? vm.entity.comments : \'-\'" class="popupFont"></div></div></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50" ng-class="{pl0imp:vm.media(\'xs\'), pr30impMBL:vm.editFlag && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER}"><div layout="row"><div ng-if="vm.existFlag" data-translate="library.popup.validation.exsits" class="errorMsg mt15"></div><div ng-if="vm.flag == 0"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(addNewEntityForm);" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="vm.entity.entityName.id != null || disableSaveButton == true" type="submit" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.save"></md-button></div><div ng-if="vm.flag == 1"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(addNewEntityForm);" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="vm.entity.entityName.id != null || vm.isEntityDisable || disableSaveButton == true" type="submit" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.add"></md-button></div><div ng-if="vm.editFlag && vm.loggedUserRole != vm.APP.GLOBAL.MANAGER" layout="row"><md-button ng-click="vm.cancel(addNewEntityForm);" class="saveOrClose caps color-red" data-translate="library.filters.close"></md-button></div><div ng-if="vm.editFlag && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER" layout="row"><md-button ng-click="vm.openEntityDeletePopup($event,\'deleteEntityConfirmPopup\',vm.entity.id)" class="saveOrClose caps darkGreyBg" data-translate="library.popup.delete"></md-button><md-button ng-click="vm.changeEditFlag()" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.edit"></md-button><md-button ng-click="vm.cancel(addNewEntityForm);" class="saveOrClose caps color-red" data-translate="library.filters.close"></md-button></div><div ng-if="vm.updateFlag"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(addNewEntityForm);" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="vm.isEntityDisable" type="submit" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.update"></md-button></div></div></md-dialog-actions></form></md-dialog></div><div id="deleteEntityConfirmPopup" class="md-dialog-container"><md-dialog class="warningPopupWidth" ng-class="{popupMBL:vm.media(\'xs\')}"><md-dialog-content><div layout="row" flex class="m50imp"><div layout-margin layout-align="center center"><div><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout-align="center center"><div class="confirmWarn aligncenter"><span data-translate="library.popup.deleteEntityContent"></span></div></div><div layout="row" layout-align="center center"><md-button class="saveOrClose caps color-red" ng-click="openNewEntity($event,\'addNewEntityPopupId\',2);showEntityProfileById(vm.entityId);" data-translate="library.popup.goBack"></md-button><md-button class="saveOrClose caps darkGreyBg" ng-click="vm.deleteEntity(vm.entityId)" data-translate="library.popup.delete" ng-disabled="vm.isDeleteEntityDisable"></md-button></div></div></div></md-dialog-content></md-dialog></div>');
$templateCache.put('app/library/entity/addLocation.html','<div id="locationRequestPopupId" class="md-dialog-container"><form name="addlocationRequestForm" id="addlocationRequestFormId" class="addlocationRequestForm" ng-submit="vm.flag == 1 ? \'\' : vm.saveLocation(vm.addLocationObject,addlocationRequestForm)" ng-class="{\'w100p\': vm.media(\'xs\')}"><md-dialog class="popup noHScroll addEditPopup" ng-class="{\'popupMBL\':vm.media(\'xs\'), \'w500\':vm.flag == 0 && !vm.media(\'xs\')}"><!-- ,\'w400\':vm.flag != 1 --><md-toolbar><div ng-if="vm.flag == 1"><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.newLocation"></div></div><div ng-if="vm.flag != 1"><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.locationTitle"></div></div></md-toolbar><md-dialog-content class="h65MBL noHScroll"><div class="pd50 pt40 pt15MBL"><div ng-if="vm.flag != 1"><div><div class="popupHr" data-translate="library.popup.locationSubTitle"></div><div layout-align="start start"><md-select ng-change="vm.clearFields(addlocationRequestForm);" ng-model="vm.locationRequestType" placeholder="{{\'library.search.searchLocation\' | translate}}" ng-class="{borderError:vm.locRegTypeValid}" class="md-no-underline camelCase libLocation" md-on-close="vm.showLocation();"><md-option class="camelCase" ng-value="location" ng-repeat="location in vm.locationVO"><span data-translate="library.popup.dropdownOption.{{location.key}}"></span></md-option></md-select></div><div class="pbot25"><div ng-if="vm.locRegTypeValid" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div ng-if="vm.flag == 1"><div class="pb10 pt10 popupHr w400p" data-translate="library.popup.locationSubTitle"></div></div><div ng-if="vm.flag != 1" ng-hide="vm.locationRequestType.id == null"><div ng-hide="vm.isShowCountry"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase required" data-translate="library.filters.country"></label></div><div layout="row"><!-- \t\t\t\t\t\t\t\t <i ng-if="vm.addLocationObject.countryObj.countryId" ng-click="vm.clear(\'COUNTRY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select style="width: 100% !important" name="country" ng-required="!vm.isShowCountry && !vm.location.country" ng-class="{borderError:!vm.addLocationObject.countryObj && addlocationRequestForm.$submitted}" ng-hide="vm.isReplaceCountry" ng-model="vm.addLocationObject.countryObj" ng-change="call();" md-on-open="vm.saveValid({type:\'COUNTRY\'});" md-on-close="vm.replaceInputField();vm.clearName(\'countryObj\',\'country\',\'searchCountryList\');vm.saveValid({type:\'COUNTRY\'});" placeholder="{{vm.addLocationObject.countryObj.countryTxt == undefined ? (\'library.search.country\' | translate) : vm.addLocationObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="vm.searchRequestLocation(vm.country, \'COUNTRY\')" ng-keydown="$event.stopPropagation();" ng-change="vm.countryChange();" ng-model="vm.country" type="search" placeholder="{{\'library.search.country\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.country.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.searchCountryList" class="stickySearch camelCase"><md-option ng-if="vm.country.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in vm.searchCountryList = (vm.searchCountryList | filter:country)">{{dropValueCountry.fullName.toLowerCase()}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.searchCountryList.length == 0 && vm.country.length > 1" data-translate="library.filters.noresult"></div></md-select></div></div><div layout="row"><!-- \t\t\t\t\t \t<i ng-if="vm.location.country!=null" ng-click="vm.clear(\'COUNTRY\');" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-input-container ng-show="vm.requestFlagCountryInput" md-no-float class="locationPopInputSty w100Imp" flex><input id="requestCountrySearchKey" class="right-drop-search camelCase" ng-change="vm.countrySearchChange();" ng-model="vm.location.country" type="search" no-special-char></md-input-container></div><div ng-messages="addlocationRequestForm.country.$error"><div ng-if="addlocationRequestForm.country.$error.required && addlocationRequestForm.$submitted && !vm.location.country" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div ng-hide="vm.isShowProvince"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase required" data-translate="library.filters.province"></label></div><!-- \t\t\t\t\t \t   <i ng-if="vm.addLocationObject.provinceObj.provinceId" ng-click="vm.clear(\'PROVINCE\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select name="province" ng-required="!vm.addLocationObject.provinceObj.provinceId && !vm.isShowProvince && !vm.location.province" ng-class="{borderError:!vm.addLocationObject.provinceObj && addlocationRequestForm.$submitted}" ng-hide="vm.isReplaceProvince" ng-model="vm.addLocationObject.provinceObj" ng-change="vm.populatePreFillDetails(vm.addLocationObject.provinceObj); call();" md-on-open="vm.saveValid({type:\'PROVINCE\'});" md-on-close="vm.replaceInputField();vm.clearName(\'provinceObj\',\'province\',\'searchProvinceList\');vm.saveValid({type:\'PROVINCE\'});" placeholder="{{vm.addLocationObject.provinceObj.provinceId == undefined ? (\'library.search.province\' | translate) : vm.addLocationObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="vm.searchRequestLocation(vm.province, \'PROVINCE\')" ng-keydown="$event.stopPropagation();" ng-change="vm.provinceChange();" ng-model="vm.province" type="search" placeholder="{{\'library.search.province\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.province.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.searchProvinceList" class="stickySearch camelCase"><md-option ng-if="vm.province.length >1" ng-value="dropValueProvince" ng-repeat="dropValueProvince in vm.searchProvinceList = (vm.searchProvinceList | filter:province)">{{dropValueProvince.fullName.toLowerCase()}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.searchProvinceList.length == 0 && vm.province.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div layout="row"><!-- \t\t\t\t\t \t<i ng-if="vm.location.province!=null" ng-click="vm.clear(\'PROVINCE\');" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-input-container md-no-float ng-show="vm.requestFlagProvinceInput" class="locationPopInputSty w100Imp" flex><input id="requestProvinceSearchKey" class="right-drop-search camelCase" ng-change="vm.provinceSearchChange();" ng-model="vm.location.province" type="search" no-special-char></md-input-container></div><div ng-messages="addlocationRequestForm.province.$error"><div ng-if="addlocationRequestForm.province.$error.required && addlocationRequestForm.$submitted && !vm.location.province" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div ng-hide="vm.isShowCity"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase required" data-translate="library.filters.city"></label></div><!-- \t\t\t\t\t \t   <i ng-if="vm.addLocationObject.cityObj.cityId" ng-click="vm.clear(\'CITY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select name="city" ng-required="!vm.addLocationObject.cityObj.cityId && !vm.isShowCity && !vm.location.city" ng-class="{borderError:!vm.addLocationObject.cityObj && addlocationRequestForm.$submitted}" ng-hide="vm.isReplaceCity" ng-model="vm.addLocationObject.cityObj" ng-change="vm.populatePreFillDetails(vm.addLocationObject.cityObj);call();" md-on-open="vm.saveValid({type:\'CITY\'});" md-on-close="vm.replaceInputField();vm.clearName(\'cityObj\',\'city\',\'searchCityList\');vm.saveValid({type:\'CITY\'});" placeholder="{{vm.addLocationObject.cityObj.cityId == undefined ? (\'library.search.city\' | translate) : vm.addLocationObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="vm.searchRequestLocation(vm.city, \'CITY\')" ng-keydown="$event.stopPropagation();" ng-model="vm.city" type="search" ng-change="vm.cityChange();" placeholder="{{\'library.search.city\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.city.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.searchCityList" class="stickySearch camelCase"><md-option ng-if="vm.city.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in vm.searchCityList = (vm.searchCityList | filter:city)">{{dropValueCity.fullName.toLowerCase()}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.searchCityList.length == 0 && vm.city.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div layout="row"><!-- \t \t \t\t\t<i ng-if="vm.location.city!=null" ng-click="vm.clear(\'CITY\');" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-input-container md-no-float ng-show="vm.requestFlagCityInput" class="locationPopInputSty w100Imp" flex><input id="requestcitySearchKey" class="right-drop-search camelCase" ng-model="vm.location.city" ng-change="vm.citySearchChange();" type="search" no-special-char></md-input-container></div><div ng-messages="addlocationRequestForm.city.$error"><div ng-if="addlocationRequestForm.city.$error.required && addlocationRequestForm.$submitted && !vm.location.city" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div ng-hide="vm.isShowSector"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase required" data-translate="library.filters.sector"></label></div><!-- \t\t\t\t\t\t   <i ng-if="vm.addLocationObject.sectorObj.sectorId" ng-click="vm.clear(\'SECTOR\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select name="sector" ng-required="!vm.addLocationObject.sectorObj.sectorId && !vm.isShowSector && !vm.location.sector" ng-class="{borderError:!vm.addLocationObject.sectorObj && addlocationRequestForm.$submitted}" ng-hide="vm.isReplaceSector" ng-model="vm.addLocationObject.sectorObj" ng-change="vm.populatePreFillDetails(vm.addLocationObject.sectorObj);call();" md-on-open="vm.saveValid({type:\'SECTOR\'});" md-on-close="vm.replaceInputField();vm.clearName(\'sectorObj\',\'sector\',\'searchSectorList\');vm.saveValid({type:\'SECTOR\'});" placeholder="{{vm.addLocationObject.sectorObj.sectorId == undefined ? (\'library.search.sector\' | translate) : vm.addLocationObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="vm.searchRequestLocation(vm.sector, \'SECTOR\')" ng-keydown="$event.stopPropagation();" ng-model="vm.sector" type="search" ng-change="vm.sectorChange();" placeholder="{{\'library.search.sector\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.sector.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.searchSectorList" class="stickySearch camelCase"><md-option ng-if="vm.sector.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in vm.searchSectorList = (vm.searchSectorList | filter:sector)">{{dropValueSector.fullName.toLowerCase()}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.searchSectorList == 0 && vm.sector.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div layout="row"><!-- \t \t \t\t\t<i ng-if="vm.location.sector!=null" ng-click="vm.clear(\'SECTOR\');" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="vm.requestFlagSectorInput"><input id="requestSectorSearchKey" class="right-drop-search camelCase" ng-change="vm.sectorSearchChange();" ng-model="vm.location.sector" type="search" no-special-char></md-input-container></div><div ng-messages="addlocationRequestForm.sector.$error"><div ng-if="addlocationRequestForm.sector.$error.required && addlocationRequestForm.$submitted && !vm.location.sector" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div ng-if="vm.flag == 1"><form-location-filter disable-flag="false" relpaceinputfield-object="addLocationInputObject" media="vm.media" savevalid="checkMandatoryFields(type)" inputsearch-object="vm.addLocationInputSearchObject" add-new-location="true" model-object="vm.saveOrAddLocationObject" horizon-flag="isHorizon" call=""></form-location-filter></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50" layout="column"><div ng-if="vm.existFlag" data-translate="library.popup.validation.locationExists" class="errorMsg mt15"></div><div ng-if="vm.validationMSGFlagProvince && vm.validationMSGFlagCity" data-translate="library.popup.validation.enterProvinceCity" class="errorMsg mt15"></div><div ng-if="!vm.validationMSGFlagCity && vm.validationMSGFlagProvince" data-translate="library.popup.validation.enterProvince" class="errorMsg mt15"></div><div ng-if="!vm.validationMSGFlagProvince && vm.validationMSGFlagCity" data-translate="library.popup.validation.enterCity" class="errorMsg mt15"></div><div layout-gt-sm="row" class="w100p" layout-align="end end"><!-- <div ng-if="isValidEnable" flex="50" flex-xs="100" class="ph5"><span class="redTxt monstFamily fz13">Already Exists</span></div> --><div layout="row" flex-xs="100" layout-align="end center"><md-button class="saveOrClose caps color-red test" ng-click="vm.cancelLocation(addlocationRequestForm, vm.flag, event)" data-translate="library.popup.cancel"></md-button><div ng-if="vm.flag != 1"><md-button ng-disabled="(vm.locationRequestType.name == vm.APP.LIBRARY.COUNTRY &&vm.addLocationObject.countryObj.countryId != null)|| (vm.locationRequestType.name == vm.APP.LIBRARY.PROVINCE && vm.addLocationObject.provinceObj.provinceId != null)|| (vm.locationRequestType.name == vm.APP.LIBRARY.CITY && vm.addLocationObject.cityObj.cityId != null)|| (vm.locationRequestType.name == vm.APP.LIBRARY.SECTOR && vm.addLocationObject.sectorObj.sectorId != null) || (disableSaveButton == true)" type="submit" class="saveOrClose caps color-yellow" data-translate="library.popup.save"></md-button></div><div ng-if="vm.flag == 1"><!-- <md-button type="button" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.add" ng-click="vm.addLocation(addlocationRequestForm, vm.flag);"></md-button> --><md-button ng-disabled="vm.isAddLocationDisable" type="button" class="saveOrClose caps color-yellow" data-translate="library.popup.add" ng-click="vm.addLocation(addlocationRequestForm, vm.flag);"></md-button><!-- ng-disabled="!isValidEnable" --></div></div></div></md-dialog-actions></md-dialog></form></div>');
$templateCache.put('app/library/entity/entityIconPopup.html','<div id="entityIconPopupId" class="md-dialog-container"><md-dialog class="addEditPopup width1050px" ng-class="{popupMBL:vm.media(\'xs\')}"><form name="entityIconForm"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle"><span data-translate="dashboard.entityReview"></span></div></md-toolbar><md-dialog-content><div ng-if="vm.entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="column" class="pd50 pt40"><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="dashboard.entityName"></label></div><div flex="25" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="dashboard.section"></label><p>{{entityItems.isApproved}}</p></div><div flex="25" flex-xs="100" class="mb25"></div></div></div><div layout="column" class="pd50Entity pt40" ng-repeat="entityItems in vm.entityReviewItems"><div ng-if="(!entityItems.isMerged)" layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><div name="profileEntityType" class="popupFont">{{entityItems.answer}}</div></div><div flex="25" flex-xs="100" class="mb25"><div name="profileEntityName" class="popupFont">{{entityItems.section}}</div></div><div flex="25" flex-xs="100" class="mb25" ng-if="(vm.userRole == \'LARI_MANAGER\') && (!entityItems.isApproved && entityItems.isApproved != undefined)"><div name="profileEntityName" class="popupFontEntity grncolor" ng-click="getEntityProfileById(entityItems.entityProfileId,false,$event)">Approve</div></div><div flex="25" flex-xs="100" class="mb25" ng-if="(vm.userRole == \'LARI_ANALYST\') && (!entityItems.isApproved && entityItems.isApproved != undefined)"><div name="profileEntityName" class="popupFontEntity redcolor">Under Review</div></div></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(entityIconForm)" data-translate="dashboard.close"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/entity/entityProfilePopup.html','<div id="entityProfilePopupId" class="md-dialog-container"><md-dialog class="addEditPopup width530px" ng-class="{popupMBL:vm.media(\'xs\')}"><form name="entityProfileForm"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle"><span data-translate="library.popup.entityProfile"></span> - <span class="caps" ng-bind="vm.entityRequestNew.entityType.name"></span></div></md-toolbar><md-dialog-content><div ng-if="vm.entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="column" class="pd50 pt40"><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.entityType"></label><div name="profileEntityType" ng-bind="vm.entityRequestNew.entityType.name" class="popupFont"></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.entityName"></label><div name="profileEntityName" ng-bind="vm.entityRequestNew.name" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.country"></label><div name="profileCountry" ng-bind="vm.entityRequestNew.countryObj.countryTxt" class="popupFont"></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.province"></label><div name="profileProvince" ng-bind="vm.entityRequestNew.provinceObj.provinceTxt" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.city"></label><div name="profileCity" ng-bind="vm.entityRequestNew.cityObj.cityTxt" class="popupFont"></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.sector"></label><div name="profileSector" ng-bind="vm.entityRequestNew.sectorObj.sectorTxt != null && vm.entityRequestNew.sectorObj.sectorTxt != \'\' ? vm.entityRequestNew.sectorObj.sectorTxt : \'-\'" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.personName"></label><div name="profileContactPerson" ng-bind="vm.entityRequestNew.contactPersonName != null && vm.entityRequestNew.contactPersonName != \'\' ? vm.entityRequestNew.contactPersonName : \'-\'" class="popupFont"></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.number"></label><div name="profileContactNumber" ng-bind="vm.entityRequestNew.contactPhoneNumber != null && vm.entityRequestNew.contactPhoneNumber != \'\' ? vm.entityRequestNew.contactPhoneNumber : \'-\'" class="popupFont"></div></div></div><div layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.email"></label><div name="profileContactEmail" ng-bind="vm.entityRequestNew.contactEmail != null && vm.entityRequestNew.contactEmail != \'\' ? vm.entityRequestNew.contactEmail : \'-\'" class="popupFont"></div></div><div flex="50" class="mb25" ng-if="vm.currentUser.loggedUser != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><label class="popupLbl normalFont" data-translate="library.popup.labels.flag"></label><div name="profileFlag" ng-bind="vm.entityRequestNew.flag" class="popupFont camelCase"></div></div></div><div ng-if="vm.currentUser.loggedUser != vm.APP.GLOBAL.ROLE_INVESTIGATOR" layout-gt-sm="row" layout-align="start center" layout-align-xs="start start" layout-align-sm="start start" class="mb25"><div><label class="popupLbl normalFont" data-translate="library.popup.labels.comment"></label><div name="profileComment" ng-bind="vm.entityRequestNew.comments != null && vm.entityRequestNew.comments != \'\' ? vm.entityRequestNew.comments : \'-\'" class="popupFont"></div></div></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(entityProfileForm)" data-translate="library.filters.close"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/entity/library.entities.html','<div resize ng-init="vm.entityInit();"><div class="noHScroll overflowHidden userFilterML"><div layout="row" class="contentWidth invTotSty"><div id="entitiesFilterId" flex="25" flex-xs="0" flex-sm="0" class="" show-gt-sm resize class="noHScroll overYAuto" ng-style="{\'height\':windowHeight}"><md-sidenav flex="100" class="md-sidenav-right lytWhiteBg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right"><div ng-show="vm.initialLoader"><md-progress-linear class="countListLoad z5imp" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filter"></div><div class="md-toolbar-tools camelCase tgRightTitle"><span ng-bind="vm.loggedUserRole"></span></div></md-toolbar><md-content class="pl30 pt30 mblSideFilter" layout-align="center center"><div ng-if="!vm.initialLoader"><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="library.filters.entity.entityType"></div><div class="filters" ng-if="!(vm.loggedUserRole == vm.APP.GLOBAL.INVESTIGATOR && entityTypeObj.name == \'DNA Center\')" layout="row" ng-repeat="entityTypeObj in vm.entityTypeList track by $index"><div flex="70"><md-checkbox ng-model="entityTypeObj.checked" ng-disabled="vm.loadingListData" ng-click="vm.toggleEntity(entityTypeObj,vm.selectedEntityType);"><span data-translate="library.subheaders.{{entityTypeObj.name}}"></span></md-checkbox></div><div flex="25" layout="row" layout-align="end"><div class="filtersCount">{{entityTypeObj.count}}</div></div></div><div id="capsFilter" flex="95"><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="library.filters.entity.location"></div><location-filter disable-flag="false" relpaceinputfield-object="libraryEntityInputObject" media="vm.media" model-object="vm.libraryEnityLocationObject" inputsearch-object="libraryEntityInputSearchObject" call="vm.getEntityProfilesList();"></location-filter></div></div></md-content><div class="locationApplyBtnSty locationApplyBtnStyMbl"><md-button ng-click="vm.callSynchronizePromise();vm.sideNavClose(\'right\');" class="leftButton applyFilter" hide-gt-sm data-translate="library.filters.apply"></md-button></div></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/library/entity/library.entitieslisting.html\'"></div></div></div></div>');
$templateCache.put('app/library/entity/library.entitieslisting.html','<div><div flex="100" layout="column" class="pv15 investigationContainer" ng-class="{\'ml30\' : vm.loggedUserRole == vm.APP.GLOBAL.MANAGER, \'mobileEditmt40 mobileEditpb55\' : vm.media(\'xs\') && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER}"><div layout="row" class="w100Imp"><div flex="70"><md-input-container md-no-float class="md-block"><!-- <i flex-order="1" class="material-icons searchIcon"><span data-translate="library.search"></span></i> --> <i flex-order="1" class="material-icons searchIcon">search</i> <input flex-order="2" no-special-char common-search search-callback="vm.searchEntity(vm.entitySearch)" name="entitySearch" id="prosInvSearchId" class="searchLeft" ng-model="vm.entitySearch" placeholder="{{media(\'xs\') ? (\'library.search.entity\' | translate): (\'library.search.entity\' | translate)}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div flex="30" layout-align="end center" layout><md-select ng-model="vm.entitySortBy" ng-change="vm.getEntitySortedList(vm.entitySortBy.id);" placeholder="{{\'library.search.sortby\' | translate}}" class="sortOrder md-no-underline selectHeader dropdownSelection caps"><md-option ng-repeat="sortOrder in vm.sortOrderList" ng-value="sortOrder"><span data-translate="library.search.{{sortOrder.value}}"></span></md-option></md-select></div></div><div id="entitiesListId" layout="column" class=""><div class="scrollableList noHScroll overYAuto" resize ng-style="{\'max-height\': windowHeight - 110}"><div class="noOutLine listBorder bgColorWh" page-size="10" ng-scroll-repeat="entity in vm.approvedEntityList track by $index" ng-click="openNewEntity($event,\'addNewEntityPopupId\',2);showEntityProfileById(entity.entityProfileId);"><div layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center"><div flex="5" ng-if="!vm.media(\'xs\')"></div><div flex="70"><div class="prospectName camelCase"><span class="fontSize15" ng-bind="entity.name"></span></div><div class="investigationsType"><span data-translate="library.subheaders.{{entity.entityTypeName}}"></span> - <span ng-bind="entity.countryName"></span></div><div flex class="status" show-xs hide-gt-xs><span ng-bind=""></span></div></div><div flex="30" layout="row" layout-align="space-around center" layout-xs="column"><div layout="column" layout-align="space-around start"><span class="prospectName fontSize10" data-translate="library.approvedDate"></span><div class="prospectName normalFont"><span data-translate="dashboard.month.{{entity.approvedMonth}}"></span> <span data-translate="{{entity.approvedDay}}"></span> <span data-translate="{{entity.approvedYear}}"></span></div></div></div></div></div></div><div class="h60p listBorder bgColorWh" ng-if="vm.approvedEntityList.length == 0 && !vm.loadingEntityProfileListData" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.noresult"></span></div><div class="h60p listBorder bgColorWh" ng-if="!vm.loadingEntityProfileListData && vm.noMoreEntities" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.nomoreresult"></span></div></div><div ng-if="vm.loadingEntityProfileListData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div></div>');
$templateCache.put('app/library/location/library.location.html','<div resize><div class="noHScroll overflowHidden userFilterML"><div layout="row" class="contentWidth invTotSty"><div id="entitiesFilterId" flex="25" flex-xs="0" flex-sm="0" class="" show-gt-sm resize class="noHScroll overYAuto" ng-style="{\'height\':windowHeight}"><md-sidenav flex="100" class="md-sidenav-right lytWhiteBg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right"><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filter"></div><div class="md-toolbar-tools camelCase tgRightTitle"><span ng-bind="vm.loggedUserRole"></span></div></md-toolbar><md-content class="pl30 pt30 mblSideFilter" layout-align="center center"><div id="capsFilterLocation" flex="95" flex-xs="100" flex-sm="100"><div layout="row" layout-xs="column" layout-sm="column" layout-align="space-between center" layout-align-xs="space-around stretch" layout-align-sm="space-around stretch" class="w100Imp" hide-gt-sm><div flex="35" flex-xs="10" flex-sm="10"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon">search</i> <input flex-order="2" no-special-char common-search name="locationSearch" id="locationSearchId" class="searchLeft" ng-model="vm.locationSearchKey" placeholder="{{media(\'xs\') ? (\'library.search.location\' | translate): (\'library.search.location\' | translate)}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div flex flex-xs="5" flex-sm="5" class="locationprofileSideNav">{{\'library.popup.locationProfile\' | translate}}</div><div flex flex-xs="10" flex-sm="10" layout="row" layout-xs="column" layout-sm="column" layout-align="end center" layout-align-xs="space-around stretch" layout-align-sm="space-around stretch"><div><md-select ng-model="vm.profileList" placeholder="{{\'library.search.allProfile\' | translate}}" class="sortOrder md-no-underline selectHeader dropdownSelection caps"><md-option ng-repeat="profileList in vm.locationProfileList" ng-value="profileList"><span data-translate="library.search.{{profileList.val}}"></span></md-option></md-select></div><div><md-select ng-model="vm.sortBy" placeholder="{{\'library.search.sortby\' | translate}}" class="sortOrder md-no-underline selectHeader dropdownSelection caps"><md-option ng-repeat="sortOrder in vm.locationSortedList" ng-value="sortOrder"><span data-translate="library.search.{{sortOrder.val}}"></span></md-option></md-select></div></div></div><hr class="style1" hide-gt-sm><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="library.filters.entity.location"></div><location-filter disable-flag="false" relpaceinputfield-object="libraryLocationInputObject" savevalid="checkMandatoryFields(type);" media="vm.media" inputsearch-object="libraryLocationInputSearchObject" model-object="libraryLocationObject" horizon-flag="vm.isHorizon" call="vm.getLocationList();"></location-filter></div></md-content><div class="locationApplyBtnSty locationApplyBtnStyMbl"><md-button ng-click="vm.getlocationProfileList(vm.profileList.id,vm.APP.GLOBAL.TRUE);vm.getlocationSortedList(vm.sortBy.id,vm.APP.GLOBAL.TRUE);vm.getLocationList();vm.sideNavClose();" class="leftButton applyFilter" hide-gt-sm data-translate="library.filters.apply"></md-button></div></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/library/location/library.locationlisting.html\'"></div></div></div></div><div ng-include src="\'app/library/location/locationProfilePopup.html\'" style="display:none;"></div><div ng-include src="\'app/library/location/location.delete.popup.html\'" style="display:none;"></div>');
$templateCache.put('app/library/location/library.locationlisting.html','<div ng-init="vm.getLocationList();"><div flex="100" class="pv15 investigationContainer" ng-class="{\'pv15 ml30 mobileEditmt55\' : vm.loggedUserRole == vm.APP.GLOBAL.MANAGER, \'mobileEditmt40 mobileEditpb55\' : vm.media(\'xs\') && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER}"><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs="start stretch" class="w100Imp" hide-sm hide-xs><div flex="40" flex-xs="10"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon">search</i> <input flex-order="2" no-special-char common-search search-callback="vm.searchLocationDetails(vm.locationSearchKey)" name="locationSearch" id="locationSearchId" class="searchLeft" ng-model="vm.locationSearchKey" placeholder="{{media(\'xs\') ? (\'library.search.location\' | translate): (\'library.search.location\' | translate)}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div flex="5"></div><div flex flex-xs="10" layout="row" layout-align="end center" layout-align-xs="space-around center"><div flex="20" class="locationprofile" hide-xs hide-md>{{\'library.popup.locationProfile\' | translate}}</div><div flex="20" flex-xs="100"><md-select ng-model="vm.profileList" ng-change="vm.getlocationProfileList(vm.profileList.id);" placeholder="{{\'library.search.allProfile\' | translate}}" class="sortOrder md-no-underline selectHeader dropdownSelection caps filtersCount"><md-option ng-repeat="profileList in vm.locationProfileList" ng-value="profileList"><span data-translate="library.search.{{profileList.val}}"></span></md-option></md-select></div><div flex><md-select ng-model="vm.sortBy" ng-change="vm.getlocationSortedList(vm.sortBy.id);" placeholder="{{\'library.search.sortby\' | translate}}" class="sortOrder md-no-underline selectHeader dropdownSelection caps filtersCount"><md-option ng-repeat="sortOrder in vm.locationSortedList" ng-value="sortOrder"><span data-translate="library.search.{{sortOrder.val}}"></span></md-option></md-select></div></div></div><div id="locationListId"><div class="scrollableList noHScroll overYAuto" resize ng-style="{\'max-height\': windowHeight - 110}"><div class="noOutLine listBorder bgColorWh" page-size="10" ng-scroll-repeat="location in vm.locationList track by $index" ng-click="vm.locationProfileShow($event,location)"><div layout="row" flex class="md-whiteframe-1dp locationListRow bkP15"><div flex="100" layout="row" layout-margin layout-align="center center"><div flex="10" flex-xs="10" class=""><!-- <ng-letter-avatar shape="round" height="41px" width="41px" fontSize="18px" data="{{ location.name| limitTo : limit : begin}}"></ng-letter-avatar> --><div class="locImg"></div></div><div flex="60" flex-xs="60"><div class="prospectName camelCase" ng-bind="location.name"></div><div class="investigationsType"><span data-translate="library.filters.requestedBy"></span><span class="camelCase mr5" ng-bind="location.requestedByFirstName"></span><span class="camelCase" ng-bind="location.requestedByLastName"></span></div><!-- <div flex class="status" show-xs hide-gt-xs><span ng-bind="investigation.investigationStatus"></span></div> --></div><div flex flex-xs="30"><div><div class="prospectName caps fontSize10" data-translate="library.filters.approvedDate"></div><div class="prospectName normalFont camelCase"><span data-translate="dashboard.month.{{location.approvedLocationMonth}}"></span> <span data-translate="{{location.approvedLocationDay}}"></span> <span data-translate="{{location.approvedLocationYear}}"></span></div></div></div></div></div></div><div class="h60p listBorder bgColorWh" ng-if="vm.locationList.length == 0 && !vm.loadingData" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.noresult"></span></div><div class="h60p listBorder bgColorWh" ng-if="!vm.loadingData && vm.noMoreMembers" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.nomoreresult"></span></div></div><div ng-if="vm.loadingData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div></div>');
$templateCache.put('app/library/location/location.delete.popup.html','<div class="hide"><div id="deleteLocation" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout-margin layout-align="center center"><div><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout-align="center center"><div class="confirmWarn aligncenter"><span data-translate="library.popup.deleteConfirm"></span></div></div><div layout="row" layout-align="center center"><md-button ng-click="vm.closeConfirmDialog($event);" class="formSubmit width100px deleteBorder md-raised md-primary">CANCEL</md-button><md-button ng-disabled="vm.isDeleteLocationDisable" ng-class="{\'halfOpacity\':vm.isDeleteLocationDisable}" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteLocation($event)">DELETE</md-button></div><div ng-if="isConflict"><div class="fz16 errorMsg aligncenter"><span ng-bind="errorConflictMsg"></span></div></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/library/location/locationProfilePopup.html','<div id="locationProfilePopupId" class="md-dialog-container"><form name="locationProfileForm" ng-class="{\'w100p\':vm.media(\'xs\')}"><md-dialog class="addEditPopup w610" ng-class="{\'popupMBL\':vm.media(\'xs\')}"><md-toolbar><!-- Mobile View --><div hide-gt-xs show-xs layout-align="center center" class="entityProfilexs"><div align="center" class="ml7 p15 mt8MBL"><div ng-show="!btnViewChange" layout-gt-xs="row" layout-align="center center" class="popupTle caps"><span data-translate="library.popup.locationProfile" class="mr5"></span> <span data-translate="library.{{vm.locationTypeName}}" class="ml5"></span></div><div ng-show="btnViewChange" layout-gt-xs="row" layout-align="center center" class="popupTle caps"><span data-translate="library.popup.update"></span> <span data-translate="library.{{vm.locationTypeName}}" class="ml5"></span></div></div></div><div hide-xs show-gt-xs ng-show="!btnViewChange" layout-gt-xs="row" layout-align="center center" class="actProfile popupTle caps"><span data-translate="library.popup.locationProfile" class="mr5"></span> - <span data-translate="library.{{vm.locationTypeName}}" class="ml5"></span></div><div hide-xs show-gt-xs ng-show="btnViewChange" layout-gt-xs="row" layout-align="center center" class="actProfile popupTle caps"><span data-translate="library.popup.update"></span> <span data-translate="library.{{vm.locationTypeName}}" class="ml5"></span></div></md-toolbar><md-dialog-content class="h56MBL"><div ng-if="vm.entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div class="pd50 pt40" layout-align="start center" ng-if="!showEditpage"><div layout-margin layout-gt-xs="row" layout-align="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.country"></label><div name="profileCountry" ng-if="vm.locationProfile.countryTxt != null && vm.locationProfile.countryTxt != \'\'" ng-bind="vm.locationProfile.countryTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileCountry" ng-if="vm.locationProfile.countryTxt == null || vm.locationProfile.countryTxt == \'\'" class="popupFont">-</div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.province"></label><div name="profileProvince" ng-if="vm.locationProfile.provinceTxt != null && vm.locationProfile.provinceTxt != \'\'" ng-bind="vm.locationProfile.provinceTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileProvince" ng-if="vm.locationProfile.provinceTxt == null || vm.locationProfile.provinceTxt == \'\'" class="popupFont">-</div></div></div><div layout-margin layout-gt-xs="row" layout-align-xs="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.city"></label><div name="profileCity" ng-if="vm.locationProfile.cityTxt != null && vm.locationProfile.cityTxt != \'\'" ng-bind="vm.locationProfile.cityTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileCity" ng-if="vm.locationProfile.cityTxt == null || vm.locationProfile.cityTxt == \'\'" class="popupFont">-</div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.sector"></label><div name="profileSector" ng-if="vm.locationProfile.sectorTxt != null && vm.locationProfile.sectorTxt != \'\'" ng-bind="vm.locationProfile.sectorTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileSector" ng-if="vm.locationProfile.sectorTxt == null || vm.locationProfile.sectorTxt == \'\'" class="popupFont">-</div></div></div></div><div class="pd50 pt40" layout-align="start center" ng-if="showEditpage"><!-- <location-Filter disable-flag="false" relpaceinputfield-object="editLocationInputObject" media="vm.media" savevalid=\'\' inputsearch-object="editLocationInputSearchObject" model-object=\'vm.editLocationObject\' horizon-flag=\'true\' call=""></location-Filter> --><div layout-margin layout-gt-xs="row" layout-align="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.country"></label><div name="profileCountry" ng-if="!isCountryEdit" ng-bind="vm.editLocationObject.countryObj.countryTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileCountry" ng-if="isEmptyCountryVal" class="popupFont">-</div><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-if="isCountryEdit"><input class="right-drop-search caps w95 popupFont camelCase" ng-model="vm.editLocationObject.countryObj.countryTxt" type="search" no-special-char></md-input-container><div ng-if="vm.countryValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.province"></label><div name="profileProvince" ng-if="!isProvinceEdit" ng-bind="vm.editLocationObject.provinceObj.provinceTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileProvince" ng-if="isEmptyProvinceVal" class="popupFont">-</div><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-if="isProvinceEdit"><input class="right-drop-search caps w95 popupFont camelCase" ng-model="vm.editLocationObject.provinceObj.provinceTxt" type="search" no-special-char></md-input-container><div ng-if="vm.provinceValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div layout-margin layout-gt-xs="row" layout-align-xs="start start"><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.city"></label><div name="profileCity" ng-if="!isCityEdit" ng-bind="vm.editLocationObject.cityObj.cityTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileCity" ng-if="isEmptyCityVal" class="popupFont">-</div><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-if="isCityEdit"><input class="right-drop-search caps w95 popupFont camelCase" ng-model="vm.editLocationObject.cityObj.cityTxt" type="search" no-special-char></md-input-container><div ng-if="vm.cityValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div flex="50" flex-xs="100" class="mb25"><label class="popupLbl normalFont" data-translate="library.popup.labels.sector"></label><div name="profileSector" ng-if="!isSectorEdit" ng-bind="vm.editLocationObject.sectorObj.sectorTxt.toLowerCase()" class="popupFont camelCase"></div><div name="profileSector" ng-if="isEmptySectorVal" class="popupFont">-</div><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-if="isSectorEdit"><input class="right-drop-search caps w95 popupFont camelCase" ng-model="vm.editLocationObject.sectorObj.sectorTxt" type="search" no-special-char></md-input-container><div ng-if="vm.sectorValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div></md-dialog-content><md-dialog-actions layout="row" class="borderNone pd50 mt15" ng-class="{pr30impMBL:(!btnViewChange && vm.currentState != vm.APP.LIBRARY.REQUEST && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER)}"><div ng-if="vm.existFlag" data-translate="library.popup.validation.locationExists" class="errorMsg mt15"></div><md-button ng-if="vm.currentState == vm.APP.LIBRARY.REQUEST" class="saveOrClose caps color-red" ng-click="vm.cancel(locationProfileForm)" data-translate="library.filters.close"></md-button><md-button ng-if="vm.currentState != vm.APP.LIBRARY.REQUEST && vm.loggedUserRole != vm.APP.GLOBAL.MANAGER" class="saveOrClose caps color-red" ng-click="vm.cancel()" data-translate="library.filters.close"></md-button><div layout="row" ng-if="!btnViewChange && vm.currentState != vm.APP.LIBRARY.REQUEST && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><md-button class="saveOrClose caps darkGreyBg" ng-click="vm.deleteConfirmDialog($event, \'deleteLocation\');" data-translate="library.popup.delete"></md-button><md-button class="saveOrClose caps color-yellow" ng-click="vm.editLocationProfile(mapId);" data-translate="library.popup.edit"></md-button><md-button class="saveOrClose caps color-red" ng-click="vm.cancel()" data-translate="library.filters.close"></md-button></div><div layout="row" ng-if="btnViewChange"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(true)" data-translate="library.popup.cancel"></md-button><md-button class="saveOrClose caps color-yellow" ng-click="vm.updateLocationDetail($event);" data-translate="library.popup.update" ng-disabled="vm.isUpdateLocationDisabled"></md-button></div></md-dialog-actions><md-dialog-content></md-dialog-content></md-dialog></form></div>');
$templateCache.put('app/library/request/addEntity.request.popup.html','<div id="addEntityRequestPopupId" class="md-dialog-container"><md-dialog class="popup" ng-class="{popupMBL:vm.media(\'xs\')}"><form name="addEntityForm" ng-submit="vm.saveEntityRequest(vm.entity,addEntityForm)" novalidate class="addEditInvestigatorForm"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.entityTitle"></div></md-toolbar><md-dialog-content><div layout="column" class="pd50"><div data-translate="library.popup.entitySubTitle" class="pb10 pt10 popupHr"></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(addEntityForm)" data-translate="library.popup.cancel"></md-button><md-button type="submit" class="saveOrClose caps color-yellow" data-translate="library.popup.save"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/request/addLocation.request.popup.html','<div id="addLocationRequestPopupId" class="md-dialog-container"><md-dialog class="popup" ng-class="{popupMBL:vm.media(\'xs\')}"><form name="addLocationForm" ng-submit="vm.saveEntityRequest(vm.location,addLocationForm)" novalidate class="addEditInvestigatorForm"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.locationTitle"></div></md-toolbar><md-dialog-content><div layout="column" class="pd50"><div data-translate="library.popup.locationSubTitle" class="pb10 pt10 popupHr"></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(addLocationForm)" data-translate="library.popup.cancel"></md-button><md-button type="submit" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.save"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/request/library.request.html','<div resize><div class="noHScroll overflowHidden userFilterML"><div ng-show="vm.filterCountLoader && !vm.loadingListData"><md-progress-linear class="countListLoad z5imp" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="row" class="contentWidth invTotSty"><div id="requestFilterId" flex="25" flex-xs="0" flex-sm="0" class="" show-gt-sm resize class="noHScroll overYAuto" ng-style="{\'height\':windowHeight}"><md-sidenav flex="100" class="md-sidenav-right lytWhiteBg" md-is-locked-open="vm.media(\'gt-sm\')" md-component-id="right"><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filter"></div><div class="md-toolbar-tools camelCase tgRightTitle"><span ng-bind="vm.loggedUserRole"></span></div></md-toolbar><md-content class="pt30 pl30 mblSideFilter" layout-align="center center"><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="library.filters.requestType.open"></div><div class="filters" layout="row" ng-repeat="openRequest in vm.openRequest track by $index"><div flex="70"><md-checkbox ng-disabled="vm.loadingListData" ng-model="openRequest.checked" ng-click="vm.toggleRequest(openRequest,vm.selectedRequestList)"><span ng-bind="openRequest.name" data-translate="library.openSubHeaders.{{openRequest.name}}"></span></md-checkbox></div><div flex="25" layout="row" layout-align="end"><div class="filtersCount"><span ng-bind="openRequest.count"></span></div></div></div><md-divider flex="95" class="dividerStyle"></md-divider><md-switch ng-disabled="vm.loadingListData" md-invert md-no-ink class="filters" ng-model="vm.formRequest" ng-change="vm.formRequestChange(vm.formRequest);"><span data-translate="library.filters.formRequest"></span></md-switch><md-divider flex="95" class="dividerStyle"></md-divider><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="library.filters.requestType.close"></div><div class="filters" layout="row" ng-repeat="closeRequest in vm.closedRequest track by $index"><div flex="70"><md-checkbox ng-disabled="vm.loadingListData" ng-model="closeRequest.checked" ng-change="vm.toggleRequest(closeRequest,vm.selectedRequestList)"><span ng-bind="closeRequest.name" data-translate="library.closeSubHeaders.{{closeRequest.name}}"></span></md-checkbox></div><div flex="25" layout="row" layout-align="end"><div class="filtersCount"><span ng-bind="closeRequest.count"></span></div></div></div></md-content><div class="locationApplyBtnSty"><md-button ng-click="vm.getRequestList();vm.sideNavClose(\'right\');" class="leftButton applyFilter" hide-gt-sm data-translate="dashboard.applyFilters"></md-button></div></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/library/request/library.request.listing.html\'" ng-class="{ml10:vm.media(\'gt-lg\')}"></div></div></div></div>');
$templateCache.put('app/library/request/library.request.listing.html','<div><div flex="100" layout="column" class="pv15 ml30 investigationContainer" ng-class="{\'mobileEditpb55 p20imp\' : vm.media(\'xs\')}"><div layout="row" class="w100Imp"><div flex="70" flex-xs="65"><md-input-container md-no-float class="md-block"><!-- <i flex-order="1" class="material-icons searchIcon"><span data-translate="library.search"></span></i> --> <i flex-order="1" class="material-icons searchIcon">search</i> <input flex-order="2" no-special-char common-search search-callback="vm.searchRequest(vm.requestSearch)" name="requestSearch" id="prosInvSearchId" class="searchLeft" ng-model="vm.requestSearch" placeholder="{{vm.media(\'xs\') ? (\'library.search.mobileSearch\' | translate) : (\'library.search.request\' | translate)}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div hide-xs show-gt-xs flex="30" layout-align="end center" layout><md-select ng-model="vm.requestSortBy" ng-change="vm.getRequestSortedList(vm.requestSortBy.id);" placeholder="{{\'library.search.sortbydays\' | translate}}" class="mt0p sortOrder md-no-underline selectHeader caps dropdownSelection"><md-option ng-repeat="sortOrder in vm.sortOrderList" ng-value="sortOrder"><span data-translate="library.search.{{sortOrder.value}}"></span></md-option></md-select></div><div hide-gt-xs show-xs flex-xs="5"></div><div id="libraryRequestListing" hide-gt-xs show-xs flex layout-align="end center"><md-select ng-model="vm.requestSortBy" ng-change="vm.getRequestSortedList(vm.requestSortBy.id);" class="mt30MBL sortOrder md-no-underline selectHeader caps dropdownSelection sort"><md-option ng-repeat="sortOrder in vm.sortOrderList" ng-value="sortOrder"><span ng-bind="sortOrder.value"></span></md-option></md-select></div></div><div id="requestListId" layout="column" class="bgColorWh"><div class="scrollableList noHScroll overYAuto" resize ng-style="{\'max-height\': windowHeight - 115}"><div class="noOutLine listBorder bgColorWh" page-size="10" ng-scroll-repeat="request in vm.requestList track by $index" ng-click="vm.goRequest($event,request)"><div layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center"><div flex="10" flex-xs="15"><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ request.requestedByFirstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="80" flex-xs="75" layout="row" layout-xs="column" class="mw150MBL"><div flex="30" flex-xs="5" layout-align-gt-xs="center center"><div class="prospectName" ng-class="{\'mt20\' : !vm.media(\'xs\') && (request.entityTypeValue!=null || request.isForm), \'mt10\': !vm.media(\'xs\') && request.entityTypeValue==null}"><span class="camelCase" ng-bind="request.requestedByFirstName.toLowerCase()"></span><span class="pl5 camelCase" ng-bind="request.requestedByLastName.toLowerCase()"></span></div><div class="investigationsType" hide-xs><span ng-bind="request.countryName"></span></div><!-- <div flex class="status caps" show-xs hide-gt-xs><span ng-bind="request.requestTypeName"></span></div> --></div><div flex="70" flex-xs="20" layout="row" layout-align-gt-xs="space-around center" layout-xs="column"><div flex="65" flex-sm="60" flex-xs="25" class="mr5"><div layout="row" layout-align="space-around center" class="mb5"><div class="smallCircle"></div><div flex class="status caps"><span data-translate="library.popup.labels.{{request.requestTypeName}}"></span></div></div><div class="requestType requestValueColor mb5" data-translate="library.popup.labels.{{request.requestTypeName}}"></div><div class="requestType requestTypeColor mb5 entityValue camelCase" ng-bind="request.entityName"></div></div><div flex="10" hide-xs show-gt-xs class="minhe40" ng-if="!request.isForm"></div><div flex="10" hide-xs show-gt-xs class="formEntry minhe40 mt20" ng-if="request.isForm"></div><div layout="column" flex="25" flex-sm="30" layout-align="center center" layout-align-xs=""><div ng-if="request.requestStatus == \'Approved\' || request.requestStatus == \'Merged\' || request.requestStatus == \'Altered\'"><!-- <div class="common caps" hide-xs ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}">Close</div>\n\t\t\t\t\t\t\t\t\t        <div show-xs hide-gt-xs class="mblCount caps" ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}">Close</div> --><div class="mblCount caps color-grey">Close</div></div><div ng-if="!(request.requestStatus == \'Approved\' || request.requestStatus == \'Merged\' || request.requestStatus == \'Altered\')"><div class="common caps" hide-xs ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}"><span data-translate="library.openDaysNav.openDays"></span> <span ng-bind="request.daysCount"></span> <span data-translate="library.openDaysNav.daysOpen"></span></div><div show-xs hide-gt-xs class="mblCount caps" ng-class="{\'color-red\': request.daysCount >= 15,\'color-yellow\': (request.daysCount <15 && request.daysCount >=10),\'color-grey\': request.daysCount <10}">{{request.daysCount}} Days</div></div></div></div></div><div flex-xs="10" hide-gt-xs show-xs class="minhe40" ng-if="!request.isForm"></div><div flex-xs="10" hide-gt-xs show-xs class="formEntry minhe40" ng-if="request.isForm"></div></div></div></div><div class="h60p listBorder bgColorWh" ng-if="vm.requestList.length == 0 && !vm.loadingRequestData" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.noresult"></span></div><div class="h60p listBorder bgColorWh" ng-if="!vm.loadingRequestData && vm.noMoreRequests" layout="row" layout-align="center center"><span class="caps" data-translate="library.filters.nomoreresult"></span></div></div><div ng-if="vm.loadingRequestData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div><div ng-include="\'app/library/request/requestLocation.html\'" style="display:none;"></div><div ng-include="\'app/library/request/requestEntity.html\'" style="display:none;"></div><div ng-include="\'app/library/location/locationProfilePopup.html\'" style="display:none;"></div><div ng-include="\'app/library/entity/entityProfilePopup.html\'" style="display:none;"></div></div>');
$templateCache.put('app/library/request/requestEntity.html','<div id="requestEntity" class="md-dialog-container req-entity" ng-init="vm.initLanguage()"><md-dialog class="reqEntPopupD" ng-class="{reqEntPopupM:vm.media(\'xs\') || vm.media(\'sm\')}"><form name="requestEntityForm" id="requestEntityFormId" ng-submit="vm.entityApprove(vm.entityRequestNew,requestEntityForm)" novalidate class="requestLocationForm"><div><!-- Desktop view --><div hide-xs show-gt-xs layout-align="center center" class="reqProfileEntity" ng-class="{mh60:vm.isRequestMerged}"><div class="p15"><div layout-align="center center" layout="row" class="popupTle caps"><span data-translate="library.popup.requestEntity"></span> - <span ng-bind="vm.requestEntityType" class="ml7"></span></div><div ng-show="!vm.isRequestMerged" layout="row" layout-margin><ng-letter-avatar flex shape="round" height="60px" width="60px" data="{{vm.request.requestedByFirstName || firstName | limitTo : limit : begin}}" dynamic="true" class="ln60"></ng-letter-avatar><div class="colorWh pt15" flex="60"><div class="fz16 fwb"><span class="camelCase" ng-bind="vm.request.requestedByFirstName.toLowerCase() || firstName.toLowerCase()"></span> <span class="camelCase" ng-bind="vm.request.requestedByLastName.toLowerCase()|| lastName.toLowerCase()"></span></div><!-- <div class="fz12"><span ng-bind="vm.entityRequestOld.countryObj.countryTxt"></span></div> --></div><div flex class="common caps entityl0px p5 mt20imp" ng-class="{\'color-red\': vm.request.daysCount >= 15 ||noOfDays >=15,\'color-yellow\': (vm.request.daysCount <15 && vm.request.daysCount >=10 || noOfDays <15 && noOfDays >=10),\'color-grey\': vm.request.daysCount <10 || noOfDays <10}"><div class="textAlignCenter">Open <span ng-if="vm.request.daysCount  || vm.request.daysCount==0 " ng-bind="vm.request.daysCount"></span><span ng-if="noOfDays || noOfDays==0" ng-bind="noOfDays"></span> Days</div></div></div></div></div><!-- Mobile view --><div hide-gt-xs show-xs layout-align="center center" class="entityProfilexs" ng-class="{h60:vm.isRequestMerged}"><div align="center" class="ml7 p15"><div class="popupTle" data-translate="library.popup.requestEntity"></div><div ng-show="!vm.isRequestMerged" layout="row"><ng-letter-avatar shape="round" height="60px" width="60px" data="{{vm.request.requestedByFirstName || firstName | limitTo : limit : begin}}" dynamic="true" class="ln60"></ng-letter-avatar><div class="mtop5 mlt10 pt15" layout-align="space-around start"><div class="fz16 fwb colorWh"><span class="camelCase" ng-bind="vm.request.requestedByFirstName.toLowerCase() || firstName.toLowerCase()"></span> <span class="camelCase" ng-bind="vm.request.requestedByLastName.toLowerCase() || lastName.toLowerCase()"></span></div><!-- <div class="fz12 colorWh"><span ng-bind="vm.entityRequestOld.countryObj.countryTxt"></span></div> --><div class="common caps entityl0px p5" ng-class="{\'color-red\': vm.request.daysCount >= 15 || noOfDays >=15,\'color-yellow\': (vm.request.daysCount <15 && vm.request.daysCount >=10 || noOfDays <15 && noOfDays >=10),\'color-grey\': vm.request.daysCount <10 || noOfDays <10}"><div class="textAlignCenter">Open <span ng-if="vm.request.daysCount  || vm.request.daysCount==0 " ng-bind="vm.request.daysCount"></span><span ng-if="noOfDays || noOfDays==0" ng-bind="noOfDays"></span> Days</div></div></div></div></div></div></div><md-dialog-content><!-- Desktop view --><div hide-xs show-gt-xs layout="row" layout-align="space-between" layout-xs="column" flex-offset="5"><!-- Left side --><div id="reqLocId" layout-fill flex="50" layout-padding><div class="mtop30 ml7 pbt10 fwb" data-translate="library.popup.requestedEntityDetails"></div><div flex class="ml7"><label class="popupLbl" data-translate="library.popup.labels.entityName"></label><div id="reqEntityName"><span class="camelCase" ng-bind="vm.entityRequestOld.name"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><div id="reqEntityType"><span ng-bind="vm.entityRequestOld.entityType.name"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.country"></label><div id="reqLocCountry"><span class="camelCase" ng-bind="vm.entityRequestOld.countryObj.countryTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.province"></label><div id="reqLocProvince"><span class="camelCase" ng-bind="vm.entityRequestOld.provinceObj.provinceTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.city"></label><div id="reqLocCity"><span class="camelCase" ng-bind="vm.entityRequestOld.cityObj.cityTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.sector"></label><div id="reqLocSector" class="h20"><span class="camelCase" ng-bind="vm.entityRequestOld.sectorObj.sectorTxt != null && vm.entityRequestOld.sectorObj.sectorTxt != \'\' ? vm.entityRequestOld.sectorObj.sectorTxt.toLowerCase() : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.personName"></label><div id="reqLocSector" class="h19"><span class="camelCase" ng-bind="vm.entityRequestOld.contactPersonName != null && vm.entityRequestOld.contactPersonName != \'\' ? vm.entityRequestOld.contactPersonName.toLowerCase() : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.number"></label><div id="reqLocSector" class="h19"><span ng-bind="vm.entityRequestOld.contactPhoneNumber != null && vm.entityRequestOld.contactPhoneNumber != \'\' ? vm.entityRequestOld.contactPhoneNumber : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.email"></label><div id="reqLocSector" class="h19"><span ng-bind="vm.entityRequestOld.contactEmail != null && vm.entityRequestOld.contactEmail != \'\' ? vm.entityRequestOld.contactEmail : \'-\'"></span></div></div><div flex layout="row" class="ml7 pt21px"><label class="popupLbl ptop20" data-translate="library.popup.labels.flag"></label><md-switch ng-model="vm.entityRequestOld.flag" ng-disabled="true" aria-label="Switch 1"></md-switch></div><div flex class="ml7 cmnt"><label class="popupLbl" data-translate="library.popup.labels.comment"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.comments != null && vm.entityRequestOld.comments != \'\' ? vm.entityRequestOld.comments : \'-\'"></span></div></div></div><div ng-show="vm.isRequestMerged" id="reqLocId" layout-fill flex="50" layout-padding><div class="mtop30 ml7 pbt10 fwb" data-translate="library.popup.mergedEntity"></div><div flex class="ml7"><label class="popupLbl" data-translate="library.popup.labels.entityName"></label><div id="reqEntityName"><span class="camelCase" ng-bind="vm.entityRequestNew.name.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><div id="reqEntityType"><span class="camelCase" ng-bind="vm.entityRequestNew.entityType.name.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.country"></label><div id="reqLocCountry"><span class="camelCase" ng-bind="vm.entityRequestNew.countryObj.countryTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.province"></label><div id="reqLocProvince"><span class="camelCase" ng-bind="vm.entityRequestNew.provinceObj.provinceTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.city"></label><div id="reqLocCity"><span class="camelCase" ng-bind="vm.entityRequestNew.cityObj.cityTxt.toLowerCase()"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.filters.sector"></label><div id="reqLocSector" class="h20"><span class="camelCase" ng-bind="vm.entityRequestNew.sectorObj.sectorTxt != null && vm.entityRequestNew.sectorObj.sectorTxt != \'\' ? vm.entityRequestNew.sectorObj.sectorTxt.toLowerCase() : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.personName"></label><div id="reqLocSector" class="h19"><span class="camelCase" ng-bind="vm.entityRequestNew.contactPersonName != null && vm.entityRequestNew.contactPersonName != \'\' ? vm.entityRequestNew.contactPersonName.toLowerCase() : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.number"></label><div id="reqLocSector" class="h19"><span ng-bind="vm.entityRequestNew.contactPhoneNumber != null && vm.entityRequestNew.contactPhoneNumber != \'\' ? vm.entityRequestNew.contactPhoneNumber : \'-\'"></span></div></div><div flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.email"></label><div id="reqLocSector" class="h19"><span ng-bind="vm.entityRequestNew.contactEmail != null && vm.entityRequestNew.contactEmail != \'\' ? vm.entityRequestNew.contactEmail : \'-\'"></span></div></div><div flex layout="row" class="ml7 pt21px"><label class="popupLbl ptop20 mr10" data-translate="library.popup.labels.flag"></label><md-switch ng-model="vm.entityRequestOld.flag" ng-disabled="true" aria-label="Switch 1"></md-switch></div><div flex class="ml7 cmnt"><label class="popupLbl" data-translate="library.popup.labels.comment"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.comments != null && vm.entityRequestNew.comments != \'\' ? vm.entityRequestNew.comments : \'-\'"></span></div></div></div><!-- Right side --><div ng-show="!vm.isRequestMerged" id="apprvEntityReq" layout-fill flex="50" class="mr20"><div class="mtop30 pbt10 pt15imp fwb ml0 pr8" layout-padding data-translate="library.popup.approvingEntityDetails"></div><div flex class="mTN50" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}" flex="50" layout="column"><div layout-margin layout-align="start start" class="popupLbl pl0imp mbt0 ml0 mt11"><label class="required mbt0 mt0" data-translate="library.popup.labels.entityName"></label></div><!-- <label  layout-align="start start" class="popupLbl required pl0imp" data-translate="library.popup.labels.entityName"></label> --><div layout="row"><i ng-if="vm.isDisable" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select md-container-class="entityReqHeader" ng-required="!vm.entityRequestNew.entityName" ng-class="{borderError:!vm.entityRequestNew.entityName && requestEntityForm.$submitted}" ng-hide="vm.isHide" ng-disabled="vm.isDisable" flex name="entityNameSearchKey" ng-model="vm.entityRequestNew.entityName" id="reqEntityNameId" md-on-close="vm.clearOnClose(\'inputSearchText\',\'entityNameList\');" ng-change="vm.getEntityProfileById(vm.entityRequestNew.entityName.id,\'true\');" placeholder="{{vm.entityRequestNew.entityName == undefined ? (\'library.popup.labels.searchName\' | translate) : vm.entityRequestNew.entityName.name }}" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border ml7 mr20Imp"><md-select-header><md-input-container id="entityReq" md-no-float class="md-block drop-search hide-error-msg w285 m0imp"><input ng-keydown="$event.stopPropagation();" ng-blur="" focus no-special-char common-search search-callback="vm.searchEntity(vm.inputSearchText,vm.entityRequestNew.entityType.id)" ng-model="vm.inputSearchText" type="search" class="left-drop-library-search mb18 cursorText" ng-minlength="2"></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.inputSearchText.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.entityNameLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="entityNameList" class="stickySearch"><md-option ng-value="dropValue" ng-repeat="dropValue in vm.entityNameList">{{dropValue.name}}</md-option></md-optgroup><div class="searchnote" ng-if="vm.entityNameList.length == 0 && vm.inputSearchText.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div ng-messages="requestEntityForm.entityNameSearchKey.$error" class="pl5"><div ng-if="requestEntityForm.entityNameSearchKey.$error.required && requestEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div><div layout="row" class="pl10"><i ng-if="!vm.isDisable && vm.entityNameSearchText" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container flex ng-if="vm.isHide" md-no-float class="mr10Imp mt0p h40" flex><input name="entityNameInputSearchKey" id="entityNameSearchTextId" ng-required="true" class="right-drop-search w95 popupFont" ng-model="vm.entityNameSearchText" ng-change="vm.entityNameSearchText == undefined? vm.clearEntity():\'\'" type="search"></md-input-container></div></div><div ng-if="vm.entityRequestOld.isForm" flex class="ml7 pt15 pb20"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><div id="reqEntityType"><span ng-bind="vm.entityRequestOld.entityType.name"></span></div></div><div ng-if="!vm.entityRequestOld.isForm" flex class="ml7 pr8 pt15"><label class="popupLbl required" data-translate="library.popup.labels.entityType"></label><!-- required --><md-select ng-disabled="vm.isForm" ng-change="vm.clearEntity();" ng-required="requestEntityForm.$submitted" ng-model-options="{trackBy: \'$value.id\'}" name="entityTypeSearchKey" ng-model="vm.entityRequestNew.entityType" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border"><md-option ng-value="dropValueLan" ng-repeat="dropValueLan in vm.entityTypeList">{{dropValueLan.name}}</md-option></md-select><div ng-messages="requestEntityForm.entityTypeSearchKey.$error"><div ng-if="requestEntityForm.entityTypeSearchKey.$error.required && requestEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div class="ml7 pr8"><form-location-filter disable-flag="vm.isDisable" inputsearch-object="vm.requestLocationInputSearchObject" model-object="vm.entityRequestNew" form-name="requestEntityForm" add-new-location="true" horizon-flag="false" call=""></form-location-filter></div><div flex class="ml7 pr8 pt15"><label class="popupLbl pl0imp" data-translate="library.popup.labels.personName"></label><md-input-container class="mr10Imp w95"><input ng-disabled="vm.isDisable" type="text" class="camelCase" name="contactPersonDesktop" ng-model="vm.entityRequestNew.contactPersonName" no-special-char ng-pattern="/^(\\D)+$/"><div ng-messages="requestEntityForm.contactPersonDesktop.$error"><div ng-if="requestEntityForm.contactPersonDesktop.$error.pattern"><span data-translate="library.popup.validation.name"></span></div></div></md-input-container></div><div flex class="ml7 pr8"><label class="popupLbl" data-translate="library.popup.labels.number"></label><md-input-container class="mr10Imp w95"><input ng-disabled="vm.isDisable" type="text" name="contactPhoneNumber" ng-model="vm.entityRequestNew.contactPhoneNumber"></md-input-container></div><div flex class="ml7 pr8"><label class="popupLbl" data-translate="library.popup.labels.email"></label><md-input-container class="mr10Imp w95"><input ng-disabled="vm.isDisable" validate-email type="email" name="contactEmailDesk" ng-model="vm.entityRequestNew.contactEmail" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"><div ng-messages="requestEntityForm.contactEmailDesk.$error"><div ng-if="requestEntityForm.contactEmailDesk.$error.email"><span data-translate="library.popup.validation.email"></span></div></div></md-input-container></div><div flex layout="row" class="ml7 pr8"><label class="popupLbl ptop20" data-translate="library.popup.labels.flag"></label><md-switch ng-disabled="vm.isDisable" ng-model="vm.entityRequestNew.flag" aria-label="Switch 1"></md-switch></div><div layout="column" flex class="ml7 pr8 mt11"><label class="popupLbl mb18" data-translate="library.popup.labels.comment"></label><md-input-container class="mr10Imp"><!-- <input type="text" ng-model="vm.entityRequestNew.comments" class="cmtbox">   --> <textarea ng-disabled="vm.isDisable" name="commentsDesk" class="resizeNone greyBorder hyt60p" ng-required="requestEntityForm.$submitted && vm.entityRequestNew.flag" ng-model="vm.entityRequestNew.comments" rows="3" cols="15"> </textarea><div ng-messages="requestEntityForm.commentsDesk.$error"><div class="redTxt" ng-if="requestEntityForm.$submitted && requestEntityForm.commentsDesk.$error.required"><span data-translate="library.popup.validation.comment"></span></div></div></md-input-container></div></div></div><!-- Mobile view --><v-accordion class="vAccordion"><div hide-gt-sm hide-gt-xs show-xs layout="row" layout-align="space-between" layout-xs="column" class="m20px"><v-pane expanded="true"><div id="reqLocId" layout-fill class="mbt20"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Requested Entity Details</div> --><div id="requestEntityBtn" layout="row" layout="space-around"><div layout-fill class="top7px fwb" data-translate="library.popup.requestedEntityDetails"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="mt15 ml10"><div flex layout="column"><label class="popupLbl" data-translate="library.popup.labels.entityName"></label><div id="reqEntityName"><span ng-bind="vm.entityRequestOld.name"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><div id="reqEntityName"><span ng-bind="vm.entityRequestOld.entityType.name"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.country"></label><div id="reqLocCountry"><span ng-bind="vm.entityRequestOld.countryObj.countryTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.province"></label><div id="reqLocProvince"><span ng-bind="vm.entityRequestOld.provinceObj.provinceTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.city"></label><div id="reqLocCity"><span ng-bind="vm.entityRequestOld.cityObj.cityTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.sector"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.sectorObj.sectorTxt != null && vm.entityRequestOld.sectorObj.sectorTxt != \'\' ? vm.entityRequestOld.sectorObj.sectorTxt : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.personName"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.contactPersonName != null && vm.entityRequestOld.contactPersonName != \'\' ? vm.entityRequestOld.contactPersonName : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.number"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.contactPhoneNumber != null && vm.entityRequestOld.contactPhoneNumber != \'\' ? vm.entityRequestOld.contactPhoneNumber : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.email"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.contactEmail != null && vm.entityRequestOld.contactEmail != \'\' ? vm.entityRequestOld.contactEmail : \'-\'"></span></div></div><div flex layout="row" class="pt21px"><label class="popupLbl ptop20 mr10" data-translate="library.popup.labels.flag"></label><md-switch ng-model="vm.entityRequestOld.flag" ng-disabled="true" aria-label="Switch 1"></md-switch></div><div flex class="cmnt"><label class="popupLbl" data-translate="library.popup.labels.comment"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestOld.comments != null && vm.entityRequestOld.comments != \'\' ? vm.entityRequestOld.comments : \'-\'"></span></div></div></v-pane-content></div></v-pane><div id="apprvEntityReq" layout-fill class="mbt20"><v-pane ng-show="vm.isRequestMerged"><div id="reqLocId" layout-fill class="mbt20"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Requested Entity Details</div> --><div id="requestEntityBtn" layout="row" layout="space-around"><div layout-fill class="top7px fwb" data-translate="library.popup.mergedEntity"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="mt15 ml10"><div flex layout="column"><label class="popupLbl" data-translate="library.popup.labels.entityName"></label><div id="reqEntityName"><span ng-bind="vm.entityRequestNew.name"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><div id="reqEntityName"><span ng-bind="vm.entityRequestNew.entityType.name"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.country"></label><div id="reqLocCountry"><span ng-bind="vm.entityRequestNew.countryObj.countryTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.province"></label><div id="reqLocProvince"><span ng-bind="vm.entityRequestNew.provinceObj.provinceTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.city"></label><div id="reqLocCity"><span ng-bind="vm.entityRequestNew.cityObj.cityTxt"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.filters.sector"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.sectorObj.sectorTxt != null && vm.entityRequestNew.sectorObj.sectorTxt != \'\' ? vm.entityRequestNew.sectorObj.sectorTxt : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.personName"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.contactPersonName != null && vm.entityRequestNew.contactPersonName != \'\' ? vm.entityRequestNew.contactPersonName : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.number"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.contactPhoneNumber != null && vm.entityRequestNew.contactPhoneNumber != \'\' ? vm.entityRequestNew.contactPhoneNumber : \'-\'"></span></div></div><div flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.email"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.contactEmail != null && vm.entityRequestNew.contactEmail != \'\' ? vm.entityRequestNew.contactEmail : \'-\'"></span></div></div><div flex layout="row" class="pt21px"><label class="popupLbl ptop20 mr10" data-translate="library.popup.labels.flag"></label><md-switch ng-model="vm.entityRequestNew.flag" ng-disabled="true" aria-label="Switch 1"></md-switch></div><div flex class="cmnt"><label class="popupLbl" data-translate="library.popup.labels.comment"></label><div id="reqLocSector"><span ng-bind="vm.entityRequestNew.comments != null && vm.entityRequestNew.comments != \'\' ? vm.entityRequestNew.comments : \'-\'"></span></div></div></v-pane-content></div></v-pane><v-pane ng-show="!vm.isRequestMerged"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Approving Entity Details</div> --><div id="approvEntityBtn" layout="row" layout="space-around"><div layout-fill class="top7px fwb" style="margin-left: 0;" data-translate="library.popup.approvingEntityDetails"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="mt15"><div layout-margin layout-algn="start start"><div flex class="mTN50" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}" flex="50"><div layout-margin layout-align="start start" class="popupLbl pl0imp mbt0 ml0"><label class="required m0imp" data-translate="library.popup.labels.entityName"></label></div><!-- <label  layout-align="start start" class="popupLbl required pl0imp" data-translate="library.popup.labels.entityName"></label> --><div layout="row"><i ng-if="vm.isDisable" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select md-container-class="entityReqHeader" flex ng-required="!vm.entityRequestNew.entityName" ng-hide="vm.isHide" ng-disabled="vm.isDisable" name="entityNameSearchKey" ng-model="vm.entityRequestNew.entityName" md-on-close="vm.clearOnClose(\'inputSearchText\',\'entityNameList\');" ng-change="vm.getEntityProfileById(vm.entityRequestNew.entityName.id,\'true\');" placeholder="{{vm.entityRequestNew.entityName == undefined ? (\'library.popup.labels.searchName\' | translate) : vm.entityRequestNew.entityName.name }}" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border"><md-select-header><md-input-container id="entityReq" md-no-float class="md-block drop-search hide-error-msg"><input ng-keydown="$event.stopPropagation();" ng-blur="" focus no-special-char common-search search-callback="vm.searchEntity(vm.inputSearchText,vm.entityRequestNew.entityType.id)" ng-model="vm.inputSearchText" type="search" class="left-drop-library-search mb18 cursorText w93" ng-minlength="2"></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.inputSearchText.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="vm.entityNameLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="entityNameList" class="stickySearch"><md-option ng-value="dropValue" ng-repeat="dropValue in vm.entityNameList">{{dropValue.name}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.entityNameList.length == 0 && vm.inputSearchText.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="requestEntityForm.entityNameSearchKey.$error"><div ng-if="requestEntityForm.entityNameSearchKey.$error.required && requestEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div layout="row"><i ng-if="!vm.isDisable && vm.entityNameSearchText" ng-click="vm.clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container flex ng-if="vm.isHide" md-no-float class="locationPopInputSty" flex><input id="entityNameSearchTextId" ng-required="true" class="right-drop-search caps popupFont" ng-model="vm.entityNameSearchText" type="search"></md-input-container><div ng-messages="requestEntityForm.entityNameSearchKey.$error"><div ng-if="!vm.entityRequestNew.name.id && addNewEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex class="pr8"><label class="popupLbl" data-translate="library.popup.labels.entityType"></label><md-select ng-disabled="vm.isForm" ng-change="vm.clearEntity();" ng-required="requestEntityForm.$submitted" ng-model-options="{trackBy: \'$value.id\'}" name="entityTypeSearchKey" ng-model="vm.entityRequestNew.entityType" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border"><md-option ng-value="dropValueLan" ng-repeat="dropValueLan in vm.entityTypeList">{{dropValueLan.name}}</md-option></md-select></div><div class="pr8"><form-location-filter disable-flag="vm.isDisable" form-name="requestEntityForm" inputsearch-object="vm.requestLocationInputSearchObject" model-object="vm.entityRequestNew" horizon-flag="false" call=""></form-location-filter></div><div flex class="pr8"><label class="popupLbl" data-translate="library.popup.labels.personName"></label><md-input-container class="md-block"><input ng-disabled="vm.isDisable" type="text" class="camelCase" name="contactPersonMob" ng-model="vm.entityRequestNew.contactPersonName" no-special-char ng-pattern="/^(\\D)+$/"><div ng-messages="requestEntityForm.contactPersonMob.$error"><div ng-if="requestEntityForm.contactPersonMob.$error.pattern"><span data-translate="library.popup.validation.name"></span></div></div></md-input-container></div><div flex class="pr8"><label class="popupLbl" data-translate="library.popup.labels.number"></label><md-input-container class="md-block"><input ng-disabled="vm.isDisable" type="text" name="contactPhoneNumber" ng-model="vm.entityRequestNew.contactPhoneNumber"></md-input-container></div><div flex class="pr8"><label class="popupLbl" data-translate="library.popup.labels.email"></label><md-input-container class="md-block"><!-- <div class="fltRt pleftNg24"><i class="material-icons">search</i></div> --> <input ng-disabled="vm.isDisable" validate-email type="email" name="contactEmailMob" ng-model="vm.entityRequestNew.contactEmail" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"><div ng-messages="requestEntityForm.contactEmailMob.$error"><div class="redTxt" ng-if="requestEntityForm.contactEmailMob.$error.email"><span data-translate="library.popup.validation.email"></span></div></div></md-input-container></div><div flex layout="row" class="pr8"><label class="popupLbl ptop20" data-translate="library.popup.labels.flag"></label><md-switch ng-disabled="vm.isDisable" ng-model="vm.entityRequestNew.flag" aria-label="Switch 1"></md-switch></div><div flex class="pr8 mtop15"><label class="popupLbl mb18" data-translate="library.popup.labels.comment"></label><md-input-container class="md-block"><textarea class="resizeNone greyBorder hyt60p" name="commentsMob" ng-disabled="vm.isDisable" ng-required="requestEntityForm.$submitted && vm.entityRequestNew.flag" ng-model="vm.entityRequestNew.comments" rows="3" cols="15"> </textarea><div ng-messages="requestEntityForm.commentsMob.$error"><div class="redTxt" ng-if="requestEntityForm.$submitted && requestEntityForm.commentsMob.$error.required"><span data-translate="library.popup.validation.comment"></span></div></div></md-input-container></div></div></v-pane-content></v-pane></div></div></v-accordion></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><div ng-if="vm.msgFlag" data-translate="library.popup.msg" class="errorMsg mt15"></div><div ng-if="vm.msgFlagForLocation" class="errorMsg mtMsg width260px"><span data-translate="library.popup.locationMsg"></span> <span data-translate="library.popup.link" ng-click="vm.getLocationPopup($event,vm.entityRequestNew,requestEntityForm)" class="locationError"></span> <span data-translate="library.popup.locationMsgAdd"></span></div><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(requestEntityForm)" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="vm.isEntityApproveDisable" ng-show="(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.userRole == \'LARI_MANAGER\') && !vm.isRequestMerged && !vm.mergeEntity" type="submit" class="approveAlt caps color-yellow buttonColor" data-translate="library.popup.approve/alter"></md-button><!-- ng-disabled="addInvestigatorForm.$invalid" --><md-button ng-show="(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.userRole == \'LARI_MANAGER\') && !vm.isRequestMerged && vm.mergeEntity" type="submit" class="approveAlt caps color-yellow buttonColor" data-translate="library.popup.merge"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/request/requestLocation.html','<div id="requestLocation" class="md-dialog-container"><md-dialog class="reqEntPopupD" ng-class="{reqEntPopupM:vm.media(\'xs\')}"><form name="requestLocationForm" id="requestLocationFormId" ng-submit="vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST ? vm.approveAlterFormLocationRequest(vm.locationRequestNew,vm.requestLocationInputSearchObject,$event) : vm.approvAlterLocationRequest(vm.locationRequestNew,requestLocationForm,$event)" novalidate class="requestLocationForm"><div><!-- Desktop view --><div hide-xs show-gt-xs layout-align="center center" class="reqProfileEntity" ng-class="{mh60:vm.isRequestMerged}"><div class="p15"><div ng-show="vm.locationTypeName != vm.APP.LIBRARY.FORM_LOCATION_REQUEST" layout-align="center center" layout="row" layout-margin class="popupTle caps"><span data-translate="library.popup.requestLocation"></span> - <span ng-bind="vm.locationTypeName"></span></div><div ng-show="vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST" layout-align="center center" layout="row" layout-margin class="popupTle caps"><span ng-bind="vm.locationTypeName"></span></div><div layout="row" layout-margin ng-show="!vm.isRequestMerged"><ng-letter-avatar flex shape="round" height="60px" width="60px" data="{{vm.request.requestedByFirstName || requestedByFirstName | limitTo : limit : begin}}" dynamic="true" class="ln60"></ng-letter-avatar><div class="colorWh pt15" flex="60"><div class="fz16 fwb"><span ng-bind="vm.request.requestedByFirstName || requestedByFirstName"></span> <span ng-bind="vm.request.requestedByLastName || requestedByLastName"></span></div><!-- <div class="fz12"><span ng-bind="vm.locationRequestOld.countryTxt"></span></div> --></div><div flex class="common caps entityl0px p5 mt20imp" ng-class="{\'color-red\': vm.request.daysCount >= 15 || requestDuration>= 15,\'color-yellow\': (vm.request.daysCount <15 && vm.request.daysCount >=10 ||(requestDuration<15 && requestDuration >=10)),\'color-grey\': vm.request.daysCount <10 || requestDuration <10}"><div class="textAlignCenter">Open <span ng-if="vm.request.daysCount  || vm.request.daysCount==0 " ng-bind="vm.request.daysCount"></span><span ng-if="requestDuration || requestDuration==0" ng-bind="requestDuration"></span> Days</div></div></div></div></div><!-- Mobile view --><div hide-gt-xs show-xs layout-align="center center" class="entityProfilexs" ng-class="{h60:vm.isRequestMerged}"><div align="center" class="ml7 p15"><div ng-show="vm.locationTypeName != vm.APP.LIBRARY.FORM_LOCATION_REQUEST" layout-align="center center" layout="row" layout-margin class="popupTle caps"><span data-translate="library.popup.requestLocation"></span></div><div ng-show="vm.locationTypeName == vm.APP.LIBRARY.FORM_LOCATION_REQUEST" layout-align="center center" layout="row" layout-margin class="popupTle caps"><span ng-bind="vm.locationTypeName"></span></div><div layout="row" ng-show="!vm.isRequestMerged"><ng-letter-avatar shape="round" height="60px" width="60px" data="{{vm.request.requestedByFirstName || requestedByFirstName | limitTo : limit : begin}}" dynamic="true" class="ln60"></ng-letter-avatar><div class="mtop5 mlt10 pt15" layout-align="space-around start"><div class="fz16 fwb colorWh"><span ng-bind="vm.request.requestedByFirstName || requestedByFirstName"></span> <span ng-bind="vm.request.requestedByLastName || requestedByLastName"></span></div><!-- <div class="fz12 colorWh"><span ng-bind="vm.entityRequestOld.countryObj.countryTxt"></span></div> --><div class="common caps entityl0px p5" ng-class="{\'color-red\': vm.request.daysCount >= 15 || requestDuration >= 15,\'color-yellow\': (vm.request.daysCount <15 && vm.request.daysCount >=10 ||(requestDuration <15 && vm.request.daysCount >=10)),\'color-grey\': vm.request.daysCount <10 ||requestDuration <10}"><div class="textAlignCenter">Open <span ng-if="vm.request.daysCount  || vm.request.daysCount==0 " ng-bind="vm.request.daysCount"></span><span ng-if="requestDuration || requestDuration==0" ng-bind="requestDuration"></span> Days</div></div></div></div></div></div></div><md-dialog-content><div hide-xs show-gt-xs layout="row" layout-align="space-between" layout-xs="column" flex-offset="5"><div id="reqLocId" flex="50" layout-padding><div class="mtop30 ml7 pbt10 fwb" data-translate="library.popup.requestedLocationDetails"></div><div ng-if="vm.locationRequestOld.countryTxt!=null" flex class="ml7"><label class="popupLbl" data-translate="library.popup.labels.country"></label><div id="reqLocCountry"><span class="camelCase" ng-bind="vm.locationRequestOld.countryTxt"></span></div></div><div flex class="ml7 pt21px" ng-if="vm.locationRequestOld.provinceTxt!=null"><label class="popupLbl" data-translate="library.popup.labels.province"></label><div id="reqLocProvince"><span class="camelCase" ng-bind="vm.locationRequestOld.provinceTxt"></span></div></div><div ng-if="vm.locationRequestOld.cityTxt!=null" flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.city"></label><div id="reqLocCity"><span class="camelCase" ng-bind="vm.locationRequestOld.cityTxt"></span></div></div><div ng-if="vm.locationRequestOld.sectorTxt!=null && vm.locationRequestOld.sectorTxt != \'\'" flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.sector"></label><div id="reqLocSector"><span class="camelCase" ng-bind="vm.locationRequestOld.sectorTxt"></span></div></div></div><!-- Show Merged Location Object details --><div ng-show="vm.isRequestMerged" id="reqLocId" flex="50" layout-padding><div class="mtop30 ml7 pbt10 fwb" data-translate="library.popup.mergedLocation"></div><div ng-if="vm.locationRequestOld.countryTxt!=null && vm.locationRequestOld.countryTxt!=\'\'" flex class="ml7"><label class="popupLbl" data-translate="library.popup.labels.country"></label><div id="reqLocCountry"><span class="camelCase" ng-bind="vm.locationRequestNew.countryTxt"></span></div></div><div flex class="ml7 pt21px" ng-if="vm.locationRequestOld.provinceTxt!=null && vm.locationRequestOld.provinceTxt!=\'\'"><label class="popupLbl" data-translate="library.popup.labels.province"></label><div id="reqLocProvince"><span class="camelCase" ng-bind="vm.locationRequestNew.provinceTxt"></span></div></div><div ng-if="vm.locationRequestOld.cityTxt!=null && vm.locationRequestOld.cityTxt!=\'\'" flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.city"></label><div id="reqLocCity"><span class="camelCase" ng-bind="vm.locationRequestNew.cityTxt"></span></div></div><div ng-if="vm.locationRequestOld.sectorTxt!=null && vm.locationRequestOld.sectorTxt!=\'\'" flex class="ml7 pt21px"><label class="popupLbl" data-translate="library.popup.labels.sector"></label><div id="reqLocSector"><span class="camelCase" ng-bind="vm.locationRequestNew.sectorTxt"></span></div></div></div><div ng-show="!vm.isRequestMerged" id="apprvLocReq" flex="50"><div class="mtop30 ml7 pbt10 fwb pl0imp ml0" layout-padding style="padding-top: 15px !important" data-translate="library.popup.approvingLocationDetails"></div><!-- <label class="popupLbl" style="padding-top:7px !important;">Country</label> --><!-- <form-Location-Filter relpaceinputfield-object="vm.relpaceinputfieldObject" ishide-object="vm.inputIsHideObject" \n\t        \t\t\tinputsearch-object="vm.requestLocationInputSearchObject" model-object=\'vm.locationRequestNew\' \n\t        \t\t\thorizon-flag=\'false\' call="" relpaceinputfield="vm.replaceSelect()" form-name="requestLocationForm" is-validation="true"></form-Location-Filter> --><form-location-filter relpaceinputfield-object="vm.relpaceinputfieldObject" ishide-object="vm.inputIsHideObject" disable-flag="false" inputsearch-object="vm.requestLocationInputSearchObject" model-object="vm.locationRequestNew" form-name="requestLocationForm" horizon-flag="false" call="" is-validation="true" relpaceinputfield="vm.replaceSelect()" addnewlocation-object="vm.addNewLocationObject"></form-location-filter><div hide-xs show-gt-xs layout-align="center center" ng-if="vm.sectorValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.sectorValidation"></span></div></div></div><v-accordion class="vAccordion"><div hide-gt-sm hide-gt-xs show-xs layout="row" layout-align="space-between" layout-xs="column" class="m20px"><v-pane expanded><div id="reqLocId" class="mb20"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Requested Entity Details</div> --><div id="requestEntityBtn" layout="row" layout="space-around"><div flex="90" class="top7px fwb" data-translate="library.popup.requestedLocationDetails"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="ml10 mt10"><div ng-if="vm.locationRequestOld.countryTxt!=null && vm.locationRequestOld.countryTxt!=\'\'" flex layout="column"><label class="popupLbl" data-translate="library.popup.labels.country"></label><div id="appLocCountryM"><span class="camelCase" ng-bind="vm.locationRequestOld.countryTxt"></span></div></div><div ng-if="vm.locationRequestOld.provinceTxt!=null && vm.locationRequestOld.provinceTxt!=\'\'" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.province"></label><div id="appLocProvinceM"><span class="camelCase" ng-bind="vm.locationRequestOld.provinceTxt"></span></div></div><div ng-if="vm.locationRequestOld.cityTxt!=null && vm.locationRequestOld.cityTxt!=\'\'" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.city"></label><div id="appLocCityM"><span class="camelCase" ng-bind="vm.locationRequestOld.cityTxt"></span></div></div><div ng-if="vm.locationRequestOld.sectorTxt!=null && vm.locationRequestOld.sectorTxt != \'\'" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.sector"></label><div id="appLocSectorM"><span class="camelCase" ng-bind="vm.locationRequestOld.sectorTxt"></span></div></div></v-pane-content></div></v-pane><div id="apprvLocReq" class="mb20"><!-- Show Merged Location Object details --><v-pane ng-show="vm.isRequestMerged"><div id="reqLocId" class="mb20"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Requested Entity Details</div> --><div id="requestEntityBtn" layout="row" layout="space-around"><div flex="90" class="top7px fwb" data-translate="library.popup.mergedLocation"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="ml10 mt10"><div ng-if="vm.locationRequestOld.countryTxt!=null" flex layout="column"><label class="popupLbl" data-translate="library.popup.labels.country"></label><div id="appLocCountryM"><span ng-bind="vm.locationRequestNew.countryTxt"></span></div></div><div ng-if="vm.locationRequestOld.provinceTxt!=null" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.province"></label><div id="appLocProvinceM"><span ng-bind="vm.locationRequestNew.provinceTxt"></span></div></div><div ng-if="vm.locationRequestOld.cityTxt!=null" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.city"></label><div id="appLocCityM"><span ng-bind="vm.locationRequestNew.cityTxt"></span></div></div><div ng-if="vm.locationRequestOld.sectorTxt!=null" flex class="pt21px"><label class="popupLbl" data-translate="library.popup.labels.sector"></label><div id="appLocSectorM"><span ng-bind="vm.locationRequestNew.sectorTxt"></span></div></div></v-pane-content></div></v-pane><v-pane ng-show="!vm.isRequestMerged"><v-pane-header><!-- <div class="mtop30 ml7 pbt10" onclick="vm.expanded(true)">Approving Entity Details</div> --><div id="approvEntityBtn" layout="row" layout="space-around"><div flex="90" class="top7px fwb pl0imp ml0" data-translate="library.popup.approvingLocationDetails"></div><div class="downArw"><i class="material-icons">&#xE313;</i></div></div></v-pane-header><v-pane-content class="ml10"><form-location-filter disable-flag="false" relpaceinputfield-object="vm.relpaceinputfieldObject" ishide-object="vm.inputIsHideObject" inputsearch-object="vm.requestLocationInputSearchObject" model-object="vm.locationRequestNew" horizon-flag="false" call="" form-name="requestLocationForm" is-validation="true" relpaceinputfield="vm.replaceSelect()" addnewlocation-object="vm.addNewLocationObject"></form-location-filter><div hide-gt-xs show-xs layout-align="center center" ng-if="vm.sectorValidationFlag" class="errorMsg"><span data-translate="library.popup.validation.sectorValidation"></span></div></v-pane-content></v-pane></div></div></v-accordion></md-dialog-content><md-dialog-actions class="borderNone mb10 pr40 mt35" ng-class="{pr25imp:vm.loggedUserRole == vm.APP.GLOBAL.MANAGER && !vm.isRequestMerged}"><div layout="column"><div layout-align="start start" ng-if="vm.msgFlag" class="errorMsg mt15"><span data-translate="library.popup.locReqMsg"></span></div><div layout="row"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel(requestLocationForm)" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="vm.isLocationApproveDisable" ng-show="(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.userRole == \'LARI_MANAGER\') && !vm.isRequestMerged && !vm.mergeFlag" type="submit" class="approveAlt caps color-yellow buttonColor" data-translate="library.popup.approve/alter"></md-button><!-- ng-disabled="addInvestigatorForm.$invalid" --><md-button ng-show="(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.userRole == \'LARI_MANAGER\') && !vm.isRequestMerged && vm.mergeFlag" type="submit" class="approveAlt caps color-yellow buttonColor" data-translate="library.popup.merge"></md-button></div></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/library/locationdirective/library.locationdirective.html','<div class="locationFilter"><div ng-show="!horizon"><div><div flex class="pr4 pb4" ng-hide="ishideObject.country"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.country"></label></div><i ng-if="modelObject.countryObj.countryId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'COUNTRY\'),call()]:clear(\'COUNTRY\')" class="material-icons fleft librarySelect" data-translate="library.filters.closeicon"></i><md-select ng-hide="inputsearchObject.isHideCountry" ng-required="!checkRequiredFields(\'countryObj\',\'countryId\') && (!ishideObject.country && !relpaceinputfieldObject.country)" ng-class="{borderError:!modelObject.countryObj.countryId && formName.$submitted}" name="country" ng-disabled="modelObject.countryObj.countryId" ng-model="modelObject.countryObj" ng-change="media(\'gt-sm\') ? [call(),savevalid({type:\'COUNTRY\'})]: \'\'" md-on-close="relpaceinputfield();clearName(\'countryObj\',\'country\',\'searchLocationCountryList\');" placeholder="{{modelObject.countryObj.countryId == undefined ? (\'library.search.country\' | translate) : modelObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection caps ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.country, \'COUNTRY\')" ng-model="inputsearchObject.country" type="search" placeholder="{{\'library.search.country\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.country.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCountryList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.country.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in searchLocationCountryList = (searchLocationCountryList | filter:country)">{{dropValueCountry.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationCountryList.length == 0 && inputsearchObject.country.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.country.$error || inputsearchObject.isInputEmptyCountry"><div ng-if="(!modelObject.countryObj.countryId && formName.$submitted && !relpaceinputfieldObject.country) || (inputsearchObject.isInputEmptyCountry)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div layout="row"><i ng-if="relpaceinputfieldObject.countryKey" ng-click="clear(\'COUNTRY\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="relpaceinputfieldObject.country"><input id="requestSectorSearchKey" class="right-drop-search caps w95 popupFont" ng-model="relpaceinputfieldObject.countryKey" type="search" no-special-char></md-input-container></div><div flex class="pr4 pb5" ng-hide="ishideObject.province"><!-- <label layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.province"></label> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.province"></label></div><i ng-if="modelObject.provinceObj.provinceId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'PROVINCE\'),call()]:clear(\'PROVINCE\')" class="material-icons fleft librarySelect" data-translate="library.filters.closeicon"></i><md-select ng-hide="inputsearchObject.isHideProvince" ng-required="!checkRequiredFields(\'provinceObj\',\'provinceId\') && (!ishideObject.province && !relpaceinputfieldObject.province)" ng-class="{borderError:!modelObject.provinceObj.provinceId && formName.$submitted}" name="province" ng-disabled="modelObject.provinceObj.provinceId" ng-model="modelObject.provinceObj" ng-change="media(\'gt-sm\') ? [populatePreFillDetails(modelObject.provinceObj),call()]: populatePreFillDetails(modelObject.provinceObj)" md-on-close="relpaceinputfield();clearName(\'provinceObj\',\'province\',\'searchLocationProvinceList\');" placeholder="{{modelObject.provinceObj.provinceId == undefined ? (\'library.search.province\' | translate) : modelObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection caps ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.province, \'PROVINCE\')" ng-model="inputsearchObject.province" type="search" placeholder="{{\'library.search.province\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.province.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationProvinceList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.province.length >1" ng-value="dropValueProvince" ng-repeat="dropValueProvince in searchLocationProvinceList = (searchLocationProvinceList | filter:province)">{{dropValueProvince.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationProvinceList.length == 0 && inputsearchObject.province.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.province.$error || inputsearchObject.isInputEmptyProvince"><div ng-if="(!modelObject.provinceObj.provinceId && formName.$submitted && !relpaceinputfieldObject.province) || (inputsearchObject.isInputEmptyProvince)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div layout="row"><i ng-if="relpaceinputfieldObject.provinceKey" ng-click="clear(\'PROVINCE\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="relpaceinputfieldObject.province"><input id="requestSectorSearchKey" class="right-drop-search caps w95 popupFont" ng-model="relpaceinputfieldObject.provinceKey" type="search" no-special-char></md-input-container></div><div flex class="pr4 pb5" ng-hide="ishideObject.city"><!-- <label layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.city"></label> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.city"></label></div><i ng-if="modelObject.cityObj.cityId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'CITY\'),call()]:clear(\'CITY\')" class="material-icons fleft librarySelect" data-translate="library.filters.closeicon"></i><md-select ng-hide="inputsearchObject.isHideCity" ng-required="!checkRequiredFields(\'cityObj\',\'cityId\') && (!ishideObject.city && !relpaceinputfieldObject.city)" ng-class="{borderError:!modelObject.cityObj.cityId && formName.$submitted}" name="city" ng-disabled="modelObject.cityObj.cityId" ng-model="modelObject.cityObj" ng-change="media(\'gt-sm\') ? [populatePreFillDetails(modelObject.cityObj),call()]: populatePreFillDetails(modelObject.cityObj)" md-on-close="relpaceinputfield();clearName(\'cityObj\',\'city\',\'searchLocationCityList\');" placeholder="{{modelObject.cityObj.cityId == undefined ? (\'library.search.city\' | translate) : modelObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection caps ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.city, \'CITY\')" ng-model="inputsearchObject.city" type="search" placeholder="{{\'library.search.city\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.city.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCityList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.city.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in searchLocationCityList = (searchLocationCityList | filter:city)">{{dropValueCity.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationCityList.length == 0 && inputsearchObject.city.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.city.$error || inputsearchObject.isInputEmptyCity"><div ng-if="(!modelObject.cityObj.cityId && formName.$submitted && !relpaceinputfieldObject.city) || (inputsearchObject.isInputEmptyCity)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div layout="row"><i ng-if="relpaceinputfieldObject.cityKey" ng-click="clear(\'CITY\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container ng-show="relpaceinputfieldObject.city" md-no-float class="locationPopInputSty w100Imp" flex><input id="requestCitySearchKey" class="right-drop-search caps w95 popupFont" ng-model="relpaceinputfieldObject.cityKey" type="search" no-special-char></md-input-container></div><div flex class="pr4" ng-hide="ishideObject.sector"><label layout="column" layout-align="start start" class="filterSubHeading camelCase" data-translate="library.filters.sector"></label> <i ng-if="modelObject.sectorObj.sectorId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'SECTOR\'),call()]:clear(\'SECTOR\')" class="material-icons fleft librarySelect" data-translate="library.filters.closeicon"></i><md-select ng-hide="inputsearchObject.isHideSector" name="sector" ng-disabled="modelObject.sectorObj.sectorId" ng-model="modelObject.sectorObj" ng-change="media(\'gt-sm\') ? [populatePreFillDetails(modelObject.sectorObj),call()]:populatePreFillDetails(modelObject.sectorObj)" md-on-close="relpaceinputfield();clearName(\'sectorObj\',\'sector\',\'searchLocationSectorList\');" placeholder="{{modelObject.sectorObj.sectorId == undefined ? (\'library.search.sector\' | translate) : modelObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection caps ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.sector, \'SECTOR\')" ng-model="inputsearchObject.sector" type="search" placeholder="{{\'library.search.sector\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.sector.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationSectorList" class="sticky camelCase"><md-option ng-if="inputsearchObject.sector.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in searchLocationSectorList = (searchLocationSectorList | filter:sector)">{{dropValueSector.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationSectorList == 0 && inputsearchObject.sector.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div layout="row"><i ng-if="relpaceinputfieldObject.sectorKey" ng-click="clear(\'SECTOR\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container ng-show="relpaceinputfieldObject.sector" md-no-float class="locationPopInputSty w100Imp" flex><input id="requestSectorSearchKey" class="right-drop-search caps w95 popupFont" ng-model="relpaceinputfieldObject.sectorKey" type="search" no-special-char></md-input-container></div></div></div><div layout-gt-xs="row" ng-show="horizon"><!-- layout-xs="column" --><div flex-xs="100" flex-gt-xs="50" class="mh10"><div class="pb15 mlm11 pr16 pt10"><!-- <div layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.country"></div> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.country"></label></div><i ng-if="modelObject.countryObj.countryId && !disableFlag" ng-click="clear(\'COUNTRY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select ng-required="!checkRequiredFields(\'countryObj\',\'countryId\') && (!ishideObject.country && !relpaceinputfieldObject.country)" ng-class="{borderError:(!modelObject.countryObj.countryId && formName.$submitted) || (inputsearchObject.isInputEmptyCountry)}" name="country" ng-disabled="modelObject.countryObj.countryId" ng-hide="inputsearchObject.isAddOrSaveLocationCountry" ng-model="modelObject.countryObj" ng-change="call();" md-on-close="clearName(\'countryObj\',\'country\',\'searchLocationCountryList\');savevalid({type:\'COUNTRY\'});" placeholder="{{modelObject.countryObj.countryId == undefined ? (\'library.search.country\' | translate) : modelObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.country, \'COUNTRY\')" ng-model="inputsearchObject.country" type="search" placeholder="{{\'library.search.country\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.country.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCountryList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.country.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in searchLocationCountryList = (searchLocationCountryList | filter:country)">{{dropValueCountry.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationCountryList.length == 0 && inputsearchObject.country.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container ng-show="inputsearchObject.isAddOrSaveLocationCountry" md-no-float class="locationPopInputSty w100Imp" flex><input id="requestCountrySearchKey" class="right-drop-search popupFont camelCase" ng-model="inputsearchObject.countrySearchKey" type="search" no-special-char></md-input-container><div ng-messages="formName.country.$error || inputsearchObject.isInputEmptyCountry"><div ng-if="(!modelObject.countryObj.countryId && formName.$submitted && !relpaceinputfieldObject.country) || (inputsearchObject.isInputEmptyCountry)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div class="pb15 mlm15 pr16"><!--  <label layout="column" layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.city"></label> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.city"></label></div><i ng-if="modelObject.cityObj.cityId && !disableFlag" ng-click="clear(\'CITY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select ng-required="!checkRequiredFields(\'cityObj\',\'cityId\') && (!ishideObject.city && !relpaceinputfieldObject.city)" ng-class="{borderError:(!modelObject.cityObj.cityId && formName.$submitted) || (inputsearchObject.isInputEmptyCity)}" name="city" ng-disabled="modelObject.cityObj.cityId" ng-hide="inputsearchObject.isAddOrSaveLocationCity" ng-model="modelObject.cityObj" ng-change="populatePreFillDetails(modelObject.cityObj);call();" md-on-close="clearName(\'cityObj\',\'city\',\'searchLocationCityList\');savevalid({type:\'CITY\'});" placeholder="{{modelObject.cityObj.cityId == undefined ? (\'library.search.city\' | translate) : modelObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.city, \'CITY\')" ng-model="inputsearchObject.city" type="search" placeholder="{{\'library.search.city\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.city.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCityList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.city.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in searchLocationCityList = (searchLocationCityList | filter:city)">{{dropValueCity.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationCityList.length == 0 && inputsearchObject.city.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container md-no-float ng-show="inputsearchObject.isAddOrSaveLocationCity" class="locationPopInputSty w100Imp" flex><input id="requestcitySearchKey" class="right-drop-search popupFont camelCase" ng-model="inputsearchObject.citySearchKey" type="search" no-special-char></md-input-container><div ng-messages="formName.city.$error || inputsearchObject.isInputEmptyCity"><div ng-if="(!modelObject.cityObj.cityId && formName.$submitted && !relpaceinputfieldObject.city) || (inputsearchObject.isInputEmptyCity)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex-xs="100" flex-gt-xs="50" class="mh10"><div class="pb15 mlm11 pr16 pt10"><!-- <div layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.province"></div> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.province"></label></div><i ng-if="modelObject.provinceObj.provinceId && !disableFlag" ng-click="clear(\'PROVINCE\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select ng-required="!checkRequiredFields(\'provinceObj\',\'provinceId\') && (!ishideObject.province && !relpaceinputfieldObject.province)" ng-class="{borderError:(!modelObject.provinceObj.provinceId && formName.$submitted) || (inputsearchObject.isInputEmptyProvince)}" name="province" ng-disabled="modelObject.provinceObj.provinceId" ng-hide="inputsearchObject.isAddOrSaveLocationProvince" ng-model="modelObject.provinceObj" ng-change="populatePreFillDetails(modelObject.provinceObj); call();" md-on-close="clearName(\'provinceObj\',\'province\',\'searchLocationProvinceList\');savevalid({type:\'PROVINCE\'});" placeholder="{{modelObject.provinceObj.provinceId == undefined ? (\'library.search.province\' | translate) : modelObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.province, \'PROVINCE\')" ng-model="inputsearchObject.province" type="search" placeholder="{{\'library.search.province\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.province.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationProvinceList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.province.length >1" ng-value="dropValueProvince" class="camelCase" ng-repeat="dropValueProvince in searchLocationProvinceList = (searchLocationProvinceList | filter:province)">{{dropValueProvince.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationProvinceList.length == 0 && inputsearchObject.province.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container md-no-float ng-show="inputsearchObject.isAddOrSaveLocationProvince" class="locationPopInputSty w100Imp" flex><input id="requestProvinceSearchKey" class="right-drop-search popupFont camelCase" ng-model="inputsearchObject.provinceSearchKey" type="search" no-special-char></md-input-container><div ng-messages="formName.province.$error || inputsearchObject.isInputEmptyProvince"><div ng-if="(!modelObject.provinceObj.provinceId && formName.$submitted && !relpaceinputfieldObject.province) || (inputsearchObject.isInputEmptyProvince)" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div class="pb15 mlm11 pr16"><label layout="column" layout-align="start start" class="filterSubHeading camelCase" data-translate="library.filters.sector"></label> <i ng-if="modelObject.sectorObj.sectorId && !disableFlag" ng-click="clear(\'SECTOR\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select name="sector" ng-disabled="modelObject.sectorObj.sectorId" ng-hide="inputsearchObject.isAddOrSaveLocationSector" ng-model="modelObject.sectorObj" ng-change="populatePreFillDetails(modelObject.sectorObj);call();" md-on-close="clearName(\'sectorObj\',\'sector\',\'searchLocationSectorList\');savevalid({type:\'SECTOR\'});" placeholder="{{modelObject.sectorObj.sectorId == undefined ? (\'library.search.sector\' | translate) : modelObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.sector, \'SECTOR\')" ng-model="inputsearchObject.sector" type="search" placeholder="{{\'library.search.sector\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchnote" ng-hide="inputsearchObject.sector.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationSectorList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.sector.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in searchLocationSectorList = (searchLocationSectorList | filter:sector)">{{dropValueSector.fullName.toLowerCase()}}</md-option></md-optgroup><div class="searchnote" ng-if="searchLocationSectorList == 0 && inputsearchObject.sector.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="inputsearchObject.isAddOrSaveLocationSector"><input id="requestSectorSearchKey" class="right-drop-search popupFont camelCase" ng-model="inputsearchObject.sectorSearchKey" type="search" no-special-char></md-input-container></div></div></div></div>');
$templateCache.put('app/user/admin/admins.html','<div resize ng-init="vm.getAdminDetails()"><div class="noHScroll overflowHidden userFilterML"><div layout="row" class="contentWidth invTotSty"><div id="userFilterId" flex="25" flex-xs="0" flex-sm="0" show-gt-sm resize class="noHScroll overYAuto" ng-style="{\'height\':windowHeight}"><md-sidenav flex="100" class="md-sidenav-right lytWhiteBg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right"><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filters.filters"></div><div class="md-toolbar-tools camelCase tgRightTitle"><span ng-bind="vm.loggedUserRole"></span></div></md-toolbar><md-content class="pt30 pl30 mblSideFilter" layout-align="center center"><div><i ng-if="vm.countryFilter.length > 0" ng-click="vm.clear();" class="material-icons crossRemoveSelection fleft" data-translate="dashboard.filters.close"></i><md-select id="sideFilter" ng-model="vm.countryFilter" placeholder="{{ ( vm.countryFilter.length == 0 ? (\'dashboard.placeholder.regions\' | translate) : vm.setCountryPlaceholder(vm.countryFilter,\'\',\'sideFilter\') ) }}" md-on-close="vm.countryFilter.length == 0 ?  vm.clear() : vm.getAdminDetails()" class="md-no-underline selectHeader greenFilter dropdownSelection caps ofH fontstyle" multiple="multiple"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input ng-keydown="$event.stopPropagation();" flex-order="2" focus no-special-char name="vm.regionSearchKey" ng-model="vm.regionSearchKey" type="search" placeholder="{{\'dashboard.search.regions\' | translate}}" class="left-drop-search mb18 cursorText"></md-input-container></md-select-header><md-optgroup class="regionStickySearch noHScroll"><div ng-hide="vm.regionSearchKey" layout="row"><div class="ml12 checkboxColor checkTick checkWidth"><md-checkbox ng-model="vm.allCountries" ng-checked="vm.isChecked(vm.countryFilter,vm.filterAllCountry,\'\');" ng-click="vm.selectAllCountries();"></md-checkbox></div><div flex="40" class="md-text countryColor">All Countries</div></div><div ng-if="!vm.allCountries" style="border: 1px solid #C9CBCE;"></div><md-option ng-value="value" ng-repeat="value in vm.filterAllCountry | filter: vm.regionSearchKey | orderBy : \'name\'">{{value.name}}</md-option></md-optgroup><div class="caps textcenter sideFilter" ng-if="vm.regionSearchKey.length > 1" ng-init="$index=-1"><span class="md-text" data-translate="dashboard.filters.noresult"></span></div></md-select></div></md-content></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/user/admin/countryAdminSelection.html\'" ng-class="{ml10:$mdMedia(\'gt-lg\')}"></div></div></div></div>');
$templateCache.put('app/user/admin/countryAdminSelection.html','<div><div layout="row" class="w100Imp" style="margin-bottom: 5px;"><div flex="95"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon"><span data-translate="user.placeholder.search"></span></i> <input flex-order="2" no-special-char allowed-char="@\'" common-search search-callback="vm.getAdminDetails()" name="countryAdminSearch" id="prosInvSearchId" class="searchLeft mobileSearchLeft" ng-model="vm.countrySearchKey" placeholder="{{media(\'xs\') ? (\'user.placeholder.mobileSearch\' | translate): (\'Search admins by name and email\' | translate)}}" type="search"></md-input-container></div></div></div><div id="userListId" ng-if="!vm.adminLoader" layout="column" ng-style="vm.selectedAdminList.length > 0 ? {\'max-height\': (windowHeight - 215) + \'px\'} : {}"><div class="scrollableList noHScroll overYAuto" resize ng-style="{\'max-height\': windowHeight -110}"><div ng-scroll-repeat="country in vm.countryAdminData track by $index"><div id="country{{$index}}" layout="column"><div flex="100" layout="row" layout-align="start center" style="margin-right: 42px;z-index: 9;"><div hide-xs flex-xs="100"></div><div class="adminNameColor"><span class="letterSpacing">{{ country.name.charAt(0)}}</span></div><div class="nameFont"><span class="nameShow" ng-bind="country.name"></span></div><span hide-xs class="dynamic-line"></span><div show-xs><md-button class="md-fab fab editViewmobilebutton" aria-label="addEntity" ng-click="vm.showDialog($event,\'editAdminPopupId\',$index)"><img class="widbutton" src="content\\images\\UserEditIcon.png"></md-button></div><div hide-xs flex="4" class="countryiconUpDown"><span><i class="material-icons accordianCircleContent" ng-click="vm.countryAdminDetailsShow(\'countryDetails\',true, country)" ng-show="!country.detailsShow">keyboard_arrow_down</i> <i class="material-icons accordianCircleContent" ng-click="vm.countryAdminDetailsShow(\'countryDetails\',false, country)" ng-show="country.detailsShow">keyboard_arrow_up</i></span></div></div><div ng-show="country.detailsShow" class="white-box-layer-1 w100Imp"></div><div ng-show="country.detailsShow" class="white-box-layer-2 w100Imp" ng-class="{\'scrollable-div\': country.countryListDTO.length >= 4}"><div ng-show="country.detailsShow" page-size="100" layout="row" id="scrollableDiv" class="white-box w100Imp" style="margin-bottom: 5px;" ng-scroll-repeat="obj in country.countryListDTO track by $index"><div id="obj{{$index}}" layout="row" flex="100" class="w100Imp" style="margin-bottom: 5px;" ng-show="country.detailsShow"><div style="margin-left: 83px;" layout="row" flex="25" class="mw150MBL countryDropDown filterBlack"><md-select id="obj{{$index}}" ng-model="obj.country" md-container-class="custom-select" md-on-close="vm.checkInvestigationWarning($parent.$index,$index);vm.resetRemainingList();vm.isChanged(country,obj)" placeholder="Choose Country" md-on-open="vm.initialLoading=false;vm.getRemainingCountryList(country)" class="country-class letterColor fontstyle"><md-optgroup ng-if="!vm.isCountryIsSelected" class="regionStickySearch noHScroll"><md-option ng-value="value" ng-repeat="value in vm.allCountry | filter: countrySearch | orderBy : \'name\'" ng-click="vm.isChanged(country,obj);">{{value.name}}</md-option></md-optgroup><md-optgroup ng-if="vm.isCountryIsSelected" class="regionStickySearch noHScroll"><md-option ng-value="remaining" ng-repeat="remaining in vm.remainingCountryList | orderBy : \'name\'" ng-disabled="remaining.isDisabled" ng-click="vm.isCountryFieldChanged =true">{{remaining.name}}</md-option></md-optgroup></md-select></div><div layout="row" hide-xs flex="30" flex-xs="40" class="mw150MBL m1500 widthDate"><div><div modval="obj.startDate" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker placeholder="Start Date" ng-model="obj.startDate" md-max-date="vm.currentDate" type="text" md-hide-icons="calendar" name="startDate" ng-change="vm.changedAdminList(country,obj);" class="test" ng-required="obj.country.name != null" ng-disabled="obj.country.name == null" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div layout="row" flex="25" class="mw150MBL m1600 widthDate"><div><div modval="obj.endDate" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker placeholder="End Date" ng-disabled="obj.country.name == null || obj.startDate == null" ng-model="obj.endDate" md-min-date="obj.startDate" type="text" ng-change="vm.changedAdminList(country,obj);" md-hide-icons="calendar" name="endDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div ng-show="!$last" layout="row" class="minusIcon" flex="10" ng-click="vm.addOrRemoveCountry(country,obj,false)"></div><div ng-show="$last" layout="row" ng-class="{\'disabled\': vm.isDisabled(obj,country)}" class="minusIcon" ng-click="vm.addOrRemoveCountry(country,obj,false)" flex="5"></div><div ng-show="$last" layout="row" ng-class="{\'disabled\': vm.isDisabled(obj,country)}" class="plusIcon" ng-click="vm.addOrRemoveCountry(country,null,true)" flex="5"></div></div></div></div></div></div></div></div><div ng-include="\'app/user/admin/editAdminPopupId.html\'" style="display:none;"></div><div class="h60p listBorder bgColorWh" ng-if="vm.countryAdminData.length == 0 && !vm.adminLoader" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.noresult"></span></div><div class="mtm5" ng-if="vm.adminLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div class="h60p listBorder bgColorWh" ng-if="!vm.adminLoader && vm.noMoreUsers" layout="row" layout-align="center center"><span class="caps" data-translate="user.filters.nomoreresult"></span></div>');
$templateCache.put('app/user/admin/editAdminPopupId.html','<div id="editAdminPopupId" class="md-dialog-container"><md-dialog class="addEditPopupedit" ng-class="{popupMBL:vm.media(\'xs\')}"><md-toolbar class="actProfile"><div layout layout-align="center center" class="popupTle tgRightHeaderHgt" data-translate="user.popup.editAdmin"></div></md-toolbar><md-dialog-content><div class="pd50"><br><br><div flex class="pb10 pt10 popupHr"><span ng-bind="vm.countryAdminData[vm.dialogIndex].name"></span></div><br><div ng-scroll-repeat="obj in vm.countryAdminData[vm.dialogIndex].countryListDTO track by $index"><div layout="row" flex layout-xs="column" layout-sm="column" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-select id="obj{{$index}}" ng-model="obj.country" md-container-class="custom-select" md-on-close="vm.checkInvestigationWarning(vm.dialogIndex,$index);vm.resetRemainingList();vm.isChanged(vm.countryAdminData[vm.dialogIndex],obj)" placeholder="Choose Country" md-on-open="vm.initialLoading=false;vm.getRemainingCountryList(vm.countryAdminData[vm.dialogIndex])" class="country-class letterColor fontstyle"><md-optgroup ng-if="!vm.isCountryIsSelected" class="regionStickySearch noHScroll"><div ng-hide="countrySearch" layout="row"></div><md-option ng-value="value" ng-repeat="value in vm.allCountry | filter: countrySearch | orderBy : \'name\'" ng-click="vm.isChanged(country);">{{value.name}}</md-option></md-optgroup><md-optgroup ng-if="vm.isCountryIsSelected" class="regionStickySearch noHScroll"><md-option ng-value="remaining" ng-repeat="remaining in vm.remainingCountryList | orderBy : \'name\'" ng-disabled="remaining.isDisabled" ng-click="vm.isCountryFieldChanged =true">{{remaining.name}}</md-option></md-optgroup></md-select></div><div layout="row" flex="30" flex-xs="40" class="mw150MBL m1500 widthDate"><div><div modval="obj.startDate" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker placeholder="Start Date" ng-model="obj.startDate" md-max-date="vm.currentDate" type="text" md-hide-icons="calendar" name="startDate" ng-change="vm.changedAdminList(country);" class="test" ng-required="obj.country.name != null" ng-disabled="obj.country.name == null" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div layout="row" flex="30" class="mw150MBL m1600 widthDate"><div><div modval="obj.endDate" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker placeholder="End Date" ng-disabled="obj.country.name == null || obj.startDate == null" ng-model="obj.endDate" md-min-date="obj.startDate" type="text" ng-change="vm.changedAdminList(country);" md-hide-icons="calendar" name="endDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div ng-show="!$last" layout="row" class="minusIcon" flex="15" ng-click="vm.addOrRemoveCountry(vm.countryAdminData[vm.dialogIndex],obj,false,vm.dialogIndex,$index)"></div><br><br><div layout="row"><div ng-show="$last" class="minusIcon" flex="15" ng-click="vm.addOrRemoveCountry(vm.countryAdminData[vm.dialogIndex],obj,false,vm.dialogIndex,$index)" ng-class="{\'disabled\': vm.isDisabled(obj,vm.countryAdminData[vm.dialogIndex])}"></div><div ng-show="$last" class="plusIcon" flex ng-click="vm.addOrRemoveCountry(vm.countryAdminData[vm.dialogIndex],null,true,null,null)" ng-class="{\'disabled\': vm.isDisabled(obj,vm.countryAdminData[vm.dialogIndex])}"></div></div><br><div class="underline"></div><br></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><md-button id="cancelAddEditInvForm" class="saveOrClose caps color-red" ng-click="vm.closeDialog()" data-translate="user.popup.close"></md-button></div></md-dialog-actions></md-dialog></div><div class="hide"><div id="warningPopupMsg" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="user.popup.warningMsg"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.closeDialog();" data-translate="No"></md-button><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.changeSection();" data-translate="Yes"></md-button></div></div></div></md-dialog-content></md-dialog></div></div><div class="hide"><div id="warningPopupMsgForActiveInvestigation" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="user.popup.activeInvestigationMsg"></span><br><br></div></div><div layout="row" class="m300px"><div style="width: 130px"><span data-translate="user.popup.labels.name"></span></div><div style="width: 170px"><span data-translate="user.popup.labels.country"></span></div><div style="width: 90px"><span data-translate="user.popup.labels.opencase"></span></div></div><div layout="row" class="m300px" ng-repeat=" details in vm.missingCountryDetails track by $index"><div style="width: 130px"><span ng-bind="details.name"></span></div><div style="width: 170px"><span ng-bind="details.country.name"></span></div><div style="width: 90px" class="m400px"><span ng-bind="details.count"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.closeDialog();" data-translate="Ok"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/user/external/addEditInvestigator.popup.html','<div id="addEditInvestigatorPopupId" class="md-dialog-container" ng-init="vm.initLanguage()"><md-dialog class="addEditPopup" ng-class="{popupMBL:vm.media(\'xs\')}"><form name="addInvestigatorForm" ng-submit="vm.saveInvestigator(vm.investigator,addInvestigatorForm)" novalidate class="addEditInvestigatorForm"><md-toolbar class="actProfile"><!-- vm.popupTitleFlag = 1 Add Investigator\n                     vm.popupTitleFlag = 0 Edit Investigator --><div ng-if="vm.popupTitleFlag == 1" layout layout-align="center center" class="popupTle tgRightHeaderHgt" data-translate="user.popup.addTitle"></div><div ng-if="vm.popupTitleFlag == 0" layout layout-align="center center" class="popupTle tgRightHeaderHgt" data-translate="user.popup.editTitle"></div></md-toolbar><md-dialog-content class="h391"><div class="pd50"><div data-translate="user.popup.subTitle" class="pb10 pt10 popupHr"></div><div layout="row" layout-xs="column" layout-sm="column" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="md-block" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label data-translate="user.popup.labels.firstName" class="popupLbl required"></label><!-- <input ng-required="addInvestigatorForm.$submitted" no-special-char allowed-char="\'" type="text" name="invFirstName" ng-model="vm.investigator.firstName" class="popupFont camelCase" ng-pattern="/^(\\D)+$/"> --> <input ng-required="addInvestigatorForm.$submitted" no-special-char type="text" name="invFirstName" ng-model="vm.investigator.firstName" class="popupFont"><div ng-messages="addInvestigatorForm.invFirstName.$error"><div ng-if="addInvestigatorForm.invFirstName.$error.required && addInvestigatorForm.$submitted"><span data-translate="user.popup.validation.required"></span></div><!-- <div  ng-if="addInvestigatorForm.invFirstName.$error.pattern"><span data-translate="user.popup.validation.name"></span></div> --></div></md-input-container><md-input-container class="md-block" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label data-translate="user.popup.labels.lastName" class="popupLbl required"></label><!-- <input ng-required="addInvestigatorForm.$submitted" no-special-char allowed-char="\'" type="text" name="invLastName" ng-model="vm.investigator.lastName" class="popupFont camelCase" ng-pattern="/^(\\D)+$/"> --> <input ng-required="addInvestigatorForm.$submitted" no-special-char type="text" name="invLastName" ng-model="vm.investigator.lastName" class="popupFont"><div ng-messages="addInvestigatorForm.invLastName.$error"><div ng-if="addInvestigatorForm.invLastName.$error.required && addInvestigatorForm.$submitted"><span data-translate="user.popup.validation.required"></span></div><!-- <div  ng-if="addInvestigatorForm.invLastName.$error.pattern"><span data-translate="user.popup.validation.name"></span></div> --></div></md-input-container></div><div layout="row" layout-xs="column" layout-sm="column" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="md-block" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label data-translate="user.popup.labels.email" class="popupLbl"></label> <input validate-email type="email" name="invEmail" ng-model="vm.investigator.emailAddress" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"><div ng-messages="addInvestigatorForm.invEmail.$error"><div ng-if="addInvestigatorForm.invEmail.$error.email"><span data-translate="user.popup.validation.email"></span></div></div></md-input-container><md-input-container class="md-block" flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label data-translate="user.popup.labels.phone" class="popupLbl"></label><!-- <input type=\'text\' name="invPhoneNO" ng-model="vm.investigator.phoneNumber" class="popupFont" ng-pattern="/^[A-z\\d)(+-\\s]*$/"> --> <input type="text" name="invPhoneNO" ng-model="vm.investigator.phoneNumber" class="popupFont"><!-- <div ng-messages="addInvestigatorForm.invPhoneNO.$error">\n\t                            \t<div  ng-if="addInvestigatorForm.invPhoneNO.$error.pattern"><span data-translate="user.popup.validation.phoneNumber"></span></div>                            \t\n\t                            </div> --></md-input-container></div><div layout="row" layout-xs="column" layout-sm="column" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><!-- <md-input-container class="md-block" flex ng-class="{w100:vm.media(\'xs\') || vm.media(\'sm\')}"> --><!-- <div flex ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}">\n\t\t                        \t<label data-translate="user.popup.labels.language" class="popupLbl required"></label>                            \n\t\t                            <md-select ng-required="addInvestigatorForm.$submitted"  multiple ng-model-options="{trackBy: \'$value.id\'}" name="invLanguage" ng-model="vm.investigator.language" ng-class="{borderError:addInvestigatorForm.invLanguage.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH"> flex ng-class="{w100:vm.media(\'xs\') || vm.media(\'sm\')}"\n\t\t                            \t<md-option ng-value="dropValueLan" ng-repeat="dropValueLan in vm.languagesVO">{{dropValueLan.name}}</md-option>                             \n\t\t                            </md-select>\n\t\t                            <div ng-messages="addInvestigatorForm.invLanguage.$error">                            \t\n\t\t                            \t<div  ng-if="addInvestigatorForm.invLanguage.$error.required && addInvestigatorForm.$submitted" class="errorMsg"><span data-translate="user.popup.validation.required"></span></div>                      \t\n\t\t                            </div>\n\t\t                       </div> --><!--  </md-input-container> --><div flex="50" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><!-- <md-input-container class="md-block" flex ng-class="{w100:vm.media(\'xs\') || vm.media(\'sm\')}"> --> <label data-translate="user.popup.labels.country" class="popupLbl required"></label><md-select ng-required="!vm.investigator.country" name="invCountry" ng-model="vm.investigator.country" ng-class="{borderError:addInvestigatorForm.invCountry.$error.required && addInvestigatorForm.$submitted}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH" md-on-close="vm.clearLocation(\'locationSearchKey\',\'locationVO\');" placeholder="{{vm.investigator.country.id == undefined ? \'\' : vm.investigator.country.name }}"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" ng-keydown="$event.stopPropagation();" focus no-special-char common-search search-callback="vm.searchLocations(vm.locationSearchKey)" name="locationSearchKey" ng-model="vm.locationSearchKey" ng-change="vm.locationVO = undefined" type="search" class="left-drop-search mb18 cursorPointer" placeholder="{{\'user.filters.search.country\' | translate}}"></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.locationSearchKey.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.locationLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.locationVO" class="stickySearch"><md-option ng-if="vm.locationSearchKey.length >1" ng-value="dropValueLoc" ng-repeat="dropValueLoc in vm.locationVO ">{{dropValueLoc.name}}</md-option></md-optgroup><div class="searchnote" ng-if="vm.locationVO.length == 0 && vm.locationSearchKey.length > 1" data-translate="user.filters.noresult"></div></md-select><div ng-messages="addInvestigatorForm.invCountry.$error"><div ng-if="addInvestigatorForm.invCountry.$error.required && addInvestigatorForm.$submitted" class="errorMsg"><span data-translate="user.popup.validation.required"></span></div></div><!-- </md-input-container> --></div></div><div layout-align="space-between start" flex class="w95" ng-class="{w90:vm.media(\'xs\') || vm.media(\'sm\')}"><md-input-container class="md-block" ng-class="{w100Imp:vm.media(\'xs\') || vm.media(\'sm\')}"><label data-translate="user.popup.labels.comment" class="popupLbl"></label> <textarea style="border-color: #c9cbce !important;" id="addinvPop" type="text" name="invComment" ng-model="vm.investigator.comment" rows="2" class="border1p popupCmt"></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row"><div ng-if="vm.existFlag" data-translate="user.popup.validation.exsits" class="errorMsg mt15"></div><div ng-if="vm.updateExistFlag" data-translate="user.popup.validation.updateExsits" class="errorMsg mt15"></div><md-button id="cancelAddEditInvForm" class="saveOrClose caps color-red" ng-click="vm.cancel(addInvestigatorForm)" data-translate="user.popup.close"></md-button><md-button ng-disabled="vm.saveDisableFlag" ng-if="vm.popupTitleFlag == 1" type="submit" class="saveOrClose caps color-yellow" data-translate="user.popup.save"></md-button><!-- ng-disabled="addInvestigatorForm.$invalid" --><md-button ng-disabled="vm.updateDisableFlag" ng-if="vm.popupTitleFlag == 0" type="submit" class="saveOrClose caps color-yellow" data-translate="user.popup.update"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/user/external/deleteInvestigatorPopup.html','<div id="vm.deleteInvestigatorPopup" class="md-dialog-container"><md-dialog class="popup"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="user.popup.deleteTitle"></div></md-toolbar><md-dialog-content><div layout="column" layout-align="center center"><div data-translate="user.popup.deleteMSG1" class="pb10 pt10 popupHr"></div><div data-translate="user.popup.deleteMSG2" class="pb10 pt10 popupHr"></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row" layout-align="center center"><md-button class="saveOrClose caps color-red" ng-click="vm.cancel()" data-translate="user.popup.close"></md-button><md-button type="submit" class="saveOrClose caps color-yellow" data-translate="user.popup.delete"></md-button></div></md-dialog-actions></md-dialog></div>');
$templateCache.put('app/user/internal/user.html','<div resize ng-init="vm.userInit();"><div class="noHScroll overflowHidden userFilterML"><div ng-show="!vm.filterCountLoader" layout="row" class="contentWidth invTotSty"><div id="userFilterId" flex="25" flex-xs="0" flex-sm="0" show-gt-sm resize class="noHScroll overYAuto" ng-style="{\'height\':windowHeight}"><!-- <md-sidenav flex="15" class="md-sidenav-right filterPannel" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id ="right" > --><md-sidenav flex="100" class="md-sidenav-right lytWhiteBg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right"><md-toolbar class="mobileNavBar tgRightHeaderHgt pl15" hide-gt-sm><div class="md-toolbar-tools tgRightHeader" data-translate="dashboard.filters.filters"></div><div class="md-toolbar-tools camelCase tgRightTitle"><span ng-bind="vm.loggedUserRole"></span></div></md-toolbar><md-content class="pt30 pl30 mblSideFilter" layout-align="center center"><div class="mtm5" ng-if="vm.loadingCountData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-show="!vm.loadingCountData"><!-- Role Filter --><div ng-if="vm.userRoles.length > 0"><div ng-if="vm.userTabIndex == 1" layout="column" layout-align="start start" class="filterHeading caps" data-translate="user.filters.userRole"></div><div ng-if="vm.userTabIndex == 2" layout="column" layout-align="start start" class="filterHeading caps" data-translate="user.subheaders.external"></div><div class="filters" ng-if="usersRole.count > 0" layout="row" ng-repeat="usersRole in vm.userRoles track by $index"><div flex="70"><md-checkbox ng-disabled="vm.loadingListData" ng-model="usersRole.checked" ng-click="vm.toggleUser(usersRole,vm.selectedUserRoleList,vm.APP.USER.USER_ROLE_FILTER)"><span ng-if="usersRole.name != vm.APP.GLOBAL.INVESTIGATOR && usersRole.name != vm.APP.GLOBAL.EXTERNALINVESTIGATOR" class="camelCase" ng-bind="usersRole.name.toLowerCase()"></span> <span ng-if="usersRole.name == vm.APP.GLOBAL.INVESTIGATOR" data-translate="user.filters.{{usersRole.type}}"></span> <span ng-if="usersRole.name == vm.APP.GLOBAL.EXTERNALINVESTIGATOR" data-translate="user.filters.{{usersRole.type}}"></span></md-checkbox></div><div flex="25" layout="row" layout-align="end"><span ng-bind="usersRole.count"></span></div></div><md-divider flex="95" class="dividerStyle"></md-divider></div><!-- Investigation Case Filter --><div ng-if="vm.investigationCases.length > 0"><div layout="column" layout-align="start start" class="filterHeading caps" data-translate="user.filters.investigationCase"></div><div class="filters" ng-if="investigationCase.count > 0" layout="row" ng-repeat="investigationCase in vm.investigationCases track by $index"><div flex="70"><md-checkbox ng-disabled="vm.loadingListData" ng-model="investigationCase.checked" ng-click="vm.toggleUser(investigationCase,vm.selectedCasesList,vm.APP.USER.INVESTIGATION_CASES)"><span ng-bind="investigationCase.name"></span></md-checkbox></div><div flex="25" layout="row" layout-align="end"><span ng-bind="investigationCase.count"></span></div></div><md-divider flex="95" class="dividerStyle"></md-divider></div><!-- location Filter  --> <i ng-if="vm.userFilter.location.id" ng-click="vm.clearUser(\'location\',\'locationId\',\'locationSearchKey\');" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.userFilter.location.id" ng-model="vm.userFilter.location" md-on-close="vm.clearOnClose(\'location\',\'locationSearchKey\',\'locationVO\');" ng-change="vm.media(\'gt-sm\') ? [vm.updateUserFilterObj(\'location\',\'locationId\'),vm.callSynchronizePromise()]: \'\' " placeholder="{{vm.userFilter.location.id == undefined ? (\'user.filters.locations\' | translate) : vm.userFilter.location.name }}" class="md-no-underline selectHeader dropdownSelection caps ofH"><md-select-header><md-input-container md-no-float class="md-block drop-search hide-error-msg"><i flex-order="1" class="material-icons left-drop-icon" data-translate="dashboard.filters.search"></i> <input flex-order="2" focus no-special-char common-search search-callback="vm.searchLocations(vm.locationSearchKey)" name="locationSearchKey" ng-model="vm.locationSearchKey" ng-change="vm.languageVO = undefined" type="search" placeholder="{{\'user.filters.search.location\' | translate}}" class="left-drop-search mb18 cursorText" ng-minlength="2"></md-input-container></md-select-header><div class="searchnote" ng-hide="vm.locationSearchKey.length >1" data-translate="dashboard.filters.minsearch"></div><md-progress-linear ng-if="vm.locationLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="vm.locationVO" class="stickySearch"><!-- <md-option  ng-if="vm.locationSearchKey.length >1" ng-value="dropValueLoc" ng-repeat="dropValueLoc in vm.locationVO | filter:vm.locationSearchKey">{{dropValueLoc.name}}</md-option> --><md-option ng-if="vm.locationSearchKey.length >1" ng-value="dropValueLoc" ng-repeat="dropValueLoc in vm.locationVO">{{dropValueLoc.name}}</md-option></md-optgroup><div class="textcenter searchnote" ng-if="vm.locationVO.length == 0 && vm.locationSearchKey.length > 1" ng-init="$index=-1" data-translate="user.filters.noresult"></div></md-select><!-- language Filter --> <i ng-if="vm.userFilter.language.id" ng-click="vm.clearUser(\'language\',\'languageId\');" class="material-icons removeSelection fleft" data-translate="dashboard.filters.close"></i><md-select ng-disabled="vm.userFilter.language.id" ng-model="vm.userFilter.language" ng-change="vm.media(\'gt-sm\') ? [vm.updateUserFilterObj(\'language\',\'languageId\'),vm.callSynchronizePromise()]: \'\' " placeholder="{{vm.userFilter.language.id == undefined ? (\'user.filters.languages\' | translate) : vm.userFilter.language.name }}" class="md-no-underline selectHeader dropdownSelection caps ofH"><md-progress-linear ng-if="vm.languageLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-option ng-value="dropValueLan" ng-repeat="dropValueLan in vm.languagesVO">{{dropValueLan.name}}</md-option><div class="textcenter searchnote" ng-if="vm.languagesVO.length == 0 && languageSearchKey.length > 1" ng-init="$index=-1" data-translate="user.filters.noresult"></div></md-select></div></md-content><div class="locationApplyBtnSty" ng-class="{locationApplyBtnStyMbl:vm.userTabIndex == 1}"><md-button ng-click="vm.updateUserFilterObj(\'language\',\'languageId\'); vm.updateUserFilterObj(\'location\',\'locationId\');vm.callSynchronizePromise();vm.sideNavClose(\'right\');" class="leftButton applyFilter" hide-gt-sm data-translate="dashboard.filters.applyfilters"></md-button></div></md-sidenav></div><div class="smoothScroll" flex ng-include src="\'app/user/internal/user.listing.html\'" ng-class="{ml10:$mdMedia(\'gt-lg\')}"></div></div></div></div>');
$templateCache.put('app/user/internal/user.listing.html','<div><div class="pv15 ml30 investigationContainer" flex="100" layout="column" ng-class="{\'mobileEditmt40 mobileEditpb55\':(vm.userTabIndex == 2 && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER)}"><div layout="row" class="w100Imp"><div flex="70"><md-input-container md-no-float class="md-block"><i flex-order="1" class="material-icons searchIcon"><span data-translate="user.placeholder.search"></span></i> <input flex-order="2" no-special-char allowed-char="@\'" common-search search-callback="vm.searchUser(vm.userSearch)" name="userSearch" id="prosInvSearchId" class="searchLeft" ng-model="vm.userSearch" placeholder="{{vm.media(\'xs\') ? (\'user.placeholder.mobileSearch\' | translate) : (vm.userTabIndex == 1 ? (\'user.placeholder.searchUser\' | translate) : (\'user.placeholder.searchInvestigator\' | translate))}}" type="search"><!-- <i flex-order="3" ng-click="vm.clearSearchProspects();" ng-if="vm.prospectSearch.length > 1" class="material-icons removeSelection" >close</i> --></md-input-container></div><div flex="30" layout-align="end center" layout><md-select ng-model="vm.userSortBy" ng-change="vm.getUserSortedList(vm.userSortBy.id);" placeholder="{{\'user.placeholder.sortByCase\' | translate}}" class="mt0p sortOrder md-no-underline selectHeader dropdownSelection caps"><md-option ng-repeat="sortOrder in vm.sortOrderList" ng-value="sortOrder"><span ng-bind="sortOrder.value"></span></md-option></md-select></div></div><div id="userListId" layout="column" class=""><div class="scrollableList noHScroll overYAuto" resize ng-style="{\'max-height\': windowHeight -110}"><div class="noOutLine listBorder bgColorWh" page-size="10" ng-scroll-repeat="user in vm.userList track by $index" ng-click="vm.goProfile(user.id,$index)"><div id="user{{$index}}" layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center"><div flex="10" flex-xs="10"><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ user.firstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="70" flex-xs="40" class="mw150MBL"><div class="prospectName prosMBL"><span ng-bind="user.firstName"></span><span class="pl5" ng-bind="user.lastName"></span></div><div class="investigationsType"><span ng-bind="user.userRole"></span></div></div><div flex="20" flex-xs="50" layout="row"><div ng-if="user.activeUser"><div layout="column" layout-align="center center"><div class="montserrat p5 fwbold lh13p fz10 brad31p userActiveCount aligncenter caps" hide-xs><span ng-bind="user.caseCount"></span> <span data-translate="user.filters.openCases"></span></div><div show-xs hide-gt-xs class="montserrat p5 fwbold lh13p fz10 brad31p userActiveCount aligncenter caps"><span ng-bind="user.caseCount"></span> <span data-translate="user.filters.openCases"></span></div></div></div><div ng-if="!user.activeUser"><span class="redTxt ml20" data-translate="user.popup.delete.deletedUser"></span></div></div></div></div></div><div class="h60p listBorder bgColorWh" ng-if="vm.userList.length == 0 && !vm.loadingUserData" layout="row" layout-align="center center"><span class="caps" data-translate="dashboard.filters.noresult"></span></div><div class="h60p listBorder bgColorWh" ng-if="!vm.loadingUserData && vm.noMoreUsers" layout="row" layout-align="center center"><span class="caps" data-translate="user.filters.nomoreresult"></span></div></div><div class="mtm5" ng-if="vm.loadingUserData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></div></div></div>');
$templateCache.put('app/user/userprospects/user.prospects.html','<div><div hide-xs flex class="pr5p prospectHeaderSize userProspect userProspectPadding" ng-init="vm.prospectsInit();"><div flex ng-click="vm.back()" class="mw150 prospectProfileBack"><span class="letsp1p fz10 monstFamily halfOpacity caps white-text" data-translate="user.subtitle"></span> <span class="ptop8 letsp1p fz10 monstFamily halfOpacity caps white-text"><i class="material-icons">&#xE315;</i></span></div><div flex class="pb10"><span class="caps white-text fz30" ng-bind="vm.userName"><span></span></span></div><md-divider class="bg-grey h3p"></md-divider></div><div hide-gt-sm hide-gt-xs show-xs flex class="plr3p bgc-blue prospectHeaderXs" layout="row"><div ng-click="vm.back()" class="letsp1p fz10 monstFamily halfOpacity caps white-text mt30 mr20"><i class="material-icons">&#xE317;</i></div><div flex class="pb10 pt20"><span class="caps white-text fz30" ng-bind="vm.userName"><span></span></span></div></div><div layout="row" class="prosHeadPart" resize style="overflow-y:auto; overflow-x:hidden" ng-style="{\'height\':windowHeight + \'px\'}"><div flex class="bktrans overflowHidden"><div class="" layout="row"><div id="userProfile" class="prospects userProspectProfile" layout-padding ng-click="vm.stateProfileDetails();vm.userDetailsTabIndex = 1;" ng-class="{activeDiv:vm.userDetailsTabIndex == 1}"><span>PROFILE</span><div class="arrow_box" ng-if="vm.userDetailsTabIndex == 1"></div></div><div id="userActivity" class="prospects" layout-padding ng-click="vm.stateActivity(); vm.userDetailsTabIndex = 2;" ng-class="{activeDiv: vm.userDetailsTabIndex == 2}"><span>ACTIVITY</span><div class="arrow_box" ng-if="vm.userDetailsTabIndex == 2"></div></div></div><div ng-if="vm.userDetailsTabIndex == 1 && vm.user.userType == vm.APP.USER.EXTERNAL" class="mTB mobileEditmt mR3" ng-class="{mR7:vm.media(\'gt-md\')}"><div ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER && vm.userActivate"><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button ng-if="vm.userRole == vm.APP.GLOBAL.EXTERNALINVESTIGATOR || (vm.userRole != vm.APP.GLOBAL.EXTERNALINVESTIGATOR && !vm.media(\'gt-sm\'))" aria-label="menu" class="md-fab fab" area-label="menu"><img src="content\\images\\UserProfile.png"></md-button></md-fab-trigger><md-fab-actions><md-button ng-if="vm.userRole == vm.APP.GLOBAL.EXTERNALINVESTIGATOR" class="md-fab md-raised md-mini bgColorWh" aria-label="edit" ng-click="vm.openEditPopup($event,\'addEditInvestigatorPopupId\',0)"><img class="h30" src="content\\images\\UserEditIcon.png"></md-button><!-- <md-button class="md-fab md-raised md-mini fab" aria-label="delete" ng-click="vm.openDeletePopup($event,\'deleteInvestigatorPopup\')">\n\t\t\t\t\t\t\t\t\t<span class="s18">D</span>\n\t\t\t\t\t\t\t\t</md-button> --><md-button hide-gt-sm ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile"><img class="h30" src="content\\images\\UserProfileViewIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div><div ng-if="vm.loggedUserRole != vm.APP.GLOBAL.MANAGER" class="mTB mobileEditmt mR3" hide-gt-sm ng-class="{mR7:vm.media(\'gt-md\')}"><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab fab"><img src="content\\images\\UserProfile.png"></md-button></md-fab-trigger><md-fab-actions><md-button ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile"><img class="h30" src="content\\images\\UserProfileViewIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div></div><div ng-if="vm.userDetailsTabIndex == 1 && vm.user.userType == vm.APP.USER.INTERNAL" class="mTB mobileEditmt mR3" hide-gt-sm ng-class="{mR7:vm.media(\'gt-md\')}"><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab fab"><img src="content\\images\\UserProfile.png"></md-button></md-fab-trigger><md-fab-actions><md-button ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile"><img class="h30" src="content\\images\\UserProfileViewIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div><!-- <div ng-if="vm.userDetailsTabIndex == 1" class="mTB mobileEditmt mR3" hide-gt-sm ng-class="{mR7:vm.media(\'gt-md\')}">\n\t\t\t\t\t<md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale">\n\t\t\t\t\t\t<md-fab-trigger>\n\t          \t\t\t\t<md-button aria-label="menu" class="md-fab fab">\n\t          \t\t\t\t\t<img src="content\\images\\UserProfile.png">\n\t          \t\t\t\t</md-button>\n\t        \t\t\t</md-fab-trigger>\n\t        \t\t\t<md-fab-actions>\n\t\t\t\t\t\t\t<md-button ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile">\n\t\t\t\t\t\t\t\t<img class="h30" src="content\\images\\UserProfileViewIcon.png">\n\t\t\t\t\t\t\t</md-button>        \t\t\t\t\n\t        \t\t\t</md-fab-actions>\n\t\t\t\t\t</md-fab-speed-dial>\n\t\t\t\t</div> --><div ui-view="userDetails" class="lytWhiteBg smoothScroll" resize></div></div></div></div><div ng-include="\'app/user/external/addEditInvestigator.popup.html\'" style="display:none;"></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<!-- <div>\n    <div class="row">\n        <div class="col-md-4 col-md-offset-4">\n            <h1 data-translate="reset.finish.title">Reset password</h1>\n\n            <div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing">\n                <strong>The password reset key is missing.</strong>\n            </div>\n\n            <div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing">\n                <p data-translate="reset.finish.messages.info">Choose a new password</p>\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.error">\n                <p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p>\n            </div>\n\n            <div class="alert alert-success" ng-show="vm.success">\n                <p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p>\n            </div>\n\n            <div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">\n                The password and its confirmation do not match!\n            </div>\n\n            <div ng-hide="vm.keyMissing">\n                <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation>\n                    <div class="form-group">\n                        <label class="control-label" for="password" data-translate="global.form.newpassword">New password</label>\n                        <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}"\n                               ng-model="vm.resetAccount.password" ng-minlength=4 ng-maxlength=50 required>\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\n                            <p class="help-block"\n                               ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">\n                                Your password is required.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">\n                                Your password is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">\n                                Your password cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                        <password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar>\n                    </div>\n\n                    <div class="form-group">\n                        <label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label>\n                        <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}"\n                               ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>\n                        <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">\n                                Your password confirmation is required.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">\n                                Your password confirmation is required to be at least 4 characters.\n                            </p>\n                            <p class="help-block"\n                               ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">\n                                Your password confirmation cannot be longer than 50 characters.\n                            </p>\n                        </div>\n                    </div>\n                    <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div> --><div class="centerAlign"><div layout="column" flex layout-align="center center"><img class="cred-logo" src="content/images/mlb_logo.svg"> <span class="logoContent" data-translate="reset.title"></span></div><div id="loginpage" class="h375" flex="100"><form ng-show="!vm.success" name="resetForm" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="loginContent caps signInContent" data-translate="reset.finish.title"></div><div class="loginSubDiv" layout="column" flex="100"><div><input type="password" class="textboxcolor w100p" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-class="{ \'has-error\' : (resetForm.$submitted && resetForm.password.$error.required)}" ng-minlength="4" ng-maxlength="50" required><div ng-messages="resetForm.password.$dirty && resetForm.password.$invalid"><div ng-if="resetForm.password.$error.required && resetForm.$submitted" data-translate="global.messages.validate.newpassword.required" class="errorMsg"></div><div ng-if="resetForm.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength" class="errorMsg"></div><div ng-if="resetForm.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength" class="errorMsg"></div></div><password-strength-bar class="mt10 resetDirective" password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="subDiv"></div><div class="user" layout="column"><input type="password" class="textboxcolor" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-class="{ \'has-error\' : (resetForm.$submitted && resetForm.confirmPassword.$error.required)}" ng-minlength="4" ng-maxlength="50" required><div ng-messages="resetForm.confirmPassword.$dirty && resetForm.confirmPassword.$invalid"><div ng-if="resetForm.confirmPassword.$error.required && resetForm.$submitted" data-translate="global.messages.validate.confirmpassword.required" class="errorMsg"></div><div ng-if="resetForm.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength" class="errorMsg"></div><div ng-if="resetForm.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength" class="errorMsg"></div></div></div></div><div class="signInDiv mt25"><md-button type="submit" id="loginButton" layout-align="center center"><span layout="row" layout-align="center"><md-progress-circular md-mode="indeterminate" ng-show="vm.activated" class="md-hue-2" md-diameter="20px"></md-progress-circular><span class="mlt5" ng-class="{mr20 : vm.activated}" data-translate="reset.finish.resetButton"></span></span></md-button></div><div class="errorDiv alert ptop20" ng-show="vm.keyMissing" data-translate="reset.finish.messages.keymissing"></div><div class="errorDiv alert ptop20" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch"></div><div class="errorDiv alert ptop20" ng-show="vm.error" data-translate="reset.finish.messages.error"></div></form><div ng-show="vm.success" layout="column" layout-margin layout-align="center center"><div layout="column" class="mt45"><div class="warnImage"><img src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center" class="pl25 pr25"><div class="confirmWarn tc-white"><span data-translate="reset.finish.messages.resettes"></span></div><div class="WarnSub tc-white"><span data-translate="reset.finish.messages.successMsg"></span></div></div><div layout="row" id="loginButton" class="w150"><span class="caps pt10 textCenter w100p" data-translate="reset.finish.messages.successLink"></span></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<!-- <div>\n    <div class="row">\n        <div class="col-md-8 col-md-offset-2">\n            <h1 data-translate="reset.request.title">Reset your password</h1>\n\n            <div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists">\n                <strong>E-Mail address isn\'t registered!</strong> Please check and try again.\n            </div>\n\n            <div class="alert alert-warning" ng-hide="vm.success">\n                <p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p>\n            </div>\n\n            <div class="alert alert-success" ng-show="vm.success == \'OK\'">\n                <p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p>\n            </div>\n\n            <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation>\n                <div class="form-group">\n                    <label class="control-label" for="email" data-translate="global.form.email">E-mail</label>\n                    <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}"\n                           ng-model="vm.resetAccount.email" ng-minlength=5 ng-maxlength=100 required>\n                    <div ng-show="form.email.$dirty && form.email.$invalid">\n                        <p class="help-block"\n                           ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">\n                            Your e-mail is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">\n                            Your e-mail is invalid.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">\n                            Your e-mail is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">\n                            Your e-mail cannot be longer than 100 characters.\n                        </p>\n                    </div>\n                </div>\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button>\n            </form>\n\n        </div>\n    </div>\n</div> --><div class="centerAlign"><div layout="column" flex layout-align="center center"><img class="cred-logo" src="content/images/mlb_logo.svg"> <span class="logoContent" data-translate="reset.title"></span></div><div id="loginpage" flex="100"><form ng-show="!vm.success" name="resetRequestForm" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="loginContent caps signInContent" data-translate="reset.finish.title"></div><div class="resetDirective textAlignCenter" data-translate="reset.request.messages.emailInfo"></div><div class="loginSubDiv" layout="column" flex="100"><div class="subDiv"></div><div class="user" layout="column"><input type="email" class="textboxcolor" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-class="{ \'has-error\' : (resetForm.$submitted && resetForm.email.$error.required)}" ng-minlength="4" ng-maxlength="50" required><div ng-messages="resetRequestForm.email.$dirty && resetRequestForm.email.$invalid"><div ng-if="resetRequestForm.email.$error.required && resetRequestForm.$submitted" data-translate="global.messages.validate.email.required" class="errorMsg"></div><div ng-if="resetRequestForm.email.$error.email" data-translate="reset.request.messages.validEmail" class="errorMsg"></div><div ng-if="resetRequestForm.email.$error.minlength" data-translate="global.messages.validate.email.minlength" class="errorMsg"></div><div ng-if="resetRequestForm.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength" class="errorMsg"></div></div></div></div><div class="signInDiv mt25"><md-button type="submit" id="loginButton" layout-align="center center"><span layout="row" layout-align="center" class="mlt5" ng-class="{mr20 : vm.activated}" data-translate="reset.request.form.submit"></span></md-button></div><div><span data-translate="reset.request.messages.signinLink"></span></div><div class="errorDiv alert ptop20" ng-show="vm.errorEmailNotExists" data-translate="reset.request.messages.notfound"></div></form><div ng-show="vm.success == \'OK\'" layout="column" layout-margin layout-align="center center"><div class="resetDirective textAlignCenter mt140" data-translate="reset.request.messages.success"></div></div></div></div>');
$templateCache.put('app/investigation/prospects/assign/assign.html','<div class="hide"><div id="assignConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex ng-hide="vm.assinerRepeat" class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><ng-letter-avatar shape="round" height="89px" width="89px" dynamic="true" data="{{ vm.data.firstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div layout="column" layout-align="center center"><div class="confirmAssign"><span ng-if="(!isReassign) && (investigatorPopup == 1)" data-translate="prospects.assignInvestigator.assignInvestigatorTitle"></span> <span ng-if="(!isReassign) && (investigatorPopup == 0)" data-translate="prospects.assignInvestigator.assignAnalystTitle"></span> <span ng-if="(isReassign) && (investigatorPopup == 1)" data-translate="prospects.assignInvestigator.reAssignInvestigatorTitle"></span> <span ng-if="(isReassign) && (investigatorPopup == 0)" data-translate="prospects.assignInvestigator.reAssignAnalystTitle"></span></div><div class="assignSub"><span data-translate="prospects.assignInvestigator.firstHalfLine"></span> <span ng-if="!isReassign" data-translate="prospects.assignInvestigator.assign"></span> <span ng-if="isReassign" data-translate="prospects.assignInvestigator.reassign"></span> <span ng-if="isReassign">{{reassignFiratName}} {{reassignLastName}}\'s</span> <span ng-if="(isReassign) && (investigatorPopup == 1)" data-translate="prospects.assignInvestigator.investigatorForm"></span> <span ng-if="(isReassign) && (investigatorPopup == 0)" data-translate="prospects.assignInvestigator.analystForm"></span> <span ng-if="isReassign" data-translate="prospects.assignInvestigator.to"></span> <span ng-bind-template="{{vm.data.firstName}} {{vm.data.lastName}}" class="capitalize"></span> <span ng-if="isReassign" data-translate="prospects.assignInvestigator.dot"></span> <span ng-if="!isReassign" data-translate="prospects.assignInvestigator.asAn"></span> <span ng-if="(!isReassign) && (investigatorPopup == 1)" data-translate="prospects.assignInvestigator.investigator"></span> <span ng-if="(!isReassign) && (investigatorPopup == 0)" data-translate="prospects.assignInvestigator.analyst"></span> <span ng-if="!isReassign" data-translate="prospects.assignInvestigator.secondHalfLine"></span> <span ng-if="vm.data.userRole != \'NON-DR INVESTIGATOR\'" ng-bind-template="{{vm.data.firstName}} {{vm.data.lastName}}" class="capitalize"></span> <span ng-if="vm.data.userRole != \'NON-DR INVESTIGATOR\'" data-translate="prospects.assignInvestigator.secondLine"></span> <span ng-if="investigatorPopup == 1 && vm.data.userRole != \'NON-DR INVESTIGATOR\'" data-translate="prospects.assignInvestigator.investigatorForm"></span> <span ng-if="investigatorPopup == 0 && vm.data.userRole != \'NON-DR INVESTIGATOR\'" data-translate="prospects.assignInvestigator.analystForm"></span></div><div class="mt50 fz18 textCenter"><span ng-if="(isReassign) && (investigatorPopup == 1) && vm.test.userRole == vm.APP.GLOBAL.EXTERNALINVESTIGATOR" data-translate="prospects.assignInvestigator.existingForm"></span> <span data-translate="prospects.assignInvestigator.proceed"></span></div></div><div layout="column"><md-button ng-if="!isReassign" ng-disabled="vm.assignDisableFlag" class="assign md-raised md-primary" ng-click="investigatorPopup == 1 ? vm.assignee($event,vm.data.id,\'assignInvestigatorPopup\') : vm.assignee($event,vm.data.id,\'assignAnalystPopup\')" data-translate="prospects.common.assign"></md-button><md-button ng-if="isReassign" ng-disabled="vm.assignDisableFlag" class="assign md-raised md-primary" ng-click="investigatorPopup == 1 ? vm.assignee($event,vm.data.id,\'assignInvestigatorPopup\') : vm.assignee($event,vm.data.id,\'assignAnalystPopup\')" data-translate="prospects.common.reAssign"></md-button><md-button ng-if="!isReassign" ng-disabled="vm.assignDisableFlag" ng-click="investigatorPopup == 1 ? vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'INVESTIGATOR\',0) : vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'ANALYST\',0)" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button><md-button ng-if="isReassign" ng-disabled="vm.assignDisableFlag" ng-click="investigatorPopup == 1 ? vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'INVESTIGATOR\',\'\',isReassign) : vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'ANALYST\',\'\',isReassign)" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div><div layout="row" flex class="m50imp" ng-if="vm.assinerRepeat"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center" class="assignSub"><div><span data-translate="prospects.assignInvestigator.alreadyInvestigator1" ng-if="!vm.analystAssignerRepeat && !vm.isAnalystAssigned"></span></div><div><span data-translate="prospects.assignInvestigator.alreadyAnalyst1" ng-if="vm.analystAssignerRepeat && !vm.isAnalystAssigned"></span></div><div><span data-translate="prospects.assignInvestigator.alreadyInvestigator2" ng-if="!vm.analystAssignerRepeat && !vm.isAnalystAssigned"></span></div><div><span data-translate="prospects.assignInvestigator.alreadyAnalyst2" ng-if="vm.analystAssignerRepeat && !vm.isAnalystAssigned"></span></div><div><span data-translate="prospects.assignInvestigator.analystAssigned" ng-if="vm.isAnalystAssigned"></span></div></div><div layout="column"><md-button ng-if="vm.isAnalystAssigned" ng-click="vm.closeResult();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.ok"></md-button><md-button ng-if="!isReassign && !vm.isAnalystAssigned" ng-click="investigatorPopup == 1 ? vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'INVESTIGATOR\',0) : vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'ANALYST\')" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button><md-button ng-if="isReassign && !vm.isAnalystAssigned" ng-click="investigatorPopup == 1 ? vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'INVESTIGATOR\',0,\'\',isReassign) : vm.openAssignPopup($event,\'assignInvestigatorPopup\',\'ANALYST\',0,\'\',isReassign)" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/assign/assignAnalyst.html','<div class="hide"><div id="assignAnalystPopup" class="md-dialog-container"><md-dialog><div class="modal-body"><md-dialog-content><div layout="row"><div class="bgk" flex="30"><div class="padding10 marginLeft20" layout="column"><div layout="column"><div layout="row" class="formUserName">ARGENIS MAURICIO SILVANIO</div><div layout="row" class="contractInvestigation">CONTRACT INVESTIGATION</div></div><md-divider class="dividerline"></md-divider><div ng-repeat="Det in vm.details"><div layout="column" ng-repeat="(key,value) in Det.Value"><div class="formStyle padding25">{{key}}</div><div class="formvalue">{{value}}</div></div></div></div></div><div class="padding15 marginLeft40" flex="70" layout="column"><div layout-margin>ASSIGN ANALYST</div><div layout="row"><div flex="50" layout="column"><!-- <i class="material-icons searchdiv">search</i> --><md-input-container md-no-float class="md-block drop-search"><i class="material-icons left-drop-icon">search</i> <input name="assignAnalystSearchKey" class="left-drop-search" ng-model="assignAnalystSearchKey" ng-minlength="2" placeholder="Search Analysts" type="search" search-callback="vm.searchAnalystorInvestigator(assignAnalystSearchKey,\'LARI_ANALYST\')"></md-input-container></div><div flex="50" layout="column"><md-select ng-model="role" ng-change="vm.searchAnalystorInvestigator(false,role)" placeholder="ROLES"><md-option ng-repeat="roles in vm.roles" ng-value="roles">{{roles}}</md-option></md-select></div></div><div class="scroll"><div layout="column" class="investigationContainer" ng-repeat="analysts in assignInvestigatorVO | filter:assignAnalystSearchKey"><div ng-mouseenter="options=true" ng-mouseleave="options=false" class="colum" layout="row" flex class="md-whiteframe-1dp" ng-click="vm.assign(analysts,$event,\'assignConformPopup\')"><div flex="" layout="row" layout-margin><div><ng-letter-avatar shape="round" height="41px" width="41px" data="{{ analysts.firstName | limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="" layout="column"><a><span ng-bind="analysts.firstName"></span> <span class="pl5" ng-bind="analysts.lastName"></span></a><div class="investigationsType" hide-xs><span ng-bind="analysts.country"></span></div></div><div layout-margin-xl layout-padding-xl layout-align="end start"><div class="common caps" hide-xs ng-class="{\'color-red\': analysts.caseCount >= 15,\'color-yellow\': analysts.caseCount <15,\'color-grey\': analysts.caseCount <=10}" ng-hide="options">Open <span ng-bind="analysts.caseCount"></span> Cases</div><div ng-show="options" class="color-green">Assign to case</div></div></div></div></div></div></div></div></md-dialog-content></div></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/assign/assignInvestigator.html','<div class="hide"><div id="assignInvestigatorPopup" class="md-dialog-container"><md-dialog class="popup assignWidth"><div><md-dialog-content><div layout="row" layout-xs="column"><md-sidenav class="md-sidenav-left bgk" md-component-id="popupLeft" md-whiteframe="4" md-is-open="isSidenavOpen"><div class="assignInvPadding bgk" layout="row" layout-xs="column"><div><div class="formUserName">{{vm.profileData.firstName}} {{vm.profileData.lastName}}</div><div class="contractInvestigation" data-translate="prospects.{{vm.profile.openInvestigationList[0].investigationTypeName}}"></div></div><md-divider class="divid"></md-divider><div><div class="formStyle padding25" data-translate="prospects.assignInvestigator.birthLocation"></div><div class="formvalue">{{vm.profileData.birthCountryText}}</div></div><div><div class="formStyle padding25" data-translate="prospects.assignInvestigator.homeLocation"></div><div class="formvalue">{{vm.profileData.homeCountryTxt}}</div></div></div></md-sidenav><div class="assignInvPadding bgk" flex="30" flex-xs="0" layout-xs="column" hide-xs><div><div class="formUserName">{{vm.profileData.firstName}} {{vm.profileData.lastName}}</div><div class="contractInvestigation" data-translate="prospects.{{vm.profile.openInvestigationList[0].investigationTypeName}}"></div></div><md-divider hide-xs class="divid"></md-divider><div hide-xs><div class="formStyle padding25" data-translate="prospects.assignInvestigator.birthLocation"></div><div class="formvalue">{{vm.profileData.birthCountryText}}</div></div><div hide-xs><div class="formStyle padding25" data-translate="prospects.assignInvestigator.homeLocation"></div><div class="formvalue">{{vm.profileData.homeCountryTxt}}</div></div></div><div flex="70" flex-xs="0" ng-model="id" class="margin50 addInvestigator"><div class="popupDiv"><div layout="row" layout-align="space-between"><div ng-if="investigatorPopup == 1" class="assgnInv" data-translate="prospects.assignInvestigator.investigatorTitle"></div><div ng-if="investigatorPopup == 0" class="assgnInv" data-translate="prospects.assignInvestigator.analystTitle"></div><div ng-click="cancel()" class="mt5"><i class="material-icons popupclose">close</i></div></div><div layout="row" layout-xs="column"><div flex><md-input-container md-no-float class="md-block"><i class="material-icons left-drop-icon">search</i> <input flex-order="2" no-special-char common-search search-callback="vm.searchAssign(searchInvObj.assignInvestigatorSearchKey)" name="assignInvestigatorSearchKey" id="assignInvestigatorSearchKey" class="left-drop-search" ng-model="searchInvObj.assignInvestigatorSearchKey" placeholder="{{media(\'xs\') ? (\'dashboard.search.mobileSearch\' | translate): (\'dashboard.search.searchTabIcon\' | translate)}}" type="search"></md-input-container></div><div flex layout-xs="row"><md-select ng-model="vm.userAssign.role" ng-change="vm.updateAssignUserFilterObjList(\'userRoleKey\',\'role\');vm.searchAnalystorInvestigator();" placeholder="{{role.id == undefined ? \'Roles\' : role.userRole}}" class="width100"><md-option ng-if="(investigatorPopup == 0 && roles.userRole != vm.APP.GLOBAL.INVESTIGATOR) || investigatorPopup == 1" ng-repeat="roles in vm.rolesList | filter : {userRole : \'!\' + \'Read Only\'}" ng-value="roles" class="mt12"><span ng-if="roles.userRole != vm.APP.GLOBAL.INVESTIGATOR" ng-bind="roles.userRole" data-translate="prospects.assignAdmin.{{roles.userRole}}"></span> <span ng-if="roles.userRole == vm.APP.GLOBAL.INVESTIGATOR" data-translate="prospects.assignInvestigator.investigatorAssign"></span></md-option></md-select></div><!-- <div flex=50 layout="column">\n\t\t\t\t\t\t\t\t\t\t<md-select ng-model="assignInvestigatorAssign" placeholder="City">\n\t\t\t\t\t\t\t\t\t\t<md-option ng-repeat="ass in vm.assigns.Assigneds" ng-value="ass">\n\t\t\t\t\t\t\t\t\t\t{{ass}} </md-option> </md-select>\n\t\t\t\t\t\t\t\t\t</div> --></div><div layout="row" layout-align="end end" class="pt5" hide-gt-xs><md-button ng-click="vm.togglepopupLeft()" class="md-fab fab">+</md-button></div></div><div class="scroll scrollableList" resize-popup style="max-height:{{windowHeight - 240 +\'px\'}};"><div class="investigationContainer" ng-scroll-repeat="investigators in assignInvestigatorVO | filter:assignInvestigatorSearchKey | filter:assignInvestigatorAssign track by $index" page-size="10" tolerance="200"><div ng-mouseenter="options=true" ng-mouseleave="options=false" class="colum" layout="row" flex class="md-whiteframe-1dp" ng-click="vm.assign(investigators,$event,\'assignConformPopup\')"><div flex="" layout="row" layout-margin><div><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ investigators.firstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex><div class="InvestigatorName" layout="row" layout-wrap><div ng-bind="investigators.firstName"></div><div class="pl5" ng-bind="investigators.lastName"></div></div><div class="investigationsType"><span ng-bind="investigators.country"></span></div><!-- <div hide-gt-xs class="common caps" ng-class="{\'color-red\': investigators.caseCount >= 15,\'color-yellow\': investigators.caseCount <15,\'color-grey\': investigators.caseCount <=10}">Open \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="investigators.caseCount"></span> Cases\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div> --></div><div layout-margin-xl layout-padding-xl layout-align="end start"><div hide-gt-xs class="common caps assignListWidth" ng-class="{\'color-red\': investigators.caseCount >= 15,\'color-yellow\': investigators.caseCount <15,\'color-grey\': investigators.caseCount <=10}"><span ng-bind="investigators.caseCount"></span> <span data-translate="prospects.common.cases"></span></div><div hide-xs class="common caps" ng-class="{\'color-red\': investigators.caseCount >= 15,\'color-yellow\': investigators.caseCount <15,\'color-grey\': investigators.caseCount <=10}" ng-hide="options"><span ng-bind="investigators.caseCount"></span> <span data-translate="prospects.common.cases"></span> <span data-translate="prospects.common.open"></span></div><div hide-xs ng-show="options" class="color-green" data-translate="prospects.assignInvestigator.assignToCase"></div></div></div></div></div><div ng-if="vm.assignInvestigatorLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div class="h60p" ng-if="!vm.assignInvestigatorLoader && assignInvestigatorVO.length == vm.listTotalLength && vm.noMoreInvestigators" layout="row" layout-align="center center"><span class="caps" data-translate="prospects.assignInvestigator.noMoreResults"></span></div><div class="h60p" ng-if="!vm.assignInvestigatorLoader && assignInvestigatorVO.length == 0 && vm.noInvestigators" layout="row" layout-align="center center"><span class="caps" data-translate="prospects.assignInvestigator.noResults"></span></div></div></div></div></md-dialog-content></div></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/assign/delete.investigtaion.form.popup.html','<div class="hide"><div id="deleteInvestigator" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteInvestigatorForm"></span> <span ng-if="investigatorPopup == 1" data-translate="prospects.assignInvestigator.investigatorForm"></span> <span ng-if="investigatorPopup == 0" data-translate="prospects.assignInvestigator.analystForm"></span> <span data-translate="prospects.Warning.questionmark"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row" ng-hide="vm.errorFormCompletedFlag"><md-button ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-disabled="vm.deleteDisableFlag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteConfirm();" data-translate="prospects.common.delete"></md-button></div><div layout="row" ng-show="vm.errorFormCompletedFlag"><md-button ng-click="vm.closeResult();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.ok"></md-button></div></div><div layout-align="center" class="textCenter" ng-show="vm.errorInvestigatorFlag"><span class="WarnSub errorMsg" data-translate="prospects.Warning.cannotDelete"></span></div><div layout-align="center" class="textCenter" ng-show="vm.errorFormCompletedFlag"><span class="WarnSub errorMsg" ng-if="!vm.isAnalystForm" data-translate="prospects.Warning.formSubmitted"></span> <span class="WarnSub errorMsg" ng-if="vm.isAnalystForm" data-translate="prospects.Warning.analystFormSubmitted"></span></div></div></md-dialog-content></md-dialog></div><!-- Send back to analyst (or) investigator popup --><div id="sentToAnalyst" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center" class="fz20 mb30 textcenter"><div ng-show="vm.reopenAnalystFlag"><span data-translate="prospects.Warning.sentToAnalyst"></span></div><div ng-show="!vm.reopenAnalystFlag"><span data-translate="prospects.Warning.sentToInvestigator"></span></div></div><div layout="row"><md-button ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-disabled="vm.sendBackDisableFlag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.sentToAnalystConfirm();" data-translate="prospects.common.send"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Send to RC popup --><div id="sentToRC" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center" class="fz20 mb30 textcenter"><span data-translate="prospects.Warning.sendToRC"></span> <span><span data-translate="prospects.{{investigationToStatus}}"></span> <span data-translate="prospects.Warning.questionmark"></span></span></div><div layout="row"><md-button ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-disabled="vm.sendToRCDisableFlag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.sentToRC();" data-translate="prospects.common.send"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Send to eBis popup --><div id="sentToeBis" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center" class="fz20 mb30 textcenter"><span ng-if="isRCResult == 0" data-translate="prospects.Warning.sendToeBis"></span> <span ng-if="isRCResult == 1" data-translate="prospects.Warning.sendToeBisRCResult"></span></div><div layout="row" ng-hide="vm.eBisResultLoader"><md-button ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.sentToeBis($event);" data-translate="prospects.common.send"></md-button></div></div></div><div ng-show="vm.eBisResultLoader" class="mb50" layout-align="center center"><div class="mb10 textcenter">Sending results to eBis....</div><md-progress-linear ng-show="vm.eBisResultLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></md-dialog-content></md-dialog></div><!-- Send to eBis success popup --><div id="sentToeBisSuccess" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column">{{erroreBisFlag}}<div ng-if="vm.erroreBisFlag" class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div><div ng-if="!vm.erroreBisFlag" class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center" class="fz18 mb30 textcenter"><span ng-bind="vm.errorMsg"></span></div><div layout="row"><md-button class="formSubmit md-raised md-primary" ng-click="vm.closeResult();" data-translate="prospects.common.ok"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Delete RC Meeting Popup --><div id="deleteRC" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteRC"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-disabled="vm.deleteRCDisableFlag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteRCSessionConfirm();" data-translate="prospects.common.delete"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- ByPass Investigation Form popup --><div id="byPassConfirmation" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div ng-if="!vm.bypassSuccessFlag" class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div><div ng-if="vm.bypassSuccessFlag" class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center" class="fz20 mb30 textcenter"><span ng-if="!vm.bypassSuccessFlag" data-translate="prospects.Warning.bypassInvestigationForm"></span> <span ng-if="vm.bypassSuccessFlag" data-translate="prospects.assignInvestigator.byPassInvestigationSuccess"></span></div><div layout="row" ng-hide="vm.bypPassLoader"><md-button ng-if="!vm.bypassSuccessFlag" ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-if="!vm.bypassSuccessFlag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.byPassInvestigationForm();" data-translate="prospects.Warning.submit"></md-button><md-button ng-if="vm.bypassSuccessFlag" class="formSubmit md-raised md-primary" ng-click="vm.cancelBypass();" data-translate="prospects.common.ok"></md-button></div></div></div><div ng-show="vm.bypPassLoader" class="mb50" layout-align="center center"><div class="mb10 textcenter" data-translate="prospects.Warning.bypassLoaderText"></div><md-progress-linear ng-show="vm.bypPassLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></md-dialog-content></md-dialog></div><div id="investigatorFormDeleted" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span ng-if="!vm.isAnalystForm" data-translate="prospects.Warning.formDeleted"></span> <span ng-if="vm.isAnalystForm" data-translate="prospects.Warning.analystFormDeleted"></span></div></div><div layout="row"><md-button ng-if="!vm.goInvestigation" ng-click="vm.closeForm($event);" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.ok"></md-button><md-button ng-if="vm.goInvestigation" ng-click="vm.gokToInvestigation();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.ok"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Non-Registered Investigator\'s Investigation Confirmation Popup --><div id="submitConfirmation" class="md-dialog-container"><md-dialog class="warningPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div ng-if="!vm.submitInvestigatorFlag" class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div><div ng-if="vm.submitInvestigatorFlag" class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center" class="fz20 mb30 textcenter"><span ng-if="!vm.submitInvestigatorFlag" data-translate="prospects.Warning.nonInvestigatorSubmit"></span> <span ng-if="vm.submitInvestigatorFlag" data-translate="prospects.Warning.nonInvestigatorSubmitSuccess"></span> <span ng-if="vm.submitInvestigatorFlagError" data-translate="prospects.Warning.nonInvestigatorSubmitError" class="errorMsg"></span></div><div layout="row" ng-hide="vm.submitInvestigatorLoader"><md-button ng-if="!vm.submitInvestigatorFlag" ng-click="vm.cancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-if="!vm.submitInvestigatorFlag" ng-click="vm.completeInvestigation(vm.assignObj)" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" data-translate="prospects.Warning.submit"></md-button><md-button ng-if="vm.submitInvestigatorFlag" ng-click="vm.cancelBypass();" class="formSubmit md-raised md-primary" data-translate="prospects.common.ok"></md-button></div></div></div><div ng-show="vm.submitInvestigatorLoader" class="mb50" layout-align="center center"><div class="mb10 textcenter" data-translate="prospects.Warning.nonInvestigatorSubmitLoaderText"></div><md-progress-linear ng-show="vm.submitInvestigatorLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/activity/activity.html','<div ng-class="{activitypad:media(\'gt-xs\')}" resize style="overflow-y:auto; overflow-x:hidden;" ng-style="{\'height\':windowHeight-48 + \'px\'}"><div ng-show="vm.activityLoader"><md-progress-linear class="countListLoad" ng-show="vm.activityLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><!-- ng-show="!vm.activityLoader" --><div style="margin-top: 50px;"><div layout="column" layout-align="start start" ng-repeat="activity in vm.activity.investigationActivity" class="ml12"><div layout="column" layout-align="start center"><div ng-if="!$first" class="box-content divider"></div><div class="act-sub-header"><span class="activityDateMapBG activityDateMap"><span data-translate="dashboard.month.{{activity.month}}"></span> <span data-translate="{{activity.day}}"></span> <span data-translate="{{activity.year}}"></span></span></div><div class="box-content divider"></div></div><div class="w99p act-mdlist bgColorWh md-whiteframe-1dp"><md-list><md-list-item class="md-3-line" ng-repeat="activityDetail in activity.investigationActivityList | orderBy:\'time\':true " ng-if="activityDetail.status != vm.APP.REF_TERM.FORM_SUBMIT"><div class="md-list-item-text"><div hide-xs layout="row"><div class="p20 activityDateTime" ng-bind="activityDetail.time |date:\'shortTime\'"></div><!-- <div class="p20 activityDateTime" ng-bind="activityDetail.time == null ? (activityDetail.rcCreatedOn | date:\'shortTime\') : \'\' "></div> --><div><img src="content/images/profile.png" class="md-avatar" style="width:32px;height:32px;"></div><div flex="85"><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS && activityDetail.status != vm.APP.REF_TERM.FORM_SUBMIT" class="activityAssigner" ng-bind-template="{{activityDetail.assignerFirstName}} {{activityDetail.assignerLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assignerFirstName.toLowerCase()}} {{activityDetail.assignerLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole != vm.APP.GLOBAL.ROLE_USER" class="activityAssigner" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER" class="activityAssigner" ng-bind-template="{{activityDetail.assignerFirstName}} {{activityDetail.assignerLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assignerFirstName.toLowerCase()}} {{activityDetail.assignerLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS" class="activityAssigner" ng-bind="activityDetail.createdBy"></div><!-- class="activityAssigner camelCase" ng-bind="activityDetail.createdBy"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && (activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.DELETED || \n\t\t\t\t\t\t\t\t\tactivityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.UPDATED || activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.ADDED)" class="activityAssigner" ng-bind="activityDetail.rcUserName"></div><!-- class="activityAssigner camelCase" ng-bind="activityDetail.rcUserName.toLowerCase()"></div> --><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CREATED" class="activityAssigner" ng-bind="activityDetail.requestedBy"></div><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && ( \n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGINVESTIGATOR || activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDERINVESTIGATION ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGANALYST || activityDetail.status == vm.APP.INVESTIGATION_STATUS.ANALYSTREVIEW ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.MANAGERREVIEW || activityDetail.status == vm.APP.INVESTIGATION_STATUS.REOPEN ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_READY || activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_TABLED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.CONFIRMED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.FAILED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDETERMINED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.WAIVED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.NA)" class="activityAssigner" ng-bind="activityDetail.createdBy"></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.DELETED" class="activityStatusChange pt5"><span data-translate="activity.Deleted"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.UPDATED" class="activityStatusChange"><span ng-bind="activityDetail.rcActivity" data-translate="activity.Updated"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span><div layout="row" class="mt5 rcActivity"><div flex="25" class="rcActivity" data-translate="activity.ageResult"></div><div flex="25" class="rcActivity" data-translate="activity.idResult"></div><div flex="25" class="rcActivity" data-translate="activity.date"></div><div flex class="rcActivity" data-translate="activity.notes"></div></div><div layout="row" class="mt5 rcActivity"><div flex="25" class="grncolor caps rcActivity"><div ng-if="activityDetail.rcAgeResult != null"><div data-translate="activity.{{activityDetail.rcAgeResult.toLowerCase()}}"></div></div><div ng-if="activityDetail.rcAgeResult == null"><div data-translate="\'-\'"></div></div></div><div flex="25" class="grncolor caps rcActivity"><div ng-if="activityDetail.rcIdentityResult != null"><div data-translate="activity.{{activityDetail.rcIdentityResult.toLowerCase()}}"></div></div><div ng-if="activityDetail.rcIdentityResult == null"><div data-translate="\'-\'"></div></div></div><div flex="25" class="grncolor camelCase nowrap" ng-bind="activityDetail.rcAssignmentDate != null ? (activityDetail.rcAssignmentDate | date) : \'-\'"></div><div flex ng-if="activityDetail.rcCommentEdited == true" class="grncolor camelCase rcActivity" data-translate="activity.notesUpdated"></div><div flex ng-if="activityDetail.rcCommentEdited == false" class="grncolor camelCase rcActivity">-</div></div></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.ADDED" class="activityStatusChange pt5"><span data-translate="activity.Added"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS"><span data-translate="activity.deletedineBis"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGINVESTIGATOR"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDERINVESTIGATION"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGANALYST"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ANALYSTREVIEW"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.MANAGERREVIEW"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REOPEN"><span data-translate="activity.reopen"></span> <span class="grncolor camelCase" data-translate="activity.investigationStatusReopen"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_SELECTED"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_READY"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_TABLED"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CONFIRMED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult" data-translate="activity.{{activityDetail.investigationAgeResult}}"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult" data-translate="activity.{{activityDetail.investigationIdResult}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.FAILED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult" data-translate="activity.{{activityDetail.investigationAgeResult}}"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult" data-translate="activity.{{activityDetail.investigationIdResult}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDETERMINED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult" data-translate="activity.{{activityDetail.investigationAgeResult}}"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult" data-translate="activity.{{activityDetail.investigationIdResult}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.WAIVED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult" data-translate="activity.{{activityDetail.investigationAgeResult}}"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult" data-translate="activity.{{activityDetail.investigationIdResult}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.NA"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.BYPASSED"><span ng-bind="activityDetail.status" data-translate="activity.ByPassed"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span ng-bind="activityDetail.formType" data-translate="activity.{{activityDetail.formType}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER && !activityDetail.isCompletedByAnotherUser"><span data-translate="activity.completed"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.investigationForm"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER && activityDetail.isCompletedByAnotherUser"><span data-translate="activity.Submitted"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span ng-bind="activityDetail.formType" data-translate="activity.{{activityDetail.formType}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole != vm.APP.GLOBAL.ROLE_USER" class="activityStatusChange pt5"><span data-translate="activity.Submitted"></span> <a class="grncolor" ng-bind="activityDetail.formType" data-translate="activity.{{activityDetail.formType}}"></a></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ASSIGNED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.Assigned"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asananalyst"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SENDBACK_ANALYST" class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asananalyst"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SENDBACK_INVESTIGATOR" class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.{{activityDetail.status}}"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asaninvestigator"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REASSIGN" class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.Reassign"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ASSIGNED && activityDetail.formType === \'Investigator Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.ASSIGNED"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asaninvestigator"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REMOVED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REMOVED && activityDetail.formType === \'Investigator Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVISIED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span data-translate="activity.submittedby"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVISIED && activityDetail.formType === \'Investigator Report\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span data-translate="activity.submittedby"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CREATED" class="activityStatusChange pt5"><span class="grncolor" data-translate="activity.investigation"></span> <span ng-bind="activityDetail.status"></span> <span data-translate="activity.by"></span> <span class="grncolor" ng-bind="activityDetail.createdBy" data-translate="activity.{{activityDetail.createdBy}}"></span></div><div ng-if="activityDetail.status == vm.APP.REF_TERM.FORM_SAVE || activityDetail.status == vm.APP.REF_TERM.FORM_SECTION_SAVE || \n\t\t\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.REF_TERM.FORM_COPY || activityDetail.status == vm.APP.REF_TERM.FORM_ATTACHMENT_ADD || activityDetail.status == vm.APP.REF_TERM.FORM_ATTACHMENT_DELETE"><span data-translate="activity.update"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}\'s"></span> <span ng-bind="activityDetail.formType" data-translate="activity.{{activityDetail.formType}}"></span></div></div></div><div hide-gt-sm hide-gt-xs show-xs layout="row" layout-align="center center"><div><img src="content/images/profile.png" class="md-avatar"></div><div layout="column" layout-fill layout-align="center"><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS" class="activityAssigner" ng-bind-template="{{activityDetail.assignerFirstName}} {{activityDetail.assignerLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assignerFirstName.toLowerCase()}} {{activityDetail.assignerLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole != vm.APP.GLOBAL.ROLE_USER" class="activityAssigner" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER" class="activityAssigner" ng-bind-template="{{activityDetail.assignerFirstName}} {{activityDetail.assignerLastName}}"></div><!-- class="activityAssigner camelCase" ng-bind-template="{{activityDetail.assignerFirstName.toLowerCase()}} {{activityDetail.assignerLastName.toLowerCase()}}"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && activityDetail.status != vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.status == vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS" class="activityAssigner" ng-bind="activityDetail.createdBy"></div><!-- class="activityAssigner camelCase" ng-bind="activityDetail.createdBy"></div> --><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && (activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.DELETED || \n\t\t\t\t\t\t\t\t\tactivityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.UPDATED || activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.ADDED)" class="activityAssigner" ng-bind="activityDetail.rcUserName"></div><!-- class="activityAssigner camelCase" ng-bind="activityDetail.rcUserName.toLowerCase()"></div> --><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CREATED" class="activityAssigner" ng-bind="activityDetail.requestedBy"></div><div ng-if="activityDetail.status != vm.APP.INVESTIGATION_STATUS.CREATED && ( \n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGINVESTIGATOR || activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDERINVESTIGATION ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGANALYST || activityDetail.status == vm.APP.INVESTIGATION_STATUS.ANALYSTREVIEW ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.MANAGERREVIEW || activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_READY || activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_TABLED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.CONFIRMED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.FAILED ||\n\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDETERMINED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.WAIVED || activityDetail.status == vm.APP.INVESTIGATION_STATUS.NA)" class="activityAssigner" ng-bind="activityDetail.createdBy"></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.DELETED" class="activityStatusChange pt5"><span ng-bind="activityDetail.rcActivity"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.UPDATED" class="activityStatusChange pt5"><span ng-bind="activityDetail.rcActivity"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span><div layout="row" class="mt7 rcActivity"><span flex="40" data-translate="activity.ageResultMBL"></span> <span flex class="grncolor caps" ng-bind="activityDetail.rcAgeResult != null ? activityDetail.rcAgeResult.toLowerCase() : \'-\'"></span></div><div layout="row" class="rcActivity"><span flex="40" data-translate="activity.idResultMBL"></span> <span flex class="grncolor caps" ng-bind="activityDetail.rcIdentityResult ? activityDetail.rcIdentityResult.toLowerCase() : \'-\'"></span></div><div layout="row" class="rcActivity"><span flex="40" data-translate="activity.dateMBL"></span> <span flex class="grncolor camelCase nowrap" ng-bind="activityDetail.rcAssignmentDate != null ? (activityDetail.rcAssignmentDate | date) : \'-\'"></span></div><div layout="row" class="rcActivity"><span flex="40" data-translate="activity.notesMBL"></span> <span flex ng-if="activityDetail.rcCommentEdited == true" class="grncolor camelCase nowrap" data-translate="activity.notesUpdated"></span> <span flex ng-if="activityDetail.rcCommentEdited == false">-</span></div></div><div ng-if="activityDetail.rcActivity == vm.APP.INVESTIGATION_STATUS.ADDED" class="activityStatusChange pt5"><span ng-bind="activityDetail.rcActivity"></span> <span class="grncolor camelCase" data-translate="activity.rcm"></span> <span class="grncolor camelCase" ng-bind="activityDetail.rcMeetingNumber"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.DELETEDINEBIS"><span data-translate="activity.deletedineBis"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGINVESTIGATOR"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDERINVESTIGATION"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.PENDINGANALYST"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ANALYSTREVIEW"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.MANAGERREVIEW"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_SELECTED"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_READY"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVIEWCOMMITTEE_TABLED"><span data-translate="activity.movedInvestigation"></span> <span class="grncolor camelCase" ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CONFIRMED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.FAILED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.UNDETERMINED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.WAIVED"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.NA"><span data-translate="activity.submitted1"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationAgeResult"></span> <span data-translate="activity.submitted2"></span> <span class="grncolor camelCase" ng-bind="activityDetail.investigationIdResult"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.BYPASSED"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span ng-bind="activityDetail.formType"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER && !activityDetail.isCompletedByAnotherUser"><span data-translate="activity.completed"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.investigationForm"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole == vm.APP.GLOBAL.ROLE_USER && activityDetail.isCompletedByAnotherUser"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span ng-bind="activityDetail.formType"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SUBMITTED && activityDetail.assigneeRole != vm.APP.GLOBAL.ROLE_USER" class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.Submitted"></span> <a class="grncolor" ng-bind="activityDetail.formType" data-translate="activity.{{activityDetail.formType}}"></a></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ASSIGNED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asananalyst"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SENDBACK_ANALYST" class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asananalyst"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.SENDBACK_INVESTIGATOR" class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asaninvestigator"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REASSIGN" class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.ASSIGNED && activityDetail.formType === \'Investigator Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status" data-translate="activity.ASSIGNED"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span> <span data-translate="activity.asaninvestigator"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVISIED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span data-translate="activity.submittedby"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REVISIED && activityDetail.formType === \'Investigator Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span data-translate="activity.submittedby"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.CREATED" class="activityStatusChange pt5"><span class="grncolor" data-translate="activity.investigation"></span> <span ng-bind="activityDetail.status"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REMOVED && activityDetail.formType === \'Analyst Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.INVESTIGATION_STATUS.REMOVED && activityDetail.formType === \'Investigator Form\' " class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span><!-- <span class="grncolor camelCase" ng-bind-template="{{activityDetail.assigneeFirstName.toLowerCase()}} {{activityDetail.assigneeLastName.toLowerCase()}}"></span> --> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}"></span></div><div ng-if="activityDetail.status == vm.APP.REF_TERM.FORM_SAVE || activityDetail.status == vm.APP.REF_TERM.FORM_SECTION_SAVE || \n\t\t\t\t\t\t\t\t\t\t\tactivityDetail.status == vm.APP.REF_TERM.FORM_COPY || activityDetail.status == vm.APP.REF_TERM.FORM_ATTACHMENT_ADD || activityDetail.status == vm.APP.REF_TERM.FORM_ATTACHMENT_DELETE"><span data-translate="activity.update"></span> <span class="grncolor" ng-bind-template="{{activityDetail.assigneeFirstName}} {{activityDetail.assigneeLastName}}\'s"></span> <span ng-bind="activityDetail.formType"></span></div></div><div flex="5"></div><div layout="row" layout-align="end center" flex="20" class="activityDateTime" ng-bind="activityDetail.time |date:\'shortTime\'"></div><!-- <div layout="row" layout-align="end center" flex="20" class="activityDateTime" ng-bind="activityDetail.time == null ? activityDetail.rcCreatedOn |date:\'shortTime\'"></div>\t --></div></div><md-divider></md-divider></md-list-item></md-list></div></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/openAnalystFormPopup.html','<div id="openAnalystFormPopupID" class="md-dialog-container"><md-dialog class="addEditPopup w561" ng-class="{popupMBL:mediaCheck(\'xs\')}"><form name="openAnalystForm" id="openAnalystFormId" novalidate ng-submit="vm.openSelectedForm(vm.openAnalystForm)"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="prospects.openAnalystFormPopup.title"></div></md-toolbar><md-dialog-content><div layout-padding class="m30 textCenter"><div class="fz20" data-translate="prospects.openAnalystFormPopup.contentLine1"></div><div class="assignSub w485" data-translate="prospects.openAnalystFormPopup.contentLine2"></div><md-select ng-change="vm.removeCheckBox()" ng-model-options="{trackBy: \'$value.id\'}" name="investigatorForm" ng-model="vm.openAnalystForm.investigatorForm" placeholder="{{vm.investigatorForm.id == undefined ? (\'prospects.openAnalystFormPopup.placeholder\' | translate) : (vm.investigatorForm.firstName)}}" class="popupFont w270 md-no-underline selectHeader dropdownSelection caps ofH border ml107 textLeft"><md-option ng-value="dropValue" ng-repeat="dropValue in vm.investigatorForm">{{dropValue.name}}</md-option></md-select><div layout="column" layout-align="center center"><div data-translate="prospects.openAnalystFormPopup.or" class="m10"></div><md-checkbox ng-click="vm.removeSelection()" ng-model="vm.openAnalystForm.analystForm.checked"><label data-translate="prospects.openAnalystFormPopup.newForm"></label></md-checkbox></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div layout="row" layout-align="center center"><div ng-if="vm.selectFlag" data-translate="prospects.openAnalystFormPopup.select" class="errorMsg mt15"></div><md-button class="saveOrClose caps color-red" ng-click="vm.cancel();" data-translate="prospects.openAnalystFormPopup.cancel"></md-button><md-button ng-disabled="!vm.openAnalystForm.analystForm.checked && vm.openAnalystForm.investigatorForm.id == null" type="submit" class="saveOrClose caps color-yellow buttonColor w110Imp" data-translate="prospects.openAnalystFormPopup.openForm"></md-button></div></md-dialog-actions></form></md-dialog></div>');
$templateCache.put('app/investigation/prospects/profile/profile.closedInvestigationList.html','<div layout="column" ng-if="vm.showCloseCases" ng-repeat="closeInv in vm.profile.closedInvestigationList" ng-class="{widthM35p:mediaCheck(\'sm\')}"><div layout="column" class="investigationLayout"><div><div class="contractHeader"><div layout="row" layout-xs="column"><div layout-padding><label class="md-title label letsp2p caps"><span data-translate="prospects.{{closeInv.investigationTypeName}}"></span></label><div class="dateDiv"><span data-translate="dashboard.month.{{closeInv.monthInvestigationDateOpened}}"></span> <span data-translate="{{closeInv.dayInvestigationDateOpened}}"></span> <span data-translate="{{closeInv.yearInvestigationDateOpened}}"></span></div></div></div><div layout="row" layout-align="space-between" layout-margin><div class="reviewDiv" ng-if="vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><label class="p4 f2" data-translate="prospects.{{closeInv.investigationStatus}}"></label></div><!-- manager review button: to send back the investigation status to manger review --><div class="openformbtnmr" ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_MANAGER  && vm.profile.openStatusCount == 0 && $last && closeInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.DELETED_IN_EBIS && closeInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.WAIVED_STATUS && closeInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.NA" ng-click="vm.reopenForm(closeInv.investigationId)"><label class="div cursorPointer" ng-class="{\'pt2MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.reopenInvestigation"></label></div></div></div><div layout-padding class="investigationDetailsMain mt30"><div class="md-subhead"><label class="label" ng-class="{\'ls0MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.investigationdetails.details.title"></label></div><div flex layout="row" layout-align="start" layout-align-xs="space-between start" layout-xs="column" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.dateopen"></label><div class="profileInvValue"><span data-translate="dashboard.month.{{closeInv.monthInvestigationDateOpened}}"></span> <span data-translate="{{closeInv.dayInvestigationDateOpened}}"></span> <span data-translate="{{closeInv.yearInvestigationDateOpened}}"></span></div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5" ng-init="vm.requestedList = closeInv.organisationAbbrevation;"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.requestedby"></label><!-- <div class="profileInvValue">{{closeInv.requestedBy}}</div> --><div layout="row"><!-- limitTo: A number, specifying how many elements to return: A number specifying where to begin the limitation. Default is 0 --><div ng-repeat="requestedopenInv in closeInv.organisationAbbrevation | limitTo:(mediaCheck(\'xs\')?vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT:vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT)"><div ng-class="{\'even\':$even, \'odd\':$odd}" class="circleRequest"><span class="colorWh circleLetter">{{requestedopenInv}}</span></div></div><div ng-if="vm.requestedList.length>0 && mediaCheck(\'xs\')? vm.requestedList.length > vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT : vm.requestedList.length > vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT"><div class="circleRequest inProgressCircle cursorP" popover-trigger="mouseenter" popover-placement="{{mediaCheck(\'xs\')?\'bottom-right\':\'right-top\'}}" uib-popover-template="\'app/investigation/prospects/profile/requestedclub.popover.html\'" type="button"><span class="colorBoldBlack circleLetter roboFont">+{{(mediaCheck(\'xs\')?(vm.requestedList.length - vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT):(vm.requestedList.length - vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT))}}</span></div></div></div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.agent_trainer"></label><div class="profileInvValue capitalize"><span ng-bind-template="{{closeInv.trainerFirstName}} {{closeInv.trainerLastName}}"></span></div></div></div><div flex layout="row" layout-xs="column" layout-align="start" layout-align-xs="space-between start" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.daysopen"></label><div class="profileInvValue">{{closeInv.investigationDaysOpened}}</div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.daysonstatus"></label><div class="profileInvValue">{{closeInv.statusOpenedDays}}</div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.status"></label><div class="profileInvValue"><span data-translate="prospects.{{closeInv.investigationStatus}}"></span></div></div></div><div flex ng-if="closeInv.isSentToEbis && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR" layout="row" layout-xs="column" layout-align="start" layout-align-xs="space-between start" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel caps" data-translate="prospects.reports.ageResult"></label><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':(closeInv.investigationAgeResult == vm.APP.REF_TERM.CONFIRMED || closeInv.investigationAgeResult == vm.APP.REF_TERM.FORM_CONFIRMED || closeInv.investigationAgeResult == vm.APP.REF_TERM.RC_CONFIRMED), \'redBg\':(closeInv.investigationAgeResult != vm.APP.REF_TERM.FORM_CONFIRMED || closeInv.investigationAgeResult != vm.APP.REF_TERM.RC_CONFIRMED)}"></div><div class="profileInvValue" data-translate="prospects.{{closeInv.investigationAgeResult}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.investigationdetails.details.on"></div><div class="ml5"><span data-translate="dashboard.month.{{closeInv.monthInvestigationResultStartTime}}"></span> <span data-translate="{{closeInv.dayInvestigationResultStartTime}}"></span> <span data-translate="{{closeInv.yearInvestigationResultStartTime}}"></span></div></div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel caps" data-translate="prospects.reports.idResult"></label><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':(closeInv.investigationIdentityResult == vm.APP.REF_TERM.CONFIRMED || closeInv.investigationIdentityResult == vm.APP.REF_TERM.FORM_CONFIRMED || closeInv.investigationIdentityResult == vm.APP.REF_TERM.RC_CONFIRMED), \'redBg\':(closeInv.investigationIdentityResult != vm.APP.REF_TERM.FORM_CONFIRMED || closeInv.investigationIdentityResult != vm.APP.REF_TERM.RC_CONFIRMED)}"></div><div class="profileInvValue" data-translate="prospects.{{closeInv.investigationIdentityResult}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.investigationdetails.details.on"></div><div class="ml5"><span data-translate="dashboard.month.{{closeInv.monthInvestigationResultStartTime}}"></span> <span data-translate="{{closeInv.dayInvestigationResultStartTime}}"></span> <span data-translate="{{closeInv.yearInvestigationResultStartTime}}"></span></div></div></div></div></div></div><md-divider class="investigationDivider mt25"></md-divider><!--  Investigation Reports Starts Here --><div layout-padding class="bgColorWh investigationDetailsMain"><div ng-if="vm.profile.openInvestigationFormListCount != \'0\'" class="md-subhead"><label class="label" data-translate="prospects.reports.title" class="p8"></label></div><div ng-if=" vm.profile.openInvestigationFormListCount == \'0\' " data-translate="prospects.reports.noinvestigation"></div></div><div class="mh20 p4" ng-if="closeInv.isReviewCommitteeActive"><div flex layout="row"><div flex="95" layout="row" layout-xs="column"><div flex="80" flex-xs="5"><label class="w100p cursorPointer reportLabel" data-translate="prospects.RC.title"></label></div><div flex="20" flex-xs="0" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.RC.downloadRCReport" ng-click="vm.getPdfReport(vm.getInvestigationFormId(closeInv),vm.APP.INVESTIGATION.REVIEW_COMMITTEE_REPORT_NAME,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></div></div></div><div class="mt40" ng-if="closeInv.rcDetailsList.length > 0"><div ng-repeat="RCResultObj in closeInv.rcDetailsList" class="mb20"><div layout-gt-xs="row"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.RC.rcmeeting" class="reportLabel mb5"></div><div class="reportName mb5" ng-bind="{{RCResultObj.assignmentDate}}"></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'yellowBg\':RCResultObj.rcStatusKey == \'RC_IN_PROGRESS\', \'grnBg\':RCResultObj.rcStatusKey == \'RC_COMPLETED\' }"></div><div class="caps reportStatus mb5" data-translate="prospects.{{RCResultObj.rcStatusKey}}"></div></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><span class="grncolor cursorPointer" data-translate="prospects.RC.openRCDetails" ng-click="vm.openRCSession(RCResultObj,false);"></span></div></div></div></div></div></div><div class="mh20 pt20" ng-if="closeInv.analystFormList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.analystReport"></span></label></div><div class="mt10"><div ng-repeat="analystReportObj in closeInv.analystFormList" class="mb20"><div layout-gt-xs="row"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedAnalyst" class="caps reportName mb5"></div><div class="profileInvValue mb5 camelCase" ng-bind-template="{{analystReportObj.assignerFirstName.toLowerCase()}} {{analystReportObj.assignerLastName.toLowerCase()}}"></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'yellowBg\':analystReportObj.investigationFormStatus == vm.APP.GLOBAL.IN_PROGRESS, \'grnBg\':analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED}"></div><div class="caps reportStatus mb5" data-translate="prospects.{{analystReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span data-translate="dashboard.month.{{analystReportObj.monthAnalystReportDate}}"></span><span data-translate="{{analystReportObj.dayAnalystReportDate}}"> </span><span data-translate="{{analystReportObj.yearAnalystReportDate}}"></span></div></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 0 && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><span class="grncolor cursorPointer" data-translate="prospects.reports.viewform" ng-click="vm.viewform(analystReportObj.investigationFormId,$event,analystReportObj.investigationFormType);"></span> <span ng-if="analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED"><span class="mh15">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystReportObj.investigationFormId,analystReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></span></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 1 && analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED  &&  vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN "><span class="grncolor cursorPointer" data-translate="prospects.reports.viewform" ng-click="vm.viewform(analystReportObj.investigationFormId,$event,analystReportObj.investigationFormType);"></span> <span class="mh15">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystReportObj.investigationFormId,analystReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></div></div></div><div layout-gt-xs="row" class="mt40" ng-if="analystReportObj.ageResult != null && analystReportObj.identityResult != null"><div flex="50" flex-xs="100"><div data-translate="prospects.reports.ageResult" class="caps reportName mb5"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':analystReportObj.ageResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':analystReportObj.ageResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{analystReportObj.ageResult}}"></div></div></div><div flex="50" flex-xs="100"><div data-translate="prospects.reports.idResult" class="caps reportName mb5" ng-class="{\'mt10\':mediaCheck(\'xs\')}"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':analystReportObj.identityResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':analystReportObj.identityResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{analystReportObj.identityResult}}"></div></div></div></div></div></div></div><div class="mh20 pt20" ng-if="closeInv.analystFormInProgressList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.analystReport"></span></label></div><div class="mt10"><div layout-gt-xs="row" class="mb30" ng-repeat="analystInprogressReportObj in closeInv.analystFormInProgressList"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedAnalyst" class="caps reportName mb5"></div><div class="profileInvValue mb5 camelCase" ng-bind-template="{{analystInprogressReportObj.assignerFirstName.toLowerCase()}} {{analystInprogressReportObj.assignerLastName.toLowerCase()}}"></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle yellowBg"></div><div class="caps reportStatus mb5" data-translate="prospects.{{analystInprogressReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5" ng-bind="analystInprogressReportObj.investigationFormDate"></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 0 && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><span class="grncolor cursorPointer" ng-click="vm.viewform(analystInprogressReportObj.investigationFormId,$event,analystInprogressReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></span><!--   Enable preview report for InProgress Analyst Form --> <span ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ANALYST"><span class="mh18">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystInprogressReportObj.investigationFormId,analystInprogressReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></span></div></div></div></div></div><div class="mh20 pt20" ng-if="closeInv.investigatorFormInProgressList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.investigatorReport"></span></label></div><div class="mt10"><div layout-gt-xs="row" class="mb30" ng-repeat="investigatorInprogressReportObj in closeInv.investigatorFormInProgressList"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedInvestigator" class="caps reportName mb5"></div><div class="profileInvValue mb5" ng-bind-template="{{investigatorInprogressReportObj.assignerFirstName}} {{investigatorInprogressReportObj.assignerLastName}}"></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle yellowBg"></div><div class="caps reportStatus mb5"><span data-translate="prospects.{{investigatorInprogressReportObj.investigationFormStatus}}"></span></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5" ng-bind="investigatorInprogressReportObj.investigationFormDate"></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR && investigatorInprogressReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div class="grncolor cursorPointer" ng-click="vm.viewform(investigatorInprogressReportObj.investigationFormId,$event,investigatorInprogressReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></div><!--   Enable preview report for InProgress Investigator Form --><div><span class="mh15">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorInprogressReportObj.investigationFormId,investigatorInprogressReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></div></div></div></div></div></div><div class="mh20 p4 compeleteProfAccord" ng-if="closeInv.investigatorFormCompletedList.length > 0"><v-accordion class="vAccordion--default"><v-pane expanded="true"><v-pane-header><div layout="row"><div class="closedDiv" ng-class="{\'completeAccordHeadLarge\': !mediaCheck(\'xs\'), \'completeAccordHeadSmall\':mediaCheck(\'xs\')}"><label class="w100p textCenter cursorPointer caps monstFamily fz13 lytGreyTxt"><span data-translate="prospects.reports.completedReport"></span></label></div></div></v-pane-header><v-pane-content><div class="mt30"><div ng-repeat="investigatorCompletedReportObj in closeInv.investigatorFormCompletedList"><div layout-gt-xs="row"><div layout="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.investigatorNameText" class="caps reportName mb5"></div><div class="profileInvValue mb5 camelCase" ng-bind-template="{{investigatorCompletedReportObj.assignerFirstName.toLowerCase()}} {{investigatorCompletedReportObj.assignerLastName.toLowerCase()}}"></div><div layout="row" class="monstFamily fz13 lytGreyTxt lh19"><div data-translate="prospects.common.completedOn"></div><div class="ml5"><span data-translate="dashboard.month.{{investigatorCompletedReportObj.monthInvestigationFomCompeledDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.dayInvestigationFomCompeledDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.yearInvestigationFomCompeledDate}}"></span></div></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED, \'redBg\':investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.IN_PROGRESS}"></div><div class="caps reportStatus mb5" data-translate="prospects.{{investigatorCompletedReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span data-translate="dashboard.month.{{investigatorCompletedReportObj.monthInvestigationFormDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.dayInvestigationFormDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.yearInvestigationFormDate}}"></span></div></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 0 && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><span ng-click="vm.viewform(investigatorCompletedReportObj.investigationFormId);" class="grncolor cursorPointer" data-translate="prospects.reports.viewform"></span> <span ng-if="investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED"><span class="mh15">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorCompletedReportObj.investigationFormId,investigatorCompletedReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></span></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 1 && investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><span class="grncolor cursorPointer" ng-click="vm.viewform(investigatorCompletedReportObj.investigationFormId);" data-translate="prospects.reports.viewform"></span> <span class="mh15">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorCompletedReportObj.investigationFormId,investigatorCompletedReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,closeInv.investigationId);"></a></div><!-- <div class="monstFamily fz12 lh19 ml18"><span class="grncolor cursorPointer fontW900">View Form</span><span class="mh15">|</span><span class="grncolor cursorPointer fontW900">Download Report</span></div> --></div></div><div layout-gt-xs="row" class="mt40" ng-if="investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR && investigatorCompletedReportObj.ageResult != null && investigatorCompletedReportObj.identityResult != null"><div flex="50" flex-xs="100"><div data-translate="prospects.reports.ageResult" class="caps reportName mb5"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.ageResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':investigatorCompletedReportObj.ageResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{investigatorCompletedReportObj.ageResult}}"></div></div></div><div flex="50" flex-xs="100"><div data-translate="prospects.reports.idResult" class="caps reportName mb5" ng-class="{\'mt10\':mediaCheck(\'xs\')}"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.identityResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':investigatorCompletedReportObj.identityResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{investigatorCompletedReportObj.identityResult}}"></div></div></div></div><hr ng-if="!$last"></div></div></v-pane-content></v-pane></v-accordion></div><div class="mh20 p4 compeleteProfAccord" ng-if="closeInv.removedFormList.length > 0"><v-accordion class="vAccordion--default"><v-pane expanded="true"><v-pane-header><div layout="row"><div class="closedDiv" ng-class="{\'completeAccordHeadLarge\': !mediaCheck(\'xs\'), \'completeAccordHeadSmall\':mediaCheck(\'xs\')}"><label class="w100p textCenter cursorPointer caps monstFamily fz13 lytGreyTxt ph15"><span data-translate="prospects.reports.deletedReport"></span></label></div></div></v-pane-header><v-pane-content><div class="mt30"><div ng-repeat="removedReportObj in closeInv.removedFormList"><div layout-gt-xs="row"><div flex="50" flex-xs="100"><div ng-if="removedReportObj.investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" data-translate="prospects.reports.analystNameText" class="caps reportName mb5"></div><div ng-if="removedReportObj.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM" data-translate="prospects.reports.investigatorNameText" class="caps reportName mb5"></div><div class="profileInvValue mb5" ng-bind-template="{{removedReportObj.assignerFirstName}} {{removedReportObj.assignerLastName}}"></div><div layout="row" class="monstFamily fz13 lytGreyTxt lh19"><div data-translate="prospects.common.deletedOn"></div><div class="ml5"><span data-translate="dashboard.month.{{removedReportObj.monthRemovedDate}}"></span><span data-translate="{{removedReportObj.dayRemovedDate}}"> </span><span data-translate="{{removedReportObj.yearRemovedDate}}"></span></div></div></div><div flex="45" flex-xs="100"><div layout="row"><div class="statCircle redBg"></div><div class="caps reportStatus mb5" data-translate="prospects.{{removedReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span data-translate="dashboard.month.{{removedReportObj.monthinvestigationFormDate}}"></span> <span data-translate="{{removedReportObj.dayinvestigationFormDate}}"></span> <span data-translate="{{removedReportObj.yearinvestigationFormDate}}"></span></div></div></div></div><hr ng-if="!$last"></div></div></v-pane-content></v-pane></v-accordion></div><md-divider class="investigationDivider"></md-divider><!-- Documents starts here --><div layout-padding class="bgColorWh"><div class="md-subhead investigationDetailsMain"><label class="label fs15MBL pl0MBL wsnormalMBL" data-translate="prospects.documents.title"></label></div><div ng-show="vm.documentLoader"><md-progress-linear ng-show="vm.documentLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-show="!vm.documentLoader"><div ng-if="documents.length == 0" class="fz16 textCenter" data-translate="prospects.documents.noDocument"></div></div><div layout="row" flex-offset="5" class="ellipsis" ng-class="{\'mt7\': !$first}" ng-show="!vm.documentLoader" ng-repeat="ebisDocuments in documents track by $index"><span class="investigationAttachmentIcon"><i class="material-icons attachicon">attachment</i></span> <span class="investigationAttachmentFile"><a class="textstyle2 textDecorationNoneImportant" href="{{vm.downloadAPI + ebisDocuments.id}}" download>{{ebisDocuments.displayName}}</a></span></div></div><!-- Documents ends here --><md-divider ng-if="$last" class="investigationDivider"></md-divider></div><div ng-if="vm.profile.closeStatusCount > 1 && !$last" flex-offset="5" flex-offset-xs="10" layout="row" class="box-content left divider"></div></div>');
$templateCache.put('app/investigation/prospects/profile/profile.html','<div layout="row" layout-align="end center" class="mR3" hide-gt-xs><md-fab-speed-dial md-open="vm.isFabOpen" md-direction="left" class="md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab fab" area-label="menu"><img src="content\\images\\UserProfile.png"></md-button></md-fab-trigger><md-fab-actions><md-button hide-gt-xs ng-click="vm.toggleLeft()" class="md-fab md-mini bgColorWh" aria-label="profile"><img class="h30" src="content\\images\\UserProfileViewIcon.png"></md-button></md-fab-actions></md-fab-speed-dial></div><div ng-show="vm.profileDataLoader" style="padding-top:50px;"><md-progress-linear ng-show="vm.profileDataLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="row" class="profileMarLeft"><div layout="column" ng-show="!vm.profileDataLoader"><md-sidenav class="md-sidenav-right profileSideTop profileSideHeight" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right" resize style="overflow-y:auto; overflow-x:hidden !important;" ng-style="{\'height\':windowHeight-139 + \'px\'}"><md-content><!-- <div layout="column"> --><div class="profileLayout" ng-class="{profileHeight :mediaCheck(\'xs\')}"><div layout layout-align="center center" class="actProfile"><div class="ptop45"><ng-letter-avatar flex shape="round" height="124px" width="124px" data="{{vm.profileData.firstName}}" dynamic="true"></ng-letter-avatar></div></div><div flex class="profileDiv wordWrap" layout-padding><label class="f1 w100p letsp2p mb30" data-translate="prospects.prospectdetails.title"></label><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.name"></label><div class="f3 camelCase">{{vm.profileData.firstName.toLowerCase()}} {{vm.profileData.lastName.toLowerCase()}}</div><div class="f3 camelCase" ng-if="vm.profile.aliasName != null">({{vm.profileData.aliasName.toLowerCase()}})</div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.dob"></label><div class="f3"><span data-translate="dashboard.month.{{vm.profileData.monthDob}}"></span> <span data-translate="{{vm.profileData.dayDob}}"></span> <span data-translate="{{vm.profileData.yearDob}}"></span></div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.country"></label><div ng-show="language == \'en\'" class="f3">{{vm.profileData.birthCountryText}}</div><div ng-show="language == \'es\'" class="f3" data-translate="dashboard.filters.countries.{{vm.profileData.birthCountryText}}"></div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.cedulanumber"></label><div class="f3">{{vm.profileData.cedulaNumber}}</div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.ebisid"></label><div class="f3">{{vm.profileData.prospectEbisId}}</div></div></div><md-divider></md-divider><div class="profileSubDiv wordWrap" layout-padding><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.address"></label><div class="f3"><div ng-bind="vm.profileData.homeAddressLine"></div><div ng-bind="vm.profileData.homeAddressLine1"></div><div ng-bind="vm.profileData.homeAddressLine2"></div><div ng-bind="vm.profileData.homeSectorTxt"></div><div ng-bind="vm.profileData.homeCityTxt"></div><div ng-bind="vm.profileData.homeProvinceTxt"></div><div ng-show="language == \'en\'" ng-bind="vm.profileData.homeCountryTxt"></div><div ng-show="language == \'es\'" data-translate="dashboard.filters.countries.{{vm.profileData.homeCountryTxt}}"></div></div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.phone"></label><div class="f3">{{vm.profileData.phoneNumber}}</div></div><div class="mb30"><label class="prospectheader" data-translate="prospects.prospectdetails.email"></label><div class="f3">{{vm.profileData.email}}</div></div></div></div><!-- </div> --></md-content></md-sidenav></div><div class="mt50 profilemt profileDetailsSec width100" resize ng-style="{\'max-height\': windowHeight - 140 +\'px\'}" style="overflow-y: auto; overflow-x: hidden;"><div class="noHScroll overflowHidden"><div ng-show="vm.profileDetailLoader && !vm.profileDataLoader" class="mltPer"><md-progress-linear ng-show="vm.profileDetailLoader && !vm.profileDataLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-show="!vm.profileDetailLoader && !vm.profileDataLoader" class="mltPer" layout="row" layout-xs="column" flex-offset-sm="5" flex-offset-xs="5"><div class="width100"><div hide-gt-sm hide-gt-xs show-xs class="p10"></div><div layout="column"><div layout="row"><div class="mw20p" ng-click="vm.openOpenedCases()"><label class="f1 w100p textCenter cursorPointer divStyle pl10 pr10"><span>{{vm.profile.openStatusCount}} </span><span data-translate="prospects.prospectdetails.openinvestigation"></span></label></div><div class="closeShow" ng-if="vm.profile.openStatusCount > 0" ng-click="vm.openOpenedCases()"><span ng-if="vm.showOpenCases" data-translate="prospects.common.hide"></span> <span ng-if="!vm.showOpenCases" data-translate="prospects.common.show"></span></div></div><div flex-offset="5" flex-offset-xs="10" class="box-content left divider mtm4"></div></div><div ng-include src="\'app/investigation/prospects/profile/profile.openInvestigationList.html\'"></div><!-- <div layout="row" hide-gt-sm hide-gt-xs show-xs class="p10"></div> --><div><div layout="column"><div flex-offset="5" flex-offset-xs="10" class="box-content left divider"></div><div layout="row"><div class="mw20p" ng-click="vm.openClosedCases()"><label class="f1 w100p textCenter closedPadding cursorPointer closedDiv pl10 pr10"><span>{{vm.profile.closeStatusCount}} </span><span data-translate="prospects.prospectdetails.closedinvestigation"></span></label></div><div class="closeShow" ng-if="vm.profile.closeStatusCount > 0" ng-click="vm.openClosedCases()"><span ng-if="vm.showCloseCases" data-translate="prospects.common.hide"></span> <span ng-if="! vm.showCloseCases" data-translate="prospects.common.show"></span></div></div><div flex-offset="5" ng-if="vm.profile.closeStatusCount>0 && vm.showCloseCases" flex-offset-xs="10" class="box-content left divider mtm4"></div></div><div ng-include src="\'app/investigation/prospects/profile/profile.closedInvestigationList.html\'"></div></div></div></div></div><div ng-include="\'app/investigation/prospects/assign/assignInvestigator.html\'"></div><!-- <div  ng-include src="\'app/investigation/prospects/assign/assignAnalyst.html\'"></div> --><div ng-include="\'app/investigation/prospects/assign/assign.html\'"></div><div ng-include="\'app/investigation/prospects/profile/openAnalystFormPopup.html\'" style="display:none;"></div><div ng-include="\'app/investigation/prospects/assign/delete.investigtaion.form.popup.html\'"></div><!-- <div ng-include src="\'app/investigation/prospects/assign/assignInvestigatorMobile.html\'"></div> --></div></div>');
$templateCache.put('app/investigation/prospects/profile/profile.openInvestigationList.html','<div layout="column" ng-if="vm.showOpenCases" ng-repeat="openInv in vm.profile.openInvestigationList" ng-class="{widthM35p:mediaCheck(\'sm\')}"><div layout="column" class="investigationLayout"><div ng-init="vm.getReopenFlag(openInv.investigationId);vm.isAllRcCompleted(openInv.rcDetailsList)"><div class="contractHeader" ng-class="{\'mh140\':(vm.reopenInvestigation || vm.reopenAnalyst)}"><div layout="row" layout-xs="column"><div layout-padding><label class="md-title label letsp2p caps"><span data-translate="prospects.{{openInv.investigationTypeName}}"></span></label><div class="dateDiv"><span ng-if="openInv.monthInvestigationDateOpened" data-translate="dashboard.month.{{openInv.monthInvestigationDateOpened}}"></span> <span data-translate="{{openInv.dayInvestigationDateOpened}}"></span> <span data-translate="{{openInv.yearInvestigationDateOpened}}"></span></div><!-- <div class="dateDiv">{{openInv.investigationDateOpened}}</div> --></div><!-- Show the reopen/reassign Flag --><div flex="10" hide-xs layout-gt-xs="row" show-gt-xs class="redFlag mt10" ng-show="vm.reopenInvestigator || (vm.reopenAnalyst && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR)"></div></div><div layout="row" layout-align="space-between" layout-margin id="openForm"><div class="reviewDiv" ng-if="vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><label class="p4 f2" data-translate="prospects.{{openInv.investigationStatus}}"></label><!-- Show the reopen/reassign Flag --><!-- <div flex="10" layout-xs="row" class="mt20" layout-align-xs="center center" hide-gt-xs show-xs>  \n\t\t       \t\t\t\tReopened Investigator Form in In progress Status\n\t       \t\t\t\t<div ng-if="vm.reopenInvestigator && vm.reopenInvestigatorInprogress == vm.APP.GLOBAL.IN_PROGRESS" class="ml5 popoverPosition" \n\t       \t\t\t\t\tpopover-trigger="click" popover-placement="bottom" uib-popover="{{(\'prospects.reopenFlag.UnderInvestigation\' | translate)}}" type="button" popover-class="popoverClass">\n\t       \t\t\t\t\t<div data-translate="prospects.reopenFlag.UI" class="mr5 reopenCircle"></div>\n\t       \t\t\t\t</div>\n\t       \t\t\t\tReopened Investigator Form in Completed Status\n\t\t\t\t\t\t<div ng-if="vm.reopenInvestigator && vm.reopenInvestigatorInprogress != vm.APP.GLOBAL.IN_PROGRESS" class="ml5 popoverPosition" \n\t\t\t\t\t\t\tpopover-trigger="click" popover-placement="bottom" uib-popover="{{(\'prospects.reopenFlag.UnderInvestigation\' | translate)}}" type="button" popover-class="popoverClass">\n\t\t\t\t\t\t\t<div data-translate="prospects.reopenFlag.UI" class="mr5 reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t\t</div>\n\t       \t\t\t\tReopened Analyst Form in In progress Status\n\t\t\t\t\t\t<div ng-if="vm.reopenAnalyst && vm.reopenAnalystInprogress == vm.APP.GLOBAL.IN_PROGRESS && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="ml5 popoverPosition" \n\t\t\t\t\t\t\tpopover-trigger="click" popover-placement="bottom" uib-popover="{{(\'prospects.reopenFlag.UnderAnalysis\' | translate)}}" type="button" popover-class="popoverClass">\n\t\t\t\t\t\t\t<div data-translate="prospects.reopenFlag.UA" class="reopenCircle"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\tReopened Analyst Form in Completed Status\n\t\t\t\t\t\t<div ng-if="vm.reopenAnalyst && vm.reopenAnalystInprogress != vm.APP.GLOBAL.IN_PROGRESS && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR" class="ml5 popoverPosition" \n\t\t\t\t\t\t\tpopover-trigger="click" popover-placement="bottom" uib-popover="{{(\'prospects.reopenFlag.UnderAnalysis\' | translate)}}" type="button" popover-class="popoverClass">\n\t\t\t\t\t\t\t<div data-translate="prospects.reopenFlag.UA" class="reopenCircle reopenCompletedBg"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div> --><div flex="10" layout-xs="row" class="redFlag mt20" layout-align-xs="center center" hide-gt-xs show-xs ng-show="vm.reopenInvestigator || (vm.reopenAnalyst && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR)"></div></div><!-- <div flex="10" layout-gt-xs="row" hide-xs show-gt-xs class="mt15">  \n\t       \t\t\t\t<div ng-show="vm.reopenInvestigation"><ng-letter-avatar avatarcustombgcolor="{{$even?\'green\':\'red\'}}" shape="round" height="25px" width="25px" fontSize="10px" charCount="2" data="UI"></ng-letter-avatar></div>\n\t\t\t\t\t\t<div ng-show="vm.reopenAnalyst" class="pl5"><ng-letter-avatar avatarcustombgcolor="{{$even?\'green\':\'red\'}}" shape="round" height="25px" width="25px" fontSize="10px" charCount="2" data="UA"></ng-letter-avatar></div>\n\t\t\t\t\t</div> --><div flex="60" ng-if="vm.user.authorities[0] == vm.APP.GLOBAL.ROLE_INVESTIGATOR"></div><!--Open Investigator Form if Investigator is new form then update the Investigation Status to \'Under Investigation\' --><div ng-class="{\'disable halfOpacity\':vm.openFormObj.disabled}" class="openformbtn" ng-if="!vm.multipleForm && vm.profile.formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && vm.profile.isNewInvestigatorForm  && vm.profile.isOwner == 1 && vm.profile.formStatus == vm.APP.GLOBAL.IN_PROGRESS" ng-click="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR ? vm.updateInvestigationStatus(vm.APP.INVESTIGATION.INVESTIGATOR_FORM,$event) : vm.openInvestigationForm($event,vm.profile.formType,vm.APP.GLOBAL.FALSE);"><label class="div cursorPointer" ng-class="{\'pt2MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.openForm"></label></div><!--Open Analyst/Investigator Form if Analyst/Investigator is old form --><div class="openformbtn" ng-if="!vm.multipleForm && ((vm.profile.formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && !vm.profile.isNewInvestigatorForm) || (vm.profile.formType != vm.APP.INVESTIGATION.INVESTIGATOR_FORM && !vm.profile.isNewAnalystForm)) && vm.profile.isOwner == 1 && vm.profile.formStatus == vm.APP.GLOBAL.IN_PROGRESS" ng-click="vm.openInvestigationForm($event,vm.profile.formType,vm.APP.GLOBAL.FALSE)"><label class="div cursorPointer" ng-class="{\'pt2MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.openForm"></label></div><!--Open Analyst Form if Analyst form is new form --><div class="openformbtn" ng-if="!vm.multipleForm && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.profile.isNewAnalystForm  && vm.profile.isOwner == 1 && vm.profile.formStatus == vm.APP.GLOBAL.IN_PROGRESS && vm.profile.formType != vm.APP.INVESTIGATION.INVESTIGATOR_FORM" ng-click="vm.openAnalystFormPopup($event,\'openAnalystFormPopupID\')"><label class="div cursorPointer" data-translate="prospects.openForm"></label></div><!-- Analyst Form and Investigator Form Assigned both assigned to single user. Investigator Form is completed and Analyst form is new form --><div class="openformbtn" ng-if="!vm.multipleForm && (vm.profile.formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && vm.profile.formStatus == vm.APP.GLOBAL.COMPLETED && openInv.analystFormInProgressList.length > 0 && openInv.analystFormInProgressList[0].isOwner) && vm.profile.isOwner == 1 && vm.profile.isNewAnalystForm" ng-click="vm.openAnalystFormPopup($event,\'openAnalystFormPopupID\')"><label class="div cursorPointer" ng-class="{\'pt2MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.openForm"></label></div><!-- Analyst Form and Investigator Form Assigned both assigned to single user. Investigator Form is completed and Analyst form is old form --><div class="openformbtn" ng-if="!vm.multipleForm && (vm.profile.formType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && vm.profile.formStatus == vm.APP.GLOBAL.COMPLETED && openInv.analystFormInProgressList.length > 0 && openInv.analystFormInProgressList[0].isOwner) && vm.profile.isOwner == 1 && !vm.profile.isNewAnalystForm" ng-click="vm.openAnalystForm($event)"><label class="div cursorPointer" ng-class="{\'pt2MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.openForm"></label></div><!-- Both Analyst Form and Investigator Form assigned to single user and both form is in In Progress status --><md-menu ng-if="vm.multipleForm"><md-button aria-label="Open menu with custom trigger" class="md-icon-button openformbtn formOpenButton" ng-click="vm.openMenu($mdOpenMenu, $event)"><label class="div cursorPointer p0imp" data-translate="prospects.openForm"></label></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.openForm(vm.APP.INVESTIGATION.INVESTIGATOR_FORM,vm.invFormId,$event)" class="fz13"><label class="div cursorPointer formMenu" data-translate="prospects.investigationForm"></label></md-button></md-menu-item><!--Open Analyst Form if Analyst Form is old form --><md-menu-item ng-if="!vm.profile.isNewAnalystForm"><md-button ng-click="vm.openForm(vm.APP.INVESTIGATION.ANALYST_FORM,vm.analystFormId,$event)" class="fz13"><label class="div cursorPointer formMenu" data-translate="prospects.analystForm"></label></md-button></md-menu-item><!--Open Analyst Form if Analyst Form is new form --><md-menu-item ng-if="vm.profile.isNewAnalystForm"><md-button ng-click="vm.openAnalystFormPopup($event,\'openAnalystFormPopupID\')" class="fz13"><label class="div cursorPointer formMenu" data-translate="prospects.analystForm"></label></md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout-padding class="investigationDetailsMain mt30"><div class="md-subhead"><label class="label" ng-class="{\'ls0MBL\':vm.lang == vm.APP.GLOBAL.ES}" data-translate="prospects.investigationdetails.details.title"></label></div><div flex layout="row" layout-align="start" layout-align-xs="space-between start" layout-xs="column" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.dateopen"></label><div class="profileInvValue"><span ng-if="openInv.monthInvestigationDateOpened" data-translate="dashboard.month.{{openInv.monthInvestigationDateOpened}}"></span> <span data-translate="{{openInv.dayInvestigationDateOpened}}"></span> <span data-translate="{{openInv.yearInvestigationDateOpened}}"></span></div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5" ng-init="vm.requestedList = openInv.organisationAbbrevation;"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.requestedby"></label><div layout="row"><!-- limitTo: A number, specifying how many elements to return: A number specifying where to begin the limitation. Default is 0 --><div ng-repeat="requestedopenInv in openInv.organisationAbbrevation| limitTo:(mediaCheck(\'xs\')?vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT:vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT)"><div ng-class="{\'even\':$even, \'odd\':$odd}" class="circleRequest"><span class="colorWh circleLetter">{{requestedopenInv}}</span></div></div><div ng-if="vm.requestedList.length>0 && mediaCheck(\'xs\')? vm.requestedList.length > vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT : vm.requestedList.length > vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT"><div class="circleRequest inProgressCircle cursorP" popover-trigger="mouseenter" popover-placement="{{mediaCheck(\'xs\')?\'bottom-right\':\'right-top\'}}" uib-popover-template="\'app/investigation/prospects/profile/requestedclub.popover.html\'" type="button"><span class="colorBoldBlack circleLetter roboFont">+{{(mediaCheck(\'xs\')?(vm.requestedList.length - vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT):(vm.requestedList.length - vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT))}}</span></div></div></div><!-- <div class="profileInvValue">{{openInv.requestedBy}}</div> --></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.agent_trainer"></label><div class="profileInvValue capitalize"><span ng-bind-template="{{openInv.trainerFirstName}} {{openInv.trainerLastName}}"></span></div></div></div><div flex layout="row" layout-xs="column" layout-align="start" layout-align-xs="space-between start" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.daysopen"></label><div class="profileInvValue">{{openInv.investigationDaysOpened}}</div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.daysonstatus"></label><div class="profileInvValue">{{openInv.statusOpenedDays}}</div></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel" data-translate="prospects.investigationdetails.details.status"></label><div class="profileInvValue"><span data-translate="prospects.{{openInv.investigationStatus}}"></span></div></div></div><div flex ng-if="openInv.isReviewCommitteeActive" layout="row" layout-xs="column" layout-align="start" layout-align-xs="space-between start" layout-gt-lg="row" layout-padding><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel caps" data-translate="prospects.reports.latestAgeResult"></label><div layout="row" ng-if="openInv.investigationAgeResult != null"><div class="statCircle" ng-class="{\'grnBg\':(openInv.investigationAgeResult == vm.APP.REF_TERM.FORM_CONFIRMED || openInv.investigationAgeResult == vm.APP.REF_TERM.RC_CONFIRMED), \'redBg\':(openInv.investigationAgeResult != vm.APP.REF_TERM.FORM_CONFIRMED || openInv.investigationAgeResult != vm.APP.REF_TERM.RC_CONFIRMED)}"></div><div class="profileInvValue" data-translate="prospects.{{openInv.investigationAgeResult}}"></div></div><div layout="row" ng-if="openInv.investigationAgeResult == null"><div class="profileInvValue">-</div></div><!-- <div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18">\n\t\t\t\t\t\t\t<div data-translate="prospects.investigationdetails.details.on"></div>\n\t\t\t\t\t\t\t<div class="ml5" ng-bind="openInv.investigationResultStartTime"></div>\n\t\t\t\t\t\t</div> --></div><div class="mt25 mb30M" layout="column" flex="33" flex-xs="5"><label class="profileInvLabel caps" data-translate="prospects.reports.latestIdResult"></label><div layout="row" ng-if="openInv.investigationIdentityResult != null"><div class="statCircle" ng-class="{\'grnBg\':(openInv.investigationIdentityResult == vm.APP.REF_TERM.FORM_CONFIRMED || openInv.investigationIdentityResult == vm.APP.REF_TERM.RC_CONFIRMED), \'redBg\':(openInv.investigationIdentityResult != vm.APP.REF_TERM.FORM_CONFIRMED || openInv.investigationIdentityResult != vm.APP.REF_TERM.RC_CONFIRMED)}"></div><div class="profileInvValue" data-translate="prospects.{{openInv.investigationIdentityResult}}"></div></div><div layout="row" ng-if="openInv.investigationIdentityResult == null"><div class="profileInvValue">-</div></div><!-- <div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18">\n\t\t\t\t\t\t\t<div data-translate="prospects.investigationdetails.details.on"></div>\n\t\t\t\t\t\t\t<div class="ml5" ng-bind="openInv.investigationResultStartTime"></div>\n\t\t\t\t\t\t</div> --></div></div></div></div><md-divider class="investigationDivider mt25"></md-divider><!--  Investigation Reports Starts Here --><div layout-padding class="bgColorWh investigationDetailsMain"><div ng-if="vm.profile.openInvestigationFormListCount != \'0\'" class="md-subhead"><label class="label" data-translate="prospects.reports.title" class="p8"></label></div><div ng-if=" vm.profile.openInvestigationFormListCount == \'0\' " data-translate="prospects.reports.noinvestigation"></div></div><div class="mh20 p4" ng-if="openInv.isReviewCommitteeActive"><div flex layout="row"><div flex="95" layout="row" layout-xs="column"><div flex="80" flex-xs="5"><label class="w100p cursorPointer reportLabel" data-translate="prospects.RC.title"></label></div><div flex="20" flex-xs="0" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.RC.downloadRCReport" ng-click="vm.getPdfReport(vm.getInvestigationFormId(openInv),vm.APP.INVESTIGATION.REVIEW_COMMITTEE_REPORT_NAME,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div><div flex="5" ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon mtm20">more_vert</i></md-button><md-menu-content width="4"><md-menu-item ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED"><md-button ng-click="vm.sentToRCConfirm($event,\'sentToRC\',vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED,0);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.RC.selected"></div></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED"><md-button ng-click="vm.sentToRCConfirm($event,\'sentToRC\',vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED,0);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.RC.tabled"></div></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY"><md-button ng-click="vm.sentToRCConfirm($event,\'sentToRC\',vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY,0);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.RC.ready"></div></md-button></md-menu-item><md-menu-item ng-if="((openInv.analystFormList[0] != null && openInv.analystFormList[0].investigationFormStatus == vm.APP.GLOBAL.COMPLETED) && (openInv.investigationAgeResult != vm.APP.REF_TERM.RC_TABLED && openInv.investigationIdentityResult != vm.APP.REF_TERM.RC_TABLED))"><md-button ng-click="vm.sentToeBisConfirm($event,\'sentToeBis\',openInv.investigationStatus);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToEBIS"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div class="mt40" ng-if="openInv.rcDetailsList.length > 0"><div ng-repeat="RCResultObj in openInv.rcDetailsList" class="mb20"><div layout-gt-xs="row"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div><span data-translate="prospects.RC.rcmeeting" class="reportLabel mb5"></span> <span class="reportLabel mt40 mr10 mt20i" ng-if="RCResultObj.meetingNumber != 1 "># {{RCResultObj.meetingNumber}}</span></div><div class="monstFamily fz13 disableText mb5 fwb lh19 mb5"><span ng-if="RCResultObj.monthRcMeetingDate" data-translate="dashboard.month.{{RCResultObj.monthRcMeetingDate}}"></span> <span data-translate="{{RCResultObj.dayRcMeetingDate}}"></span> <span data-translate="{{RCResultObj.yearRcMeetingDate}}"></span></div></div><div flex ng-if="mediaCheck(\'xs\') && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.openRCSession(RCResultObj,true);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.edit"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.deleteRCSession($event,\'deleteRC\',RCResultObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'yellowBg\':RCResultObj.rcStatusKey == \'RC_IN_PROGRESS\', \'grnBg\':RCResultObj.rcStatusKey == \'RC_COMPLETED\' }"></div><div class="caps reportStatus mb5" data-translate="prospects.{{RCResultObj.rcStatusKey}}"></div></div><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><span class="grncolor cursorPointer" data-translate="prospects.RC.openRCDetails" ng-click="vm.openRCSession(RCResultObj,true);"></span></div></div><div flex ng-if="!mediaCheck(\'xs\') && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.READ_ONLY && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.openRCSession(RCResultObj,true);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.edit"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.deleteRCSession($event,\'deleteRC\',RCResultObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div ng-if="vm.loggedUserRole != vm.APP.GLOBAL.READ_ONLY && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN" class="caps attachmentAddText" ng-click="vm.createRCSession();" data-translate="prospects.RC.addRCMeeting"></div></div><div class="mh20 pt50" ng-if="openInv.analystFormList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.analystReport"></span></label></div><div class="mt10"><div ng-repeat="analystReportObj in openInv.analystFormList" class="mb20"><div layout-gt-xs="row"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedAnalyst" class="caps reportName mb5"></div><div class="profileInvValue mb5 camelCase" ng-bind-template="{{analystReportObj.assignerFirstName.toLowerCase()}} {{analystReportObj.assignerLastName.toLowerCase()}}"></div></div><div flex ng-if="mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN)"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.MANAGER_REVIEW && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><md-button ng-click="vm.sentToeBisConfirm($event,\'sentToeBis\',openInv.investigationStatus,analystReportObj.investigationFormId);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToEBIS"></div></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.MANAGER_REVIEW && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><md-button ng-click="vm.sentToRCConfirm($event,\'sentToRC\',vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED,1);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToRC"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.sentToAnalyst($event,\'sentToAnalyst\',analystReportObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToAnalyst"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'yellowBg\':analystReportObj.investigationFormStatus == vm.APP.GLOBAL.IN_PROGRESS, \'grnBg\':analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED}"></div><div class="caps reportStatus mb5" data-translate="prospects.{{analystReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span ng-if="analystReportObj.monthAnalystReportDate" data-translate="dashboard.month.{{analystReportObj.monthAnalystReportDate}}"></span> <span data-translate="{{analystReportObj.dayAnalystReportDate}}"></span> <span data-translate="{{analystReportObj.yearAnalystReportDate}}"></span></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 0 && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.loggedUserRole != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><div class="grncolor cursorPointer" data-translate="prospects.reports.viewform" ng-click="vm.viewform(analystReportObj.investigationFormId,$event,analystReportObj.investigationFormType);"></div><div layout="row" ng-if="analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED"><div class="mh10">|</div><div><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystReportObj.investigationFormId,analystReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.profile.isOwner == 1 && analystReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED  && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN "><div class="grncolor cursorPointer" data-translate="prospects.reports.viewform" ng-click="vm.viewform(analystReportObj.investigationFormId,$event,analystReportObj.investigationFormType);"></div><div class="mh10">|</div><div><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" href="{{vm.reportUrl}}" download="{{vm.reportFileName}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystReportObj.investigationFormId,analystReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div></div><div flex ng-if="!mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN)"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.MANAGER_REVIEW && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><md-button ng-click="vm.sentToeBisConfirm($event,\'sentToeBis\',openInv.investigationStatus,analystReportObj.investigationFormId);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToEBIS"></div></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.MANAGER_REVIEW && vm.loggedUserRole == vm.APP.GLOBAL.MANAGER"><md-button ng-click="vm.sentToRCConfirm($event,\'sentToRC\',vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED,1);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToRC"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.sentToAnalyst($event,\'sentToAnalyst\',analystReportObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToAnalyst"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout-gt-xs="row" class="mt40" ng-if="analystReportObj.ageResult != null && analystReportObj.identityResult != null"><div flex="50" flex-xs="100"><div data-translate="prospects.reports.ageResult" class="caps reportName mb5"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':analystReportObj.ageResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':analystReportObj.ageResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{analystReportObj.ageResult}}"></div></div></div><div flex="50" flex-xs="100"><div data-translate="prospects.reports.idResult" class="caps reportName mb5" ng-class="{\'mt10\':mediaCheck(\'xs\')}"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':analystReportObj.identityResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':analystReportObj.identityResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{analystReportObj.identityResult}}"></div></div></div></div><!-- Assign investigator/analyst dropdown in analyst view area --><div layout="row" class="m20 ml0" ng-if="(vm.rcCompleted) && $last && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN)\n\t\t\t\t\t\t&& (openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED)"><i class="material-icons mln5" layout="column" ng-click="vm.isAllRcCompleted(openInv.rcDetailsList)">add_circle</i><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)" data-translate="prospects.assignInvestigator.assignToCase"></div><md-menu-content width="4"><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED"><md-button ng-disabled="openInv.investigatorFormInProgressList.length >1" ng-click="vm.search();vm.openAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,1)" data-translate="prospects.reports.assigninvestigator"></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED || !(vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN)"><md-button ng-disabled="openInv.analystFormInProgressList.length >0" ng-click="vm.search();vm.openAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.ANALYST,1)" data-translate="prospects.reports.assignanalyst"></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div class="mh20 pt20" ng-if="openInv.analystFormInProgressList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.analystReport"></span></label></div><div class="mt10"><div layout-gt-xs="row" class="mb30" ng-repeat="analystInprogressReportObj in openInv.analystFormInProgressList"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedAnalyst" class="caps reportName mb5"></div><div class="profileInvValue mb5 camelCase" ng-bind-template="{{analystInprogressReportObj.assignerFirstName.toLowerCase()}} {{analystInprogressReportObj.assignerLastName.toLowerCase()}}"></div></div><div flex ng-if="mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN)"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.ANALYST,analystInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.isReviewCommitteeActive)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',analystReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle yellowBg"></div><div class="caps reportStatus mb5" data-translate="prospects.{{analystInprogressReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span ng-if="analystInprogressReportObj.monthInprogressDate" data-translate="dashboard.month.{{analystInprogressReportObj.monthInprogressDate}}"></span> <span data-translate="{{analystInprogressReportObj.dayInprogressDate}}"></span> <span data-translate="{{analystInprogressReportObj.yearInprogressDate}}"></span></div></div><!-- Old Analyst Form --><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="!vm.profile.isNewAnalystForm && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR  && vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN"><span class="grncolor cursorPointer" ng-click="vm.viewform(analystInprogressReportObj.investigationFormId,$event,analystInprogressReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></span> <span ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ANALYST || vm.loggedUserRole == vm.APP.GLOBAL.READ_ONLY"><span class="mh10">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystInprogressReportObj.investigationFormId,analystInprogressReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></span></div><!-- New Analyst Form. Admin/Manager can edit his form alos another users form. But analyst can edit his form alone --><div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="vm.user.authorities[0] != vm.APP.GLOBAL.ROLE_INVESTIGATOR && vm.profile.isNewAnalystForm && analystInprogressReportObj.investigationFormStatus == vm.APP.GLOBAL.IN_PROGRESS &&\n\t\t\t\t\t\t\t((vm.profile.isOwner == 1 && vm.loggedUserRole == vm.APP.GLOBAL.ANALYST) || ((vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.READ_ONLY || !(vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN)) && (vm.profile.isOwner == 1 || vm.profile.isOwner == 0)) )"><span class="grncolor cursorPointer" ng-click="vm.openAnalystFormPopup($event,\'openAnalystFormPopupID\')" data-translate="prospects.reports.viewform"></span> <span ng-if="vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ANALYST || vm.loggedUserRole == vm.APP.GLOBAL.READ_ONLY"><span class="mh10">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(analystInprogressReportObj.investigationFormId,analystInprogressReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></span></div></div><div flex ng-if="!mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN)"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.ANALYST,analystInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.isReviewCommitteeActive)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',analystInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div class="mh20 pt20" ng-if="openInv.investigatorFormInProgressList.length > 0"><div><label class="w100p cursorPointer reportLabel"><span data-translate="prospects.reports.investigatorReport"></span></label></div><div class="mt10"><div layout-gt-xs="row" class="mb30" ng-repeat="investigatorInprogressReportObj in openInv.investigatorFormInProgressList"><div layout-xs="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.assignedInvestigator" class="caps reportName mb5"></div><div class="profileInvValue mb5" ng-bind-template="{{investigatorInprogressReportObj.assignerFirstName}} {{investigatorInprogressReportObj.assignerLastName}}"></div></div><div flex ng-if="mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) && investigatorInprogressReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topenInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.openByPassInvestigationConfirmPopup($event, \'byPassConfirmation\', investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.byPassMenu"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div flex ng-if="mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN) && investigatorInprogressReportObj.assignerUserGroup == vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topenInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.completeInvestigationConfirmation($event,\'submitConfirmation\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.completeInvestigation"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle yellowBg"></div><div class="caps reportStatus mb5"><span data-translate="prospects.{{investigatorInprogressReportObj.investigationFormStatus}}"></span></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span ng-if="investigatorInprogressReportObj.monthInprogressDate" data-translate="dashboard.month.{{investigatorInprogressReportObj.monthInprogressDate}}"></span> <span data-translate="{{investigatorInprogressReportObj.dayInprogressDate}}"></span> <span data-translate="{{investigatorInprogressReportObj.yearInprogressDate}}"></span></div></div><!-- <div class="monstFamily fz13 lh19 ml18 fontW900" ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR && investigatorInprogressReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR">\n\t\t\t\t\t\t\t<span class="grncolor cursorPointer" ng-click="vm.viewform(investigatorInprogressReportObj.investigationFormId,$event,investigatorInprogressReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></span>\n\t\t\t\t\t\t</div> --><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR && investigatorInprogressReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div class="grncolor cursorPointer" ng-click="vm.viewform(investigatorInprogressReportObj.investigationFormId,$event,investigatorInprogressReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></div><!--   Enable Preview option for In Progress Investigator Report --><div><span class="mh10">|</span> <a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorInprogressReportObj.investigationFormId,investigatorInprogressReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div></div><div flex ng-if="!mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) && investigatorInprogressReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topenInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.openByPassInvestigationConfirmPopup($event, \'byPassConfirmation\', investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.byPassMenu"></div></md-button></md-menu-item></md-menu-content></md-menu></div><div flex ng-if="!mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) && investigatorInprogressReportObj.assignerUserGroup == vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.search(); vm.openReAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.reAssign"></div></md-button></md-menu-item><md-menu-item ng-if="!(openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\topenInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED)"><md-button ng-click="vm.openDeletePopup($event,\'deleteInvestigator\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.delete"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="vm.completeInvestigationConfirmation($event,\'submitConfirmation\',investigatorInprogressReportObj)" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.completeInvestigation"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div><div class="mh20 p4 compeleteProfAccord" ng-if="openInv.investigatorFormCompletedList.length > 0"><v-accordion class="vAccordion--default"><v-pane expanded="true"><v-pane-header><div layout="row"><div class="closedDiv" ng-class="{\'completeAccordHeadLarge\': !mediaCheck(\'xs\'), \'completeAccordHeadSmall\':mediaCheck(\'xs\')}"><label class="w100p textCenter cursorPointer caps monstFamily fz13 lytGreyTxt"><span data-translate="prospects.reports.completedReport"></span></label></div></div></v-pane-header><v-pane-content><div class="mt30"><div ng-repeat="investigatorCompletedReportObj in openInv.investigatorFormCompletedList"><div layout-gt-xs="row"><div layout="row" flex="50" flex-xs="95"><div flex="90"><div data-translate="prospects.reports.investigatorNameText" class="caps reportName mb5"></div><div class="profileInvValue mb5" ng-bind-template="{{investigatorCompletedReportObj.assignerFirstName}} {{investigatorCompletedReportObj.assignerLastName}}"></div><div layout="row" class="monstFamily fz13 lytGreyTxt lh19"><div data-translate="prospects.common.completedOn"></div><div class="ml5"><span ng-if="investigatorCompletedReportObj.monthCompletedDate" data-translate="dashboard.month.{{investigatorCompletedReportObj.monthCompletedDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.dayCompletedDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.yearCompletedDate}}"></span></div></div></div><div flex ng-if="mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || (vm.loggedUserRole == vm.APP.GLOBAL.ANALYST && openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.ANALYST_REVIEW)) \n\t\t\t\t\t\t\t\t\t\t\t\t\t&& (openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_ANALYST) && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><md-menu><md-button aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.sentToAnalyst($event,\'sentToAnalyst\',investigatorCompletedReportObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToInvestigator"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div flex="45" flex-xs="100" ng-class="{\'mt30\':mediaCheck(\'xs\')}"><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED, \'redBg\':investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.IN_PROGRESS}"></div><div class="caps reportStatus mb5" data-translate="prospects.{{investigatorCompletedReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span ng-if="investigatorCompletedReportObj.monthInvestigationFormDate" data-translate="dashboard.month.{{investigatorCompletedReportObj.monthInvestigationFormDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.dayInvestigationFormDate}}"></span> <span data-translate="{{investigatorCompletedReportObj.yearInvestigationFormDate}}"></span></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="openInv.analystFormInProgressList.length == 0 && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div ng-click="vm.viewform(investigatorCompletedReportObj.investigationFormId,$event,investigatorCompletedReportObj.investigationFormType);" class="grncolor cursorPointer" data-translate="prospects.reports.viewform"></div><div layout="row" ng-if="investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED"><div class="mh10">|</div><div><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorCompletedReportObj.investigationFormId,investigatorCompletedReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div></div><div layout="row" class="monstFamily fz13 lh19 ml18 fontW900" ng-if="openInv.analystFormInProgressList.length != 0 && (vm.profile.isOwner == 1 || vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ANALYST || vm.loggedUserRole == vm.APP.GLOBAL.READ_ONLY) && investigatorCompletedReportObj.investigationFormStatus == vm.APP.GLOBAL.COMPLETED && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div class="grncolor cursorPointer" ng-click="(vm.loggedUserRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR && (openInv.analystFormInProgressList[0].isOwner == 1 || vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN) && openInv.analystFormInProgressList.length == 1) ? vm.setCopyFormId(investigatorCompletedReportObj,$event) : vm.viewform(investigatorCompletedReportObj.investigationFormId,$event,investigatorCompletedReportObj.investigationFormType);" data-translate="prospects.reports.viewform"></div><div class="mh10">|</div><div><a class="grncolor cursorPointer fontW900 textDecorationNoneImportant" download="{{vm.reportFileName}}" href="{{vm.reportUrl}}" data-translate="prospects.reports.downloadreport" ng-click="vm.getPdfReport(investigatorCompletedReportObj.investigationFormId,investigatorCompletedReportObj.investigationFormType,vm.profileData.firstName,vm.profileData.lastName,openInv.investigationId);"></a></div></div></div><div flex ng-if="!mediaCheck(\'xs\') && (vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || (vm.loggedUserRole == vm.APP.GLOBAL.ANALYST && openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.ANALYST_REVIEW)) \n\t\t\t\t\t\t\t\t\t\t\t\t\t&& (openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_ANALYST) && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><md-menu><md-button ng-disabled="(openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_READY || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_SELECTED ||openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.REVIEW_COMMITTEE_TABLED) && (openInv.investigatorFormInProgressList.length >1)" aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content width="4"><md-menu-item><md-button ng-click="vm.sentToAnalyst($event,\'sentToAnalyst\',investigatorCompletedReportObj);" class="fz13"><div class="statCircle lytGreyBg fleft"></div><div class="pbot9 caps" data-translate="prospects.common.sendToInvestigator"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div layout-gt-xs="row" class="mt40" ng-if="investigatorCompletedReportObj.identityResult != null && investigatorCompletedReportObj.ageResult != null && investigatorCompletedReportObj.assignerUserGroup != vm.APP.GLOBAL.EXTERNAL_INVESTIGATOR"><div flex="50" flex-xs="100"><div data-translate="prospects.reports.ageResult" class="caps reportName mb5"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.ageResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':investigatorCompletedReportObj.ageResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{investigatorCompletedReportObj.ageResult}}"></div></div></div><div flex="50" flex-xs="100"><div data-translate="prospects.reports.idResult" class="caps reportName mb5" ng-class="{\'mt10\':mediaCheck(\'xs\')}"></div><div layout="row"><div class="statCircle" ng-class="{\'grnBg\':investigatorCompletedReportObj.identityResult == vm.APP.REF_TERM.FORM_CONFIRMED, \'redBg\':investigatorCompletedReportObj.identityResult != vm.APP.REF_TERM.FORM_CONFIRMED}"></div><div class="profileInvValue fz14 caps" data-translate="prospects.{{investigatorCompletedReportObj.identityResult}}"></div></div></div></div><hr ng-if="!$last"></div></div></v-pane-content></v-pane></v-accordion></div><div class="mh20 p4 compeleteProfAccord" ng-if="openInv.removedFormList.length > 0"><v-accordion class="vAccordion--default"><v-pane expanded="true"><v-pane-header><div layout="row"><div class="closedDiv" ng-class="{\'completeAccordHeadLarge\': !mediaCheck(\'xs\'), \'completeAccordHeadSmall\':mediaCheck(\'xs\')}"><label class="w100p textCenter cursorPointer caps monstFamily fz13 lytGreyTxt ph15"><span data-translate="prospects.reports.deletedReport"></span></label></div></div></v-pane-header><v-pane-content><div class="mt30"><div ng-repeat="removedReportObj in openInv.removedFormList"><div layout-gt-xs="row"><div flex="50" flex-xs="100"><div ng-if="removedReportObj.investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" data-translate="prospects.reports.analystNameText" class="caps reportName mb5"></div><div ng-if="removedReportObj.investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM" data-translate="prospects.reports.investigatorNameText" class="caps reportName mb5"></div><div class="profileInvValue mb5" ng-bind-template="{{removedReportObj.assignerFirstName}} {{removedReportObj.assignerLastName}}"></div><div layout="row" class="monstFamily fz13 lytGreyTxt lh19"><div data-translate="prospects.common.deletedOn"></div><div class="ml5"><span ng-if="removedReportObj.monthRemovedDate" data-translate="dashboard.month.{{removedReportObj.monthRemovedDate}}"></span> <span data-translate="{{removedReportObj.dayRemovedDate}}"></span> <span data-translate="{{removedReportObj.yearRemovedDate}}"></span></div></div></div><div flex="45" flex-xs="100"><div layout="row"><div class="statCircle redBg"></div><div class="caps reportStatus mb5" data-translate="prospects.{{removedReportObj.investigationFormStatus}}"></div></div><div layout="row" class="monstFamily fz13 lytGreyTxt mb5 lh19 ml18"><div data-translate="prospects.common.assignedOn"></div><div class="ml5"><span ng-if="removedReportObj.monthinvestigationFormDate" data-translate="dashboard.month.{{removedReportObj.monthinvestigationFormDate}}"></span> <span data-translate="{{removedReportObj.dayinvestigationFormDate}}"></span> <span data-translate="{{removedReportObj.yearinvestigationFormDate}}"></span></div></div></div></div><hr ng-if="!$last"></div></div></v-pane-content></v-pane></v-accordion></div><!-- Assign Investigator Button --><div ng-if="(vm.loggedUserRole == vm.APP.GLOBAL.MANAGER || vm.loggedUserRole == vm.APP.GLOBAL.ADMIN || vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN) && (openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.UNDER_INVESTIGATION\n\t\t\t|| openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_ANALYST || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.ANALYST_REVIEW)"><div layout="row" class="m20 mt0"><md-button class="assign" ng-click="vm.search();vm.openAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR)" ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR" data-translate="prospects.assignInvestigator.investigatorTitle"></md-button></div><div layout="row" class="m20" ng-if="openInv.investigationStatus != vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR"><i class="material-icons" layout="column">add_circle</i><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)" data-translate="prospects.assignInvestigator.assignToCase"></div><md-menu-content width="4"><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_INVESTIGATOR || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.UNDER_INVESTIGATION\n\t\t\t\t\t\t\t|| openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_ANALYST || openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.ANALYST_REVIEW"><md-button ng-click="vm.search();vm.openAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.INVESTIGATOR,1)" data-translate="prospects.reports.assigninvestigator"></md-button></md-menu-item><md-menu-item ng-if="openInv.investigationStatus == vm.APP.INVESTIGATION_STATUS.PENDING_ANALYST && !(vm.loggedUserRole == vm.APP.GLOBAL.ROLE_COUNTRY_ADMIN)"><md-button ng-click="vm.search();vm.openAssignPopup($event,\'assignInvestigatorPopup\',vm.APP.INVESTIGATION.ANALYST,1)" data-translate="prospects.reports.assignanalyst"></md-button></md-menu-item></md-menu-content></md-menu></div></div><!-- </div> --><!--  Assign Investigator Ends Here --><md-divider class="investigationDivider"></md-divider><!-- Documents starts here --><!-- Documents ends here --><div layout-padding class="bgColorWh"><div class="md-subhead investigationDetailsMain"><label class="label fs15MBL pl0MBL wsnormalMBL" data-translate="prospects.documents.title"></label></div><div ng-show="vm.documentLoader"><md-progress-linear ng-show="vm.documentLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-show="!vm.documentLoader"><div ng-if="documents.length == 0" class="fz16 textCenter" data-translate="prospects.documents.noDocument"></div></div><div layout="row" flex-offset="5" class="ellipsis" ng-class="{\'mt7\': !$first}" ng-show="!vm.documentLoader" ng-repeat="ebisDocuments in documents track by $index"><span class="investigationAttachmentIcon"><i class="material-icons attachicon">attachment</i></span> <span class="investigationAttachmentFile"><a class="textstyle2 textDecorationNoneImportant" href="{{vm.downloadAPI + ebisDocuments.id}}" download>{{ebisDocuments.displayName}}</a></span></div></div></div><div ng-if="vm.profile.openStatusCount > 1 && !$last" flex-offset="5" flex-offset-xs="10" layout="row" class="box-content left divider"></div></div>');
$templateCache.put('app/investigation/prospects/profile/requestedclub.popover.html','<div layout="row"><div layout="column"><div layout="row" class="mH20p" ng-if="$even" ng-repeat="requestedClub in vm.requestedList | limitTo:vm.requestedList.length:(mediaCheck(\'xs\')?vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT:vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT)"><div layout="row" class="m5"><div class="lytGreyBg statCircle mt0p"></div><span class="colorBoldBlack roboFont">{{requestedClub}}</span></div></div></div><div layout="column" class="pl20"><div layout="row" class="mH20p" ng-if="$odd" ng-repeat="requestedClub in vm.requestedList | limitTo:vm.requestedList.length:(mediaCheck(\'xs\')?vm.APP.INVESTIGATION.REQUESTED_BY_MOBILE_COUNT:vm.APP.INVESTIGATION.REQUESTED_BY_DEFAULT_COUNT)"><div layout="row" class="m5"><div class="lytGreyBg statCircle mt0p"></div><span class="colorBoldBlack roboFont">{{requestedClub}}</span></div></div></div></div>');
$templateCache.put('app/user/userprospects/activity/user.activity.html','<div ng-style="{\'height\':windowHeight + \'px\'}" class="pb3p p10" style="overflow: auto;"><div ng-class="{activitypad:media(\'gt-xs\')}" class="pb3p"><div ng-show="vm.userActivityLoader"><md-progress-linear class="countListLoad" ng-show="vm.userActivityLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><!-- ng-show="!vm.activityLoader" --><div><div layout="column" layout-align="start start" ng-repeat="activity in vm.activity" class="ml12"><div layout="column" layout-align="start center"><div ng-if="!$first" class="box-content divider"></div><div class="act-sub-header"><span class="activityDateMapBG activityDateMap" ng-bind="activity.date"></span></div><div class="box-content divider"></div></div><div class="w100p bgColorWh act-mdlist md-whiteframe-1dp"><md-list><md-list-item class="md-3-line" ng-repeat="activityDetail in activity.investigationActivityList | orderBy:\'time\':true"><div class="md-list-item-text"><div hide-xs layout="row"><div class="p20 activityDateTime" ng-bind="activityDetail.time |date:\'shortTime\'"></div><div><img src="content/images/profile.png" class="md-avatar" style="width:32px;height:32px;"></div><div class="mt7" flex="100"><div ng-if="activityDetail.status !== vm.APP.USER.USER_CREATED" class="activityAssigner"><!-- <span class="camelCase" ng-bind="activityDetail.assignerFirstName"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="camelCase" ng-bind="activityDetail.assignerLastName"></span> --> <span ng-bind="activityDetail.assignerFirstName"></span> <span ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="activityDetail.status === vm.APP.USER.USER_CREATED" class="activityAssigner" ng-bind="activityDetail.requestedBy"></div><div ng-if="(activityDetail.status === vm.APP.USER.USER_CREATED) || (activityDetail.status === vm.APP.USER.USER_DELETED)" class="activityStatusChange pt5"><span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assignerLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="(activityDetail.status === vm.APP.USER.SUBMITTED)" class="activityStatusChange pt5"><span ng-bind="activityDetail.status"></span> <span class="grncolor" ng-bind="activityDetail.formType"></span></div><div ng-if="activityDetail.status === vm.APP.USER.ASSIGNED" class="activityStatusChange pt5"><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assigneeFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assigneeLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>to</span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assignerLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="(activityDetail.status ==  vm.APP.USER.USER_UPDATED) ||(activityDetail.status == vm.APP.USER.USER_COUNTRY_UPDATED) || (activityDetail.status == vm.APP.USER.USER_PHONE_UPDATED) || (activityDetail.status == vm.APP.USER.USER_LANGUAGE_UPDATED)" class="activityStatusChange pt5"><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assigneeFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assigneeLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assignerLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="activityDetail.status ==  vm.APP.USER.COUNTRY_VISIBILITY_ADDED" class="activityStatusChange mb10i"><span data-translate="userActivity.updated"></span> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span class="camelCase" data-translate="userActivity.countryVisibility"></span><div layout="row" class="mt5 rcActivity"><div flex="30" class="rcActivity" data-translate="userActivity.country"></div><div flex="30" class="rcActivity" data-translate="userActivity.startDate"></div><div flex="30" class="rcActivity" data-translate="userActivity.endDate"></div></div><div layout="row" class="mt5 rcActivity"><div ng-if="activityDetail.isAllCountrySelected == true" flex="30" class="grncolor camelCase rcActivity" data-translate="userActivity.allCountries"></div><div ng-if="activityDetail.isAllCountrySelected == false" flex="30" class="grncolor camelCase rcActivity" ng-bind="activityDetail.selectedCountryName != null ? activityDetail.selectedCountryName.toLowerCase() : \'-\'"></div><div flex="30" class="grncolor camelCase nowrap" ng-bind="activityDetail.countryVisibilityStartDate != null ? activityDetail.countryVisibilityStartDate : \'-\'"></div><div flex="30" class="grncolor camelCase nowrap" ng-bind="activityDetail.countryVisibilityEndDate != null ? activityDetail.countryVisibilityEndDate : \'-\'"></div></div></div><div ng-if="activityDetail.status ==  vm.APP.USER.COUNTRY_VISIBILITY_REMOVED"><span data-translate="userActivity.removed"></span> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span class="camelCase" data-translate="userActivity.countryVisibility"></span><div layout="row" class="mt5 rcActivity"><div flex="30" class="rcActivity" data-translate="userActivity.country"></div><div flex="30" class="rcActivity" data-translate="userActivity.startDate"></div><div flex="30" class="rcActivity" data-translate="userActivity.endDate"></div></div><div layout="row" class="mt5 rcActivity"><div ng-if="activityDetail.isAllCountrySelected == true" flex="30" class="grncolor camelCase rcActivity" data-translate="userActivity.allCountries"></div><div ng-if="activityDetail.isAllCountrySelected == false" flex="30" class="grncolor camelCase rcActivity" ng-bind="activityDetail.selectedCountryName != null ? activityDetail.selectedCountryName.toLowerCase() : \'-\'"></div><div flex="30" class="grncolor camelCase nowrap" ng-bind="activityDetail.countryVisibilityStartDate != null ? activityDetail.countryVisibilityStartDate : \'-\'"></div><div flex="30" class="grncolor camelCase nowrap" ng-bind="activityDetail.countryVisibilityEndDate != null ? activityDetail.countryVisibilityEndDate : \'-\'"></div></div></div></div></div><div hide-gt-sm hide-gt-xs show-xs layout="row" class="pb3p"><div><img src="content/images/profile.png" class="md-avatar" flex="100"></div><div layout="column" layout-fill class="mt7"><div ng-if="activityDetail.status !== vm.APP.USER.USER_CREATED" class="activityAssigner"><!-- <span class="camelCase" ng-bind="activityDetail.assignerFirstName"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="camelCase" ng-bind="activityDetail.assignerLastName"></span> --> <span ng-bind="activityDetail.assignerFirstName"></span> <span ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="activityDetail.status === vm.APP.USER.USER_CREATED" class="activityAssigner" ng-bind="activityDetail.requestedBy"></div><div ng-if="(activityDetail.status === vm.APP.USER.USER_CREATED) || (activityDetail.status === vm.APP.USER.SUBMITTED) || (activityDetail.status === vm.APP.USER.USER_DELETED)" class="activityStatusChange pt5"><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assigneeFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assigneeLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="activityDetail.status === vm.APP.USER.ASSIGNED" class="activityStatusChange pt5"><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assigneeFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assigneeLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>to</span> <span class="grncolor" ng-bind="activityDetail.formType"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assignerLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="(activityDetail.status ==  vm.APP.USER.USER_UPDATED) ||(activityDetail.status == vm.APP.USER.USER_COUNTRY_UPDATED) || (activityDetail.status == vm.APP.USER.USER_PHONE_UPDATED) || (activityDetail.status == vm.APP.USER.USER_LANGUAGE_UPDATED)" class="activityStatusChange pt5"><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assigneeFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assigneeLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span ng-bind="activityDetail.status"></span> <span>by</span><!-- <span class="grncolor camelCase" ng-bind="activityDetail.assignerFirstName.toLowerCase()"></span>\n\t\t\t\t\t\t\t\t\t\t<span class="grncolor camelCase" ng-bind="activityDetail.assignerLastName.toLowerCase()"></span> --> <span class="grncolor" ng-bind="activityDetail.assignerFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assignerLastName"></span></div><div ng-if="activityDetail.status ==  vm.APP.USER.COUNTRY_VISIBILITY_ADDED" class="activityStatusChange mb10i"><span data-translate="userActivity.updated"></span> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span class="camelCase" data-translate="userActivity.countryVisibility"></span><div layout="row" class="mt5 rcActivity"><div flex="40" class="rcActivity" data-translate="userActivity.country"></div><div flex="30" class="rcActivity" data-translate="userActivity.startDate"></div><div flex="30" class="rcActivity" data-translate="userActivity.endDate"></div></div><div layout="row" class="mt5 rcActivity"><div ng-if="activityDetail.isAllCountrySelected == true" flex="40" class="grncolor camelCase rcActivity" data-translate="userActivity.allCountries"></div><div ng-if="activityDetail.isAllCountrySelected == false" flex="40" class="grncolor camelCase rcActivity" ng-bind="activityDetail.selectedCountryName != null ? activityDetail.selectedCountryName.toLowerCase() : \'-\'"></div><div flex="30" class="grncolor camelCase" ng-bind="activityDetail.countryVisibilityStartDate != null ? activityDetail.countryVisibilityStartDate : \'-\'"></div><div flex="30" class="grncolor camelCase" ng-bind="activityDetail.countryVisibilityEndDate != null ? activityDetail.countryVisibilityEndDate : \'-\'"></div></div></div><div ng-if="activityDetail.status ==  vm.APP.USER.COUNTRY_VISIBILITY_REMOVED"><span data-translate="userActivity.removed"></span> <span class="grncolor" ng-bind="activityDetail.assigneeFirstName"></span> <span class="grncolor" ng-bind="activityDetail.assigneeLastName"></span> <span class="camelCase" data-translate="userActivity.countryVisibility"></span><div layout="row" class="mt5 rcActivity"><div flex="40" class="rcActivity" data-translate="userActivity.country"></div><div flex="30" class="rcActivity" data-translate="userActivity.startDate"></div><div flex="30" class="rcActivity" data-translate="userActivity.endDate"></div></div><div layout="row" class="mt5 rcActivity"><div ng-if="activityDetail.isAllCountrySelected == true" flex="40" class="grncolor camelCase rcActivity" data-translate="userActivity.allCountries"></div><div ng-if="activityDetail.isAllCountrySelected == false" flex="40" class="grncolor camelCase rcActivity" ng-bind="activityDetail.selectedCountryName != null ? activityDetail.selectedCountryName.toLowerCase() : \'-\'"></div><div flex="30" class="grncolor camelCase" ng-bind="activityDetail.countryVisibilityStartDate != null ? activityDetail.countryVisibilityStartDate : \'-\'"></div><div flex="30" class="grncolor camelCase" ng-bind="activityDetail.countryVisibilityEndDate != null ? activityDetail.countryVisibilityEndDate : \'-\'"></div></div></div></div><div layout="row" layout-align="end center" flex="20" class="mt7 mw20pp activityDateTime" ng-bind="activityDetail.time |date:\'shortTime\'"></div></div></div><md-divider></md-divider></md-list-item></md-list></div></div></div></div></div>');
$templateCache.put('app/user/userprospects/profile/user.profile.html','<div><div ng-show="vm.userProfileLoader"><md-progress-linear class="countListLoad" ng-show="vm.userProfileLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div layout="row" class="mb2p mobileEditWidth100 UserProfileInfo userProfilePadding" ng-class="{ml6p:mediaCheck(\'md\')}"><div><div class="pb12p" resize ng-style="{\'height\':windowHeight-45 + \'px\'}"><md-sidenav flex="15" class="md-sidenav-right filterPannel h100p" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="right" flex><md-content class="h100p" layout-align="center center"><div class="profileWidth" id="profileinfo usersProfileHeight"><div layout layout-align="center center" class="actProfile"><div class="ptop45"><ng-letter-avatar flex shape="round" height="124px" width="124px" data="{{vm.profile.firstName}}" dynamic="true"></ng-letter-avatar></div></div><div flex class="sideNavScroll" layout-padding><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.name"></label><div class="f3">{{vm.profile.firstName}} {{vm.profile.lastName}}</div></div><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.userrole"></label><div class="f3">{{vm.profile.userRole}}</div></div><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.email"></label><div class="f3">{{vm.profile.emailAddress}}</div></div><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.phone"></label><div ng-repeat="phone in vm.profile.phoneNumberList"><div class="f3">{{phone}}<span ng-if="!$last">,</span></div></div></div><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.country"></label><div class="f3">{{vm.profile.countryName}}</div></div><div ng-if="vm.profile.userRole == vm.APP.GLOBAL.COUNTRY_ADMIN" class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.selectedCountries"></label><div class="f3 wordWrap" ng-bind="vm.profile.visibleCountries"></div></div><div class="mb15"><label class="prospectheader" data-translate="prospects.userdetails.language"></label><div ng-repeat="language in vm.profile.userLanguageList"><div class="f3 fleft">{{language.languageName}}<span ng-if="!$last">,</span></div></div></div></div></div></md-content></md-sidenav></div></div><div class="width95p pb2p mt50 mobileEditmt70" resize ng-style="{\'height\':windowHeight-110 + \'px\'}" style="overflow-y: auto"><div ng-show="!vm.userProfileLoader" class="" layout="row" layout-xs="column" flex-offset-sm="5" flex-offset-xs="5"><div flex-offset="5" flex-offset-xs="0"></div><div class="width100"><div hide-gt-sm show-xs class="p10"></div><div><div layout="row" class=""><div ng-click="vm.openOpenedCases()" class="mw16p w148"><label class="f1 w100p textCenter cursorPointer divStyle pl10 pr10"><span ng-bind="vm.profile.openCount"></span> <span data-translate="prospects.common.openCases"></span></label></div><div ng-if="vm.profile.openCount > 0" ng-click="vm.openOpenedCases()"><div class="closeShow mw56px" ng-if="!vm.showOpenCases" data-translate="prospects.common.show"></div><div class="closeShow" ng-if="vm.showOpenCases" data-translate="prospects.common.hide"></div></div></div><div flex-offset="5" flex-offset-xs="10" class="box-content left divider"></div></div><div ng-if="vm.showOpenCases" class="bgColorWh userProfileWidth listBorder" ng-repeat="openCase in vm.profile.investigationFormOpenList"><!-- <md-card class="m0"> --><div layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center" ng-click="vm.prospectProfile(openCase.investigationId);"><div flex="10" flex-md="10" flex-xs="15"><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ openCase.prospectFirstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="70" flex-md="60" flex-xs="50"><div class="prospectName"><span ng-bind="openCase.prospectFirstName"></span><span class="pl5" ng-bind="openCase.prospectLastName"></span></div><div class="investigationsType"><span ng-bind="openCase.investigationType"></span></div></div><div flex="20" ng-if="vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR"><div ng-show="(vm.requestFlag_{{$index}} || vm.requestedShow_{{$index}})" class="redalert listEntityIcon" ng-click="vm.showIcon($event,investigation.investigationId)"></div></div><div flex="10" hide-xs show-gt-xs ng-class="vm.reopenInvestigator_{{$index}} || (vm.reopenAnalyst_{{$index}} && vm.userRole != vm.APP.GLOBAL.ROLE_INVESTIGATOR) ? \'redFlag \' : \'\'"></div><div flex="20" flex-xs="35" flex-md="30" layout="row" layout-align="space-around center"><div layout="column" layout-align="center center"><div class="montserrat p5 fwbold lh13p fz10 brad31p mw125px userActiveCount aligncenter caps" hide-xs><span ng-bind="openCase.daysOverDue"></span></div><div show-xs hide-gt-xs class="montserrat p5 fwbold lh13p fz10 brad31p mw125px userActiveCount aligncenter caps"><span ng-bind="openCase.daysOverDue"></span></div></div></div></div></div></div><div><div><div flex-offset="5" flex-offset-xs="10" class="box-content left divider"></div><div layout="row" class=""><div class="mw16p w148" ng-click="vm.openClosedCases()" ng-class="{ mw45p :mediaCheck(\'sm\'), mw25p:mediaCheck(\'lg\')}"><label class="f1 w100p textCenter cursorPointer divStyle pl10 pr10"><span ng-bind="vm.profile.closeCount"></span> <span data-translate="prospects.common.closedCases"></span></label></div><div ng-if="vm.profile.investigationFormClosedList.length>0" ng-click="vm.openClosedCases()"><div class="closeShow mw56px" ng-if="!vm.showCloseCases" data-translate="prospects.common.show"></div><div class="closeShow" ng-if="vm.showCloseCases" data-translate="prospects.common.hide"></div></div></div><div flex-offset="5" ng-if="vm.profile.investigationFormClosedList.length>0 && vm.showCloseCases" flex-offset-xs="10" class="box-content left divider"></div></div><div ng-if="vm.showCloseCases" class="bgColorWh userProfileWidth listBorder" ng-repeat="closeCase in vm.profile.investigationFormClosedList"><div layout="row" flex class="md-whiteframe-1dp"><div flex="100" layout="row" layout-margin layout-align="center center" ng-click="vm.prospectProfile(closeCase.investigationId);"><div flex="10" flex-md="10" flex-xs="15"><ng-letter-avatar shape="round" height="41px" width="41px" fontsize="18px" data="{{ closeCase.prospectFirstName| limitTo : limit : begin}}"></ng-letter-avatar></div><div flex="70" flex-md="60" flex-xs="50"><div class="prospectName"><span ng-bind="closeCase.prospectFirstName"></span><span class="pl5" ng-bind="closeCase.prospectLastName"></span></div><div class="investigationsType"><span ng-bind="closeCase.investigationType"></span></div></div><div flex="20" flex-xs="35" layout="row" layout-align="space-around center"><div layout="column" layout-align="center center"><div class="montserrat p5 fwbold lh13p fz10 brad31p mw125px userActiveCount aligncenter caps" hide-xs><span ng-bind="closeCase.daysOverDue"></span></div><div show-xs hide-gt-xs class="montserrat p5 fwbold lh13p fz10 brad31p userActiveCount aligncenter caps"><span ng-bind="closeCase.daysOverDue"></span></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/ckeditor/ckeditor/plugins/preview/preview.html','<script>// Prevent from DOM clobbering.\nif ( typeof window.opener._cke_htmlToLoad == \'string\' ) {\n\tvar doc = document;\n\tdoc.open();\n\tdoc.write( window.opener._cke_htmlToLoad );\n\tdoc.close();\n\n\tdelete window.opener._cke_htmlToLoad;\n}</script>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/addEntity.html','<div id="addNewEntityPopupId" class="md-dialog-container req-entity"><md-dialog class="addEditPopup w780" ng-class="{popupMBL:media(\'xs\')}"><!-- Flag 0: New Entity Request, Flag 1: New Entity, Flag 2: Update Entity  --><form name="addNewEntityForm" id="addEntityFormId" novalidate ng-submit="saveNewEntity(entity,addNewEntityForm,entityLocationObject,libraryAddEntityInputSearchObject)" class="addEntityForm"><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.entityTitle"></div></md-toolbar><md-dialog-content ng-show="!editFlag"><div ng-if="entityPopupLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div class="pdlr40"><div class="pb10 pt30imp popupHr mb15" data-translate="library.popup.entityDetails"></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><div flex class="alignpb mb17" ng-class="{\'w100Imp mt20\':media(\'xs\') || media(\'sm\'), \'mb20\':addNewEntityForm.entityName.$error.required && addNewEntityForm.$submitted}" flex="50"><label class="popupLbl required pl0imp" data-translate="library.popup.labels.entityType"></label><md-select ng-disabled="updateFlag" ng-change="clearEntity();" ng-required="addNewEntityForm.$submitted" ng-model-options="{trackBy: \'$value.id\'}" name="entityTypeSearchKey" ng-model="entity.entityTypeSearchKey" placeholder="{{entity.entityTypeSearchKey.id == undefined ? (\'library.popup.labels.selectType\' | translate) : entity.entityTypeSearchKey.name }}" ng-class="{borderError:addNewEntityForm.entityTypeSearchKey.$error.required}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border"><md-option ng-value="dropValueLan" ng-repeat="dropValueLan in entityTypeList">{{dropValueLan.name}}</md-option></md-select><div ng-messages="addNewEntityForm.entityTypeSearchKey.$error"><div ng-if="addNewEntityForm.entityTypeSearchKey.$error.required && addNewEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div flex-gt-sm="10"></div><div flex class="alignpb mb17" ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}" flex="50"><label class="popupLbl required pl0imp marginLeftZero" data-translate="library.popup.labels.entityName"></label><!-- required --><!-- <div layout="column"  layout-align="start start" class="popupLbl required pl0imp" data-translate="library.popup.labels.entityName"></div> --><div layout="row"><i ng-if="entity.entityName.id && !updateFlag" ng-click="clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-select flex ng-required="!entity.entityName" ng-hide="isHide  && !entity.entityName.id" ng-class="{borderError:addNewEntityForm.entityName.$error.required && addNewEntityForm.$submitted}" ng-disabled="entity.entityTypeSearchKey.id == null" md-on-close="clearOnClose(\'entity.inputSearchText\',\'entityNameList\');" name="entityName" ng-model="entity.entityName" ng-change="getEntityProfileById(entity.entityName.id);" placeholder="{{entity.entityName.id == undefined ? (\'library.popup.labels.searchName\' | translate) : entity.entityName.name }}" class="popupFont md-no-underline selectHeader dropdownSelection caps ofH border"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input ng-keydown="$event.stopPropagation();" ng-blur="" focus no-special-char common-search search-callback="searchEntity(entity.inputSearchText,entity.entityTypeSearchKey.id)" ng-model="entity.inputSearchText" type="search" placeholder="{{\'library.search.searchEntity\' | translate}}" class="left-drop-library-search mb18 cursorText" ng-minlength="2"></md-input-container></md-select-header><div class="searchNotification" ng-hide="entity.inputSearchText.length >1" data-translate="library.filters.minsearch"></div><div ng-if="entityNameLoader"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><md-optgroup label="entityNameList" class="stickySearch"><md-option ng-value="dropValue" ng-repeat="dropValue in entityNameList">{{dropValue.name}}<div class="investigationsType camelCase" hide-xs><span ng-bind="dropValue.cityName.toLowerCase()"></span></div><md-tooltip class="camelCase" md-direction="bottom"><span>{{dropValue.name.toLowerCase()}}</span></md-tooltip></md-option></md-optgroup><div class="searchNotification" ng-if="entityNameList.length == 0 && entity.inputSearchText.length > 1" data-translate="library.filters.noresult"></div></md-select></div><div layout="row"><i ng-if="isHide && !entity.entityName.id" ng-click="clearEntity();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i><md-input-container flex ng-required="!entity.entityName" name="entityNameSearchKey" ng-show="isHide && !entity.entityName.id" md-no-float class="locationPopInputSty widthclass" flex><input id="entityNameSearchTextId" class="right-dropdown-search camelCase popupFont" ng-model="entity.entityName" type="search"></md-input-container></div><div ng-messages="addNewEntityForm.entityName.$error"><div ng-if="addNewEntityForm.entityName.$error.required && addNewEntityForm.$submitted" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><form-location-filter disable-flag="entity.entityName.id != null && !updateFlag" class="width100" inputsearch-object="libraryAddEntityInputSearchObject" model-object="entityLocationObject" horizon-flag="true" add-new-location="true" call="" form-name="addNewEntityForm" is-validation="true"></form-location-filter></div><div flex layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="alignpb" flex ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.personName"></label><!-- <input ng-disabled="entity.entityName.id != null && !updateFlag" type="text" name="contactPerson" ng-model="entity.contactPersonName" class="popupFont" no-special-char ng-pattern="/^(\\D)+$/"> --> <input ng-disabled="entity.entityName.id != null && !updateFlag" type="text" name="contactPerson" ng-model="entity.contactPersonName" class="popupFont" no-special-char><!-- <div ng-messages="addNewEntityForm.contactPerson.$error">                            \t\n\t                            \t<div  ng-if="!addNewEntityForm.contactPerson.$error.required && addNewEntityForm.contactPerson.$error.pattern"><span data-translate="library.popup.validation.name"></span></div>                 \t\n\t                            </div> --></md-input-container><div flex-gt-sm="10"></div><md-input-container class="alignpb" flex ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.number"></label><!-- <input ng-disabled="entity.entityName.id != null && !updateFlag" no-special-char type="text" phone-input name="contactNumber" ng-model="entity.contactPhoneNumber" class="popupFont"> --> <input ng-disabled="entity.entityName.id != null && !updateFlag" type="text" name="contactNumber" ng-model="entity.contactPhoneNumber" class="popupFont"></md-input-container></div><div flex class="mtm13" layout-gt-sm="row" layout-align="space-between center" layout-align-xs="space-between start" layout-align-sm="space-between start"><md-input-container class="alignpb" flex ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.email"></label><!-- <input ng-disabled="entity.entityName.id != null && !updateFlag" type="email" name="contactEmail" ng-model="entity.contactEmail" class="popupFont"> --> <input ng-disabled="entity.entityName.id != null && !updateFlag" validate-email type="email" name="contactEmail" ng-model="entity.contactEmail" ng-model-options="{ updateOn: \'blur\'}" class="popupFont"><div ng-messages="addNewEntityForm.contactEmail.$error"><div ng-if="!addNewEntityForm.contactEmail.$error.required && addNewEntityForm.contactEmail.$error.email"><span data-translate="library.popup.validation.email"></span></div></div></md-input-container><div flex-gt-sm="10"></div><div layout="row" class="alignpb" flex ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}"><label class="popupLbl mt20 mr20 pl0imp" data-translate="library.popup.labels.flag"></label><md-switch ng-disabled="entity.entityName.id != null && !updateFlag" class="md-primary" ng-model="entity.flag" aria-label="Switch 1"></md-switch></div></div><div layout-align="space-between start" flex class="w95" ng-class="{w90:media(\'xs\') || media(\'sm\')}"><label class="popupLbl pl0imp" data-translate="library.popup.labels.comment"></label><md-input-container class="md-block" ng-class="{w100Imp:media(\'xs\') || media(\'sm\')}"><textarea ng-disabled="entity.entityName.id != null && !updateFlag" ng-required="addNewEntityForm.$submitted && entity.flag" name="comment" ng-model="entity.comments" row="3" class="popupCmt resizeNone greyBorder hyt60p"></textarea><div ng-messages="addNewEntityForm.comments.$error"><div class="redTxt" ng-if="addNewEntityForm.$submitted && addNewEntityForm.comments.$error.required"><span data-translate="library.popup.validation.comment"></span></div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions class="borderNone pd50" ng-class="{pl0imp:media(\'xs\'), pr30impMBL:editFlag && loggedUserRole == APP.GLOBAL.MANAGER}"><div layout="row"><div ng-if="existFlag" data-translate="library.popup.validation.exsits" class="errorMsg mt15"></div><div ng-if="flag == 0"><md-button class="saveOrClose caps color-red" ng-click="cancel(addNewEntityForm);" data-translate="library.popup.cancel"></md-button><md-button ng-disabled="entity.entityName.id != null || disableSaveButton == true" type="submit" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.save"></md-button></div></div></md-dialog-actions></form></md-dialog></div><div id="locationRequestPopupId" class="md-dialog-container"><form name="addlocationRequestForm" id="addlocationRequestFormId" class="addlocationRequestForm" ng-class="{\'w100p\': media(\'xs\')}"><md-dialog class="popup noHScroll addEditPopup" ng-class="{\'popupMBL\':media(\'xs\'), \'w500\':flag == 0 && !media(\'xs\')}"><!-- ,\'w400\':flag != 1 --><md-toolbar><div layout layout-align="center center" class="actProfile popupTle" data-translate="library.popup.locationTitle"></div></md-toolbar><md-dialog-content class="h65MBL noHScroll"><div class="pd50 pt40 pt15MBL"><div class="pb10 pt10 popupHr w400p" data-translate="library.popup.locationSubTitle"></div><form-location-filter model-object="saveOrAddLocationObject" inputsearch-object="addLocationInputSearchObject" horizon-flag="true" add-new-location="true" call="" is-validation="true"></form-location-filter></div></md-dialog-content><md-dialog-actions class="borderNone pd50"><div ng-if="isValidLocation" flex="50" flex-xs="100" class="ph5"><span class="redTxt monstFamily fz13" data-translate="library.popup.validation.locationExists"></span></div><div layout-gt-sm="row" class="w100p" layout-align="end end"><div layout="row" flex-xs="100" layout-align="end center"><md-button class="saveOrClose caps color-red test" ng-click="cancelLocation(addlocationRequestForm, flag, event)" data-translate="library.popup.cancel"></md-button><md-button type="button" class="saveOrClose caps color-yellow buttonColor" data-translate="library.popup.add" ng-disabled="disableButton.isDisabled" ng-click="disableButton.isDisabled = true; saveLocation(saveOrAddLocationObject,addLocationInputSearchObject,null,null,null,false);"></md-button></div></div></md-dialog-actions></md-dialog></form></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/investigation.form.header.html','<!-- <investigation-form-sidenav  hide-gt-sm></investigation-form-sidenav> --><div layout="row"><div layout="row" layout-align="start center"><div hide-gt-sm ng-click="sectionLeft();"><i class="material-icons ml25" style="color:white">sort</i></div></div><div layout="column" flex class="plr5p prospectHeaderSize prospectPad"><div class="prospectProfileBack" ng-class="{\'mb10\' : vm.user.authorities[0] == vm.app.GLOBAL.ROLE_INVESTIGATOR}" ng-if="vm.formProfile.firstName ||  vm.formProfile.lastName"><span class="monstFamily halfOpacity caps white-text" ng-class="{\'fz13\' : vm.user.authorities[0] != vm.app.GLOBAL.ROLE_INVESTIGATOR,\'fz20\' : vm.user.authorities[0] == vm.app.GLOBAL.ROLE_INVESTIGATOR}" ng-click="vm.backProfile();">{{vm.formProfile.firstName}} {{vm.formProfile.lastName}}</span> <span class="letsp1p fz10 monstFamily halfOpacity caps white-text" ng-class="{\'ptop6\' : vm.user.authorities[0] == vm.app.GLOBAL.ROLE_INVESTIGATOR,\'ptop8\' : vm.user.authorities[0] != vm.app.GLOBAL.ROLE_INVESTIGATOR}" ng-click="vm.backProfile();"><i class="material-icons">&#xE315;</i></span></div><div ng-if="vm.user.authorities[0] != vm.app.GLOBAL.ROLE_INVESTIGATOR && vm.formProfile.investigationType!= undefined"><span class="caps white-text fz30 fz20i" data-translate="prospects.{{vm.formProfile.investigationType}}"></span></div></div></div><!-- <div hide-gt-sm show-xs flex class="plr3p bgc-blue prospectHeaderXs" layout="row">\n\t\t<div ng-click="vm.back()" class="letsp1p fz10 monstFamily halfOpacity caps white-text mt30 mr20"><i class="material-icons">&#xE317;</i></div>\n\t\t<div flex class="pb10 pt20"><span class="caps white-text fz30" ng-bind="vm.prospectName"><span></div>\n\t</div>  --><div layout="row" class="prosHeadPart" style="overflow-y:auto; overflow-x:hidden;background-color:#f4f8f9;"><div ui-view="invesForm" flex class="lytWhiteBg smoothScroll" style="overflow-y:auto; overflow-x:hidden;"></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/investigation.form.html','<div layout="column" class="mb25 mt25" layout-align="space-around"><div flex layout="row" ng-if="lastEditTime" layout-align="center center"><i class="material-icons fz20 greyColor">access_time</i> <span class="greyColor ml5" data-translate="prospects.profileFormDetails.lastEditTime"></span> <span class="greyColor ml5" ng-bind="lastEditTime"></span></div></div><div layout="row" flex class="formSideML" ng-init="vm.checkSectionFormType();"><investigation-form-sidenav></investigation-form-sidenav><div ui-view="dynamicViewForInvestigationForm" class="formBorderStyle bcMain mt0i ml2P"></div></div><div ng-include src="\'app/investigation/prospects/profile/investigation-form/warning.popup.html\'" style="display:none;"></div><div ng-include src="\'app/investigation/prospects/profile/investigation-form/addEntity.html\'" style="display:none;"></div><div class="hide"><div id="formSectionChange" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.formSectionChange"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.backToCurrentSection();" data-translate="answer_no"></md-button><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.changeSection();" data-translate="answer_yes"></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- <div ng-include  src="\'app/investigation/prospects/profile/investigation-form/summary/formSubmitConform.html\'"></div> -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/investigation.form.sidenav.html','<md-sidenav layout-align-gt-sm="end end" class="md-sidenav-left bgi formSidemt0i mobileNavBar" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="formLeft" ng-class="{lytWhiteBg :mediaCheck(\'gt-sm\')}"><md-content class="mw100i backColorTrans" style="max-width:200px;" ng-class="{formSideContentColor :mediaCheck(\'gt-sm\')}"><div class="navHead"><div class="navHeading"><div class="fz16 fwb monstFamily tc-white">{{vm.formProfile.firstName}} {{vm.formProfile.middleName}} {{vm.formProfile.lastName}}</div></div><div class="ml15 navDateandcountry">{{vm.formProfile.country}}</div><div class="ml15 pb10 navDateandcountry"><span data-translate="dashboard.month.{{vm.formProfile.dobMonth}}"></span> <span data-translate="{{vm.formProfile.dobDay}}"></span> <span data-translate="{{vm.formProfile.dobYear}}"></span></div><div ng-if="investigationFormType != vm.app.INVESTIGATION.ANALYST_FORM && isView" class="copyBtn mb10 ml23" ng-click="vm.formSectionCopy(vm.sectionValue,$event,\'warningPopupId\');" ng-class="{\'copySelectedDisableBg\':!vm.sectionValue.birthcerticate_checked && !vm.sectionValue.birthAndMedical_checked && !vm.sectionValue.neighbourhoodCanvas_checked \n \t\t\t\t&& !vm.sectionValue.familyInfo_checked && !vm.sectionValue.schoolInfo_checked && !vm.sectionValue.religiousInstitution_checked && !vm.sectionValue.residencyQuestion_checked\n \t\t\t\t && !vm.sectionValue.other_checked && !vm.sectionValue.summary_checked}"><md-button ng-disabled="!vm.sectionValue.birthcerticate_checked && !vm.sectionValue.birthAndMedical_checked && !vm.sectionValue.neighbourhoodCanvas_checked \n \t\t\t\t&& !vm.sectionValue.familyInfo_checked && !vm.sectionValue.schoolInfo_checked && !vm.sectionValue.religiousInstitution_checked && !vm.sectionValue.residencyQuestion_checked\n \t\t\t\t && !vm.sectionValue.other_checked && !vm.sectionValue.summary_checked" class="copyLabel m0 ml10" data-translate="COPY SELECTED" ng-class="{\'copySelectedDisableFont\':!vm.sectionValue.birthcerticate_checked && !vm.sectionValue.birthAndMedical_checked && !vm.sectionValue.neighbourhoodCanvas_checked \n \t\t\t\t&& !vm.sectionValue.familyInfo_checked && !vm.sectionValue.schoolInfo_checked && !vm.sectionValue.religiousInstitution_checked && !vm.sectionValue.residencyQuestion_checked\n \t\t\t\t&& !vm.sectionValue.other_checked && !vm.sectionValue.summary_checked}"></md-button></div><div class="ml18" ng-if="formValid.birthCertificateFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-click="vm.selectAllSection(vm.selectAll);" ng-model="vm.selectAll">Select All</md-checkbox></div></div><div resize ng-style="{ \'max-height\' : mediaCheck(\'gt-sm\') ? (windowHeight-185 +\'px\') : (windowHeight +\'px\') }" style="overflow-y:auto; overflow-x:hidden" class="md-accordion"><div class="menuPosition accordian-holder" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/birthCertificate\')}" ng-click="vm.collapseAll(0);vm.birthCertificateCall();vm.sideNavClose();"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.birthCertificateFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.birthCertificateFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.birthcerticate_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/birthCertificate\')}" data-translate="prospects.investigationFormHeaders.birthCertificate"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[0]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllBCType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllBCType.firstObj.checked, 0, birthCertificateCheckList, vm.selectAllBCType);" ng-model="vm.selectAllBCType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllBCType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllBCType.secondObj.checked, 1, birthCertificateCheckList, vm.selectAllBCType);" ng-model="vm.selectAllBCType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllBCType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllBCType.thirdObj.checked, 2, birthCertificateCheckList, vm.selectAllBCType);" ng-model="vm.selectAllBCType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllBCType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllBCType.fourthObj.checked, 3, birthCertificateCheckList, vm.selectAllBCType);" ng-model="vm.selectAllBCType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentObj in birthCertificateCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentObj.questionValue" data-translate="{{parentObj.dataTranslate}}"></div><md-divider ng-if="parentObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentObj.others_Checked" ng-click="vm.clearfield(\'BIRTH_CERTIFICATE\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentObj.questionValue == \'Other\' && parentObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span ng-if="parentObj.questionValue != \'Other\' || parentObj.others_Checked" class="tes" layout-align-xs="space-between center" ng-repeat="childObj in parentObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0, \'yellowCheckbox\':$index==1,\'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllBCType); vm.toggleList(birthCertificateCheckList,parentObj.checkBoxDTOList,$index,$parent.$index,childObj,vm.selectAllBCType);" ng-model="childObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(1);vm.birthMedicalCall();vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/birthMedicalReport\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.birthandMedicalInfoFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="(formValid.birthandMedicalInfoFormStatus === undefined && isView) || vm.sectionValue.birthcerticate_checked"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.birthAndMedical_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/birthMedicalReport\')}" data-translate="prospects.investigationFormHeaders.birthRecords"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[1]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllBirthMedicalRecordType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllBirthMedicalRecordType.firstObj.checked, 0, birthMedicalCheckList, vm.selectAllBirthMedicalRecordType);" ng-model="vm.selectAllBirthMedicalRecordType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllBirthMedicalRecordType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllBirthMedicalRecordType.secondObj.checked, 1, birthMedicalCheckList, vm.selectAllBirthMedicalRecordType);" ng-model="vm.selectAllBirthMedicalRecordType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllBirthMedicalRecordType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllBirthMedicalRecordType.thirdObj.checked, 2, birthMedicalCheckList, vm.selectAllBirthMedicalRecordType);" ng-model="vm.selectAllBirthMedicalRecordType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllBirthMedicalRecordType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllBirthMedicalRecordType.fourthObj.checked, 3, birthMedicalCheckList, vm.selectAllBirthMedicalRecordType);" ng-model="vm.selectAllBirthMedicalRecordType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentBMObj in birthMedicalCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentBMObj.questionValue" data-translate="{{parentBMObj.dataTranslate}}"></div><md-divider ng-if="parentBMObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentBMObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentBMObj.others_Checked" ng-click="vm.clearfield(\'BIRTH_MEDICAL\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentBMObj.questionValue == \'Other\' && parentBMObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentBMObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span class="tes" ng-if="parentBMObj.questionValue != \'Other\' || parentBMObj.others_Checked" layout-align-xs="space-between center" ng-repeat="childBMObj in parentBMObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0,\'yellowCheckbox\':$index==1, \'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentBMObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllBirthMedicalRecordType); vm.toggleList(birthMedicalCheckList,parentBMObj.checkBoxDTOList,$index,$parent.$index,childBMObj,vm.selectAllBirthMedicalRecordType);" ng-model="childBMObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(2);vm.neighbourhoodCall();vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/neighbourhoodCanvas\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.neighbourhoodFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.neighbourhoodFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.neighbourhoodCanvas_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/neighbourhoodCanvas\')}" data-translate="prospects.investigationFormHeaders.neighbourhoodCanvas"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[2]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllNeighbourhoodType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllNeighbourhoodType.firstObj.checked, 0, neighbourhoodCheckList, vm.selectAllNeighbourhoodType);" ng-model="vm.selectAllNeighbourhoodType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllNeighbourhoodType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllNeighbourhoodType.secondObj.checked, 1, neighbourhoodCheckList, vm.selectAllNeighbourhoodType);" ng-model="vm.selectAllNeighbourhoodType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllNeighbourhoodType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllNeighbourhoodType.thirdObj.checked, 2, neighbourhoodCheckList, vm.selectAllNeighbourhoodType);" ng-model="vm.selectAllNeighbourhoodType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllNeighbourhoodType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllNeighbourhoodType.fourthObj.checked, 3, neighbourhoodCheckList, vm.selectAllNeighbourhoodType);" ng-model="vm.selectAllNeighbourhoodType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentNHObj in neighbourhoodCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentNHObj.questionValue" data-translate="{{parentNHObj.dataTranslate}}"></div><md-divider ng-if="parentNHObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentNHObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentNHObj.others_Checked" ng-click="vm.clearfield(\'NEIGHBORHOOD_CANVASS\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentNHObj.questionValue == \'Other\' && parentNHObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentNHObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span ng-if="parentNHObj.questionValue != \'Other\' || parentNHObj.others_Checked" class="tes" layout-align-xs="space-between center" ng-repeat="childNHObj in parentNHObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0,\'yellowCheckbox\':$index==1,\'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentNHObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllNeighbourhoodType); vm.toggleList(neighbourhoodCheckList,parentNHObj.checkBoxDTOList,$index,$parent.$index,childNHObj,vm.selectAllNeighbourhoodType);" ng-model="childNHObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(3);vm.familyCall();vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/familyInformation\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.familyInformationFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.familyInformationFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.familyInfo_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/familyInformation\')}" data-translate="prospects.investigationFormHeaders.familyInfo"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[3]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllFamilyType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllFamilyType.firstObj.checked, 0, familyCheckList, vm.selectAllFamilyType);" ng-model="vm.selectAllFamilyType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllFamilyType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllFamilyType.secondObj.checked, 1, familyCheckList, vm.selectAllFamilyType);" ng-model="vm.selectAllFamilyType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllFamilyType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllFamilyType.thirdObj.checked, 2, familyCheckList, vm.selectAllFamilyType);" ng-model="vm.selectAllFamilyType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllFamilyType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllFamilyType.fourthObj.checked, 3, familyCheckList, vm.selectAllFamilyType);" ng-model="vm.selectAllFamilyType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentFamObj in familyCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentFamObj.questionValue" data-translate="{{parentFamObj.dataTranslate}}"></div><md-divider ng-if="parentFamObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentFamObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentFamObj.others_Checked" ng-click="vm.clearfield(\'FAMILY_INFORMATION\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentFamObj.questionValue == \'Other\' && parentFamObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentFamObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span ng-if="parentFamObj.questionValue != \'Other\' || parentFamObj.others_Checked" class="tes" layout-align-xs="space-between center" ng-repeat="childFamObj in parentFamObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0,\'yellowCheckbox\':$index==1,\'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentFamObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllFamilyType); vm.toggleList(familyCheckList,parentFamObj.checkBoxDTOList,$index,$parent.$index,childFamObj,vm.selectAllFamilyType);" ng-model="childFamObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(4);vm.schoolCall();vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/schoolInformation\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.schoolInfoFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.schoolInfoFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.schoolInfo_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/schoolInformation\')}" data-translate="prospects.investigationFormHeaders.schoolInfo"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[4]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllSchoolType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllSchoolType.firstObj.checked, 0, schoolCheckList, vm.selectAllSchoolType);" ng-model="vm.selectAllSchoolType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllSchoolType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllSchoolType.secondObj.checked, 1, schoolCheckList, vm.selectAllSchoolType);" ng-model="vm.selectAllSchoolType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllSchoolType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllSchoolType.thirdObj.checked, 2, schoolCheckList, vm.selectAllSchoolType);" ng-model="vm.selectAllSchoolType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllSchoolType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllSchoolType.fourthObj.checked, 3, schoolCheckList, vm.selectAllSchoolType);" ng-model="vm.selectAllSchoolType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentSchoolObj in schoolCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentSchoolObj.questionValue" data-translate="{{parentSchoolObj.dataTranslate}}"></div><md-divider ng-if="parentSchoolObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentSchoolObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentSchoolObj.others_Checked" ng-click="vm.clearfield(\'SCHOOL_INFORMATION\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentSchoolObj.questionValue == \'Other\' && parentSchoolObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentSchoolObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span ng-if="parentSchoolObj.questionValue != \'Other\' || parentSchoolObj.others_Checked" class="tes" layout-align-xs="space-between center" ng-repeat="childSchoolObj in parentSchoolObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0,\'yellowCheckbox\':$index==1,\'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentSchoolObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllSchoolType); vm.toggleList(schoolCheckList,parentSchoolObj.checkBoxDTOList,$index,$parent.$index,childSchoolObj,vm.selectAllSchoolType);" ng-model="childSchoolObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(5);vm.religiousCall();vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/religiousInstitution\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.relegiousInformationFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.relegiousInformationFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.religiousInstitution_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/religiousInstitution\')}" data-translate="prospects.investigationFormHeaders.religiousInstitution"></div></div></div><div ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-class="{dataContent:true, activeContent:sideNavAccordion[5]}" class="checkBoxBgColor"><div ng-if="summaryActivated"><div layout="row"><div class="checkBoxContentStyle pl6" data-translate="prospects.AnalystFormAnalysis.selectAll"></div><md-menu><div layout="column" class="ml10" ng-click="vm.openMenu($mdOpenMenu, $event)"><i class="material-icons fz12">help</i></div><md-menu-content width="4"><md-menu-item><div layout="row"><md-checkbox class="greenCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.support"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="yellowCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.inconclusive"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="redCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notSupport"></div></div></md-menu-item><md-menu-item><div layout="row"><md-checkbox class="whiteCheckbox md-checked" ng-disabled="true"></md-checkbox><div data-translate="prospects.AnalystFormAnalysis.notApplicable"></div></div></md-menu-item></md-menu-content></md-menu></div><div id="selectAll" layout="row"><md-checkbox class="greenCheckbox" ng-checked="vm.isChecked(vm.selectAllReligiousType.firstObj)" ng-click="vm.toggleAll(!vm.selectAllReligiousType.firstObj.checked, 0, religiousCheckList, vm.selectAllReligiousType);" ng-model="vm.selectAllReligiousType.firstObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="yellowCheckbox" ng-checked="vm.isChecked(vm.selectAllReligiousType.secondObj)" ng-click="vm.toggleAll(!vm.selectAllReligiousType.secondObj.checked, 1, religiousCheckList, vm.selectAllReligiousType);" ng-model="vm.selectAllReligiousType.secondObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="redCheckbox" ng-checked="vm.isChecked(vm.selectAllReligiousType.thirdObj)" ng-click="vm.toggleAll(!vm.selectAllReligiousType.thirdObj.checked, 2, religiousCheckList, vm.selectAllReligiousType);" ng-model="vm.selectAllReligiousType.thirdObj.checked" ng-disabled="isreadonly"></md-checkbox><md-checkbox class="whiteCheckbox" ng-checked="vm.isChecked(vm.selectAllReligiousType.fourthObj)" ng-click="vm.toggleAll(!vm.selectAllReligiousType.fourthObj.checked, 3, religiousCheckList, vm.selectAllReligiousType);" ng-model="vm.selectAllReligiousType.fourthObj.checked" ng-disabled="isreadonly"></md-checkbox></div></div><div><div ng-repeat="parentRelObj in religiousCheckList track by $index"><div layout="row" id="checkBoxContentStyle"><div class="checkBoxContentStyle pl6" ng-bind="parentRelObj.questionValue" data-translate="{{parentRelObj.dataTranslate}}"></div><md-divider ng-if="parentRelObj.questionValue == \'Other\'"></md-divider><md-checkbox ng-if="parentRelObj.questionValue == \'Other\'" class="OtherWhiteCheckbox" ng-model="parentRelObj.others_Checked" ng-click="vm.clearfield(\'RELIGIOUS_INSTITUTION\');" ng-disabled="isreadonly"></md-checkbox></div><div class="othersInput" ng-if="parentRelObj.questionValue == \'Other\' && parentRelObj.others_Checked"><input ng-disabled="isreadonly" auto-focus ng-model="parentRelObj.subAnswer" type="text" class="test" maxlength="30" style="width: 155px;border-radius: 4px;" required></div><span ng-if="parentRelObj.questionValue != \'Other\' || parentRelObj.others_Checked" class="tes" layout-align-xs="space-between center" ng-repeat="childRelObj in parentRelObj.checkBoxDTOList track by $index"><md-checkbox ng-class="{\'greenCheckbox\':$index==0,\'yellowCheckbox\':$index==1,\'redCheckbox\':$index==2,\'whiteCheckbox\':$index==3}" ng-change="vm.toggleSubList(parentRelObj.checkBoxDTOList,$index,$parent.$index,vm.selectAllReligiousType); vm.toggleList(religiousCheckList,parentRelObj.checkBoxDTOList,$index,$parent.$index,childRelObj,vm.selectAllReligiousType);" ng-model="childRelObj.checked" ng-disabled="isreadonly"></md-checkbox></span></div></div></div><div class="menuPosition" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" ng-click="vm.collapseAll(6);vm.loadSectionFormByType(\'dnaInfoForm\');vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/dnaInformation\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.recedencyQuestionsFormStatus === undefined"><img src="content/images/Pending.png"></div><div flex class="formType" data-translate="prospects.investigationFormHeaders.dnaInfo"></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(7);vm.loadSectionFormByType(\'residencyQuestionForm\');vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/residencyQuestions\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.recedencyQuestionsFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.recedencyQuestionsFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.residencyQuestion_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/residencyQuestions\')}" data-translate="prospects.investigationFormHeaders.residencyQuestions"></div></div></div><div class="menuPosition" ng-click="vm.collapseAll(8);vm.loadSectionFormByType(\'otherForm\');vm.sideNavClose();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/other\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.otherFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.otherFormStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.other_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/other\')}" data-translate="prospects.investigationFormHeaders.other"></div></div></div><div class="menuPosition" ng-click="vm.summarycall();" ng-class="{\'activeSectionForm\' : vm.isActiveSectionForm(\'/summary\')}"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.summaryStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div class="ml18" ng-if="formValid.summaryStatus === undefined && isView"><md-checkbox class="greenCheckbox mbt0" ng-model="vm.sectionValue.summary_checked" ng-click="vm.unselect()"></md-checkbox></div><div flex class="formType" ng-class="{\'th-select\' : vm.isActiveSectionForm(\'/summary\')}" data-translate="prospects.investigationFormHeaders.summary.summary"></div></div></div></div></md-content></md-sidenav>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/warning.popup.html','<!-- copy investigation form confirmation popup --><div id="warningPopupId" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center" ng-hide="vm.warrnFlag"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="WarnSub mb35"><span data-translate="prospects.Warning.copyInvestigationForm"></span></div><div layout="column" class="warningSub" ng-repeat="Det in investigationSectionObj.name"><div layout="row" class="mb6"><div class="blackCircle mr18"></div><div>{{Det}}</div></div><md-divider></md-divider></div></div><div layout="column"><md-button layout="row" layout-align="center center" ng-disabled="vm.copyDisable" class="warnbtn btnwidth" ng-click="vm.submitWarn()" role="button"><md-progress-circular md-mode="indeterminate" ng-show="vm.copyDisable" class="md-hue-2" md-diameter="20px"></md-progress-circular><span ng-class="{ml10 : vm.copyDisable}" data-translate="prospects.Warning.submit"></span></md-button><md-button ng-disabled="vm.copyDisable" class="mt15 btnwidth" ng-click="vm.goBack()" data-translate="prospects.assignInvestigator.goback"></md-button></div></div><div layout="column" layout-margin layout-align="center center" ng-show="vm.warrnFlag"><div layout="column"><div class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center"><div class="WarnSub"><span data-translate="prospects.Warning.select"></span></div></div><div layout="column" layout-align="center center" class="mtn17"><md-button class="warnbtn warnBtnWid" role="button" ng-click="vm.openAnalystForm(39);" data-translate="prospects.Warning.open"></md-button><md-button class="mt15 warnBtnWid" ui-sref="profile" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div></md-dialog-content></md-dialog></div><div class="hide"><!-- Check box missing warning popup --><div id="provideDetailsPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign textcenter"><span data-translate="prospects.Warning.checkBoxMissing"></span></div><div class="assignSub"><span data-translate="prospects.Warning.checkAllCheckBox"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-click="vm.gobacktoForm();" data-translate="prospects.common.ok"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Upload file delete confirmation popup --><div id="deleteUploadFilePopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteUploadFile"></span></div><!-- <div class="WarnSub">\n\t\t\t\t\t\t\t\t <span data-translate="prospects.Warning.operationUndone"></span>  \n\t\t\t\t\t\t\t</div> --></div><div><md-button ng-click="vm.gobacktoForm();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="deleteFile();" data-translate="delete"></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Upload file confirmation popup --><div id="uploadFileConfirmationPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.formUploadWarning"></span></div><!-- <div class="WarnSub">\n\t\t\t\t\t\t\t\t<span data-translate="prospects.Warning.operationUndone"></span>\n\t\t\t\t\t\t\t</div> --></div><div><md-button ng-click="vm.gobacktoForm();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="vm.disableUpload" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="uploadFile();" data-translate="prospects.common.upload"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/profile/rc/rc.details.html','<div layout="row" flex class="formSideML" ng-init="vm.getRCSessionData();"><md-sidenav layout-align-gt-sm="start end" class="md-sidenav-left mt50 bgi formSidemt0i mobileNavBar" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="formLeft" ng-class="{lytWhiteBg :mediaCheck(\'gt-sm\')}"><md-content class="mw100i backColorTrans" style="max-width:200px;" ng-class="{formSideContentColor :mediaCheck(\'gt-sm\')}"><div class="navHead"><div class="navHeading"><div class="fz16 fwb monstFamily tc-white">{{vm.RCMeetingData.prospectFirstName}} {{vm.RCMeetingData.prospectMiddleName}} {{vm.RCMeetingData.prospectLastName}}</div></div><div class="ml15 navDateandcountry">{{vm.RCMeetingData.prospectBirthCountry}}</div><div class="ml15 pb10 navDateandcountry"><span ng-if="vm.RCMeetingData.prospectDobMonth" data-translate="dashboard.month.{{vm.RCMeetingData.prospectDobMonth}}"></span> <span data-translate="{{vm.RCMeetingData.prospectDobDay}}"></span> <span data-translate="{{vm.RCMeetingData.prospectDobYear}}"></span></div></div><div class="md-accordion"><div class="menuPosition activeSectionForm" ng-click="vm.sideNavClose();"><div layout="row" flex layout-align="space-between center"><div class="ml18 mr12" ng-if="formValid.otherFormStatus === undefined && !isView"><img src="content/images/Pending.png"></div><div flex class="formType th-select" data-translate="rc"></div></div></div></div></md-content></md-sidenav><div ng-if="resizingRCPage" id="rcDetails" class="formBorderStyle bcMain mt50 mt0i ml2P" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-40 +\'px\') : (windowHeight +\'px\') }" style="overflow-y:auto; overflow-x:hidden"><!-- RC Meeting Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bcHeader fs17i" data-translate="title"></div></div><!-- RC Meeting  Header End --><div ng-if="loadingRCSessionData"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingRCSessionData"><div class="dividerDiv"></div><form name="RCDetails"><fieldset ng-disabled="vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': rcDate}">1</div></div><div flex layout="row" layout-xs="column"><div flex="50" flex-xs="5" flex-offset-xs="5" class="quesStyle mt5 mb10" data-translate="rcDate"></div><div flex="50" flex-xs="10" flex-offset-xs="5"><div modval="vm.RCMeetingData.assignmentDate" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-disabled="!vm.isCaseOpen" ng-model="vm.RCMeetingData.assignmentDate" md-max-date="vm.RCMeetingData.maxDate" md-min-date="vm.RCMeetingData.minDate" type="text" md-hide-icons="calendar" name="assignmentDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div></div><div class="p40 pt0 pl0 p20i" flex layout="row" layout-xs="column"><!-- Question 2 Stars Here--><div layout="row" flex="50"><div flex="20" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': ageResults}">2</div></div><div flex-offset-xs="5"><div class="quesStyle mt5 mb20" data-translate="ageResults"></div><md-radio-group ng-disabled="!vm.isCaseOpen || vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY" ng-model="vm.RCMeetingData.ageResult.refTermKey" layout="column" name="ageResults" ng-required="required"><div layout="column"><md-radio-button value="{{(\'RC_CONFIRMED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_CONFIRMED"></label></md-radio-button><md-radio-button value="{{(\'RC_FAILED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_FAILED"></label></md-radio-button><md-radio-button value="{{(\'RC_UNDETERMINED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_UNDETERMINED"></label></md-radio-button><md-radio-button value="{{(\'RC_NA\')}}" class="md-primary"><label class="registryContent" data-translate="NA"></label></md-radio-button><md-radio-button value="{{(\'RC_TABLED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_TABLED"></label></md-radio-button></div></md-radio-group></div></div><!-- Question 2 Ends Here--><!-- Question 3 Stars Here--><div layout="row" flex="50"><div flex="20" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': idResults}">3</div></div><div flex-offset-xs="5"><div class="quesStyle mt5 mb20" data-translate="idResults"></div><md-radio-group ng-disabled="!vm.isCaseOpen || vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY" ng-model="vm.RCMeetingData.identityResult.refTermKey" layout="column" name="idResults" ng-required="required"><div layout="column"><md-radio-button value="{{(\'RC_CONFIRMED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_CONFIRMED"></label></md-radio-button><md-radio-button value="{{(\'RC_FAILED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_FAILED"></label></md-radio-button><md-radio-button value="{{(\'RC_UNDETERMINED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_UNDETERMINED"></label></md-radio-button><md-radio-button value="{{(\'RC_NA\')}}" class="md-primary"><label class="registryContent" data-translate="NA"></label></md-radio-button><md-radio-button value="{{(\'RC_TABLED\')}}" class="md-primary"><label class="registryContent" data-translate="prospects.RC_TABLED"></label></md-radio-button></div></md-radio-group></div></div><!-- Question 3 Ends Here--></div><!-- RC Notes Starts Here--><div flex-offset="10" flex-offset-xs="15" class="p40 pt0 pl0"><div class="w99p"><div class="insName mb10" data-translate="rcNotes"></div><div ng-if="vm.isCaseOpen && vm.loggedUserRole != vm.app.GLOBAL.READ_ONLY" ckeditor="options" id="rcNotes" name="rcNotes" ng-model="vm.RCMeetingData.commentData" ready="onReady()"></div><!-- <div ng-if="!vm.isCaseOpen"><p class="disableEditor" ng-bind="vm.RCMeetingData.commentData"></p></div> --><div ng-if="!vm.isCaseOpen || vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY"><p class="disableEditor" ng-bind-html="trustAsHTML(vm.RCMeetingData.commentData)"></p></div></div></div><!-- RC Notes Ends Here--></fieldset></form><!-- Save Button Section Starts Here--><div layout="row" layout-align="end center" class="nextSec"><div ng-hide="!vm.isCaseOpen ||  vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY" class="nextBtn" ng-click="vm.backProfile();"><div class="nextLabel" data-translate="cancel"></div></div><div flex="5"></div><div ng-if="vm.isCaseOpen && vm.loggedUserRole != vm.app.GLOBAL.READ_ONLY" class="nextBtn greenClr" ng-click="vm.saveRCSessionData($event);"><div class="nextLabel" data-translate="save"></div></div><div ng-if="!vm.isCaseOpen ||  vm.loggedUserRole == vm.app.GLOBAL.READ_ONLY"><md-button ng-click="vm.backProfile();" class="saveOrClose caps color-red" data-translate="close"></md-button></div><div flex="10"></div></div><!-- Save Button Section Ends Here--></div></div></div><div ng-include src="\'app/investigation/prospects/profile/rc/rc.details.warning.popup.html\'" style="display:none;"></div>');
$templateCache.put('app/investigation/prospects/profile/rc/rc.details.warning.popup.html','<div class="hide"><div id="fillOutDate" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.fillDate"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-click="vm.closePopup();" data-translate="prospects.common.ok"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="tabledConfirm" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.tabledConform"></span></div></div><div layout="row"><md-button ng-click="vm.closePopup();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.resultConfirm($event);" data-translate="save"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="fillResult" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.fillResult"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-click="vm.closePopup();" data-translate="prospects.common.ok"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/ckeditor/ckeditor/plugins/wsc/dialogs/ciframe.html','<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN" "http://www.w3.org/TR/html4/strict.dtd"><!--\nCopyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.\nFor licensing, see LICENSE.html or http://ckeditor.com/license\n--><html><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><script type="text/javascript">function gup( name )\n{\n\tname = name.replace( /[\\[]/, \'\\\\\\[\' ).replace( /[\\]]/, \'\\\\\\]\' ) ;\n\tvar regexS = \'[\\\\?&]\' + name + \'=([^&#]*)\' ;\n\tvar regex = new RegExp( regexS ) ;\n\tvar results = regex.exec( window.location.href ) ;\n\n\tif ( results )\n\t\treturn results[ 1 ] ;\n\telse\n\t\treturn \'\' ;\n}\n\nvar interval;\n\nfunction sendData2Master()\n{\n\tvar destination = window.parent.parent ;\n\ttry\n\t{\n\t\tif ( destination.XDTMaster )\n\t\t{\n\t\t\tvar t = destination.XDTMaster.read( [ gup( \'cmd\' ), gup( \'data\' ) ] ) ;\n\t\t\twindow.clearInterval( interval ) ;\n\t\t}\n\t}\n\tcatch (e) {}\n}\n\nfunction OnMessage (event) {\n\t        var message = event.data;\n\t        var destination = window.parent.parent;\n\t        destination.XDTMaster.read( [ \'end\', message, \'fpm\' ] ) ;\n}\n\nfunction listenPostMessage() {\n    if (window.addEventListener) { // all browsers except IE before version 9\n            window.addEventListener ("message", OnMessage, false);\n    }else {\n            if (window.attachEvent) { // IE before version 9\n                        window.attachEvent("onmessage", OnMessage);\n                }\n        }\n}\n\nfunction onLoad()\n{\n\tinterval = window.setInterval( sendData2Master, 100 );\n\tlistenPostMessage();\n}</script></head><body onload="onLoad()"><p></p></body></html>');
$templateCache.put('app/ckeditor/ckeditor/plugins/wsc/dialogs/tmpFrameset.html','<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Frameset//EN" "http://www.w3.org/TR/html4/frameset.dtd"><!--\nCopyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.\nFor licensing, see LICENSE.html or http://ckeditor.com/license\n--><html><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><script type="text/javascript">function doLoadScript( url )\n{\n\tif ( !url )\n\t\treturn false ;\n\n\tvar s = document.createElement( "script" ) ;\n\ts.type = "text/javascript" ;\n\ts.src = url ;\n\tdocument.getElementsByTagName( "head" )[ 0 ].appendChild( s ) ;\n\n\treturn true ;\n}\n\nvar opener;\nfunction tryLoad()\n{\n\topener = window.parent;\n\n\t// get access to global parameters\n\tvar oParams = window.opener.oldFramesetPageParams;\n\n\t// make frameset rows string prepare\n\tvar sFramesetRows = ( parseInt( oParams.firstframeh, 10 ) || \'30\') + ",*," + ( parseInt( oParams.thirdframeh, 10 ) || \'150\' ) + \',0\' ;\n\tdocument.getElementById( \'itFrameset\' ).rows = sFramesetRows ;\n\n\t// dynamic including init frames and crossdomain transport code\n\t// from config sproxy_js_frameset url\n\tvar addScriptUrl = oParams.sproxy_js_frameset ;\n\tdoLoadScript( addScriptUrl ) ;\n}</script></head><frameset id="itFrameset" onload="tryLoad();" border="0" rows="30,*,*,0"><frame scrolling="no" framespacing="0" frameborder="0" noresize="noresize" marginheight="0" marginwidth="2" src="" name="navbar"><frame scrolling="auto" framespacing="0" frameborder="0" noresize="noresize" marginheight="0" marginwidth="0" src="" name="mid"><frame scrolling="no" framespacing="0" frameborder="0" noresize="noresize" marginheight="1" marginwidth="1" src="" name="bot"><frame scrolling="no" framespacing="0" frameborder="0" noresize="noresize" marginheight="1" marginwidth="1" src="" name="spellsuggestall"></frameset></html>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.accordion.html','<div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!bcForm.birthCertificate_1.answer" class="accordianNameHolder caps"><span data-translate="birthCertificate"></span> {{$index+1}}</span> <span ng-if="bcForm.birthCertificate_1.answer" class="accordianNameHolder caps"><span ng-bind="bcForm.birthCertificate_1.answer"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : bcForm.questions[0].expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeBirthCertificateForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:bcForm.expanded}"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_1a.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="birthCertificate1"></div><div class="insName mt40 mt20i" data-translate="birthCertificate_1"></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input ng-model="bcForm.questions[0].birthCertificate_1.answer" class="test" type="text" style="width:100%">\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div class="changeWhiteFrame"><md-autocomplete flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item="searchText" md-selected-item-change="bcForm.questions[0].birthCertificate_1a.answer = item.type;bcForm.questions[0].birthCertificate_1.answer=item.nameCityCounty;bcForm.questions[0].birthCertificate_1.answerId=item.id" md-search-text="bcForm.questions[0].birthCertificate_1.answer" md-items="item in vm.entityRequestSuggest(bcForm.questions[0].birthCertificate_1.answer)" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="searchText">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="insName mt20 mt0i" data-translate="birthCertificate_1a"></div><div class="mt18 mt9i"><md-radio-group ng-model="bcForm.questions[0].birthCertificate_1a.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'bith_local_registry\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="bith_local_registry"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'bith_national_registry\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="bith_national_registry"></label></md-radio-button></div></md-radio-group></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_1.comment.comment" comment-id="bcForm.questions[0].birthCertificate_1.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_1"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Proceed only whether the registry type is Local or National --><div ng-if="bcForm.questions[0].birthCertificate_1a.answer == (\'bith_local_registry\' | translate) || bcForm.questions[0].birthCertificate_1a.answer == (\'bith_national_registry\' | translate)"><div class="dividerDiv"></div><!-- Question 2 Starts Here--><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_2.answer}">2</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10" data-translate="birthCertificate_2"></div><md-radio-group ng-model="bcForm.questions[0].birthCertificate_2.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div></div><!-- if Q2 is Yes --><!-- Q2a ---><div ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'birth_yes\' | translate)"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_2a.answer}">2a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i" data-translate="birthCertificate2a"></div><div class="insName mt40 mt20i" data-translate="birthCertificate_2a"></div><div><md-input-container class="m0 w100p"><md-datepicker ng-model="bcForm.questions[0].birthCertificate_2a.answer" type="text" md-open-on-focus md-hide-icons="calender" class="test" md-max-date="vm.maxDate"></md-datepicker></md-input-container></div></div></div><!-- Q2b --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_2a.answer}">2b</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i" data-translate="birthCertificate2b" ng-init="vm.interviewFlag(2, $index)"></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/interview.html\'"></div> --><!-- <div interview interview-List="{{bcForm.questions[0].birthCertificate2b.interviews}}" model-value="bcForm.questions[0].birthCertificate2b.interviews[0]"></div> --><!-- <div ng-if="bcForm.questions[0].birthCertificate2b.interviews.length == 1">\n\t\t\t\t\t\t      \t\t<div>\n         \t\t\t\t\t  \t\t<div class="mt40 mt20i"><label class="interviewTxt" data-translate="interviewee"></label></div>\n\t\t\t\t\t\t\t  \t\t<div class="insName mt24 mt12i" data-translate="bcinterviewContactName"></div>\n\t\t\t\t\t\t\t\t  <div>\n\t\t\t\t\t\t\t\t\t<md-input-container class="m0 w100p" >\n\t\t\t\t\t\t\t\t\t\t<input ng-model="bcForm.questions[0].birthCertificate2b.interviews[0].questions[0].bcinterviewContactName.answer" type="text" class="test" >\t\t\t\t\n\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t\t  <div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs="">\n\t\t\t\t\t\t\t\t\t <div flex="50" flex-xs="50">\n\t\t\t\t\t\t\t\t\t\t <div class="insName mt40 mt10i" data-translate="bcinterviewTitle"></div>\n\t\t\t\t\t\t\t\t\t\t <div>\n\t\t\t\t\t\t\t\t\t\t\t<md-input-container class="m0 w100p">\n\t\t\t\t\t\t\t\t\t\t\t\t<input ng-model="bcForm.questions[0].birthCertificate2b.interviews[0].questions[0].bcinterviewTitle.answer" type="text" class="test" >\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t <div flex flex-xs>\n\t\t\t\t\t\t\t\t\t\t <div class="insName mt40 mt10i" data-translate="bcinterviewCedulaNum"></div>\n\t\t\t\t\t\t\t\t\t\t <div>\n\t\t\t\t\t\t\t\t\t\t\t<md-input-container class="m0 w100p">\n\t\t\t\t\t\t\t\t\t\t\t\t<input ng-model="bcForm.questions[0].birthCertificate2b.interviews[0].questions[0].bcinterviewCedulaNum.answer" type="text" class="test">\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t </div> \n\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t      <div class="insName mt40 mt20i" data-translate="optionalComment"></div>\n\t\t\t\t\t\t          <div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate2b.interviews[0].comment.comment" comment-id="bcForm.questions[0].birthCertificate2b.interviews[0].comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate2b"></div>\n\t\t\t\t\t\t\t</div>   \n                   \t\t \t<div class="additionalInterviewTxt mt40 mt20i" ng-click="bcForm.questions[0].birthCertificate2b.interviews.push({})" data-translate="add_interview"></div>\n\t\t\t\t\t\t</div> --><div ng-if="!bcForm.questions[0].birthCertificate2b.interviews" ng-init="bcForm.questions[0].birthCertificate2b.interviews = [];bcForm.questions[0].birthCertificate2b.interviews[0].questions = []"></div><div ng-repeat="interviewee in bcForm.questions[0].birthCertificate2b.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row"><div class="mt40 mt20i"><label class="interviewTxt" data-translate="interviewee"></label></div><span class="interviewTxt mt40 ml10 mt20i" ng-if="bcForm.questions[0].birthCertificate2b.interviews.length > 1">#</span> <span class="interviewTxt mt40 ml10 mt20i" ng-if="bcForm.questions[0].birthCertificate2b.interviews.length > 1">{{$index+1}}</span><div ng-click="bcForm.questions[0].birthCertificate2b.interviews.splice($index,1)"><span><i ng-if="bcForm.questions[0].birthCertificate2b.interviews.length > 1" class="material-icons trashInterview mt40 mt20i">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="bcinterviewContactName"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].bcinterviewContactName.answer" type="text" class="test"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="bcinterviewTitle"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].bcinterviewTitle.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="bcinterviewCedulaNum"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].bcinterviewCedulaNum.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mt40 mb10 mt20i" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="interviewee.comment.comment" comment-id="interviewee.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate2b"></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="bcForm.questions[0].birthCertificate2b.interviews.push({})" data-translate="add_interview"></div><!-- Interview part ends --></div></div></div></div><!--  If Q2 is No --><div flex-offset="10"><div class="mt20 pr40 mb10" ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'birth_no\' | translate)"><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_2.comment.comment" comment-id="bcForm.questions[0].birthCertificate_2.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_2"></div></div></div></div><!-- Question 2 Ends Here --><div ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'birth_yes\' | translate)"><div class="dividerDiv"></div><!-- Question 3 Starts Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3.answer}">3</div></div><div flex-offset-xs="5"><div class="quesStyle mb10" data-translate="birthCertificate_3"></div><md-radio-group ng-model="bcForm.questions[0].birthCertificate_3.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div></div><!-- If Q3 is yes --><!-- Q3a --><div ng-if="bcForm.questions[0].birthCertificate_3.answer == (\'birth_yes\' | translate)"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3aYes1.answer}">3a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i" data-translate="birthCertificate_3aYes"></div><div class="insName mt24" data-translate="birthCertificate_3aYes1"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="bcForm.questions[0].birthCertificate_3aYes1.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_prospect\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_prospect"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_brother\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_brother"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_sister\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_sister"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_other\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="bcForm.questions[0].birthCertificate_3aYes1.answer == (\'birth_other\' | translate)"><input ng-model="bcForm.questions[0].birthCertificate_3aYes1.subAnswer" type="text" class="test"></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50"><div class="insName mt40" data-translate="birthCertificate_3aYes2"></div><div><md-input-container class="m0 w100p"><!-- <input ng-model="bcForm.questions[0].birthCertificate_3aYes2.answer" type="text" class="test" > --><md-datepicker ng-model="bcForm.questions[0].birthCertificate_3aYes2.answer" type="text" md-open-on-focus md-hide-icons="calender" md-max-date="vm.maxDate" class="test"></md-datepicker></md-input-container></div></div><div flex="50"><div class="insName mt40 mt10i" data-translate="birthCertificate_3aYes3"></div><div><md-input-container class="m0 w100p"><input ng-model="bcForm.questions[0].birthCertificate_3aYes3.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mt40 mt10i" data-translate="birthCertificate_3aYes4"></div><div><md-input-container class="m0 w100p"><div ng-if="bcForm.questions[0].birthCertificate_3aYes2.answer" class="quesStyle mt10" ng-bind="bcForm.questions[0].birthCertificate_3aYes4.answer = vm.assignDateDiffValue(bcForm.questions[0].birthCertificate_3aYes2.answer)"></div><div ng-if="!bcForm.questions[0].birthCertificate_3aYes2.answer" class="quesStyle mt10" ng-bind="bcForm.questions[0].birthCertificate_3aYes4.answer"></div></md-input-container></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40" data-translate="birthCertificate_3aYes5"></div><div><md-input-container class="m0 w100p"><input ng-model="bcForm.questions[0].birthCertificate_3aYes5.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="birthCertificate_3aYes6"></div><div><md-input-container class="m0 w100p"><input ng-model="bcForm.questions[0].birthCertificate_3aYes6.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mt24" data-translate="birthCertificate_3aYes7"></div><div><md-input-container class="m0 w100p"><input ng-model="bcForm.questions[0].birthCertificate_3aYes7.answer" type="text" class="test"></md-input-container></div><div class="insName mt24" data-translate="birthCertificate_3aYes8"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="bcForm.questions[0].birthCertificate_3aYes8.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_prospect\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_prospect"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_father\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_father"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_mother\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_mother"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_other\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="bcForm.questions[0].birthCertificate_3aYes8.answer == (\'birth_other\' | translate)"><input ng-model="bcForm.questions[0].birthCertificate_3aYes8.subAnswer" type="text" class="test"></md-input-container></div></div><!-- Q3a Comment box --><div class="mt40 mt10i"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_3.comment.comment" comment-id="bcForm.questions[0].birthCertificate_3.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_3"></div></div><!-- <div class="pt40">\n\t\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t\t<span class="attachementAddIconspan"><i class="material-icons attachAddIcon">add</i></span>\n\t\t\t\t\t\t\t\t<span class="caps attachmentAddText" data-translate="birth_add_record"></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t  </div> --></div></div><!-- Q3 Ends Here --><div class="dividerDiv mt10"></div><!--  if Q3a declaration Date is True --><!--  If Q4 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_4.answer}">4</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="birthCertificate_4"></div><md-radio-group ng-model="bcForm.questions[0].birthCertificate_4.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group><div class="mt40" ng-if="bcForm.questions[0].birthCertificate_4.answer == (\'birth_yes\' | translate) || bcForm.questions[0].birthCertificate_4.answer == (\'birth_no\' | translate)"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_4.comment.comment" comment-id="bcForm.questions[0].birthCertificate_4.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_4"></div></div></div></div><!--  Q4 Ends Here --><div class="dividerDiv mt10"></div><!-- Q5 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_5.answer}">5</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="birthCertificate_5"></div><md-radio-group ng-model="bcForm.questions[0].birthCertificate_5.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group><div class="mt40" ng-if="bcForm.questions[0].birthCertificate_5.answer == (\'birth_yes\' | translate) || bcForm.questions[0].birthCertificate_5.answer == (\'birth_no\' | translate)"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_5.comment.comment" comment-id="bcForm.questions[0].birthCertificate_5.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_5"></div></div></div></div><!--  Q5 Ends Here --><div class="dividerDiv mt10"></div><!--  Q6 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_6.answer}">6</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10 mt50 mt20i" data-translate="birthCertificate_6"></div><div layout="row"><md-radio-group ng-model="bcForm.questions[0].birthCertificate_6.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div><div class="mt40" ng-if="bcForm.questions[0].birthCertificate_6.answer == (\'birth_yes\' | translate) || bcForm.questions[0].birthCertificate_6.answer == (\'birth_no\' | translate)"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_6.comment.comment" comment-id="bcForm.questions[0].birthCertificate_6.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_6"></div></div></div></div><!--  Q6 Ends Here --></div><!-- If Q3 is No --><div ng-if="bcForm.questions[0].birthCertificate_3.answer == (\'birth_no\' | translate)"><div layout="row"><div layout="row" flex="10" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt10i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3aNo.answer}">3a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt40 mt10i" data-translate="birthCertificate_3aNo"></div><div class="mt20 mt9i" layout="row"><md-radio-group ng-model="bcForm.questions[0].birthCertificate_3aNo.answer"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_all_records\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_all_records"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_prospect_record\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_prospect_record"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_not_permitted\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_not_permitted"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_certficate_provided\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_certficate_provided"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_other\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group><!-- <div ng-if="bcForm.questions[0].birthCertificate_3aNo.answer == (\'birth_other\' | translate)">\n\t\t\t\t\t\t\t\t\t  \t<md-input-container class="m0 w100p">\n\t\t\t\t\t\t\t\t\t\t\t<input ng-model="bcForm.questions[0].birthCertificate_3aNo.subAnswer" type="text" class="test" >\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t\t\t\t  </div> --></div><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment class="w99p" model-value="bcForm.questions[0].birthCertificate_3.comment.comment" comment-id="bcForm.questions[0].birthCertificate_3.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_3"></div></div></div></div></div></div><div class="dividerDiv"></div></div><!-- Accordion Popup Starts Here --><!-- <div class="hide">\n\t<div id="accordionCloseConformPopup" class="md-dialog-container">\n\t\t<md-dialog class="assignConfirmPopupWidth"> \n\t\t\t<md-dialog-content>\n\t\t\t\t<div layout="row" flex  class="m50imp">\n\t\t\t\t\t<div layout="column" layout-margin layout-align="center center">\n\t\t\t\t\t\t<div layout="column" layout-align="center center">\n\t\t\t\t\t\t\t<div class="assignSub">\n\t\t\t\t\t\t\t\t<span>Do you want to delete the record?</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t<md-button ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary">CANCEL</md-button>\n\t\t\t\t\t\t\t<md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform($index);">DELETE</md-button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</md-dialog-content> \n\t\t</md-dialog>\n\t</div>\n</div> --><!-- Accordion Popup Ends Here -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.form.html','<!-- Question 1 Stars Here --><form name="birthCerticateForm" novalidate ng-init="vm.birthInit();"><fieldset ng-disabled="isreadonly && sideCommentVisible"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_1b.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="birthCertificate1"></div><div class="insName mt40 mt20i" data-translate="birthCertificate_1a"></div><div ng-if="!isreadonly && (bcForm.questions[0].birthCertificate_1a.requested == true) && bcForm.questions[0].birthCertificate_1a.answerId"><div ng-init="bcForm.questions[0].birthCertificate_1a = requestStatus(bcForm.questions[0].birthCertificate_1a);"></div></div><div class="changeWhiteFrame"><md-autocomplete ng-disabled="bcForm.questions[0].birthCertificate_1a.requested" id="{{$index}}" class="global-search-input" flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="item.type !=null ? bcForm.questions[0].birthCertificate_1b.answer = item.type : \'\';bcForm.questions[0].birthCertificate_1b.answerId=item.entityTypeId;bcForm.questions[0].birthCertificate_1a.answerId=item.id;isEntityApproved(bcForm.questions[0].birthCertificate_1a.answerId, false)" md-search-text="bcForm.questions[0].birthCertificate_1a.answer" md-search-text-change="bcForm.questions[0].birthCertificate_1a.answer == \'\' ? bcForm.questions[0].birthCertificate_1a = {} : \'\';bcForm.questions[0].birthCertificate_1a.subAnswer = hideApprovedMessage(bcForm.questions[0].birthCertificate_1a.subAnswer);isEntityApproved(bcForm.questions[0].birthCertificate_1a.answerId, true)" md-items="item in vm.entityRequestSuggest(bcForm.questions[0].birthCertificate_1a.answer,$index)" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="bcForm.questions[0].birthCertificate_1a.answer">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ((!bcForm.questions[0].birthCertificate_1a.answerId && (bcForm.questions[0].birthCertificate_1b.answer && bcForm.questions[0].birthCertificate_1a.answer) && !bcForm.questions[0].birthCertificate_1a.requested) || \n\t\t\t\t\t\t  (entityChanged && !bcForm.questions[0].birthCertificate_1a.requested && !(bcForm.questions[0].birthCertificate_1a.subAnswer != undefined)))"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="birthCertificateEntityRequest($event,\'addNewEntityPopupId\',0,bcForm.questions[0].birthCertificate_1b.answer)" data-translate="add_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && bcForm.questions[0].birthCertificate_1a.requested"><div class="attachmentAddText" data-translate="added_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && bcForm.questions[0].birthCertificate_1a.subAnswer != undefined"><div class="attachmentAddText" data-translate="added_entity_approved"></div></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input no-special-char text-only ng-model="bcForm.questions[0].birthCertificate_1.answer" class="test" type="text" style="width:100%" name="question1"  max-length="70" ng-required="bcForm.questions[0].birthCertificate_1b.answer">\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div class="insName" data-translate="birthCertificate_1b"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly || bcForm.questions[0].birthCertificate_1a.requested" ng-model="bcForm.questions[0].birthCertificate_1b.answer" name="question1a" ng-change="radioChangeCheck($event,\'radioButtonChange\',bcForm.questions[0].birthCertificate_1b.answer,$index);" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'Local Registry\')}}" class="md-primary"><label class="registryContent" data-translate="birth_local_registry"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'National Registry\')}}" class="md-primary"><label class="registryContent" data-translate="birth_national_registry"></label></md-radio-button></div></md-radio-group></div><!-- Upload document for each accordion --><div layout="row" class="mtm20p mb20"><div><div class="investigationFormContent pt40 w550" data-translate="birth_upload_title"></div><upload-form-file id-form-name="birthCertificate" id-name="birthCertificateSection_{{$index}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div><div class="mt40 mt20i"><!--  <div class="insName mb10" data-translate="optionalComment"></div> --><div investigation-comment model-value="bcForm.questions[0].birthCertificate1.comment.comment" comment-id="bcForm.questions[0].birthCertificate1.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate1" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate1\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment><div ng-if="(!bcForm.questions[0].birthCertificate_1a.answerId && bcForm.questions[0].birthCertificate_1a.answer) || notApproved ||  bcForm.questions[0].birthCertificate_1a.requested"><div class="redalert mt20" ng-click="openAutocomplete($index)"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Proceed only whether the registry type is Local or National --><div ng-if="bcForm.questions[0].birthCertificate_1b.answer == (\'Local Registry\') || bcForm.questions[0].birthCertificate_1b.answer == (\'National Registry\')" ng-init="vm.radioButtonFlag[$index] = true;"><div class="dividerDiv"></div><!-- Question 2 Starts Here--><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_2.answer}">2</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10" data-translate="birthCertificate_2"></div><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_2.answer" ng-change="formViewCall($index);bcForm.questions[0].birthCertificate_3={};\n\t\t\t           \t\t\tbcForm.questions[0].birthCertificate_3aYes={};\n\t\t\t           \t\t\tbcForm.questions[0].birthCertificate_3aNo={};\n\t\t\t\t\t           bcForm.questions[0].birthCertificate_2a={};\n\t\t\t\t\t           bcForm.questions[0].birthCertificate2b={};\n\t\t\t\t\t           bcForm.questions[0].birthCertificate_2.comment={};\n\t\t\t\t\t           bcForm.questions[0].birthCertificate_4={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_5={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_6={};" layout="row" name="question2" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_2\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- if Q2 is Yes --><!-- Q2a ---><div ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_2a.answer}">2a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i" data-translate="birthCertificate2a"></div><div class="insName mt40 mt20i" data-translate="birthCertificate_2a"></div><div><div modval="bcForm.questions[0].birthCertificate_2a.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="bcForm.questions[0].birthCertificate_2a.answer" md-max-date="vm.maxDate" type="text" md-hide-icons="calendar" name="question2a" class="test" ng-required="bcForm.questions[0].birthCertificate_2.answer == (\'answer_yes\')" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mr40"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate2a\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q2b --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate2b.interviews[0].questions[0].interviewContactName.answer}">2b</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i" data-translate="birthCertificate2b" ng-init="vm.interviewFlag(1)"></div><div ng-if="!bcForm.questions[0].birthCertificate2b.interviews" ng-init="bcForm.questions[0].birthCertificate2b.interviews = [];bcForm.questions[0].birthCertificate2b.interviews[0].questions = []"></div><div ng-if="interviewFlag"><div ng-repeat="interviewee in bcForm.questions[0].birthCertificate2b.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row"><div class="mt40 mt20i"><label class="interviewTxt" data-translate="interviewee"></label></div><span class="interviewTxt mt40 mt20i mr10 pl5" ng-if="bcForm.questions[0].birthCertificate2b.interviews.length > 1"># {{$index+1}}</span><!-- <span class="interviewTxt mt40 mr10 mt20i" ng-if="bcForm.questions[0].birthCertificate2b.interviews.length > 1">{{$index+1}}</span> --><!-- <div ng-if="!isreadonly && bcForm.questions[0].birthCertificate2b.interviews.length > 1" ng-click="bcForm.questions[0].birthCertificate2b.interviews.splice($index,1)"> --><div ng-if="!isreadonly && bcForm.questions[0].birthCertificate2b.interviews.length > 1" ng-click="vm.deleteIndex($event,\'birthDeleteInterviewConformPopup\',$index,true)"><span><i class="material-icons trashInterview mt40 mt20i">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="bcinterviewContactName"></div><div><md-input-container class="m0 w100p camelCase"><input no-special-char text-only ng-model="interviewee.questions[0].bcinterviewContactName.answer" type="text" class="test" maxlength="70" required camel-case></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="bcinterviewTitle"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].bcinterviewTitle.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="bcinterviewCedulaNum"></div><div><md-input-container class="m0 w100p"><!-- <input only-digits allowed-char="-+()" ng-model="interviewee.questions[0].bcinterviewCedulaNum.answer" type="text" class="test" maxlength="15"> --> <input ng-model="interviewee.questions[0].bcinterviewCedulaNum.answer" type="text" class="test"></md-input-container></div></div></div><!-- <div class="insName mt40 mb10 mt20i" data-translate="optionalComment"></div> --><div investigation-comment model-value="interviewee.comment.comment" comment-id="interviewee.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate2b" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="bcForm.questions[0].birthCertificate2b.interviews.push({})" data-translate="add_interview"></div><!-- Interview part ends --></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mr40"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate2b\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div></div><!--  If Q2 is No --><div flex flex-offset="10"><div class="pr40 mb10" ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'answer_no\')"><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment model-value="bcForm.questions[0].birthCertificate_2.comment.comment" comment-id="bcForm.questions[0].birthCertificate_2.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_2" req-val="true" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><!-- Question 2 Ends Here --><div ng-if="bcForm.questions[0].birthCertificate_2.answer == (\'answer_yes\')"><div class="dividerDiv"></div><!-- Question 3 Starts Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3.answer}">3</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10" data-translate="birthCertificate_3"></div><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_3.answer" ng-change=" formViewCall($index);bcForm.questions[0].birthCertificate_3aYes.records=[];bcForm.questions[0].birthCertificate_3aYes.records[0].questions=[];\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_4={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_5={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_6={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_3aNo={};\n\t\t\t\t\t\t         bcForm.questions[0].birthCertificate_3.comment={}" layout="row" layout-xs="column" name="question3" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_3\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- If Q3 is yes --><!-- Q3a --><div ng-if="bcForm.questions[0].birthCertificate_3.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3aYes.records[0].questions[0].birthCertificate_3aYes1.answer}">3a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i" ng-if="bcForm.questions[0].birthCertificate_1b.answer != \'National Registry\'" data-translate="birthCertificate_3aYes_local_registry"></div><div class="quesStyle mt50 mt20i" ng-if="bcForm.questions[0].birthCertificate_1b.answer == \'National Registry\'" data-translate="birthCertificate_3aYes_national_registry"></div><div ng-if="!bcForm.questions[0].birthCertificate_3aYes.records" ng-init="bcForm.questions[0].birthCertificate_3aYes.records = [];bcForm.questions[0].birthCertificate_3aYes.records[0].questions = []"></div><div ng-if="recordFlag"><div ng-repeat="record in bcForm.questions[0].birthCertificate_3aYes.records track by $index"><div ng-if="!record.questions" ng-init="record.questions = []"></div><div ng-if="!record.sortOrder" ng-init="record.sortOrder = $index+1"></div><div layout="row"><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_3aYes.records.length > 1"><label class="interviewTxt" data-translate="birth_record"></label></div><span class="interviewTxt mt40 ml10 mt20i" ng-if="bcForm.questions[0].birthCertificate_3aYes.records.length > 1">#</span> <span class="interviewTxt mt40 mr10 mt20i" ng-if="bcForm.questions[0].birthCertificate_3aYes.records.length > 1">{{$index+1}}</span><!-- <div ng-if="!isreadonly && bcForm.questions[0].birthCertificate_3aYes.records.length > 1"  ng-click="bcForm.questions[0].birthCertificate_3aYes.records.splice($index,1)"> --><div ng-if="!isreadonly && bcForm.questions[0].birthCertificate_3aYes.records.length > 1" ng-click="vm.deleteIndex($event,\'birthDeleteInterviewConformPopup\',$index,false)"><span><i class="material-icons trashInterview mt40 mt20i">delete</i></span></div><!-- <label class="interviewTxt"><span data-translate="birth_record"></span>\n\t\t\t\t\t\t\t\t\t\t<span ng-if="bcForm.questions[0].birthCertificate_3aYes.records.length > 1 "># {{$index+1}}</span>\n\t\t\t\t\t                       \t    <span class="trashHolder" ng-click="bcForm.questions[0].birthCertificate_3aYes.records.splice($index,1)">\n\t\t\t\t\t                       \t    <span><i ng-if="bcForm.questions[0].birthCertificate_3aYes.records.length > 1" class="material-icons trashInterview">delete</i></span>\n\t\t\t\t\t                       \t </span></label> --></div><div class="insName mt24" data-translate="birthCertificate_3aYes1"></div><!-- <div class="insName mt24" data-translate="birthCertificate_3aYes1_national"></div> --><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthCertificate_3aYes1.answer" ng-change="record.questions[0].birthCertificate_3aYes1.subAnswer=\'\';record.questions[0].birthCertificate_3aYes9 = {};\n\t\t\t\t\t\t\t\t    \trecord.questions[0].birthCertificate_3aYes4 = {};record.questions[0].birthCertificate_3aYes4a = {};record.questions[0].birthCertificate_3aYes4b = {};record.questions[0].birthCertificate_3aYes4c = {};\n\t\t\t\t\t\t\t\t    \trecord.questions[0].birthCertificate_3aYes9.answer = declaredPersonsDob(record.questions[0].birthCertificate_3aYes9.answer,record.questions[0].birthCertificate_3aYes1.answer)" layout="row" layout-xs="column" name="question3a1" required><div class="mr25i mb10i"><md-radio-button value="{{(\'birth_prospect\')}}" class="md-primary"><label class="registryContent" data-translate="birth_prospect"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birth_brother\')}}" class="md-primary"><label class="registryContent" data-translate="birth_brother"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birth_sister\')}}" class="md-primary"><label class="registryContent" data-translate="birth_sister"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birth_other\')}}" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="record.questions[0].birthCertificate_3aYes1.answer == (\'birth_other\')"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes1.subAnswer" type="text" class="test" name="birthCertificate_3aYes1" maxlength="70" required></md-input-container></div></div><div ng-if="record.questions[0].birthCertificate_3aYes1.answer == (\'birth_prospect\')" ng-init="record.questions[0].birthCertificate_3aYes9.answer = declaredPersonsDob(record.questions[0].birthCertificate_3aYes9.answer,record.questions[0].birthCertificate_3aYes1.answer)"></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthCertificate_3aYes2"></div><div><div modval="record.questions[0].birthCertificate_3aYes2.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><!-- <input ng-model="record.questions[0].birthCertificate_3aYes2.answer" type="text" class="test" > --><md-datepicker ng-model="record.questions[0].birthCertificate_3aYes2.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="vm.maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthCertificate_3aYes3"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes3.answer" type="text" maxlength="70" name="birthCertificate_3aYes3" class="test" camel-case required></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthCertificate_3aYes9"></div><div><div modval="record.questions[0].birthCertificate_3aYes9.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><!-- <input ng-model="bcForm.questions[0].birthCertificate_3aYes2.answer" type="text" class="test" > --><md-datepicker ng-model="record.questions[0].birthCertificate_3aYes9.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="vm.maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><div class="insName mt40 mt10i" data-translate="birthCertificate_3aYes4"></div><div><md-input-container class="m0 w100p"><!--  <div ng-if="record.questions[0].birthCertificate_3aYes2.answer && record.questions[0].birthCertificate_3aYes1.answer == (\'birth_prospect\') " class="quesStyle mt10">\n\t\t\t\t\t\t\t\t\t \t<span ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4.answer = vm.assignDateDiffValue(record.questions[0].birthCertificate_3aYes2.answer)"></span>\n\t\t\t\t\t\t\t\t        <span ng-bind-template="{{years}}"></span><span data-translate="years"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4a.answer = years"></div>\n\t\t\t\t\t\t\t\t\t\t<span ng-bind-template="{{months}}" class="pl5" ></span><span data-translate="months"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4b.answer = months"></div>\n\t\t\t\t\t\t\t\t\t\t<span ng-bind-template="{{days}}" class="pl5" ></span> <span data-translate="days"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4c.answer = days"></div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div ng-if="!record.questions[0].birthCertificate_3aYes2.answer" class="quesStyle mt10" ng-bind="record.questions[0].birthCertificate_3aYes4.answer"></div>--><div ng-if="record.questions[0].birthCertificate_3aYes2.answer && record.questions[0].birthCertificate_3aYes9.answer" class="quesStyle mt10"><span ng-hide="vm.trueflag" ng-bind="vm.assignDateDiffValue(record.questions[0].birthCertificate_3aYes2.answer,record.questions[0].birthCertificate_3aYes9.answer)"></span> <span ng-bind-template="{{years}}"></span><span data-translate="years"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4a.answer = years"></div><span class="pl5" ng-bind-template="{{months}}"></span><span data-translate="months"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4b.answer = months"></div><span class="pl5" ng-bind-template="{{days}}"></span> <span data-translate="days"></span><div ng-hide="vm.trueflag" ng-bind="record.questions[0].birthCertificate_3aYes4c.answer = days"></div></div></md-input-container></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthCertificate_3aYes5"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes5.answer" type="text" maxlength="70" name="birthCertificate_3aYes5" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthCertificate_3aYes6"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes6.answer" type="text" ng-max-length="70" name="birthCertificate_3aYes6" class="test" camel-case required></md-input-container></div></div></div><div class="insName mt24" data-translate="birthCertificate_3aYes7"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes7.answer" type="text" class="test" maxlength="70" name="birthCertificate_3aYes7" camel-case required></md-input-container></div><div class="insName mt24" data-translate="birthCertificate_3aYes8"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthCertificate_3aYes8.answer" ng-change="record.questions[0].birthCertificate_3aYes8.subAnswer=\'\'" layout="row" layout-xs="column"><!-- <div class="mr25i mb10i">\n\t\t\t\t\t\t\t\t\t\t\t<md-radio-button value="{{(\'birth_prospect\')}}" class="md-primary">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="registryContent" data-translate="birth_prospect"></label> \n\t\t\t\t\t\t\t\t\t\t\t</md-radio-button>\n\t\t\t\t\t\t\t\t\t\t</div> --><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_father\')}}" class="md-primary"><label class="registryContent" data-translate="birth_father"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_mother\')}}" class="md-primary"><label class="registryContent" data-translate="birth_mother"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_other\')}}" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="record.questions[0].birthCertificate_3aYes8.answer == (\'birth_other\')"><input no-special-char text-only ng-model="record.questions[0].birthCertificate_3aYes8.subAnswer" type="text" class="test" name="birthCertificate_3aYes8" required></md-input-container></div></div><!-- Q3a Comment box --><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="optionalComment"></div> --><div investigation-comment model-value="record.comment.comment" comment-id="record.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birth_record" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="bcForm.questions[0].birthCertificate_3aYes.records.push({})" data-translate="birth_add_record"></div><!--  <div class="pt40">\n\t\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t\t<span class="attachementAddIconspan"><i class="material-icons attachAddIcon">add</i></span>\n\t\t\t\t\t\t\t\t<span class="caps attachmentAddText" data-translate="birth_add_record"></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t  </div> --></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_3aYes\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q3 Ends Here --><div class="dividerDiv mt40"></div><!--  if Q3a declaration Date is True --><!--  If Q4 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_4.answer}">4</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="birthCertificate_4"></div><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_4.answer" ng-change="bcForm.questions[0].birthCertificate_4.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_4.answer == (\'answer_yes\')"><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment model-value="bcForm.questions[0].birthCertificate_4.comment.comment" comment-id="bcForm.questions[0].birthCertificate_4.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_4" req-val="true" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_4.answer == (\'answer_no\')"><!-- <div class="insName mb10" data-translate="optionalComment"></div> --><div investigation-comment model-value="bcForm.questions[0].birthCertificate_4.comment.comment" comment-id="bcForm.questions[0].birthCertificate_4.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_4" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_4\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q4 Ends Here --><div class="dividerDiv mt40"></div><!-- Q5 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_5.answer}">5</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="birthCertificate_5"></div><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_5.answer" ng-change="bcForm.questions[0].birthCertificate_5.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_5.answer == (\'answer_yes\')"><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment model-value="bcForm.questions[0].birthCertificate_5.comment.comment" comment-id="bcForm.questions[0].birthCertificate_5.comment.id" section-id="{{birthCertificateSectionId}}" req-val="true" form-id="{{investigationFormId}}" question-key="birthCertificate_5" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_5.answer == (\'answer_no\')"><!-- <div class="insName mb10" data-translate="optionalComment"></div> --><div investigation-comment model-value="bcForm.questions[0].birthCertificate_5.comment.comment" req-val="false" comment-id="bcForm.questions[0].birthCertificate_5.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_5" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_5\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q5 Ends Here --><div class="dividerDiv mt40"></div><!--  Q6 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_6.answer}">6</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10 mt50 mt20i" data-translate="birthCertificate_6"></div><div layout="row"><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_6.answer" ng-change="bcForm.questions[0].birthCertificate_6.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birth_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birth_no"></label></md-radio-button></div></md-radio-group></div><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_6.answer == (\'answer_yes\')"><!-- <div class="insName mb10" data-translate="requiredComment"></div> --><div investigation-comment model-value="bcForm.questions[0].birthCertificate_6.comment.comment" comment-id="bcForm.questions[0].birthCertificate_6.comment.id" req-val="false" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_6" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div class="mt40 mt20i" ng-if="bcForm.questions[0].birthCertificate_6.answer == (\'answer_no\')"><div class="insName mb10" data-translate="requiredComment"></div><div investigation-comment model-value="bcForm.questions[0].birthCertificate_6.comment.comment" comment-id="bcForm.questions[0].birthCertificate_6.comment.id" req-val="true" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_6" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_6\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q6 Ends Here --></div><!-- If Q3 is No --><div ng-if="bcForm.questions[0].birthCertificate_3.answer == (\'answer_no\')"><div layout="row"><div layout="row" flex="10" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt10i" ng-class="{\'changeColor\': bcForm.questions[0].birthCertificate_3aNo.answer}">3a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt40 mt20i" data-translate="birthCertificate_3aNo"></div><div class="mt20 mt9i" layout="row"><md-radio-group ng-disabled="isreadonly" ng-model="bcForm.questions[0].birthCertificate_3aNo.answer" ng-change="clearCKEditor();(bcForm.questions[0].birthCertificate_3aNo.subAnswer=\'\')"><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_all_records\')}}" name="birthCertificateNo3" class="md-primary"><label class="registryContent" data-translate="birth_all_records"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_prospect_record\')}}" name="birthCertificateNo3" class="md-primary"><label class="registryContent" data-translate="birth_prospect_record"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_not_permitted\')}}" name="birthCertificateNo3" class="md-primary"><label class="registryContent" data-translate="birth_not_permitted"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_certficate_provided\')}}" name="birthCertificateNo3" class="md-primary"><label class="registryContent" data-translate="birth_certficate_provided"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birth_other\')}}" name="birthCertificateNo3" class="md-primary"><label class="registryContent" data-translate="birth_other"></label></md-radio-button></div></md-radio-group></div><div ng-if="bcForm.questions[0].birthCertificate_3aNo.answer == (\'birth_other\')"><md-input-container class="m0 w100p"><input ng-model="bcForm.questions[0].birthCertificate_3aNo.subAnswer" type="text" class="test"></md-input-container></div><div class="insName mt40 mt20i mb10" data-translate="requiredComment"></div><div investigation-comment model-value="bcForm.questions[0].birthCertificate_3.comment.comment" comment-id="bcForm.questions[0].birthCertificate_3.comment.id" req-val="true" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birthCertificate_3" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div ng-if="sideCommentTrigger" -sm ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_CERTIFICATE" accordion-index="$index" question-name="\'birthCertificate_3aNo\'" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div></div></div><div class="dividerDiv"></div></fieldset></form><div ng-include="\'app/investigation/prospects/profile/investigation-form/summary/formSubmitConform.html\'"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.html','<div id="birthCertificate" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadBirthCertificateFormDetails();getSideComments(investigationFormId,vm.app.REF_TERM.BIRTH_CERTIFICATE,vm.app.REF_TERM.ZERO_INDEX);"><!-- part 1 --><!-- Birth Certificate Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bcHeader fs17i" data-translate="birthCertificate"></div></div><!-- Birth Certificate Header End --><div ng-if="loadingBirthCertificate"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingBirthCertificate" ng-init="vm.birthInit()"><div class="dividerDiv"></div><!-- <div class="md-accordion" ng-if="birthCertificate.sections.length > 1" ng-repeat="bcForm in birthCertificate.sections">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.accordion.html\'"></div>\n\t\t\t</div>\n\t\t\t<div class="md-accordion" ng-if="birthCertificate.sections.length == 1">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.form.html\'"></div>\n\t\t\t</div>\t --><div class="md-accordion" ng-if="birthCertificate.sections.length > 1" ng-repeat="bcForm in birthCertificate.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!bcForm.birthCertificate_1.answer" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="birthCertificate"></span> {{$index+1}}</span> <span ng-if="bcForm.birthCertificate_1.answer" class="accordianNameHolder caps accordianNameHolderMBL"><span ng-bind="bcForm.birthCertificate_1.answer"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index);isEntityApproved(bcForm.questions[0].birthCertificate_1a.answerId)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : bcForm.questions[0].expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeBirthCertificateForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:bcForm.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.form.html\'"></div></div></div><div class="md-accordion" ng-if="birthCertificate.sections.length == 1" ng-repeat="bcForm in birthCertificate.sections"><div ng-init="getUploadFiles(null,vm.app.REF_TERM.BIRTH_CERTIFICATE,$index);isEntityApproved(bcForm.questions[0].birthCertificate_1a.answerId)" ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.form.html\'"></div></div><div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.summary.html\'"></div><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><input type="hidden" id="bcFormSave" ng-click="saveBirthCertificateFormDetails();"></div><!-- Next Button Section End --><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="deleteDocumentByIndex(vm.app.REF_TERM.BIRTH_CERTIFICATE,indexVal);vm.closeConform(indexVal);deleteSidecommentsByIndex(vm.app.REF_TERM.BIRTH_CERTIFICATE,indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Confirmation popup for delete additional interviews and records --><div id="birthDeleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-if="isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteInterviewConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button><md-button ng-if="!isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteRecordConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.summary.html','<fieldset ng-disabled="isreadonly"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="attachmentAddText" ng-if="!isreadonly" ng-click="vm.addAdditionalInstitutionForm()" data-translate="add_additional_birthcertificate"></div><div class="investigationFormHeader mt30" data-translate="birth_summary_title"></div><div class="investigationFormContent pt40 w550" data-translate="birth_upload_title"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.BIRTH_CERTIFICATE)"><upload-form-file id-form-name="birthCertificate" id-name="birthCertificateSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="birthCertificate.summary.question = \'birth_summary_comment_title\'"><div class="sectionBC mb10" data-translate="birth_summary_comment_title"></div></div><!-- <div ckeditor="options" ng-model="birthCertificate.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="requiredComment"></div><div investigation-comment model-value="birthCertificate.summary.comment.comment" comment-id="birthCertificate.summary.comment.id" section-id="{{birthCertificateSectionId}}" form-id="{{investigationFormId}}" question-key="birth_summary_comment_title" req-val="true" read-only="{{isreadonly}}" indexval="0"></div></div></div></div></div></div></fieldset>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-certificate/interview.html','<div ng-repeat="interviewee in birthCertificate.interview track by $index"><div class="mt40 mt20i"><label class="interviewTxt">Interviewee</label></div><span ng-if="birthCertificate.interview.length > 1" class="interviewTxt">#</span> <span ng-if="birthCertificate.interview.length > 1" class="interviewTxt">{{$index+1}}</span><div ng-if="birthCertificate.interview.length > 1" class="trashHolder" ng-click="vm.deleteInterviewee($index)"><span><i class="material-icons trashInterview">delete</i></span></div><div class="insName mt24 mt12i">Contact Name</div><div><md-input-container class="m0 w100p"><input ng-model="name.institution" type="text" class="test"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i">Title</div><div><md-input-container class="m0 w100p"><input ng-model="interviewTitle" type="text" class="test"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i">Celuda Number(Optional)</div><div><md-input-container class="m0 w100p"><input ng-model="celuda" type="text" class="test"></md-input-container></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()">+ ADD ADDITIONAL INTERVIWEE</div><div class="insName mt40 mt20i">Comment(Optional)</div><div ckeditor="options" ng-model="editorcontent" ready="onReady()"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.form.html','<!-- Question 1 Stars Here --><form name="birthAndMedicalForm" novalidate><fieldset ng-disabled="isreadonly && sideCommentVisible"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical1_1.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle"><span data-translate="birthMedical1"></span></div><div class="insName mt20i mt40"><span data-translate="birthMedical1_1"></span></div><div ng-if="(bcForm.questions[0].birthCertificate_1a.requested == true) && bcForm.questions[0].birthCertificate_1a.answerId"><div ng-init="bcForm.questions[0].birthCertificate_1a = requestStatus(bcForm.questions[0].birthCertificate_1a);"></div></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly || bmForm.questions[0].birthMedical1_1_medical_institution_1.requested" ng-model="bmForm.questions[0].birthMedical1_1.answer" layout="row" ng-change=" formViewCall($index);bmForm.questions[0].birthMedical1_1.comment={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_medical_institution={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_mid_wife={}; \n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical1_1_mid_wife={}; \n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_mid_wife_no_2a={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical4_medical_institution={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical5_medical_institution={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical6_medical_institution={}; \n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical1_1_medical_institution_1={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical3_medical_institution_no_3a={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birth_medical_record_list={}; " layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical1_1_medical_institution\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical1_1_medical_institution"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical1_1_mid_wife\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical1_1_mid_wife"></label></md-radio-button></div></div></md-radio-group></div><div ng-if="bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_medical_institution\')"><div class="insName mt40 mt20i"><span data-translate="birthMedical1_1_medical_institution_1"></span></div><!-- <div>\n\t\t\t\t\t\t<md-input-container class="m0" style="width:100%">\n\t\t\t\t\t\t\t<input no-special-char text-only ng-model="bmForm.questions[0].birthMedical1_1_medical_institution_1.answer" class="test" type="text" style="width: 100%" maxlength="70" required> \n\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t</div> --><div class="changeWhiteFrame birthmedical" id="birthMedical"><div ng-if="!isreadonly &&  (bmForm.questions[0].birthMedical1_1_medical_institution_1.requested == true) && bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId"><div ng-init="bmForm.questions[0].birthMedical1_1_medical_institution_1 = requestStatus(bmForm.questions[0].birthMedical1_1_medical_institution_1);"></div></div><md-autocomplete ng-disabled="bmForm.questions[0].birthMedical1_1_medical_institution_1.requested" id="{{$index}}" class="global-search-input" flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId=item.id;isEntityApproved(bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId, false)" md-selected-item="searchText" md-search-text="bmForm.questions[0].birthMedical1_1_medical_institution_1.answer" md-search-text-change="bmForm.questions[0].birthMedical1_1_medical_institution_1.answer == \'\' ? bmForm.questions[0].birthMedical1_1_medical_institution_1 = {} : \'\';bmForm.questions[0].birthMedical1_1_medical_institution_1.subAnswer = hideApprovedMessage(bmForm.questions[0].birthMedical1_1_medical_institution_1.subAnswer);isEntityApproved(bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId, true)" md-items="item in vm.entityRequestSuggest(bmForm.questions[0].birthMedical1_1_medical_institution_1.answer,\'Medical Institution\')" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="bmForm.questions[0].birthMedical1_1_medical_institution_1.answer">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ((!bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId && (bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_medical_institution\') && bmForm.questions[0].birthMedical1_1_medical_institution_1.answer) && !bmForm.questions[0].birthMedical1_1_medical_institution_1.requested) || \n\t\t\t\t\t\t(entityChanged && !(bmForm.questions[0].birthMedical1_1_medical_institution_1.requested) && !(bmForm.questions[0].birthMedical1_1_medical_institution_1.subAnswer != undefined)))"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="birthMedicalEntityRequest($event,\'addNewEntityPopupId\',0)" data-translate="add_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && bmForm.questions[0].birthMedical1_1_medical_institution_1.requested"><div class="attachmentAddText" data-translate="added_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && bmForm.questions[0].birthMedical1_1_medical_institution_1.subAnswer != undefined"><div class="attachmentAddText" data-translate="added_entity_approved"></div></div></div><div ng-if="bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_mid_wife\')"><div class="insName mt40 mt20i"><span data-translate="birthMedical1_1_mid_wife_1"></span></div><div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="bmForm.questions[0].birthMedical1_1_mid_wife.answer" class="test" type="text" style="width: 100%" maxlength="70" required></md-input-container></div></div><!-- Upload document for each accordion --><div layout="row" class="mb20" ng-class="{\'mtm40p\': bmForm.questions[0].birthMedical1_1.answer != null}"><div><div class="investigationFormContent pt40 w550" data-translate="birthMedical_sum"></div><upload-form-file id-form-name="birthRecords" id-name="birthMedicalSection_{{$index}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div><div ng-if="bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_medical_institution\')" class="mt40 mt20i"><!-- <div class="insName mb10"><span data-translate="birthMedical_comment_optional"></span></div> --><div investigation-comment model-value="bmForm.questions[0].birthMedical1_1.comment.comment" comment-id="bmForm.questions[0].birthMedical1_1.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" req-val="false" question-key="birthMedical1_1_medical_institution_1" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment><div ng-if="(!bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId && bmForm.questions[0].birthMedical1_1_medical_institution_1.answer) || notApproved || bmForm.questions[0].birthMedical1_1_medical_institution_1.requested"><div class="redalert mt110" ng-click="openAutocomplete($index)"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Proceed only whether the institution type is Birth Record or Medical --><!-- Qusetions for Midwife Starts --><div ng-if="bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_mid_wife\')"><div class="dividerDiv"></div><!-- Question 2 Starts Here--><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical2_mid_wife.answer}">2</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10"><span data-translate="birthMedical2_mid_wife"></span></div><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical2_mid_wife.answer" ng-change="formViewCall($index);bmForm.questions[0].birthMedical2_mid_wife_no_2a={};bmForm.questions[0].birthMedical2_mid_wife_yes_1={};\n\t\t\t\t\t\t bmForm.questions[0].birthMedical3_medical_institution={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION2_MIDWIFE" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- if Q2 is Yes --><div ng-if="bmForm.questions[0].birthMedical2_mid_wife.answer == (\'answer_yes\')"><!-- Q2a ---><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- <div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': vm.medicalInstitutionDateOfVisit}">2a</div> --></div><div flex flex-xs flex-offset-xs="5"><div class="insName mt40 mt20i"><span data-translate="birthMedical2_mid_wife_yes_1"></span></div><div><div modval="bmForm.questions[0].birthMedical2_mid_wife_yes_1.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="bmForm.questions[0].birthMedical2_mid_wife_yes_1.answer" type="text" md-hide-icons="calendar" class="test" required md-max-date="vm.maxDate" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><!-- Q2a Comment box --><div class="mt40 mt20i"><div class="insName mb10"><span data-translate="birthMedical_comment_required"></span></div><div investigation-comment model-value="bmForm.questions[0].birthMedical2_mid_wife_yes_1.comment.comment" comment-id="bmForm.questions[0].birthMedical2_mid_wife_yes_1.comment.id" req-val="true" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical2_mid_wife_yes_1" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div ckeditor="options" ng-model="bmForm.questions[0].birthMedical2_mid_wife_yes_1.comment.comment"\n\t\t\t\t\t\t\t\tready="onReady()"></div> --></div></div></div></div><div ng-if="bmForm.questions[0].birthMedical2_mid_wife.answer == (\'answer_no\')"><!-- Q2a ---><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical2_mid_wife_no_2a.answer}">2a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i"><span data-translate="birthMedical2_mid_wife_no_2a"></span></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical2_mid_wife_no_2a.answer" ng-change="clearCKEditor();formViewCall($index);" layout="row" layout-xs="column" required><!-- bmForm.questions[0].birthMedical2_mid_wife_no_2a.comment={}; --><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_deceased\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_deceased"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_could_not_locate\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_could_not_locate"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_other"></label></md-radio-button></div></div></md-radio-group></div><!-- Q2a Comment box --><div class="mt40 mt20i" ng-if="bmForm.questions[0].birthMedical2_mid_wife_no_2a.answer == (\'birthMedical_deceased\') || \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_mid_wife_no_2a.answer == (\'birthMedical_could_not_locate\') ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_mid_wife_no_2a.answer == (\'birthMedical_other\') "><div class="insName mb10"><span data-translate="birthMedical_comment_required"></span></div><div investigation-comment model-value="bmForm.questions[0].birthMedical2_mid_wife_no_2a.comment.comment" comment-id="bmForm.questions[0].birthMedical2_mid_wife_no_2a.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical2_mid_wife_no_2a" req-val="true" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION2A_MIDWIFE" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div></div></div><!-- Qusetions for Midwife Ends --><!-- Qusetions for birthMedical1_1_medical_institution Starts --><div ng-if="bmForm.questions[0].birthMedical1_1.answer == (\'birthMedical1_1_medical_institution\')"><div class="dividerDiv"></div><!-- Question 2 Starts Here--><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical2_medical_institution.answer}">2</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10"><span data-translate="birthMedical2_medical_institution"></span></div><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical2_medical_institution.answer" ng-change="formViewCall($index);bmForm.questions[0].birthMedical2_medical_institution.subAnswer=\'\';bmForm.questions[0].birthMedical2_medical_institution.comment={};\n\t\t\t\t\t\t\tbmForm.questions[0].birthMedical4_medical_institution={};bmForm.questions[0].birthMedical5_medical_institution={};\n\t\t\t\t\t\t\tbmForm.questions[0].birthMedical6_medical_institution={};bmForm.questions[0].birthMedical2_medical_institution_yes_2a_1={};\n\t\t\t\t\t\t\tbmForm.questions[0].birthMedical2_medical_institution_yes_2b_1={};bmForm.questions[0].birthMedical3_medical_institution_no_3a={};\n\t\t\t\t\t\t\tbmForm.questions[0].birthMedical3_medical_institution={};bmForm.questions[0].birth_medical_record_list={};" layout="row" layout-xs="column"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION2_MEDICAL" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- if Q2 is Yes --><div ng-if="bmForm.questions[0].birthMedical2_medical_institution.answer == (\'answer_yes\')"><!-- Q2a ---><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical2_medical_institution_yes_2a_1.answer}">2a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i"><span data-translate="birthMedical2_medical_institution_yes_2a"></span></div><div class="insName mt40 mt20i"><span data-translate="birthMedical2_medical_institution_yes_2a_1"></span></div><div><div modval="bmForm.questions[0].birthMedical2_medical_institution_yes_2a_1.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="bmForm.questions[0].birthMedical2_medical_institution_yes_2a_1.answer" type="text" md-hide-icons="calendar" class="test" required md-max-date="vm.maxDate" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION2_MEDICAL_YES_2A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q2b --><div layout="row" class="pb40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical2_medical_institution_yes_2a_1.answer}">2b</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i mb10"><span data-translate="birthMedical2_medical_institution_yes_2b"></span></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.interview.html\'"></div> --><div ng-init="vm.interviewFlag(1)"><div ng-if="!bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews" ng-init="bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews = []; bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews[0].questions = []"></div><div ng-if="interviewFlag"><div ng-repeat="interviewee in bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div layout="row" class="mt40 mt20i"><div><label class="interviewTxt" data-translate="birthMedical2_medical_institution_yes_2b_1"></label></div><span class="interviewTxt mr10 pl5" ng-if="bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.length > 1 "># {{$index+1}}</span><!-- <div ng-if="!isreadonly && bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.length > 1" ng-click="bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.splice($index,1)"> --><div ng-if="!isreadonly && bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.length > 1" ng-click="vm.deleteIndex($event,\'medicalDeleteInterviewConformPopup\',$index,true)"><span><i class="material-icons trashInterview">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="birthMedical2_medical_institution_yes_2b_1_1"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].birthMedical2_medical_institution_yes_2b_1_1.answer" type="text" class="test" camel-case required></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthMedical2_medical_institution_yes_2b_1_2"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].birthMedical2_medical_institution_yes_2b_1_2.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="birthMedical2_medical_institution_yes_2b_1_3"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].birthMedical2_medical_institution_yes_2b_1_3.answer" type="text" class="test"></md-input-container></div></div></div><!-- <div class="insName mt40 mb10 mt20i" data-translate="birthMedical_comment_optional"></div> --><div investigation-comment model-value="interviewee.questions[0].birthMedical2_medical_institution_yes_2b.comment.comment" comment-id="interviewee.questions[0].birthMedical2_medical_institution_yes_2b.comment.id" section-id="{{birthMedicalSectionId}}" req-val="false" form-id="{{investigationFormId}}" question-key="birthMedical2_medical_institution_yes_2b" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].birthMedical2_medical_institution_yes_2b.comment.comment" ready="onReady()"></div> --></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="bmForm.questions[0].birthMedical2_medical_institution_yes_2b_1.interviews.push({})" data-translate="addAdditionalInterview"></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="addAdditionalInterview"></div> --><!-- <div class="insName mt40 mt20i" data-translate="birthMedical_comment_optional"></div>\n\t\t\t\t\t\t\t\t\t\t\t<div investigation-comment  model-value="bmForm.questions[0].birthMedical2_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical2_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical2_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div> --><!-- <div ckeditor="options" ng-model="bmForm.questions[0].birthMedical2_medical_institution.comment.comment" ready="onReady()"></div> --></div><!-- Interview part ends --></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION2_MEDICAL_YES_2B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><div class="dividerDiv"></div><!-- Question 2 Ends Here --><!-- Question 3 Starts Here --><div class="p40 pl0 pb0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical3_medical_institution.answer}">3</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10"><span data-translate="birthMedical3_medical_institution"></span></div><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical3_medical_institution.answer" ng-change="formViewCall($index);bmForm.questions[0].birthMedical4_medical_institution={};bmForm.questions[0].birthMedical5_medical_institution={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birthMedical6_medical_institution={};bmForm.questions[0].birthMedical3_medical_institution_no_3a={};\n\t\t\t\t\t\t\t\t\tbmForm.questions[0].birth_medical_record_list={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm40p"><form-side-comment flex investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION3_MEDICAL" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- If Q3 is yes --><!-- Q3a --><div ng-if="bmForm.questions[0].birthMedical3_medical_institution.answer == (\'answer_yes\')"><div ng-if="!bmForm.questions[0].birth_medical_record_list.records" ng-init="bmForm.questions[0].birth_medical_record_list.records = [];bmForm.questions[0].birth_medical_record_list.records[0].questions = []"></div><div layout="column"><div ng-if="recordFlag"><div class="" ng-repeat="record in bmForm.questions[0].birth_medical_record_list.records track by $index"><!-- <div flex="10"></div>  --><!-- In this section question 3a model values in 3b --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- \t\t\t\t\t\t\t \t\t<div ng-if="bmForm.questions[0].birth_medical_record_list.records.length == 1" class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': record.questions[0].birthMedical3_medical_institution_yes_3b.answer}">3a</div> --></div><div flex flex-xs flex-offset-xs="5"><div layout="row"><div ng-if="bmForm.questions[0].birth_medical_record_list.records.length == 1" class="mt50 mt20i"><label class="quesStyle" data-translate="birth_record_one"></label></div><div ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1" class="mt50 mt20i"><label class="quesStyle" data-translate="birth_record"></label></div><span class="interviewTxt mt50 ml10 mt20i" ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1">#</span> <span class="interviewTxt mt50 mr10 mt20i" ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1">{{$index+1}}</span><!-- <div ng-if="!isreadonly && bmForm.questions[0].birth_medical_record_list.records.length > 1" ng-click="bmForm.questions[0].birth_medical_record_list.records.splice($index,1)"> --><div ng-if="!isreadonly && bmForm.questions[0].birth_medical_record_list.records.length > 1" ng-click="vm.deleteIndex($event,\'medicalDeleteInterviewConformPopup\',$index,false)"><span><i class="material-icons trashInterview mt50 mt20i">delete</i></span></div></div><div layout="row" class="mt20 mt10i"><label class="quesStyle" data-translate="birthMedical3_medical_institution_yes_3b"></label></div><div layout="row"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3b.answer" ng-change="record.questions[0].birthMedical3_medical_institution_yes_3a={};\n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_1={};record.questions[0].birthMedical3_medical_institution_yes_3a_birth_2={};  \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_3={};record.questions[0].birthMedical3_medical_institution_yes_3a_birth_4={}; \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_5={};record.questions[0].birthMedical3_medical_institution_yes_3a_birth_6={};  \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_other_2={}; record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_1={}; \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_2={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_3={}; \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_4={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_5={}; \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_6={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7={};  \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_other_1={};record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1={};  \n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_admission_2={}; record.questions[0].birthMedical3_medical_institution_yes_3a_admission_3={};\n\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a.comment={}; record.questions[0].birthMedical3_medical_institution_yes_3b.subAnswer=\'\' " layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_record_prospect\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_record_prospect"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_record_sibling\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_record_sibling"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_record_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_record_other"></label></md-radio-button></div><div class="mtm7"><md-input-container class="m0 w100p" ng-if="record.questions[0].birthMedical3_medical_institution_yes_3b.answer == (\'birthMedical_record_other\')"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3b.subAnswer" type="text" class="test" name="birthCertificate_3aYes1" maxlength="70" required></md-input-container></div></div></md-radio-group></div></div><!-- <div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p">\n\t\t\t\t\t\t\t \t\t<form-side-comment investigation-id=investigationFormId form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION3_MEDICAL_YES_3B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment>\n\t\t\t\t\t\t\t \t</div> --></div><div layout="row"><!-- In this section question 3b model values in 3a --><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- \t\t\t\t\t\t\t \t\t<div ng-if="bmForm.questions[0].birth_medical_record_list.records.length == 1" class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': record.questions[0].birthMedical3_medical_institution_yes_3a.answer}">3b</div> --></div><div flex flex-xs flex-offset-xs="5"><!-- <div ng-if="!bmForm.questions[0].birth_medical_record_list.records" ng-init="bmForm.questions[0].birth_medical_record_list.records = [];bmForm.questions[0].birth_medical_record_list.records[0].questions = []"></div> --><!-- <div ng-repeat="record in bmForm.questions[0].birth_medical_record_list.records track by $index"> --><div><div ng-if="!record.questions" ng-init="record.questions = []"></div><div ng-if="!record.sortOrder" ng-init="record.sortOrder = $index+1"></div><div layout="row"><!-- <div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bmForm.questions[0].birth_medical_record_list.records[0].questions[0].birthMedical3_medical_institution_yes_3a.answer}">3a</div> --><div class="mt20 mt10i"><label class="quesStyle" data-translate="birthMedical3_medical_institution_yes_3a"></label></div><!-- <span class="interviewTxt mt50 ml10 mt20i" ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1">#</span>\n\t\t\t                           \t\t<span class="interviewTxt mt50 mr10 mt20i" ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1">{{$index+1}}</span>\n\t\t\t\t                          \t<div ng-click="bmForm.questions[0].birth_medical_record_list.records.splice($index,1)">\n\t\t\t\t                          \t    <span ng-if="!isreadonly"><i ng-if="bmForm.questions[0].birth_medical_record_list.records.length > 1" class="material-icons trashInterview mt50 mt20i">delete</i></span>\n\t\t\t\t                          \t</div> --></div><!-- <div class="quesStyle mt50 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a"></span></div> --><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a.answer" ng-change="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_1={};\n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_2={};  \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_3={};record.questions[0].birthMedical3_medical_institution_yes_3a_birth_4={}; \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_birth_5={};record.questions[0].birthMedical3_medical_institution_yes_3a_birth_6={};  \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_other_2={}; record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_1={}; \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_2={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_3={}; \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_4={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_5={}; \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_6={};record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7={};  \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_other_1={};record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1={};  \n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_admission_2={}; record.questions[0].birthMedical3_medical_institution_yes_3a_admission_3={};\n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a.comment={}; " required><div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_birth\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_birth"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_admission_release\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_admission_release"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_vaccine\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_vaccine"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_other_record"></label></md-radio-button></div></div></md-radio-group></div><!-- If Record Type is Birth (Starts Here)--><div ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a.answer == (\'birthMedical_birth\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_1"></span></div><div><div modval="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_1.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p" required><md-datepicker ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_1.answer" md-max-date="vm.maxDate" type="text" md-hide-icons="calendar" name="question2a" class="test" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_2"></span></div><div><md-input-container class="m0 w100p" required><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_2.answer" maxlength="70" type="text" camel-case class="test"></md-input-container></div></div></div><div class="insName mt24"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_3"></span></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_3.answer" ng-change="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_3.subAnswer=\'\'" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_male\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_male"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_female\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_female"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birth_Medical_unknown\')}}" class="md-primary"><label class="registryContent" data-translate="birth_Medical_unknown"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_other"></label></md-radio-button></div></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_3.answer == (\'birthMedical_other\')"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_3.subAnswer" type="text" class="test" name="birthMedical3_medical_institution_yes_3a_birth_3" maxlength="70" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_4"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_4.answer" maxlength="70" type="text" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_5"></span></div><div><md-input-container class="m0 w100p"><!-- <input only-digits ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_5.answer" max="99" min="10" maxlength="2" class="test" required> --> <input only-digits ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_5.answer" class="test" required></md-input-container></div></div></div><div class="insName mt24"><span data-translate="birthMedical3_medical_institution_yes_3a_birth_6"></span></div><div><md-input-container class="m0 w100p"><input ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_birth_6.answer" type="text" class="test" required></md-input-container></div><!-- Q3a Comment box --><!-- <div class="mt40 mt20i"> --><!-- <div class="insName mb10"><span data-translate="birthMedical_comment_optional"></span></div> --><!-- <div investigation-comment  model-value="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment" comment-id="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.id" section-id="{{birthMedicalSectionId}}" req-val=false form-id="{{investigationFormId}}" question-key="birthMedical3_medical_institution_yes_3a" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div> --><!-- <div ckeditor="options" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment"\n\t\t\t\t\t\t\t\t\t\t\tready="onReady()"></div> --><!-- </div> --></div><!-- If Record Type is Birth (Ends Here)--><!-- If Record Type is Admission/Release (Starts Here)--><div ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a.answer == (\'birthMedical_admission_release\')"><div class="insName mt24"><span data-translate="birthMedical3_medical_institution_yes_3a_admission_1"></span></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1.answer" ng-change="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_2={};\n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a_admission_3={};\n\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].birthMedical3_medical_institution_yes_3a.comment={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_admission\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_admission"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_release\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_release"></label></md-radio-button></div></div></md-radio-group></div><div ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1.answer"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_admission_2"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_2.answer" ng-maxlength="70" type="text" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1.answer == (\'birthMedical_admission\')" data-translate="birthMedical3_medical_institution_yes_3a_admission_3_admission_date"></span> <span ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_1.answer == (\'birthMedical_release\')" data-translate="birthMedical3_medical_institution_yes_3a_admission_3_release_date"></span></div><div><div modval="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_3.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p" required><md-datepicker ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_admission_3.answer" type="text" md-hide-icons="calendar" class="test" required md-max-date="vm.maxDate" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><!-- Q3a Comment box --><!-- <div class="mt40 mt20i"> --><!-- <div class="insName mb10"><span data-translate="birthMedical_comment_optional"></span></div> --><!-- <div investigation-comment  model-value="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment" comment-id="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.id" req-val=false section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical3_medical_institution_yes_3a" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div> --><!-- <div ckeditor="options" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment"\n\t\t\t\t\t\t\t\t\t\t\tready="onReady()"></div> --><!-- </div> --></div><!-- If Record Type is Admission/Release (Ends Here)--><!-- If Record Type is Vaccine (Starts Here)--><div ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a.answer == (\'birthMedical_vaccine\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_1"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_1.answer" type="text" maxlength="70" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_2"></span></div><div><div modval="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_2.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_2.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_3"></span></div><div><md-input-container class="m0 w100p"><!-- <input only-digits ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_3.answer" maxlength="2" class="test" required> --> <input only-digits ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_3.answer" class="test" required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_4"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_4.answer" type="text" maxlength="70" camel-case class="test"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_5"></span></div><div><div modval="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_5.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_5.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_6"></span></div><div><md-input-container class="m0 w100p"><input text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_6.answer" type="text" class="test" required></md-input-container></div></div></div><div class="insName mt24"><span data-translate="birthMedical3_medical_institution_yes_3a_Vaccine_7"></span></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7.answer" ng-change="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7.subAnswer=\' \'" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_institution\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_institution"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_family\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_family"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'birthMedical_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_other"></label></md-radio-button></div></div></md-radio-group><div class="mtm7" ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7.answer == (\'birthMedical_other\')"><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_Vaccine_7.subAnswer" type="text" class="test" required></md-input-container></div></div><!-- Q3a Comment box --><div class="mt40 mt20i"><!-- <div class="insName mb10"><span data-translate="birthMedical_comment_optional"></span></div> --><div investigation-comment model-value="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment" comment-id="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical3_medical_institution_yes_3a" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment"\n\t\t\t\t\t\t\t\t\t\t\tready="onReady()"></div> --></div></div><!-- If Record Type is Vaccine (ends Here)--><!-- If Record Type is Other (Starts Here)--><div ng-if="record.questions[0].birthMedical3_medical_institution_yes_3a.answer == (\'birthMedical_other\')"><div><div><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_other_1"></span></div><div><md-input-container class="m0 w100p"><input ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_other_1.answer" type="text" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="50"><div class="insName mt40 mt20i"><span data-translate="birthMedical3_medical_institution_yes_3a_other_2"></span></div><div><div modval="record.questions[0].birthMedical3_medical_institution_yes_3a_other_2.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a_other_2.answer" type="text" md-hide-icons="calendar" class="test" required md-max-date="vm.maxDate" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><!-- Q3a Comment box --><div class="mt40 mt20i"><!-- <div class="insName mb10"><span data-translate="birthMedical_comment_optional"></span></div> --><div investigation-comment model-value="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment" comment-id="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.id" req-val="false" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical3_medical_institution_yes_3a" read-only="{{isreadonly}}" indexval="{{$index}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="record.questions[0].birthMedical3_medical_institution_yes_3a.comment.comment"\n\t\t\t\t\t\t\t\t\t\t\tready="onReady()"></div> --></div></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i"  ng-if="!isreadonly" ng-click="bmForm.questions[0].birth_medical_record_list.records.push({})" data-translate="birth_medical_add_record"></div> --><!-- If Record Type is Other (Starts Here)--></div><!-- Side comment --><!-- <div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p">\n\t\t\t\t\t\t\t \t\t<form-side-comment investigation-id=investigationFormId form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION3_MEDICAL_YES_3A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment>\n\t\t\t\t\t\t\t </div>\t --></div></div></div><div class="caps additionalInterviewTxt mt40 mt20i pl10per" ng-if="!isreadonly" ng-click="bmForm.questions[0].birth_medical_record_list.records.push({})" data-translate="birth_medical_add_record"></div><!-- Q3 Ends Here --><!-- <div class="dividerDiv"></div> --><!--  if Q3a  is True --><div ng-if="bmForm.questions[0].birthMedical3_medical_institution.answer == (\'answer_yes\')"><!--  If Q4 Starts Here --><div class="dividerDiv mt40"></div><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical4_medical_institution.answer}">4</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10"><span data-translate="birthMedical4_medical_institution"></span></div><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical4_medical_institution.answer" ng-change="bmForm.questions[0].birthMedical4_medical_institution.comment={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group><div class=""><div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_yes\')"><span data-translate="birthMedical_comment_required"></span></div><!-- <div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_no\')"><span data-translate="birthMedical_comment_optional"></span></div> --><div class="mt40 mt20i" ng-if="bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_no\')"><div investigation-comment model-value="bmForm.questions[0].birthMedical4_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical4_medical_institution.comment.id" req-val="false" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical4_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div investigation-comment ng-if="bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_yes\')" model-value="bmForm.questions[0].birthMedical4_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical4_medical_institution.comment.id" req-val="true" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical4_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div ckeditor="options" ng-if="bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_yes\') || bmForm.questions[0].birthMedical4_medical_institution.answer == (\'answer_no\')" ng-model="bmForm.questions[0].birthMedical4_medical_institution.comment.comment" ready="onReady()" style="margin-top: 8px"></div> --></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION4_MEDICAL" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q4 Ends Here --><div class="dividerDiv mt40"></div><!-- Q5 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical5_medical_institution.answer}">5</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10"><span data-translate="birthMedical5_medical_institution"></span></div><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical5_medical_institution.answer" ng-change="bmForm.questions[0].birthMedical5_medical_institution.comment={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group><div class=""><div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_yes\')"><span data-translate="birthMedical_comment_required"></span></div><!-- <div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_no\')"><span data-translate="birthMedical_comment_optional"></span></div> --><div investigation-comment ng-if="bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_yes\')" req-val="true" model-value="bmForm.questions[0].birthMedical5_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical5_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical5_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div><div class="mt40 mt20i" ng-if="bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_no\')"><div investigation-comment model-value="bmForm.questions[0].birthMedical5_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical5_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical5_medical_institution" req-val="false" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><!-- <div ckeditor="options" ng-if="bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_yes\') || bmForm.questions[0].birthMedical5_medical_institution.answer == (\'answer_no\')" ng-model="bmForm.questions[0].birthMedical5_medical_institution.comment.comment" ready="onReady()" style="margin-top: 8px"></div> --></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION5_MEDICAL" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q5 Ends Here --><div class="dividerDiv mt40"></div><!--  Q6 Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical6_medical_institution.answer}">6</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10 mt50 mt20i"><span data-translate="birthMedical6_medical_institution"></span></div><div layout="row"><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical6_medical_institution.answer" ng-change="bmForm.questions[0].birthMedical6_medical_institution.comment={};" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no"></label></md-radio-button></div></div></md-radio-group></div><div class=""><!-- <div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_no\')"><span data-translate="birthMedical_comment_optional"></span></div> --><div class="mt40 mt20i" ng-if="bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_yes\')"><div investigation-comment model-value="bmForm.questions[0].birthMedical6_medical_institution.comment.comment" req-val="false" comment-id="bmForm.questions[0].birthMedical6_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical6_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div><div class="insName mt40 mt20i mb10" ng-if="bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_no\')"><span data-translate="birthMedical_comment_required"></span></div><div investigation-comment ng-if="bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_no\')" req-val="true" model-value="bmForm.questions[0].birthMedical6_medical_institution.comment.comment" comment-id="bmForm.questions[0].birthMedical6_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical6_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div ckeditor="options" ng-if="bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_yes\') || bmForm.questions[0].birthMedical6_medical_institution.answer == (\'answer_no\')" ng-model="bmForm.questions[0].birthMedical6_medical_institution.comment.comment" ready="onReady()" style="margin-top: 8px"></div> --></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION6_MEDICAL" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q6 Ends Here --></div></div></div><!-- If Q3 is No --><div ng-if="bmForm.questions[0].birthMedical3_medical_institution.answer == (\'answer_no\')"><div layout="row"><div layout="row" flex="10" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt10i" ng-class="{\'changeColor\': bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer}">3a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt40 mt10i"><span data-translate="birthMedical3_medical_institution_no_3a"></span></div><div class="mt20 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer" ng-change="clearCKEditor();(bmForm.questions[0].birthMedical3_medical_institution_no_3a.subAnswer=\'\')" required><div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_no_longer_exist\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_no_longer_exist"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_records_destroyed\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_records_destroyed"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_not_permitted\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_not_permitted"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_certificate_provided\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical_certificate_provided"></label></md-radio-button></div><div layout="row" class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical_other\')}}" class="md-primary mr66"><label class="registryContent" data-translate="birthMedical_other"></label></md-radio-button><div class="mtm7"><md-input-container class="m0 w100p" ng-if="bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer == (\'birthMedical_other\')"><input no-special-char text-only ng-model="bmForm.questions[0].birthMedical3_medical_institution_no_3a.subAnswer" type="text" class="test" name="birthMedical3_medical_institution_no_3a" maxlength="70" required></md-input-container></div></div></div></md-radio-group></div><div ng-if="bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer == (\'birthMedical_no_longer_exist\') || bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer == (\'birthMedical_records_destroyed\')|| bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer == (\'birthMedical_not_permitted\') || bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer  == (\'birthMedical_certificate_provided\')|| bmForm.questions[0].birthMedical3_medical_institution_no_3a.answer == (\'birthMedical_other\')"><div class="insName mt40 mt20i mb10"><span data-translate="birthMedical_comment_required"></span></div><div investigation-comment model-value="bmForm.questions[0].birthMedical3_medical_institution_no_3a.comment.comment" req-val="true" comment-id="bmForm.questions[0].birthMedical3_medical_institution_no_3a.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical3_medical_institution_no_3a" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div ckeditor="options" ng-model="bmForm.questions[0].birthMedical3_medical_institution_no_3a.comment.comment" ready="onReady()"></div> --></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60 mrm40p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.BIRTH_AND_MEDICAL_RECORDS.QUESTION3_MEDICAL_NO_3A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div></div></div><!--  If Q2 is No --><div ng-if="bmForm.questions[0].birthMedical2_medical_institution.answer == (\'answer_no\')"><div class="p40 pl11"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div layout="row" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-disabled="isreadonly" ng-model="bmForm.questions[0].birthMedical2_medical_institution.subAnswer" ng-change="clearCKEditor()" layout="row" layout-xs="column"><!-- ng-change="bmForm.questions[0].birthMedical2_medical_institution.comment={};"  --><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical2_medical_institution_no_2a_permanently_closed\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical2_medical_institution_no_2a_permanently_closed"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'birthMedical2_medical_institution_no_2a_other\')}}" class="md-primary"><label class="registryContent" data-translate="birthMedical2_medical_institution_no_2a_other"></label></md-radio-button></div></md-radio-group></div><div ng-if="(bmForm.questions[0].birthMedical2_medical_institution.subAnswer ==(\'birthMedical2_medical_institution_no_2a_permanently_closed\'))\n\t\t                 \t\t||(bmForm.questions[0].birthMedical2_medical_institution.subAnswer ==(\'birthMedical2_medical_institution_no_2a_other\'))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="birthMedical_comment_required"></div><div investigation-comment model-value="bmForm.questions[0].birthMedical2_medical_institution.comment.comment" req-val="true" comment-id="bmForm.questions[0].birthMedical2_medical_institution.comment.id" section-id="{{birthMedicalSectionId}}" form-id="{{investigationFormId}}" question-key="birthMedical2_medical_institution" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div></div></div></div></div></div><div class="dividerDiv"></div></fieldset></form><!-- <div ng-click="vm.addAdditionalInstitutionForm()">Add Additional Institution</div>\n\t <div ng-include src="\'app/investigation/prospects/profile/investigation-form/investigation.form.section.summary.html\'"></div> -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.information.html','<div id="birthMedical" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadBirthMedicalFormDetails();getSideComments(investigationFormId,vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS,vm.app.REF_TERM.ZERO_INDEX);"><!-- part 1 --><!-- Birth Record and Medical Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bmHeader fz18i" data-translate="birthMedical"></div></div><!-- Birth Record and Medical End --><div ng-if="loadingBirthMedical"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingBirthMedical"><div class="dividerDiv"></div><!-- <div class="md-accordion" ng-if="birthMedical.sections.length > 1" ng-repeat="bmForm in birthMedical.sections">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.accordion.html\'"></div>\n\t\t </div>\n\t\t <div class="md-accordion" ng-if="birthMedical.sections.length == 1">\n\t\t\t\t <div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.form.html\'"></div>\n\t\t </div> --><div class="md-accordion" ng-if="birthMedical.sections.length > 1" ng-repeat="bmForm in birthMedical.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="birthMedical_accordian"></span> <span>{{$index+1}}</span> </span><span ng-if="name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index);isEntityApproved(bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : bmForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeBirthAndMedicalForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:bmForm.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.form.html\'"></div></div></div><div class="md-accordion" ng-if="birthMedical.sections.length == 1" ng-repeat="bmForm in birthMedical.sections"><div ng-init="getUploadFiles(null,vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS,$index);isEntityApproved(bmForm.questions[0].birthMedical1_1_medical_institution_1.answerId)" ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.form.html\'"></div></div><!--  <div ng-click="vm.addAdditionalInstitutionForm()">Add Additional Institution</div> --><div ng-include src="\'app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.information.summary.html\'"></div><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><input type="hidden" id="medicalFormSave" ng-click="saveBirthMedicalFormDetails();"></div><!-- Next Button Section End --><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform(indexVal);deleteSidecommentsByIndex(vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS,indexVal);deleteDocumentByIndex(vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS,indexVal)"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Confirmation popup for delete additional interviews and records --><div id="medicalDeleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-if="isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteInterviewConfirm(indexVal);" data-translate="delete"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button><md-button ng-if="!isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteRecordConfirm(indexVal);" data-translate="delete"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.information.summary.html','<div><fieldset ng-disabled="isreadonly"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="attachmentAddText" ng-if="!isreadonly" ng-click="vm.addAdditionalInstitutionForm()" data-translate="birthMedical_add_another_section"></div><div class="investigationFormHeader mt30" data-translate="birthMedical_sum_head"></div><div class="investigationFormContent pt40 w550" data-translate="birthMedical_sum"></div><!-- Upload document directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.BIRTH_AND_MEDICAL_RECORDS)"><upload-form-file id-form-name="birthRecords" id-name="birthMedicalSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="birthMedical.summary.question = \'birthMedical_sum_comment\'"><div class="sectionBC mb10" data-translate="birthMedical_sum_comment"></div></div><!-- <div ckeditor="options" ng-model="birthMedical.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="birthMedical_comment_required"></div><div investigation-comment model-value="birthMedical.summary.comment.comment" comment-id="birthMedical.summary.comment.id" section-id="{{birthMedicalSectionId}}" req-val="true" form-id="{{investigationFormId}}" question-key="birthMedical_sum_comment" read-only="{{isreadonly}}" indexval="0"></div></div></div></div></div></div></fieldset></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/birth-medical-information/birth.medical.interview.html','<div ng-repeat="interviewee in birthAndMedical.interview track by $index"><div layout="row" class="mt40 mt20i"><label class="interviewTxt">Interviewee</label> <span ng-if="birthAndMedical.interview.length > 1" class="interviewTxt"># {{$index+1}}</span> <i ng-if="birthAndMedical.interview.length > 1" class="material-icons trashInterview" ng-click="vm.deleteInterviewee($index)">delete</i></div><div class="insName mt24 mt12i">Contact Name</div><div><md-input-container class="m0 w100p"><input ng-model="name.institution" type="text" class="test"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i">Title</div><div><md-input-container class="m0 w100p"><input ng-model="interviewTitle" type="text" class="test"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i">Celuda Number(Optional)</div><div><md-input-container class="m0 w100p"><input ng-model="celuda" type="text" class="test"></md-input-container></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()">+ ADD ADDITIONAL INTERVIWEE</div><div class="insName mt40 mt20i">Comment(Optional)</div><div ckeditor="options" ng-model="editorcontent" ready="onReady()"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/comment-directive/investigationform.comment.html','<div class="w99p"><div ng-if="reqValue"><div ng-if="readOnly != \'true\'" ckeditor="options" name="{{questionKey}}" ng-model="modelName" ng-required="reqValue" ng-change="saveOrUpdateComment(modelName);"></div><p ng-if="readOnly == \'true\'" class="disableEditor" ng-bind-html="trustAsHTML(modelName)"></p></div><div ng-if="!reqValue"><div ng-if="readOnly == \'false\'"><span ng-if="!showComment" class="addCmntText mt30 mt20i mb15" ng-click="showOrHideComment();" data-translate="prospects.comment.add_comment"></span> <span ng-if="showComment" class="addCmntText mt30 mt20i mb15" ng-click="showOrHideComment();removeComment(cmtId);" data-translate="prospects.comment.remove_comment"></span><div ng-if="showComment" class="mt10"><div ckeditor="options" class="mt10" name="{{questionKey}}" ng-model="modelName" ng-required="reqValue" ng-change="saveOrUpdateComment(modelName);"></div></div></div><p ng-if="readOnly == \'true\' && showDisableComment" class="disableEditor" ng-bind-html="trustAsHTML(modelName)"></p></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/dna-information/dna.information.accordian.html','<div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps"><span data-translate="dnaInformation"></span> <span>{{$index+1}}</span> </span><span ng-if="name.institution" class="accordianNameHolder caps"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : dnaFormSection.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeDNAForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:dnaFormSection.expanded}"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': dnaFormSection.questions[0].dnaInformation_1.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle"><span data-translate="dnaInformation_1"></span></div><div class="mt18 mt9i"><md-radio-group ng-model="dnaFormSection.questions[0].dnaInformation_1.answer" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_1yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_1no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1no"></label></md-radio-button></div></div></md-radio-group></div></div></div></div><div ng-if="dnaFormSection.questions[0].dnaInformation_1.answer == (\'dnaInformation_1yes\' | translate)"><div class="pr40 pb40 pl0 p20i"><div layout="column"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': dnaFormSection.questions[0].dnaInformation_1a_1.answer}" data-translate="dnaInformation1a"></div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle"><span data-translate="dnaInformation_1a"></span></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_1"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_1.answer" type="text" maxlength="70" class="test" required></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40"><span data-translate="dnaInformation_1a_2"></span></div><div><md-input-container class="m0 w100p"><md-datepicker ng-model="dnaFormSection.questions[0].dnaInformation_1a_2.answer" type="text" md-open-on-focus md-hide-icons="calendar" class="test" md-max-date="maxDate"></md-datepicker></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_3"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_3.answer" type="text" maxlength="70" class="test" required></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40"><span data-translate="dnaInformation_1a_4"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_4.answer" type="text" md-open-on-focus md-hide-icons="calendar" class="test" md-max-date="maxDate"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_5"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_6.answer" type="text" maxlength="70" class="test" required></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40"><span data-translate="dnaInformation_1a_6"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_6.answer" type="text" md-open-on-focus md-hide-icons="calendar" class="test" md-max-date="maxDate"></md-input-container></div></div></div><div class="quesStyle"><span data-translate="dnaInformation_1a_7"></span></div><div class="mt18 mt9i"><md-radio-group ng-model="dnaFormSection.questions[0].dnaInformation_1a_7.answer" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_1\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_1"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_2\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_2"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_3\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_3"></label></md-radio-button></div></div></md-radio-group></div><!-- <div class="mt40 mt10i">\n\t\t\t\t\t\t<div class="insName mb10"><span data-translate="dnaInformation_1a_8"></span></div>\n\t\t\t\t\t\t<div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div>\n\t\t\t\t  </div> --><div class="mt40 mt10i"><div class="insName mb10" data-translate="optionalComment"></div><div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div></div></div></div></div></div></div><div flex-offset="10"><div class="mt20" ng-if="dnaFormSection.questions[0].dnaInformation_1.answer == (\'dnaInformation_1no\' | translate)"><div class="pr40 pb40 pl0 p20i"><div layout="column" class="pr40 mb10"><div class="insName mb10"><span data-translate="dnaInformation_comment_required"></span></div><div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div></div></div></div></div><div class="dividerDiv"></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/dna-information/dna.information.form.html','<!-- Question 1 Stars Here --><form name="dnaForm"><fieldset ng-disabled="isreadonly && sideCommentVisible"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': dnaFormSection.questions[0].dnaInformation1_1.answer}">1</div></div><!-- For new DNA CR Added the new question --><div flex flex-xs flex-offset-xs="5"><div class="quesStyle"><span data-translate="dnaInformation1_1"></span></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly " ng-model="dnaFormSection.questions[0].dnaInformation1_1.answer" layout="row" layout-xs="column" ng-change="formViewCall(vm.app.REF_TERM.ZERO_INDEX);\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1={};enableSave(\'dnaTestInThisCase\',dnaFormSection.questions[0].dnaInformation1_1.answer);"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation1_1yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation1_1no"></label></md-radio-button></div></div></md-radio-group></div></div></div><div layout="row" ng-if="dnaFormSection.questions[0].dnaInformation1_1.answer == (\'answer_yes\')"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div ng-class="{\'changeColor\': dnaFormSection.questions[0].dnaInformation_1.answer}"></div></div><div flex flex-xs flex-offset-xs="5" class="mrtop1a"><div class="insName"><span data-translate="dnaInformation_1"></span></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly || dnaFormSection.questions[0].dnaInformation_1a_2.requested" ng-model="dnaFormSection.questions[0].dnaInformation_1.answer" layout="row" layout-xs="column" ng-change="enableSave(\'dnaConducted\',dnaFormSection.questions[0].dnaInformation_1.answer);formViewCall(vm.app.REF_TERM.ZERO_INDEX);\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_1={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_2={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_3={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_4={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_5={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_6={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_7={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1a_9={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1.comment={};\n\t\t\t\t\tdnaFormSection.questions[0].dnaInformation_1_no={}"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1no"></label></md-radio-button></div></div></md-radio-group></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.DNA" accordion-index="vm.app.REF_TERM.ZERO_INDEX" question-name="vm.app.INVESTIGATION_FORM.DNA_QUESTIONS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><div ng-if="dnaFormSection.questions[0].dnaInformation_1.answer == (\'answer_yes\')"><div class="pr40 pb40 pl0 p20i"><div layout="column"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div ng-class="{\'changeColor\': dnaFormSection.questions[0].dnaInformation_1a_1.answer}"></div></div><div flex flex-xs flex-offset-xs="5"><div class="insName"><span data-translate="dnaInformation_1a"></span></div><div layout="row" layout-xs="column"><!-- For DNA CR set the required field for dateOfTest,dnaCenter,dateOfTestRecived --><div flex="50" flex-xs="50" required><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_1"></span><span class="lgreycolor star">*</span></div><div><div modval="dnaFormSection.questions[0].dnaInformation_1a_1.answer" formatted-date format="MM-DD-YYYY"></div><div ng-class="{borderError:(!dnaFormSection.questions[0].dnaInformation_1a_1.answer && nullDateOfTest) }"><md-input-container class="m0 w100p"><md-datepicker only-didgits ng-model="dnaFormSection.questions[0].dnaInformation_1a_1.answer" md-max-date="vm.maxDate" type="text" md-hide-icons="calendar" class="test" name="dnaInformation_1a_1" ng-change="enableSave(\'dnaTest\',dnaFormSection.questions[0].dnaInformation_1a_1.answer)" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><div ng-if="!dnaFormSection.questions[0].dnaInformation_1a_1.answer && nullDateOfTest "><div ng-if="!dnaFormSection.questions[0].dnaInformation_1a_1.answer" class="dnaErrorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50" class="reduceHeight" ;><div class="insName mt40"><span data-translate="dnaInformation_1a_2"></span><span class="lgreycolor star">*</span></div><div ng-if="!isreadonly && (dnaFormSection.questions[0].dnaInformation_1a_2.requested == true) && dnaFormSection.questions[0].dnaInformation_1a_2.answerId"><div ng-init="dnaFormSection.questions[0].dnaInformation_1a_2 = requestStatus(dnaFormSection.questions[0].dnaInformation_1a_2);"></div></div><div class="changeWhiteFrame"><div ng-class="{borderError:(!dnaFormSection.questions[0].dnaInformation_1a_2.answer && nullDnaCenterId) }"><md-autocomplete class="borderline" ng-disabled="dnaFormSection.questions[0].dnaInformation_1a_2.requested" id="{{$index}}" class="global-search-input" flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item="selectedtext" md-selected-item-change="dnaFormSection.questions[0].dnaInformation_1a_2.answerId=item.id;isEntityApproved(dnaFormSection.questions[0].dnaInformation_1a_2.answerId, false); enableSave(\'dnaCenter\',dnaFormSection.questions[0].dnaInformation_1a_2.answer)" md-search-text="dnaFormSection.questions[0].dnaInformation_1a_2.answer" md-search-text-change="dnaFormSection.questions[0].dnaInformation_1a_2.answer == \'\' ? dnaFormSection.questions[0].dnaInformation_1a_2 = {} : \'\';dnaFormSection.questions[0].dnaInformation_1a_2.subAnswer = hideApprovedMessage(dnaFormSection.questions[0].dnaInformation_1a_2.subAnswer);isEntityApproved(dnaFormSection.questions[0].dnaInformation_1a_2.answerId, true);enableSave(\'dnaCenter\',dnaFormSection.questions[0].dnaInformation_1a_2.answer)" md-items="item in vm.entityRequestSuggest(dnaFormSection.questions[0].dnaInformation_1a_2.answer,\'Dna Center\')" md-item-text="item.nameCityCounty" md-floating-label="j"><md-item-template><span md-highlight-text="dnaFormSection.questions[0].dnaInformation_1a_2.answer">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete><div ng-if="!dnaFormSection.questions[0].dnaInformation_1a_2.answer && nullDnaCenterId "><div ng-if="!dnaFormSection.questions[0].dnaInformation_1a_2.answer" class="dnaCenterErrorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><!-- <md-datepicker ng-model="dnaFormSection.questions[0].dnaInformation_1a_2.answer" type="text" md-open-on-focus md-hide-icons="calendar" class="test"  md-max-date="maxDate" date-picker-local-date dp-blur-format></md-datepicker> --></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ((!dnaFormSection.questions[0].dnaInformation_1a_2.answerId && dnaFormSection.questions[0].dnaInformation_1a_2.answer && !dnaFormSection.questions[0].dnaInformation_1a_2.requested) || \n\t\t\t\t\t\t\t(entityChanged && !dnaFormSection.questions[0].dnaInformation_1a_2.requested && !(dnaFormSection.questions[0].dnaInformation_1a_2.subAnswer != undefined)))"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="dnaEntityRequest($event,\'addNewEntityPopupId\',0)" data-translate="add_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && dnaFormSection.questions[0].dnaInformation_1a_2.requested"><div class="attachmentAddText" data-translate="added_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && dnaFormSection.questions[0].dnaInformation_1a_2.subAnswer != undefined"><div class="attachmentAddText" data-translate="added_entity_approved"></div></div></div></div><!-- For DNA CR added a new question dateOfTestRecived --><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_9"></span><span class="lgreycolor star">*</span></div><div><div modval="dnaFormSection.questions[0].dnaInformation_1a_9.answer" formatted-date format="MM-DD-YYYY"></div><div ng-class="{borderError:(!dnaFormSection.questions[0].dnaInformation_1a_9.answer && nullDateOfTestRecived) }"><md-input-container class="m0 w100p"><md-datepicker only-didgits ng-model="dnaFormSection.questions[0].dnaInformation_1a_9.answer" md-max-date="vm.maxDate" type="text" md-hide-icons="calendar" class="test" ng-change="enableSave(\'dnaTestRecived\',dnaFormSection.questions[0].dnaInformation_1a_9.answer)" name="dnaInformation_1a_9" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><div ng-if="(!dnaFormSection.questions[0].dnaInformation_1a_9.answer && nullDateOfTestRecived) "><div ng-if="!dnaFormSection.questions[0].dnaInformation_1a_9.answer" class="dnaErrorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_3"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_3.answer" type="text" maxlength="70" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40"><span data-translate="dnaInformation_1a_4"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_4.answer" type="text" class="test" maxlength="70"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt10i"><span data-translate="dnaInformation_1a_5"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_5.answer" type="text" maxlength="70" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40"><span data-translate="dnaInformation_1a_6"></span></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="dnaFormSection.questions[0].dnaInformation_1a_6.answer" type="text" class="test" maxlength="70"></md-input-container></div></div></div><div class="quesStyle"><span data-translate="dnaInformation_1a_7"></span></div><div layout="row" class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="dnaFormSection.questions[0].dnaInformation_1a_7.answer" ng-change="dnaFormSection.questions[0].dnaInformation_1a_7.subAnswer=\'\'" layout="row" layout-xs="column"><div layout="row" layout-xs="column"><div class="mr25i mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_1\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_1"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_2\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_2"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'dnaInformation_1a_7_3\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_1a_7_3"></label></md-radio-button></div></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="dnaFormSection.questions[0].dnaInformation_1a_7.answer == (\'dnaInformation_1a_7_3\')"><input ng-model="dnaFormSection.questions[0].dnaInformation_1a_7.subAnswer" type="text" class="test" name="dnaInformation_1a_7_3" maxlength="70"></md-input-container></div></div><!-- <div class="mt40 mt10i">\n\t\t\t\t\t\t<div class="insName mb10"><span data-translate="dnaInformation_1a_8"></span></div>\n\t\t\t\t\t\t<div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div>\n\t\t\t\t  </div> --><div class="mt40 mt10i"><!-- <div class="insName mb10" data-translate="dnaInformation_1a_8"></div> --><div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1a.comment.comment" req-val="false" comment-id="dnaFormSection.questions[0].dnaInformation_1a.comment.id" section-id="{{dnaFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1a" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div> --></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.DNA" accordion-index="vm.app.REF_TERM.ZERO_INDEX" question-name="vm.app.INVESTIGATION_FORM.DNA_QUESTIONS.QUESTION1A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment><div ng-if="(!dnaFormSection.questions[0].dnaInformation_1a_2.answerId && dnaFormSection.questions[0].dnaInformation_1a_2.answer) || notApproved ||dnaFormSection.questions[0].dnaInformation_1a_2.requested"><div class="redalert mt55" ng-click="openAutocomplete($index)"></div></div></div></div></div></div></div><div flex-offset="10"><div ng-if="dnaFormSection.questions[0].dnaInformation_1.answer == (\'answer_no\')"><div layout="row"><md-radio-group ng-disabled="isreadonly" ng-change="dnaFormSection.questions[0].dnaInformation_1.comment={};dnaFormSection.questions[0].dnaInformation_1_no.subAnswer=\'\'" ng-model="dnaFormSection.questions[0].dnaInformation_1_no.answer" layout="row" layout-xs="column"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_no_1\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_no_1"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'dnaInformation_no_2\')}}" class="md-primary"><label class="registryContent" data-translate="dnaInformation_no_2"></label></md-radio-button></div></div></md-radio-group><div class="mtm7"><md-input-container class="m0 w100p" ng-if="dnaFormSection.questions[0].dnaInformation_1_no.answer == (\'dnaInformation_no_2\')"><input ng-model="dnaFormSection.questions[0].dnaInformation_1_no.subAnswer" type="text" class="test" maxlength="70"></md-input-container></div></div><div class="pr40 pb40 pl0 p20i mt20"><div layout="column"><!-- <div class="insName mb10"><span data-translate="dnaInformation_comment_required"></span></div> --><div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" req-val="false" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{dnaFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1" read-only="{{isreadonly}}" indexval="{{$index}}"></div><!-- <div investigation-comment model-value="dnaFormSection.questions[0].dnaInformation_1.comment.comment" comment-id="dnaFormSection.questions[0].dnaInformation_1.comment.id" section-id="{{investigationFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_1"></div> --></div></div></div></div><div class="dividerDiv"></div></fieldset></form>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/dna-information/dna.information.html','<div id="dnaInformation" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadDNAFormDetails();getSideComments(investigationFormId,vm.app.REF_TERM.DNA,vm.app.REF_TERM.ZERO_INDEX);"><!-- Family Information Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bmHeader fz18i" data-translate="dnaInformation"></div></div><div ng-if="loadingDNA"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingDNA"><div class="dividerDiv"></div><div class="md-accordion" ng-if="dna.sections.length > 1" ng-repeat="dnaFormSection in dna.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="dnaInformation"></span> <span>{{$index+1}}</span> </span><span ng-if="name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index);isEntityApproved(dnaFormSection.questions[0].dnaInformation_1a_2.answerId)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : dnaFormSection.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeDNAForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:dnaFormSection.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/dna-information/dna.information.form.html\'"></div></div></div><div class="md-accordion" ng-if="dna.sections.length == 1" ng-repeat="dnaFormSection in dna.sections"><div ng-init="isEntityApproved(dnaFormSection.questions[0].dnaInformation_1a_2.answerId)" ng-include src="\'app/investigation/prospects/profile/investigation-form/dna-information/dna.information.form.html\'"></div></div><div ng-include src="\'app/investigation/prospects/profile/investigation-form/dna-information/dna.information.summary.html\'"></div><!-- Next Button Section--><div layout="row" ng-if="!isreadonly" layout-align="end center" class="nextSec"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><div><button class="nextBtn saveOrClose caps color-yellow buttonColor md-button ng-scope md-ink-ripple" type="button" ng-transclude ng-disabled="disableDnaSaveButton.isDisabled" ng-click=" disableDnaSaveButton.isDisabled = true; vm.nextInvestigationForm()" data-translate="save"></button></div><div flex="10"></div></div><input type="button" id="dnaFormSave" ng-click="saveDNAFormDetails()"><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button class="formSubmit width100px greenClr md-raised md-primary" ng-click="vm.closeConform(indexVal);" data-translate="delete"></md-button><md-button ng-click="vm.closeCancel();" class="formSubmit width100px color-red md-raised md-primary" data-translate="cancel"></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/dna-information/dna.information.summary.html','<fieldset ng-disabled="isreadonly"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><!-- <div class="caps attachmentAddText" ng-click="vm.addAdditionalInstitutionForm()"  data-translate="schoolInformation_add"></div> --><div class="investigationFormHeader" data-translate="dnaInformation_sum_head"></div><div class="investigationFormContent pt40 w550" data-translate="dnaInformation_sum"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.DNA)"><upload-form-file id-form-name="dnaInfo" id-name="dnaSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="dna.summary.question = \'dnaInformation_section_narative\'"><div class="sectionBC mb10" data-translate="dnaInformation_section_narative"></div></div><div class="pr40 mb10"><div class="insName mt40 mt20i mb10"><span data-translate="dnaInformation_comment_required"></span></div><div investigation-comment model-value="dna.summary.comment.comment" comment-id="dna.summary.comment.id" section-id="{{dnaFormSectionId}}" form-id="{{investigationFormId}}" question-key="dnaInformation_section_narative" read-only="{{isreadonly}}" req-val="true"></div></div></div></div></div></div></fieldset>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/family-information/family.information.accordion.html','<div class="accordian-holder" style="padding:0 10px 0 10px"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll(members)"><span ng-if="members.id == 0" class="accordianNameHolder caps"><span data-translate="familyInformation_father"></span></span> <span ng-if="members.id == 1" class="accordianNameHolder caps"><span data-translate="familyInformation_mother"></span></span> <span ng-if="members.id == 2" class="accordianNameHolder caps"><span data-translate="familyInformation_prospect"></span></span> <span ng-if="members.id == 3 && vm.siblingsCount == 1" class="accordianNameHolder caps"><span data-translate="familyInformation_siblings"></span></span> <span ng-if="members.id == 3 && vm.siblingsCount > 1" class="accordianNameHolder caps"><span data-translate="familyInformation_sibling"></span><span> 1</span></span> <span ng-if="members.value == \'PFM\' && members.id > 3" class="accordianNameHolder caps"><span data-translate="familyInformation_familyMember"></span><span> {{members.sortOrder}}</span></span> <span ng-if="members.value == \'Siblings\' && members.id > 3" class="accordianNameHolder caps"><span data-translate="familyInformation_sibling"></span><span> {{members.sortOrder}}</span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll(members)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll(members)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : members.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll(members)"><span class="lineSeparator" ng-class="{mw10p: members.id > 3}"></span> <span class="lineSeparator" ng-class="{mw10p: members.id == 3 && vm.siblingsCount > 1}"></span></div><!-- Remove the Additional family members and additional sibling --><div ng-if="members.id > 3 && !isreadonly" layout-align="center center" ng-click="vm.removefamilyInfoForm($event,\'accordionCloseConformPopup\',members)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div><!-- Remove the First sibling record if more than one sibling record is available --><div ng-if="members.id == 3 && vm.siblingsCount > 1 && !isreadonly" layout-align="center center" ng-click="vm.removefamilyInfoForm($event,\'accordionCloseConformPopup\',members)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-if="members.value != \'Siblings\'" ng-class="{dataContent:true, activeContent:members.expanded}" ng-init="$index == 0 ? getUploadFiles(null,vm.app.REF_TERM.FAMILY_INFORMATION,$index) : \'\';"><form novalidate><fieldset ng-disabled="isreadonly && sideCommentVisible"><input ng-model="familyInformation.sections[members.id].type" ng-init="familyInformation.sections[members.id].type=\'PFM\'" type="hidden"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_1.answer}" data-translate="familyInformation1"></div></div><div flex flex-offset-xs="5"><div ng-if="members.id == 0" class="quesStyle" data-translate="familyInformation_father_1"></div><div ng-if="members.id == 1" class="quesStyle" data-translate="familyInformation_mother_1"></div><div ng-if="members.id == 2" class="quesStyle" data-translate="familyInformation_prospect_1"></div><div ng-if="members.value == \'PFM\' && members.id > 3" class="quesStyle"><span data-translate="familyInformation_familyMember_1"></span><span> {{members.sortOrder}}</span></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div ng-if="members.id == 0" class="insName mt40 mt20i" data-translate="familyInformation_father_1_1"></div><div ng-if="members.id == 1" class="insName mt40 mt20i" data-translate="familyInformation_mother_1_1"></div><div ng-if="members.id == 2" class="insName mt40 mt20i" data-translate="familyInformation_prospect_1_1"></div><div ng-if="members.value == \'PFM\' && members.id > 3" class="insName mt40 mt20i" data-translate="familyInformation_familyMember_1_1"></div><div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_1.answer" class="test" type="text" style="width:100%" maxlength="70" name="familyInformation_prospect_1_1" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="familyInformation_prospect_1_2"></div><div><md-input-container class="m0" style="width:100%"><!-- <input only-digits allowed-char="-+()" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_2.answer" class="test" type="text" name="familyInformation_prospect_1_2" maxlength="15"> --> <input ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_2.answer" class="test" type="text" name="familyInformation_prospect_1_2"></md-input-container></div></div></div><!-- Starts Relation to family member information - Only for Additional Family Member --><div ng-if="members.value == \'PFM\' && members.id > 3" layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="familyInformation_familyMember_1_4"></div><div id="familyMembers" class="mbt27"><md-select ng-disabled="isreadonly" name="familyInformation_familyMember_1_4" ng-change="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.subAnswer=\'\'" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.answer" class="m0 md-no-underline ofH border" required placeholder="{{familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.answer == undefined ? (\'familyInformation_familyMember_1_4_placeHolder\' | translate) : familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.answer}}"><md-option ng-value="dropValue.value" ng-repeat="dropValue in vm.relationTypeList"><span data-translate="{{dropValue.value}}"></span></md-option></md-select></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div ng-show="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.answer == \'Others\'"><div class="insName mt40 mt20i" data-translate="familyInformation_familyMember_1_5"></div><div><md-input-container class="m0" style="width:100%"><input ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.subAnswer" class="test" type="text" name="familyInformation_prospect_1_5"></md-input-container></div></div></div></div><!-- End: Relation to family member information - Only for Additional Family Member --><div class="mt10i" ng-class="{mt20imp:familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_4.answer != \'Others\'}"><div class="insName mt40 mt20i mb10" data-translate="familyInformation_prospect_1_3"></div><div><md-input-container class="m0" style="width:100%"><input ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1_3.answer" class="test" type="text" name="familyInformation_prospect_1_3" required></md-input-container></div></div></div><!-- Side Comment --><!-- FATHER --><div ng-if="sideCommentTrigger && members.id == 0" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_FATHER" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><!-- MOTHER --><div ng-if="sideCommentTrigger && members.id == 1" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_MOTHER" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><!-- PROSPECT --><div ng-if="sideCommentTrigger && members.id == 2" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><!-- FAMILY MEMBER --><div ng-if="sideCommentTrigger && members.value == \'PFM\' && members.id > 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="members.index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_FAMILY_MEMBER" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!--  Q1a Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt20i" ng-class="{\'changeColor\': familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer}" data-translate="familyInformation1a"></div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_prospect_1a"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer" layout="row" layout-xs="column" required ng-change="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_no_1 = {};\n\t\t\t\t\t\t\t\t            familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_1={};\n\t\t\t\t\t\t\t\t            familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_2= {};\n\t\t\t\t\t\t\t\t            familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.comment={};"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_no"></label></md-radio-button></div></md-radio-group><!--  If Q1a is Yes --><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer == (\'answer_yes\')"><div class="insName mt40 mt20i" data-translate="familyInformation_prospect_1a_yes_1"></div><div flex-gt-xs="50"><div modval="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_1.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_1.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="maxDate" name="familyInformation_prospect_1a_yes_1" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><div><div class="insName mb10 mt20 mt10i" data-translate="familyInformation_prospect_1a_yes_2"></div><div class="mt10" investigation-comment model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_2.comment.comment" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_yes_2.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1a_yes_2" req-val="true" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div></div><!-- If Q1a is NO --><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer == (\'answer_no\')"><div class="mt40 mt20i"><div ng-if="members.value != \'Prospect\'" class="insName mb10 mt20 mt10i" data-translate="familyInformation_prospect_1a_no_1"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_no_1.answer" ng-change="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.comment = {};" layout-xs="column" required><div layout-xs="column"><md-radio-button value="{{(\'familyInformation_noInterview_InterviewWaived\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_noInterview_InterviewWaived"></label></md-radio-button><md-radio-button ng-if="members.value != \'Prospect\' && members.id != 2" value="{{(\'familyInformation_noInterview_familyMemberDeceased\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_noInterview_familyMemberDeceased"></label></md-radio-button><md-radio-button ng-if="members.value != \'Prospect\' && members.id != 2" value="{{(\'familyInformation_noInterview_familyMemberUnavilable\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_noInterview_familyMemberUnavilable"></label></md-radio-button></div><div><div ng-if="members.value == \'Prospect\' || familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_no_1.answer == (\'familyInformation_noInterview_InterviewWaived\')"><div class="insName mt40 mt20i" data-translate="familyInformation_commentRequired" ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer == (\'answer_yes\')"></div><div class="mt10 colorBlack" investigation-comment model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.comment.comment" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1a" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_no_1.answer == (\'familyInformation_noInterview_familyMemberDeceased\')"><div class="insName mt20 mt10i mb10" flex-offset="10"><span data-translate="familyInformation_noInterview_familyMemberDeceased_reminder"></span></div></div><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a_no_1.answer == (\'familyInformation_noInterview_familyMemberUnavilable\')"><div class="insName mt20 mt10i mb10" flex-offset="10"><span data-translate="familyInformation_noInterview_familyMemberUnavilable_reminder"></span></div></div></div></md-radio-group></div></div></div><!-- Side comment --><div ng-if="sideCommentTrigger && members.id < 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><div ng-if="sideCommentTrigger && members.value == \'PFM\' && members.id > 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="members.index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q1a Ends Here --><!-- Q1b Starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt20i" ng-class="{\'changeColor\': familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.answer}" data-translate="familyInformation1b"></div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_prospect_1b"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.answer" layout="row" layout-xs="column" required ng-change="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.comment = {}"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_no"></label></md-radio-button></div></md-radio-group><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.answer == (\'answer_yes\')"><div class="insName mt40 mt20i" data-translate="familyInformation_commentRequired"></div><div class="mt10" investigation-comment model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.comment.comment" req-val="true" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1b" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.answer == (\'answer_no\')"><!--  <div class="insName mt40 mt20i" data-translate="familyInformation_commentOptional"></div> --><div class="mt10" investigation-comment model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.comment.comment" req-val="false" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1b.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1b" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div></div><!-- Side comment --><div ng-if="sideCommentTrigger && members.id < 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><div ng-if="sideCommentTrigger && members.value == \'PFM\' && members.id > 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="members.index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q1b Ends Here --><!-- Q1c Stars Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt20i" ng-class="{\'changeColor\': familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.answer}" data-translate="familyInformation1c"></div></div><div flex flex-offset-xs="5"><div ng-if="members.id == 2" class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_prospect_1c"></div><div ng-if="members.id == 1 || members.id == 0" class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_prospect_1c_parent"></div><div ng-if="members.id > 3" class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_prospect_1c_familyMember"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.answer" layout="row" layout-xs="column" required ng-change="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.comment = {}"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_no"></label></md-radio-button></div></md-radio-group><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.answer == (\'answer_yes\')"><div class="insName mt40 mt20i" data-translate="familyInformation_commentRequired"></div><div class="mt10" investigation-comment req-val="true" model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.comment.comment" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1c" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div><div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.answer == (\'answer_no\')"><!-- <div class="insName mt40 mt20i" data-translate="familyInformation_commentOptional"></div> --><div class="mt10" investigation-comment req-val="false" model-value="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.comment.comment" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1c.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_prospect_1c" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div></div><!-- Side comment --><div ng-if="sideCommentTrigger && members.id < 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1C" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div><div ng-if="sideCommentTrigger && members.value == \'PFM\' && members.id > 3" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="members.index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PROSPECT_1C" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q1c Ends Here --><!-- <div ng-if="familyInformation.sections[members.id].questions[0].familyInformation_prospect_1a.answer == (\'answer_yes\')">\n\t\t\t\t     <div flex-offset="10">\n\t\t\t\t\t     <div class="insName mb10 mt20 mt10i" data-translate="familyInformation_interviewContent"></div>\n\t\t\t\t\t\t   <md-input-container class="m0" style="width:100%">\n\t\t                        <input ng-model="familyInformation.sections[members.id].questions[0].familyInformation_interviewContent.answer" class="test" type="text" style="width:100%">\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t  </div>\n\t\t\t     </div> --><!-- Q1c Ends Here --><!--  Add Additional Family Member Section Starts --><!-- <div flex-offset="10"  ng-if="!isreadonly && members.id == 0" class="grncolor mt40 mt20i monstFamily fwb fz14 lineHeight18 cursorP" ng-click="vm.addfamilyInfoForm(\'PFM\');">+ ADD FAMILY MEMBER</div> --><!--  Add Additional Family Member End --></div><!-- Question 1 Ends Here--><!-- Upload document for each accordion --><div layout="row" class="mtm40p"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div><div class="investigationFormContent pt40 w550" data-translate="familyInformation_label_summarySection"></div><upload-form-file id-form-name="familyInfo" id-name="familyInformation_{{members.id}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div></div></fieldset></form></div><!--  Siblings PAGE Starts Here --><div ng-if="members.value == \'Siblings\'" ng-class="{dataContent:true, activeContent:members.expanded}"><form><fieldset ng-disabled="isreadonly"><input ng-model="familyInformation.sections[members.id].type" ng-init="familyInformation.sections[members.id].type=\'Siblings\'" type="hidden"><!-- Question 1 Starts Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_1.answer}" data-translate="familyInformation1"></div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10"><span data-translate="familyInformation_sibling_1"></span> <span ng-if="vm.siblingsCount > 1"># {{members.sortOrder}}</span></div><div class="insName mt40 mt20i" data-translate="familyInformation_sibling_1_1"></div><div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_1.answer" class="test" type="text" style="width:100%" required maxlength="70" camel-case name="familyInformation_sibling_1_1"></md-input-container></div><div class="insName mt20 mt10i" data-translate="familyInformation_sibling_1_2"></div><div><div modval="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_2.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_2.answer=datePickerFormat(familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_2.answer)" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_2.answer" type="text" md-hide-icons="calendar" class="test" name="familyInformation_sibling_1_2" md-max-date="maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><div class="insName mt20 mt10i" data-translate="familyInformation_sibling_1_3"></div><div layout="row" layout-xs="column" class="mt20"><div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_3.answer" layout="row" layout-xs="column" required ng-change="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_3.subAnswer = \'\'"><div layout="row" layout-xs="column"><div class="mr25i mb10i"><md-radio-button value="{{(\'familyInformation_siblingType_1\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_siblingType_1"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'familyInformation_siblingType_2\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_siblingType_2"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'familyInformation_siblingType_3\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_siblingType_3"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'familyInformation_siblingType_4\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_siblingType_4"></label></md-radio-button></div></div></md-radio-group></div><div flex-gt-xs="50" ng-if="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_3.answer == (\'familyInformation_siblingType_4\')" class="mtm7"><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_3.subAnswer" type="text" class="test" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" ng-model="relation.name" data-translate="familyInformation_sibling_1_4"></div><div><div modval="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_4.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_4.answer=datePickerFormat(familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_4.answer)" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_4.answer" type="text" md-open-on-focus md-hide-icons="calendar" class="test" md-max-date="maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="familyInformation_sibling_1_5"></div><div><md-input-container class="m0" style="width:100%"><input ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_5.answer" class="test" type="text" required></md-input-container></div></div></div><div class="insName mb10 mt20" data-translate="familyInformation_sibling_1_6"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1_6.answer" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><md-radio-button value="{{(\'familyInformation_sibling_male\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_sibling_male"></label></md-radio-button><md-radio-button value="{{(\'familyInformation_sibling_female\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_sibling_female"></label></md-radio-button></div></md-radio-group><div class="mt40 mt20i"><!--  <div class="insName mb10" data-translate="optionalComment"></div> --><div investigation-comment model-value="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1.comment.comment" comment-id="familyInformation.sections[members.id].questions[0].familyInformation_sibling_1.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_sibling_1" req-val="false" read-only="{{isreadonly}}" indexval="{{members.id}}"></div></div><!-- Upload document for each accordion --><div><div class="investigationFormContent pt40 w550" data-translate="familyInformation_label_summarySection"></div><upload-form-file id-form-name="familyInfo" id-name="familyInformation_{{members.id}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div><!-- Additional Sibling --><div class="grncolor mt40 mt20i monstFamily fwb fz14 lineHeight18 cursorP" ng-if="!isreadonly" ng-click="vm.addfamilyInfoForm(\'Siblings\');"><span data-translate="familyInformation_sibling_add"></span></div></div><!-- Side comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10 mrm10p"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_SIBLING" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- Question 1 Ends Here --></fieldset></form></div><!--  Siblings Page Ends Here --><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="prospects.common.cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform(vm.removingMember);deleteSidecommentsByIndex(vm.app.REF_TERM.FAMILY_INFORMATION,vm.removingMember.id);deleteDocumentByIndex(vm.app.REF_TERM.FAMILY_INFORMATION,vm.removingMember.id);" data-translate="prospects.common.delete"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/family-information/family.information.html','<div id="familyInformation" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100+\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.initFamilyMembers();vm.loadFamilyInformationDetails();getSideComments(investigationFormId,vm.app.REF_TERM.FAMILY_INFORMATION,vm.app.REF_TERM.ZERO_INDEX);getfamilySectionDTO();"><!-- part 1 --><!-- Family Information Header--><div class="p40 pl0 pl0MBL" flex-offset="10" layout="row" ng-class="{pmMob:mediaCheck(\'xs\')}"><div flex="50" class="bcHeader" data-translate="familyInformation_label"></div><!--  Enabling import sibling feature --><div layout="row" flex class="pl12per caps attachmentAddText" ng-if="familyInformation.sections[0].questions != undefined  && familyInformation.sections[0].questions[0].familyInformation_prospect_1_2.subAnswer!=\'siblingImported\' && !isreadonly" ng-click="vm.openimportFamilyPopup($event,\'importFamilyDetailsId\')"><div class="mr10 fz20">+</div><div data-translate="import_family_data"></div></div></div><!-- Family Information Header End --><div ng-if="loadingFamilyInfo"><div class="dividerDiv"></div><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingFamilyInfo"><div class="md-accordion" ng-repeat="members in familyMember"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/family-information/family.information.accordion.html\'"></div></div><!--  Add Additional Family Member Section Starts --><div flex-offset="5" ng-if="!isreadonly" class="grncolor mt40 mt20i monstFamily fwb fz14 lineHeight18 cursorP" ng-click="vm.addfamilyInfoForm(\'PFM\');"><span data-translate="familyInformation_familyMember_add"></span></div><!-- <div class="md-accordion" ng-if="familyInformation.sections.length >= 1" ng-repeat="fiForm in familyInformation.sections">\n\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/family-information/family.information.form.html\'"></div>\n\t\t</div> --><!-- <div class="md-accordion" ng-if="familySibilingForm.length >= 1" ng-repeat="sibForm in familySibilingForm">\n\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/family-information/family.information.sibiling.form.html\'"></div>\n\t\t</div> --><div class="dividerDiv mt40"></div><!-- Family Photos Sections --><fieldset ng-disabled="isreadonly && sideCommentVisible" ng-init="vm.setFamilyPhotoValue();"><div class="p40 pl0 p20i"><div flex-offset="10" class="investigationFormHeader" data-translate="familyInformation_label_familyPhoto"></div><!-- Q1 starts Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt20i" ng-class="{\'changeColor\': familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer}" data-translate="familyInformation1"></div></div><div flex=""><div class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_familyPhoto_1"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer" layout="row" ng-change="attachedPhotoRemove($event,familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer,\'removeAttachedPhoto\');" layout-xs="column" required><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" ng-disabled="fileUploadLoader" class="md-primary"><label class="registryContent" data-translate="familyInformation_no"></label></md-radio-button></div></md-radio-group><!-- Uploaded Photo Section is shown for if the photos are provided by the family ("YES" to the question1 in photo section) --><div ng-if="familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer == (\'answer_yes\') || !vm.yesToProceed" ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO,vm.app.REF_TERM.FAMILY_INFORMATION)"><div><div class="pt15"><div ng-show="uploadFileSectionFamilyPhotoList[0].uploadList.length > 0"><manage-attachments id-name="vm.familyInformationSectionPhoto" id-form-name="vm.familyPhotos" asset-list="uploadFileSectionFamilyPhotoList[0].uploadList" is-summary="0" is-read-only="isReadOnly" record-flag="recordFlag"></manage-attachments></div><div ng-if="recordFlag"><div class="ellipsis" ng-class="{\'mt7\': !$first}" ng-if="uploadFileSectionFamilyPhotoList[0].uploadList.length > 0" ng-repeat="uploadFamilyPhoto in uploadFileSectionFamilyPhotoList[0].uploadList track by $index"><div layout="row" class="ellipsis mt20"><span class="investigationAttachmentIcon"><i class="material-icons attachicon">attachment</i></span> <span class="investigationAttachmentFile"><a class="textstyle2 textDecorationNoneImportant" href="{{assetDownloadAPI+uploadFamilyPhoto.id}}" download>{{uploadFamilyPhoto.displayName}}</a></span> <span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="deleteFileConfirm($event,uploadFamilyPhoto.id,$index,\'familyInformation_familyPhoto_1\')"><i class="material-icons">clear</i></span></div><div class="p40 pl0 p20i"><div class="insName mb10 mt20 mt10i" data-translate="familyInformation_descriptionRequired"></div><!-- <div ng-if="!isreadonly"ckeditor="options" ng-model="uploadFamilyPhoto.description" ready="onReady()">{{uploadFamilyPhoto.description}}</div>\n\t\t\t\t\t                \t\t\t\t<p ng-if="isreadonly" class="disableEditor" ng-bind-html="trustAsHTML(uploadFamilyPhoto.description)"></p> --><div class="mt10" investigation-comment model-value="uploadFamilyPhoto.description" req-val="true" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_familyPhoto_1" read-only="{{isreadonly}}"></div></div></div></div><div layout="row" class="layout-row" ng-if="fileUploadProgress_photo != null"><div class="progressbarWidth"><span class="progressHolder"><md-progress-linear class="uploadProgress" md-mode="determinate" value="{{fileUploadProgress_photo}}"></md-progress-linear></span></div><div class="progressClose"><span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="hideUploadProgressBar(\'photo\');uploadingFile.upload.abort();"><i class="material-icons">clear</i></span></div></div></div></div><div id="fileTypeError_familyPhotoSectionSummary" class="hide"><span data-translate="prospects.profileFormDetails.uploadFileNotSupported"></span></div><div id="fileSizeError_familyPhotoSectionSummary" class="hide"><span data-translate="prospects.profileFormDetails.fileSizeExceed"></span></div><div class="mt10" ng-if="!isreadonly"><div layout="row"><span class="attachementAddIconspan"><i class="material-icons attachAddIcon">add</i></span><!-- <span class="caps attachmentAddText" data-translate="prospects.profileFormDetails.uploadDocument" ng-click="vm.uploadFileForSummary()"></span>\n\t\t\t\t\t\t\t\t\t\t<input type="file" hide id="sectionSummary" name="sectionSummary" onchange="vm.testFunc()" ng-model="picFileOth"/> --><div class="drop-box ml0 miw350" ng-class="{\'disable\': fileUploadLoader}" ngf-drop ngf-drag-over-class="\'dragover\'" ngf-allow-dir="false" ngf-drop-available="true"><span class="lh30 caps"></span> <span id="uploadReviewFile" data-translate="prospects.profileFormDetails.uploadDocument" class="caps attachmentAddText noOutLine" ng-click="vm.familyPhotoUploadFileForSummary(\'photo\',\'familyPhotoSectionSummary\',$event)"></span> <input type="file" id="familyPhotoSectionSummary" name="familyPhotoSectionSummary" hide ng-model="picFileOth" accept=".pdf,.png,.jpg,.bmp,.tiff,.jpeg,.tif,.jfif"></div></div></div><!-- <div class="mt40 mt20i grncolor fz14 monstFamily fwb cursorP">+ UPLOAD PHOTOS</div> --></div><div ng-if="familyInformation.photo.questions[0].familyInformation_familyPhoto_1.answer == (\'answer_no\')"><div class="insName mb10 mt40 mt20i" data-translate="familyInformation_commentRequired"></div><div class="mt10" investigation-comment model-value="familyInformation.photo.questions[0].familyInformation_familyPhoto_1.comment.comment" req-val="true" comment-id="familyInformation.photo.questions[0].familyInformation_familyPhoto_1.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_familyPhoto_1" read-only="{{isreadonly}}"></div></div></div><!-- Side comment --><div ng-if="familyPhotoCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.PHOTO_INDEX" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION1_PHOTO" object-list="photoSectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Q2 Stars Here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40 mt20i" ng-class="{\'changeColor\': familyInformation.photo.questions[0].familyInformation_familyPhoto_2.answer}" data-translate="familyInformation2"></div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10 mt40 mt20i" data-translate="familyInformation_familyPhoto_2"></div><md-radio-group ng-disabled="isreadonly" ng-model="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.answer" layout="row" layout-xs="column" required ng-change="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.comment = {};"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr66i"><label class="registryContent" data-translate="familyInformation_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="familyInformation_no"></label></md-radio-button></div></md-radio-group><div ng-if="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.answer == (\'answer_yes\')"><div class="insName mb10 mt40 mt20i" data-translate="familyInformation_commentRequired"></div><div class="mt10" investigation-comment req-val="true" model-value="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.comment.comment" comment-id="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_familyPhoto_2" read-only="{{isreadonly}}"></div></div><div ng-if="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.answer == (\'answer_no\')"><!-- <div class="insName mb10 mt20 mt10i" data-translate="familyInformation_commentOptional"></div> --><div class="mt10" investigation-comment req-val="false" model-value="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.comment.comment" comment-id="familyInformation.photo.questions[0].familyInformation_familyPhoto_2.comment.id" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_familyPhoto_2" read-only="{{isreadonly}}"></div></div></div><!-- Side comment --><div ng-if="familyPhotoCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt50"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.FAMILY_INFORMATION" accordion-index="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.PHOTO_INDEX" question-name="vm.app.INVESTIGATION_FORM.FAMILY_QUESTIONS.QUESTION2_PHOTO" object-list="photoSectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- Family Photo Section Ends Here --><!-- Family Summary Starts Here --><div class="p40 pl0 p20i"><div flex-offset="10"><div class="investigationFormHeader" data-translate="familyInformation_label_summary"></div><div class="mt30 mt20i fz15 fwb monstFamily colorBoldBlack" data-translate="familyInformation_label_summarySection"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.FAMILY_INFORMATION)"><upload-form-file id-form-name="familyInfo" id-name="familyInformationSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div ng-init="familyInformation.summary.question = \'familyInformation_summary_comment\'"><div class="sectionBC mt40 mt20i mb10" data-translate="familyInformation_summary_comment"></div></div><!-- <div ckeditor="options" class="mb40 mb10i" ng-model="editorcontent" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="familyInformation_commentRequired"></div><div investigation-comment model-value="familyInformation.summary.comment.comment" comment-id="familyInformation.summary.comment.id" req-val="true" section-id="{{familyInfoSectionId}}" form-id="{{investigationFormId}}" question-key="familyInformation_summary_comment" read-only="{{isreadonly}}"></div></div></div></div></fieldset><!-- Family Summary Ends Here --><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><!-- Next Button Section End --> <input type="hidden" id="familyFormSave" ng-click="saveFamilyInformationDetails();vm.saveFamilyPhotoSectionDescription(uploadFileSectionFamilyPhotoList[0].uploadList);"></div></div><div class="hide"><div id="removeAttachedPhoto" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteUploadFiles"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div><md-button ng-click="vm.gobacktoForm();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="deleteAllFamilyPhoto(uploadFileSectionFamilyPhotoList[0].uploadList);vm.setRemovalFlag();" data-translate="delete"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="importFamilyDetailsId" class="md-dialog-container"><md-dialog class="importFamilyPopup w468p formSideContentColor" ng-class="{popupMBL:vm.media(\'xs\')}" layout="column"><md-toolbar class="formSideContentColor ptitle pt15imp"><div><div><div flex="95" class="popupTle1 width100 fLeft" ng-class="{heightInherit:vm.language}" data-translate="siblingDataImport"></div><div flex="5" class="fRight"><i ng-click="vm.closeCancel()" class="material-icons" data-translate="library.filters.closeicon"></i></div></div><div class="popupTle2 mt10" data-translate="siblingselection"></div></div></md-toolbar><md-dialog-content flex class="noHScroll h67p bgColorWh"><md-progress-linear ng-show="true" ng-if="vm.contentWaitForResponse" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-list ng-cloak><md-list-item class="h40px"><div flex="10" class="topAuto"><md-checkbox ng-model="siblingsSelectAll.checked" ng-if="vm.dataList.length!=0" ng-click="vm.selectAll()" class="mb0"></md-checkbox></div><div flex="65" data-translate="name" class="bold topAuto pb4"></div><div flex data-translate="relationship" class="bold topAuto pb4"></div></md-list-item><md-divider class="md-whiteframe-4dp"></md-divider><div class="noValueAlert" ng-if="vm.dataList.length==0" data-translate="filters.noResultsFound"></div><md-list-item ng-repeat="datum in vm.dataList" class="h46px mt10"><div flex="10" class="topAuto h46px pt10"><md-checkbox ng-model="datum.selected" ng-change="toggleSelect()"></md-checkbox></div><div flex="65" class="pb10">{{datum.questions[0].familyInformation_sibling_1_1.answer}}</div><div flex class="pb10"><span ng-if="datum.questions[0].familyInformation_sibling_1_6.answer == \'familyInformation_sibling_male\'" data-translate="brother"></span> <span ng-if="datum.questions[0].familyInformation_sibling_1_6.answer == \'familyInformation_sibling_female\'" data-translate="sister"></span></div><md-divider ng-if="!$last"></md-divider></md-list-item></md-list></md-dialog-content><md-dialog-actions class="formSideContentColor h100" ng-if="!vm.language"><div flex class="bold f20p fontColorWhite ml10" ng-if="!vm.numberOfSiblingsAdded==0"><span>{{vm.numberOfSiblingsAdded}} </span><span ng-if="vm.numberOfSiblingsAdded==1" data-translate="filters.sibling"></span> <span ng-if="vm.numberOfSiblingsAdded>1" data-translate="filters.siblings"></span></div><div layout-align="end end" class="pr15"><md-button ng-disabled="notselected" class="color-yellow fontColorBlack camelCase fontFamily bold" data-translate="siblingButton" ng-click="vm.siblingImportAlert($event,\'siblingImportAlert\')"></md-button></div></md-dialog-actions><md-dialog-actions class="formSideContentColor h100" ng-if="vm.language" layout="column"><div flex class="bold f20p mt10 fontColorWhite" ng-if="!vm.numberOfSiblingsAdded==0"><span>{{vm.numberOfSiblingsAdded}} </span><span ng-if="vm.numberOfSiblingsAdded==1" data-translate="filters.sibling"></span> <span ng-if="vm.numberOfSiblingsAdded>1" data-translate="filters.siblings"></span></div><div layout-align="center end" class="w100pMBL pr15"><md-button ng-disabled="notselected" class="color-yellow w100pMBL mbt20 fontColorBlack fontFamily camelCase bold" ng-class="{importBtnMBL: vm.media(\'xs\')}" data-translate="siblingButton" ng-click="vm.siblingImportAlert($event,\'siblingImportAlert\')"></md-button></div></md-dialog-actions></md-dialog></div><div id="siblingImportAlert" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center" class="marginAuto"><div layout="column"><div class="warnImage"><img class="done" src="content\\images\\dones.png"></div><div layout="column" layout-align="center center"><div class="confirmAssign"><span data-translate="siblingImport.sureTransferSiblings"></span></div><div class="assignSub"><span data-translate="siblingImport.onlyTimeAction"></span></div></div><div layout="column"><md-button ng-disabled="disableConfirm" ng-click="vm.siblingPopupButtonClick();" class="marginAuto formSubmit md-raised md-primary" ng-class="{confirmBtnWid:vm.language, btnWidth:(vm.language && vm.media(\'sm\')), fz10:(vm.language && vm.media(\'xs\'))}" data-translate="siblingImport.confirmImport"></md-button><md-button ng-click="vm.hideSiblingImportAlert($event,\'siblingImportAlert\',\'importFamilyDetailsId\');" class="marginAuto mt15imp" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/family-information/family.information.sibiling.form.html','<div class="accordian-holder" style="padding:0 10px 0 10px"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseSibiling($index)"><span class="accordianNameHolder caps"><span>Sibiling #{{$index+1}}</span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseSibiling($index)"><span class="lineSeparator" flex></span></div><div layout-align="center center" ng-click="vm.collapseSibiling($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : members.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseSibiling($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeSibiling($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><!--  Sibilings PAGE Starts Here --><div ng-class="{dataContent:true, activeContent:sibForm.expanded}"><!-- Question 1 Starts Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': memberName}">1</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10">Sibiling #</div><div class="insName mt40 mt20i">Sibiling Name</div><div><md-input-container class="m0" style="width:100%"><input class="test" type="text" style="width:100%"></md-input-container></div><div class="insName mt20 mt10i">Sibiling DOB</div><div><div modval="birthCertificate.sections[0].birthCertificate_2a.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="birthCertificate.sections[0].birthCertificate_2a.answer=datePickerFormat(birthCertificate.sections[0].birthCertificate_2a.answer)" ng-model="birthCertificate.sections[0].birthCertificate_2a.answer" type="text" md-open-on-focus md-hide-icons="all" class="test"></md-datepicker></md-input-container></div><div class="insName mt20 mt10i">Sibiling Type</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="bcFo" layout="row" layout-xs="column"><div class="mr25 mb10i" ng-repeat="sibType in sibilingType"><md-radio-button value="{{sibType.value}}" class="md-primary"><label class="registryContent">{{sibType.value}}</label></md-radio-button></div></md-radio-group><div ng-if="bcFo == \'Other\'" class="mtm7"><md-input-container class="m0 w100p"><input ng-model="sibType.subAnswer" type="text" class="test"></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="40" flex-xs="0"><div class="insName mt40 mt20i" ng-model="relation.name">Sibling declaration date</div><div><md-input-container class="m0" style="width:100%"><input ng-model="memberName" class="test" type="text" style="width:100%"></md-input-container></div></div><div flex="10"></div><div flex="40" flex-xs="0"><div class="insName mt40 mt20i">Declaration timing</div><div><md-input-container class="m0" style="width:100%"><input ng-model="Celuda" class="test" type="text"></md-input-container></div></div></div><div class="insName mb10">Sex</div><md-radio-group ng-model="confession" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="gender in sex"><md-radio-button value="{{gender.value}}" class="md-primary"><label class="registryContent">{{gender.value}}</label></md-radio-button></div></md-radio-group><div class="insName mb10 mt20 mt10i">Comments(Required)</div><div ckeditor="options" ng-model="editorcontent" ready="onReady()"></div><!-- Additional Sibiling --><div flex-offset="10" class="grncolor mt40 mt20i monstFamily fwb fz14 lineHeight18 cursorP" ng-click="vm.addfamilySibilingForm();">+ ADD SIBILINGS</div></div></div></div><!-- Question 1 Ends Here --></div><!--  Sibilings Page Ends Here -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/manage-attachments-directive/manage.attachments.html','<div id="manageAttachments_{{idName}}" ng-init="vm.show()" ng-click="showDialog($event,\'manageAttachmentPopupId\');"><div class="manageAttachmentsTxt"><span data-translate="prospects.manageAttachmentsPopup.manageAttachments"></span></div></div><div class="hide"><div id="manageAttachmentPopupId_{{idName}}" class="md-dialog-container"><md-dialog class="manageAttachmentPopup maxw825p h900p" ng-class="{popupMBL:media(\'xs\'), \'assignConfirmPopupWidth heightAuto\':showDeleteConfirmPopup == true, \'flexClass formSideContentColor\':showDeleteConfirmPopup == false}" layout="column"><md-toolbar flex-gt-sm="20" flex-sm="15" flex-xs="25" class="formSideContentColor caps s20mbl s25 pl27imp pt22 pt10mbl pr15mbl" ng-class="{\'displayNone\':showDeleteConfirmPopup == true,\'showBlk\':showDeleteConfirmPopup == false}"><div flex layout="column"><div flex-sm="55" class="pb10" layout="row"><div flex="95" ng-if="!isSummary" data-translate="prospects.investigationFormHeaders.{{idFormName}}"></div><div flex="95" ng-if="isSummary" data-translate="prospects.investigationFormHeaders.summary.{{idFormName}}"></div><div flex="5"><i ng-click="closeCancel()" class="material-icons fleft" data-translate="library.filters.closeicon"></i></div></div><div flex-sm="45" layout="row" layout-sm="row" layout-xs="column"><div flex-sm="75" flex-gt-sm="80" class="formValue pb5"><span data-translate="prospects.manageAttachmentsPopup.investigationDocuments"></span></div><div flex-sm="25" flex-gt-sm="20" ng-if="isReadOnly == \'false\'" align="center" class="deleteBtn w100pmbl mb5" ng-class="{deleteSelected : assetSelectedCount}" ng-click="(assetSelectedCount == 0) ? \'\' : deleteAllFileConfirm($event,assetList);"><span data-translate="prospects.manageAttachmentsPopup.delete"></span> ({{assetSelectedCount}}) <span data-translate="prospects.manageAttachmentsPopup.documents"></span></div></div></div></md-toolbar><md-dialog-content class="noHScroll h67p bgColorWh p15" ng-class="{\'displayNone\':showDeleteConfirmPopup == true,\'showBlk\':showDeleteConfirmPopup == false}"><div class="h35px" ng-if="isReadOnly == \'false\'"><div class="manageAttachmentsTxt" align="right" ng-model="isAllSelected"><div class="w205pximp mr5per"><span ng-click="toggleAll();" ng-if="assetSelectedCount == assetList.length" data-translate="prospects.manageAttachmentsPopup.deselectAll"></span> <span ng-click="toggleAll();" ng-if="assetSelectedCount < assetList.length || assetSelectedCount == 0" data-translate="prospects.manageAttachmentsPopup.selectAll"></span></div></div></div><preview-image base-url="baseUrl" asset-list="assetList" asset-selected-count="assetSelectedCount" is-read-only="isReadOnly"></preview-image></md-dialog-content><md-dialog-content ng-if="showDeleteConfirmPopup"><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteMultipleFile"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.deleteMultipleUndone"></span></div></div><div><md-button ng-click="closeOpen($event);" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="deleteMultipleFile($event,assetList);" data-translate="delete"></md-button></div></div></div></md-dialog-content></md-dialog></div></div><div class="hide"><div id="deleteMultipleFilePopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.deleteMultipleFile"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.deleteMultipleUndone"></span></div></div><div><md-button ng-click="closeOpen($event);" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="deleteMultipleFile($event);" data-translate="delete"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/location-directive/form.locationdirective.html','<div id="locationFilter" class="locationFilter"><div ng-show="!horizon"><div><div flex class="pr4 pb4" ng-hide="ishideObject.country"><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.country"></label></div><!-- \t\t\t\t <i ng-if="modelObject.countryObj.countryId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'COUNTRY\'),call()]:clear(\'COUNTRY\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-hide="inputsearchObject.isAddOrSaveLocationCountry && addnewlocationObject.country" ng-class="{borderError:!modelObject.countryObj.countryTxt && formName.$submitted}" name="country" ng-model="modelObject.countryObj" ng-change="populatePreFillDetails(modelObject.countryObj);validateLocationMapping();" md-on-open="saveValid({type:\'COUNTRY\'});" md-on-close="relpaceinputfield();clearName(\'countryObj\',\'country\',\'searchLocationCountryList\');saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.countryObj.countryTxt == undefined ? (\'library.search.country\' | translate) : modelObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection ofH libLocation camelCase"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.country, \'COUNTRY\')" ng-model="inputsearchObject.country" type="search" ng-change="countrySearchChange();" placeholder="{{\'library.search.country\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.country.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCountryList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.country.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in searchLocationCountryList = (searchLocationCountryList | filter:country)">{{dropValueCountry.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCountryList.length == 0 && inputsearchObject.country.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="inputsearchObject.isAddOrSaveLocationCountry && addnewlocationObject.country"><input ng-disabled="disableFlag" id="requestSectorSearchKey" class="right-dropdown-search camelCase w95 popupFont" name="country" ng-change="countryChange();" ng-model="inputsearchObject.countrySearchKey" type="search"></md-input-container><div ng-if="!modelObject.countryObj.countryTxt"><div ng-if="!inputsearchObject.countrySearchKey" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div flex class="pr4 pb5" ng-hide="ishideObject.province"><!-- <label layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.province"></label> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.province"></label></div><!-- \t\t\t \t   <i ng-if="modelObject.provinceObj.provinceId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'PROVINCE\'),call()]:clear(\'PROVINCE\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-hide="inputsearchObject.isAddOrSaveLocationProvince && addnewlocationObject.province" ng-class="{borderError:!modelObject.provinceObj.provinceTxt && formName.$submitted}" name="province" ng-model="modelObject.provinceObj" ng-change="populatePreFillDetails(modelObject.provinceObj);validateLocationMapping();;" md-on-open="saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});" md-on-close="relpaceinputfield();clearName(\'provinceObj\',\'province\',\'searchLocationProvinceList\');saveValid({type:\'PROVINCE\'});validateLocationMapping();;" placeholder="{{modelObject.provinceObj.provinceTxt == undefined ? (\'library.search.province\' | translate) : modelObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.province, \'PROVINCE\')" ng-change="provinceSearchChange();" ng-model="inputsearchObject.province" type="search" placeholder="{{\'library.search.province\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.province.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationProvinceList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.province.length >1" ng-value="dropValueProvince" ng-repeat="dropValueProvince in searchLocationProvinceList = (searchLocationProvinceList | filter:province)">{{dropValueProvince.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationProvinceList.length == 0 && inputsearchObject.province.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container md-no-float class="locationPopInputSty w100Imp" ng-show="inputsearchObject.isAddOrSaveLocationProvince && addnewlocationObject.province"><input ng-disabled="disableFlag" id="requestSectorSearchKey" class="right-dropdown-search camelCase w95 popupFont" ng-change="provinceChange();" name="province" ng-model="inputsearchObject.provinceSearchKey" type="search"></md-input-container><div ng-if="!modelObject.provinceObj.provinceTxt"><div ng-if="!inputsearchObject.provinceSearchKey" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div flex class="pr4 pb5" ng-hide="ishideObject.city"><!-- <label layout="column"  layout-align="start start" class="filterSubHeading camelCase" data-translate="library.filters.city"></label> --><div layout="row" layout-align="start start"><label class="filterSubHeading camelCase require" data-translate="library.filters.city"></label></div><!-- \t\t\t \t   <i ng-if="modelObject.cityObj.cityId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'CITY\'),call()]:clear(\'CITY\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-hide="inputsearchObject.isAddOrSaveLocationCity && addnewlocationObject.city" ng-class="{borderError:!modelObject.cityObj.cityTxt && formName.$submitted}" name="city" ng-model="modelObject.cityObj" ng-change="populatePreFillDetails(modelObject.cityObj);validateLocationMapping();" md-on-open="saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});" md-on-close="relpaceinputfield();clearName(\'cityObj\',\'city\',\'searchLocationCityList\');saveValid({type:\'CITY\'});validateLocationMapping();" placeholder="{{modelObject.cityObj.cityTxt == undefined ? (\'library.search.city\' | translate) : modelObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.city, \'CITY\')" ng-change="citySearchChange();" ng-model="inputsearchObject.city" type="search" placeholder="{{\'library.search.city\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.city.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCityList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.city.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in searchLocationCityList = (searchLocationCityList | filter:city)">{{dropValueCity.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCityList.length == 0 && inputsearchObject.city.length > 1" data-translate="library.filters.noresult"></div></md-select><md-input-container ng-show="inputsearchObject.isAddOrSaveLocationCity && addnewlocationObject.city" md-no-float class="locationPopInputSty w100Imp" flex><input ng-disabled="disableFlag" id="requestCitySearchKey" class="right-dropdown-search camelCase w95 popupFont" ng-change="cityChange();" name="city" ng-model="inputsearchObject.citySearchKey" type="search"></md-input-container><div ng-if="!modelObject.cityObj.cityTxt"><div ng-if="!inputsearchObject.citySearchKey" class="errorMsg"><span data-translate="library.popup.validation.required"></span></div></div></div><div flex class="pr4" ng-hide="ishideObject.sector"><!-- Sector label is replaced with Neighborhood for only neighborhood section --> <label layout="column" layout-align="start start" class="filterSubHeading camelCase" data-translate="{{currentState != \'neighbourhoodCanvas\' ? \'library.filters.sector\' : \'library.filters.neighborhoodSector\'}}"></label><!-- \t\t\t \t   <i ng-if="modelObject.sectorObj.sectorId && !disableFlag" ng-click="media(\'gt-sm\') ? [clear(\'SECTOR\'),call()]:clear(\'SECTOR\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-hide="inputsearchObject.isAddOrSaveLocationSector && addnewlocationObject.sector" name="sector" ng-model="modelObject.sectorObj" ng-change="populatePreFillDetails(modelObject.sectorObj);validateLocationMapping();" md-on-open="saveValid({type:\'SECTOR\'});saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});" md-on-close="relpaceinputfield();saveValid({type:\'SECTOR\'});validateLocationMapping();" placeholder="{{modelObject.sectorObj.sectorTxt == undefined ? (\'library.search.sector\' | translate) : modelObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.sector, \'SECTOR\')" ng-change="sectorSearchChange();" ng-model="inputsearchObject.sector" type="search" placeholder="{{\'library.search.sector\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.sector.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationSectorList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.sector.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in searchLocationSectorList = (searchLocationSectorList | filter:sector)">{{dropValueSector.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationSectorList == 0 && inputsearchObject.sector.length > 1" data-translate="library.filters.noresult"></div></md-select><div layout="row"><!-- \t          \t\t<i ng-if="relpaceinputfieldObject.sectorKey" ng-click="clear(\'SECTOR\')" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-input-container ng-show="inputsearchObject.isAddOrSaveLocationSector && addnewlocationObject.sector" md-no-float class="locationPopInputSty w100Imp" flex><input ng-disabled="disableFlag" id="requestSectorSearchKey" class="right-dropdown-search camelCase w95 popupFont" ng-change="sectorChange();" ng-model="inputsearchObject.sectorSearchKey" type="search"></md-input-container></div></div></div></div><div ng-show="horizon"><!-- layout-xs="column" --><div layout-gt-xs="row"><div flex class="pr4 pb4 pr16"><!-- <div layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.country"></div> --><div layout="row" layout-align="start start" ng-hide="inputsearchObject.isAddOrSaveLocationCountry && addNewLocation"><label class="filterSubHeading camelCase require" data-translate="library.filters.country"></label></div><!-- \t\t\t\t <i ng-if="modelObject.countryObj.countryId && !disableFlag" ng-click="clear(\'COUNTRY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i>  --><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'countryObj\',\'countryId\') && (!ishideObject.country && !relpaceinputfieldObject.country)" ng-class="{borderError:(!modelObject.countryObj.countryTxt && formName.$submitted) || (inputsearchObject.isInputEmptyCountry)}" name="country" ng-hide="inputsearchObject.isAddOrSaveLocationCountry && addNewLocation" ng-model="modelObject.countryObj" ng-change="populatePreFillDetails(modelObject.countryObj);validateLocationMapping(); call();" md-on-open="saveValid({type:\'COUNTRY\'});" md-on-close="clearName(\'countryObj\',\'country\',\'searchLocationCountryList\');saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.countryObj.countryTxt == undefined ? (\'library.search.country\' | translate) : modelObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation selectWidth"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.country, \'COUNTRY\')" ng-change="countrySearchChange();" ng-model="inputsearchObject.country" type="search" placeholder="{{\'library.search.country\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="stickySearchField searchNotification" ng-hide="inputsearchObject.country.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCountryList" class="stickySearchCountry camelCase"><md-option ng-if="inputsearchObject.country.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in searchLocationCountryList = (searchLocationCountryList | filter:country)">{{dropValueCountry.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCountryList.length == 0 && inputsearchObject.country.length > 1" data-translate="library.filters.noresult"></div></md-select><div layout="row" layout-align="start start" ng-show="inputsearchObject.isAddOrSaveLocationCountry && addNewLocation"><label class="filterSubHeadingnew lgreycolor camelCase" data-translate="library.filters.country"></label>&nbsp;<span class="lgreycolor">*</span></div><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'countryObj\',\'countryId\') && (!ishideObject.country && !relpaceinputfieldObject.country)" ng-class="{borderError:(!inputsearchObject.countrySearchKey && formName.$submitted) || (inputsearchObject.isInputEmptyCountry)}" name="country" ng-show="inputsearchObject.isAddOrSaveLocationCountry && addNewLocation" ng-model="modelObject.countryObj" ng-change="populatePreFillDetails(modelObject.countryObj);validateLocationMapping(); call();" md-on-open="saveValid({type:\'COUNTRY\'});" md-on-close="clearName(\'countryObj\',\'country\',\'searchLocationCountryList\');saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.countryObj.countryTxt == undefined ? (inputsearchObject.countrySearchKey == undefined || inputsearchObject.countrySearchKey == \'\') ? (\'library.search.country\' | translate) : inputsearchObject.countrySearchKey : modelObject.countryObj.countryTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation selectWidth"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg" flex><input id="requestCountrySearchKey" class="right-dropdown-search camelCase popupFont" no-special-char common-search search-callback="searchLocation(inputsearchObject.countrySearchKey, \'COUNTRY\')" ng-change="countryChange();" ng-model="inputsearchObject.countrySearchKey" ng-disabled="disableFlag" type="search"></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.countrySearchKey.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCountryList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.countrySearchKey.length >1" ng-value="dropValueCountry" ng-repeat="dropValueCountry in searchLocationCountryList = (searchLocationCountryList | filter:country)">{{dropValueCountry.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCountryList.length == 0 && inputsearchObject.countrySearchKey.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.country.$error"><div ng-if="formName.country.$error && formName.$submitted" class="errorMsg"><div ng-if="!modelObject.countryObj.countryTxt"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex-gt-sm="10"></div><div flex class="pr4 pb4 pr16"><!-- <div layout="column"  layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.province"></div> --><div layout="row" layout-align="start start" ng-hide="inputsearchObject.isAddOrSaveLocationProvince && addNewLocation"><label class="filterSubHeading camelCase require" data-translate="library.filters.province/state"></label></div><!-- \t\t \t   <i ng-if="modelObject.provinceObj.provinceId && !disableFlag" ng-click="clear(\'PROVINCE\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'provinceObj\',\'provinceId\') && (!ishideObject.province && !relpaceinputfieldObject.province)" ng-class="{borderError:(!modelObject.provinceObj.provinceTxt && formName.$submitted) || (inputsearchObject.isInputEmptyProvince)}" name="province" ng-hide="inputsearchObject.isAddOrSaveLocationProvince && addNewLocation" ng-model="modelObject.provinceObj" ng-change="populatePreFillDetails(modelObject.provinceObj);validateLocationMapping();; call();" md-on-open="saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});" md-on-close="clearName(\'provinceObj\',\'province\',\'searchLocationProvinceList\');saveValid({type:\'PROVINCE\'});validateLocationMapping();;" placeholder="{{modelObject.provinceObj.provinceTxt == undefined ? (\'library.search.province\' | translate) : modelObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.province, \'PROVINCE\')" ng-model="inputsearchObject.province" ng-change="provinceSearchChange();" type="search" placeholder="{{\'library.search.province\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="stickySearchField searchNotification" ng-hide="inputsearchObject.province.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationProvinceList" class="stickySearchProvince camelCase"><md-option ng-if="inputsearchObject.province.length >1" ng-value="dropValueProvince" ng-repeat="dropValueProvince in searchLocationProvinceList = (searchLocationProvinceList | filter:province)">{{dropValueProvince.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationProvinceList.length == 0 && inputsearchObject.province.length > 1" data-translate="library.filters.noresult"></div></md-select><div layout="row" layout-align="start start" ng-show="inputsearchObject.isAddOrSaveLocationProvince && addNewLocation"><label class="filterSubHeadingnew lgreycolor camelCase" data-translate="library.filters.province/state"></label>&nbsp;<span class="lgreycolor">*</span></div><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'provinceObj\',\'provinceId\') && (!ishideObject.province && !relpaceinputfieldObject.province)" ng-class="{borderError:(!inputsearchObject.provinceSearchKey && formName.$submitted) || (inputsearchObject.isInputEmptyProvince)}" name="province" ng-show="inputsearchObject.isAddOrSaveLocationProvince && addNewLocation" ng-model="modelObject.provinceObj" ng-change="populatePreFillDetails(modelObject.provinceObj);validateLocationMapping();; call();" md-on-open="saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});" md-on-close="clearName(\'provinceObj\',\'province\',\'searchLocationProvinceList\');saveValid({type:\'PROVINCE\'});validateLocationMapping();;" placeholder="{{modelObject.provinceObj.provinceTxt == undefined ? (inputsearchObject.provinceSearchKey == undefined || inputsearchObject.provinceSearchKey == \'\') ? (\'library.search.province\' | translate) : inputsearchObject.provinceSearchKey : modelObject.provinceObj.provinceTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg" flex><input id="requestProvinceSearchKey" class="right-dropdown-search camelCase popupFont" no-special-char common-search search-callback="searchLocation(inputsearchObject.provinceSearchKey, \'PROVINCE\')" ng-change="provinceChange();" ng-model="inputsearchObject.provinceSearchKey" ng-disabled="disableFlag" type="search"></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.provinceSearchKey.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationProvinceList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.provinceSearchKey.length >1" ng-value="dropValueProvince" ng-repeat="dropValueProvince in searchLocationProvinceList = (searchLocationProvinceList | filter:province)">{{dropValueProvince.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationProvinceList.length == 0 && inputsearchObject.provinceSearchKey.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.province.$error"><div ng-if="formName.province.$error && formName.$submitted" class="errorMsg"><div ng-if="!modelObject.provinceObj.provinceTxt"><span data-translate="library.popup.validation.required"></span></div></div></div></div></div><div layout-gt-xs="row"><div flex class="pr4 pb4 pr16"><!--  <label layout="column" layout-align="start start" class="filterSubHeading caps" data-translate="library.filters.city"></label> --><div layout="row" layout-align="start start" ng-hide="inputsearchObject.isAddOrSaveLocationCity && addNewLocation"><label class="filterSubHeading camelCase require" data-translate="library.filters.city"></label></div><!-- \t\t\t \t   <i ng-if="modelObject.cityObj.cityId && !disableFlag" ng-click="clear(\'CITY\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'cityObj\',\'cityId\') && (!ishideObject.city && !relpaceinputfieldObject.city)" ng-class="{borderError:(!modelObject.cityObj.cityTxt && formName.$submitted) || (inputsearchObject.isInputEmptyCity)}" name="city" ng-hide="inputsearchObject.isAddOrSaveLocationCity && addNewLocation" ng-model="modelObject.cityObj" ng-change="populatePreFillDetails(modelObject.cityObj);validateLocationMapping();call();" md-on-open="saveValid({type:\'CITY\'});" md-on-close="clearName(\'cityObj\',\'city\',\'searchLocationCityList\');saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.cityObj.cityTxt == undefined ? (\'library.search.city\' | translate) : modelObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.city, \'CITY\')" ng-model="inputsearchObject.city" type="search" ng-change="citySearchChange();" placeholder="{{\'library.search.city\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="stickySearchField searchNotification" ng-hide="inputsearchObject.city.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCityList" class="stickySearchCity camelCase"><md-option ng-if="inputsearchObject.city.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in searchLocationCityList = (searchLocationCityList | filter:city)">{{dropValueCity.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCityList.length == 0 && inputsearchObject.city.length > 1" data-translate="library.filters.noresult"></div></md-select><div layout="row" layout-align="start start" ng-show="inputsearchObject.isAddOrSaveLocationCity && addNewLocation"><label class="filterSubHeadingnew lgreycolor camelCase" data-translate="library.filters.city"></label>&nbsp;<span class="lgreycolor">*</span></div><md-select ng-disabled="disableFlag" ng-required="!checkRequiredFields(\'cityObj\',\'cityId\') && (!ishideObject.city && !relpaceinputfieldObject.city)" ng-class="{borderError:(!inputsearchObject.citySearchKey && formName.$submitted) || (inputsearchObject.isInputEmptyCity)}" name="city" ng-model="modelObject.cityObj" ng-show="inputsearchObject.isAddOrSaveLocationCity && addNewLocation" ng-change="populatePreFillDetails(modelObject.cityObj);validateLocationMapping();call();" md-on-open="saveValid({type:\'CITY\'});" md-on-close="clearName(\'cityObj\',\'city\',\'searchLocationCityList\');saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.cityObj.cityTxt == undefined ? (inputsearchObject.citySearchKey == undefined || inputsearchObject.citySearchKey == \'\') ? (\'library.search.city\' | translate) : inputsearchObject.citySearchKey : modelObject.cityObj.cityTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg" flex><input id="requestcitySearchKey" class="left-drop-library-search mb3 cursorText" no-special-char common-search search-callback="searchLocation(inputsearchObject.citySearchKey, \'CITY\')" ng-change="cityChange();" ng-model="inputsearchObject.citySearchKey" ng-disabled="disableFlag" type="search"></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.citySearchKey.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationCityList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.citySearchKey.length >1" ng-value="dropValueCity" ng-repeat="dropValueCity in searchLocationCityList = (searchLocationCityList | filter:city)">{{dropValueCity.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationCityList.length == 0 && inputsearchObject.citySearchKey.length > 1" data-translate="library.filters.noresult"></div></md-select><div ng-messages="formName.city.$error"><div ng-value="formName.city.$error" ng-if="formName.city.$error && formName.$submitted" class="errorMsg"><div ng-if="!modelObject.cityObj.cityTxt"><span data-translate="library.popup.validation.required"></span></div></div></div></div><div flex-gt-sm="10"></div><div flex class="pr4 pb4 pr16"><!-- Sector label is replaced with Neighborhood for only neighborhood section --> <label layout="column" layout-align="start start" ng-hide="inputsearchObject.isAddOrSaveLocationSector  && addNewLocation" class="filterSubHeading camelCase" data-translate="{{currentState != \'neighbourhoodCanvas\' ? \'library.filters.sector\' : \'library.filters.neighborhoodSector\'}}"></label><!-- \t\t \t   <i ng-if="modelObject.sectorObj.sectorId && !disableFlag" ng-click="clear(\'SECTOR\');call();" class="material-icons fleft librarySelect" data-translate="library.filters.close"></i> --><md-select ng-disabled="disableFlag" name="sector" ng-hide="inputsearchObject.isAddOrSaveLocationSector  && addNewLocation" ng-model="modelObject.sectorObj" ng-change="populatePreFillDetails(modelObject.sectorObj);validateLocationMapping();call();" md-on-open="saveValid({type:\'SECTOR\'});" md-on-close="clearName(\'sectorObj\',\'sector\',\'searchLocationSectorList\');saveValid({type:\'SECTOR\'});saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.sectorObj.sectorTxt == undefined ? (\'library.search.sector\' | translate) : modelObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg"><input focus no-special-char common-search search-callback="searchLocation(inputsearchObject.sector, \'SECTOR\')" ng-change="sectorSearchChange();" ng-model="inputsearchObject.sector" type="search" placeholder="{{\'library.search.sector\' | translate}}" class="left-drop-library-search mb3 cursorText" ng-minlength="2"><!-- <i flex-order="3" ng-if="serchFilterClub.length > 1" ng-click="clear(\'club\');" class="material-icons removeSelection">close</i> --></md-input-container></md-select-header><div class="stickySearchField searchNotification" ng-hide="inputsearchObject.sector.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationSectorList" class="stickySearchSector camelCase"><md-option ng-if="inputsearchObject.sector.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in searchLocationSectorList = (searchLocationSectorList | filter:sector)">{{dropValueSector.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationSectorList == 0 && inputsearchObject.sector.length > 1" data-translate="library.filters.noresult"></div></md-select><label layout="column" layout-align="start start" ng-show="inputsearchObject.isAddOrSaveLocationSector  && addNewLocation" class="filterSubHeadingnew lgreycolor camelCase" data-translate="{{currentState != \'neighbourhoodCanvas\' ? \'library.filters.sector\' : \'library.filters.neighborhoodSector\'}}"></label><md-select ng-disabled="disableFlag" name="sector" ng-show="inputsearchObject.isAddOrSaveLocationSector  && addNewLocation" ng-model="modelObject.sectorObj" ng-change="populatePreFillDetails(modelObject.sectorObj);validateLocationMapping();call();" md-on-open="saveValid({type:\'SECTOR\'});" md-on-close="clearName(\'sectorObj\',\'sector\',\'searchLocationSectorList\');saveValid({type:\'SECTOR\'});saveValid({type:\'CITY\'});saveValid({type:\'PROVINCE\'});saveValid({type:\'COUNTRY\'});validateLocationMapping();" placeholder="{{modelObject.sectorObj.sectorTxt == undefined ? (inputsearchObject.sectorSearchKey == undefined || inputsearchObject.sectorSearchKey == \'\') ? (\'library.search.sector\' | translate) : inputsearchObject.sectorSearchKey : modelObject.sectorObj.sectorTxt }}" class="md-no-underline selectHeader dropdownSelection camelCase ofH libLocation"><md-select-header><md-input-container md-no-float class="md-block dropdown-search hide-error-msg" flex><input id="requestSectorSearchKey" class="right-dropdown-search camelCase popupFont" no-special-char common-search search-callback="searchLocation(inputsearchObject.sectorSearchKey, \'SECTOR\')" ng-change="sectorChange();" ng-model="inputsearchObject.sectorSearchKey" ng-disabled="disableFlag" type="search"></md-input-container></md-select-header><div class="searchNotification" ng-hide="inputsearchObject.sectorSearchKey.length >1" data-translate="library.filters.minsearch"></div><md-progress-linear ng-if="locLoader" md-class="md-warn" md-mode="indeterminate"></md-progress-linear><md-optgroup label="searchLocationSectorList" class="stickySearch camelCase"><md-option ng-if="inputsearchObject.sectorSearchKey.length >1" ng-value="dropValueSector" ng-repeat="dropValueSector in searchLocationSectorList = (searchLocationSectorList | filter:sector)">{{dropValueSector.fullName}}</md-option></md-optgroup><div class="searchNotification" ng-if="searchLocationSectorList.length == 0 && inputsearchObject.sectorSearchKey.length > 1" data-translate="library.filters.noresult"></div></md-select></div></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.accordion.html','<div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps"><span data-translate="neighborhood_accordian"></span> <span>{{$index+1}}</span> </span><span ng-if="name.institution" class="accordianNameHolder caps"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : ncForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeneighbourhoodCanvasForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:ncForm.expanded}"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i" ng-init="vm.interviewFlag(2)"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': ncForm.questions[0].neighborhood_1.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="neighborhood_1"></div><div class="mt18 mt9i"><md-radio-group ng-model="ncForm.questions[0].neighborhood_1.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><!-- Q1 yes starts here--><div ng-if="ncForm.questions[0].neighborhood_1.answer == (\'neighborhood_yes\' | translate)"><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40" data-translate="neighborhood_1a"></div><div><md-input-container class="m0 w100p"><input ng-model="ncForm.questions[0].neighborhood_1a.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_province/state"></div><div><md-input-container class="m0 w100p"><input ng-model="ncForm.questions[0].neighborhood_province/state.answer" type="text" class="test"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40" data-translate="neighborhood_1c"></div><div><md-input-container class="m0 w100p"><input ng-model="ncForm.questions[0].neighborhood_1c.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_1d"></div><div><md-input-container class="m0 w100p"><input ng-model="ncForm.questions[0].neighborhood_1d.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mt40 mt20i" data-translate="neighborhood_1e"></div><div><md-input-container class="m0" style="width:100%"><!-- <input ng-model="ncForm.questions[0].neighborhood_1e.answer" class="test" type="text" style="width: 100%"> --><md-datepicker ng-model="ncForm.questions[0].neighborhood_1e.answer" md-max-date="vm.maxDate" type="text" md-open-on-focus md-hide-icons="calendar" class="test"></md-datepicker></md-input-container></div><!-- Interviee Section Starts Here --><div ng-if="ncForm.questions[0].neighborhood_1.answer == (\'neighborhood_yes\' | translate)" ng-init="vm.interviewFlag(2, $index)"><div layout="row"><div flex flex-xs><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.interview.html\'"></div> --><div ng-if="!ncForm.questions[0].neighborhood_1.interviews" ng-init="ncForm.questions[0].neighborhood_1.interviews = []; ncForm.questions[0].neighborhood_1.interviews[0].questions = []"></div><div ng-repeat="interviewee in ncForm.questions[0].neighborhood_1.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row" class="mt20i" ng-class="{mt40 : $index+1 > 1 }"><label class="interviewTxt"><span data-translate="neighborhood_inv"></span> # {{$index+1}}</label><div ng-click="ncForm.questions[0].neighborhood_1.interviews.splice($index,1)"><span><i ng-if="ncForm.questions[0].neighborhood_1.interviews.length > 1" class="material-icons trashInterview">delete</i></span></div><!-- <i ng-if="ncForm.questions[0].neighborhood_1.interviews.length > 1" class="material-icons trashInterview" ng-click="vm.deleteInterviewee($index)">delete</i> --></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_inv_a"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].neighborhood_inv_a.answer" type="text" class="test"></md-input-container></div></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_inv_c"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].neighborhood_inv_c.answer" type="text" class="test"></md-input-container></div></div></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_inv_b"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].neighborhood_inv_b.answer" type="text" class="test"></md-input-container></div></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="neighborhood_inv_d"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].neighborhood_inv_d.answer" type="text" class="test"></md-input-container></div></div></div><!-- Q2e Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_e"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_e.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_e.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_e.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_e.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_e.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_e"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_e.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2e Ends Here --><!-- Q2f Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_f"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_f.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_f.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_f.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_f.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_f.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_f"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_f.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2f Ends Here --><!-- Q2g Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_g"></div><div layout="row" layout-xs="column" class="mt20 mt30MBL"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_g.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_g.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_g.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_g.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_g.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_g"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_g.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2g Ends Here --><!-- Q2h Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_h"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_h.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_h.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_h.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_h.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_h.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_h"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_h.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2h Ends Here --><!-- Q2i Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_i"></div><div layout="row" layout-xs="column" class="mt20 mt30MBL"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_i.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_i.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_i.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_i.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_i.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_i"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_i.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2i Ends Here --><!-- Q2j Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_j"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="interviewee.questions[0].neighborhood_inv_j.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="Yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'neighborhood_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="No"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_j.answer == (\'neighborhood_yes\' | translate) || interviewee.questions[0].neighborhood_inv_j.answer == (\'neighborhood_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_opt"></div><div investigation-comment class="w99p" model-value="interviewee.questions[0].neighborhood_inv_j.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_j.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_j"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_j.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2j Ends Here --></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="neighborhood_inv_add"></div> --><div class="additionalInterviewTxt mt40 mt20i" ng-click="ncForm.questions[0].neighborhood_1.interviews.push({})" data-translate="neighborhood_inv_add"></div><!-- Interview part ends --></div></div></div><!-- Interviee Section Ends Here --><!-- <div class="mt40 mt20i">\n\t\t\t\t\t<div class="insName mb10">Comment(Optional)</div>\n\t\t\t\t\t<div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div>\n\t\t\t\t</div> --></div></div></div></div><!-- Q1 no starts here--><div flex-offset="10" flex-offset-xs="20" ng-if="ncForm.questions[0].neighborhood_1.answer == (\'neighborhood_no\' | translate)"><div class="mt20i pr40 mb40"><div class="insName mb10" data-translate="neighborhood_comment_req"></div><div investigation-comment class="w99p" model-value="ncForm.questions[0].neighborhood_1.comment.comment" comment-id="ncForm.questions[0].neighborhood_1.comment.id" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_1"></div><!-- <div ckeditor="options" ng-model="ncForm.questions[0].neighborhood_1.comment.comment" ready="onReady()"></div> --></div></div><div class="dividerDiv mt10"></div><!-- Question 1 Ends Here--></div><!-- Accordion Popup Starts Here --><!-- <div class="hide">\n\t<div id="accordionCloseConformPopup" class="md-dialog-container">\n\t\t<md-dialog class="assignConfirmPopupWidth"> \n\t\t\t<md-dialog-content>\n\t\t\t\t<div layout="row" flex  class="m50imp">\n\t\t\t\t\t<div layout="column" layout-margin layout-align="center center">\n\t\t\t\t\t\t<div layout="column" layout-align="center center">\n\t\t\t\t\t\t\t<div class="assignSub">\n\t\t\t\t\t\t\t\t<span>Do you want to delete the record?</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t<md-button ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary">CANCEL</md-button>\n\t\t\t\t\t\t\t<md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform($index);">DELETE</md-button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</md-dialog-content> \n\t\t</md-dialog>\n\t</div>\n</div> --><!-- Accordion Popup Ends Here -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.form.html','<form><fieldset ng-disabled="isreadonly && sideCommentVisible"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': ncForm.questions[0].neighborhood_1.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="neighborhood_1"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly || ncForm.questions[0].neighborhood_1.requested" ng-model="ncForm.questions[0].neighborhood_1.answer" ng-change="ncForm.questions[0].neighborhood_1a={};ncForm.questions[0].neighborhood_1b={};ncForm.questions[0].neighborhood_1c={};\n\t\t\t\t\t\tncForm.questions[0].neighborhood_1d={};ncForm.questions[0].neighborhood_1e={};ncForm.questions[0].neighborhood_1.interviews=[];\n\t\t\t\t\t\tncForm.questions[0].neighborhood_1.interviews[0].questions=[];ncForm.questions[0].neighborhood_1.comment={};vm.inputSearchObject={};vm.entityLocationObject={};" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><!-- Q1 yes starts here--><div ng-if="ncForm.questions[0].neighborhood_1.answer == (\'answer_yes\')"><!-- This init call used to check the location request status --><div ng-if="!isreadonly && ncForm.questions[0].neighborhood_1.requested && ncForm.questions[0].neighborhood_1.answerId && sideCommentTrigger"><div ng-init="vm.checkLocationRequest(ncForm.questions[0])"></div></div><!-- Location Mapping --><div class="mt20" id="neighborhoodLocation"><form-location-filter disable-flag="isreadonly || ncForm.questions[0].neighborhood_1.requested" class="width100" inputsearch-object="vm.inputSearchObject" model-object="vm.entityLocationObject" horizon-flag="true" add-new-location="true" is-requested="ncForm.questions[0].neighborhood_1.subAnswer" form-name="neigborhoodForm"></form-location-filter></div><div class="mt20 mt10i mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && (vm.inputSearchObject.isAddOrSaveLocationCountry || vm.inputSearchObject.isAddOrSaveLocationProvince || vm.inputSearchObject.isAddOrSaveLocationCity || vm.inputSearchObject.isAddOrSaveLocationSector) && !ncForm.questions[0].neighborhood_1.requested"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="formLocationRequest($event);" data-translate="add_location"></div></div><div class="mt20 mt10i mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ncForm.questions[0].neighborhood_1.requested && !ncForm.questions[0].neighborhood_1.requestAlreadyApplied"><div class="attachmentAddText" data-translate="added_location"></div><div class="mt20 mt10i mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ncForm.questions[0].neighborhood_1.requested && ncForm.questions[0].neighborhood_1.requestAlreadyApplied"><div class="attachmentAddText" data-translate="location_request_already_applied"></div></div></div><!-- To define the location request is approved --><div class="mt20 mt10i mb30" ng-if="!(vm.inputSearchObject.isAddOrSaveLocationCountry || vm.inputSearchObject.isAddOrSaveLocationProvince || vm.inputSearchObject.isAddOrSaveLocationCity || vm.inputSearchObject.isAddOrSaveLocationSector) && !ncForm.questions[0].neighborhood_1.requested && ncForm.questions[0].neighborhood_1.subAnswer"><div class="attachmentAddText" data-translate="approved_location"></div></div><div class="insName mt40 mt20i" data-translate="neighborhood_1e"></div><div><div modval="ncForm.questions[0].neighborhood_1e.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0" style="width:100%"><md-datepicker ng-model="ncForm.questions[0].neighborhood_1e.answer" md-max-date="maxDate" type="text" md-hide-icons="calendar" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><!-- Interviee Section Starts Here --><div ng-if="ncForm.questions[0].neighborhood_1.answer == (\'answer_yes\')"><div layout="row"><div flex flex-xs><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.interview.html\'"></div> --><div ng-if="!ncForm.questions[0].neighborhood_1.interviews" ng-init="ncForm.questions[0].neighborhood_1.interviews = []; ncForm.questions[0].neighborhood_1.interviews[0].questions = []"></div><div ng-if="interviewFlag"><div ng-repeat="interviewee in ncForm.questions[0].neighborhood_1.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row" class="mt20i" ng-class="{mt40 : $index+1 > 1 }"><div><label class="interviewTxt" data-translate="neighborhood_inv"></label></div><span class="interviewTxt mr10 pl5"># {{$index+1}}</span><div ng-if="!isreadonly && ncForm.questions[0].neighborhood_1.interviews.length > 1" ng-click="vm.deleteIndex($event,\'deleteInterviewConformPopup\',$index)"><span><i class="material-icons trashInterview">delete</i></span></div><!-- <i ng-if="ncForm.questions[0].neighborhood_1.interviews.length > 1" class="material-icons trashInterview" ng-click="vm.deleteInterviewee($index)">delete</i> --></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="neighborhood_inv_a"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].neighborhood_inv_a.answer" type="text" class="test" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="neighborhood_inv_c"></div><div><md-input-container class="m0 w100p"><!-- <input only-digits ng-model="interviewee.questions[0].neighborhood_inv_c.answer" type="text" maxlength="2" class="test" required> --> <input only-digits ng-model="interviewee.questions[0].neighborhood_inv_c.answer" type="text" class="test" required></md-input-container></div></div></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="neighborhood_inv_b"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].neighborhood_inv_b.answer" type="text" class="test" maxlength="70" required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="neighborhood_inv_d"></div><div><md-input-container class="m0 w100p"><!-- <input only-digits ng-model="interviewee.questions[0].neighborhood_inv_d.answer" type="text" maxlength="2" class="test" required> --> <input only-digits ng-model="interviewee.questions[0].neighborhood_inv_d.answer" type="text" class="test" required></md-input-container></div></div></div><!-- Q2e Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_e"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_e.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_e.comment={};" --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_e.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_e.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_e.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_e.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_e" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_e.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2e Ends Here --><!-- Q2f Starts Here --><div ng-if="formVersion==vm.APP.GLOBAL.VERSION_ONE"><div class="insName mt24" data-translate="neighborhood_inv_f"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_f.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_f.comment={};"  --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_f.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_f.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_f.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_f.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_f" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_f.comment.comment" ready="onReady()"></div> --></div></div></div><!-- Q2f Ends Here --><!-- Q2k Starts Here --><div ng-if="formVersion!=vm.APP.GLOBAL.VERSION_ONE"><div class="insName mt24" data-translate="neighborhood_inv_k"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_k.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_f.comment={};"  --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_k.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_k.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_k.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_k.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_k" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_f.comment.comment" ready="onReady()"></div> --></div></div></div><!-- Q2k Ends Here --><!-- Q2l Starts Here --><div ng-if="formVersion==\'v2\'"><div class="insName mt24" data-translate="neighborhood_inv_l"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_l.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_f.comment={};"  --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_l.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_l.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_l.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_l.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_l" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_f.comment.comment" ready="onReady()"></div> --></div></div></div><!-- Q2l Ends Here --><!-- Q2g Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_g"></div><div layout="row" layout-xs="column" class="mt20 mt30MBL"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_g.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_g.comment={};"  --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_g.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_g.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_g.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_g.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_g" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_g.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2g Ends Here --><!-- Q2h Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_h"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_h.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_h.comment={};" --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_h.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_h.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_h.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_h.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_h" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_h.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2h Ends Here --><!-- Q2i Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_i"></div><div layout="row" layout-xs="column" class="mt20 mt30MBL"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_i.answer" layout="row" layout-xs="column"><!-- ng-change="interviewee.questions[0].neighborhood_inv_i.comment={};"  --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_i.answer == (\'answer_yes\') || interviewee.questions[0].neighborhood_inv_i.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_i.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_i.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_i" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_i.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2i Ends Here --><!-- Q2j Starts Here --><div class="insName mt24" data-translate="neighborhood_inv_j"></div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-disabled="isreadonly" ng-model="interviewee.questions[0].neighborhood_inv_j.answer" ng-change="interviewee.questions[0].neighborhood_inv_j.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="neighborhood_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="interviewee.questions[0].neighborhood_inv_j.answer == (\'answer_yes\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="neighborhood_comment_req"></div><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_j.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_j.comment.id" req-val="true" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_j" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_j.comment.comment" ready="onReady()"></div> --></div></div><div ng-if="interviewee.questions[0].neighborhood_inv_j.answer == (\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="neighborhood_comment_opt"></div> --><div investigation-comment model-value="interviewee.questions[0].neighborhood_inv_j.comment.comment" comment-id="interviewee.questions[0].neighborhood_inv_j.comment.id" req-val="false" section-id="{{neighbourhoodSectionId}}" form-id="{{investigationFormId}}" question-key="neighborhood_inv_j" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="interviewee.questions[0].neighborhood_inv_j.comment.comment" ready="onReady()"></div> --></div></div><!-- Q2j Ends Here --></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="neighborhood_inv_add"></div> --><div class="additionalInterviewTxt mt40 mb30 mt20i" ng-if="!isreadonly" ng-click="ncForm.questions[0].neighborhood_1.interviews.push({})" data-translate="neighborhood_inv_add"></div><!-- Interview part ends --></div></div></div><!-- Interviee Section Ends Here --><!-- <div class="mt40 mt20i">\n\t\t\t\t\t<div class="insName mb10">Comment(Optional)</div>\n\t\t\t\t\t<div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div>\n\t\t\t\t</div> --></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt20"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.NEIGHBORHOOD_CANVAS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.NEIGHBORHOOD_CANVAS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- Q1 no starts here--><div flex-offset="10" flex-offset-xs="20" ng-if="ncForm.questions[0].neighborhood_1.answer == (\'answer_no\')"><div class="mt20i pr40 mb40"><div class="insName mb10" data-translate="neighborhood_comment_req"></div><div investigation-comment model-value="ncForm.questions[0].neighborhood_1.comment.comment" comment-id="ncForm.questions[0].neighborhood_1.comment.id" section-id="{{neighbourhoodSectionId}}" req-val="true" form-id="{{investigationFormId}}" question-key="neighborhood_1" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div><!-- <div ckeditor="options" ng-model="ncForm.questions[0].neighborhood_1.comment.comment" ready="onReady()"></div> --></div></div><!-- Upload document for each accordion --><div layout="row" class="mtm60p"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div><div class="investigationFormContent pt40 w550" data-translate="neighborhood_sum"></div><upload-form-file id-form-name="neighbourhoodCanvas" id-name="neighborhoodSection_{{$index}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div></div><div class="dividerDiv mt10"></div><!-- Question 1 Ends Here--></fieldset></form>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.interview.html','<div ng-repeat="interviewee in neighbourhoodCanvas.interview track by $index"><div layout="row" class="mt20i" ng-class="{mt40 : $index+1 > 1 }"><label class="interviewTxt">Interviewee Information # {{$index+1}}</label> <i ng-if="neighbourhoodCanvas.interview.length > 1" class="material-icons trashInterview" ng-click="vm.deleteInterviewee($index)">delete</i></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i">Interviewee Name</div><div><md-input-container class="m0 w100p"><input ng-model="interviewTitle" type="text" class="test"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i">Years Known Prospect</div><div><md-input-container class="m0 w100p"><input ng-model="celuda" type="text" class="test"></md-input-container></div></div></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i">Relation to Prospect</div><div><md-input-container class="m0 w100p"><input ng-model="interviewTitle" type="text" class="test"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i">Years Living in Neightborhood</div><div><md-input-container class="m0 w100p"><input ng-model="celuda" type="text" class="test"></md-input-container></div></div></div><!-- Q2e Starts Here --><div class="insName mt24">Did the interviewee recognize the prospect\'s photo?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2e.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2e.yesorno == \'Yes\' || Q2e.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2e Ends Here --><!-- Q2f Starts Here --><div class="insName mt24">Did the interviewee recognize the prospect\'s nickname?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2f.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2f.yesorno == \'Yes\' || Q2f.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2f Ends Here --><!-- Q2g Starts Here --><div class="insName mt24">Did the interviewee know the prospect\'s approximate age?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2g.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2g.yesorno == \'Yes\' || Q2g.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2g Ends Here --><!-- Q2h Starts Here --><div class="insName mt24">Did the interviewee know the prospect\'s parent\'s?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2h.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2h.yesorno == \'Yes\' || Q2h.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2h Ends Here --><!-- Q2i Starts Here --><div class="insName mt24">Did the interviewee know the prospect\'s sibling order?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2i.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2i.yesorno == \'Yes\' || Q2i.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2i Ends Here --><!-- Q2j Starts Here --><div class="insName mt24">Are there any indications of fraud?</div><div layout="row" layout-xs="column" class="mt20"><md-radio-group ng-model="Q2j.yesorno" layout="row" layout-xs="column"><div class="mr66 mb10i" ng-repeat="yesOrNo in YorN"><md-radio-button value="{{yesOrNo.value}}" class="md-primary"><label class="registryContent">{{yesOrNo.value}}</label></md-radio-button></div></md-radio-group></div><div ng-if="Q2j.yesorno == \'Yes\' || Q2j.yesorno == \'No\'"><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><!-- Q2j Ends Here --><div class="mt40 mt20i"><div class="insName mb10">Comment(Optional)</div><div ckeditor="options" ng-model="medicalEditorContent" ready="onReady()"></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()">+ ADD ADDITIONAL INTERVIWEE</div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvass.html','<div id="neighbourhoodCanvas" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="getSideComments(investigationFormId,vm.app.REF_TERM.NEIGHBORHOOD_CANVAS,vm.app.REF_TERM.ZERO_INDEX);vm.loadNeighbourhoodCanvasFormDetails();"><!-- part 1 --><!-- Birth Record and Medical Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bmHeader"><span data-translate="neighborhood"></span></div><!-- <div class="bmHeader" ng-click="vm.saveNeighbourhoodCanvasFormDetails()">saveNeighbourhoodCanvasFormDetails</div> --></div><!-- Birth Record and Medical End --><div ng-if="loadingNeighbourhood"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingNeighbourhood"><div class="dividerDiv"></div><!--  <div class="md-accordion" ng-if="neighbourhoodCanvasForm.sections.length > 1" ng-repeat="ncForm in neighbourhoodCanvasForm.sections">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.accordion.html\'"></div>\n\t\t </div>\n\t\t <div class="md-accordion" ng-if="neighbourhoodCanvasForm.sections.length == 1">\n\t\t\t\t <div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.form.html\'"></div>\n\t\t </div> --><div class="md-accordion" ng-if="neighbourhoodCanvasForm.sections.length > 1" ng-repeat="ncForm in neighbourhoodCanvasForm.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="neighborhood_accordian"></span> <span>{{$index+1}}</span> </span><span ng-if="name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : ncForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeneighbourhoodCanvasForm(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:ncForm.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.form.html\'"></div></div></div><div class="md-accordion" ng-if="neighbourhoodCanvasForm.sections.length == 1" ng-repeat="ncForm in neighbourhoodCanvasForm.sections"><div ng-init="getUploadFiles(null,vm.app.REF_TERM.NEIGHBORHOOD_CANVAS,$index)" ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvas.form.html\'"></div></div><!--  <div ng-click="vm.addAdditionalInstitutionForm()">Add Additional Institution</div> --><div ng-include src="\'app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvass.summary.html\'"></div><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><input type="hidden" id="neighbourhoodFormSave" ng-click="saveNeighbourhoodCanvasFormDetails();"><!-- Next Button Section End --></div><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform(indexVal);deleteSidecommentsByIndex(vm.app.REF_TERM.NEIGHBORHOOD_CANVAS,indexVal);deleteDocumentByIndex(vm.app.REF_TERM.NEIGHBORHOOD_CANVAS,indexVal)"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="deleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteInterviewConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/neighborhood-canvass/neighborhood.canvass.summary.html','<fieldset ng-disabled="isreadonly"><div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="vm.addAdditionalInstitutionForm()" data-translate="neighborhood_add"></div><div class="investigationFormHeader mt30" data-translate="neighborhood_sum_head"></div><div class="investigationFormContent pt40 w550" data-translate="neighborhood_sum"></div><!-- Upload document directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.NEIGHBORHOOD_CANVAS)"><upload-form-file id-form-name="neighbourhoodCanvas" id-name="neighborhoodSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="neighbourhoodCanvasForm.summary.question = \'neighborhood_sum_comment\'"><div class="sectionBC mb10" data-translate="neighborhood_sum_comment"></div></div><!-- <div ckeditor="options" ng-model="neighbourhoodCanvasForm.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="neighborhood_comment_req"></div><div investigation-comment model-value="neighbourhoodCanvasForm.summary.comment.comment" comment-id="neighbourhoodCanvasForm.summary.comment.id" section-id="{{neighbourhoodSectionId}}" req-val="true" form-id="{{investigationFormId}}" question-key="neighborhood_sum_comment" read-only="{{isreadonly}}" indexval="0"></div></div></div></div></div></div></div></fieldset>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/other/other.html','<div hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadOther()"><!-- part 1 --><!-- Other Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bcHeader fs17i" data-translate="prospects.other.other"></div></div><!-- Other Header End --><div ng-if="loadingOther"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingOther"><div class="dividerDiv"></div><form><fieldset ng-disabled="isreadonly"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="mt20 mt10i mb10 w99p" flex-xs="80"><div class="insName mb10" data-translate="prospects.other.other_comment"></div><div investigation-comment model-value="otherForm.sections[0].questions[0].other_comment.comment.comment" comment-id="otherForm.sections[0].questions[0].other_comment.comment.id" section-id="{{otherSectionId}}" form-id="{{investigationFormId}}" question-key="other_comment" req-val="true" read-only="{{isreadonly}}" indexval="0"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.OTHER)"><upload-form-file id-form-name="other" id-name="other" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div></div></div></div></div></fieldset></form><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><div class="nextBtn" ng-click="vm.nextInvestigationForm()"><div class="nextLabel" data-translate="save"></div></div><div flex="10"></div></div><input type="hidden" id="otherFormSave" ng-click="saveOtherDetails();"><!-- Next Button Section End --></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/preview-image-directive/preview.image.html','<div flex class="greyBorder heightInherit overYAuto noHScroll p15"><div ng-repeat="asset in assetList track by $index "><div ng-class="$index % 3 == 0 ? row : \'\' "><div class="col-xs-12 col-sm-6 col-lg-4 pt10 pb10" align="center" style="height: 270px"><div id="previewImage_{{$index}}" class="imageContent" ng-class="{selectBorder : asset.isSelected }" ng-init="asset.isSelected = false;" ng-click="asset.isSelected = toggle(asset.isSelected,$event) ;"><label class="containerPreview"><img class="previewImage" ng-src="{{baseUrl}}api/assets/imageDocument/{{asset.id}}/true"><div class="viewDocumentBtn hide" ng-click="viewAttachment(\'api/assets/imageDocument/\',asset.id,$event)"><span data-translate="prospects.manageAttachmentsPopup.viewAttachments"></span></div><div class="checkmarkBg" ng-class="{show : asset.isSelected}"><span class="checkmark"></span></div></label></div><div class="imageDetails" flex layout="column" style="height: 25px"><div class="fz10" flex="50" layout="row"><div class="textLeft textOverflow" flex="50">{{asset.displayName}}</div><div flex="5"></div><div class="textRight textOverflow" flex="45">{{asset.createdByName}}</div></div><div class="fz10" flex="50" layout="row"><div class="textLeft" flex="50">{{asset.numberOfPages != null ? asset.numberOfPages+\' page(s)\' : \'\'}}<span ng-if="!asset.numberOfPages" data-translate="prospects.manageAttachmentsPopup.unknown"></span></div><div flex="5"></div><div class="textRight textOverflow" flex="45">{{asset.createdOn | date: \'yyyy-MM-dd\' }}</div></div></div><div style="height: 10px"></div></div></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/interview.html','<div ng-if="!religiousInstitution.sections[0].questions[0].religiousInstitution_q2.interviews" ng-init="religiousInstitution.sections[0].questions[0].religiousInstitution_q2.interviews = []; religiousInstitution.sections[0].questions[0].religiousInstitution_q2.interviews[0].questions = []"></div><div ng-repeat="interviewee in religiousInstitution.sections[0].questions[0].religiousInstitution_q2.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div layout="row" class="mt40"><div><label class="interviewTxt" data-translate="religiousInstitution_q2a_interviewee"></label></div><span ng-if="interviewee.length > 1" class="interviewTxt">#</span> <span ng-if="interviewee.length > 1" class="interviewTxt">{{$index+1}}</span><div ng-click="interviewee.splice($index,1)"><span><i ng-if="interviewee.length > 1" class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="religiousInstitution_q2a_contactName"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions.religiousInstitution_q2a_contactName.answer" type="text" class="test" required="Q2.yesorno"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="religiousInstitution_q2a_title"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions.religiousInstitution_q2a_title.answer" type="text" class="test" required="Q2.yesorno"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i" data-translate="religiousInstitution_q2a_cedulaNumber"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions.religiousInstitution_q2a_cedulaNumber.answer" type="text" class="test" required="Q2.yesorno"></md-input-container></div></div></div><div class="insName mb10 mt40 mt20i" data-translate="religiousInstitution_comment_optional"></div><div ckeditor="options" ng-model="interviewee.questions.religiousInstitution_comment_optional.answer" ready="onReady()"></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="religiousInstitution_addAdditionalInterview"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.accordion.html','<div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps"><span>Religious Institution {{$index+1}}</span></span> <span ng-if="name.institution" class="accordianNameHolder caps"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : riForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeReligiousInstitutions(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:riForm.expanded}"><form><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q1.answer}">1</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q1"></div><div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group layout="row" ng-model="riForm.questions[0].religiousInstitution_q1.answer" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Proceed only when Question 1 is "YES" --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'religiousInstitution_q1_yes\')"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q1_nameofInstitution"></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input ng-model="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer" class="test" type="text" style="width:100%" required>\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div class="changeWhiteFrame"><md-autocomplete flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer=item.nameCityCounty;riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId=item.id" md-selected-item="searchText" md-search-text="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer" md-items="item in vm.entityRequestSuggest(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer,\'Religious Institution\')" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="searchText">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Question 2 starts here --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'religiousInstitution_q1_yes\')"><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q2.answer}">2</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q2"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q2.answer" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_yes\')}}" class="md-primary mr25i"><label class="registryContent" data-translate="religiousInstitution_q2_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_no\')}}" class="md-primary mr25i"><label class="registryContent" data-translate="religiousInstitution_q2_no"></label></md-radio-button></div></md-radio-group></div></div></div></div><!-- When Question 2 chooses Yes --><!-- Question 2a starts here --><div ng-if="riForm.questions[0].religiousInstitution_q2.answer == (\'religiousInstitution_q2_yes\')" ng-init="vm.interviewFlag(2, $index)"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': interviewee.questions[0].religiousInstitution_q2a_contactName.answer}">2a</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q2a"></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/interview.html\'"></div> --><div ng-if="!riForm.questions[0].religiousInstitution_q2a.interviews" ng-init="riForm.questions[0].religiousInstitution_q2a.interviews = []; riForm.questions[0].religiousInstitution_q2a.interviews[0].questions = []"></div><div ng-repeat="interviewee in riForm.questions[0].religiousInstitution_q2a.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row" class="mt40"><div><label class="interviewTxt" data-translate="religiousInstitution_q2a_interviewee"></label></div><span ng-if="riForm.questions[0].religiousInstitution_q2a.interviews.length >1" class="interviewTxt">#</span> <span ng-if="riForm.questions[0].religiousInstitution_q2a.interviews.length >1" class="interviewTxt">{{$index+1}}</span><div ng-if="riForm.questions[0].religiousInstitution_q2a.interviews.length >1" ng-click="riForm.questions[0].religiousInstitution_q2a.interviews.splice($index,1)"><span><i class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="religiousInstitution_q2a_contactName"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].religiousInstitution_q2a_contactName.answer" type="text" class="test" required></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="religiousInstitution_q2a_title"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].religiousInstitution_q2a_title.answer" type="text" class="test" required></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="religiousInstitution_q2a_cedulaNumber"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].religiousInstitution_q2a_cedulaNumber.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mb10 mt40 mt20i" data-translate="religiousInstitution_comment_optional"></div><div investigation-comment class="w99p" model-value="interviewee.comment.comment" comment-id="interviewee.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q2a"></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="religiousInstitution_addAdditionalInterview" ></div> --><div class="additionalInterviewTxt mt40 mt20i caps" ng-click="riForm.questions[0].religiousInstitution_q2a.interviews.push({})" data-translate="religiousInstitution_addAdditionalInterview"></div><!-- Interview part ends --></div></div></div><!-- Question 2a ends here --><!-- Question 3 starts here --><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q3.answer}">3</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q3"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q3.answer" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_no\' )}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_no"></label></md-radio-button></div></md-radio-group></div></div></div><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.records.html\'"></div> --><!-- Question 3 starts here  --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer == (\'religiousInstitution_q3_yes\')"><!-- When Q3 is YES --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt40" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q3_recordType.answer}">3a</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle mt40" data-translate="religiousInstitution_q3_recordType"></div><div layout="row" layout-xs="column" class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><div><md-radio-group layout="row" layout-xs="column" ng-model="riForm.questions[0].religiousInstitution_q3_recordType.answer"><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_officialChurchRecords\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_officialChurchRecords"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_churchIssuedCertification\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_churchIssuedCertification"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_others\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_others"></label></md-radio-button></div></md-radio-group></div></div><!-- Official Church Records  --><div ng-if="riForm.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_officialChurchRecords\') ||\n\t\t\t\t\t\t\t\t          riForm.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_churchIssuedCertification\') "><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_recordName"></div><md-input-container class="m0" style="width:100%"><input ng-model="riForm.questions[0].religiousInstitution_q3a_recordName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobirth"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="riForm.questions[0].religiousInstitution_q3a_dobirth.answer" type="text" md-max-date="vm.maxDate" md-open-on-focus md-hide-icons="calender" class="test"></md-datepicker></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobaptism"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="riForm.questions[0].religiousInstitution_q3a_dobaptism.answer" type="text" md-open-on-focus md-hide-icons="calender" md-max-date="vm.maxDate" class="test"></md-datepicker></md-input-container></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_fatherName"></div><md-input-container class="m0" style="width:100%"><input ng-model="riForm.questions[0].religiousInstitution_q3a_fatherName.answer" class="test" type="text" style="width:100%"></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_motherName"></div><md-input-container class="m0" style="width:100%"><input ng-model="riForm.questions[0].religiousInstitution_q3a_motherName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex-gt-sm="10"></div></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><!-- <div ckeditor="options" ng-model="riForm.questions[0].religiousInstitution_q3_recordType.comment.comment" ready="onReady()"></div> --><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q3_recordType.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q3_recordType.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3_recordType"></div></div></div><!-- Others --><div ng-if="riForm.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_others\')"><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_recordName"></div><md-input-container class="m0" style="width:100%"><input ng-model="riForm.questions[0].religiousInstitution_q3a_other_recordName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_dobirth"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="riForm.questions[0].religiousInstitution_q3a_other_dobirth.answer" type="text" md-open-on-focus md-hide-icons="calender" md-max-date="vm.maxDate" class="test"></md-datepicker></md-input-container></div></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><!-- <div ckeditor="options" ng-model="riForm.questions[0].religiousInstitution_comment_required.comment.comment" ready="onReady()"></div> --><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q3_recordType.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q3_recordType.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3_recordType"></div></div></div></div></div><!-- 3a Ends here --><div ng-if="religiousInstitutions.records.length >= 1" class="additionalInterviewTxt ml70 mt20i" ng-click="vm.addAdditionalRecordsForm()" data-translate="religiousInstitution_addAdditionalRecords"></div></div><!-- Q3 NO Starts here --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer ==(\'religiousInstitution_q3_no\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><!-- <div ckeditor="options" ng-model="religiousInstitution.section.question.religiousInstitution_comment_required.answer" ready="onReady()"></div> --><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q3.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q3.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3"></div></div></div></div></div><!-- Question 3 Ends here  --><!-- 4 Starts here --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer == (\'religiousInstitution_q3_yes\')"><div class="dividerDiv mt40"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q4.answer}">4</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q4"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q4.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q4_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q4_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q4_no\'| translate)}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q4_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="( riForm.questions[0].religiousInstitution_q4.answer == (\'religiousInstitution_q4_yes \'))  "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q4.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q4.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q4"></div></div></div><div ng-if="( riForm.questions[0].religiousInstitution_q4.answer == (\'religiousInstitution_q4_no \'))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_optional"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q4.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q4.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q4"></div></div></div></div></div></div><!-- 4 Ends here --><!-- 5 Starts here --><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q5.answer}">5</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q5"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q5.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q5_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q5_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q5_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q5_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="riForm.questions[0].religiousInstitution_q5.answer ==(\'religiousInstitution_q5_yes\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q5.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q5.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q5" required></div></div></div><div ng-if="riForm.questions[0].religiousInstitution_q5.answer ==(\'religiousInstitution_q5_no\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_optional"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q5.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q5.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q5"></div></div></div></div></div></div><!-- 5 Ends here --><!-- 6 Starts here --><div class="dividerDiv"></div><div class="p40 pl0 p20i pb0"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q6.answer}">6</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q6"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q6.answer " layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q6_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q6_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q6_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q6_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="riForm.questions[0].religiousInstitution_q6.answer == (\'religiousInstitution_q6_yes\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q6.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q6.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q6" required></div></div></div><div ng-if="riForm.questions[0].religiousInstitution_q6.answer == (\'religiousInstitution_q6_no\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_optional"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q6.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q6.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q6"></div></div></div></div></div></div><!-- 6 Ends here --></div></div></div><!-- For Q2 YES  --><!-- Comment for Question 2 NO--><div ng-if="(riForm.questions[0].religiousInstitution_q2.answer == (\'religiousInstitution_q2_no\'))"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div layout="row" class="mt18 mt9i" layout-align="start start"><div><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q2.subAnswer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_closed\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q2_closed"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_other\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q2_other"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="( riForm.questions[0].religiousInstitution_q2.subAnswer == (\'religiousInstitution_q2_closed\')) || \n\t\t\t\t\t      \t           ( riForm.questions[0].religiousInstitution_q2.subAnswer == (\'religiousInstitution_q2_other\')) "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q2.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q2.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q2"></div></div></div></div></div></div></div><!-- Question 2 NO Ends Here --></div><!-- For Q1 YES --><!-- Q1 YES Ends here --><!-- Q1 NO Starts Here --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'religiousInstitution_q1_no\') "><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q1.subAnswer}">1a</div></div><div flex-offset-xs="5" class="w100p"><div layout="row" layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-model="riForm.questions[0].religiousInstitution_q1.subAnswer " layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no_notBaptised\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no_notBaptised"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no_na\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no_na"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="(riForm.questions[0].religiousInstitution_q1.subAnswer == (\'religiousInstitution_q1_no_notBaptised\')) || \n\t\t\t\t\t                 (riForm.questions[0].religiousInstitution_q1.subAnswer  == (\'religiousInstitution_q1_no_na\'))  "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment class="w99p" model-value="riForm.questions[0].religiousInstitution_q1.comment.comment" comment-id="riForm.questions[0].religiousInstitution_q1.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q1"></div></div></div></div></div></div></div><!-- Q1 NO Ends Here --></form></div><!-- Accordion Popup Starts Here --><!-- <div class="hide">\n\t<div id="accordionCloseConformPopup" class="md-dialog-container">\n\t\t<md-dialog class="assignConfirmPopupWidth"> \n\t\t\t<md-dialog-content>\n\t\t\t\t<div layout="row" flex  class="m50imp">\n\t\t\t\t\t<div layout="column" layout-margin layout-align="center center">\n\t\t\t\t\t\t<div layout="column" layout-align="center center">\n\t\t\t\t\t\t\t<div class="assignSub">\n\t\t\t\t\t\t\t\t<span>Do you want to delete the record?</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t<md-button ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary">CANCEL</md-button>\n\t\t\t\t\t\t\t<md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform($index);">DELETE</md-button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</md-dialog-content> \n\t\t</md-dialog>\n\t</div>\n</div> --><!-- Accordion Popup Ends Here -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.form.html','<form><fieldset ng-disabled="isreadonly && sideCommentVisible"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q1.answer}">1</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q1"></div><div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly || riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested" layout="row" ng-model="riForm.questions[0].religiousInstitution_q1.answer" ng-change="formViewCall($index);riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution={};\n\t\t\t\t\t\t                 riForm.questions[0].religiousInstitution_q1.subAnswer=\'\';\n\t\t\t\t\t\t                 riForm.questions[0].religiousInstitution_q1.comment={};\n\t\t\t\t\t\t                 riForm.questions[0].religiousInstitution_q2={}" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Proceed only when Question 1 is "YES" --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'answer_yes\')"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q1_nameofInstitution"></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input no-special-char text-only ng-model="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer" class="test" type="text" style="width:100%" maxlength="70" required>\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div ng-if="!isreadonly && (riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested == true) && riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId"><div ng-init="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution = requestStatus(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution);"></div></div><div class="changeWhiteFrame religious" id="religiousInstitution"><md-autocomplete ng-disabled="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested" id="{{$index}}" class="global-search-input" flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId=item.id;isEntityApproved(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId, false)" md-selected-item="searchText" md-search-text="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer" md-search-text-change="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer == \'\' ? riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution = {} : \'\';riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.subAnswer = hideApprovedMessage(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.subAnswer);isEntityApproved(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId, true)" md-items="item in vm.entityRequestSuggest(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer,\'Religious Institution\')" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ((!riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId && riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer && !riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested) || \n\t\t\t\t\t\t (entityChanged && !(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested) && !(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.subAnswer != undefined)))"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="religiousEntityRequest($event,\'addNewEntityPopupId\',0)" data-translate="add_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested"><div class="attachmentAddText" data-translate="added_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.subAnswer != undefined"><div class="attachmentAddText" data-translate="added_entity_approved"></div></div></div><!-- Upload document for each accordion --><div layout="row" class="mtm20p"><div><div class="investigationFormContent pt40 w550" data-translate="religiousInstitution_summary_uploadDoc_label"></div><upload-form-file id-form-name="religiousInstitution" id-name="religiousInstitutionSection_{{$index}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment><div ng-if="(!riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId && riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answer) || notApproved || riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.requested"><div class="redalert mt60" ng-click="openAutocomplete($index)"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Question 2 starts here --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'answer_yes\')"><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q2.answer}">2</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q2"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q2.answer" ng-change="formViewCall($index);riForm.questions[0].religiousInstitution_q2a={};\n\t\t\t\t\t \t \triForm.questions[0].religiousInstitution_q2a_dateOfVisit={};\n\t\t\t\t\t\t \t riForm.questions[0].religious_record_list={};\n\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q3={};\n\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q2.comment={};\n\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q2.subAnswer=\'\';" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary mr25i"><label class="registryContent" data-translate="religiousInstitution_q2_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary mr25i"><label class="registryContent" data-translate="religiousInstitution_q2_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION2" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- When Question 2 chooses Yes --><!-- Question 2a starts here --><div ng-if="riForm.questions[0].religiousInstitution_q2.answer == (\'answer_yes\')" ng-init="vm.interviewFlag(1)"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q2a_dateOfVisit.answer}">2a</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle mt50 mt25i" data-translate="religiousInstitutuion_2a"></div><div class="insName mt40 mt20i" data-translate="religiousInstitution_q2a_dateOfVisit"></div><div><div modval="riForm.questions[0].religiousInstitution_q2a_dateOfVisit.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="riForm.questions[0].religiousInstitution_q2a_dateOfVisit.answer" md-max-date="vm.maxDate" type="text" md-hide-icons="calendar" name="question2a" class="test" ng-required="riForm.questions[0].religiousInstitution_q2.answer == (\'answer_yes\')" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION2A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt25i" ng-class="{\'changeColor\': interviewee.questions[0].religiousInstitution_q2a_contactName.answer}">2b</div></div><div flex="" flex-xs="" flex-offset-xs="5" class="w100p"><div class="quesStyle mt50 mt25i" data-translate="religiousInstitution_q2a"></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/interview.html\'"></div> --><div ng-if="!riForm.questions[0].religiousInstitution_q2a.interviews" ng-init="riForm.questions[0].religiousInstitution_q2a.interviews = []; riForm.questions[0].religiousInstitution_q2a.interviews[0].questions = []"></div><div ng-if="interviewFlag"><div ng-repeat="interviewee in riForm.questions[0].religiousInstitution_q2a.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div ng-if="!interviewee.sortOrder" ng-init="interviewee.sortOrder = $index+1"></div><div layout="row" class="mt40"><div><label class="interviewTxt" data-translate="religiousInstitution_q2a_interviewee"></label></div><span ng-if="riForm.questions[0].religiousInstitution_q2a.interviews.length >1" class="interviewTxt pl5"># {{$index+1}}</span><!-- <span ng-if="riForm.questions[0].religiousInstitution_q2a.interviews.length >1" class="interviewTxt">{{$index+1}}</span> --><!-- <div ng-if="!isreadonly && riForm.questions[0].religiousInstitution_q2a.interviews.length >1" ng-click="riForm.questions[0].religiousInstitution_q2a.interviews.splice($index,1)"> --><div ng-if="!isreadonly && riForm.questions[0].religiousInstitution_q2a.interviews.length >1" ng-click="vm.deleteIndex($event,\'religiousDeleteInterviewConformPopup\',$index,true)"><span><i class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="religiousInstitution_q2a_contactName"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].religiousInstitution_q2a_contactName.answer" type="text" class="test" maxlength="70" camel-case required></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q2a_title"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].religiousInstitution_q2a_title.answer" type="text" maxlength="70" class="test"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q2a_cedulaNumber"></div><div><md-input-container class="m0 w100p"><!-- <input only-digits allowed-char="-+()" ng-model="interviewee.questions[0].religiousInstitution_q2a_cedulaNumber.answer" type="text" class="test"  maxlength="15" > --> <input ng-model="interviewee.questions[0].religiousInstitution_q2a_cedulaNumber.answer" type="text" class="test"></md-input-container></div></div></div><!-- <div class="insName mb10 mt40 mt20i" data-translate="religiousInstitution_comment_optional" ></div> --><div investigation-comment model-value="interviewee.comment.comment" req-val="false" comment-id="interviewee.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q2a" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="religiousInstitution_addAdditionalInterview" ></div> --><div class="additionalInterviewTxt mt40 mt20i caps" ng-if="!isreadonly" ng-click="riForm.questions[0].religiousInstitution_q2a.interviews.push({})" data-translate="religiousInstitution_addAdditionalInterview"></div><!-- Interview part ends --></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION2B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- Question 2a ends here --><!-- Question 3 starts here --><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q3.answer}">3</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q3"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q3.answer" ng-change="formViewCall($index);riForm.questions[0].religious_record_list={};\n\t\t\t\t\t\t\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q4={};\n\t\t\t\t\t\t\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q5={};\n\t\t\t\t\t\t\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q6={};\n\t\t\t\t\t\t\t\t\t\t\t\t \t riForm.questions[0].religiousInstitution_q3.comment={};" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION3" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.records.html\'"></div> --><!-- Question 3 starts here  --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer == (\'answer_yes\')"><!-- When Q3 is YES --><div ng-if="!riForm.questions[0].religious_record_list.records" ng-init="riForm.questions[0].religious_record_list.records = [];riForm.questions[0].religious_record_list.records[0].questions = []"></div><div layout="column"><div ng-if="recordFlag"><div ng-repeat="record in riForm.questions[0].religious_record_list.records track by $index"><div layout="row"><!-- In this section question 3a model values in 3b --><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- \t\t\t\t\t\t\t \t\t<div  class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': record.questions[0].religiousInstitution_q3b.answer}">3a</div> --></div><div flex-offset-xs="5" class="w100p"><div layout="row"><div ng-if="riForm.questions[0].religious_record_list.records.length == 1" class="mt50 mt20i"><label class="quesStyle" data-translate="religiousInstitution_q3_record_one"></label></div><div ng-if="riForm.questions[0].religious_record_list.records.length > 1" class="mt50 mt20i"><label class="quesStyle" data-translate="religiousInstitution_q3_record"></label></div><span class="interviewTxt mt50 ml10 mt20i" ng-if="riForm.questions[0].religious_record_list.records.length > 1">#</span> <span class="interviewTxt mt50 mr10 mt20i" ng-if="riForm.questions[0].religious_record_list.records.length > 1">{{$index+1}}</span><!-- <div ng-if="!isreadonly && riForm.questions[0].religious_record_list.records.length > 1" ng-click="riForm.questions[0].religious_record_list.records.splice($index,1)"> --><div ng-if="!isreadonly && riForm.questions[0].religious_record_list.records.length > 1" ng-click="vm.deleteIndex($event,\'religiousDeleteInterviewConformPopup\',$index,false)"><span><i class="material-icons trashInterview mt50 mt20i">delete</i></span></div></div><div layout="row" class="mt20 mt10i"><label class="quesStyle" data-translate="religiousInstitution_q3b"></label></div><div layout="row"><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].religiousInstitution_q3b.answer" ng-change="record.questions[0].religiousInstitution_q3_recordType={};\n\t\t\t\t\t\t\t\t\t\t\t\t\t\trecord.questions[0].religiousInstitution_q3a_recordName={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_dobirth={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_dobaptism={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_fatherName={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_motherName={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3_recordType.comment={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_other_recordName={};\n\t\t\t\t\t\t\t\t\t\t                record.questions[0].religiousInstitution_q3a_other_dobirth={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3b.subAnswer=\'\'" layout="row" layout-xs="column" required><div layout="row" layout-xs="column"><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3b_prospect\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3b_prospect"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3b_sibling\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3b_sibling"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3b_other\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3b_other"></label></md-radio-button></div><div class="mtm7"><md-input-container class="m0 w100p" ng-if="record.questions[0].religiousInstitution_q3b.answer == (\'religiousInstitution_q3b_other\')"><input no-special-char text-only ng-model="record.questions[0].religiousInstitution_q3b.subAnswer" type="text" class="test" name="birthCertificate_3b" maxlength="70" required></md-input-container></div></div></md-radio-group></div></div><!-- <div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60">\n\t\t\t\t\t\t\t \t\t<form-side-comment investigation-id=investigationFormId form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION3B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment>\n\t\t\t\t\t\t\t \t</div> --></div><!-- In this section question 3b model values in 3a --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- <div  class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': riForm.questions[0].religious_record_list.records[0].questions[0].religiousInstitution_q3_recordType.answer}">3a</div> --><!-- <div  class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': record.questions[0].religiousInstitution_q3_recordType.answer}">3b</div> --></div><div flex="" class="w100p"><!-- <div ng-if="!riForm.questions[0].religious_record_list.records" ng-init="riForm.questions[0].religious_record_list.records = [];riForm.questions[0].religious_record_list.records[0].questions = []"></div> --><!-- <div ng-repeat="record in riForm.questions[0].religious_record_list.records track by $index"> --><div><div ng-if="!record.questions" ng-init="record.questions = []"></div><div ng-if="!record.sortOrder" ng-init="record.sortOrder = $index+1"></div><div layout="row"><div class="mt20 mt10i"><label class="quesStyle" data-translate="religiousInstitution_q3_recordType"></label></div><!-- <span class="interviewTxt mt50 ml10 mt20i" ng-if="riForm.questions[0].religious_record_list.records.length > 1">#</span>\n\t\t\t                           \t\t<span class="interviewTxt mt50 mr10 mt20i" ng-if="riForm.questions[0].religious_record_list.records.length > 1">{{$index+1}}</span>\n\t\t\t\t                          \t<div ng-click="riForm.questions[0].religious_record_list.records.splice($index,1)">\n\t\t\t\t                          \t    <span ng-if="!isreadonly"><i ng-if="riForm.questions[0].religious_record_list.records.length > 1" class="material-icons trashInterview mt50 mt20i">delete</i></span>\n\t\t\t\t                          \t </div> --></div><!-- <div class="quesStyle mt40"  data-translate="religiousInstitution_q3_recordType"></div> --><div layout="row" layout-xs="column" class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-disabled="isreadonly" layout="column" layout-xs="column" ng-model="record.questions[0].religiousInstitution_q3_recordType.answer" ng-change="record.questions[0].religiousInstitution_q3a_recordName={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_dobirth={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_dobaptism={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_fatherName={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_motherName={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3_recordType.comment={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_other_recordName={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].religiousInstitution_q3a_other_dobirth={};\n\t\t\t\t\t\t\t\t\t\t                 clearCKEditor()" required><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_officialChurchRecords\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_officialChurchRecords"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_churchIssuedCertification\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_churchIssuedCertification"></label></md-radio-button></div><div class="mr25i mb10i"><md-radio-button value="{{(\'religiousInstitution_q3_others\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_others"></label></md-radio-button></div></md-radio-group></div></div><!-- Official Church Records  --><div ng-if="record.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_officialChurchRecords\') ||\n\t\t\t\t\t\t\t\t          record.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_churchIssuedCertification\') "><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_recordName"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].religiousInstitution_q3a_recordName.answer" class="test" required maxlength="70" type="text" camel-case style="width:100%"></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobirth"></div><div modval="record.questions[0].religiousInstitution_q3a_dobirth.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].religiousInstitution_q3a_dobirth.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobaptism"></div><div modval="record.questions[0].religiousInstitution_q3a_dobaptism.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].religiousInstitution_q3a_dobaptism.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_fatherName"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].religiousInstitution_q3a_fatherName.answer" class="test" type="text" maxlength="70" camel-case style="width:100%"></md-input-container></div></div><div layout="row" layout-xs="column"><div><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_motherName"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].religiousInstitution_q3a_motherName.answer" class="test" type="text" style="width:100%" maxlength="70" camel-case required></md-input-container></div><!-- <div flex-gt-xs="10"></div> --><!-- <div flex-gt-xs="50">\n\t\t\t\t\t\t\t\t\t         \t </div> --></div><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="religiousInstitution_comment_required"  ></div> --><!-- <div ckeditor="options" ng-model="record.questions[0].religiousInstitution_q3_recordType.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="record.questions[0].religiousInstitution_q3_recordType.comment.comment" req-val="false" comment-id="record.questions[0].religiousInstitution_q3_recordType.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3_recordType" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div><!-- Others --><div ng-if="record.questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_others\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_recordName"></div><md-input-container class="m0" style="width:100%"><input text-only ng-model="record.questions[0].religiousInstitution_q3a_other_recordName.answer" class="test" type="text" style="width:100%" camel-case></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_dobirth"></div><div modval="record.questions[0].religiousInstitution_q3a_other_dobirth.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="record.questions[0].religiousInstitution_q3a_other_dobirth.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div class="mt40 mt20i"><!--  <div class="insName mb10" data-translate="religiousInstitution_comment_required" ></div> --><!-- <div ckeditor="options" ng-model="record.questions[0].religiousInstitution_comment_required.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="record.questions[0].religiousInstitution_q3_recordType.comment.comment" req-val="false" comment-id="record.questions[0].religiousInstitution_q3_recordType.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3_recordType" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i"  ng-if="!isreadonly" ng-click="riForm.questions[0].religious_record_list.records.push({})" data-translate="religiousInstitution_addAdditionalRecords"></div> --></div><!-- Side Comment --><!-- <div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60">\n\t\t\t\t\t\t\t\t\t \t<form-side-comment investigation-id=investigationFormId form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION3A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment>\n\t\t\t\t\t\t\t\t\t </div>\t --></div></div></div><div class="additionalInterviewTxt mt40 mt20i pl9per" ng-if="!isreadonly" ng-click="riForm.questions[0].religious_record_list.records.push({})" data-translate="religiousInstitution_addAdditionalRecords"></div></div><!-- 3a Ends here --><div ng-if="religiousInstitutions.records.length >= 1" class="additionalInterviewTxt ml70 mt20i" ng-click="vm.addAdditionalRecordsForm()" data-translate="religiousInstitution_addAdditionalRecords"></div></div><!-- Q3 NO Starts here --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer ==(\'answer_no\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex="" class="w100p"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><!-- <div ckeditor="options" ng-model="religiousInstitution.section.question.religiousInstitution_comment_required.answer" ready="onReady()"></div> --><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q3.comment.comment" req-val="true" comment-id="riForm.questions[0].religiousInstitution_q3.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q3" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div></div><!-- Question 3 Ends here  --><!-- 4 Starts here --><div ng-if="riForm.questions[0].religiousInstitution_q3.answer == (\'answer_yes\')"><div class="dividerDiv mt40"></div><div class="p40 pl0 p20i pr0"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q4.answer}">4</div></div><div flex="" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q4"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q4.answer" ng-change="riForm.questions[0].religiousInstitution_q4.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q4_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q4_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="( riForm.questions[0].religiousInstitution_q4.answer == (\'answer_yes\'))  "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q4.comment.comment" req-val="true" comment-id="riForm.questions[0].religiousInstitution_q4.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q4" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="( riForm.questions[0].religiousInstitution_q4.answer == (\'answer_no\'))"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="religiousInstitution_comment_optional"  ></div> --><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q4.comment.comment" req-val="false" comment-id="riForm.questions[0].religiousInstitution_q4.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q4" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION4" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- 4 Ends here --><!-- 5 Starts here --><div class="dividerDiv"></div><div class="p40 pl0 p20i pr0"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q5.answer}">5</div></div><div flex="" class="w100p"><div class="quesStyle" data-translate="religiousInstitution_q5"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q5.answer" ng-change="riForm.questions[0].religiousInstitution_q5.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q5_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q5_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="riForm.questions[0].religiousInstitution_q5.answer ==(\'answer_yes\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q5.comment.comment" req-val="true" comment-id="riForm.questions[0].religiousInstitution_q5.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q5" required read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="riForm.questions[0].religiousInstitution_q5.answer ==(\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="religiousInstitution_comment_optional" ></div> --><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q5.comment.comment" req-val="false" comment-id="riForm.questions[0].religiousInstitution_q5.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q5" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION5" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- 5 Ends here --><!-- 6 Starts here --><!-- <div class="dividerDiv"></div>\n\t\t\t\t\t\t     \t\t\t  <div class="p40 pl0 p20i pb0 pr0">\n\t\t\t\t\t\t     \t\t\t \t<div layout="row">\n\t\t\t\t\t\t\t\t\t\t\t \t  <div flex=10 layout="row" layout-align="center start" layout-align-xs="center start">\n\t\t\t\t\t\t\t\t\t\t\t\t  \t<div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q6.answer}">6</div>\n\t\t\t\t\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t\t\t\t\t\t  <div flex-offset-xs="5" class=" w100p">\n\t\t\t\t\t\t\t\t\t\t\t\t   <div class="quesStyle"  data-translate="religiousInstitution_q6"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t \t <div layout="row" class="mt18 mt9i" layout-align="start start">\n\t\t\t\t\t\t\t\t\t\t\t\t\t \t <md-radio-group ng-disabled="isreadonly"  ng-model="riForm.questions[0].religiousInstitution_q6.answer" \n\t\t\t\t\t\t\t\t\t\t\t\t\t \t \tng-change="riForm.questions[0].religiousInstitution_q6.comment={};" layout="row" layout-xs="column" >\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="mr66 mb10i">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent"  data-translate="religiousInstitution_q6_yes"></label></md-radio-button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="mr66 mb10i">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q6_no"></label></md-radio-button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t                 </md-radio-group>\n\t\t\t\t\t\t\t\t\t                 </div>\n\t\t\t\t\t\t\t\t\t                 <div ng-if="riForm.questions[0].religiousInstitution_q6.answer == (\'answer_yes\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="mt40 mt20i">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <div investigation-comment  model-value="riForm.questions[0].religiousInstitution_q6.comment.comment" req-val=false comment-id="riForm.questions[0].religiousInstitution_q6.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q6" read-only="{{isreadonly}}" indexval="{{$index}}"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="riForm.questions[0].religiousInstitution_q6.answer == (\'answer_no\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="mt40 mt20i">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <div class="insName mb10" data-translate="religiousInstitution_comment_required"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <div investigation-comment  model-value="riForm.questions[0].religiousInstitution_q6.comment.comment" req-val=true comment-id="riForm.questions[0].religiousInstitution_q6.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_q6" required read-only="{{isreadonly}}" indexval="{{$index}}"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t Side Comment\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10">\n\t\t\t\t\t\t\t\t\t\t\t\t \t<form-side-comment investigation-id=investigationFormId form-name="vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.RELIGIOUS_QUESTIONS.QUESTION6" object-list="sectionDTO.formQuestionDTOs"></form-side-comment>\n\t\t\t\t\t\t\t\t\t\t\t\t </div>\t\t\t\n\t\t\t\t\t\t\t     \t\t\t </div>\n\t\t\t\t\t\t\t     \t\t\t </div> --><!-- 6 Ends here --></div></div></div><!-- For Q2 YES  --><!-- Comment for Question 2 NO--><div ng-if="(riForm.questions[0].religiousInstitution_q2.answer == (\'answer_no\'))"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex="" class="w100p"><div layout="row" class="mt18 mt9i" layout-align="start start"><div><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q2.subAnswer" ng-change="clearCKEditor()" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_closed\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q2_closed"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q2_other\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q2_other"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="( riForm.questions[0].religiousInstitution_q2.subAnswer == (\'religiousInstitution_q2_closed\')) || \n\t\t\t\t\t      \t           ( riForm.questions[0].religiousInstitution_q2.subAnswer == (\'religiousInstitution_q2_other\')) "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q2.comment.comment" req-val="true" comment-id="riForm.questions[0].religiousInstitution_q2.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" required question-key="religiousInstitution_q2" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div></div></div></div><!-- Question 2 NO Ends Here --></div><!-- For Q1 YES --><!-- Q1 YES Ends here --><!-- Q1 NO Starts Here --><div ng-if="riForm.questions[0].religiousInstitution_q1.answer == (\'answer_no\') "><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': riForm.questions[0].religiousInstitution_q1.subAnswer}">1a</div></div><div flex="" flex-xs="" flex-offset-xs="5" class="w100p"><div layout="row" layout-align="start start"><div><md-radio-group ng-disabled="isreadonly" ng-model="riForm.questions[0].religiousInstitution_q1.subAnswer " ng-change="clearCKEditor()" layout="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no_notBaptised_records_notAvailable\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no_notBaptised_records_notAvailable"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no_notBaptised\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no_notBaptised"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'religiousInstitution_q1_no_na\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q1_no_na"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="(riForm.questions[0].religiousInstitution_q1.subAnswer == (\'religiousInstitution_q1_no_notBaptised_records_notAvailable\')) ||\n\t\t\t\t\t                 (riForm.questions[0].religiousInstitution_q1.subAnswer  == (\'religiousInstitution_q1_no_na\'))  "><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q1.comment.comment" req-val="true" comment-id="riForm.questions[0].religiousInstitution_q1.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" required question-key="religiousInstitution_q1" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="(riForm.questions[0].religiousInstitution_q1.subAnswer == (\'religiousInstitution_q1_no_notBaptised\'))"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="religiousInstitution_comment_required"></div> --><div investigation-comment model-value="riForm.questions[0].religiousInstitution_q1.comment.comment" req-val="false" comment-id="riForm.questions[0].religiousInstitution_q1.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" required question-key="religiousInstitution_q1" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div></div></div></div><!-- Q1 NO Ends Here --></fieldset></form>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.html','<div id="religiousInstitution" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadReligiousDetails();getSideComments(investigationFormId,vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS,vm.app.REF_TERM.ZERO_INDEX);"><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bcHeader fs17i" data-translate="religiousInstitution"></div></div><div ng-if="loadingReligious"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingReligious"><div class="dividerDiv"></div><!-- <div class="md-accordion" ng-if="religiousInstitution.sections.length > 1" ng-repeat="riForm in religiousInstitution.sections">\n\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.accordion.html\'"></div>\n\t\t</div>  \n\t   <div class="md-accordion" ng-if="religiousInstitution.sections.length == 1">\n\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.form.html\'"></div>\n\t\t</div> --><div class="md-accordion" ng-if="religiousInstitution.sections.length > 1" ng-repeat="riForm in religiousInstitution.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="religiousInstitution"></span><span> {{$index+1}}</span></span> <span ng-if="name.institution" class="accordianNameHolder caps accordianNameHolderMBL"><span ng-bind="name.institution"></span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index);isEntityApproved(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : riForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeReligiousInstitutions(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:riForm.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.form.html\'"></div></div></div><div class="md-accordion" ng-if="religiousInstitution.sections.length == 1" ng-repeat="riForm in religiousInstitution.sections"><div ng-init="getUploadFiles(null,vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS,$index);isEntityApproved(riForm.questions[0].religiousInstitution_q1_yes_nameofInstitution.answerId)" ng-include src="\'app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.form.html\'"></div></div><div class="dividerDiv mt20"></div><fieldset ng-disabled="isreadonly"><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="vm.addAdditionalInstitutionForm()" data-translate="religiousInstitution_addInstitutions"></div><div class="investigationFormHeader mt30" data-translate="religiousInstitution_summary"></div><div class="investigationFormContent pt40 w550" data-translate="religiousInstitution_summary_uploadDoc_label"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS)"><upload-form-file id-form-name="religiousInstitution" id-name="religiousInstitutionSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10" ng-init="religiousInstitution.summary.question = \'religiousInstitution_summary_comment\'"><div class="sectionBC mb10" data-translate="religiousInstitution_summary_comment"></div><!-- <div ckeditor="options" ng-model="religiousInstitution.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="religiousInstitution_comment_required"></div><div investigation-comment model-value="religiousInstitution.summary.comment.comment" req-val="true" comment-id="religiousInstitution.summary.comment.id" section-id="{{religiousInsSectionId}}" form-id="{{investigationFormId}}" question-key="religiousInstitution_summary_comment" read-only="{{isreadonly}}" indexval="0"></div></div></div></div></div></div></fieldset><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><input type="hidden" id="religiousFormSave" ng-click="saveReligiousInstitutionsDetails();"><!-- Next Button Section End --></div><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform(indexVal);deleteSidecommentsByIndex(vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS,indexVal);deleteDocumentByIndex(vm.app.REF_TERM.RELIGIOUS_INSTITUTIONS,indexVal);" data-translate="delete"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Confirmation popup for delete additional interviews and records --><div id="religiousDeleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-if="isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteInterviewConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button><md-button ng-if="!isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteRecordConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.records.html','<div ng-if="religiousInstitution.sections[0].questions[0].religiousInstitution_q3.answer == (\'religiousInstitution_q3_yes\')"><div class="mt30"><!-- ng-repeat="recordInfo in religiousInstitutions.records track by $index" --><!-- When Q3 is YES --><div layout="row" class="ml70"><div ng-if="religiousInstitutions.records.length > 1"><label class="recordTxt" data-translate="religiousInstitution_q3_record"></label></div><div><span ng-if="religiousInstitutions.records.length > 1" class="interviewTxt">#</span></div><div><span ng-if="religiousInstitutions.records.length > 1" class="interviewTxt">{{$index+1}}</span></div><div ng-if="religiousInstitutions.records.length > 1" ng-click="vm.deleteRecordInfo($index)"><span><i class="material-icons trashInterview ml10">delete</i></span></div></div><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div ng-if="$index == 0" class="questionCircle questionNumber" ng-class="{\'changeColor\': Q3.recordType}">3a</div></div><div flex flex-offset-xs="5" class="p6 w100p"><div class="quesStyle mb10" data-translate="religiousInstitution_q3_recordType"></div><div layout="row" layout-xs="column" class="mb10" layout-align="start start" layout-align-xs="center start"><div class="ml10"><md-radio-group layout="row" layout-xs="column" ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3_recordType.answer"><md-radio-button value="{{(\'religiousInstitution_q3_officialChurchRecords\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_officialChurchRecords"></label></md-radio-button><md-radio-button value="{{(\'religiousInstitution_q3_churchIssuedCertification\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_churchIssuedCertification"></label></md-radio-button><md-radio-button value="{{(\'religiousInstitution_q3_others\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_others"></label></md-radio-button></md-radio-group></div></div><!-- Official Church Records  --><div ng-if="religiousInstitution.sections[0].questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_officialChurchRecords\') ||\n\t\t\t\t\t\t\t\t          religiousInstitution.sections[0].questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_churchIssuedCertification\') "><div layout="row"><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_recordName"></div><md-input-container class="m0" style="width:100%"><input ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_recordName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex="10"></div><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobirth"></div><div modval="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_dobirth.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_dobirth.answer" type="text" md-open-on-focus md-hide-icons="all" class="test"></md-datepicker></md-input-container></div></div><div layout="row"><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_dobaptism"></div><div modval="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_dobaptism.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_dobaptism.answer" type="text" md-open-on-focus md-hide-icons="all" class="test"></md-datepicker></md-input-container></div><div flex="10"></div><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_fatherName"></div><md-input-container class="m0" style="width:100%"><input ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_fatherName.answer" class="test" type="text" style="width:100%"></md-input-container></div></div><div layout="row"><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_motherName"></div><md-input-container class="m0" style="width:100%"><input ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_motherName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex="10"></div><div flex="40"></div></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div ckeditor="options" ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3_recordType.comment.comment" ready="onReady()"></div></div></div><!-- Others --><div ng-if="religiousInstitution.sections[0].questions[0].religiousInstitution_q3_recordType.answer == (\'religiousInstitution_q3_others\')"><div layout="row"><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_recordName"></div><md-input-container class="m0" style="width:100%"><input ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_other_recordName.answer" class="test" type="text" style="width:100%"></md-input-container></div><div flex="10"></div><div flex="40"><div class="insName mt40 mt20i" data-translate="religiousInstitution_q3a_other_dobirth"></div><div modval="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_other_dobirth.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_q3a_other_dobirth.answer" type="text" md-open-on-focus md-hide-icons="all" class="test"></md-datepicker></md-input-container></div></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div ckeditor="options" ng-model="religiousInstitution.sections[0].questions[0].religiousInstitution_comment_required.comment.comment" ready="onReady()"></div></div></div></div></div><!-- 3a Ends here --></div><!-- For Q3 YES --><div ng-if="religiousInstitutions.records.length >= 1" class="additionalInterviewTxt ml70 mt20i" ng-click="vm.addAdditionalRecordsForm()" data-translate="religiousInstitution_addAdditionalRecords"></div></div><!-- Q3 NO Starts here --><div ng-if="religiousInstitution.sections[0].questions[0].religiousInstitution_q3.answer ==(\'religiousInstitution_q3_no\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex flex-offset-xs="5" class="p6 w100p"><div layout="row" class="mb10" layout-align="start start" layout-align-xs="center start"><div class="mb10 mr15"><md-radio-group ng-model="religiousInstitution.section.question.religiousInstitution_q3_no.answer" layout="row" layout-xs="column"><md-radio-button value="{{(\'religiousInstitution_q3_no_closed\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_no_closed"></label></md-radio-button><md-radio-button value="{{(\'religiousInstitution_q3_no_other\')}}" class="md-primary"><label class="registryContent" data-translate="religiousInstitution_q3_no_other"></label></md-radio-button></md-radio-group></div></div><div ng-if="religiousInstitution.section.question.religiousInstitution_q3_no.answer == (\'religiousInstitution_q3_no_closed\') ||\n\t\t\t\t\t                 religiousInstitution.section.question.religiousInstitution_q3_no.answer ==  (\'religiousInstitution_q3_no_other\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="religiousInstitution_comment_required"></div><div ckeditor="options" ng-model="religiousInstitution.section.question.religiousInstitution_comment_required.answer" ready="onReady()"></div></div></div></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/religious-institutions/religious.institutions.summary.html','<!DOCTYPE html><html><head><meta charset="ISO-8859-1"><title>Insert title here</title></head><body></body></html>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.form.html','<form name="residencyQuestions"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency1.answer}">1</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10" data-translate="residency1"></div><md-radio-group ng-model="residencyQuestions.sections[0].questions[0].residency1.answer" layout="row" layout-xs="column" name="question1" ng-required="required"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="residency_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="residency_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Proceed only when the value is Yes or No --><div ng-if="residencyQuestions.sections[0].questions[0].residency1.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency1_1a_1.answer && residencyQuestions.sections[0].questions[0].residency1_1a_2.answer}">1a</div></div><div flex flex-offset-xs="5"><div class="quesStyle mt50 mt20i" data-translate="residency1_1a"></div><div ng-init="residencyQuestions.sections[0].questions[0].residency1_1a.interviews = [];residencyQuestions.sections[0].questions[0].residency1_1a.interviews[0].questions = []"></div><div ng-if="residencyQuestions.sections[0].questions[0].residency1_1a.interviews.length == 1"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency1_1a_1"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency1_1a_1.answer == (\'answer_yes\')"><input ng-model="residencyQuestions.sections[0].questions[0].residency1_1a_1.answer" ng-maxlength="30" type="text"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency1_1a_2"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency1_1a_2.answer == (\'answer_yes\')"><!-- <input ng-model="residencyQuestions.sections[0].questions[0].residency1_1a_2.answer" type="text" ng-min="1" ng-maxlength="2"> --> <input ng-model="residencyQuestions.sections[0].questions[0].residency1_1a_2.answer" type="text"></md-input-container></div></div></div><!-- <div flex-offset="10">\n\t\t\t\t\t\t\t\t<div class="additionalInterviewTxt mt40 mt20i" ng-click="birthCertificate.sections[0].questions[0].birthCertificate_2b.interviews.push({})">+ADD ANOTHER COUNTRY</div>\n\t\t\t\t\t\t\t</div> --></div></div></div><div layout="row"><div flex="10"></div><div flex class="mt40 mt20i"><div class="insName mb10" data-translate="residency_comment_optional"></div><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency1.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency1.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residencyQuestions_1" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options" ng-model="residencyQuestions.sections[0].questions[0].residencyQuestions_1.comment.comment" ready="onReady()"></div> --></div></div></div><div flex-offset="10"><div class="mt40 mt20i" ng-if="residencyQuestions.sections[0].questions[0].residency1.answer == (\'answer_no\')"><div class="insName mb10" data-translate="residency_comment_required"></div><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency1.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency1.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residencyQuestions_1" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options"\n\t\t\t\tng-model="residencyQuestions.sections[0].questions[0].residencyQuestions_1.comment.comment"\n\t\t\t\tready="onReady()"></div> --></div></div></div><div class="dividerDiv"></div><!-- Question 2 --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency2.answer}">2</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10" data-translate="residency2"></div><md-radio-group ng-model="residencyQuestions.sections[0].questions[0].residency2.answer" layout="row" layout-xs="column" name="question2" ng-required="required"><div layout="row" layout-xs="column"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="residency_yes"></label></md-radio-button><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="residency_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Proceed only when the value is Yes or No --><div ng-if="residencyQuestions.sections[0].questions[0].residency2.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': }">2a</div></div><div flex flex-offset-xs="5"><div class="quesStyle mt50 mt20i" data-translate="residency2_2a"></div><div ng-init="residencyQuestions.sections[0].questions[0].residency2_2a.schools = [];residencyQuestions.sections[0].questions[0].residency2_2a.schools[0].questions = []"></div><div ng-if="residencyQuestions.sections[0].questions[0].birthCertificate_2b.schools.length == 1"><div><div class="mt40 mt20i"><span class="interviewTxt" data-translate="residency2_2a_school"></span></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_1"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_1.answer" type="text" ng-maxlength="70"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_2"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_2.answer" type="text" ng-maxlength="70"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_3"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_3.answer" type="text" ng-max-length="70"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_4"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_4.answer" type="text" ng-max-length="70"></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_5"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><!-- <input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_5.answer" type="text" ng-max-length="70"> --> <input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_5.answer" type="text"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt10i" data-translate="residency2_2a_6"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><!-- <input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_6.answer" type="text" ng-maxlength="2"> --> <input ng-model="residencyQuestions.sections[0].questions[0].residency2_2a_6.answer" type="text"></md-input-container></div></div></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="birthCertificate.sections[0].questions[0].birthCertificate_2b.schools.push({})">+ ADD ADDITIONAL SCHOOL</div> --></div></div></div><div layout="row"><div flex="10"></div><div flex class="mt40 mt20i"><div class="insName mb10" data-translate="residency_comment_optional"></div><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency2.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency2.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency2" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options" ng-model="residencyQuestions.sections[0].questions[0].residency2.comment.comment" ready="onReady()"></div> --></div></div></div><div flex-offset="10"><div class="mt20" ng-if="residencyQuestions.sections[0].questions[0].residency2.answer == (\'answer_no\')"><div class="insName" data-translate="residency_comment_required"></div><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency2.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency2.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency2" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options"\n\t\t\t\tng-model="residencyQuestions.sections[0].questions[0].residency2.comment.comment"\n\t\t\t\tready="onReady()"></div> --></div></div></div><div class="dividerDiv"></div></form>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.html','<div resize hide-pop ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y: auto; overflow-x: hidden" ng-init="vm.initLoadResidencyQuestions();getSideComments(investigationFormId,vm.app.REF_TERM.RESIDENCY_QUESTIONS,vm.app.REF_TERM.ZERO_INDEX);"><!-- part 1 --><!-- Residency Questions Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bmHeader" data-translate="residency"></div></div><!-- Residency Questions Header End --><div ng-if="loadingResidency"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingResidency"><div class="dividerDiv"></div><!-- \t <div class="md-accordion" ng-if="residencyQuestionsForm.length > 1" ng-repeat="rqForm in residencyQuestionsForm">\n\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.accordian.html\'"></div>\n\t </div> --><div class="md-accordion"><form name="residencyQuestion"><fieldset ng-disabled="isreadonly && sideCommentVisible"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency1.answer}">1</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10" data-translate="residency1"></div><md-radio-group ng-disabled="isreadonly" ng-model="residencyQuestions.sections[0].questions[0].residency1.answer" ng-change="residencyQuestions.sections[0].questions[0].residency1_1a= {};residencyQuestions.sections[0].questions[0].residency1.comment={};" layout="row" layout-xs="column" name="question1" ng-required="required"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="residency_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="residency_no"></label></md-radio-button></div></div></md-radio-group></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt20"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RESIDENCY_QUESTIONS" accordion-index="vm.app.REF_TERM.ZERO_INDEX" question-name="vm.app.INVESTIGATION_FORM.RESIDENCY_QUESTIONS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Proceed only when the value is Yes or No --><div ng-if="residencyQuestions.sections[0].questions[0].residency1.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- <div class="questionCircle questionNumber mt50 mt20i"\n\t\t\t\t\tng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency1_1a_1.answer && residencyQuestions.sections[0].questions[0].residency1_1a_2.answer}">1a</div> --></div><div flex flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="residency1_1a"></div><div><div ng-if="!residencyQuestions.sections[0].questions[0].residency1_1a.interviews" ng-init="residencyQuestions.sections[0].questions[0].residency1_1a.interviews = []; residencyQuestions.sections[0].questions[0].residency1_1a.interviews[0].questions = []"></div><div ng-repeat="country in residencyQuestions.sections[0].questions[0].residency1_1a.interviews track by $index"><div ng-if="!country.questions" ng-init="country.questions = []"></div><div layout="row" class="mt20i" ng-class="{mt40 : $index+1 > 1 }"><div ng-if="residencyQuestions.sections[0].questions[0].residency1_1a.interviews.length > 1 "><label class="interviewTxt" data-translate="residency2_2a_2"></label> <span class="interviewTxt mr10 pl5"># {{$index+1}}</span></div><!-- <div ng-if="!isreadonly && residencyQuestions.sections[0].questions[0].residency1_1a.interviews.length > 1" ng-click="residencyQuestions.sections[0].questions[0].residency1_1a.interviews.splice($index,1)"> --><div ng-if="!isreadonly && residencyQuestions.sections[0].questions[0].residency1_1a.interviews.length > 1" ng-click="vm.deleteIndex($event,\'residencyDeleteInterviewConformPopup\',$index,true)"><span><i class="material-icons trashInterview">delete</i></span></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency1_1a_1"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="country.questions[0].residency1_1a_1.answer == (\'answer_yes\')"><input no-special-char text-only ng-model="country.questions[0].residency1_1a_1.answer" type="text" camel-case></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency1_1a_2"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="country.questions[0].residency1_1a_2.answer == (\'answer_yes\')"><input no-special-char ng-model="country.questions[0].residency1_1a_2.answer" type="text" maxlength="4"></md-input-container></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="vm.addAdditionalCountryForm()" data-translate="addAdditionalCountry"></div></div></div></div><!-- <div layout="row" >\n\t\t\t<div flex=10 flex-xs="15"></div>\n\t\t\t<div flex class="mt40 mt20i"> --><!-- <div class="insName mb10" data-translate="residency_comment_optional"></div>\n\t\t\t    <div investigation-comment  model-value="residencyQuestions.sections[0].questions[0].residency1.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency1.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency1" read-only="{{isreadonly}}"></div> --><!-- <div ckeditor="options" ng-model="residencyQuestions.sections[0].questions[0].residencyQuestions_1.comment.comment" ready="onReady()"></div> --><!-- </div>\n\t\t</div> --></div><div flex-offset="10" flex-offset-xs="15"><div class="mt40 mt20i" ng-if="residencyQuestions.sections[0].questions[0].residency1.answer == (\'answer_no\')"><!-- <div class="insName mb10" data-translate="residency_comment_optional"></div> --><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency1.comment.comment" req-val="false" comment-id="residencyQuestions.sections[0].questions[0].residency1.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency1" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options"\n\t\t\t\tng-model="residencyQuestions.sections[0].questions[0].residencyQuestions_1.comment.comment"\n\t\t\t\tready="onReady()"></div> --></div></div></div><div class="dividerDiv"></div><!-- Question 2 --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': residencyQuestions.sections[0].questions[0].residency2.answer}">2</div></div><div flex flex-offset-xs="5"><div class="quesStyle mb10" data-translate="residency2"></div><md-radio-group ng-disabled="isreadonly" ng-model="residencyQuestions.sections[0].questions[0].residency2.answer" ng-change="residencyQuestions.sections[0].questions[0].residency2_2a={};residencyQuestions.sections[0].questions[0].residency2.comment={};" layout="row" layout-xs="column" name="question2" ng-required="required"><div layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="residency_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="residency_no"></label></md-radio-button></div></div></md-radio-group></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt20"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.RESIDENCY_QUESTIONS" accordion-index="vm.app.REF_TERM.ZERO_INDEX" question-name="vm.app.INVESTIGATION_FORM.RESIDENCY_QUESTIONS.QUESTION2" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Proceed only when the value is Yes or No --><div ng-if="residencyQuestions.sections[0].questions[0].residency2.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><!-- <div class="questionCircle questionNumber mt50 mt20i"\n\t\t\t\t\tng-class="{\'changeColor\': }">2a</div> --></div><div flex flex-offset-xs="5"><div class="quesStyle mt50 mt20i mb10" data-translate="residency2_2a"></div><div><div ng-if="!residencyQuestions.sections[0].questions[0].residency2_2a.interviews" ng-init="residencyQuestions.sections[0].questions[0].residency2_2a.interviews = []; residencyQuestions.sections[0].questions[0].residency2_2a.interviews[0].questions = []"></div><div ng-repeat="school in residencyQuestions.sections[0].questions[0].residency2_2a.interviews track by $index"><div ng-if="!school.questions" ng-init="school.questions = []"></div><div layout="row" class="mt20i" ng-class="{mt40 : $index+1 > 1 }"><div ng-if="residencyQuestions.sections[0].questions[0].residency2_2a.interviews.length > 1"><label class="interviewTxt" data-translate="residency2_2a_school"></label> <span class="interviewTxt mr10 pl5"># {{$index+1}}</span></div><!-- <div ng-if="!isreadonly && residencyQuestions.sections[0].questions[0].residency2_2a.interviews.length > 1" ng-click="residencyQuestions.sections[0].questions[0].residency2_2a.interviews.splice($index,1)"> --><div ng-if="!isreadonly && residencyQuestions.sections[0].questions[0].residency2_2a.interviews.length > 1" ng-click="vm.deleteIndex($event,\'residencyDeleteInterviewConformPopup\',$index,false)"><span><i class="material-icons trashInterview">delete</i></span></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_1"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input no-special-char text-only ng-model="school.questions[0].residency2_2a_1.answer" type="text" maxlength="70" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_2"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="school.questions[0].residency2_2a_2.answer" type="text" maxlength="70" required camel-case></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_3"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input no-special-char text-only ng-model="school.questions[0].residency2_2a_3.answer" type="text" maxlength="70" camel-case required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_4"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input no-special-char text-only ng-model="school.questions[0].residency2_2a_4.answer" type="text" maxlength="70" camel-case required></md-input-container></div></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_5"></div><div><md-input-container class="m0 w100p" name="countryName" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input ng-model="school.questions[0].residency2_2a_5.answer" type="text" maxlength="10" required></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="residency2_2a_6"></div><div><md-input-container class="m0 w100p" name="yearsLived" ng-required="residencyQuestions.sections[0].questions[0].residency2.answer == \'Yes\'"><input no-special-char ng-model="school.questions[0].residency2_2a_6.answer" type="text" maxlength="4" required></md-input-container></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="vm.addAdditionalSchoolForm()" data-translate="addAdditionalSchool"></div></div></div></div><div layout="row"><div flex="10" flex-xs="15"></div><div flex class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="residency_comment_optional"></div>\n\t\t\t\t<div investigation-comment  model-value="residencyQuestions.sections[0].questions[0].residency2.comment.comment" comment-id="residencyQuestions.sections[0].questions[0].residency2.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency2" read-only="{{isreadonly}}"></div> --><!-- <div ckeditor="options" ng-model="residencyQuestions.sections[0].questions[0].residency2.comment.comment" ready="onReady()"></div> --></div></div></div><div flex-offset="10" flex-offset-xs="15"><div class="mt40 mt20i" ng-if="residencyQuestions.sections[0].questions[0].residency2.answer == (\'answer_no\')"><!-- <div class="insName mb10" data-translate="residency_comment_optional"></div> --><div investigation-comment model-value="residencyQuestions.sections[0].questions[0].residency2.comment.comment" req-val="false" comment-id="residencyQuestions.sections[0].questions[0].residency2.comment.id" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residency2" read-only="{{isreadonly}}"></div><!-- <div ckeditor="options"\n\t\t\t\tng-model="residencyQuestions.sections[0].questions[0].residency2.comment.comment"\n\t\t\t\tready="onReady()"></div> --></div></div></div><div class="dividerDiv"></div></fieldset></form></div><!-- End of Document --><!-- Summary Starts here --><div ng-include src="\'app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.summary.html\'"></div><!-- Summary Ends here --><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><div class="nextBtn" ng-click="vm.nextInvestigationForm()"><div class="nextLabel" data-translate="save"></div></div><div flex="10"></div></div><input type="hidden" id="residencyFormSave" ng-click="saveResidencyQuestionsDetails();"><!-- Next Button Section End --></div><!-- Confirmation popup for delete additional interviews and records --><div class="hide"><div id="residencyDeleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-if="isCountry" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteCountryConfirm(indexVal);" data-translate="delete"></md-button><md-button ng-if="!isCountry" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteSchoolConfirm(indexVal);" data-translate="delete"></md-button></div></div></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/residency-questions/residency.questions.summary.html','<fieldset ng-disabled="isreadonly"><div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><!-- <div class="caps attachmentAddText" ng-click="vm.addAdditionalInstitutionForm()"  data-translate="schoolInformation_add"></div> --><div class="investigationFormHeader" data-translate="residencyQuestions_sum_head"></div><div class="investigationFormContent pt40 w550" data-translate="residencyQuestions_sum"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.RESIDENCY_QUESTIONS)"><upload-form-file id-form-name="residencyQuestions" id-name="residencySectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="residencyQuestions.summary.question = \'residencyQuestions_sum_comment\'"><div class="sectionBC mb10" data-translate="residencyQuestions_sum_comment"></div></div><!-- <div ckeditor="options" ng-model="residencyQuestions.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="residency_comment_required"></div><div investigation-comment model-value="residencyQuestions.summary.comment.comment" comment-id="residencyQuestions.summary.comment.id" req-val="true" section-id="{{residencySectionId}}" form-id="{{investigationFormId}}" question-key="residencyQuestions_sum_comment" read-only="{{isreadonly}}"></div></div></div></div></div></div></div></fieldset>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/school-information/interview.html','<div ng-if="!schoolInformation.sections[0].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews" ng-init="schoolInformation.sections[0].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews = []; schoolInformation.sections[0].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews[0].questions = []"></div><div ng-repeat="interviewee in schoolInformation.sections[0].questions[0].schoolInformation_2_yes_2b_Interviewee.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div layout="row" class="mt40"><div><label class="interviewTxt" data-translate="schoolInformation_2_yes_2b_Interviewee"></label></div><span ng-if="interviewee.length > 1" class="interviewTxt">#</span> <span ng-if="interviewee.length > 1" class="interviewTxt">{{$index+1}}</span><div ng-if="interviewee.length > 1" ng-click="vm.deleteInterviewee($index)"><span><i class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="schoolInformation_2_yes_2b_Interviewee_1"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_1.answer" type="text" class="test"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="schoolInformation_2_yes_2b_Interviewee_2"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_2.answer" type="text" class="test"></md-input-container></div></div><div flex flex-xs><div class="insName mt40 mt10i" data-translate="schoolInformation_2_yes_2b_Interviewee_3"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_3.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mb10 mt40 mt20i" data-translate="schoolInformation_Comment_Optional"></div><div ckeditor="options" ng-model="editorcontent" ready="onReady()"></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="add_Additional_interview"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/school-information/school.information.accordion.html','<div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!schoolInformation.sections[0].questions[0].schoolInformation_1_label.answer" class="accordianNameHolder caps"><span data-translate="schoolInformation_accordian"></span> <span>{{$index+1}}</span> </span><span ng-if="schoolInformation.sections[0].questions[0].schoolInformation_1_label.answer" class="accordianNameHolder caps"><span>SCHOOL INFORMATION {{$index+1}}</span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : siForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p"></span></div><div layout-align="center center" ng-click="vm.removeschoolInformation(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div id="schoolInformation" ng-class="{dataContent:true, activeContent:siForm.expanded}"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_1_label.answer}">1</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_1"></div><div class="insName mt40 mt20i" data-translate="schoolInformation_1_label"></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input ng-model="siForm.questions[0].schoolInformation_1_label.answer" class="test" type="text" style="width:100%">\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div class="changeWhiteFrame"><md-autocomplete flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="siForm.questions[0].schoolInformation_1_label.answer=item.nameCityCounty;siForm.questions[0].schoolInformation_1_label.answerId=item.id" md-selected-item="searchText" md-search-text="siForm.questions[0].schoolInformation_1_label.answer" md-items="item in vm.entityRequestSuggest(siForm.questions[0].schoolInformation_1_label.answer,\'School\')" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="searchText">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div><!-- <div ckeditor="options" ng-model="siForm.questions[0].schoolInformation_Comment_Optional.comment.comment" ready="onReady()"></div> --><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_1.comment.comment" comment-id="siForm.questions[0].schoolInformation_1.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_1"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Proceed only when Institution name is entered --><!-- Question 2 starts here --><div ng-if="siForm.questions[0].schoolInformation_1_label.answer"><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_2.answer}">2</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-model="siForm.questions[0].schoolInformation_2.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_yes">Yes</label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no">No</label></md-radio-button></div></md-radio-group></div></div></div></div><!-- When Question 2 chooses Yes --><!-- Question 2a starts here --><div ng-if="siForm.questions[0].schoolInformation_2.answer == (\'schoolInformation_2_yes\' | translate)" ng-init="vm.interviewFlag(2, $index);"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': vm.dateOfBirth}">2a</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2_yes_2a"></div><div class="insName mt40 mt20i" data-translate="schoolInformation_2_yes_2a_label"></div><div><md-input-container class="m0 w100p"><md-datepicker ng-model="siForm.questions[0].schoolInformation_2_yes_2a.answer" type="text" md-hide-icons="calender" md-max-date="vm.maxDate" class="test" required></md-datepicker></md-input-container></div></div></div><!-- Question for 2a ends here --><!-- Question 2b starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': name.Interviewee}">2b</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2_yes_2b_label"></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/interview.html\'"></div> --><div ng-if="!siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews" ng-init="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews = []; siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews[0].questions = []"></div><div ng-repeat="interviewee in siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div layout="row" class="mt40"><div><label class="interviewTxt" data-translate="schoolInformation_2_yes_2b_Interviewee"></label></div><span ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" class="interviewTxt">#</span> <span ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" class="interviewTxt">{{$index+1}}</span><div ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" ng-click="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.splice($index,1)"><span><i class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="schoolInformation_2_yes_2b_Interviewee_1"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_1.answer" type="text" class="test"></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="schoolInformation_2_yes_2b_Interviewee_2"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_2.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-sm="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt10i" data-translate="schoolInformation_2_yes_2b_Interviewee_3"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_3.answer" type="text" class="test"></md-input-container></div></div></div><div class="insName mb10 mt40 mt20i" data-translate="schoolInformation_Comment_Optional"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee_1.comment.comment" comment-id="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee_1.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_2_yes_2b_Interviewee_1"></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="add_Additional_interview"></div> --><div class="additionalInterviewTxt mt40 mt20i" ng-click="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.push({})" data-translate="add_Additional_interview"></div><!-- Interview part ends --></div></div></div><!-- Question 2b ends here --><div class="dividerDiv"></div><!-- Question 3 Starts here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3.answer}">3</div></div><div flex flex-xs flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_3"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-model="siForm.questions[0].schoolInformation_3.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no"></label></md-radio-button></div></md-radio-group></div></div></div><!-- When Question 3 chooses Yes --><!-- Question 3a starts here --><div ng-if="siForm.questions[0].schoolInformation_3.answer == (\'schoolInformation_3_yes\' | translate)"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_yes_3a.answer}">3a</div></div><div flex flex-offset-xs="5" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3a"></div><div layout="row" layout-xs="column" layout-align="space-between start" class="mt18 mt9i"><div layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-model="siForm.questions[0].schoolInformation_3_yes_3a.answer" layout-xs="column"><md-radio-button value="{{(\'schoolInformation_3_yes_3a_Class_Record\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_Class_Record"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_National_Exam\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_National_Exam"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_National_educational_registry\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_National_educational_registry"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_Others\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_Others"></label></md-radio-button></md-radio-group></div></div></div><!-- Class Record  --><div ng-if="siForm.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_Class_Record\' | translate)"><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_1"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_1.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_2"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_2.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_3"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_3.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_4"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_4.answer" type="text" md-hide-icons="calender" class="test" md-max-date="vm.maxDate" required></md-datepicker></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_5"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_5.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_6"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_6.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_7"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Class_Record_7.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="50"></div></div></div><!-- National Exam --><div ng-if="siForm.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_National_Exam\' | translate)"><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_1"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_Exam_1.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_2"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_Exam_2.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_3"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_Exam_3.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_4"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_Exam_4.answer" type="text" md-hide-icons="calender" md-max-date="vm.maxDate" class="test" required></md-datepicker></md-input-container></div></div></div><!-- National educational registry --><div ng-if="siForm.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_National_educational_registry\' | translate)"><div layout="row" layout-xs="column"><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_educational_registry_1"></div><md-input-container class="m0" style="width:100%"><input ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_educational_registry_1.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="50" flex-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_educational_registry_2"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="siForm.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2.answer" type="text" md-hide-icons="calender" class="test" md-max-date="vm.maxDate" required></md-datepicker></md-input-container></div></div></div><!-- Others --><div ng-if="siForm.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_Others\' | translate)"><div layout="row"><div flex="40"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_1"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Others_1.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex="10"></div><div flex="40"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_2"></div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Others_2.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="column"><div class="insName mt20i" data-translate="schoolInformation_3_yes_3a_Others_3"></div><md-input-container class="m0 w100p"><md-datepicker ng-model="siForm.questions[0].schoolInformation_3_yes_3a_Others_3.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" required></md-datepicker></md-input-container></div><div class="insName mb10 mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_4"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3a_Others_3.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3a_Others_3.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3a_Others_3"></div></div></div></div><!-- Question for 3a ends here --><!-- Question 3b starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_yes_3b.answer}">3b</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3b"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-model="siForm.questions[0].schoolInformation_3_yes_3b.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_yes_3b_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3b_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_yes_3b_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3b_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3b.answer == (\'schoolInformation_3_yes_3b_yes\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3b.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3b.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3b"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3b.answer ==(\'schoolInformation_3_yes_3b_no\' | translate)"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3b.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3b.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3b"></div></div></div></div></div><!-- Question 3b ends here --><!-- Question 3c starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\':siForm.questions[0].schoolInformation_3_yes_3c.answer}">3c</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3c"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-model="siForm.questions[0].schoolInformation_3_yes_3c.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_yes_3c_yes\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3c_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_3_yes_3c_no\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3c_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3c.answer ==\'Yes\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3c.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3c.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3c"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3c.answer ==\'No\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3c.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3c.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3c"></div></div></div></div></div><!-- Question 3c ends here --><!-- Question 3d starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_yes_3d.answer}">3d</div></div><div flex-offset-xs="5" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3d"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-model="siForm.questions[0].schoolInformation_3_yes_3d.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="Yes" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3d_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="No" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3d_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3d.answer ==\'Yes\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3d.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3d.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3d"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3d.answer ==\'No\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div><div investigation-comment lass="w99p" model-value="siForm.questions[0].schoolInformation_3_yes_3d.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_yes_3d.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3d"></div></div></div></div></div></div></div><!-- When Question 3 chooses No --><div ng-if="siForm.questions[0].schoolInformation_3.answer == (\'schoolInformation_3_no\' | translate)"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_no_1.answer}">3a</div></div><div flex flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_3_no_1"></div><div layout-align="space-around start"><div layout="column" class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-model="siForm.questions[0].schoolInformation_3_no_1.answer"><md-radio-button value="{{(\'schoolInformation_3_no_1_All_records_destroyed\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_All_records_destroyed"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Prospect_specific_records_destroyed\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Prospect_specific_records_destroyed"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Not_permitted_to_view\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Not_permitted_to_view"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Certification_provided\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Certification_provided"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Others\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Others"></label></md-radio-button></md-radio-group></div></div></div><div ng-if="(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_All_records_destroyed\' | translate))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Prospect_specific_records_destroyed\' | translate))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Not_permitted_to_view\' | translate))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Certification_provided\' | translate))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Others\' | translate))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_3_no_1.comment.comment" comment-id="siForm.questions[0].schoolInformation_3_no_1.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_no_1"></div></div></div></div></div><!-- Question 3d ends here --></div></div></div><!-- Question 2 "NO" --><div ng-if="siForm.questions[0].schoolInformation_2.answer == (\'schoolInformation_2_no\' | translate)"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div layout="row" layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-model="siForm.questions[0].schoolInformation_2_no.answer" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_no_Permenently_Closed\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no_Permenently_Closed"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_no_Other\' | translate)}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no_Other"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="(siForm.questions[0].schoolInformation_2_no.answer ==(\'schoolInformation_2_no_Permenently_Closed\' | translate))\n\t\t\t\t\t                 ||(siForm.questions[0].schoolInformation_2_no.answer ==(\'schoolInformation_2_no_Other\' | translate))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment class="w99p" model-value="siForm.questions[0].schoolInformation_2_no.comment.comment" comment-id="siForm.questions[0].schoolInformation_2_no.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_2_no"></div></div></div></div></div></div></div></div></div><!-- Accordion Popup Starts Here --><!-- <div class="hide">\n\t<div id="accordionCloseConformPopup" class="md-dialog-container">\n\t\t<md-dialog class="assignConfirmPopupWidth"> \n\t\t\t<md-dialog-content>\n\t\t\t\t<div layout="row" flex  class="m50imp">\n\t\t\t\t\t<div layout="column" layout-margin layout-align="center center">\n\t\t\t\t\t\t<div layout="column" layout-align="center center">\n\t\t\t\t\t\t\t<div class="assignSub">\n\t\t\t\t\t\t\t\t<span>Do you want to delete the record?</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div layout="row">\n\t\t\t\t\t\t\t<md-button ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary">CANCEL</md-button>\n\t\t\t\t\t\t\t<md-button class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform($index);">DELETE</md-button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</md-dialog-content> \n\t\t</md-dialog>\n\t</div>\n</div> --><!-- Accordion Popup Ends Here -->');
$templateCache.put('app/investigation/prospects/profile/investigation-form/school-information/school.information.form.html','<form novalidate><fieldset ng-disabled="isreadonly && sideCommentVisible"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_1_label.answer}">1</div></div><div flex="" class="w100p"><div class="quesStyle" data-translate="schoolInformation_1"></div><div class="insName mt40 mt20i" data-translate="schoolInformation_1_label"></div><!-- <div>\n\t\t\t\t\t\t    <md-input-container class="m0" style="width:100%">\n\t\t                        <input no-special-char text-only ng-model="siForm.questions[0].schoolInformation_1_label.answer" class="test" type="text" style="width:100%" required>\t\t\t\t\n\t\t\t\t\t\t\t</md-input-container>\n\t\t\t\t\t\t </div> --><div ng-if="!isreadonly && (siForm.questions[0].schoolInformation_1_label.requested == true) && siForm.questions[0].schoolInformation_1_label.answerId"><div ng-init="siForm.questions[0].schoolInformation_1_label = requestStatus(siForm.questions[0].schoolInformation_1_label);"></div></div><div class="changeWhiteFrame"><md-autocomplete ng-disabled="siForm.questions[0].schoolInformation_1_label.requested" id="{{$index}}" class="global-search-input" flex md-input-minlength="1" md-input-maxlength="100" md-no-cache="noCache" md-selected-item-change="siForm.questions[0].schoolInformation_1_label.answerId=item.id;isEntityApproved(siForm.questions[0].schoolInformation_1_label.answerId, false)" md-selected-item="searchText" md-search-text="siForm.questions[0].schoolInformation_1_label.answer" md-search-text-change="siForm.questions[0].schoolInformation_1_label.answer == \'\' ? siForm.questions[0].schoolInformation_1_label = {} : \'\';siForm.questions[0].schoolInformation_1_label.subAnswer = hideApprovedMessage(siForm.questions[0].schoolInformation_1_label.subAnswer);isEntityApproved(siForm.questions[0].schoolInformation_1_label.answerId, true)" md-items="item in vm.entityRequestSuggest(siForm.questions[0].schoolInformation_1_label.answer,\'School\')" md-item-text="item.nameCityCounty" md-floating-label="j" required><md-item-template><span md-highlight-text="siForm.questions[0].schoolInformation_1_label.answer">{{item.nameCityCounty}}</span></md-item-template><md-not-found><span data-translate="no_results"></span></md-not-found></md-autocomplete></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && ((siForm.questions[0].schoolInformation_1_label.answer && !siForm.questions[0].schoolInformation_1_label.answerId && !siForm.questions[0].schoolInformation_1_label.requested) || \n\t\t\t\t\t\t(entityChanged && !(siForm.questions[0].schoolInformation_1_label.requested) && !(siForm.questions[0].schoolInformation_1_label.subAnswer != undefined)))"><div class="caps attachmentAddText pb25" ng-if="!isreadonly" ng-click="schoolEntityRequest($event,\'addNewEntityPopupId\',0)" data-translate="add_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && siForm.questions[0].schoolInformation_1_label.requested"><div class="attachmentAddText" data-translate="added_entity"></div></div><div class="mb30" ng-if="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM && siForm.questions[0].schoolInformation_1_label.subAnswer != undefined"><div class="attachmentAddText" data-translate="added_entity_approved"></div></div><!-- Upload document for each accordion --><div layout="row" class="mtm60p mb20"><div><div class="investigationFormContent pt40 w550" data-translate="schoolInformation_sum"></div><upload-form-file id-form-name="schoolInfo" id-name="schoolInformationSection{{$index}}" is-summary="false" is-read-only="{{isreadonly}}"></upload-form-file></div></div><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div> --><!-- <div ckeditor="options" ng-model="siForm.questions[0].schoolInformation_Comment_Optional.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="siForm.questions[0].schoolInformation_1.comment.comment" req-val="false" comment-id="siForm.questions[0].schoolInformation_1.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_1" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment><div ng-if="(siForm.questions[0].schoolInformation_1_label.answer && !siForm.questions[0].schoolInformation_1_label.answerId) ||notApproved || siForm.questions[0].schoolInformation_1_label.requested"><div class="redalert mt15" ng-click="openAutocomplete($index)"></div></div></div></div></div><!-- Question 1 Ends Here--><!-- Proceed only when Institution name is entered --><!-- Question 2 starts here --><div ng-if="siForm.questions[0].schoolInformation_1_label.answer"><div class="dividerDiv"></div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_2.answer}">2</div></div><div flex="" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_2.answer" ng-change="formViewCall($index);siForm.questions[0].schoolInformation_2_yes_2b_Interviewee={};\n\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_2_yes_2a = {};\n\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_3={};siForm.questions[0].school_record_list={};siForm.questions[0].schoolInformation_2.comment={};\n\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_2.subAnswer=\'\';" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_yes">Yes</label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no">No</label></md-radio-button></div></md-radio-group></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION2" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- When Question 2 chooses Yes --><!-- Question 2a starts here --><div ng-if="siForm.questions[0].schoolInformation_2.answer == (\'answer_yes\')" ng-init="vm.interviewFlag(1)"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_2_yes_2a.answer}">2a</div></div><div flex="" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2_yes_2a"></div><div class="insName mt40 mt20i" data-translate="schoolInformation_2_yes_2a_label"></div><div><div modval="siForm.questions[0].schoolInformation_2_yes_2a.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="siForm.questions[0].schoolInformation_2_yes_2a.answer=datePickerFormat(siForm.questions[0].schoolInformation_2_yes_2a.answer)" ng-model="siForm.questions[0].schoolInformation_2_yes_2a.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION2_YES_2A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question for 2a ends here --><!-- Question 2b starts here --><div layout="row" class="mt40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_1.answer}">2b</div></div><div flex="" flex-xs="" flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_2_yes_2b_label"></div><!--  Interview Part --><!-- <div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/interview.html\'"></div> --><div ng-if="!siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews" ng-init="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews = []; siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews[0].questions = []"></div><div ng-if="interviewFlag"><div ng-repeat="interviewee in siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews track by $index"><div ng-if="!interviewee.questions" ng-init="interviewee.questions = []"></div><div layout="row" class="mt40 mt20i"><div><label class="interviewTxt" data-translate="schoolInformation_2_yes_2b_Interviewee"></label></div><span ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" class="interviewTxt pl5"># {{$index+1}}</span><!-- <span ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" class="interviewTxt">{{$index+1}}</span> --><!-- <div ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" ng-click="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.splice($index,1)"> --><div ng-if="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.length >1" ng-click="vm.deleteIndex($event,\'schoolDeleteInterviewConformPopup\',$index,true)"><span ng-if="!isreadonly"><i class="material-icons trashInterview ml10">delete</i></span></div></div><div class="insName mt24 mt12i" data-translate="schoolInformation_2_yes_2b_Interviewee_1"></div><div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_1.answer" type="text" class="test" camel-case required></md-input-container></div><div layout="row" layout-xs="column" layout-align="space-between center" layout-align-xs=""><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_2_yes_2b_Interviewee_2"></div><div><md-input-container class="m0 w100p"><input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_2.answer" type="text" class="test"></md-input-container></div></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_2_yes_2b_Interviewee_3"></div><div><md-input-container class="m0 w100p"><!-- <input only-digits allowed-char="-+()" ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_3.answer" type="text" class="test"  maxlength="15"> --> <input ng-model="interviewee.questions[0].schoolInformation_2_yes_2b_Interviewee_3.answer" type="text" class="test"></md-input-container></div></div></div><!-- <div class="insName mb10 mt40 mt20i" data-translate="schoolInformation_Comment_Optional"></div> --><div investigation-comment model-value="interviewee.comment.comment" req-val="false" comment-id="interviewee.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_2_yes_2b_Interviewee" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div><!-- <div class="additionalInterviewTxt mt40 mt20i" ng-click="vm.addAdditionalInterviewForm()" data-translate="add_Additional_interview"></div> --><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="siForm.questions[0].schoolInformation_2_yes_2b_Interviewee.interviews.push({})" data-translate="add_Additional_interview"></div><!-- Interview part ends --></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION2_YES_2B" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div><!-- Question 2b ends here --><div class="dividerDiv"></div><!-- Question 3 Starts here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3.answer}">3</div></div><div flex flex-xs flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_3"></div><div layout="row" class="mt18 mt9i" layout-align="start start"><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_3.answer" ng-change="formViewCall($index);siForm.questions[0].school_record_list={};\n\t\t\t\t\t\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_3_yes_3b={};\n\t\t\t\t\t\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_3_yes_3c={};\n\t\t\t\t\t\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_3_yes_3d={};\n\t\t\t\t\t\t\t\t\t\t\t \t siForm.questions[0].schoolInformation_3_no_1={}" layout="row" layout-xs="column" required><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no"></label></md-radio-button></div></md-radio-group></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- When Question 3 chooses Yes --><!-- Question 3a starts here --><div ng-if="siForm.questions[0].schoolInformation_3.answer == (\'answer_yes\')"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].school_record_list.records[0].questions[0].schoolInformation_3_yes_3a.answer}">4</div></div><div flex flex-offset-xs="5" class="w100p"><div ng-if="!siForm.questions[0].school_record_list.records" ng-init="siForm.questions[0].school_record_list.records = [];siForm.questions[0].school_record_list.records[0].questions = []"></div><div ng-repeat="record in siForm.questions[0].school_record_list.records track by $index"><div ng-if="recordFlag"><div ng-if="!record.questions" ng-init="record.questions = []"></div><div ng-if="!record.sortOrder" ng-init="record.sortOrder = $index+1"></div><div layout="row"><div class="mt50 mt20i"><label class="quesStyle" data-translate="schoolInformation_3_yes_3a"></label></div><span class="interviewTxt mt50 ml10 mt20i" ng-if="siForm.questions[0].school_record_list.records.length > 1">#</span> <span class="interviewTxt mt50 mr10 mt20i" ng-if="siForm.questions[0].school_record_list.records.length > 1">{{$index+1}}</span><!-- <div ng-if="!isreadonly && siForm.questions[0].school_record_list.records.length > 1" ng-click="siForm.questions[0].school_record_list.records.splice($index,1)"> --><div ng-if="!isreadonly && siForm.questions[0].school_record_list.records.length > 1" ng-click="vm.deleteIndex($event,\'schoolDeleteInterviewConformPopup\',$index,false)"><span><i class="material-icons trashInterview mt50 mt20i">delete</i></span></div></div><!-- <div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3a"></div> --><div class="mt18 mt9i" layout-align="start start" layout="row"><div><md-radio-group ng-disabled="isreadonly" ng-model="record.questions[0].schoolInformation_3_yes_3a.answer" required ng-change="record.questions[0].schoolInformation_3_yes_3a_Class_Record_1={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_2={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_3={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_4={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_5={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_6={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_7={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Class_Record_8={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_Exam_1={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_Exam_2={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_Exam_3={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_Exam_4={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_1={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Others_1={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Others_2={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a_Others_3={};\n\t\t\t\t\t\t\t\t\t\t                 record.questions[0].schoolInformation_3_yes_3a.comment={}"><md-radio-button value="{{(\'schoolInformation_3_yes_3a_Class_Record\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_Class_Record"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_National_Exam\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_National_Exam"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_National_educational_registry\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_National_educational_registry"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_yes_3a_Others\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3a_Others"></label></md-radio-button></md-radio-group></div></div><!-- Class Record  --><div ng-if="record.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_Class_Record\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_1"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_1.answer" class="test" type="text" style="width:100%" camel-case required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_2"></div><md-input-container class="m0" style="width:100%"><!-- <input no-special-char ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_2.answer" class="test" type="text" style="width:100%" maxlength="4" required> --> <input no-special-char ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_2.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_3"></div><md-input-container class="m0" style="width:100%"><input ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_3.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_4"></div><div modval="record.questions[0].schoolInformation_3_yes_3a_Class_Record_4.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="record.questions[0].schoolInformation_3_yes_3a_Class_Record_4.answer=datePickerFormat(record.questions[0].schoolInformation_3_yes_3a_Class_Record_4.answer)" ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_4.answer" type="text" md-hide-icons="calendar" class="test" md-max-date="maxDate" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_5"></div><md-input-container class="m0" style="width:100%"><!-- <input only-digits ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_5.answer" class="test" type="text" style="width:100%" maxlength="2" required> --> <input only-digits ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_5.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_6"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_6.answer" class="test" type="text" max-length="70" style="width:100%" camel-case required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_7"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_7.answer" class="test" type="text" max-length="70" style="width:100%" camel-case required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Class_Record_8"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Class_Record_8.answer" class="test" type="text" max-length="70" style="width:100%" camel-case required></md-input-container></div></div></div><!-- National Exam --><div ng-if="record.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_National_Exam\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_1"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_1.answer" class="test" type="text" style="width:100%" maxlength="70" camel-case required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_2"></div><md-input-container class="m0" style="width:100%"><!-- <input no-special-char ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_2.answer" class="test" type="text" style="width:100%" maxlength="4" required> --> <input no-special-char ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_2.answer" class="test" type="text" style="width:100%" required></md-input-container></div></div><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_3"></div><md-input-container class="m0" style="width:100%"><!-- <input ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_3.answer" class="test" type="text" style="width:100%" maxlength="10" required> --> <input ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_3.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_Exam_4"></div><div modval="record.questions[0].schoolInformation_3_yes_3a_National_Exam_4.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="record.questions[0].schoolInformation_3_yes_3a_National_Exam_4.answer=datePickerFormat(record.questions[0].schoolInformation_3_yes_3a_National_Exam_4.answer)" ng-model="record.questions[0].schoolInformation_3_yes_3a_National_Exam_4.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><!-- National educational registry --><div ng-if="record.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_National_educational_registry\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_educational_registry_1"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_1.answer" class="test" type="text" style="width:100%" camel-case required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_National_educational_registry_2"></div><div modval="record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2.answer=datePickerFormat(record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2.answer)" ng-model="record.questions[0].schoolInformation_3_yes_3a_National_educational_registry_2.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div></div></div><!-- Others --><div ng-if="record.questions[0].schoolInformation_3_yes_3a.answer == (\'schoolInformation_3_yes_3a_Others\')"><div layout="row" layout-xs="column"><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_1"></div><md-input-container class="m0" style="width:100%"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Others_1.answer" class="test" type="text" style="width:100%" required></md-input-container></div><div flex-gt-xs="10"></div><div flex-gt-xs="50"><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_2"></div><md-input-container class="m0 w100p"><input no-special-char text-only ng-model="record.questions[0].schoolInformation_3_yes_3a_Others_2.answer" class="test" type="text" style="width:100%" camel-case required></md-input-container></div></div><div><div class="insName mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_3"></div><div modval="record.questions[0].schoolInformation_3_yes_3a_Others_3.answer" formatted-date format="MM-DD-YYYY"></div><md-input-container class="m0 w100p"><md-datepicker ng-change="record.questions[0].schoolInformation_3_yes_3a_Others_3.answer=datePickerFormat(record.questions[0].schoolInformation_3_yes_3a_Others_3.answer)" ng-model="record.questions[0].schoolInformation_3_yes_3a_Others_3.answer" type="text" md-hide-icons="calendar" md-max-date="maxDate" class="test" required date-picker-local-date dp-blur-format></md-datepicker></md-input-container></div><!-- <div class="insName mb10 mt40 mt20i" data-translate="schoolInformation_3_yes_3a_Others_4"></div> --><div investigation-comment model-value="record.questions[0].schoolInformation_3_yes_3a.comment.comment" req-val="false" comment-id="record.questions[0].schoolInformation_3_yes_3a.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3a_Others_3" read-only="{{isreadonly}}" indexval="{{$index}}" parentindex="{{$parent.$index}}"></div></div></div></div><div class="additionalInterviewTxt mt40 mt20i" ng-if="!isreadonly" ng-click="siForm.questions[0].school_record_list.records.push({})" data-translate="add_record"></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3_YES_4" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question for 4 ends here --><!-- Question 5 starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_yes_3b.answer}">5</div></div><div flex="" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3b"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_3_yes_3b.answer" ng-change="siForm.questions[0].schoolInformation_3_yes_3b.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3b_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3b_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3b.answer == (\'answer_yes\')"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3b.comment.comment" req-val="true" comment-id="siForm.questions[0].schoolInformation_3_yes_3b.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3b" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3b.answer ==(\'answer_no\')"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="schoolInformation_Comment_Optional"></div> --><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3b.comment.comment" req-val="false" comment-id="siForm.questions[0].schoolInformation_3_yes_3b.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3b" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3_YES_5" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 5 ends here --><!-- Question 6 starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\':siForm.questions[0].schoolInformation_3_yes_3c.answer}">6</div></div><div flex="" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3c"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_3_yes_3c.answer" ng-change="formViewCall($index);siForm.questions[0].schoolInformation_3_yes_3c.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3c_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3c_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3c.answer ==\'answer_yes\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3c.comment.comment" req-val="true" comment-id="siForm.questions[0].schoolInformation_3_yes_3c.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3c" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3c.answer ==\'answer_no\'"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div> --><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3c.comment.comment" req-val="false" comment-id="siForm.questions[0].schoolInformation_3_yes_3c.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3c" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3_YES_6" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 6 ends here --><!-- Question 7 starts here --><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber mt50 mt20i" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_yes_3d.answer}">7</div></div><div flex="" class="w100p"><div class="quesStyle mt50 mt20i" data-translate="schoolInformation_3_yes_3d"></div><div class="mt18 mt9i" layout-align="start start" layout-align-xs="center start"><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_3_yes_3d.answer" ng-change="siForm.questions[0].schoolInformation_3_yes_3d.comment={};" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3d_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_yes_3d_no"></label></md-radio-button></div></md-radio-group></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3d.answer ==\'answer_yes\'"><div class="mt40 mt20i"><!-- <div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div> --><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3d.comment.comment" req-val="false" comment-id="siForm.questions[0].schoolInformation_3_yes_3d.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3d" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="siForm.questions[0].schoolInformation_3_yes_3d.answer ==\'answer_no\'"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_yes_3d.comment.comment" req-val="true" comment-id="siForm.questions[0].schoolInformation_3_yes_3d.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_yes_3d" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt60"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3_YES_7" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 7 ends here --></div></div><!-- When Question 3 chooses No --><div ng-if="siForm.questions[0].schoolInformation_3.answer == (\'answer_no\')"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': siForm.questions[0].schoolInformation_3_no_1.answer}">3a</div></div><div flex flex-offset-xs="5" class="w100p"><div class="quesStyle" data-translate="schoolInformation_3_no_1"></div><div class="mt18 mt9i" layout-align="start start"><div><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_3_no_1.answer" ng-change="clearCKEditor();(siForm.questions[0].schoolInformation_3_no_1.subAnswer=\'\');"><md-radio-button value="{{(\'schoolInformation_3_no_1_All_records_destroyed\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_All_records_destroyed"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Prospect_specific_records_destroyed\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Prospect_specific_records_destroyed"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Not_permitted_to_view\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Not_permitted_to_view"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Certification_provided\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Certification_provided"></label></md-radio-button><md-radio-button value="{{(\'schoolInformation_3_no_1_Others\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_3_no_1_Others"></label></md-radio-button></md-radio-group></div></div><div ng-if="siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Others\')"><md-input-container class="m0 w100p"><input ng-model="siForm.questions[0].schoolInformation_3_no_1.subAnswer" type="text" class="test"></md-input-container></div><div ng-if="(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_All_records_destroyed\'))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Prospect_specific_records_destroyed\'))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Not_permitted_to_view\'))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Certification_provided\'))\n\t\t\t\t\t\t\t             ||(siForm.questions[0].schoolInformation_3_no_1.answer == (\'schoolInformation_3_no_1_Others\'))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="siForm.questions[0].schoolInformation_3_no_1.comment.comment" req-val="true" comment-id="siForm.questions[0].schoolInformation_3_no_1.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_3_no_1" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div><!-- Side Comment --><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.app.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.app.REF_TERM.SCHOOL_INFORMATION" accordion-index="$index" question-name="vm.app.INVESTIGATION_FORM.SCHOOL_QUESTIONS.QUESTION3_NO_3A" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div></div></div></div><!-- Question 2 "NO" --><div ng-if="siForm.questions[0].schoolInformation_2.answer == (\'answer_no\')"><div class="p40 pl0 pt0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex="" class="w100p"><div layout="row" layout-align="start start" layout-align-xs="center start"><div><md-radio-group ng-disabled="isreadonly" ng-model="siForm.questions[0].schoolInformation_2.subAnswer" ng-change="clearCKEditor()" layout="row" layout-xs="column"><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_no_Permenently_Closed\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no_Permenently_Closed"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'schoolInformation_2_no_Other\')}}" class="md-primary"><label class="registryContent" data-translate="schoolInformation_2_no_Other"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="(siForm.questions[0].schoolInformation_2.subAnswer ==(\'schoolInformation_2_no_Permenently_Closed\'))\n\t\t\t\t\t                 ||(siForm.questions[0].schoolInformation_2.subAnswer ==(\'schoolInformation_2_no_Other\'))"><div class="mt40 mt20i"><div class="insName mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="siForm.questions[0].schoolInformation_2.comment.comment" req-val="true" comment-id="siForm.questions[0].schoolInformation_2.comment.id" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_2" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div></div></div></div></div></div></fieldset></form>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/school-information/school.information.html','<div id="schoolInformation" hide-pop resize ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="getSideComments(investigationFormId,vm.app.REF_TERM.SCHOOL_INFORMATION,vm.app.REF_TERM.ZERO_INDEX);vm.loadschoolInformationDetails();"><!-- part 1 --><!-- School Information Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bcHeader fs17i" data-translate="schoolInformation"></div></div><!-- School Information Header End --><div ng-if="loadingSchool"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingSchool"><div class="dividerDiv"></div><!-- <div class="md-accordion" ng-if="schoolInformation.sections.length > 1" ng-repeat="siForm in schoolInformation.sections">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/school.information.accordion.html\'"></div>\n\t\t\t</div> \n\t\t   <div class="md-accordion" ng-if="schoolInformation.sections.length == 1">\n\t\t\t\t\t<div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/school.information.form.html\'"></div>\n\t\t\t</div> --><div class="md-accordion" ng-if="schoolInformation.sections.length > 1" ng-repeat="siForm in schoolInformation.sections"><div class="accordian-holder"><div layout="row" layout-align="center center" class="accordianHolder"><div layout-align="center center" ng-click="vm.collapseAll($index)"><span ng-if="!schoolInformation.sections[0].questions[0].schoolInformation_1_label.answer" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="schoolInformation_accordian"></span> <span>{{$index+1}}</span> </span><span ng-if="schoolInformation.sections[0].questions[0].schoolInformation_1_label.answer" class="accordianNameHolder caps accordianNameHolderMBL"><span data-translate="schoolInformation"></span><span> {{$index+1}}</span></span></div><div layout="row" flex layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator" flex></span></div><div class="acc_{{$index}}" layout-align="center center" ng-click="vm.collapseAll($index);isEntityApproved(siForm.questions[0].schoolInformation_1_label.answerId)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent" ng-class="{\'accordianContentTransform\' : siForm.expanded}">keyboard_arrow_down</i></span></div></div><div layout="row" layout-align="center center" ng-click="vm.collapseAll($index)"><span class="lineSeparator mw10p" ng-if="!isreadonly"></span></div><div layout-align="center center" ng-if="!isreadonly" ng-click="vm.removeschoolInformation(event,\'accordionCloseConformPopup\',$index)"><div class="accordianCircle"><span><i class="material-icons accordianCircleContent">clear</i></span></div></div></div></div><div ng-class="{dataContent:true, activeContent:siForm.expanded}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/school.information.form.html\'"></div></div></div><div class="md-accordion" ng-if="schoolInformation.sections.length == 1" ng-repeat="siForm in schoolInformation.sections"><div ng-init="getUploadFiles(null,vm.app.REF_TERM.SCHOOL_INFORMATION,$index);isEntityApproved(siForm.questions[0].schoolInformation_1_label.answerId)" ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/school.information.form.html\'"></div></div><div class="dividerDiv mt20"></div><!-- Summary Starts here --><div ng-include src="\'app/investigation/prospects/profile/investigation-form/school-information/school.information.summary.html\'"></div><!-- Summary Ends here --><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><md-button class="nextBtn2" ng-click="vm.nextInvestigationForm()" ng-disabled="disablesaveflag" class="nextLabel" data-translate="save"></md-button><div flex="10"></div></div><input type="hidden" id="schoolFormSave" ng-click="saveschoolInformationDetails();"><!-- Next Button Section End --></div><!-- Accordion Popup Starts Here --><div class="hide"><div id="accordionCloseConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.closeConform(indexVal);deleteSidecommentsByIndex(vm.app.REF_TERM.SCHOOL_INFORMATION,indexVal);deleteDocumentByIndex(vm.app.REF_TERM.SCHOOL_INFORMATION,indexVal);" data-translate="delete"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div><!-- Confirmation popup for delete additional interviews and records --><div id="schoolDeleteInterviewConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmWarn textCenter"><span data-translate="prospects.Warning.delete_popup_msg"></span></div><div class="WarnSub"><span data-translate="prospects.Warning.operationUndone"></span></div></div><div layout="row"><md-button ng-disabled="deleteLoader.flag" ng-click="vm.closeCancel();" class="formSubmit width100px deleteBorder md-raised md-primary" data-translate="cancel"></md-button><md-button ng-if="isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteInterviewConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button><md-button ng-if="!isInterview" ng-disabled="deleteLoader.flag" class="formSubmit deleteBorder color-red whiteClr width100px md-raised md-primary" ng-click="vm.deleteRecordConfirm(indexVal);"><span class="caps" ng-if="!deleteLoader.flag" translate="delete"></span> <span class="caps" ng-if="deleteLoader.flag"><span class="btn-spinner"></span><span class="p4" translate="deleting"></span></span></md-button></div></div></div></md-dialog-content></md-dialog></div></div><!-- Accordion Popup Ends Here --></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/school-information/school.information.summary.html','<fieldset ng-disabled="isreadonly"><div><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"></div><div flex-offset-xs="5" class="w100p"><div class="caps attachmentAddText" ng-if="!isreadonly" ng-click="vm.addAdditionalInstitutionForm()" data-translate="schoolInformation_add"></div><div class="investigationFormHeader mt30" data-translate="schoolInformation_Comment_Summary"></div><div class="investigationFormContent pt40 w550" data-translate="schoolInformation_sum"></div><!-- Upload directive --><div ng-init="getUploadFiles(vm.app.INVESTIGATION_FORM.SUMMARY_KEY,vm.app.REF_TERM.SCHOOL_INFORMATION)"><upload-form-file id-form-name="schoolInfo" id-name="schoolInformationSectionSummary" is-summary="true" is-read-only="{{isreadonly}}"></upload-form-file></div><div class="mt40 mt20i mb10"><div ng-init="schoolInformation.summary.question = \'schoolInformation_sum_comment\'"><div class="sectionBC mb10" data-translate="schoolInformation_sum_comment"></div></div><!-- <div ckeditor="options" ng-model="schoolInformation.summary.comment.comment" ready="onReady()"></div> --><div class="pr40 mb10"><div class="insName mt40 mt20i mb10" data-translate="schoolInformation_Comment_Required"></div><div investigation-comment model-value="schoolInformation.summary.comment.comment" comment-id="schoolInformation.summary.comment.id" req-val="true" section-id="{{schoolInfoSectionId}}" form-id="{{investigationFormId}}" question-key="schoolInformation_sum_comment" read-only="{{isreadonly}}" indexval="0"></div></div></div></div></div></div></div></fieldset>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/sideComment-directive/side.comment.popover.html','<div id="SideCommentsDiv{{questionName}}{{accordionIndex}}" class="SideCommentsDiv ml5 mb5" ng-mouseenter="changeVisibilityFalse();" ng-mouseleave="changeVisibilityTrue();"><!-- Comment label for mobile --><div show-xs show-sm hide-gt-sm layout class="pt2P pt50" ng-click="closeMobileSideComment();"><i class="material-icons fz40 fwb defaultBlack">navigate_before</i> <span class="pt10 pl3 fwb monstFamily defaultBlack lineHeight20 fz20" data-translate="prospects.common.comments"></span></div><div class="mlt3p replyPadding mrt3p"><div class="replyPaddingBottom"><!--  Show Reply Button --><div id="sideCommentReply"><md-button type="submit" ng-disabled="editMode" ng-hide="modelObject.formQuestionCommentDTOs !=null && modelObject.formQuestionCommentDTOs.length==0 " ng-if="showReplyButton" layout="row" ng-click="$event.stopPropagation();hideReply();" class="caps replyButton replyPadding"><i class="material-icons" style="font-size: 26px;">reply</i><div class="ml5 mt5" data-translate="replyButton"></div></md-button></div><div ng-show="modelObject.formQuestionCommentDTOs !=null && modelObject.formQuestionCommentDTOs.length==0" layout="row" class="caps replyButton"><!-- <i class="material-icons" style="font-size: 26px;">reply</i> --><div class="" data-translate="commentHere"></div></div><!--  Div for first comment --><div ng-if="modelObject.formQuestionCommentDTOs !=null && modelObject.formQuestionCommentDTOs.length==0" class="replyArea"><textarea auto-focus ng-model="commentContent" id="firstComment" aria-label="Reply..." rows="3" style="width: 95%;" class="emptySideComment"></textarea><div id="sideComment" layout="row" layout-align="end center" class="pt2P pr5P"><md-progress-circular md-mode="indeterminate" ng-show="loader" class="md-hue-2" md-diameter="20px"></md-progress-circular><!-- <div class="ml90 mt8 caps cancelButton" ng-if="replyComment" ng-click="replyComment = \'\'" data-translate="cancel"></div> --><md-button type="submit" ng-disabled="loader" popover-elem class="ml90 mt8 caps cancelButton" ng-click="$event.stopPropagation();closeMobileSideComment();showComment();" data-translate="cancel"></md-button><div id="sideCommentSave"><md-button type="submit" ng-disabled="loader" class="ml15 mt8 caps postButton" ng-click="$event.stopPropagation();getCommentDTO(commentContent,app.GLOBAL.TRUE);" data-translate="save"></md-button></div></div></div><!--  Div for Reply comment --><div ng-hide="modelObject.formQuestionCommentDTOs.length==0" ng-if="!showReplyButton" class="replyArea"><!--       \t\t<input ng-model="replyComment" type="text" aria-label="Reply..." style="border-radius:5px;width: 95%;word-wrap: normal;"> --> <textarea id="replyCommentDiv" auto-focus ng-model="replyComment" aria-label="Reply..." rows="3" style="width: 95%;" cols="" class="emptySideComment"></textarea><div id="sideComment" layout="row" layout-align="end center" class="pt2P pr5P"><md-progress-circular md-mode="indeterminate" ng-show="loader" class="md-hue-2" md-diameter="20px"></md-progress-circular><md-button type="submit" ng-disabled="loader" class="ml90 mt8 caps cancelButton" ng-click="$event.stopPropagation();hideReply();" data-translate="cancel"></md-button><div id="sideCommentSave"><md-button type="submit" ng-disabled="loader" class="ml15 mt8 caps postButton" ng-click="$event.stopPropagation();getCommentDTO(replyComment,app.GLOBAL.TRUE);" data-translate="save"></md-button></div></div></div></div><!--   Div for existing comments---><div ng-repeat="item in modelObject.formQuestionCommentDTOs | orderBy:\'createdOn\':true | limitTo:limit"><div class="commentedBox"><div layout="row"><div flex="90"><div modval="item.updatedOn" comment-date-format></div><div class="CommentedByName">{{item.commenterName}}</div><div class="CommentedDate copySelectedDisableFont">{{item.updatedOn}}</div><div ng-if="item.isEdited" class="ifEdited" data-translate="edited"></div><p ng-if="(selectedSortOrder == undefined) || (selectedSortOrder != item.sortOrder)" class="mt5 emptySideComment wordWrap" ng-bind-html="item.commentData | link"></p></div><div flex ng-if="item.isOwner" class="mtn5 sideindex"><md-menu><md-button ng-disabled="editMode" aria-label="Open menu with custom trigger" class="md-icon-button p0imp m0imp" ng-click="$event.stopPropagation();openMenu($mdOpenMenu, $event);"><i class="material-icons moreVertIcon">more_vert</i></md-button><md-menu-content><md-menu-item><md-button ng-click="$event.stopPropagation();deleteComment(item.sortOrder,item.id,$index);"><div class="statCircle lytGreyBg fleft"></div><div class="mr15 pbot9 caps" data-translate="sideCommentDelete"></div></md-button></md-menu-item><md-menu-item><md-button ng-click="$event.stopPropagation();editComment(item.sortOrder,$index);"><div class="statCircle lytGreyBg fleft"></div><div class="mr15 pbot9 caps" data-translate="sideCommentEdit"></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><!-- \t\t\t        <div class="divider"></div>\t       \t        \t\t\t\t\t     --> <!-- <p ng-if="(selectedSortOrder == undefined) || (selectedSortOrder != item.sortOrder)" class="mt5">{{item.data}}</p> --><div ng-if="editMode && (selectedSortOrder == item.sortOrder)"><textarea auto-focus ng-model="item.commentData" class="w95 emptySideComment"></textarea><div id="sideComment" layout="row" layout-align="end center" class="pt2P pr5P"><md-progress-circular md-mode="indeterminate" ng-show="loader" class="md-hue-2" md-diameter="20px"></md-progress-circular><md-button type="submit" ng-disabled="loader" class="ml90 mt8 caps cancelButton" ng-click="$event.stopPropagation();cancelCommentUpdate(item);" data-translate="cancel"></md-button><div id="sideCommentSave"><md-button type="submit" ng-disabled="loader" class="ml15 mt8 caps postButton" ng-click="$event.stopPropagation();getCommentDTO(item,app.GLOBAL.FALSE);" data-translate="save"></md-button></div></div></div></div></div></div></div><!-- <div show-xs show-sm hide-gt-sm ng-init="showAllComments();"></div> --><div hide-xs hide-sm show-gt-sm class="ml5 mt5 showMoreOrLess" ng-if="limit ==3 && modelObject.formQuestionCommentDTOs.length > 3" ng-click="$event.stopPropagation();showAllComments();" data-translate="showMore"></div><div hide-xs hide-sm show-gt-sm class="ml5 mt5 showMoreOrLess" ng-if="limit > 3" ng-click="$event.stopPropagation();showLessComments();" data-translate="showLess"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/sideComment-directive/side.commentdirective.html','<div hide-pop class="sideCommentsPosition"><!-- Desktop view --><div class="squareBkround" ng-class="{greenColor : modelObject.formQuestionCommentDTOs.length > 0}" hide-xs hide-sm show-gt-sm><i ng-click="showComment(questionName+accordionIndex);" class="material-icons" popover-is-open="showFlag" popover-trigger="outsideClick" popover-placement="{{mediaCheck(\'max-width:1250px\')?\'bottom-right\':\'right-top\'}}" uib-popover-template="\'app/investigation/prospects/profile/investigation-form/sideComment-directive/side.comment.popover.html\'" type="button">speaker_notes</i></div><!-- Mobile view --><div show-xs show-sm hide-gt-sm layout="row" ng-class="{greenColor : modelObject.formQuestionCommentDTOs.length > 0}" class="mobileCommentButton" ng-click="showMobileSideComment($event,popupId);"><i class="material-icons" type="button">speaker_notes</i></div><div style="visibility: hidden" show-xs show-sm hide-gt-sm><div id="{{questionName}}{{accordionIndex}}" class="md-dialog-container"><md-dialog ng-class="{popupMBL:!mediaCheck(\'gt-sm\')}"><div ng-include src="\'app/investigation/prospects/profile/investigation-form/sideComment-directive/side.comment.popover.html\'"></div></md-dialog></div></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/summary/formSubmitConform.html','<div class="hide"><div id="formConformPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign"><span data-translate="prospects.profileFormDetails.areYouReady"></span></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="assignSub"><span data-translate="prospects.profileFormDetails.submitAnalystForm"></span></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM" class="assignSub"><span data-translate="prospects.profileFormDetails.submitInvestigatorForm"></span></div></div><div layout="column"><md-button ng-disabled="vm.formSubmitDisableFlag" class="formSubmit md-raised md-primary" ng-click="vm.reportResult($event,\'reportResultPopup\',\'reportErrorPopup\');" data-translate="submit"></md-button><md-button ng-disabled="vm.isGoBackDisable" ng-click="saveSummaryFormDetails(2);vm.gobackInvestigationForm();" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="reportResultPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign textCenter"><div ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM"><span data-translate="prospects.profileFormDetails.conformAnalystForm"></span></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM"><span data-translate="prospects.profileFormDetails.conformInvestigatorForm"></span></div></div><div class="assignSub"><div ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM"><span data-translate="prospects.profileFormDetails.conformAnalystFormReview"></span></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM"><span data-translate="prospects.profileFormDetails.conformInvestigatorFormReview"></span></div></div></div><div layout="column"><md-button class="formSubmit formSubmitWidth md-raised md-primary ml0MBL" ng-click="vm.backProfile();" data-translate="prospects.assignInvestigator.backToProspect"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="countryAdminWarningPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign textCenter"><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM"><span data-translate="prospects.profileFormDetails.conformInvestigatorForm"></span></div></div></div><div layout="column"><md-button class="formSubmit formSubmitWidth md-raised md-primary ml0MBL" ng-click="vm.backProfile();" data-translate="prospects.assignInvestigator.backTOInvestigation"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="reportErrorPopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign textCenter"><div><span data-translate="prospects.assignInvestigator.reportNotSubmitted"></span></div></div><div class="assignSub"><div><span data-translate="prospects.assignInvestigator.investigatorNotCompletd"></span></div></div></div><div layout="row"><md-button ng-click="vm.gobackInvestigationForm();" class="mt15" data-translate="prospects.assignInvestigator.goback"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="fillOutSummary" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.fillResults"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-click="vm.gobackInvestigationForm();" data-translate="prospects.common.close"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="radioButtonChange" class="md-dialog-container"><md-dialog class="radioChangePopupWidth"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage"><img class="mt15 ml20" src="content\\images\\warning.png"></div></div><div layout="column" layout-align="center center"><div class="fz18 textcenter"><span data-translate="prospects.Warning.radioButtonChange"></span></div></div><div layout="column"><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.backToOriginalValue(vm.radioButtonValue);" data-translate="prospects.assignInvestigator.goback"></md-button><md-button class="formSubmit md-raised md-primary" ng-class="{w190i:vm.selectedLang == vm.app.GLOBAL.ES}" ng-click="vm.changeRadioValue();" data-translate="yes"></md-button></div></div></div></md-dialog-content></md-dialog></div><div id="saveclosePopup" class="md-dialog-container"><md-dialog class="assignConfirmPopupWidth mw90MBL"><md-dialog-content><div layout="row" flex class="m50imp m20MBL" layout-align-xs="center"><div layout="column" layout-margin layout-align="center center"><div layout="column"><div class="warnImage mtm20"><img class="done" src="content\\images\\dones.png"></div></div><div layout="column" layout-align="center center"><div class="confirmAssign textCenter"><div ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM"><span data-translate="prospects.profileFormDetails.saveAnalystForm"></span></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM"><span data-translate="prospects.profileFormDetails.saveInvestigatorForm"></span></div></div></div><div layout="column"><md-button class="formSubmit formSubmitWidth md-raised md-primary ml0MBL" ng-click="vm.backProfile();" data-translate="prospects.assignInvestigator.backToProspect"></md-button></div></div></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/summary/summary.html','<div resize hide-pop ng-style="{ \'height\' : mediaCheck(\'gt-xs\') ? (windowHeight-50 +\'px\') : (windowHeight-100 +\'px\') }" style="overflow-y:auto; overflow-x:hidden" ng-init="vm.loadSummaryFormDetails();getSideComments(investigationFormId,vm.APP.REF_TERM.SUMMARY,vm.APP.REF_TERM.ZERO_INDEX);"><!-- part 1 --><!-- Summary Header--><div class="p40 ml80 pl0" ng-class="{pmMob:mediaCheck(\'xs\')}"><div class="bmHeader" data-translate="summary"></div></div><!-- Summary Header End --><div ng-if="loadingSummary"><md-progress-linear md-class="md-warn" md-mode="indeterminate"></md-progress-linear></div><div ng-if="!loadingSummary"><div class="dividerDiv"></div><form><fieldset ng-disabled="isreadonly && sideCommentVisible"><!-- Question 1 Stars Here --><div class="p40 pl0 p20i"><div layout="row"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_age.answer}">1</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_age"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="summaryForm.sections[0].questions[0].summary_age.answer" layout="row" layout-xs="column"><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_confirmed\')}}" class="md-primary"><label class="registryContent" data-translate="summary_confirmed"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_failed\')}}" class="md-primary"><label class="registryContent" data-translate="summary_failed"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_undetermined\')}}" class="md-primary"><label class="registryContent" data-translate="summary_undetermined"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_NA\')}}" class="md-primary"><label class="registryContent" data-translate="summary_NA"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX" question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION1" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 1 Ends Here--><!-- Question 2 Stars Here --><div layout="row" class="mt40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_identity.answer}">2</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_identity"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="summaryForm.sections[0].questions[0].summary_identity.answer" layout="row" layout-xs="column"><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_confirmed\')}}" class="md-primary"><label class="registryContent" data-translate="summary_confirmed"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_failed\')}}" class="md-primary"><label class="registryContent" data-translate="summary_failed"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_undetermined\')}}" class="md-primary"><label class="registryContent" data-translate="summary_undetermined"></label></md-radio-button></div><div class="mr40 mb10i"><md-radio-button value="{{(\'summary_NA\')}}" class="md-primary"><label class="registryContent" data-translate="summary_NA"></label></md-radio-button></div></md-radio-group></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX " question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION2" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 2 Ends Here--><div class="dividerDiv mt40"></div><!-- Question 3 Stars Here --><div layout="row" class="mt40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_3.answer}">3</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_3"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="summaryForm.sections[0].questions[0].summary_3.answer" layout="row" layout-xs="column"><!-- ng-change="summaryForm.sections[0].questions[0].summary_3.comment={};" --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="summary_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="summary_no"></label></md-radio-button></div></md-radio-group></div><div class="mt40 mt20i" ng-if="summaryForm.sections[0].questions[0].summary_3.answer == (\'answer_yes\') || summaryForm.sections[0].questions[0].summary_3.answer == (\'answer_no\')"><!-- <div class="insName mb10" ng-if="summaryForm.sections[0].questions[0].summary_3.answer != (\'answer_no\')" data-translate="summary_comment_req"></div> \n\t\t\t\t\t<div class="insName mb10" ng-if="summaryForm.sections[0].questions[0].summary_3.answer == (\'answer_no\')" data-translate="summary_comment_opt"></div>--><!-- <div ckeditor="options" ng-model="summaryForm.sections[0].questions[0].summary_3.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="summaryForm.sections[0].questions[0].summary_3.comment.comment" req-val="false" comment-id="summaryForm.sections[0].questions[0].summary_3.comment.id" section-id="{{summarySectionId}}" form-id="{{investigationFormId}}" question-key="summary_3" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX " question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION3" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 3 Ends Here--><div class="dividerDiv mt40"></div><!-- Question 4 Stars Here --><div layout="row" class="mt40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_4.answer}">4</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_4"></div><div class="mt18 mt9i"><md-radio-group ng-disabled="isreadonly" ng-model="summaryForm.sections[0].questions[0].summary_4.answer" layout="row" layout-xs="column"><!-- ng-change="summaryForm.sections[0].questions[0].summary_4.comment={};" --><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_yes\')}}" class="md-primary"><label class="registryContent" data-translate="summary_yes"></label></md-radio-button></div><div class="mr66 mb10i"><md-radio-button value="{{(\'answer_no\')}}" class="md-primary"><label class="registryContent" data-translate="summary_no"></label></md-radio-button></div></md-radio-group></div><div class="mt40 mt20i" ng-if="summaryForm.sections[0].questions[0].summary_4.answer == (\'answer_yes\') || summaryForm.sections[0].questions[0].summary_4.answer == (\'answer_no\')"><!-- <div class="insName mb10" ng-if="summaryForm.sections[0].questions[0].summary_4.answer != (\'answer_no\')" data-translate="summary_comment_req"></div>\n\t\t\t\t\t<div class="insName mb10" ng-if="summaryForm.sections[0].questions[0].summary_4.answer == (\'answer_no\')" data-translate="summary_comment_opt"></div> --><!-- <div ckeditor="options" ng-model="summaryForm.sections[0].questions[0].summary_4.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="summaryForm.sections[0].questions[0].summary_4.comment.comment" req-val="false" comment-id="summaryForm.sections[0].questions[0].summary_4.comment.id" section-id="{{summarySectionId}}" form-id="{{investigationFormId}}" question-key="summary_4" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX " question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION4" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 4 Ends Here--><div class="dividerDiv mt40"></div><!-- Question 5 Stars Here --><div layout="row" class="mt40" ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_5.comment.comment}">5</div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_5"></div><div class="mt40 mt20i"><!-- <div ckeditor="options" ng-model="summaryForm.sections[0].questions[0].summary_5.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="summaryForm.sections[0].questions[0].summary_5.comment.comment" comment-id="summaryForm.sections[0].questions[0].summary_5.comment.id" section-id="{{summarySectionId}}" form-id="{{investigationFormId}}" question-key="summary_5" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX " question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION5" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 5 Ends Here--><div class="dividerDiv mt40" ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM"></div><!-- Question 6 Stars Here --><div layout="row" class="mt40"><div flex="10" layout="row" layout-align="center start" layout-align-xs="center start"><div class="questionCircle questionNumber" ng-class="{\'changeColor\': summaryForm.sections[0].questions[0].summary_6.comment.comment}"><span ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM">5</span> <span ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM">6</span></div></div><div flex flex-xs flex-offset-xs="5"><div class="quesStyle" data-translate="summary_6"></div><div class="mt40 mt20i"><!-- <div ckeditor="options" ng-model="summaryForm.sections[0].questions[0].summary_6.comment.comment" ready="onReady()"></div> --><div investigation-comment model-value="summaryForm.sections[0].questions[0].summary_6.comment.comment" req-val="false" comment-id="summaryForm.sections[0].questions[0].summary_6.comment.id" section-id="{{summarySectionId}}" form-id="{{investigationFormId}}" question-key="summary_6" read-only="{{isreadonly}}" indexval="{{$index}}"></div></div></div><div ng-if="sideCommentTrigger" ng-show="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM" class="sidecommentBackground mt10"><form-side-comment investigation-id="investigationFormId" form-name="vm.APP.REF_TERM.SUMMARY" accordion-index="vm.APP.REF_TERM.ZERO_INDEX " question-name="vm.APP.INVESTIGATION_FORM.SUMMARY_QUESTIONS.QUESTION6" object-list="sectionDTO.formQuestionDTOs"></form-side-comment></div></div><!-- Question 6 Ends Here--></div></fieldset></form><div ng-if="mediaCheck(\'gt-sm\')" ng-class="isreadonly ? \'height270p\':\'height155p\'"><!-- This is for side comment scroll for Q5 & Q6 --></div><!-- Next Button Section--><div layout="row" layout-align="end center" class="nextSec" ng-if="!isreadonly"><div class="formAutoSave" data-translate="" ng-if="">ALL CHANGES SAVED</div><div flex="10"></div><div class="nextBtn mr25" ng-click="vm.saveSideNavCheckList();vm.submitInvestigationForm($event,\'saveclosePopup\');saveSummaryFormDetails(0);"><div class="nextLabel nextLabelFont" data-translate="saveClose"></div></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.ANALYST_FORM && investigationFormStatus != vm.APP.GLOBAL.COMPLETED" class="nextBtn greenClr" ng-click="vm.saveSideNavCheckList();saveSummaryFormDetails(0);vm.summaryValidationFunc($event);"><div class="nextLabel" data-translate="submit"></div></div><div ng-if="investigationFormType == vm.APP.INVESTIGATION.INVESTIGATOR_FORM && investigationFormStatus != vm.APP.GLOBAL.COMPLETED" class="nextBtn greenClr" ng-click="vm.submitInvestigationForm(event,\'formConformPopup\');saveSummaryFormDetails(1);"><div class="nextLabel" data-translate="submit"></div></div><div flex="10"></div></div><input type="hidden" id="summaryFormSave" ng-click="saveSummaryFormDetails(0);"><!-- Next Button Section End --></div></div><div ng-include="\'app/investigation/prospects/profile/investigation-form/summary/formSubmitConform.html\'"></div>');
$templateCache.put('app/investigation/prospects/profile/investigation-form/upload-file-directive/upload.file.html','<div class="mt10 mt10i"><div ng-if="uploadFileSectionList[0].uploadList.length > 0 && isSummary==\'false\'"><manage-attachments id-name="idName" id-form-name="idFormName" asset-list="uploadFileSectionList[0].uploadList" is-summary="0" is-read-only="isReadOnly"></manage-attachments><div layout="row" class="ellipsis" ng-class="{\'mt7\': !$first}" ng-repeat="asset in uploadFileSectionList[0].uploadList track by $index"><span class="investigationAttachmentIcon"><i class="material-icons attachicon">attachment</i></span> <span class="investigationAttachmentFile"><a class="textstyle2 textDecorationNoneImportant" href="{{assetDownloadAPI+asset.id}}" download>{{asset.displayName}}</a></span> <span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="deleteFileConfirm($event,asset.id,$index,null)"><i class="material-icons">clear</i></span></div></div><div ng-if="uploadFileSectionListSummary[0].uploadList.length > 0 && isSummary==\'true\'"><manage-attachments id-name="idName" id-form-name="idFormName" asset-list="uploadFileSectionListSummary[0].uploadList" is-summary="1" is-read-only="isReadOnly"></manage-attachments><div layout="row" class="ellipsis" ng-class="{\'mt7\': !$first}" ng-repeat="asset in uploadFileSectionListSummary[0].uploadList track by $index"><span class="investigationAttachmentIcon"><i class="material-icons attachicon">attachment</i></span> <span class="investigationAttachmentFile"><a class="textstyle2 textDecorationNoneImportant" href="{{assetDownloadAPI+asset.id}}" download>{{asset.displayName}}</a></span> <span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="deleteFileConfirm($event,asset.id,$index,vm.app.INVESTIGATION_FORM.SUMMARY_KEY )"><i class="material-icons">clear</i></span></div></div><!-- Accordion Index --><div id="progress_{{idName}}" layout="row" class="layout-row" ng-if="isSummary==\'false\' && currentSection == orginSectionFileUpload && sectionAccordionIndex == $index && fileUploadProgressAccordion != null"><div class="progressbarWidth"><span class="progressHolder"><md-progress-linear class="uploadProgress" md-mode="determinate" value="{{fileUploadProgressAccordion}}"></md-progress-linear></span></div><div class="progressClose"><span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="hideUploadProgressBar(isSummary);uploadingFile.upload.abort();"><i class="material-icons">clear</i></span></div></div><!-- Summary --><div id="progress_summary_{{idName}}" layout="row" class="layout-row" ng-if="isSummary==\'true\' && currentSection == orginSectionFileUpload && fileUploadProgressSummary != null"><div class="progressbarWidth"><span class="progressHolder"><md-progress-linear class="uploadProgress" md-mode="determinate" value="{{fileUploadProgressSummary}}"></md-progress-linear></span></div><div class="progressClose"><span class="investigationAttachmentCancel noOutLine" ng-if="!isreadonly" ng-click="hideUploadProgressBar(isSummary);uploadingFile.upload.abort();"><i class="material-icons">clear</i></span></div></div><!-- <div ng-if="fileUploadLoader"><span><img ng-src="/content/images/loader.gif"></span></div> --><div id="fileTypeError_{{idName}}" class="hide"><span data-translate="prospects.profileFormDetails.uploadFileNotSupported"></span></div><div id="fileSizeError_{{idName}}" class="hide"><span data-translate="prospects.profileFormDetails.fileSizeExceed"></span></div><div class="pt20" ng-if="!isreadonly"><div layout="row"><span class="attachementAddIconspan"><i class="material-icons attachAddIcon">add</i></span><div class="drop-box ml0 miw350" ngf-drop ngf-drag-over-class="\'dragover\'" ngf-allow-dir="false" ngf-drop-available="true"><span class="lh30 caps"></span> <span id="uploadReviewFile" data-translate="prospects.profileFormDetails.uploadDocument" class="caps attachmentAddText noOutLine" ng-click="vm.uploadFileForSummary(isSummary,$index,idName,$event);"></span> <input type="file" id="{{idName}}" name="{{idName}}" hide ng-model="picFileOth" accept=".pdf,.png,.jpg,.bmp,.tiff,.jpeg,.tif,.jfif"></div></div></div></div>');}]);})();